export const feats = [
    {
        name: "Unlikeliest of Friends",
        type: "teamwork",
        shortDesc: "",
        longDesc: "When adjacent to or flanking with an ally with this feat, you gain a +1 bonus on attack rolls for each alignment step away they are from you beyond the first, except against creatures that share one of your alignments. If multiple people are flanking or adjacent to each other they can all share the bonus, but instead pick the highest bonus that could be gained from 2 players, and then add +1 for each unique alignment other than those two. Your aid another attempts to people with this feat who dont share your alignment also get a +1 bonus for each alignment step away they are, -1.",
        prereq: "",
    },
    {
        name: "Musketeer's Sidestep",
        type: "martial",
        shortDesc: "",
        longDesc: "When you use the dodging panache deed, the movement granted by that deed does not provoke attacks of opportunity from any creature, and the dodge bonus to armor class that you gain increases by +2.",
        perkPrereq:["Dodging Panache"],
    },
    {
        name: "Quicken Blessing",
        type: "magic",
        shortDesc: "",
        longDesc: "Choose one of your blessings that normally requires a standard action to use. You can expend two of your daily uses of blessings to deliver that blessing (regardless of whether it's a minor or major effect) as a swift action instead.",
        perkPrereq:["Fervor"],
    },
    {
        name: "Musketeer's Daring",
        type: "martial",
        shortDesc: "",
        longDesc: "When using Derring-Do, lower the dice result required to re-roll by 1 (so 5 or 6 on a d6). The number of dice you roll is still limited to a number equal to your Dexterity modifier (minimum 1), and after you gain the benefit of this feat on a roll once, you cannot gain it again.",
        perkPrereq:["Derring-Do"],
    },
    {
        name: "Structural Strike",
        type: "martial",
        shortDesc: "",
        longDesc: `When dealing precision damage, you can make a single strike as a standard action against an opponent that would be otherwise immune to the precision damage. If you hit, you deal your precision damage as normal against this enemy. Alternatively, you can spend level/2 spell points as a swift action to deal your regular precision damage on a single attack against an opponent that would typically be immune. These abilities do not grant you precision damage that you would not be getting unless the creature was immune (such as you still need to be flanking a creature to use this ability to apply sneak attack damage).
        \nAdditionally, against opponents with a chance of immunity to your precision damage (such as an opponent wearing armor with the fortification special ability), this feat reduces their chance of negating your precision damage by 10%.`,
        perkRateUp:["Sneak Attack", "Epic Sneak Attack", "Precise Strike"],
    },
    {
        name: "Summoned Synthesis",
        type: "magic",
        shortDesc: "",
        longDesc: "When you use the fused summons perk, you can choose for the creature's form to be more potent. When you do, you can use the summoned creatures natural attacks, using your physical stats to determine their bonuses. You cannot use attacks from your body and from your fused summon in the same turn.",
        perkPrereq:["Fused Summons"],
    },
    {
        name: "Improved Synthesis",
        type: "magic",
        shortDesc: "",
        longDesc: "While fused with a summoned creature, you can instead use the creatures physical stats and BAB to determine the power of the attacks, and your mental stats to determine any other powers.",
        prereq:"Summoned Synthesis",
    },
    {
        name: "Fuse Forms",
        type: "magic",
        shortDesc: "",
        longDesc: "While fused with a summoned creature you can gain the benefits of the creatures special abilities and movement types as long as they could be completed by only the creatures physical body. Generally this includes every special ability that could be gained from spells such as beast shape, elemental shape, plant shape, etc. but may also include additional abilities such as natural invisibility(invisible stalker) or spores(vrock). This is up to GM's descretion on what could be accomplished with this ability.",
        prereq:"Summoned Synthesis",
    },
    {
        name: "Synthesis Shell",
        type: "magic",
        shortDesc: "",
        longDesc: "While fused with a summoned creature you can choose to gain the benefits of the creatures defenses in place of your own. This includes natural armor, damage reduction, elemental resistances and immunities, spell resistance, and any protections they have against physical conditions (such as bleed or stun, but not immunity to mind-affecting effects or fear). These defenses are in place of your own, and you must choose which to use when you first fuse the creature.",
        prereq:"Summoned Synthesis",
    },
    {
        name: "Bouncing Trick",
        type: "magic",
        shortDesc: "",
        longDesc: "When you trigger a trick, you can spend the tricks cost + level as an immediate action to cause the trick to bounce to a new target within 30 feet of the original target. It is immediately implanted in the new target as if it was the original target of the trick. You cannot bounce a trick that has been implanted this way again for the rest of the day.",
        prereq: "",
        perkPrereq:["Mesmerism"]
    },
    {
        name: "Always Ready",
        type: "martial",
        shortDesc: "",
        longDesc: "When you make an attack of opportunity, you gain a +1 bonus on that attack for each remaining attack of opportunity you have this round.",
        prereq: "",
    },    
    {
        name: "Greater Spellstrike",
        type: "magic",
        shortDesc: "",
        longDesc: "You do not need a free hand to use spell combat or spellstrike, and you can use two-handed and ranged weapons during it, however you cannot use it to wield a shield, unless the shield would count as a free hand for casting spells.",
        prereq: "",
        perkPrereq:["Spell Combat"]
    },
    {
        name: "Greater Spell Combat",
        type: "magic",
        shortDesc: "",
        longDesc: "You can use spell combat and spellstrike in the same round.",
        prereq: "",
        perkPrereq:["Spell Combat"]
    },    
    {
        name: "Bleeding Stare",
        type: "magic",
        shortDesc: "",
        longDesc: "When you trigger your hypnotic stare, the target takes an amount of bleed damage equal to 1/3 level. Bleed damage from multiple uses of Bleeding Stare doesn't stack.",
        prereq: "",
        perkPrereq:["Mesmerism"]
    },
    {
        name: "Blinding Stare",
        type: "magic",
        shortDesc: "",
        longDesc: "When you trigger your hypnotic stare, the target must succeed at a Will save (DC = 10 + level/2 + highest mental) or be blinded for 1 round. Once a creature saves from this the first time, it no longer can be affected by it.",
        prereq: "",
        perkPrereq:["Mesmerism"]
    },
    {
        name: "Confusing Stare",
        type: "magic",
        shortDesc: "",
        longDesc: "When you trigger your hypnotic stare, the target must succeed at a Will save (DC = 10 + level/2 + highest mental) or become confused for 1 round. Targets of your hypnotic stare must roll twice to determine the result of its confused condition, and you select which roll is used. Once a creature saves from this the first time, it no longer can be affected by it.",
        prereq: "",
        perkPrereq:["Mesmerism"]
    },
    {
        name: "Demoralizing Stare",
        type: "magic",
        shortDesc: "",
        longDesc: "When you trigger your hypnotic stare, the target must succeed at a Will save (DC = 10 + level/2 + highest mental) or become shaken for 1 round. This can't cause the target to become frightened, even if the target is already shaken.",
        prereq: "",
        perkPrereq:["Mesmerism"]
    },
    {
        name: "Disconcerting Stare",
        type: "magic",
        shortDesc: "",
        longDesc: "When you trigger your hypnotic stare, the target must succeed at a Will save (DC = 10 + level/2 + highest mental) or take a -6 penalty Perception checks and a -4 penalty on Reflex saves for the next minute.",
        prereq: "",
        perkPrereq:["Mesmerism"]
    },
    {
        name: "Excoriating Stare",
        type: "magic",
        shortDesc: "",
        longDesc: "When you trigger your hypnotic stare, the target must succeed at a Will save (DC = 10 + level/2 + highest mental) or become sickened by the pain for 1 round.",
        prereq: "",
        perkPrereq:["Mesmerism"]
    },
    {
        name: "Fatiguing Stare",
        type: "magic",
        shortDesc: "",
        longDesc: "When you trigger your hypnotic stare, the target must succeed at a Will save (DC = 10 + level/2 + highest mental) or become fatigued for 1 round. This can't cause the target to become exhausted, even if the target is already fatigued.",
        prereq: "",
        perkPrereq:["Mesmerism"]
    },
    {
        name: "Intense Pain",
        type: "magic",
        shortDesc: "",
        longDesc: "When you trigger your hypnotic stare to increase your own damage, you deal an additional 1d6 points of damage. This damage increases to by 1d6 every 6 levels. When you use painful stare to augment an ally's damage, the target of the painful stare takes 1 additional point of damage for every 3 levels you possess.",
        prereq: "",
        perkPrereq:["Mesmerism"]
    },
    {
        name: "Penetrating Stare",
        type: "magic",
        shortDesc: "",
        longDesc: "When you trigger your hypnotic stare, the damage dealt ignores 5 + your highest mental points of the target's damage reduction, unless that damage reduction is untyped (eg, DR 10/—).",
        prereq: "",
        perkPrereq:["Mesmerism"]
    },
    {
        name: "Perturbing Stare",
        type: "magic",
        shortDesc: "",
        longDesc: "When you trigger your hypnotic stare, the target must succeed at a Will save (DC = 10 + level/2 + highest mental) or lose its Dexterity modifier to AC for 1 round.",
        prereq: "",
        perkPrereq:["Mesmerism"]
    },
    {
        name: "Venomous Stare",
        type: "magic",
        shortDesc: "",
        longDesc: "When you trigger your hypnotic stare, the target must succeed at a fortitude save (DC = 10 + level/2 + highest mental) or become poisoned: frequency 1/round for 6 rounds; effect 1d3 Dex; cure 2 saves. Whether your target succeeds at or fails its save, you can't use Venomous Stare against that particular foe for 24 hours.",
        prereq: "",
        perkPrereq:["Mesmerism"]
    },
    {
        name: "Manifold Stare",
        type: "magic",
        shortDesc: "",
        longDesc: "You can trigger your painful stare one additional time per round.",
        prereq: "",
        perkPrereq:["Mesmerism"]
    },
    {
        name: "Improved Manifold Stare",
        type: "magic",
        shortDesc: "",
        longDesc: "You can trigger your painful stare one additional time per round.",
        prereq: "Manifold Stare",
    },
    {
        name: "Greataer Manifold Stare",
        type: "magic",
        shortDesc: "",
        longDesc: "You can trigger your painful stare one additional time per round.",
        prereq: "Improved Manifold Stare",
    },
    {
        name: "Contingent Trick",
        type: "magic",
        shortDesc: "",
        longDesc: "When you select this feat you can choose to implant a trick immediately on an ally. Implanting a trick this way does not restrict it from being implanted again, however you cannot implant a trick in a creature twice with it. Once you have triggered this trick, you can implant a new contingent trick, however it can never be a trick you have previously made contingent again.",
        prereq: "",
        perkPrereq:["Mesmerism"]
    },
    {
        name: "Reflexive Trick",
        type: "magic",
        shortDesc: "",
        longDesc: "Whenever the triggering condition for one trick that you have not implanted in yourself occurs, you can implant that trick in yourself as an immediate action. You can then immediately trigger the trick as if it were implanted in you when the triggering condition occurred. You can't use this ability on a trick more than once per day, and the cost of implanting the trick this way doubles.",
        prereq: "",
        perkPrereq:["Mesmerism"]
    },
    {
        name: "Split Trick",
        type: "magic",
        shortDesc: "",
        longDesc: "Whenever you implant a trick in a target, you can designate that trick as a split trick. When doing so, you target two targets and split the trick between them. This counts as implanting a trick in both targets. The trick functions as normal, except it does not grant any passive bonuses, and that when the trick's triggering condition occurs, you must choose one of the split trick's targets to receive the effects of the split trick. The other target receives no benefit from the trick.",
        prereq: "",
        perkPrereq:["Mesmerism"]
    },
    {
        name: "Dual Trick",
        type: "magic",
        shortDesc: "",
        longDesc: "One of your tricks can be implanted in two creatures at once.",
        prereq: "",
        perkPrereq:["Mesmerism"]
    },
    {
        name: "Feral Combat Training",
        type: "martial",
        shortDesc: "",
        longDesc: "Choose one of your natural weapons. While using the selected natural weapon, you can apply the effects of feats that augment unarmed attacks.",
        prereq: "",
        perkPrereq:["Wild Shape"]
    },
    {
        name: "Improved Feral Combat Training",
        type: "martial",
        shortDesc: "",
        longDesc: "While using the natural attack you selected for feral combat training, you can also use perks that augment unarmed attacks.",
        prereq: "Feral Combat Training",
    },
    {
        name: "Improved Dual Trick",
        type: "magic",
        shortDesc: "",
        longDesc: "An additional one of your tricks can be implanted in two creatures at once. You cannot have the same trick implanted more than twice.",
        prereq: "Dual Trick",
    },
    {
        name: "Greater Dual Trick",
        type: "magic",
        shortDesc: "",
        longDesc: "An additional one of your tricks can be implanted in two creatures at once. You cannot have the same trick implanted more than twice.",
        prereq: "Improved Dual Trick",
    },
    {
        name: "Special Delivery",
        type: "magic",
        shortDesc: "",
        longDesc: "You can attempt an unarmed strike in place of a touch attack as part of casting a spell with a range of touch. This unarmed attack does not provoke.",
        prereq: "",
    },
    {
        name: "Powerful Eyes",
        type: "magic",
        shortDesc: "",
        longDesc: "Increase the penalty of your hypnotic stare by 1, and its range increases by 10 feet.",
        prereq: "",
        perkPrereq:["Mesmerism"]
    },
    {
        name: "Very Powerful Eyes",
        type: "magic",
        shortDesc: "",
        longDesc: "Increase the penalty of your hypnotic stare by 1, and its range increases by 10 feet.",
        prereq: "Powerful Eyes",        
    },
    {
        name: "Swap Trick",
        type: "magic",
        shortDesc: "",
        longDesc: "If a creature currently has a trick implanted in them, but the triggering condition for another trick that you do not have implanted in anybody else occurs, you can swap the current trick they have implanted into the trick you do not have implanted, costing the normal spell point cost, and then trigger it immediately as if it were implanted in you when the triggering condition occurred.",
        prereq: "",
        perkPrereq:["Mesmerism"]
    },
    {
        name: "Combat Hypnosis",
        type: "magic",
        shortDesc: "",
        longDesc: "Each time you complete a combat, you can immediately implant a trick in a creature within 30 feet of you. The cost of implanting a trick this way increases by 50%, and it doesn't let you bypass any normal restrictions on the trick.",
        prereq: "",
        perkPrereq:["Mesmerism"]
    },
    {
        name: "Elemental Current",
        type: "martial",
        shortDesc: "",
        longDesc: "Whenever you use a Mithral Current strike or stance to make a creature vulnerable to silver, you can instead make that creature vulnerable to your active element's associated energy type. Creatures with vulnerability to an energy type take half again as much (+50%) damage as normal from that energy type, as normal. If your target is normally immune to that energy type, they instead take half damage from that energy type instead of none for as long as they are vulnerable.",
        prereq: "",
    },
    {
        name: "Elemental Marksman",
        type: "martial",
        shortDesc: "",
        longDesc: "When you hit a foe with a maneuver using a weapon that deals the same type of damage as your active energy type (such as with a flaming bow while your active energy type is fire), the creature takes a -3 penalty to their save against the maneuver. This only applies if the weapon or ammunition deals the damage, not if a maneuver gives it bonus damage of the type.",
        prereq: "",
    },
    {
        name: "Elemental Oscillation",
        type: "martial",
        shortDesc: "",
        longDesc: "The first weapon attack each round after changing your Active Energy from its prior energy to its opposite element gains +1d6 damage of the same type as the newly selected Active Energy (see elemental flux in discipline info). This bonus will stack each round until you reach a number of bonus dice equal to your highest mental Modifier or half your level (whichever is lower). Once you make an attack with the maximum amount of dice, the bonus damage resets.",
        prereq: "",
    },    
    {
        name: "Duelist's Bind",
        type: "martial",
        shortDesc: "",
        longDesc: "You can invest essense in this feat. When essence in this feat, choose a specific manufactured weapon, for every essence invested, you gain a +1 insight bonus to attack and damage rolls made with that weapon. You gain 1 essence.",
        prereq: "",
        additionalInfoTags:["Essence"],
        givesEssence:true,
    },
    {
        name: "Essence Balanced Blades",
        type: "martial",
        shortDesc: "",
        longDesc: "You can invest essence into this feat. For every odd-numbered essence invested you gain a +1 bonus on damage rolls made with your off-hand weapon while two-weapon fighting. For every even-numbered essence invested you gain a +1 insight bonus on attack rolls made with your primary-hand weapon while two-weapon fighting. You gain 1 essence.",
        prereq: "",
        additionalInfoTags:["Essence"],
        givesEssence:true,
    },
    {
        name: "Essence Expertise",
        type: "martial",
        shortDesc: "",
        longDesc: "You can invest essence into this feat. When you do, choose a type of combat maneuver, or feints, you gain an insight bonus to that type of maneuver, and as an insight bonus to your armor class equal to the investments. You gain 1 essence.",
        prereq: "",
        additionalInfoTags:["Essence"],
        givesEssence:true,
    },
    {
        name: "Chakra Power",
        type: "martial",
        shortDesc: "",
        longDesc: "You can invest essence into this feat. When you do, choose a type of combat maneuver, you gain an insight bonus to that type of maneuver, and as an insight bonus to your damage when you are using power attack equal to the investments. You gain 1 essence.",
        prereq: "",
        additionalInfoTags:["Essence"],
        givesEssence:true,
    },
    {
        name: "Enhanced Capacity",
        type: "universal",
        shortDesc: "",
        longDesc: "Choose two different abilities, feats, or maneuvers you can invest essence into, its maximum investment increases by 1.",
        prereq: "",
        repeatable:true,
        key:true,
        additionalInfoTags:["Essence"],
    },
    {
        name: "Improved Enhanced Capacity",
        type: "martial",
        shortDesc: "",
        longDesc: "Choose two different abilities, feats, or maneuvers you can invest essence into, its maximum investment increases by 1. You can choose the same options you chose with enhanced capacity.",
        prereq: "Enhanced Capacity",
        repeatable:true,
        additionalInfoTags:["Essence"],
    },
    {
        name: "Essence of Movement",
        type: "utility",
        shortDesc: "",
        longDesc: "You can invest essence into this feat. You get a +1 dodge bonus to Armor Class against attacks of opportunity caused when you move out of or within a threatened area, plus an additional +1 per investment in this feat. In addition, you gain a +1 insight bonus per investment on all acrobatics checks. A condition that makes you lose your Dexterity bonus to Armor Class (if any) also makes you lose the dodge and acrobatics bonuses. You gain 1 essence.",
        prereq: "",
        additionalInfoTags:["Essence"],
        givesEssence:true,
    },
    {
        name: "Essence of Recovery",
        type: "magic",
        shortDesc: "",
        longDesc: "You can invest essence into this feat. Whenever you use a perk that heals hit points by rolling dice, you increase the total healing by 1 point per dice rolled for each investment into this feat. You gain 1 essence.",
        prereq: "",
        additionalInfoTags:["Essence"],
        givesEssence:true,
    },
    {
        name: "Veil-Woven Channel",
        type: "magic",
        shortDesc: "",
        longDesc: "You can invest essence into this feat. When you invest into this feat, you choose one of the following: armor class, a save, attacks. Then whenever you use a prereq perk that heals hit points, all creatures healed gain a bonus equal to the amount of investments in this feat to that roll type for 1 round. If your ability deals damage and the target fails a save against the ability it instead gets a penalty to its roll equal to the investments (if no save is granted, the penalty is halved). If your ability does both damage and heals, choose one whether it grants a bonus or a penalty when you activate the ability. You gain 1 essence.",
        prereq: "",
        perkPrereq:["Channel Energy", "Epic Channel Energy", "Lay On Hands", "Touch of Corruption", "Guardian's Shield", "Fervor", "Hemomancy", "Hexes"],
        additionalInfoTags:["Essence"],
        givesEssence:true,
    },
    {
        name: "Essence of the Immortal",
        type: "utility",
        shortDesc: "",
        longDesc: "As a swift action you can reduce your current and maximum spell points by any amount (though you must have enough of each to do this), your maximum hit points increase by half the amount spent. You can change the amount of spell points invested into this as a swift action, however when you do, if you reduce the amount of spell points traded away, you regain maximum spell points, but not current spell points.",
        prereq: "",
    },
    {
        name: "Share Curse",
        type: "utility",
        shortDesc: "",
        longDesc: `Once per day as a standard action, you can share a portion of your accursed heritage with a willing ally by dealing damage to them with a natural weapon you gained from your transformation. The ally gains the benefits of your transformation for rounds equal to your constitution modifier.`,
        prereq: "",
        perkPrereq:["Skinwalker"]
    },
    {
        name: "Akasha Adaptation",
        type: "utility",
        shortDesc: "",
        longDesc: `You can invest essence into this feat. When you invest into this feat, you choose an element (fire, cold, acid, electricity), then for each point invested, you gain 4 energy resistance to that element, and a +1 on saving throws on abilities of that element. 
        \nYou gain 1 essence.`,
        prereq: "",
        additionalInfoTags:["Essence"],
        givesEssence:true,
    },
    {
        name: "Queen's Knight",
        type: "teamwork",
        shortDesc: "",
        longDesc: "As long as you are within 60 feet of an ally with this feat and can see each other, you both gain a +2 morale bonus on will saving throws. Additionally, the receiver of this feat cannot be compelled to attack or harm the sender of it by any means. Charm and compulsion effects still work as normal, but any attempt to command the receiver to attack the giver or take any other action that would cause you direct harm automatically fails and grants them a new saving throw (if applicable) against the effect.",
        prereq: "",
    },
    {
        name: "Eternal Hourglass",
        type: "martial",
        shortDesc: "",
        longDesc: "Once per encounter you can initiate a counter as a free action that you can take even if it isn't your turn, however its cost is doubled. If you are in a riven hourglass stance its cost is only increases by 50%.",
        prereq: "",
    },
    {
        name: "Power Throwing",
        type: "martial",
        shortDesc: "",
        longDesc: "You can use your Strength modifier for both your attack and damage rolls with thrown weapons.",
        prereq: "",
    },
    {
        name: "Focused Critical",
        type: "martial",
        shortDesc: "",
        longDesc: "You can invest essence into this feat. You gain an insight bonus equal to the investments on attack rolls made to confirm a critical threat. You also gain an insight bonus equal to the investments on damage rolls made as part of a critical hit. (This extra damage is also multiplied for the critical hit). You gain 1 essence.",
        prereq: "",
        additionalInfoTags:["Essence"],
        givesEssence:true,
    },
    {
        name: "High Noon",
        type: "martial",
        shortDesc: "",
        longDesc: "You can invest essence into this feat. When you invest essence into this feat choose 1 maneuver you have, when you initiate it, your next attack made within 1 round gains a bonus to damage equal to the total investments in this feat. For each additional investment in this feat you make, you can choose an additional maneuver to be modified by this feat. You gain 1 essence.",
        prereq: "",
        additionalInfoTags:["Essence"],
        givesEssence:true,
    },
    {
        name: "Sunrise",
        type: "martial",
        shortDesc: "",
        longDesc: "You can invest essence into this feat. When you invest essence into this feat choose 1 maneuver you have, when you initiate it, you gain a bonus to your armor class equal to 1/2 the maneuver's level, plus half the investments in this feat for 1 round. For each additional investment in this feat you make, you can choose an additional maneuver to be modified by this feat. You gain 1 essence.",
        prereq: "",
        additionalInfoTags:["Essence"],
        givesEssence:true,
    },
    {
        name: "Sunset",
        type: "martial",
        shortDesc: "",
        longDesc: "You can invest essence into this feat. When you invest essence into this ability choose 1 maneuver you have, when you initiate it, one ally within close range (25 feet + 5 feet per 2 initiator levels) gains a number of temporary hit points equal to your level plus your investments in this feat. You can only trigger this once per round, they stack up to a maximum of half the allies maximum hit points, and last 1 minute. For each additional investment in this feat you make, you can choose an additional maneuver to be modified by this feat. You gain 1 essence.",
        prereq: "",
        additionalInfoTags:["Essence"],
        givesEssence:true,
    },
    {
        name: "Willful Throw",
        type: "martial",
        shortDesc: "",
        longDesc: "You can invest essence into this feat. When you have at least 1 investment in this feat, you may use your highest mental modifier in place of your Dexterity modifier for your attack rolls when attacking with thrown weapons, and gain a bonus to damage rolls with these attacks equal to the total investment in this feat. Additionally, for each investment you also ignore 1 point of AC your target has due to cover.",
        prereq: "",
        additionalInfoTags:["Essence"],
        givesEssence:true,
    },
    {
        name: "Akasha-Infused Spells",
        type: "martial",
        shortDesc: "",
        longDesc: "When you take this feat, choose one school of magic. You can invest essence into this feat at a base increment of 8 spell points. For each increment invested in this feat you choose one spell, its effective caster level increases by 1 per investment in this feat. This can increase its damage past the usual caster level maximum, however the bonus is reduced by half. You gain 1 essence.",
        prereq: "",
        additionalInfoTags:["Essence"],
        givesEssence:true,
    },
    {
        name: "Chakra Strike",
        type: "martial",
        shortDesc: "",
        longDesc: "You can invest essence into this feat. You gain a bonus on damage rolls made when delivering attacks that would count as a sneak attack equal to the investments, if you actually deal sneak attack damage the bonus increases to double the investments. Creatures that are immune to sneak attack are immune to this bonus damage. You gain 1 essence.",
        prereq: "",
        additionalInfoTags:["Essence"],
        givesEssence:true,
    },
    {
        name: "Chakra-Enhanced Fortitude",
        type: "utility",
        shortDesc: "",
        longDesc: "You can invest essence into this feat. You gain an insight bonus on Fortitude saves equal to the investments. You gain 1 essence.",
        prereq: "",
        additionalInfoTags:["Essence"],
        givesEssence:true,
    },
    {
        name: "Weaver's Reflexes",
        type: "utility",
        shortDesc: "",
        longDesc: "You can invest essence into this feat. You gain an insight bonus on reflex saves equal to the investments. You gain 1 essence.",
        prereq: "",
        additionalInfoTags:["Essence"],
        givesEssence:true,
    },
    {
        name: "Will of the Daeva",
        type: "utility",
        shortDesc: "",
        longDesc: "You can invest essence into this feat. You gain an insight bonus on will saves equal to the investments. You gain 1 essence.",
        prereq: "",
        additionalInfoTags:["Essence"],
        givesEssence:true,
    },
    {
        name: "Akashic Charge",
        type: "utility",
        shortDesc: "",
        longDesc: "You can invest essence into this feat. You gain an insight bonus on attack rolls and damage rolls equal to the investments on all charge attacks. You gain 1 essence.",
        prereq: "",
        additionalInfoTags:["Essence"],
        givesEssence:true,
    },
    {
        name: "Akasha Mind Burn",
        type: "magic",
        shortDesc: "",
        longDesc: "You can permanently reduce your maximum spell points in order to restore your current spell points. This is done at a 1 to 1 ratio, and you can convert as many points at a time as you want. Doing this is a free action you can take even when not your turn. These spell points can never be returned.",
        prereq: "",
    },
    {
        name: "Enhanced Akasha Mind Burn",
        type: "magic",
        shortDesc: "",
        longDesc: "The ratio of conversion when burning maximum spell points becomes 1 maximum to gain 2 current.",
        prereq: "Akasha Mind Burn",
    },
    {
        name: "Akasha Body Burn",
        type: "magic",
        shortDesc: "",
        longDesc: "You can permanently reduce your maximum hit points in order to restore your current hit points. This is done at a ratio of 1 maximum to 2 current, and you can convert as many points at a time as you want. Doing this is a free action you can take even when not your turn. These hit points can never be returned.",
        prereq: "",
    },
    {
        name: "Enhanced Akasha Body Burn",
        type: "magic",
        shortDesc: "",
        longDesc: "The ratio of conversion when burning maximum hit points becomes 1 maximum to gain 4 current.",
        prereq: "Akasha Body Burn",
    },
    {
        name: "King's Castle",
        type: "teamwork",
        shortDesc: "",
        longDesc: "When an opponent makes a melee attack against an ally with this feat who is no farther away from you than half your land speed, as an immediate action you can move up to half your speed directly towards the ally. This movement provokes attacks of opportunity. As long as you end this movement adjacent to the targeted ally, you may take the attack in their place. The attack is resolved as though you were the original target of the attack, comparing the attack roll to your defenses and dealing damage as appropriate.",
        prereq: "",
    },
    {
        name: "Exceptional Aid",
        type: "teamwork",
        shortDesc: "",
        longDesc: "The bonus you grant to an ally that has this feat when using aid another increases by +2.",
        prereq: "",
    },
    {
        name: "Esoteric Advantage",
        type: "utility",
        shortDesc: "",
        longDesc: `If you have personally used a knowledge check to identify a creature (dc=20+HD), you can spend a move action to adapt your tactics to reduce that individual's natural defenses. Choose one of the following: -2 damage reduction, -5 energy resistance, -2 spell resistance. You treat the creature as if it had that reduced defense. You can only benefit from this feat against one single creature at a time. You can switch which identified creature you have adapted your tactics to (including which special ability you wish to treat as lower) as a move action. For every 8 you beat the DC by, you can add another reduced defense, and its effects stack.`,
        prereq: "",
    },
    {
        name: "Ferocious Loyalty",
        type: "teamwork",
        shortDesc: "",
        longDesc: "You gain a +1 morale bonus on attack rolls against any foe that currently threatens an ally who also has this feat. If the enemy has struck the ally within 1 round, this increases to +2. It increases to +3 if one of those attacks was a critical hit. Whenever an ally with this feat is rendered helpless or killed within 30 feet of you, you gain a +6 morale bonus on attack rolls for 1 minute or until the foe responsible is rendered helpless or killed, whichever comes first.",
        prereq: "",
    },
    {
        name: "Hammer Guards the Anvil",
        type: "teamwork",
        shortDesc: "",
        longDesc: "Creatures threatened by an ally with this feat cannot make attacks of opportunity against you when you pick up an item from the ground, retrieve a stored item, sheathe or draw a weapon, or stand up from prone.",
        prereq: "",
    },
    {
        name: "Giantslaying Team",
        type: "teamwork",
        shortDesc: "",
        longDesc: "Whenever a foe that is at least 2 sizes larger than you that you threaten misses with an attack of opportunity against an ally with this feat, you can make a melee attack against that foe as an immediate action.",
        prereq: "",
    },
    {
        name: "Fortified Armor Training",
        type: "utility",
        shortDesc: "",
        longDesc: "If an opponent scores a critical hit against you, you can turn the critical hit into a normal hit. If you do, either your armor or your shield gains the broken condition (your choice). If your armor or shield was already broken, it is instead destroyed.",
        prereq: "",
    },
    {
        name: "Flinging Charge",
        type: "martial",
        shortDesc: "",
        longDesc: "If you have a thrown weapon in hand when you begin charging, you can make a ranged attack with that weapon against the target of your charge at any point during your charge. You gain the +2 bonus for charging on the attack roll for this ranged attack. You can then immediately draw a melee weapon during your charge. You take a -5 penalty on the melee attack made at the end of the charge. When charging this way, you cannot use any effect that would grant you more than one attack at the end of your charge (such as pounce).",
        prereq: "",
    },
    {
        name: "Flying Tackle",
        type: "martial",
        shortDesc: "",
        longDesc: "At the end of a charge, if you make either a trip or grapple attempt and it succeeds, you can also drop prone yourself to attempt to either make a grapple or trip attempt (whichever you did not use to initiate this feat) as a free action against the target of the charge, this second maneuver does not provoke, and you do not take the penalty to your CMB due to being prone. If this second combat maneuver succeeds, you can also attempt to make a bull rush attempt against the creature, which also does not take the penalty for being prone, however you must move with the bull rushed creature.",
        prereq: "",
    },
    {
        name: "Weapon Shift",
        type: "martial",
        shortDesc: "",
        longDesc: "When you use your wild shape ability, any melee weapons you are wielding meld into your new form. Select one of these weapons; while in your new form, your natural attacks deal the same damage type as that weapon. Your natural attacks also gain all of the weapon's properties (such as disarm), other than the double weapon property and the fragile weapon property; moreover, when using this feat to grant the trip property to your natural attacks, you gain a +2 bonus on combat maneuver checks to trip an enemy, but you cannot drop your weapon to avoid being tripped due to a failed trip attempt. Weapon Shift does not apply a magic weapon's enhancement bonus to your natural attacks, nor does it grant your natural attacks any of a weapon's magical special abilities.",
        prereq: "",
        perkPrereq:["Wild Shape"],
        key:true,
    },
    {
        name: "Improved Weapon Shift",
        type: "martial",
        shortDesc: "",
        longDesc: "When you apply a melee weapon's damage type and properties to your natural attacks using the Weapon Shift feat, your natural attacks also gain the weapon special abilities of the weapon, such as the flaming special ability. Improved Weapon Shift does not apply the dancing special ability or any special abilities limited to thrown or ranged weapons, and it does not apply the weapon's enhancement bonuses to your attacks.",
        prereq: "Weapon Shift",        
    },
    {
        name: "Greater Weapon Shift",
        type: "martial",
        shortDesc: "",
        longDesc: "When you apply a melee weapon's damage type and properties to your natural attacks using the Weapon Shift feat, your natural attacks also gain an enhancement bonus on attack and damage rolls equal to the enhancement bonus (if any) of the weapon.",
        prereq: "Improved Weapon Shift",        
    },
    {
        name: "Armor Shift",
        type: "magic",
        shortDesc: "",
        longDesc: "While wild shaped you can choose a piece of armor to continue to provide its armor bonus without enchantments to your armor class, however you also still suffer all of its penalties such as max dex bonus or reduced speed.",
        prereq: "",
        perkPrereq:["Wild Shape"]
    },
    {
        name: "Improved Armor Shift",
        type: "magic",
        shortDesc: "",
        longDesc: "Your chosen armor while wild shaped also provides all of its enchantments.",
        prereq: "Armor Shift",       
    },
    {
        name: "Eschew Materials",
        type: "magic",
        shortDesc: "",
        longDesc: "You can cast spells without needing material components, this allows you to cast spells with material components while polymorphed into non-humanoids or when grappled, as long as the spell does not have other components you still cannot meet.",
        prereq: "",
    },
    {
        name: "Arithmancy",
        type: "magic",
        shortDesc: "",
        longDesc: "When you gain this feat choose a single letter, whenever you cast a spell with the chosen letter in its name, it gains a +1 bonus to its DC. This only applies to spells with a verbal component.",
        prereq: "",
    },
    {
        name: "Improved Arithmancy",
        type: "magic",
        shortDesc: "",
        longDesc: "When you cast a spell that the arithmancy feat applies to, you instead gain a +1 bonus to its DC for each time that letter appears in the spells name.",
        prereq: "Arithmancy",
    },
    {
        name: "Dispel Focus",
        type: "magic",
        shortDesc: "",
        longDesc: "You gain a +4 bonus to caster level checks to dispel magic, and when an enemy attempts to use dispel magic to dispel one of your spells, or work equipment, the DC increases by +2.",
        prereq: "",
    },
    {
        name: "Greater Dispel Focus",
        type: "magic",
        shortDesc: "",
        longDesc: "You gain a +4 bonus to caster level checks to dispel magic, and when an enemy attempts to use dispel magic to dispel one of your spells, or work equipment, the DC increases by +2. These bonuses stack with dispel focus.",
        prereq: "Dispel Focus",
    }, 
    {
        name: "Blackfire Summoning",
        type: "magic",
        shortDesc: "",
        longDesc: "When you summon monsters through a summoning spell they appear in a flash of black fire dealing damage equal to 2x the CR of the creature. Creatures can attempt a will save (dc=the spells DC) to halve the damage. If you summon multiple creatures at once consider this one source of damage. This damage only affects creatures that dont share the summoned creatures good/neutral/evil alignment.",
        prereq: "",
    },
    {
        name: "Sacred Summons",
        type: "magic",
        shortDesc: "",
        longDesc: "When you summon monsters through a summoning spell, for each component of your alignment they match, they gain a +2 bonus to all physical stats.",
        prereq: "",
    },
    {
        name: "Friendly Rivalry",
        type: "teamwork",
        shortDesc: "",
        longDesc: "If you're the only one threatening a foe and an ally within 30 feet who also has this feat is the only creature threatening a different foe, you gain a +2 morale bonus on your melee attack rolls against the foe that only you are threatening. You gain the bonus only if neither of the qualifying opponents is flat-footed, helpless or otherwise unable to act. You must be able to see your ally to gain the benefit of this feat. If another ally who is not threatening your chosen foe makes any sort of attack against that foe (such as a ranged attack or a spell), you lose this feat's benefit for 1 round.",
        prereq: "",
    },
    {
        name: "Measure Foe",
        type: "martial",
        shortDesc: "",
        longDesc: "If a foe has been in combat for at least 2 rounds, you can make a sense motive check against them as a free action (dc=20 + its bab + higher of its bluff or disguise). You take a -10 penalty if the creature has not attacked yet. If you succeed you gain a +1 insight bonus on attack rolls against that foe and to your AC against that foe. For each 5 you beat the DC by, you gain an additional +1 insight bonus to attack and armor class against it. If you fail this check against a particular foe, you can't try again against that foe again.",
        prereq: "",
    },
    {
        name: "Expert Sniper",
        type: "martial",
        shortDesc: "",
        longDesc: "You reduce the penalty on your Stealth checks to stay hidden while sniping by 10.",
        prereq: "",
    },
    {
        name: "Master Sniper",
        type: "martial",
        shortDesc: "",
        longDesc: "You can snipe while making a full-round attack, however you cannot make any attacks other than the ones you gain from your BAB. This applies to all bonus attacks, even those from feats like rapid shot, spells like haste, or weapon bonuses. Things that allow you to make extra attacks stull work, such as Manyshot. You also take a -2 penalty on all attacks taken this way.",
        prereq: "Expert Sniper",
    },
    {
        name: "Grandmaster Sniper",
        type: "martial",
        shortDesc: "",
        longDesc: "You can snipe while making a full-round attack, however all attacks are at a -4 penalty, and you take an additional penalty to your stealth check after equal to -1 per attack made.",
        prereq: "Master Sniper",
    },
    {
        ame: "Sniper Expert", 
        type: "martial", 
        uiType: "feat",
        longDesc: "You reduce the penalty on your Stealth checks to stay hidden while sniping by an additional 5.",
        prereq:"Grandmaster Sniper",
    },
    {
        name: "Die for Your Master",
        type: "magic",
        shortDesc: "",
        longDesc: "When you would be reduced below 0 hit points by damage from a weapon, you can as an immediate action cause a summoned creature adjacent to you to leap in front of the attack, it makes a reflex save (dc=damage dealt) to take all the damage from the attack, if it fails, you both take half damage. Both you and the summoned creature must be aware of the attack and able to react to use this feat, and any individual summoned creature can only use this feat once. Evasion and improved evasion do not effect this feat.",
        prereq: "",
    },
    {
        name: "Allied Spellcaster",
        type: "teamwork",
        shortDesc: "",
        longDesc: "Whenever you are adjacent to an ally who also has this feat, you receive a +2 competence bonus on level checks made to overcome spell resistance. If your ally has the same spell known, this bonus increases to +4 and you receive a +2 bonus to the caster level for all level-dependent variables, such as duration, range, and effect.",
        prereq: "",
    },
    {
        name: "Exorcising Mutilation",
        type: "utility",
        shortDesc: "",
        longDesc: "When you fail a saving throw to resist possession or a dominate spell, you can deal 4 points of Constitution damage to yourself and reroll your saving throw as an immediate action. You cannot reduce or negate this damage in any way, and the only way to heal the damage is that 2 points are removed at the end of each floor; magical methods don't work. You must take the result of the second roll, even if it is worse. If you succeed at the second saving throw, you also become immune to that spell or ability from that creature for the rest of the floor. You must be wielding a lethal piercing or slashing weapon, or possess a claw natural attack or some way to draw such a weapon reactively without using your immediate action, to use this ability.",
        prereq: "",
    },
    {
        name: "Improved Martial Flexibility",
        type: "martial",
        shortDesc: "",
        longDesc: "You count as 4 levels higher for determining which feats you can take with the Martial Flexibility Perk.",
        prereq: "",
        perkPrereq:["Martial Flexibility"]
    },
    {
        name: "Improved Channel",
        type: "magic",
        shortDesc: "",
        longDesc: "The DC for your channel energy increases by +2, and your channel heals an additional 1d6 + second highest mental modifier hit points.",
        prereq: "",
        perkPrereq:["Channel Energy", "Epic Channel Energy", "Fervor"]
    },
    {
        name: "Improved Spell Synthesis",
        type: "magic",
        shortDesc: "",
        longDesc: "The cost of spell synthesis reduces to 2x your level, and using spell synthis becomes a standard action.",
        prereq: "",
        perkPrereq:["Spell Synthesis"]
    },
    {
        name: "Channel Force",
        type: "magic",
        shortDesc: "",
        longDesc: "When you channel energy you may choose to target a single target within 30 feet. the target must make a save against your channel energy, and if that creature fails its saving throw, you may pull or push the target up to 5 feet for every 2d6 points of channel energy damage you are capable of dealing.",
        prereq: "",
        perkPrereq:["Channel Energy", "Epic Channel Energy", "Fervor"]
    },
    {
        name: "Improved Channel Force",
        type: "magic",
        shortDesc: "",
        longDesc: "When using Channel Force, you can affect all creatures in a 60-foot line or a 30-foot cone-shaped burst. You must choose to either push or pull all creatures within the affected area that fail their saves, unless you also have selective channelling.",
        prereq: "Channel Force",
    },
    {
        name: "Greater Channel Force",
        type: "magic",
        shortDesc: "",
        longDesc: "When using Improved Channel Force, you can affect all creatures in a 30-foot-radius burst.",
        prereq: "Improved Channel Force",
    },
    {
        name: "Greater Martial Flexibility",
        type: "martial",
        shortDesc: "",
        longDesc: "Martial Flexibility costs 2 less spell points per round. This cannot reduce its cost below 1 spell point.",
        prereq: "Improved Martial Flexibility",
        
    },
    {
        name: "Improved Animal Focus",
        type: "martial",
        shortDesc: "",
        longDesc: `You gain various bonuses depending on your animal aspect:
        \nTiger Bear: Increase the bonus to your chosen physical stat by +1.
        \nBat: You gain +4 bonus to perception checks, gain a +1 bonus on ranged attack rolls.
        \nFrog Monkey: Increase the bonus to your chosen skill by +2
        \nMouse: Gain +2 bonus on reflex saves,
        \nSnake: Gain a +1 bonus to your attacks, and a +1 dodge bonus to your armor class,
        \nStag: Gain an additional 5 feet to your base land speed.
        \nWolf: Gain a +4 bonus on perception checks, gain a +1 bonus on melee attack rolls.`,
        prereq: "",
        perkPrereq:["Animal Focus"]
    },
    {
        name: "Gruesome Shapechanger",
        type: "utility",
        shortDesc: "",
        longDesc: "When you change shape, your previous form sloughs off your body in a spray of blood and viscera that congeals into a thick, disgusting slime. Until the slime dissolves or is cleaned in some way, the space where you stood when you changed (or the space below if you changed in mid-air) becomes slippery, counting as difficult terrain and increasing the DC of Acrobatics checks made in that area by 5. Any foe witnessing this gruesome shape change must succeed at a Fortitude save (DC = 10 + 1/2 Hit Dice + Constitution modifier) or be sickened for 1 minute. Once a creature succeeds on its save it can no longer be affected by this ability.",
        prereq: "",
        perkPrereq:["Wild Shape", "Skinwalker"]        
    },
    {
        name: "Harrowed Summoning",
        type: "magic",
        shortDesc: "",
        longDesc: `When you cast a spell or use a spell-like ability to summon one or more creatures, you roll a 1d6, each number resulting in one of the following bonuses those creatures gain:
        1: +2 enhancement bonus to its attacks
        2: +4 enhancement bonus to damage
        3: +4 bonus to its constitution score
        4: +4 bonus to its natural armor
        5: +2 to the DC of its spells and abilities
        6: Roll twice and get both bonuses, ignoring any future rolls of 6.`,
        prereq: "",                
    },
    {
        name: "Tenacious Hunter",
        type: "martial",
        shortDesc: "",
        longDesc: "You gain a +10 bonus on perception checks to pinpoint invisible creature's locations. In additional, whenever you successfully use perception to notice a creature using stealth or to pinpoint an invisible creature's location, that foe is denied its Dexterity bonus to AC against the next attack you make against it.",
        prereq: "",        
    },
    {
        name: "Greater Tenacious Hunter",
        type: "martial",
        shortDesc: "",
        longDesc: "You can attempt a Perception check as a swift action to intentionally search for an invisible creature, and you instead gain a +20 bonus on perception checks to notice a creature using stealth or to pinpoint an invisible creature's location. In addition, whenever you successfully use Perception to oppose a Stealth check or to pinpoint an invisible creature's location, that foe is denied its Dexterity bonus to AC against all attacks that you make before the start of your next turn.",
        prereq: "Tenacious Hunter",        
    },
    {
        name: "Uncivilized Tactics",
        type: "martial",
        shortDesc: "",
        longDesc: "As a standard action, you can attempt a combat maneuver check against a creature no more than one size category larger than yourself. This provokes an attack of opportunity from the target of the maneuver. If the check is successful, you can prevent the target from using one arm (or similar limb) or one natural attack of your choice for 1 round. For every 5 by which your check result exceeds the target's CMD, the affected arm or natural attack is unusable for 1 additional round. The target can regain the use of its disabled limb or natural attack by taking a standard action to do so.",
        prereq: "",        
    },
    {
        name: "Improved Uncivilized Tactics",
        type: "martial",
        shortDesc: "",
        longDesc: "You don't provoke an attack of opportunity when attempting a combat maneuver check to use Uncivilized Tactics. In addition, you receive a +2 bonus on such checks.",
        prereq: "Uncivilized Tactics",        
    },
    {
        name: "Greater Uncivilized Tactics",
        type: "martial",
        shortDesc: "",
        longDesc: "You gain a +2 bonus on checks to use Uncivilized Tactics. This bonus stacks with the bonus granted by Improved Uncivilized Tactics. Additionally, a foe must take a full-round action to recover the use of a limb or natural attack you've incapacitated with Uncivilized Tactics.",
        prereq: "Improved Uncivilized Tactics",        
    },
    {
        name: "Greater Animal Focus",
        type: "martial",
        shortDesc: "",
        longDesc: "Double the bonuses you gain from the improved animal focus feat. Animal Focus costs 1 less spell point per round to maintain.",
        prereq: "Improved Animal Focus",  
    },
    {
        name: "Swing!",
        type: "martial",
        shortDesc: "",
        longDesc: "Gain a +1 bonus on attack and damage with weapons.",
        prereq: "",
        perkPrereq:["Bonus feats"]
    },
    {
        name: "Swing!!",
        type: "martial",
        shortDesc: "",
        longDesc: "Gain an additional +1 bonus on attack and damage with weapons.",
        prereq: "Swing!",
        
    },
    {
        name: "Swing!!!",
        type: "martial",
        shortDesc: "",
        longDesc: "Gain an additional +1 bonus on attack and damage with weapons.",
        prereq: "Swing!!",
        
    },
    {
        name: "Swing!!!!",
        type: "martial",
        shortDesc: "",
        longDesc: "Gain an additional +1 bonus on attack and damage with weapons.",
        prereq: "Swing!!!",
        
    },
    {
        name: "Swing!!!!!",
        type: "martial",
        shortDesc: "",
        longDesc: "Gain an additional +1 bonus on attack and damage with weapons.",
        prereq: "Swing!!!!",
        
    },
    {
        name: "Swing!!!!!!",
        type: "martial",
        shortDesc: "",
        longDesc: "Gain an additional +1 bonus on attack and damage with weapons.",
        prereq: "Swing!!!!!",
        
    },
    {
        name: "Swing!!!!!!!",
        type: "martial",
        shortDesc: "",
        longDesc: "Gain an additional +1 bonus on attack and damage with weapons.",
        prereq: "Swing!!!!!!",
    },
    {
        name: "Swing!!!!!!!!",
        type: "martial",
        shortDesc: "",
        longDesc: "Gain an additional +1 bonus on attack and damage with weapons.",
        prereq: "Swing!!!!!!!",
    },
    {
        name: "Swing!!!!!!!!!",
        type: "martial",
        shortDesc: "",
        longDesc: "Gain an additional +1 bonus on attack and damage with weapons.",
        prereq: "Swing!!!!!!!!",
    },
    {
        name: "Swing!!!!!!!!!!",
        type: "martial",
        shortDesc: "",
        longDesc: "Gain an additional +1 bonus on attack and damage with weapons.",
        prereq: "Swing!!!!!!!!!",
    },
    {
        name: "Improved Dragon Warrior",
        type: "martial",
        shortDesc: "",
        longDesc: "You can maintain Dragon Stance for an additional 4 rounds per day.",
        prereq: "",
        perkPrereq:["Finesse Training"]
    },
    {
        name: "Greater Dragon Warrior",
        type: "martial",
        shortDesc: "",
        longDesc: "You can maintain Dragon Stance for an additional 2 rounds per day. Your level and BAB count as 4 higher for determining the effects of Dragon Stance.",
        prereq: "Improved Dragon Warrior",
        
    },
    {
        name: "Improved Flurry",
        type: "martial",
        shortDesc: "",
        longDesc: "Reduce the spell point cost of gaining additional attacks with the flurry of blows perk by 1, and you gain a +2 bonus to attack on additional attacks gained from spending spell points with the flurry of blows perk. This cannot reduce its cost below 1 spell point.",
        prereq: "",
        perkPrereq:["Flurry of Blows"]
    },
    {
        name: "Greater Flurry",
        type: "martial",
        shortDesc: "",
        longDesc: "When you make an additional attack by spending spell points with flurry of blows, if it hits, all further attacks on your turn gain a +1 bonus. This stacks.",
        prereq: "Improved Flurry",
        
    },
    {
        name: "Improved Judgement",
        type: "martial",
        shortDesc: "",
        longDesc: "Your judgement lasts an additional 2 rounds, and its cost is reduced by 1 spell point. This spell point reduction applies to both the active abilities of judgement, but it cannot reduce it below 0 spell points.",
        prereq: "",
        perkPrereq:["Judgement"]
    },
    {
        name: "Extremely Judgemental",
        type: "martial",
        shortDesc: "",
        longDesc: "You can have an additional judgement bonus active at a time, this increases the cost of your judgement by level/2 as normal for having additional judgements active.",
        prereq: "",
        perkPrereq:["Judgement"]
    },
    {
        name: "Greater Judgement",
        type: "martial",
        shortDesc: "",
        longDesc: "Your judgement cost is reduced by 1 spell point, and you count as 4 levels higher for the effects of your judgement. This spell point reduction applies to both the active abilities of judgement, but it cannot reduce it below 0 spell points.",
        prereq: "Improved Judgement",
        
    },
    {
        name: "Ultimate Judgement",
        type: "martial",
        shortDesc: "",
        longDesc: "When you activate Judgement and have at least 3 bonuses active, choose one of your bonuses and increase its bonus by 50%. You can choose to not gain one of the bonuses you would otherwise gain from judgement to increase one of your other bonuses by 50% (this still counts as an active bonus for the previous ability and costs spell points normally)",
        prereq: "Greater Judgement",
        
    },
    {
        name: "Improved Panache",
        type: "martial",
        shortDesc: "",
        longDesc: "Your Deeds cost 1 less spell point. This cannot reduce their cost below 1 spell point. Gain an additional attack of opportunity per round.",
        prereq: "",
        perkPrereq:["Panache"]
    },
    {
        name: "Greater Panache",
        type: "martial",
        shortDesc: "",
        longDesc: "Your deeds cost 2 less spell points. This cannot reduce their spell point cost below 1 spell point. Gain an additional attack of opportunity per round.",
        prereq: "Improved Panache",
    },
    {
        name: "Greater Parry",
        type: "martial",
        shortDesc: "",
        longDesc: "When using a [parry] deed, you gain a +2 bonus on your attack rolls. When using Flurry Defense the bonus you gain from using it increases by +1.",
        prereq: "",
        perkPrereq:["Panache"]
    },
    {
        name: "Improved Rage",
        type: "martial",
        shortDesc: "",
        longDesc: "When your rage is active you gain an additional +1 bonus to either your strength or constitution when you have rage active. The bonus is chosen when you activate rage, and remains until your rage ends. Additionally, the cost of your rage is reduced by 1 spell point. This cannot reduce it below 1 spell point. This applies to each rage effect you have, so if you have both rage and epic rage you could gain an additional +2 to strength, and its spell point cost is also reduced.",
        prereq: "",
        perkPrereq:["Rage","Epic Rage"]
    },
    {
        name: "Selective Bombs",
        type: "magic",
        shortDesc: "",
        longDesc: "When you through a bomb you choose 1 square in its blast radius to not be affected by the bomb. For every 4 of your highest mental modifier you can choose an additional square.",
        prereq: "",
        perkPrereq:["Alchemy"]
    },
    {
        name: "Dangerous Mixture",
        type: "magic",
        shortDesc: "",
        longDesc: "When you throw a bomb you can choose to increase the spell point cost of it by 1 to increase the radius of the blast radius by 5 feet. You can only do this once per bomb, plus an additional time for every 5 modifier of your highest mental stat.",
        prereq: "",
        perkPrereq:["Alchemy"]
    },
    {
        name: "High Explosives",
        type: "magic",
        shortDesc: "",
        longDesc: "When you throw a bomb, you can choose to spend 2 extra spell points to cause the bombs splash damage to become half of the damage rolled instead of minimum.",
        prereq: "Dangerous Mixture",
    },
    {
        name: "Destructive Discovery",
        type: "magic",
        shortDesc: "",
        longDesc: "The damage dice of your bomb increases by 1 step. The reflex save DC for your bombs increases by +1.",
        prereq: "",
        perkPrereq:["Alchemy"]
    },
    {
        name: "Improved Alchemy",
        type: "magic",
        shortDesc: "",
        longDesc: "Curative and Mnemonic potions you drink or throw heal an additional 1 point per dice rolled. Bombs from alchemy or gear have their DC increased by +4 and their base range increment is increased by 5 feet. Increase the potions crafted at the start of each floor by 1.",
        prereq: "",
        perkPrereq:["Alchemy"]
    },    
    {
        name: "Unending Rage",
        type: "martial",
        shortDesc: "",
        longDesc: "Reduce the cost of your rage by a further 2 spell points. This cannot reduce the cost of your rage below 1 spell point.",
        prereq: "Improved Rage",        
    },
    {
        name: "Greater Rage",
        type: "martial",
        shortDesc: "",
        longDesc: "You can increase the morale bonuses you gain to strength from rage by an additional +2, however you reduce your armor class by a further -2, and your rage costs an additional spell point per round to maintain. This also can be applied to each form of rage you have.",
        prereq: "Improved Rage",
    },
    // {
    //     name: "Ranged Versatility",
    //     type: "utility",
    //     shortDesc: "",
    //     longDesc: "When you select this feat, choose one of the levels you make a choice for your ranged training, you can act as if you had gotten both options for that level. This does not allow you to gain the same ability or feat twice.",
    //     prereq: "",
    //     perkPrereq:["Ranged Training"]
    // },
    {
        name: "Saint's Blessing",
        type: "utility",
        shortDesc: "",
        longDesc: `Each time the target of your smite takes damage, you heal 1 hit point for every order that you have.`,
        prereq: "",
        perkPrereq:["Smite"]
    },
    {
        name: "Improved Smite",
        type: "utility",
        shortDesc: "",
        longDesc: "Reduce the cost of activating smite by 2 spell points. This cannot reduce the cost of smite below 1 spell point. Increase the bonus to attack, damage, and armor class you gain from smite by +1.",
        prereq: "",
        perkPrereq:["Smite"]
    },
    {
        name: "Greater Smite",
        type: "utility",
        shortDesc: "",
        longDesc: "Reduce the cost of activating smite by 2 spell points. This cannot reduce the cost of smite below 1 spell point. Increase the bonus to attack, damage, and armor class you gain from smite by +1. When you smite a creature who's alignment is not your opposing alignment, you still gain double your level to damage on your first attack against them, if they are your direct opposing alignment, your first 3 attacks gain this bonus instead of just the first.",
        prereq: "Improved Smite",
    },
    {
        name: "Improved Sneak Attack",
        type: "utility",
        shortDesc: "",
        longDesc: "Increase the damage dice of your sneak attack by 1 step. This applies to any other forms of sneak attack or precision damage you may deal.",
        prereq: "",
        perkPrereq:["Sneak Attack"]
    },
    {
        name: "Greater Sneak Attack",
        type: "utility",
        shortDesc: "",
        longDesc: "When using sudden technique, you gain a bonus to your attack, and for 1 round as a dodge bonus to your armor class. Both bonuses are equal to your highest mental modifier. When you confirm a critical hit when dealing sneak attack damage, your critical hit deals additional precision damage equal to the amount of sneak attack dice rolled multiplied by the critical hit damage multiplier. This additional damage is added after the critical hit and does not count as part of the attack.",
        prereq: "Improved Sneak Attack",
    },
    {
        name: "Desperate Technique",
        type: "utility",
        shortDesc: "",
        longDesc: "Once per floor you can spend level x5 spell points to use sudden technique, except it doesn't expend your immediate action. You are stunned on your next turn instead of staggered when you use this. If you use sudden technique twice in the same round, you are instead stunned for 1d4+1 rounds. When being stunned by this ability it cannot be removed or negated in any way.",
        prereq: "",
        perkPrereq:["Sneak Attack"]
    },
    // {
    //     name: "Speed Ball",
    //     type: "utility",
    //     shortDesc: "",
    //     longDesc: "When throwing a potion you can increase the maximum range of throwing the potion ",
    //     prereq: "",
    //     perkPrereq:["Alchemy", "Potion Thrower"]
    // },
    {
        name: "Devastating Assault",
        type: "martial",
        longDesc: `As a full-round action, you can bat aside all of your foe's defenses to ensure you make a single, especially effective melee attack. You make a single melee attack using an appropriate weapon against a single target, but make as many attack rolls as you could in a full-attack action using that weapon. You make the attack rolls in order from highest bonus to lowest, as if you were making a full attack.        
        \nIf any of the attack rolls hit the target, your single attack is considered to have hit and you roll damage normally. If you hit multiple times, you can add the weapons damage dice to the damage, but other modifiers are not included.
        \nIf one or more rolls are critical threats, you confirm the critical hit only once using your highest base attack bonus.
        \nIf you hit with two or more attacks, the target must succeed at a Fortitude save (DC = 10 + 1/2 your base attack bonus + your Strength modifier) or suffer a condition for 1d4 rounds. If at least two attacks hit, you can choose from deafened, entangled, or shaken. If at least three attacks hit, you can also choose from blinded or staggered. If at least four attacks hit, you can also choose the dazed condition. Once you have forced a foe to attempt a saving throw to avoid suffering a condition via this feat, you cannot attempt to inflict that condition on it again with Devastating Assault for 24 hours.`,
        prereq: "",
    },
    {
        name: "Difficult Swings",
        type: "martial",
        longDesc: `When you make a full attack with a two handed melee weapon, you can force creatures to treat squares adjacent to you as difficult terrain until the beginning of your next turn.        
        \nYou can choose to allow any creature you are aware of to ignore the difficult terrain you effectively create with this ability.`,
        prereq:"",
    },
    {
        name: "Ricochet Toss",
        type: "martial",
        longDesc: `When you make a ranged attack with a thrown weapon, the weapon returns to your hand immediately after the attack is resolved, as long as it was not special ammunition such as grenades, ranged weapon ammunition, or improvised weapons.`,
        prereq:"",
        },
    {
        name: "Duelist",
        type: "martial",
        shortDesc: "",
        longDesc: "While wielding a buckler and a 1-handed heavy or light blade the shield bonus you gain from buckler increases by +1. You can also spend 3 spell points to attack with your weapon with two hands while ignoring the -1 penalty to attack rolls and keep your shield bonus to armor class for 1 round. If you activate this ability and a creature misses you because of this bonus armor class it gains a -2 penalty on the rest of its attacks against you for the rest of the turn.",
        prereq: "",
    },
    // {
    //     name: "Expanded Summon Monster",
    //     type: "magic",
    //     shortDesc: "",
    //     longDesc: "",
    //     prereq: "",
    // },
    {
        name: "Tactical Rush",
        type: "martial",
        shortDesc: "",
        longDesc: "Once per combat you can move up to your speed as a swift action.",
        prereq: "",
    },
    {
        name: "Acupuncture Specialist",
        type: "utility",
        shortDesc: "",
        longDesc: "You can use the 'Bandage Up' option of the heal skill to attempt to remove curses. To do so, roll a heal check, if the result is higher than the DC of the curse +15, the curse is removed. You can only do this on a specific ally once per day, but it does not count towards your uses of the 'Bandage Up' skill.",
        prereq: "",
    },
    {
        name: "Esoteric Acupuncture Specialist",
        type: "utility",
        shortDesc: "",
        longDesc: "You can now use Acupuncture Specialist feat to treat the nauseated, petrified, or stunned conditions. If an ability does not have a DC related to it, you cannot use this to fix it.",
        prereq: "Acupuncture Specialist",
    },
    {
        name: "Strength in Diversity",
        type: "utility",
        shortDesc: "",
        longDesc: "You get a +1 morale bonus to saves for each adjacent ally that is a unique race from you.",
        prereq: "",
    },
    {
        name: "Acute Shot",
        type: "martial",
        shortDesc: "",
        longDesc: "You can deduct the attack penalties from range increments from your damage instead of your attack. Additionally, if you have at least a +1 enhancement bonus on your attack, you can deal sneak attack damage on a ranged attack against a creature with concealment(but not total concealment) as long as the attack otherwise qualifies to deal sneak attack damage.",
        prereq: "",
    },
    {
        name: "Strength in Unity",
        type: "martial",
        shortDesc: "",
        longDesc: "You gain a +1 bonus to the numeric modifier teamwork feats grant if the ally you are using the teamwork feat is the same race as you",
        prereq: "",
    },
    {
        name: "Taskmaster",
        type: "utility",
        shortDesc: "",
        longDesc: "As a standard action you can spur on an ally into reckless effort. Roll an intimidate check against the ally, for the normal duration of the shaken they are instead spurred on, gaining a +1 bonus to attack rolls, damage rolls, and will saves against mind-affecting effects, however they also take a -2 penalty to AC and skill checks. The ally does not need to be willing for you to use this ability. For each 10 ranks in intimidate you have, the bonus increases by +1, and the penalty increases by -2.",
        prereq: "",
    },    
    {
        name: "Commissar's Encouragement",
        type: "utility",
        shortDesc: "",
        longDesc: "By making an attack against an ally currently under a fear effect you give strong encouragement for your other allies to not fall to such weakness. Make an attack against an ally, all other allies that see it can use the damage you dealt as the result of a re-save against their current fear effect as an immediate action. If you knock out the teammate they get the re-save without requiring an action. If you do this with a gun the bonus is increased by +1, +1 per 4 levels. If you kill the teammate your allies become immune to fear effects for 5 rounds.",
        prereq: "Taskmaster",
    },
    {
        name: "Weakness Will Not Be Suffered",
        type: "utility",
        shortDesc: "",
        longDesc: "You can execute a party member as a full-round action with a weapon wielded, all allies who see it gain your level/2 as a morale bonus to their attacks, damage, and saves against fear, compulsion, and to fortitude saves, but a penalty to their armor class and skill checks equal to your level. If you do this with a gun the bonus is increased by +1, +1 per 4 levels, but so are the penalties. This bonus lasts until the ally is revived.",
        prereq: "Commissar's Encouragement",
    },
    {
        name: "Thrill of the Hunt",
        type: "martial",
        shortDesc: "",
        longDesc: "When you enter a map except the first you roll a survival check DC=15+map CR, if you succeed you mark a random enemy (each enemy that spawns/you encounter has a 15% chance to the that marked enemy until it appears) You gain a +2 insight bonus on attacks damage, and knowledge skill checks against it, increasing by +1 for each 10 you beat the DC by. If you successfully land the killing blow on your mark the bonus provided by this feat permanently increases by +1.",
        prereq: "",
    },
    {
        name: "Huntmaster",
        type: "martial",
        shortDesc: "",
        longDesc: "If you land the killing blow on your mark you can now roll another survival check to re-activate Thrill of the hunt, and for each killing blow you successfully land on a monster the chance your marked creature appears increases by 5% permanently.",
        prereq: "Thrill of the Hunt",
    },
    {
        name: "Lord of the Hunt",
        type: "martial",
        shortDesc: "",
        longDesc: "Your allies gain 1/4 the bonus you gain from Thrill of the Hunt against your marked target. Whoever lands the killing blow on the marked creature regains HD hit points and spell points.",
        prereq: "Huntmaster",
    },
    {
        name: "Demoralizing Lash",
        type: "martial",
        shortDesc: "",
        longDesc: "While wielding a weapon from the flail group. If you hit a creature currently shaken because it was demoralized by an intimidate check you extend the duration of that shaken by 1 round.",
        prereq: "",
    },
    {
        name: "Terrorizing Display",
        type: "martial",
        shortDesc: "",
        longDesc: "You can perform a terrorizing show of prowess as a full-round action, you can roll an intimidate check against all allies within 30 feet to affect them with the taskmaster feat, and increase the bonuses by +1 and the penalities by -2 for each 10 you beat the DC by. If you have the dazzling Display feat you can activate these both at the same time, using the same intimidate check for both.",
        prereq: "Taskmaster",
    },
    {
        name: "Throat Slicer",
        type: "martial",
        shortDesc: "",
        longDesc: "When using a one-handed, light, or natural weapon, you can deliver a coup de grace to an unconscious, bound, or pinned target (though not other kinds of helpless targets) you can reduce the action to coup-de-grace that creature by 1 step.",
        prereq: "",
    },
    {
        name: "Dirty Fighting",
        type: "martial",
        shortDesc: "",
        longDesc: "When you attempt a combat maneuver check against a foe you are flanking, you can forgo the +2 bonus on your attack roll for flanking to instead have the combat maneuver not provoke an attack of opportunity. If you have a feat or ability that allows you to attempt the combat maneuver without provoking an attack of opportunity, you can instead increase the bonus on your attack roll for flanking to +4 for the combat maneuver check.",
        prereq: "",
    },
    {
        name: "Readied Assault",
        type: "martial",
        shortDesc: "",
        longDesc: "As a full round action, you can ready a full attack.",
        prereq: "",
    },
    {
        name: "Twin Throw",
        type: "martial",
        shortDesc: "",
        longDesc: "When making a full-attack action with a thrown weapon, your first attack fires two thrown weapons. If the attack hits, both weapons hit. Apply precision-based damage (such as sneak attack) and critical hit damage only once for this attack. Damage bonuses from a high Strength bonus apply to each weapon, as do other damage bonuses, such as a ranger's favored enemy bonus. Damage reduction and resistances apply separately to each weapon.",
        prereq: "",
    },
    {
        name: "Greater Twin Throw",
        type: "martial",
        shortDesc: "",
        longDesc: "When making a full-attack action with a thrown weapon, your first and second attack fires two thrown weapons. If the attack hits, both weapons hit. Apply precision-based damage (such as sneak attack) and critical hit damage only once for this attack. Damage bonuses from a high Strength bonus apply to each weapon, as do other damage bonuses, such as a ranger's favored enemy bonus. Damage reduction and resistances apply separately to each weapon.",
        prereq: "Twin Throw",
        perkPrereq:["Ranged Training"]
    },
    {
        name: "Bull Charge",
        type: "martial",
        shortDesc: "",
        longDesc: "If you have the Vital Strike feat, you can use Vital Strike (or Improved Vital Strike or Greater Vital Strike, if you have them) in place of the attack at the end of a charge. The damage dice added by Vital Strike, Improved Vital Strike, or Greater Vital Strike are not doubled when charging with a lance while mounted.",
        prereq: "Vital Strike",
    },
    {
        name: "Arcane Weaponry",
        type: "martial",
        shortDesc: "",
        longDesc: "Increase the DC of any weapon special properties that require a saving throw by +1 (this also applies to the DC's of magical armaments). This bonus increases by +1, increasing by +1 every 6 bab. This benefit only applies to weapons you are wielding (and applies for up to 1 round after leaving your grip or being fired, in the case of thrown weapons or ammunition, respectively).",
        prereq: "",
    },
    {
        name: "Dogpile",
        type: "teamwork",
        shortDesc: "",
        longDesc: "When attacking a prone creature that an ally who also has this feat threatens, you gain a +1 to the attack. This stacks.",
        prereq: "",
    },
    {
        name: "Fang and Fury",
        type: "martial",
        shortDesc: "",
        longDesc: "Once per round you may make a bite attack as an additional part of initiating a strike. This bite attack must be made against one of the targets of your strike. It does not gain any of the benefits of the strike (though it might benefit from other effects, such as boosts or stances).",
        prereq: "",
    },
    {
        name: "Ferocious Assault",
        type: "martial",
        shortDesc: "",
        longDesc: "When attacking with both manufactured weapons and natural attacks within the same full attack, your secondary natural attacks take only a -2 penalty.",
        prereq: "",
    },
    {
        name: "Einhander",
        type: "martial",
        shortDesc: "",
        longDesc: `As long as you are only wielding a light or one-handed weapon (unarmed weapons do not count) in one hand and no other weapons or shields in your off-hand(s), you gain a +2 dodge bonus to your armor class.

        \nIn addition, once per round when a creature within your weapon's reach misses you with a melee attack while you are wielding a light or one-handed weapon (unarmed weapons do not count) in one hand and no other weapons or shields in your off-hand(s), you may make an attack of opportunity against that creature.`,
        prereq: "",
    },
    {
        name: "Improved Einhander",
        type: "martial",
        shortDesc: "",
        longDesc: `As long as you are only wielding a single, light or one-handed weapon in one hand and no other weapons or shields in your off-hand(s), you may add your half of the total of your enhancement bonuses of your weapon to your armor class as a dodge bonus (minimum 1).`,
        prereq: "Einhander",
    },
    {
        name: "Dolphin Flip",
        type: "martial",
        shortDesc: "",
        longDesc: "After making a standard Action melee attack, you may withdraw as a Move Action, however to determine how far you can move, you must make a swim check. Unless you are swimming then you can move your movement speed.",
        prereq: "",
    },
    {
        name: "Oath of Protection",
        type: "teamwork",
        shortDesc: "",
        longDesc: `This teamwork feat only works one way, only the sender can use its benefits. Whoever you give this feat to becomes your charge. If you are adjacent to your Charge, you may, as an immediate action, redirect any single target spell or effect, or an attack made against them to yourself.`,
        prereq: "",
    },
    {
        name: "Enduring Mind",
        type: "utility",
        shortDesc: "",
        longDesc: `Whenever you would suffer ability damage to a mental ability score, reduce that damage by 1 (to a minimum of 0). Ability damage you deal to yourself (such as from one of your feats or powers) is not reduced in this fashion.`,
        prereq: "",
    },
    {
        name: "Improved Enduring Mind",
        type: "utility",
        shortDesc: "",
        longDesc: `Whenever you would suffer ability damage to a mental ability score, reduce that damage by 2 instead of 1 (to a minimum of 0). Ability damage you deal to yourself (such as from one of your feats or powers) is not reduced in this fashion.`,
        prereq: "Enduring Mind",
    },
    {
        name: "Weapon Group Adaptation",
        type: "martial",
        shortDesc: "",
        longDesc: "When you get this feat select a weapon group (augmenting, light, one-handed, two-handed, primitive, tech, armament). For perks and feats that require you to select a type of weapon, you can also use this type of weapon. This only applies if you get to select the weapon.",
        prereq: "",
        key:true,
    },
    {
        name: "Improved Weapon Group Adaptation",
        type: "martial",
        shortDesc: "",
        longDesc: "When an ability or perk requires using a specific weapon, such as a scythe, you can instead use any weapon of the same weapon group.",
        prereq: "Weapon Group Adaptation",
    },
    {
        name: "Greater Weapon Group Adaptation",
        type: "martial",
        shortDesc: "",
        longDesc: "When an ability requires you use a certain kind of weapon, you can also use the weapon type you chose in weapon group adaptation, as long as your weapon meets all of the other prerequisites.",
        prereq: "Improved Weapon Group Adaptation",
    },
    {
        name: "Weapon Type Adaptation",
        type: "martial",
        shortDesc: "",
        longDesc: "When you select this feat, choose a damage type (bludgeoning, slashing, piercing). When you select a feat or ability that requires you to use a weapon that deals a specific damage type, you can also use that damage type.",
        prereq: "",
    },
    {
        name: "Armament Master",
        type: "magic",
        shortDesc: "",
        longDesc: "You can apply power attack to a magical armament's damage.",
        prereq: "",
        key:true,
    },
    {
        name: "Armament Grandmaster",
        type: "magic",
        shortDesc: "",
        longDesc: "You can apply power attack to a magical armament's damage, even when it is dealing damage as if it had struck a creature, such as when it is dealing damage through its special ability.",
        prereq: "Armament Master",
    },
    {
        name: "Hone Weapon",
        type: "utility",
        shortDesc: "",
        longDesc: "Roll a craft check when you get this feat or when entering a floor DC 20, if you succeed; one weapon you or an ally has gains a +1 bonus on damage for the next combat. For each 10 you beat the DC by the bonus increases by +1, and for each 15 you beat the DC by it lasts an additional combat. This feat cannot grant bonuses to magical armaments.",
        prereq: "",
    },
    {
        name: "Weaken the Prey",
        type: "martial",
        shortDesc: "",
        longDesc: "Cursed creatures, diseased creatures, shaken creatures, and creatures suffering from ability damage take a -2 penalty on saving throws against your maneuvers.",
        prereq: "",
    },
    {
        name: "Treacherous Will",
        type: "utility",
        shortDesc: "",
        longDesc: "When you are flanking a creature, it takes a -2 penalty on saving throws against your abilities.",
        prereq: "",
    },
    {
        name: "Enduring Protector",
        type: "martial",
        shortDesc: "",
        longDesc: "Whenever you reduce an opponent to 0 or fewer hit points with an attack of opportunity, you gain temporary hit points equal to that opponent's Hit Dice. These temporary hit points do not stack with themselves, and last for one round.",
        prereq: "",
    },
    {
        name: "Channeled Recovery",
        type: "magic",
        shortDesc: "",
        longDesc: "When you use your prerequisite ability to heal allies (but not yourself), allies in your channeled energy area may choose to forgo the healing to instead recover spell points equal to their highest level of maneuver known.",
        prereq: "",
        perkPrereq:["Channel Energy", "Epic Channel Energy", "Lay On Hands", "Fervor", "Hemomancy"]
    },
    {
        name: "Fast Shift",
        type: "utility",
        shortDesc: "",
        longDesc: "Changing your form now takes a movement action.",
        prereq: "",
        perkPrereq:["Skinwalker", "Wild Shape"]
    },
    {
        name: "Natural Spell",
        type: "magic",
        shortDesc: "",
        longDesc: "You can complete the verbal and somatic components of spells while using wild shape. You substitute various noises and gestures for the normal verbal and somatic components of a spell, and can use any materials even if they are fused with your current form.",
        prereq: "",
        perkPrereq:["Wild Shape"]
    },
    {
        name: "Energized Wild Shape",
        type: "martial",
        shortDesc: "",
        longDesc: "When you assume a wild shape form, choose one of the following energy types: acid, cold, electricity, or fire. You gain resistance 10 to that energy type. Also, one of your types of natural attacks deals an additional 1d6 points of damage of the chosen energy type. If you choose a wild shape form that already has energy resistance of the same type you choose, it increases by 5 instead. If you choose a wild shape form that deals damage of the same energy type you choose, increase the energy damage you deal by 1d6.",
        prereq: "",
        perkPrereq:["Wild Shape"]
    },
    {
        name: "Elemental Claws",
        type: "martial",
        shortDesc: "",
        longDesc: "When you attack with a natural weapon, select one of the following energy types: acid, cold, electricity, or fire. If you hit, the attack deals its normal damage plus 1d6 points of damage of the chosen energy type. You must declare that you are using this feat before you make your attack roll (a failed attack roll ruins the attempt). Using elemental claw costs 4 spell points, and you cannot use it more than once per round, plus an additional time per 6 bab.",
        prereq: "",
        perkPrereq:["Wild Shape"],
    },
    {
        name: "Master of Claw and Fang",
        type: "universal",
        shortDesc: "",
        longDesc: "If you are only attacking with natural attacks on your turn, choose one of your natural attacks, you can make itterative attacks with it as if it was a normal weapon for having a high BAB. All attacks you take in that round take a -2 penalty for each itterative attack you make.",
        prereq: "",
        perkPrereq:["Wild Shape"]
    },
    {
        name: "Fuse Styles",
        type: "utility",
        shortDesc: "",
        longDesc: "You can enter a fighting style and a martial stance with the same swift action.",
        prereq: "",
    },
    {
        name: "Hypocrite",
        type: "utility",
        shortDesc: "",
        longDesc: "When using an ability or spell that is based on alignment you can choose to act as your direct opposition alignment. You act as your opposition alignment for the entire ability. This has no effect on true neutral creatures, as they stand for nothing anyway. You get a temporary negative level for 5 rounds when using this feat.",
        prereq: "",
    },
    {
        name: "Extreme Hypocrisy",
        type: "utility",
        shortDesc: "",
        longDesc: "When affected by an ability that has different results depending on your alignment, you can roll a bluff or diplomacy check as an immediate action DC 10+the dc of the ability to act as your direct opposition alignment (if no dc, the check must be 5 + creatures HD + wisdom mod, or 5+ its sense motive, whichever is higher). You cannot gain any sacred or profane bonuses for the rest of the floor, and you get a temporary negative level that lasts 5 rounds.",
        prereq: "Hypocrite",
    },
    {
        name: "Focused Shot",
        type: "martial",
        shortDesc: "",
        longDesc: "As a standard action, you may make an attack with a bow, crossbow, or firearm and add your Intelligence modifier on the damage roll as precison damage (this stacks with crossbow bonus damage). You must be within 30 feet of your target to deal this extra damage. Creatures immune to critical hits and sneak attacks are immune to this extra damage, and attacks that apply damage multiple times still only apply this a single time.",
        prereq: "",
    },
    {
        name: "Improved Focused Shot",
        type: "martial",
        shortDesc: "",
        longDesc: "As a swift action you can spend level/2 spell points to cause all of your ranged attacks in a round with the required weapons to apply the damage of focused shot, however all of your attacks take a -4 penalty to them.",
        prereq: "Focused Shot",
    },
    {
        name: "Greater Focused Shot",
        type: "martial",
        shortDesc: "",
        longDesc: "You can activate improved focus shot as a free action, but doing so increases the spell point cost to your level.",
        prereq: "Improved Focused Shot",
    },
        {
        name: "Style Blending",
        type: "martial",
        shortDesc: "",
        longDesc: "Once per round you can swap to a different style feat as a free action.",
        prereq: "",
        },
        {
        name: "Improved Style Blending",
        type: "martial",
        shortDesc: "",
        longDesc: "When swapping your style as a free action, if you do so during a specific action (such as an attack, or a skill check, not things like a full-round action or movement action), you can complete that action as if you had both of the style feats active at the same time.",
        prereq: "Style Blending",
        },
        {
        name: "Greater Style Blending",
        type: "martial",
        shortDesc: "",
        longDesc: "You can swap your style feat as a swift action, when you do you can act as if you were in both styles for the rest of the turn.",
        prereq: "Improved Style Blending",
        },
        {
        name: "Weapon Style Mastery",
        type: "martial",
        shortDesc: "",
        longDesc: "When you select this feat choose another style you know, you can have that style and another style active at once. Starting a stance provided by a style feat is still a swift action, but you can assume both the chosen style's stance and another style's stance simultaneously using this action.",
        prereq: "",
        },
        {
            name: "Distracting Fire Style",
            type: "style",
            shortDesc: "",
            longDesc: `This styles benefits only apply when using a ranged weapon. Once per round when making a ranged attack that passes through a friendly creatures space, you can make it a distracting attack, taking a -2 penalty to your attack, and if it hits it grants the creatures it passed through a +2 bonus to their armor class against the creature the attack struck for 1 round. For each additional distracting fire style feat you have, you can choose to increase the penalty and bonus this feat gives by 2.`,
            prereq: "",
        },
        {
            name: "Distracting Fire Opening",
            type: "style",
            shortDesc: "",
            longDesc: `If the attack is successful, the creatures that your attack passed through also gains a +2 bonus on attacks against the struck creature for 1 round. This bonus increases by +1 for each distracting fire style feat you have. If your attack is a critical hit, the creature also becomes flat-footed against attacks made by ally for 1 round.`,
            prereq: "Distracting Fire Style",
        },
        {
            name: "Distracting Fire Opportunity",
            type: "style",
            shortDesc: "",
            longDesc: `A creature distracted by distracting fire cannot make any attacks of opportunity against the covered ally for 1 round. If your distracting attack is a confirmed critical hit, the creatures your attack passed through can make a melee attack of opportunity against the struck creature if they are within reach of the distracted creature.`,
            prereq: "Distracting Fire Opening",
        },
        {
            name: "Arrow Dancer Style",
            type: "style",
            shortDesc: "",
            longDesc: `This styles benefits only apply when using a ranged weapon. When making a full-attack with a ranged weapon, before you have made any attacks in that turn you can use a swift action to prepare to make a dodging step. Then, once before the start of your next turn when an attack is declared against you, you can take a 5-foot step. You can take this 5-foot step even if you have already taken a 5-foot step, however it provokes from creatures other than the creature you activated this ability against. The attack also resolves even if you step to a location the creature could no longer attack you. You must be aware of the attack and not flat-footed to use this ability.`,
            prereq: "",
        },
        {
            name: "Arrow Dancer Preparation",
            type: "style",
            shortDesc: "",
            longDesc: `When using arrow dancer style and preparing to dodge, you can choose to take a penalty to your attacks for 1 round up to a maximum of your dexterity modifier. Then when you use your dodging step, you gain a dodge bonus to your armor class equal to the attack penalty you took. If this bonus to armor class causes the creature to miss its attack, you keep the bonus to armor class against any other attack it makes until the start of its next turn. If after you have taken a dodging step it would cause the attack against you to have a penalty due to positioning, such as cover or concealment, you gain that bonus from the attack.`,
            prereq: "Arrow Dancer Style",
        },
        {
            name: "Arrow Dancer Retaliation",
            type: "style",
            shortDesc: "",
            longDesc: `When you take your dodging step you can choose to either move 10-feet instead of 5, have your 5-foot step not provoke from any creature, or to make a ranged attack against the creature who you dodged. This attack does not provoke from the creature you dodged, and any penalty you took to your attacks from Arrow Dancer Preparation instead becomes a bonus to your attack. If the additional dodge bonus you gained from Arrow Dancer Preparation caused the attack to miss, your critical threat range on this attack increases by a flat +1. If the bonus attack you gained from Arrow Dancer Preparation caused the attack to hit, your critical damage multiplier increases by +1.`,
            prereq: "Arrow Dancer Preparation",
        },
        {
            name: "Volley Fire Style",
            type: "teamwork",
            shortDesc: "",
            longDesc: `This is a style feat and a teamwork feat. If you make a ranged attack against a target that another ally with this feat has already made a ranged attack against, your first attack against them this round gains a bonus to its attack equal to the amount of attacks your allies with this feat made against it.`,
            prereq: "",
        },
        {
            name: "Volley Fire Penetration",
            type: "style",
            shortDesc: "",
            longDesc: `Your ranged attacks bypass 1 point of DR for each ranged attack an ally with volley fire style made against the creature this round.`,
            prereq: "Volley Fire Style",
        },
        {
            name: "Volley Fire Synchronous Shot",
            type: "style",
            shortDesc: "",
            longDesc: `When you score a critical hit with a ranged weapon, your allies with Volley Fire style can make an attack of opportunity with a ranged weapon against the target if they are within their weapons first range increment. Additionally, the bonus you gain from Volley Fire style applies to your first and second attack each round, and on your first attack it gains a bonus on its damage equal to the bonus to attack it gained. This bonus damage is precision damage.`,
            prereq: "Volley Fire Penetration",
        },
        // {
        //     name: "Flurry of Stars Style",
        //     type: "style",
        //     shortDesc: "",
        //     longDesc: `You can make thrown attacks while prone with no penalty. `,
        //     prereq: "",
        // },
        {
            name: "Sniper Style",
            type: "style",
            shortDesc: "",
            longDesc: `The benefits of this style only apply to ranged weapons. At the start of your turn you can reduce the range increment of your weapon by any amount you want to a minimum of 10 feet, any reduction lasts until the start of your next turn. When you make a ranged attack you gain a bonus to damage of +2 per range increment penalty you are currently taking, this is precision damage.`,
            prereq: "",
        },
        {
            name: "Sniper Style Headshot",
            type: "style",
            shortDesc: "",
            longDesc: `For every 3 range increments penalties you suffer, your critical damage multiplier increases by +1. The minimum range increment of your weapons is now 5 feet.`,
            prereq: "Sniper Style",
        },
        {
            name: "Sniper's Perfect Shot",
            type: "style",
            shortDesc: "",
            longDesc: `As a standard action you can make a single attack with your ranged weapon, it deals an additional 1 point of damage for every 5 feet it travels before striking the target. This is precision damage, but it is still multiplied on critical hits.`,
            prereq: "Sniper Style Headshot",
        },
        {
            name: "Covering Fire Style",
            type: "style",
            shortDesc: "",
            longDesc: `The benefits of this style can only be used with ranged weapons. When any ally within your first range increment or 30 feet, whichever is shorter provokes an attack of opportunity, you can expend an attack of opportunity to make an attack against the attack of the creatures attack of opportunity, if your attack is higher, the creatures attack of opportunity takes a -4 penalty to it, -4 for each covering fire style feat you have, but your attack otherwise deals no damage. You must declare use of this ability before the targets attack of opportunity is rolled. You also gain a -1 penalty to the attack for each size larger the creature is. You must be aware of and see the attack of opportunity take place, and have a ranged weapon wielded and loaded to use this ability. If the creatures attack roll is a natural 20 this ability always fails.`,
            prereq: "",
        },
        {
            name: "Covering Fire Protection",
            type: "style",
            shortDesc: "",
            longDesc: `When you use the ability granted by Covering Fire Style, if you cause a creatures attack of opportunity to miss, the ally the attack missed can take a free 5-foot step, even if it already took one this round, this 5-foot step does not provoke from the creature that took the attack of opportunity, and for the rest of the round the ally gains a +2 dodge bonus to armor class against the enemy. The range of covering fire becomes 40 feet or your first range increment, whichever is shorter.`,
            prereq: "Covering Fire Style",
        },
        {
            name: "Covering Fire Decimation",
            type: "style",
            shortDesc: "",
            longDesc: `When you use the ability granted by Covering Fire Style, if your attack of opportunity to deflect the attack is successful, you can reduce the attack by -10, and if this is higher than the attacking creatures armor class, you can deal your damage with the attack to the creature. to negate the attack of opportunity is successful. If the triggering attack is a natural 20 this ability no longer automatically fails if your attack roll is also a natural 20. If it is, the attempt is an automatic success, and your attack automatically confirms as a critical hit, and the critical damage multiplier increases by +2. The range of covering fire style increases to 60 feet or your first range increment, whichever is shorter.`,
            prereq: "Covering Fire Protection",
        },
        {
            name: "Gun-Fu Style",
            type: "style",
            shortDesc: "",
            longDesc: `Any creature you attack with a melee weapon cannot make attacks of opportunity against you for firing or reloading a ranged weapon for 1 round. You gain a +2 to hit a creature with a ranged attack if you have made a successful melee attack against them this round, and a +2 on melee attacks if you have successful attack with a ranged weapon against them. Both of these bonuses increase by +1 for each Gun-fu feat you have.`,
            prereq: "",
        },
        {
            name: "Gun-Fu Weapon Improvisation",
            type: "style",
            shortDesc: "",
            longDesc: `When you successfully make a melee attack against a creature, for the rest of your turn any bonuses you gain from feats and perks that affect the melee weapon you struck the creature with that applies to all attacks you make in a round, also apply to the next ranged attacks you make against that creature. The opposite applies with ranged attacks. If you make multiple attacks with one weapon type, it stacks, applying to one more attack of the other type. This doesn't apply to the bonuses gained from Gun-Fu Style.`,
            prereq: "Gun-Fu Style",
        },
        {
            name: "Gun-Fu Deadly Dance",
            type: "style",
            shortDesc: "",
            longDesc: `When you score a critical hit with a range weapon against a creature this is within your reach, you can make an additional melee attack against them at a -4 penalty. Whenever you score a critical hit with a melee weapon you can reload a single shot in a ranged weapon you are currently wielding. If your weapon is already fully loaded, the next ranged attack you make this round with the weapon gains a +1 bonus to its critical threat range. This is a flat bonus unmodified by other abilities, but multiple critical hits with a melee weapon increase the critical threat range.`,
            prereq: "Gun-Fu Weapon Improvisation",
        },
        {
            name: "Wind Runner Style",
            type: "style",
            shortDesc: "",
            longDesc: `When using shot on the run, you can also use any other feat that requires you making a full-round attack with ranged weapons, such as rapid shot or manyshot, and also abilities that apply when you use two move actions to move, such as lightning stance.`,
            prereq: "Shot on the Run",
        },
        {
            name: "Wind Runner Flurry",
            type: "style",
            shortDesc: "",
            longDesc: `When using shot on the run, you can make an additional attack at your highest bonus. You can move an additional 10 feet during shot on the run per wind runner feat you have.`,
            prereq: "Wind Runner Style",
        },
        {
            name: "Wind Runner Leap",
            type: "style",
            shortDesc: "",
            longDesc: `When you make a ranged attack with shot on the run, the attack gains a bonus to damage of +1 for each 10 feet of movement in a straight line you made before you made the attack. If you make multiple attacks at the end of the movement each can gain the bonus.`,
            prereq: "Wind Runner Flurry",
        },
        {
            name: "Rifleman Style",
            type: "style",
            shortDesc: "",
            longDesc: `When you make a ranged attack from prone you gain a +2 bonus to attack rolls, and your bonus to armor class against ranged attacks increases by +2. Both of these bonuses increase by +1 for each rifleman feat you have.`,
            prereq: "",
        },
        {
            name: "Rifleman Brace",
            type: "style",
            shortDesc: "",
            longDesc: `When prone you can take a movement action to brace your gun, then until you move from the spot, your ranged attacks with the braced weapon ignore the penalties from deadly aim(power attack) for your first attac plus one additional attack for every 6 BAB you have.`,
            prereq: "Rifleman Style",
        },
        {
            name: "Rifleman Combat Roll",
            type: "style",
            shortDesc: "",
            longDesc: `Once per combat when you are prone and targeted by an attack or in response to making a reflex save against an area of effect ability, you can as an immediate action make an acrobatics check, moving feet equal to the result of the check, up to a maximum of your movement speed. This movement must be in a straight line, and does not provoke. If you would be in a position after your roll where you could no longer be targeted by the attack, the attack fails, if its in response to a reflex save and you leave the area of the effect, you gain evasion against the ability. After using this ability, whether successful or not, you are staggered on your next turn, and you end this movement prone. You can reload a weapon as long as it could be reloaded in a standard action or less while using this feat.`,
            prereq: "Rifleman Brace",
        },
        {
            name: "Weaponmaster Style",
            type: "style",
            shortDesc: "",
            longDesc: `When in this style, for each unique weapon you have used to make an attack roll this activation of weaponmaster style, you gain a +1 to attack and damage on weapon attacks. This bonus resets once you use the same weapon to attack more than once, and you must reactivate this style feat.`,
            prereq: "",
        },
        {
            name: "Weaponmaster Final Strike",
            type: "style",
            shortDesc: "",
            longDesc: `When you use a weapon that you have used before this activation of weaponmaster style, it instead gains double the bonus to attack and damage for that single attack, and then the bonus resets and you must reactivate the style. If your final strike is a confirmed critical hit, you are not removed from the style, and can continue attacking with weapons you have used before until you fail to confirm a critical hit.`,
            prereq: "Weaponmaster Style",
        },
        {
            name: "Weaponmaster, Unlimited Techniques",
            type: "style",
            shortDesc: "",
            longDesc: `Whenever you attack with a new weapon, as part of that attack you can take on another style feat as long as you could apply the benefits of that feat to the attack you are making. You can maintain this style and the other style taken on as part of this feat at the same time (only 1 single new style can be taken on at a time). For each additional unqiue style you activate during the activation of weaponmaster style you gain a +2 bonus to attack and damage with weapon attacks. If you have additional feats that have the style feat as a previous feat in the chain, you gain another additional +1 to attack and damage with weapon attacks. You cannot enter a style you have already entered this activation of weapon master style, and the style only lasts until you attack with a new weapon or leave weaponmaster style . This bonus attack and damage is not doubled for final strike.`,
            prereq: "Weaponmaster Final Strike",
        },
        {
            name: "Angel Guard Style",
            type: "style",
            shortDesc: "",
            longDesc: `When you use Combat Expertise to grant yourself a dodge bonus to AC, the penalty you take to attack rolls is reduced by 1.

            In addition, when you use Combat Expertise or take the total defense action you can designate one ally that is in an adjacent space to you. That ally gains a dodge bonus to AC equal to the bonus you granted yourself. If the ally is unconscious or helpless, the bonus is doubled. The ally loses the benefit if it is not adjacent to you, and the bonus lasts until the start of your next turn.`,
            prereq: "",
        },
        {
            name: "Angel Guard Retaliation",
            type: "style",
            shortDesc: "",
            longDesc: `Once per round when an opponent attacks the ally you are defending with Angel Style with a weapon or natural attack, you can choose to either defend or avenge your ally.

            If you defend your ally, you can use an attack of opportunity to make an attack roll against the attacking creature. If your attack roll beats the attacker's attack roll, you deal no damage, but the attacker's attack fails.
            
            If you avenge your ally, you make an attack of opportunity against the opponent. You do not take the normal penalty to attack rolls from Combat Expertise when making this attack, and your attack deals an additional 1d8 damage. This damage is the same type as the weapon used and is not multiplied on a critical hit. The opponent must be in your threatened area to make this attack of opportunity, and your attack must be made after the opponent's attack resolves.`,
            prereq: "Angel Guard Style",
        },
        {
            name: "Angel Guard Protection",
            type: "style",
            shortDesc: "",
            longDesc: `When you use Combat Expertise or fighting defensively to grant yourself a dodge bonus to AC, the penalty you take to attack rolls is reduced by an additional 2. This stacks with the reduction from Angel Style.

            Rather than designate a single adjacent ally to receive the benefit of your Angel Style, you can instead grant the benefit to all allies within 10 feet of you. When doing so, the dodge bonus granted to allies by Angel Style is reduced by half. An unconscious or helpless ally receives the normal benefits of Angel Style (as opposed to double the bonus). This also allows you to avenge or defend any affected ally once per round each, as described in Angel Retaliation. Affected allies lose the benefit if they move more than 10 feet away from you.`,
            prereq: "Angel Guard Retaliation",
        },
        {
            name: "Asura Dancing Style",
            type: "style",
            shortDesc: "",
            longDesc: `The bonus creatures receive to attack rolls when flanking you is reduced by 1, and you gain a +2 bonus to dodge AC to avoid attacks of opportunity from moving through a threatened square (this bonus stacks with the bonus granted by Mobility). Whenever you hit with an attack of opportunity with a melee weapon, you can move up to 10 feet in any direction, so long as your movement ends in a space adjacent to the opponent struck. This movement does not provoke attacks of opportunity from the target you struck, but provokes as normal from other creatures. Your total movement each round from this feat can't exceed your normal speed.`,
            prereq: "",
        },
        {
            name: "Asura Dancing Motion",
            type: "style",
            shortDesc: "",
            longDesc: `Each melee weapon attack you make within 1 round against a different target than the last deals an additional 2d6 damage per previous target hit. For example, if there are three different creatures that you strike, the first hit deals no additional damage, the second target takes 2d6 extra damage, and the third target takes 4d6 extra damage. This damage is not multiplied on a critical hit. The additional damage is only added once per target on the first attack you hit them with that turn.`,
            prereq: "Asura Dancing Style",
        },
        {
            name: "Asura Untouchable Dance",
            type: "style",
            shortDesc: "",
            longDesc: `Creatures do not gain an attack roll benefit when flanking you (though they can still gain other benefits of flanking, such as sneak attack), and the dodge bonus to AC to avoid attacks of opportunity from moving through a threatened square from Asura Style increases to +4.
            \nWhenever you take the full-attack action and strike with a melee weapon, you can move up to 10 feet before making your next attack. This movement does not provoke attacks of opportunity from the target you struck, but still provokes from other creatures as normal. You must have another attack to make in order to move in this manner, and cannot move a greater distance than your normal speed in a single turn.`,
            prereq: "Asura Dancing Motion",
        },
        {
            name: "Bebilith Style",
            type: "style",
            shortDesc: "",
            longDesc: `Whenever you make at least two successful attacks in a round against an opponent with a melee weapon, you can make a sunder check against that target as a free action at your full attack bonuses. You can only do this once per round.`,
            prereq: "",
        },
        {
            name: "Bebilith Claw",
            type: "style",
            shortDesc: "",
            longDesc: `You can make sunder checks against an opponent's natural armor. You make a sunder check as normal, using a melee weapon. On a successful hit, you deal only half your normal damage to the creature struck, but reduce the creature's natural armor by 1 (minimum 0). Armor bonus lost in this way can only be restored by a Heal check (DC 10 + your base attack bonus, taking 10 minutes per point of natural armor lost) or by applying a restoration, regenerate, heal, wish, or miracle to the creature (which restores all lost natural armor with no check needed). A creature that has the regeneration ability recovers lost natural armor bonus at a rate of 1 point per round.`,
            prereq: "Bebilith Style",
        },
        {
            name: "Bebilith Rend",
            type: "style",
            shortDesc: "",
            longDesc: `Any time you confirm a critical hit against an opponent or successfully make a sunder attempt against an opponent's armor or shield, you reduce the armor bonus that equipment provides by 1 (if from a critical hit, you choose whether to affect the creature's armor, shield, or its natural armor, as described in Bebilith Claw). Repairing the equipment to full hit points restores its lost AC bonuses. If an armor or shield's armor bonus is reduced to 0, it is reduced to half hit points, gains the broken condition, and is unequipped from the creature, regardless of its current hit points or hardness. The equipment falls on the ground in the creature's space.`,
            prereq: "Bebilith Claw",
        },
        {
            name: "Whip Mastery",
            type: "martial",
            shortDesc: "",
            longDesc: `You no longer provoke attacks of opportunity when attacking with a whip. You deal damage with a whip or spiked chain as if it were one size larger.`,
            prereq: "",
        },
        {
            name: "Improved Whip Mastery",
            type: "martial",
            shortDesc: "",
            longDesc: `While wielding a whip, you threaten the area of your natural reach plus 5 feet. You deal damage with a whip or spiked chain as if it were one size larger.`,
            prereq: "Whip Mastery",
        },
        {
            name: "Greater Whip Mastery",
            type: "martial",
            shortDesc: "",
            longDesc: `You are so quick with your whip that you never drop it due to a failed disarm or trip combat maneuver attempt. Further, you gain the ability to grapple using your whip. To do so, use the normal grapple rules with the following changes.
            \nAttack: You cannot use your whip to attack while you are using it to grapple an opponent.
            \nDamage: When dealing damage to your grappled opponent, you deal your whip's weapon damage rather than your unarmed strike damage.
            \nFree Hands: You take no penalty on your combat maneuver check for having fewer than two hands free when you use your whip to grapple.
            \nReach: Rather than pulling your grappled opponent adjacent to you when you successfully grapple and when you move the grapple, you must keep him within your whip's reach minus his own reach to maintain the grapple. If the difference in reach is less than 0, such as is the case for a Medium whip wielder and a Gargantuan creature, you cannot grapple that opponent with your whip. If you have to pull a creature adjacent to you to grapple it with your whip, you still provoke an attack of opportunity from that opponent unless you have the Improved Grapple feat.`,
            prereq: "Improved Whip Mastery",
        },
        {
            name: "Demon Whip Style",
            type: "style",
            shortDesc: "",
            longDesc: `While wielding a whip, you threaten the area of your natural reach plus 5 feet, and dont provoke attacks of opportunity while wielding a whip. Gain +2 to attacks with a whip while two weapon fighting.`,
            prereq: "",
        },
        {
            name: "Demon Whip Grasp",
            type: "style",
            shortDesc: "",
            longDesc: `When you score a critical hit with a whip, you can immediately attempt a grapple check using the whip (as described in Greater Whip MasteryUC) without provoking an attack of opportunity.
            \nIf you successfully grapple a creature using a whip, you can draw your foe into a square adjacent to you while maintaining the grapple. This does not provoke an attack of opportunity. You also gain a +2 bonus on combat maneuver checks to make or maintain a grapple with a whip.`,
            prereq: "Demon Whip Style",
        },
        {
            name: "Demon Whip Lash",
            type: "style",
            shortDesc: "",
            longDesc: `Whenever you grapple an opponent using a whip, you do not gain the grappled condition. If you successfully grapple an opponent with a whip and pull them adjacent to you, you can make an attack with your main-hand weapon against that creature as a free action with a +2 bonus to the attack roll.
            \nIn addition, so long as you maintain a grapple with your whip, you can maintain the grapple on your opponent as a swift action. This only lets you maintain the grapple; you cannot damage, move, pin, or tie-up your opponent without using a standard action to maintain as normal.`,
            prereq: "Demon Whip Grasp",
        },
        {
            name: "Divine Shield Style",
            type: "style",
            shortDesc: "",
            longDesc: `Increase the base shield bonus of your shield by +1 (this modifies abilities based off your base shield bonus). Your shieled bashes deal 1d6 extra damage, and you can shield bash with tower shields (1d6) and bucklers (1d3)`,
            prereq: "",
        },
        {
            name: "Divine Shield Defense",
            type: "style",
            shortDesc: "",
            longDesc: `Your shield bonus to armor class when wielding a shield except a buckler increases by +1, and you add your full strength modifier for damage rolls when making a shield bash even if it was an off-hand attack. If wielding with at +3 base shield bonus you can have it provide cover as if it was a tower shield as a standard action. If it is a tower shield it becomes a movement action,`,
            prereq: "Divine Shield Style",
        },
        {
            name: "Divine Shield Bulwark",
            type: "style",
            shortDesc: "",
            longDesc: `If you successfully hit at least one shield bash attack with a shield with at least a +3 base shield bonus when making a full-attack action, you can use a swift action to grant yourself total cover on one edge of your space. If you spend an action to place your shield (with the Divine Shield Defense feat), you can choose two contiguous sides of your space to defend, rather than just one.`,
            prereq: "Divine Shield Defense",
        },
        {
            name: "Devil Style",
            type: "style",
            shortDesc: "",
            longDesc: `If you successfully attack the same opponent at least twice in a single turn with a melee weapon, you cause the target to take 1d8 bleed damage. The bleed damage increases by +1 for every attack you hit the opponent with in the same turn above two (for example, if you strike an opponent with five attacks during your turn, the target takes 1d8 + 3 bleed damage). This bleed damage does not stack.`,
            prereq: "",
        },
        {
            name: "Devil Pact",
            type: "style",
            shortDesc: "",
            longDesc: `The bleed damage you inflict with Devil Style can now stack. Any opponent that is currently taking bleed damage from your Devil Style takes a -2 penalty to their AC and to saving throws.`,
            prereq: "Devil Style",
        },
        {
            name: "Devil Wound",
            type: "style",
            shortDesc: "",
            longDesc: `Any opponent that is taking bleed damage from your Devil Style has its speed reduced by half. This cannot reduce its speed below 5 feet.

            If you critically hit an opponent that is suffering from bleed damage inflicted by your Devil Style, you can inflict 1d2 points of Strength, Dexterity, or Constitution damage (your choice).`,
            prereq: "Devil Pact",
        },
        {
            name: "Garuda Style",
            type: "style",
            shortDesc: "",
            longDesc: `Whenever you attack a foe from high ground with a melee attack, you deal an additional 2 damage. This damage is doubled when performing a charge.

            You can now jump as part of a charge. You make an Acrobatics check when performing the charge, which determines how far you can jump, as normal. The attack from the charge must be made before you land, and you stop after making the attack, even if you miss or have additional distance remaining for your jump.
            
            If the Acrobatics check you made to jump is higher than the CMD of the creature you are charging, you are treated as being on higher ground for the purpose of making the attack, regardless of your actual positioning.
            
            If you are flying, rather than jumping, you can make a Fly check against your opponent's CMD to be treated as if on higher ground, as described above.`,
            prereq: "",
        },
        {
            name: "Garuda Dive",
            type: "style",
            shortDesc: "",
            longDesc: `You gain a +2 bonus to Acrobatics checks and Fly checks while using Garuda style.

            When you jump or fly during a charge using Garuda style, you can continue your movement. If you miss, you may continue in the normal direction of your jump or flight path in a straight line, but if you hit, you can alter the course of your jump or flight path to any other direction, including back the way you came (though this does not grant you any more jump height; it only changes the horizontal direction of a jump).
            
            If you have the high ground, you do not provoke attacks of opportunity from the creature you charge for moving towards or past it. You still provoke from other creatures, as normal.`,
            prereq: "Garuda Style",
        },
        {
            name: "Garuda Talon",
            type: "style",
            shortDesc: "",
            longDesc: `The damage bonus you gain from Garuda style increases to 4, and you gain an additional +1 bonus to melee attack rolls when you have the high ground.

            If you jump or fly at a creature while charging with Garuda style, you can make an additional attack. This attack uses the same weapon and uses your full attack bonuses, with a -5 to the attack roll. This attack cannot be used with other abilities that grant you additional attacks as part of a charge, such as pounce.`,
            prereq: "Garuda Dive",
        },
        {
            name: "Kami Style",
            type: "style",
            shortDesc: "",
            longDesc: `You can change the damage type of a weapon to deal bludgeoning, piercing, or slashing damage by taking a -2 penalty to attack, and your weapons always count as magic for overcoming DR. when an opponent targets you with a melee or ranged attack, you can use an immediate action to make a Perception check. You can use the result as your AC or touch AC against that attack. You must be aware of the attack and not flat-footed.`,
            prereq: "",
        },
        {
            name: "Kami Insight",
            type: "style",
            shortDesc: "",
            longDesc: `You gain a +2 bonus on Perception checks. You can now use Kami Style to make a Perception check in place of your AC against attacks that you are not aware of, and can do so even when flat-footed.
            \nWhenever you score a critical hit with a weapon, you can make a Perception check in place of the attack roll to confirm the critical hit.`,
            prereq: "Kami Style",
        },
        {
            name: "Kami Ward",
            type: "style",
            shortDesc: "",
            longDesc: `If you use Kami Style to use a Perception check in place of your AC, and the attacker is within 30 feet of you when you do so, you are immediately aware of its location, even if it is invisible, and remain aware of where it is so long as it is within 30 feet of you (as if you had blindsight to a range of 30 feet.). If the attacker is further than 30 feet away from you, you know which direction the attack came from, but not how far away the opponent is.
            If you use Kami Insight to make a Perception check to confirm a critical hit with a weapon, that weapon's critical multiplier increases by 1 for that attack.`,
            prereq: "Kami Insight",
        },        
        {
            name: "Inevitable Style",
            type: "style",
            shortDesc: "",
            longDesc: `Each round that you use a standard action to make an attack (including when using a vital strike feat, cleave, some martial strikes, or another ability that attacks as a standard action), you gain a +1 bonus to attack rolls and damage rolls (whether you hit or not). The bonus is granted after the attack resolves and stacks to a maximum of +4. You lose the stacking benefit and must regain it again should you spend more than 1 round not taking the attack action or if you target a different creature with your attacks. These bonuses only apply when taking a standard action to attack, or when making an attack of opportunity, not when performing full attack actions or other forms of attack, such as from a spell.
            \nIf you have a Vital Strike feat, the damage bonus provided by Inevitable Style is multiplied by the number of times you multiply the dice when using those feats: twice for Vital Strike, three times for Improved Vital Strike, or four times for Greater Vital Strike.`,
            prereq: "",
        },
        {
            name: "Inevitable Justice",
            type: "style",
            shortDesc: "",
            longDesc: `Once per round when taking the attack action or making an attack of opportunity with a weapon, you can declare it a justice strike. On this attack, you can use a Vital Strike feat, even if the strike is part of an attack of opportunity. You must declare that you are attempting the justice strike before making the attack roll.
            \nIf you hit, you immediately gain the maximum benefit provided by Inevitable Style (apply the bonus before calculating damage, instead of after), and the attack deals its average damage (rounded down), as if you had rolled exactly the average amount on the damage die or dice for the attack. You add other damage bonuses and penalties as normal.`,
            prereq: "Inevitable Style",
        },
        {
            name: "Inevitable Order",
            type: "style",
            shortDesc: "",
            longDesc: `The maximum bonus of your Inevitable Style increases to +6. When you switch targets or go more than one round without taking an attack action, your bonus from Inevitable Style goes down by 1 instead of being lost entirely.
            \nWhen you hit an opponent with an attack while you have a bonus from Inevitable Style, you can turn your benefit into a penalty upon the target struck. The target takes a penalty to its attack and damage rolls equal to the bonus you have from Inevitable Style + 1. Doing so immediately resets your bonus from Inevitable Style to +0. This is a supernatural effect that lasts for 1 round, and can only be used on a given creature once in a 24 hour period.`,
            prereq: "Inevitable Justice",
        },
        {
            name: "Protean Style",
            type: "style",
            shortDesc: "",
            longDesc: `Whenever you make an attack roll and the result of the die is a natural roll of a 19 or 20, you gain a +1 dodge bonus to AC. Whenever you make an attack roll and the result of the die is a natural roll of a 1 or 2, you gain a +1 bonus to attack rolls. These bonuses stack, up to +2 each. You must move at least 10 feet or make at least one attack each round to maintain these bonuses, otherwise both of the bonuses reset to +0 and must be gained again, and also end if combat ends.`,
            prereq: "",
        },
        {
            name: "Protean Twist",
            type: "style",
            shortDesc: "",
            longDesc: `You now gain the bonus to AC provided by Protean Style on a natural roll of an 18, 19, or 20, and gain the bonus to attack rolls on a natural roll of a 1, 2 or 3. The bonus to AC is doubled against critical hit confirmations against you, and the bonus to attack rolls is doubled on critical confirmation rolls you make.`,
            prereq: "Protean Style",
        },
        {
            name: "Protean Chaos",
            type: "style",
            shortDesc: "",
            longDesc: `You now gain the bonus to AC provided by Protean Style on a natural roll of a 17, 18, 19, or 20, and gain the bonus to attack rolls on a natural roll of a 1, 2, 3, or 4. The maximum bonus to AC or attack rolls granted by Protean Style is increased to +3.
            \nIf you have a +3 dodge bonus to AC from Protean Style and an opponent hits you, you can lose the dodge bonus you have gained (resetting it to +0) to cause the opponent to miss instead. If the creature had critically hit you, it instead deals normal damage (as if it had not critically hit).
            \nIf you have a +3 bonus to attack rolls from Protean Style and you miss an attack, you can lose the attack bonus you have gained (resetting it to +0) to instead have the attack roll be treated as a 20. This can only be used on an attack that missed due to a failed attack roll, not due to concealment or some other effect. This attack cannot critically hit and does not trigger any other abilities or effects that occur on a natural attack roll of a 20 (including Protean Style).`,
            prereq: "Protean Twist",
        },
        {
            name: "Psychopomp Style",
            type: "style",
            shortDesc: "",
            longDesc: `When you strike a creature with a ranged weapon, that creature gains one fate point. For every two fate points on a creature, it takes a -1 penalty to all saving throws against any effects created by you (max -4 penalty). Fate points last for 1 minute. This is a supernatural curse effect.`,
            prereq: "",
        },
        {
            name: "Psychopomp Fate",
            type: "style",
            shortDesc: "",
            longDesc: `For every two fate points a creature has from Psychopomp style, you gain a +1 bonus to attack and damage rolls made as part of attacks of opportunity against them when using a ranged weapon (max +4).

            For every four fate points a creature has, you treat your threatened area as being 5 feet larger as if using the snap shot feat (max 15 foot increase, this stacks with the snap shot feat).`,
            prereq: "Psychopomp Style",
        },
        {
            name: "Psychopomp Doom",
            type: "style",
            shortDesc: "",
            longDesc: `It takes half as many fate points to gain the benefits from Psychopomp Style and Psychopomp Fate for you, and you can stack both of the feats 1 additional time.

            For every two fate points a creature has from Psychopomp Style, the creature takes a -1 penalty on saving throws against all effects (max -2), not just your own. This does not stack with the penalty against your own effects (i.e. at four fate points, the creature has a -4 penalty to saves against your effects, and a -2 penalty to saves against anything else).`,
            prereq: "Psychopomp Fate",
        },
        {
            name: "Rakshasa Style",
            type: "style",
            shortDesc: "",
            longDesc: `You gain a +2 bonus on Bluff checks made to feint in combat, and can feint with a ranged weapon. Whenever you strike an opponent that is denied their dexterity bonus to AC, you deal an additional 1d6 precision damage.`,
            prereq: "",
        },
        {
            name: "Rakshasa Deception",
            type: "style",
            shortDesc: "",
            longDesc: `You can now feint as a movement action. If it was already a movement action it becomes a swift. If it was already a swift it becomes a free, but you can only do it once per turn. If you hit a creature that is denied its Dexterity bonus to AC, you throw the opponent off-balance. It takes a -2 penalty on attack rolls and saving throws and loses its Dexterity bonus to AC until the end of your next turn. The penalty does not stack.`,
            prereq: "Rakshasa Style",
        },
        {
            name: "Rakshasa Corruption",
            type: "style",
            shortDesc: "",
            longDesc: `Increase the precision damage you deal with Rakshasa style to 2d6. You no longer take a penalty to your feint check for feinting against a non-humanoid target. Feinting a creature of animal Intelligence (1 or 2) now imposes only a -4 penalty. You can feint a creature with no Intelligence score, although you have a -8 penalty when doing so.`,
            prereq: "Rakshasa Deception",
        },
        {
            name: "Titan Style",
            type: "style",
            shortDesc: "",
            longDesc: "While using this style, you can increase the damage of your weapon by 1 size for a -4 penalty to attack. If you aren't using strength to determine attack and damage you gain a further -2 penalty.",
            prereq: "",
        },
        {
            name: "Titan Grip",
            type: "style",
            shortDesc: "",
            longDesc: "While using Titan Style the penalty reduces by 1, plus an additional reduction of -1 for each 6 of your bab.",
            prereq: "Titan Style",
        },
        {
            name: "Titan Slayer",
            type: "style",
            shortDesc: "",
            longDesc: "While using Titan Style you can choose to instead gain a -8 penalty to attack, but your weapon is instead 2 sizes larger, if you do your weapons reach increases by 5 feet. If you aren't using strength to attack and damage the penalty is increases by a further -4.",
            prereq: "Titan Grip",
        },
        {
        name: "Archon Style",
        type: "style",
        shortDesc: "",
        longDesc: "While using this style, as a move action, you can protect adjacent allies from a single opponent that you currently threaten. This grants adjacent allies a +2 dodge bonus to AC against that opponent's next melee attack (as long as that attack comes before the beginning of your next turn), but causes you to take a -2 penalty to AC against that opponent until your next turn. The dodge bonus against the designated opponent's attacks persists even if your allies move away from you.",
        prereq: "",
        },
        {
        name: "Archon Diversion",
        type: "style",
        shortDesc: "",
        longDesc: "The penalty to AC for using Archon Style to grant nearby allies a bonus to AC against a single opponent decreases to -1. Once per round while using Archon Style, when you have at least one hand free or when wielding a shield, you can divert one melee weapon attack targeting an adjacent ally to yourself. After resolving the attack, the ally you protected can make an attack of opportunity against the diverted opponent. You expend no action to divert the attack, but you must be aware of it and must not be flat-footed. You must choose to divert the attack after the opponent has declared the melee attack, but before the attack roll is rolled.",
        prereq: "Archon Style",
        },
        {
        name: "Archon Justice",
        type: "style",
        shortDesc: "",
        longDesc: `You no longer take a penalty to AC for using Archon Style to grant nearby allies a bonus to AC, and you can activate this effect as a swift action or a move action.

        Whenever you take damage from an attack you diverted to yourself using Archon Diversion, each ally threatening the attacking creature can make an attack of opportunity against that creature.`,
        prereq: "Archon Diversion",
        },
        {
        name: "Asura Style",
        type: "style",
        shortDesc: "",
        longDesc: `When you attack a creature that is casting a divine spell, whether it was a prepared attack, or an attack of opportunity, the target is sickened for 1d4 rounds. A target can attempt a Fortitude save (DC = 10 + level/2 + your highest mental modifier) to reduce the duration of the sickened effect to 1 round.`,
        prereq: "",
        },
        {
        name: "Asura Sight",
        type: "style",
        shortDesc: "",
        longDesc: `When using Asura Style, you gain improved uncanny dodge as a rogue of your character level.`,
        prereq: "Asura Style",
        },
        {
        name: "Asura Spellrend",
        type: "style",
        shortDesc: "",
        longDesc: `You can replace one of your attacks at your highest base attack bonus each round with a spellrending strike. If your spellrending strike hits, it deals no damage, but you can attempt to dispel a harmless divine spell affecting this target as per dispel magic, with a caster level equal to your character level. If you succeed at your dispel check, the target is sickened as if you had interrupted the spell with Asura Style and receives no saving throw to reduce the sickened duration.`,
        prereq: "Asura Sight",
        },

        {
        name: "Azata Style",
        type: "style",
        shortDesc: "",
        longDesc: `While using this style, during any round in which you move at least 15 feet, you gain a +1 dodge bonus to your AC. This bonus lasts until the beginning of your next turn.`,
        prereq: "",
        },
        {
        name: "Azata Mischief",
        type: "style",
        shortDesc: "",
        longDesc: `While using Azata Style, whenever an opponent misses you with an attack of opportunity provoked by your movement through its threatened squares, you can attempt a trip combat maneuver against that creature at the end of your turn as a swift action, provided you are still adjacent to the creature when you end your movement for the round.

        This trip attempt does not provoke attacks of opportunity.
        
        You gain a bonus on your combat maneuver check equal to any bonuses to AC you gain against attacks of opportunity provoked by movement (such as that granted by the Mobility feat).`,
        prereq: "Azata Style",
        },
        {
        name: "Azata Sprint",
        type: "style",
        shortDesc: "",
        longDesc: `While using Azata Style, your base speed increases by 10 feet and you ignore the movement penalties applied by the first 10 feet of difficult terrain you move through in the round. The dodge bonus granted by Azata style increases to +2.`,
        prereq: "Azata Mischief",
        },
        {
        name: "Blinded Blade Style",
        type: "style",
        shortDesc: "",
        longDesc: `While you are using this style, you gain a number of benefits whenever you are blinded or unable to see (including when you wear a blindfold or close your eyes). Under such circumstances, you do not take any penalties on Strength- or Dexterity-based skill checks due to blindness. In addition, you gain a +4 bonus on hearing- and smell-based Perception checks and gain the scent special ability with a range of 10 feet; if you already have scent, the range of your scent ability increases by 10 feet instead.`,
        prereq: "",
        },
        {
        name: "Blinded Competence",
        type: "style",
        shortDesc: "",
        longDesc: `While you are using Blinded Blade Style and you are blinded or unable to see, you do not need to succeed at Perception checks to pinpoint the location of creatures within reach of your melee weapon, or your unmodified reach if you are not wielding a melee weapon. This ability functions like blindsight.`,
        prereq: "Blinded Blade Style",
        },
        {
        name: "Blinded Master",
        type: "style",
        shortDesc: "",
        longDesc: `While you are using Blinded Blade Style and you are blinded or unable to see, your ability to pinpoint creatures' locations using Blinded Competence improves to function at a range of 30 feet. In addition, you add half your character level to the DCs of Bluff checks to feint you in combat.`,
        prereq: "Blinded Competence",
        },
        {
        name: "Boar Style",
        type: "style",
        shortDesc: "",
        longDesc: `You can deal bludgeoning damage or slashing damage with your unarmed strikes—changing damage type is a free action. While using this style, once per round when you hit a single foe with two or more melee attacks with a slashing weapon, you can tear flesh. When you do, the attack deals an extra 2d6 damage.`,
        prereq: "",
        },
        {
        name: "Boar Ferocity",
        type: "style",
        shortDesc: "",
        longDesc: `You add piercing damage to the damage types you can deal with your unarmed strikes, and the boar style rend attack now works with piercing weapons as well. Further, you gain a +2 bonus on Intimidate checks to demoralize opponents. While using Boar Style, whenever you tear an opponent's flesh, you can spend a free action to make an Intimidate check to demoralize that opponent.`,
        prereq: "Boar Style",
        },
        {
        name: "Boar Shred",
        type: "style",
        shortDesc: "",
        longDesc: `You can make an Intimidate check to demoralize an opponent as a move action. While using Boar Style, whenever you tear an opponent's flesh, they begin to take 1d6 bleed damage. If you reapply the bleed to a creature currently bleeding because of boar style, the bleed is increased to 1d6+1, with another +1 each time you reapply it.`,
        prereq: "Boar Ferocity",
        },
        {
        name: "Brute Style",
        type: "style",
        shortDesc: "",
        longDesc: `While using this style, you can use your Vicious Stomp feat against any opponent within 10 feet of you, as long as it is within your natural reach. If you don't have the Vicious Stomp feat, you gain no benefit from this feat.`,
        prereq: "",
        },
        {
        name: "Brute Stomp",
        type: "style",
        shortDesc: "",
        longDesc: `While using Brute Style, when you make a full attack with a prone opponent adjacent to you, you can make an additional unarmed strike at your highest base attack bonus against that prone creature. This does not allow you to make an additional attack against a creature you tripped during your full attack. Additionally, you can use your Vicious Stomp feat against any opponent within your natural reach regardless of whether it falls prone adjacent to you.`,
        prereq: "Brute Style",
        },
        {
        name: "Brute Assault",
        type: "style",
        shortDesc: "",
        longDesc: `While using Brute Style, when you successfully perform an overrun or trip combat maneuver against an opponent that causes that opponent to fall prone, your opponent takes 1d6 points of Strength damage, and its base speed is halved until the Strength damage is healed. A successful Fortitude save (DC = 10 + your base attack bonus) reduces the Strength damage to 1 point and negates the movement speed reduction.`,
        prereq: "Brute Stomp",
        },
        {
        name: "Bulette Charge Style",
        type: "style",
        shortDesc: "",
        longDesc: `While using this style, you gain a +4 bonus on combat maneuver checks to overrun an opponent. Any magic ability or material that reduces your armor check penalty also reduces the bonus you gain for this style.`,
        prereq: "",
        },
        {
        name: "Bulette Leap",
        type: "style",
        shortDesc: "",
        longDesc: `While using Bulette Charge Style, you gain a bonus on Acrobatics checks to jump equal to your Strength bonus. Additionally, when you perform an overrun combat maneuver, you can attempt to overrun multiple foes, but you take a cumulative -2 penalty on each successive overrun attempt in the same round. If an overrun attempt fails, you cannot make any further attempts until your next round.`,
        prereq: "Bulette Charge Style",
        },
        {
        name: "Bulette Rampage",
        type: "style",
        shortDesc: "",
        longDesc: `While you're using Bulette Charge Style, whenever you succeed at an overrun combat maneuver check against a foe, that foe takes an amount of damage equal to 1d8 (if your size is Medium) or 1d6 (if your size is Small) + 1/2 your armor bonus to AC + 1-1/2 times your Strength bonus.`,
        prereq: "Bulette Leap",
        },
        {
        name: "Bull-Catcher Style",
        type: "style",
        shortDesc: "",
        longDesc: `As a standard action, you can ready yourself against oncoming foes. Until the start of your next turn, if a creature moves at least 10 feet in your direction and enters a square you threaten, you can attempt a grapple combat maneuver against that creature. If the creature is charging, you gain a +2 bonus on the check. A creature you grapple with this style can make only a single natural attack after its movement or charge, even if it has the pounce ability. You can make only one grapple attempt in this manner per round.`,
        prereq: "",
        },
        {
        name: "Bull-Catcher Toss",
        type: "style",
        shortDesc: "",
        longDesc: `When you successfully grapple a creature with the Bull-Catcher Style feat, you can immediately move that creature into any square you threaten. After it is placed, you can break your grapple as an immediate action to move the creature an additional 5 feet in any direction. You can't use this maneuver to move a foe into a space that is intrinsically dangerous or unstable, such as a pit, wall of fire, or midair.`,
        prereq: "Bull-Catcher Style",
        },
        {
        name: "Bull-Catcher Wrangler",
        type: "style",
        shortDesc: "",
        longDesc: `When a creature is charging you, and you successfully grapple it with the Bull-Catcher Style feat, you can immediately move it as per the Bull-Catcher Toss feat. Once the creature is moved, you can break your grapple as an immediate action. If you do, select another creature in the repositioned target's threatened area. That creature becomes the new target of the initial charge attack.`,
        prereq: "Bull-Catcher Toss",
        },

        {
        name: "Cerberus Style",
        type: "style",
        shortDesc: "",
        longDesc: `As a standard action, you can make a single attack at your full base attack bonus against a foe within reach. If you hit, you deal damage normally and can make an additional attack (using your full base attack bonus) against up to two other foes that are also within reach. You take a -2 penalty to your Armor Class until the start of your next turn for each additional attack you make with this feat.`,
        prereq: "",
        },
        {
        name: "Cerberus Snare",
        type: "style",
        shortDesc: "",
        longDesc: `Whenever you damage an opponent with Cerberus Style, that opponent cannot take 5-foot steps until the beginning of your next turn. Additionally, it is barred from dimensional travel. This effect functions as dimensional anchor, except that its duration is 1 round. Spell resistance applies; for the purpose of checks to overcome spell resistance, your caster level is equal to your character level. If only one creature is within your reach when you use the Cerberus style attack, the two additional attacks can be at the same target and both deal +2 damage.`,
        prereq: "Cerberus Style",
        },
        {
        name: "Cerberus Crush",
        type: "style",
        shortDesc: "",
        longDesc: `You can apply the benefits of Vital Strike, Improved Vital Strike, and Greater Vital Strike to all attacks made using Cerberus Style or while using cleave feats. If you have the cleave or great cleave feat you can use it while using the initial cerberus style attack. Cerberus snare bonus damage for attacks against the same creature deal +4 damage.`,
        prereq: "Cerberus Snare",
        },
        {
        name: "Charging Stag Style",
        type: "style",
        shortDesc: "",
        longDesc: `When using this style and not mounted, you can charge through difficult terrain and spaces containing allies. You can also make a single turn of up to 90 degrees during your charge. You must see your target at the beginning of your charge, and can make only a single attack at the end, even if you would normally be able to make multiple attacks (such as with the pounce ability).`,
        prereq: "",
        },
        {
        name: "Stag Horns",
        type: "style",
        shortDesc: "",
        longDesc: `While using Charging Stag Style, if you make a successful attack at the end of a charge while having a hand free, you can attempt a free grapple check against the target of your charge without provoking an attack of opportunity.`,
        prereq: "Charging Stag Style",
        },
        {
        name: "Stag Submission",
        type: "style",
        shortDesc: "",
        longDesc: `When you are in Charging Stag Style and succeed at a combat maneuver check to pin a foe, you can choose to also knock the foe prone or to deal your unarmed attack damage to the foe.`,
        prereq: "Stag Horns",
        },
        {
        name: "Cloak and Dagger Style",
        type: "style",
        shortDesc: "",
        longDesc: `When using a light weapon and this style, on the first round of combat if you make an attack with the attack action or a strike from veiled moon, shattered mirror, or steel serpent, you can attempt a dirty trick combat maneuver check against that opponent as a free action (only once per round). Additionally, if an adjacent target attempts to remove a condition that you inflicted upon it with the dirty trick combat maneuver, it provokes an attack of opportunity from you.`,
        prereq: "",
        },
        {
        name: "Cloak and Dagger Subterfuge",
        type: "style",
        shortDesc: "",
        longDesc: `While you are using Cloak and Dagger Style and wielding a light weapon, whenever you make an attack of opportunity against a target, you can attempt a free dirty trick combat maneuver check against the target as a free action as well (that you can take even when not your turn). Additionally, whenever you successfully perform a dirty trick maneuver against a target, you can immediately attempt a steal combat maneuver check against the target as a free action. If you succeed, you get 1d6 gold.`,
        prereq: "Cloak and Dagger Style",
        },
        {
        name: "Cloak and Dagger Tactics",
        type: "style",
        shortDesc: "",
        longDesc: `While you are using Cloak and Dagger Style and wielding a light weapon, whenever you hit an opponent that is denied its Dexterity bonus to AC or that you are flanking, or make an attack using Vital Strike (or its improved or greater versions), you can attempt a dirty trick combat maneuver check against that opponent as a free action. If you succeed, the target must succeed at a Fortitude save (DC = 10 + 1/2 your base attack bonus + your Intelligence modifier) or take an additional penalty from the dirty trick selected from the following list: anchored in place and unable to move from that square, confused, exhausted, or staggered. This additional penalty lasts only 1 round, regardless of how long the dirty trick's normal penalty lasts, and can be removed by the target with a standard action. You can only attempt one free dirty trick combat maneuver check per round using this feat. The gold you gain from Cloak and Dagger Subterfuge increases to 2d6`,
        prereq: "Cloak and Dagger Subterfuge",
        },
        {
        name: "Crashing Wave Style",
        type: "style",
        shortDesc: "",
        longDesc: `When you successfully drag or reposition an opponent while using this style, at any point during the dragging or repositioning of the opponent, you can move 5 feet as an immediate action, including moving into a square previously occupied by the opponent, even if you have already taken a move action this round. This movement does not provoke attacks of opportunity.`,
        prereq: "",
        },
        {
        name: "Crashing Wave Buffet",
        type: "style",
        shortDesc: "",
        longDesc: `When dragging or repositioning an opponent, you use your full body to knock your opponent around like a constant wave. At the end of the drag or reposition maneuver, your opponent must succeed at a Fortitude save (DC = 10 + half your character level + highest mental mod + 2 for every 5 feet you drag or reposition your opponent). On a failed save, your opponent becomes disorientated from the movement and takes a -2 penalty on attack rolls, combat maneuver checks, and Dexterity-based skill checks until the end of its next turn.`,
        prereq: "Crashing Wave Style",
        },
        {
        name: "Crashing Wave Fist",
        type: "style",
        shortDesc: "",
        longDesc: `When dragging or repositioning an opponent, at any point during the movement, you can make one unarmed or light weapon attack against the opponent using your highest attack bonus. You can make one additional attack for every 5 feet you drag or reposition the opponent beyond the first 5 feet. You take a cumulative -5 penalty on each additional attack made in this way.`,
        prereq: "Crashing Wave Buffet",
        },
        {
        name: "Bludgeoner",
        type: "martial",
        shortDesc: "",
        longDesc: `You do not take the normal -4 penalty on attack rolls for using a lethal bludgeoning weapon to deal nonlethal damage, and can deal non-lethal damage with sneak attacks.`,
        prereq: "",
        },
        {
        name: "Cudgeler Style",
        type: "style",
        shortDesc: "",
        longDesc: `When you hit with a charge attack to deal nonlethal damage while using this style, your weapon deals damage as if it were one size category larger than it actually is. If you have the ability to make more than one attack on a charge, this increase applies only to your first attack.`,
        prereq: "",
        },
        {
        name: "Cudgeler Sweep",
        type: "style",
        shortDesc: "",
        longDesc: `When you hit with a charge attack using the Cudgeler Style feat, you can immediately attempt a single trip combat maneuver check against the target with a +2 competence bonus as a free action. This provokes an attack of opportunity as normal for a trip combat maneuver.`,
        prereq: "Cudgeler Style",
        },
        {
        name: "Cudgeler Takedown",
        type: "style",
        shortDesc: "",
        longDesc: `When you hit with a charge attack using the Cudgeler Style feat, your weapon deals damage as though it were one size category larger for 1 round or until it leaves your hand. When you successfully trip an opponent with the Cudgeler Sweep feat, your opponent must succeed at a Fortitude save (DC = 10 + your character level + your Strength modifier) or be stunned for 1 round.`,
        prereq: "Cudgeler Sweep",
        },
        {
        name: "Deadhand Style",
        type: "style",
        shortDesc: "",
        longDesc: `While using this style, you gain a +2 bonus on saves against fear effects, and the DC of Intimidate checks against you increases by 4. As a swift action, you can spend 4 spell points to empower your unarmed strikes. Creatures hit with your unarmed strikes must succeed at a Will save (DC = 10 + 1/2 your character level + your highest mental modifier) or become shaken for a number of rounds equal to your highest mental modifier. This is a mind-affecting fear effect.`,
        prereq: "",
        },
        {
        name: "Deadhand Initiate",
        type: "style",
        shortDesc: "",
        longDesc: ` While using Deadhand Style, your bonus on saving throws against fear effects increases to +4, and the DC of Intimidate checks attempted against you increases by 8.

        Additionally, if an enemy targets you with a fear effect, you can spend level/2 spell points as an immediate action to gain a number of temporary hit points equal to twice your Hit Dice.`,
        prereq: "Deadhand Style",
        },
        {
        name: "Deadhand Master",
        type: "style",
        shortDesc: "",
        longDesc: `While using Deadhand Style, when you damage a living creature with an attack, you can spend 5+level/2 spell points as a swift action to inflict 2 temporary negative levels on your enemy with no saving throw. Effects that reduce spell point costs do not work with this ability. As long as the foe is affected by the temporary negative levels, you can't recover the spell point spent on this ability, effectively reducing the size of your spell point pool. The Fortitude save DC to remove the negative levels and prevent them from becoming permanent is equal to 10 + 1/2 your Hit Dice + your highest mental modifier. Once the negative levels become permanent or the foe removes them, you can recover your spent spell points. If the foe dies before either happens, you cant recover these spell points until the next floor.`,
        prereq: "Deadhand Initiate",
        },
        {
        name: "Demonic Style",
        type: "style",
        shortDesc: "",
        longDesc: `While using this style, when you use the charge action, the bonus on your attack roll increases by 1 and you deal 2 additional points of damage with melee attacks made as part of the charge. If you have the rage ability you can enter this stance as a free action while entering rage, but the style ends when your rage ends. If you do rage while using this style, the bonus to attack increases to +2, and the damage to +4.`,
        prereq: "",
        },
        {
        name: "Demonic Momentum",
        type: "style",
        shortDesc: "",
        longDesc: `While using Demonic Style, when you successfully bull rush an opponent as part of a charge, you gain a +2 bonus on melee weapon damage rolls against that opponent for every 5 feet it was moved by your bull rush.

        This bonus lasts until the end of your next turn, and it stacks with the damage bonus granted by Demonic Style.`,
        prereq: "Demonic Style",
        },
        {
        name: "Demonic Slaughter",
        type: "style",
        shortDesc: "",
        longDesc: `While using Demonic Style, when you successfully bull rush an opponent as part of a charge, you can immediately use Great Cleave as though you had used a standard action to do so. This occurs after the effect of your bull rush is fully resolved. The target of your bull rush must be the target of the first attack you make as part of Great Cleave. If you do not have the Cleave feat you can use it for this attack, if you do not have the Great cleave feat but do have the cleave feat, you can use Great Cleave for this attack. If you have both, you can cleave targets even if they are not adjacent to each other.`,
        prereq: "Demonic Momentum",
        },
        {
        name: "Diabolic Style",
        type: "style",
        shortDesc: "",
        longDesc: `While using this style, you can make an attack of opportunity with an unarmed strike to deliver a humiliating swat to the target. If you hit the target, you inflict 1 point of nonlethal damage and the target must succeed at a Will saving throw (DC = 10 + half your level + highest mental modifier) or become staggered for 1 round.`,
        prereq: "",
        },
        {
        name: "Diabolic Humiliation",
        type: "style",
        shortDesc: "",
        longDesc: `When you successfully stagger a foe with an unarmed strike using Diabolic Style, the target becomes further humiliated. The target cannot gain the benefit of any morale bonus for 1 minute after being staggered in this way, and for the duration of that minute, any additional staggered effects it suffers from your attacks of opportunity last for 2 rounds rather than 1. The durations of multiple staggered effects administered in this way stack.`,
        prereq: "Diabolic Style",
        },
        {
        name: "Diabolic Judgment",
        type: "style",
        shortDesc: "",
        longDesc: `While using Diabolic Style, the first time each round that you successfully hit with an attack of opportunity, you can apply the effects of any Vital Strike feat you have to that attack.`,
        prereq: "Diabolic Humiliation",
        },
        {
        name: "Diva Style",
        type: "style",
        shortDesc: "",
        longDesc: `While using this style, you can use the Perform skill in place of Bluff to feint in combat, you can attempt a Perform check to feint as a move action. If you possess the bardic performance ability, when you start a bardic performance, but no more than once per round, you can bluff a creature as a part of that action while in this style.`,
        prereq: "",
        },
        {
        name: "Diva Advance",
        type: "style",
        shortDesc: "",
        longDesc: `While using Diva Style, you do not provoke attacks of opportunity from creatures you have successfully feinted against as long as they are feinted. Additionally, you can feint against a creature using Diva Style from up to 30 feet away.`,
        prereq: "Diva Style",
        },
        {
        name: "Diva Strike",
        type: "style",
        shortDesc: "",
        longDesc: `While using Diva Style, the first time you hit with a weapon in a round, you deal an additional amount of damage equal to your highest mental modifier to a target that is denied its Dexterity bonus to AC. This damage is precision-based, and is not multiplied on a critical hit.`,
        prereq: "Diva Advance",
        },
        {
        name: "Dolphin Style",
        type: "style",
        shortDesc: "",
        longDesc: `You gain a +1 bonus on melee attack rolls against any creature adjacent to at least two of its other allies as long as you aren't flanking that creature, and your melee attacks ignore any bonus to AC gained by use of the aid another action.`,
        prereq: "",
        },
        {
        name: "Dolphin Dart",
        type: "style",
        shortDesc: "",
        longDesc: `While in Dolphin Style, as a standard action you can move up to half your speed, make a single melee attack against a creature within your reach, and then retreat back to your previous position. Your movement and attack don't provoke attacks of opportunity, even if your foe has an ability that allows attacks of opportunity with triggers other than moving out of a threatened area.`,
        prereq: "Dolphin Style",
        },
        {
        name: "Dolphin Circle",
        type: "style",
        shortDesc: "",
        longDesc: `While in Dolphin Style, as a full-round action you can choose a circular path starting and ending in your current space whose length is no longer than you could swim with a single move action. You circle around that path until your next turn, and this movement doesn't provoke attacks of opportunity. You are considered to be in every space along the path for the purpose of threatening squares and providing flanking for other allies (but not yourself), as well as whether you are in the area of an area effect. Other creatures can attack you (and touch you with beneficial touch spells) as if you were in every space along the path. However, you don't count as being in any of the spaces for the purpose of other creatures moving through an occupied space. At the beginning of your next turn, choose any space along the path to stop circling.`,
        prereq: "Dolphin Dart",
        },
        {
        name: "Dragon Style",
        type: "style",
        shortDesc: "",
        longDesc: `While using this style, you gain a +2 bonus on saving throws against sleep effects, paralysis effects, and stunning effects. You ignore difficult terrain when you charge, run, or withdraw. You can also charge through squares that contain allies. Further, you can add 1-1/2 times your Strength bonus on the damage roll for your first unarmed strike on a given round.`,
        prereq: "",
        },
        {
        name: "Dragon Ferocity",
        type: "style",
        shortDesc: "",
        longDesc: `While using Dragon Style, increase your Strength bonus on unarmed strike damage rolls by an additional one-half your Strength bonus, to a total of double your Strength bonus on the first attack and 1-1/2 times your Strength bonus on the other attacks.

        When you score a critical hit or a successful Stunning Fist attempt against an opponent while using this style, that opponent is also shaken for a number of rounds equal to 1d4 + your Strength bonus.`,
        prereq: "Dragon Style",
        },
        {
        name: "Dragon Roar",
        type: "style",
        shortDesc: "",
        longDesc: `Reduce the spell point cost of using stunning fist by 2. While using Dragon Style, as a standard action you can expend two Stunning Fist attempts to unleash a concussive roar in a 15-foot cone. Creatures caught in the cone take your unarmed strike damage and become shaken for 1d4 rounds. A successful Will save (DC 10 + 1/2 your character level + your highest mental modifier) reduces the damage by half and prevents a target from being shaken.`,
        prereq: "Dragon Ferocity",
        },
        {
        name: "Dragonfly Style",
        type: "style",
        shortDesc: "",
        longDesc: `You add your highest mental modifier to Acrobatics checks in addition to your Dexterity modifier. While using this style, when you are adjacent to a vertical surface or object capable of supporting your weight and taller than you, such as a wall or a tree, you gain a +1 bonus on melee attack rolls against opponents your size or smaller, as if you were on higher ground.`,
        prereq: "",
        },
        {
        name: "Dragonfly Wings",
        type: "style",
        shortDesc: "",
        longDesc: `While using Dragonfly Style, the bonus on your melee attacks increases to +2 and applies to opponents up to two size categories larger than you. In addition, you can substitute a creature your size or larger in place of a vertical surface. You can freely use a willing creature in such a manner, but using a hostile creature requires a successful Acrobatics check with a DC equal to the creature's CMD. If you fail this check by 5 or more, you provoke an attack of opportunity from the hostile creature.`,
        prereq: "Dragonfly Style",
        },
        {
        name: "Dragonfly Flight",
        type: "style",
        shortDesc: "",
        longDesc: `While using Dragonfly Style, you can attempt an Acrobatics check to high jump as a move action, and then immediately glide as the spell for 1 round. If you have not used your standard action after using Dragonfly Flight to make a high jump and start gliding, you can charge while gliding. This charge follows the rules for charging when you are only able to take a standard action.`,
        prereq: "Dragonfly Wings",
        },
        {
        name: "Elven Battle Style",
        type: "style",
        shortDesc: "",
        longDesc: `While wielding a one handed slashing weapon, or any melee weapon that has “elven” in its name, combat maneuver checks attempted with that weapon as attacks of opportunity don't themselves provoke attacks of opportunity.`,
        prereq: "",
        perkRateUp:["Elf"]
        },
        {
        name: "Elven Battle Focus",
        type: "style",
        shortDesc: "",
        longDesc: `While using Elven Battle Style, you can add your Intelligence modifier to that weapon's damage (instead of any other ability bonus or modifier you can add to your weapon damage). The weapon must be one appropriate for your size.`,
        prereq: "Elven Battle Style",
        },
        {
        name: "Elven Battle Torrent",
        type: "style",
        shortDesc: "",
        longDesc: `While using Elven Battle Style, any opponent that makes an attack against you and misses while you are fighting defensively or using total defense or the Combat Expertise feat provokes an attack of opportunity from you.

        Even if you have Combat Reflexes, you can't benefit from this feat more than once per round.`,
        prereq: "Elven Battle Focus",
        },
        {
        name: "Empty Quiver Style",
        type: "style",
        shortDesc: "",
        longDesc: `While using this style, you can make melee attacks with ranged weapons as if it were a heavy mace (or a light mace for melee attack made with a hand crossbow or one-handed firearm), though you don't automatically threaten the area around you as if you were wielding a melee weapon.

        You can switch between melee and ranged attacks with this weapon without penalty, even during the same round. If your ranged weapon could already be used like a melee weapon, increase its damage as if you were one size larger.
        
        If you have the Stabbing Shot feat, you can use it with a crossbow or firearm, substituting a loaded bolt or firearm ammunition for an arrow.`,
        prereq: "",
        },
        {
        name: "Empty Quiver Flexibility",
        type: "style",
        shortDesc: "",
        longDesc: `While using Empty Quiver Style, you can apply any feats and class abilities you possess that modify your ranged attack rolls and damage rolls with the chosen weapon to melee attack rolls and damage rolls made with that weapon. Additionally, you are considered to be threatening the area around you as if you were wielding a melee weapon.`,
        prereq: "Empty Quiver Style",
        },
        {
        name: "Empty Quiver Flurry",
        type: "style",
        shortDesc: "",
        longDesc: `While using Empty Quiver Style or Stabbing Shot to make melee attacks with a ranged weapon, if you successfully hit a foe, any ranged attacks you make with the same weapon until the beginning of your next turn do not provoke attacks of opportunity from that foe.
        \nSpecial: If you have the Rapid Reload feat in addition to this feat, your chosen weapon is a crossbow or firearm, that weapon is unloaded, and you successfully hit a foe in melee with it, you can automatically load it as a free action.`,
        prereq: "Empty Quiver Flexibility",
        },
        {
        name: "Fox Style",
        type: "style",
        shortDesc: "",
        longDesc: `While using this style, you can use your base attack bonus in place of your ranks in Bluff on Bluff checks to feint in combat and to create a distraction to hide, or choose to add half your BAB as a bonus, and once per combat you can feint as a free action. You can use this an additional time per combat for each Fox Style feat you have. Additionally, when using your charisma to determine your bluff, you can also add your intelligence modifier.`,
        prereq: "",
        },
        {
        name: "Fox Insight",
        type: "style",
        shortDesc: "",
        longDesc: `While using Fox Style, you can use your base attack bonus in place of your ranks in Sense Motive to determine your Sense Motive skill bonus when foes attempt to feint against you, or add half your BAB as a bonus to your sense motive, and creatures attempting to demoralize you don't gain a bonus for being bigger than you (though they still take a penalty for being smaller). Additionally you add your intelligence modifier when determining the DC to feint or intimidate you. When attacking a creature you successfully feinted and is currently flat-footed against you because of it, you gain a +2 insight bonus to your attacks, and deal +2 precision damage for each fox style feat you possess.`,
        prereq: "Fox Style",
        },
        {
        name: "Fox Trickery",
        type: "style",
        shortDesc: "",
        longDesc: `While using Fox Style, you can perform dirty trick combat maneuvers as attacks of opportunity. If you make a dirty trick as an attack of opportunity it does not provoke attacks of opportunity (if it already didn't, you gain a +2 bonus on them). If using a stat other than intelligence to determine your bonus to dirty trick combat maneuvers, you can add your intelligence bonus as a bonus to them.`,
        prereq: "Fox Insight",
        },
        {
        name: "Grabbing Style",
        type: "style",
        shortDesc: "",
        longDesc: `When you use this style, you do not take a -4 penalty on combat maneuver checks to grapple a foe with only one hand. Additionally, you do not lose your Dexterity bonus to AC while pinning an opponent.`,
        prereq: "",
        },
        {
        name: "Grabbing Drag",
        type: "style",
        shortDesc: "",
        longDesc: `When you are using Grabbing Style, if you use the move grapple action, you can move both yourself and a single target that you're grappling your full speed instead of half your speed. After you have done so, you can use a move action to move yourself and the target of your grapple half your speed without needing to attempt an additional combat maneuver check. You cannot use this feat if you are grappling two targets.`,
        prereq: "Grabbing Style",
        },
        {
        name: "Grabbing Master",
        type: "style",
        shortDesc: "",
        longDesc: `When you are grabbing two opponents while using Grabbing Style, you can use your grapple to move or damage one or both opponents you are grappling, instead of just one.`,
        prereq: "Grabbing Drag",
        },
        {
        name: "Illusive Gnome Style",
        type: "style",
        shortDesc: "",
        longDesc: `While feinting with a light melee weapon, you can sacrifice a spell slot for a control or utility spell you know, to gain a bonus on the skill check attempted to feint. This bonus is equal to 1 + the level of the spell sacrificed. If you sacrifice a 0-level spell, you cannot cast or sacrifice that spell again for 24 hours.`,
        prereq: "",
        },
        {
        name: "Illusive Gnome Surprise",
        type: "style",
        shortDesc: "",
        longDesc: `While using Illusive Gnome Style, you gain a +2 bonus on combat maneuver checks to perform dirty tricks and on Bluff checks to feint. In addition, when you successfully use Bluff to feint against a foe, instead of denying that foe its Dexterity bonus to AC, you can treat the weapon you used to feint as if it had one of the following weapon special features: blocking, brace, disarm, distracting, performance, sunder, or trip. This benefit applies only against that foe and lasts for a number of rounds equal to your highest mental modifier (minimum 1).`,
        prereq: "Illusive Gnome Style",
        },
        {
        name: "Illusive Gnome Bewilderment",
        type: "style",
        shortDesc: "",
        longDesc: `While using Illusive Gnome Style, when you successfully use Bluff to feint against an opponent, you can pick one special weapon feature from among those listed by Illusive Gnome Surprise and deny the opponent its Dexterity modifier to AC, as normal for feinting; alternatively, you can pick two special weapon features instead of one.`,
        prereq: "Illusive Gnome Surprise",
        },
        {
        name: "Indomitable Mountain Style",
        type: "style",
        shortDesc: "",
        longDesc: `As long as you do not take a move action, you gain a +4 morale bonus to your CMD and to the DC of Bluff checks used for feint attempts against you. Additionally, you are considered to be one size category larger for the purpose of calculating your CMD when creatures attempt Acrobatics checks to move through spaces you threaten without provoking attacks of opportunity.`,
        prereq: "",
        },
        {
        name: "Indomitable Mountain Peak",
        type: "style",
        shortDesc: "",
        longDesc: `Gain a +1 bonus to your CMD when you dont take a move action. Whenever an opponent succeeds at a combat maneuver against you or at an Acrobatics check to avoid provoking an attack of opportunity when moving through a square you threaten, you immediately gain a +2 morale bonus to your CMD against the next combat maneuver against you or to the DC of the next Acrobatics check to avoid an attack of opportunity when moving through a square you threaten. This bonus stacks until either attempt fails against you.`,
        prereq: "Indomitable Mountain Style",
        },
        {
        name: "Indomitable Mountain Avalanche",
        type: "style",
        shortDesc: "",
        longDesc: `Gain another +2 bonus to your CMD when you dont take a move action. If an opponent fails at a combat maneuver against you, you can use an attack of opportunity to make a melee attack against the opponent using your highest attack bonus. If the attack hits, instead of dealing damage, you can push the opponent back 5 feet for every 5 by which it failed its combat maneuver check (minimum 5 feet). Additionally, when you hit with a melee attack against an opponent who provoked an attack of opportunity by failing its Acrobatics check to move through a space you threaten, you can push the opponent back 5 feet instead of dealing damage. The opponent moves back in a straight line, but stops before hitting any obstacle or hazard.`,
        prereq: "Indomitable Mountain Peak",
        },
        {
        name: "Jabbing Style",
        type: "style",
        shortDesc: "",
        longDesc: `When you hit a target with an unarmed strike or melee light piercing weapon, and you have hit that target with an such an attack previously that round, you deal an extra 1d6 points of damage to that target.`,
        prereq: "",
        },
        {
        name: "Jabbing Dancer",
        type: "style",
        shortDesc: "",
        longDesc: `Each time you hit with an unarmed or melee light piercing weapon while using Jabbing Style, you can move 5 feet without provoking an attack of opportunity as long as you move to a space adjacent to the opponent you hit with the attack. If you use this feat, you cannot take a 5-foot step during your next turn.`,
        prereq: "Jabbing Style",
        },
        {
        name: "Jabbing Master",
        type: "style",
        shortDesc: "",
        longDesc: `While using Jabbing Style, the extra damage you deal when you hit a single target with two attacks increases to 2d6, and the extra damage when you hit a single target with three or more unarmed strikes increases to 4d6.`,
        prereq: "Jabbing Dancer",
        },
        {
        name: "Janni Style",
        type: "style",
        shortDesc: "",
        longDesc: `While using this style, you take only a -1 penalty to AC for charging. Further, opponents that flank you gain only a +1 bonus on attack rolls against you.`,
        prereq: "",
        },
        {
        name: "Janni Tempest",
        type: "style",
        shortDesc: "",
        longDesc: `While you are using the Janni Style feat, whenever you make an attack and hit an opponent, you gain a +4 bonus on checks made to bull rush or trip that opponent, as long as the combat maneuver is made by the end of your turn. You do not provoke an attack of opportunity from the target of the maneuver. If you already would not provoke them, you gain an additional +2 to the maneuver.`,
        prereq: "Janni Style",
        },
        {
        name: "Janni Rush",
        type: "style",
        shortDesc: "",
        longDesc: `While using Janni Style, you are always considered to have a running start when jumping. Further, if you jump as part of a charge and make an attack against the designated opponent, a hit allows you to roll the weapon's damage dice twice and add the results together before adding modifiers (such as from Strength) or extra dice (such as precision-based damage or dice from weapon abilities). The extra damage dice are not multiplied on a successful critical hit.`,
        prereq: "Janni Tempest",
        },
        {
        name: "Kirin Style",
        type: "style",
        shortDesc: "",
        longDesc: `While using this style, you can spend a swift action to make a Knowledge check to identify a single creature (DC 15 + the creature's HD for this purpose). If you succeed at the check, while using this style, you gain a +2 bonus on saving throws against that creature's attacks, as well as a +2 dodge bonus to AC against that creature's attacks of opportunity. These bonuses last for as long as you use this style. If you cease combat with the creature during this time and resume it later, you can attempt the check again.`,
        prereq: "",
        },
        {
        name: "Kirin Strike",
        type: "style",
        shortDesc: "",
        longDesc: `You gain a +4 insight bonus on Knowledge checks made to identify creatures, including the one Kirin Style allows. While using Kirin Style against a creature you have identified using that feat, as a swift action after you have hit a creature with a melee or ranged attack, you can add twice your Intelligence modifier in damage (minimum 2).`,
        prereq: "Kirin Style",
        },
        {
        name: "Kirin Path",
        type: "style",
        shortDesc: "",
        longDesc: `Whenever you make a Knowledge check to identify a creature, even when using Kirin Style, you can take 10 even if stress and distractions would normally prevent you from doing so. While using Kirin Style against a creature you have identified using that feat, if the creature ends its turn within your threatened area, you can spend a use of your attacks of opportunity that round to move up to 5 feet times your Intelligence modifier (minimum 1). You must end your move in a square threatened by the creature. This move does not provoke attacks of opportunity.`,
        prereq: "Kirin Strike",
        },
        {
        name: "Kitsune Style",
        type: "style",
        shortDesc: "",
        longDesc: `While using this style, you can attempt to perform a dirty trick in place of an attack at the end of a charge. For each Kitsune style feat you have, you gain a +1 bonus on dirty trick attempts.`,
        prereq: "",
        },
        {
        name: "Kitsune Tricks",
        type: "style",
        shortDesc: "",
        longDesc: `While you are using the Kitsune Style feat, you can apply two different conditions with a single dirty trick combat maneuver check. Removing both conditions imparted in this way requires only one action.`,
        prereq: "Kitsune Style",
        },
        {
        name: "Kitsune Vengeance",
        type: "style",
        shortDesc: "",
        longDesc: `While using the Kitsune Style feat you gain a +2 bonus to dirty trick attempts. Additionally, When a foe provokes an attack of opportunity from you, you can attempt to perform a dirty trick combat maneuver in place of making a melee attack.`,
        prereq: "Kitsune Tricks",
        },
        {
        name: "Kobold Style",
        type: "style",
        shortDesc: "",
        longDesc: `While in Kobold Style you gain a +1 to attacks against enemies denied their Dexterity bonus to AC, unless it is a CMB check, in which case you instead gain a +4. For each Kobold Style feat you possess the bonus increases by +1, or +2 for CMB checks.`,
        prereq: "",
        },
        {
        name: "Kobold Groundling",
        type: "style",
        shortDesc: "",
        longDesc: `While in Kobold Style prone creatures are denied their Dexterity bonus to AC against your attacks.`,
        prereq: "Kobold Style",
        },
        {
        name: "Kobold Flood",
        type: "style",
        shortDesc: "",
        longDesc: `While in Kobold Style you can make a grapple combat maneuver check to mount a prone creature up to two sizes larger than you. If you're successful, you move into the target's square and are considered to be on top of the target. For the target to stand, it must succeed at a combat maneuver check to break your grapple.`,
        prereq: "Kobold Groundling",
        },
        {
        name: "Kraken Style",
        type: "style",
        shortDesc: "",
        longDesc: `When you succeed at a grapple check while using this style, your opponent takes an amount of bludgeoning damage equal to your highest mental modifier in addition to any damage your grapple deals, such as when you choose to harm your opponent as part of a successful check to maintain a grapple. In addition, you gain a +2 bonus on combat maneuver checks to maintain a grapple.`,
        prereq: "",
        },
        {
        name: "Kraken Throttle",
        type: "style",
        shortDesc: "",
        longDesc: `The damage that you deal with the Kraken Style feat on a successful grapple combat maneuver check increases to an amount equal to your highest mental bonus + 2.

        While using this style, you can choke your opponent when you successfully maintain a grapple instead of choosing to damage, move, pin, or tie up your opponent. This suffocates your opponent. The grappled opponent can take a breath during any round in which you do not maintain the grapple.`,
        prereq: "Kraken Style",
        },
        {
        name: "Kraken Wrack",
        type: "style",
        shortDesc: "",
        longDesc: `The damage you deal with the Kraken Style feat on a successful grapple combat maneuver check increases to an amount equal to your highest mental modifier + 4. While using this style, you can crush your opponent when you successfully maintain a grapple instead of choking, damaging, moving, pinning, or tying up your opponent.

        When you do, you deal an amount of damage equal to that of your unarmed strike or one of your natural attacks to your foe's armor or an item held in your foe's hand. This crushing damage bypasses half of the hardness of the armor or item.`,
        prereq: "Kraken Throttle",
        },
        {
        name: "Lantern Style",
        type: "style",
        shortDesc: "",
        longDesc: `Your thrown weapons glow with holy light, illuminating a 20-foot-radius area where they fall for 1 round. A target damaged by one of these weapons becomes dazzled for 1 round.`,
        prereq: "",
        },
        {
        name: "Lantern Glare",
        type: "style",
        shortDesc: "",
        longDesc: `Creatures you hit with a thrown weapon as well as creatures within 20 feet of your target must succeed at a Will save (DC = 10 + 1/2 level + highest mental modifier) or become shaken until they damage you or 24 hours have passed. A creature that succeeds at its saving throw or that damages you after becoming shaken becomes immune to this effect for 24 hours.`,
        prereq: "Lantern Style",
        },
        {
        name: "Lantern Light",
        type: "style",
        shortDesc: "",
        longDesc: `When you make a single ranged attack with a thrown weapon, that weapon temporarily transforms into pure holy light, overcoming the target's damage reduction, if any.`,
        prereq: "Lantern Glare",
        },
        {
        name: "Linnorm Style",
        type: "style",
        shortDesc: "",
        longDesc: `While using this style, you take a -2 penalty to your AC against melee attacks. After a creature makes a melee attack against you, you can choose to add your highest mental bonus to the damage from your melee attacks against that creature, rather than your Strength bonus. If you can normally add your Dexterity bonus to the attack's damage, you can instead replace it with your highest mental bonus. This lasts until the beginning of the target creature's next turn.`,
        prereq: "",
        },
        {
        name: "Linnorm Vengeance",
        type: "style",
        shortDesc: "",
        longDesc: `While you're using the Linnorm Style feat and an enemy hits you with a melee attack, you gain a +2 bonus on melee attack rolls you make against that creature until the beginning of that creature's next turn.

        If a creature's melee attack would normally miss you, you can allow it to hit you to gain this bonus; the attack deals the minimum amount of damage (as though the attacker had rolled a natural 1 on each damage die).
        
        Furthermore, if a melee attack deals enough damage to knock you unconscious or kill you, you can make a single retaliatory melee attack against that opponent as a free action before you drop unconscious or die. If you do so, when you are restored to consciousness or to life, you are stunned for 1 round.`,
        prereq: "Linnorm Style",
        },
        {
        name: "Linnorm Wrath",
        type: "style",
        shortDesc: "",
        longDesc: `When you use the Linnorm Vengeance feat to allow an enemy to hit you, you can make a retaliatory unarmed strike attack against that opponent as an immediate action. This acts as an attack of opportunity, and counts against the number of attacks of opportunity you can make each round. Additionally, once per day when a melee attack deals enough damage to knock you unconscious or kill you, the attacker must succeed at a Fortitude saving throw (DC = 10 + 1/2 level + your highest mental modifier) or be stunned for 1 round. This save occurs after you make the retaliatory attack granted by the Linnorm Vengeance feat.`,
        prereq: "Linnorm Vengeance",
        },
        {
        name: "Maddening Style",
        type: "style",
        shortDesc: "",
        longDesc: `Reduce the spell point cost of stunning fist by 2 spell points. When using this style, if you have at least level spell points remaining, you increase the DCs of your confusion, madness, and insanity effects (including Maddening Strike) by 1. Additionally, when you successfully stun an opponent with your Stunning Fist attack, your target takes 1 point of Wisdom damage.`,
        prereq: "",
        },
        {
        name: "Maddening Strike",
        type: "style",
        shortDesc: "",
        longDesc: `As a swift action, you can spend 4 spell points to imbue the next melee attack you make on this turn with the maddening power of the spaces between the stars. If that attack doesn't hit, you take 2 points of damage to your highest mental ability score. If the attack hits, your opponent takes damage from your attack plus 1d4+1 points of wisdom damage. A successful Will save (DC = 10 + 1/2 level + highest mental modifier) reduces this to 2 points of Wisdom damage.`,
        prereq: "Maddening Style",
        },
        {
        name: "Maddening Obliteration",
        type: "style",
        shortDesc: "",
        longDesc: `When you damage a living creature with an unarmed strike while using Maddening Style, and you have at least level spell points remaining, that creature suffers a -2 penalty on saving throws against any confusion, madness, and insanity effects (including your Maddening Strike) for 1 round. Additionally, if you reduce a creature to fewer than 0 hit points with an unarmed attack, you can spend levelx2 spell points points as a free action to obliterate your opponent, reducing their body to fine dust as per disintegrate. A living creature can attempt a Fortitude save (DC = 10 + 1/2 level + your highest mental modifier) to negate this effect.`,
        prereq: "Maddening Strike",
        },
        {
        name: "Mobile Bulwark Style",
        type: "style",
        shortDesc: "",
        longDesc: `While using a shield that gives at least +3 shield bonus to armor class at base, add the shield's bonus to AC (including its enhancement bonus) to your CMD against bull rush and overrun combat maneuvers. While using this style, you can use a tower shield to grant you total cover along one edge of your space as a move action, or use a tower shields total cover ability if it didn't have it before.`,
        prereq: "",
        },
        {
        name: "Mobile Bulwark Fortress",
        type: "style",
        shortDesc: "",
        longDesc: `While using a shield that gives at least +3 shield bonus to armor class at base, you add half of the shield's bonus to AC (including its enhancement bonus) to your touch AC and take only a -1 penalty on attack rolls because of the shield's encumbrance (if it applies a penalty). While using Mobile Bulwark Style, whenever you would use a shield to gain total cover, you also grant any adjacent ally total cover against attacks passing through the selected edge of your space.`,
        prereq: "Mobile Bulwark Style",
        },
        {
        name: "Mobile Bulwark Stronghold",
        type: "style",
        shortDesc: "",
        longDesc: `While using a tower shield, you do not suffer a penalty on attack rolls because of the shield's encumbrance.

        While using Mobile Bulwark Style, whenever you use a tower shield to gain total cover, you also gain partial cover (and grant partial cover to adjacent allies) against spells passing through the selected edge of your space. Also, while using this style, you can gain total cover against a single attack made against you as an immediate or swift action.`,
        prereq: "Mobile Bulwark Fortress",
        },
        {
        name: "Monkey Style",
        type: "style",
        shortDesc: "",
        longDesc: `You add your highest mental bonus on Acrobatics checks. While using this style, you take no penalty on melee attack rolls or to AC while prone. Further, you can crawl and stand up from lying prone without provoking attacks of opportunity, and you can stand up as a swift action if you succeed at a DC 20 Acrobatics check.`,
        prereq: "",
        },
        {
        name: "Monkey Moves",
        type: "style",
        shortDesc: "",
        longDesc: `While using Monkey Style, you gain a highest mental bonus on Climb checks. You can also can climb and crawl at half your speed; you can take a 5-foot step by jumping, crawling, or climbing; and you retain your Dexterity bonus to AC while climbing. Further, while using Monkey Style, when you successfuly make two melee attacks with a light weapon to hit an opponent twice or more on your turn, you can spend a swift action to take a 5-foot step even if you have moved this round.`,
        prereq: "Monkey Style",
        },
        {
        name: "Monkey Shine",
        type: "style",
        shortDesc: "",
        longDesc: `While using Monkey Style, if you are adjacent to a creature that becomes stunned, paralyzed, or dazed, you can spend a free action to enter a square adjacent to you that is within your opponent's space. This movement does not provoke attacks of opportunity. While you are in your opponent's space, you gain a +4 dodge bonus to AC and a +4 bonus on melee attack rolls against that opponent. If otherwise unhindered, the opponent can move away from you, but if he does, he provokes an attack of opportunity from you even if his choice of movement does not normally do so.`,
        prereq: "Monkey Moves",
        },
        {
        name: "Octopus Style",
        type: "style",
        shortDesc: "",
        longDesc: `As a move action when using this style, you can select a number of creatures you are aware of equal to your Dexterity modifier. You can't be flanked by the selected creatures until the start of your next turn.`,
        prereq: "",
        },
        {
        name: "Octopus Focus",
        type: "style",
        shortDesc: "",
        longDesc: `When using this style, you gain a cumulative +1 bonus on melee attacks for each enemy that threatens you, up to a maximum equal to your Dexterity modifier.

        In addition, when you attempt to grapple without two free hands, you take only a -2 penalty on your combat maneuver check instead of the usual -4.`,
        prereq: "Octopus Style",
        },
        {
        name: "Octopus Thrash",
        type: "style",
        shortDesc: "",
        longDesc: `While using Octopus Style, when you threaten two enemies who are adjacent to each other, you can attempt a trip combat maneuver check against both targets at once in place of a melee attack. You attempt a single combat maneuver check at a -5 penalty and apply the result to both targets.`,
        prereq: "Octopus Focus",
        },
        {
        name: "Orc Fury Style",
        type: "style",
        shortDesc: "",
        longDesc: `While wielding a two handed melee weapon, you can use the Bullying Blow feat with the first attack of a full-attack action or as part of a standard action to make one or more attacks (such as with the Cleave feat).`,
        prereq: "Bullying Blow",
        },
        {
        name: "Orc Rampage",
        type: "style",
        shortDesc: "",
        longDesc: `While using Orc Fury Style, you gain a +1 bonus on attack rolls and damage rolls against shaken opponents, and you don't take an attack penalty when using the Bullying Blow feat.`,
        prereq: "Orc Fury Style",
        },
        {
        name: "Orc Snarl",
        type: "style",
        shortDesc: "",
        longDesc: `While using Orc Fury Style, you gain a +4 bonus on saving throws against effects created by shaken foes.`,
        prereq: "Orc Rampage",
        },
        {
            name: "Outslug Style",
            type: "style",
            shortDesc: "",
            longDesc: `While using this style, when you take a 5-foot step, you gain a +1 dodge bonus to AC and a +1 bonus on weapon damage rolls with bludgeoning weapons, or unarmed attacks until the beginning of your next turn.`,
            prereq: "",
        },
        {
            name: "Outslug Weave",
            type: "style",
            shortDesc: "",
            longDesc: `While using Outslug Style, you don't take a -2 penalty to your AC when using the Lunge feat, or similar abilities. The bonuses to AC and on weapon damage rolls that you gain from Outslug Style increase to +2.`,
            prereq: "Outslug Style",
        },
        {
            name: "Outslug Sprint",
            type: "style",
            shortDesc: "",
            longDesc: `While using Outslug Style, you can move an additional 5 feet when making a 5-foot step.`,
            prereq: "Outslug Weave",
        },
        {
            name: "Overwatch Style",
            type: "style",
            shortDesc: "",
            longDesc: `While using this style, as a full-round action you can ready two ranged attacks, each with its own triggering event.

            You take a -2 penalty on attack rolls made with these readied actions.`,
            prereq: "",
        },
        {
            name: "Overwatch Tactician",
            type: "style",
            shortDesc: "",
            longDesc: `While using Overwatch Style, you can ready two ranged attacks as a standard action, rather than a full-round action.`,
            prereq: "Overwatch Style",
        },
        {
            name: "Overwatch Vortex",
            type: "style",
            shortDesc: "",
            longDesc: `While using the Overwatch Style, as a full-round action you can ready up to four ranged attacks, each with its own triggering event. You take a -2 penalty on attack rolls made with these readied actions.`,
            prereq: "Overwatch Tactician",
        },
        {
            name: "Owl Style",
            type: "style",
            shortDesc: "",
            longDesc: `While using this style, you can use your base attack bonus in place of your ranks in Stealth to determine your Stealth skill modifier (as usual, this does not replace your ranks for other purposes, such as determining the effects of Skill Focus). While in this stance and using Stealth, you can charge at a -10 penalty beyond the penalty you take for using Stealth at full speed (which is typically -5).

            Foes that fail their Perception checks and don't otherwise notice you (for instance, with an ability like blindsight) are denied their Dexterity bonuses to AC against all attacks you make against them during or at the end of that charge instead of just against the first attack.`,
            prereq: "",
        },
        {
            name: "Owl Swoop",
            type: "style",
            shortDesc: "",
            longDesc: `While using Owl Style, you can use your base attack bonus in place of your ranks in Acrobatics to determine your Acrobatics skill bonus. You can attempt Acrobatics checks to move on narrow or slick surfaces and to avoid attacks of opportunity while charging, incurring the same penalties and increased DCs that you usually would apply for moving at full speed.`,
            prereq: "Owl Style",
        },
        {
            name: "Owl Dive",
            type: "style",
            shortDesc: "",
            longDesc: `While using Owl Style, you can use your base attack bonus in place of your ranks in Fly to determine your Fly skill bonus. You can charge through other creatures' spaces, but you must make a successful Acrobatics check to move through enemy spaces, as normal. If you fail an Acrobatics check to move through an enemy's space during a charge, your charge stops just before you enter that enemy's space; if you threaten that foe, you can make your charge attack against that foe.`,
            prereq: "Owl Style",
        },
        {
            name: "Panther Style",
            type: "style",
            shortDesc: "",
            longDesc: `While using this style, when an opponent makes an attack of opportunity against you for moving through a threatened square, you can spend a swift action to make a retaliatory unarmed or light slashing or piercing attack against that opponent. Your attack is resolved after the triggering attack of opportunity.`,
            prereq: "",
        },
        {
            name: "Panther Claw",
            type: "style",
            shortDesc: "",
            longDesc: `While using Panther Style, you can spend a free action, instead of spending a swift action, to make your retaliatory attack. You can make a number of retaliatory attacks on your turn equal to your highest mental modifier.`,
            prereq: "Panther Style",
        },
        {
            name: "Panther Parry",
            type: "style",
            shortDesc: "",
            longDesc: `While using Panther Style, your retaliatory attacks are resolved before the triggering attacks. If your retaliatory attack deals damage to an opponent, that opponent takes a -2 penalty on attack and damage rolls with the triggering attack of opportunity.`,
            prereq: "Panther Claw",
        },
        {
            name: "Perfect Style",
            type: "style",
            shortDesc: "",
            longDesc: `When you take this feat, you can choose between getting 5 acid, fire, or electricity resistance. This energy resistance stacks with all others.`,
            prereq: "",
        },
        {
            name: "Unblinking Flame Feint",
            type: "style",
            shortDesc: "",
            longDesc: `While using Perfect Style, you can use your highest mental modifier in place of your Charisma modifier when attempting Bluff checks to feint. You can spend 4 spell points as a swift action to gain the benefits of Improved Feint for 1 round.`,
            prereq: "Perfect Style",
        },
        {
            name: "Unblinking Flame Fist",
            type: "style",
            shortDesc: "",
            longDesc: `When using Perfect Style, the save DC of your feats that you deliver through unarmed attacks increases by 2 against flat-footed targets. When you spend spell points to gain the benefits of Improved Feint for 1 round, you may attempt a feint as part of your movement when charging.`,
            prereq: "Unblinking Flame Feint",
        },
        {
            name: "Unfolding Wind Strike",
            type: "style",
            shortDesc: "",
            longDesc: `When using Perfect Style, you double the range increment of any thrown weapon you wield. You can spend 4 spell points as a swift action to imbue a number of thrown weapons equal to your highest mental bonus with the frost or seeking weapon special ability for 1 round.`,
            prereq: "Perfect Style",
        },
        {
            name: "Unfolding Wind Rush",
            type: "style",
            shortDesc: "",
            longDesc: `When using Perfect Style and wielding thrown weapons, you can combine a full attack action with a single move action. You must forgo the attack at your highest bonus but may take the remaining attacks as normal at any point during your movement. You can spend 1 ki point as a swift action to create a path of wind along your path of movement that functions as wind wall for 1 round; this effect does not affect your ranged attacks.`,
            prereq: "Unfolding Wind Strike",
        },
        {
            name: "Untwisting Iron Strength",
            type: "style",
            shortDesc: "",
            longDesc: `When using Perfect Style, you can ignore an amount of hardness equal to your character level. Additionally, you gain a +4 bonus on Strength checks to break objects. If you spend 4 spell points as a swift action, you also gain the benefits of Improved Sunder for 1 round.`,
            prereq: "Perfect Style",
        },
        {
            name: "Untwisting Iron Skin",
            type: "style",
            shortDesc: "",
            longDesc: `When using Perfect Style, you gain an amount of DR/adamantine equal to 1/3 your character level (maximum 6). Additionally, whenever you break an item with at least hardness 10, you gain DR 1/— for a number of rounds equal to half the item's hit points (maximum 10 rounds); the value of this damage reduction increases by 1 for every 5 points of hardness above 10 the broken item possessed. You can spend 4 spell points as a swift action to double either of the damage reduction values granted by this feat for 1 round.`,
            prereq: "Untwisting Iron Strength",
        },
        {
            name: "Psychovore Style",
            type: "style",
            shortDesc: "",
            longDesc: `When using this style, you can attempt a Sense Motive check (DC = 15 + CR of target) as a move action against a creature with an Intelligence score of 3 or higher. If you succeed, you gain a +1 dodge bonus to your AC against attacks from the target creature until you are no longer using this style. You can have this bonus against only one creature at a time: if you succeed at this Sense Motive check against another creature, you lose the bonus against the first creature. This bonus increases by +1 for each 8 ranks you have in sense motive.`,
            prereq: "",
        },
        {
            name: "Psychovore Strike",
            type: "style",
            shortDesc: "",
            longDesc: `When you strike the creature you are gaining a dodge bonus to AC against from Psychovore Style with a weapon attack, you can force that creature to attempt a Will saving throw (DC = 10 + 1/2 level + highest mental modifier), in addition to dealing damage normally. A creature who fails its save is confused for 1d6 rounds. You must declare that you are using this feat before you make your attack roll (thus, a failed attack roll ruins the attempt). It costs 5 spell points to use this ability, and you can use it no more than once per round. This is a mind-affecting effect, and a creature confused in this way never attacks you.`,
            prereq: "Psychovore Style",
        },
        {
            name: "Psychovore Master",
            type: "style",
            shortDesc: "",
            longDesc: `When you score a critical hit against the creature you are gaining a dodge bonus to AC against from Psychovore Style with your a weapon attack, that target also takes 1 point of Intelligence and Wisdom damage and you gain 2d8 temporary hit points. These temporary hit points last for 1 hour and don't stack with other temporary hit points you might gain with this feat.`,
            prereq: "Psychovore Strike",
        },
        {
            name: "Pummeling Style",
            type: "style",
            shortDesc: "",
            longDesc: `Whenever you use a full-attack action or flurry of blows to make multiple attacks against a single opponent with unarmed strikes, total the damage from all hits before applying damage reduction. This ability works only with unarmed strikes, no matter what other abilities you might possess.`,
            prereq: "",
        },
        {
            name: "Pummeling Bully",
            type: "style",
            shortDesc: "",
            longDesc: `When you use Pummeling Style to make an entire full attack or flurry of blows against a single target, if you hit with any of your attacks, you can attempt a reposition or trip combat maneuver check as a free action.`,
            prereq: "Pummeling Style",
        },
        {
            name: "Pummeling Charge",
            type: "style",
            shortDesc: "",
            longDesc: `You can charge and make a full attack or flurry of blows at the end of your charge as part of the charge action. You can use Pummeling Charge in this way only if all of your attacks qualify for using Pummeling Style against a single target.`,
            prereq: "Pummeling Bully",
        },
        {
            name: "Shark Style",
            type: "style",
            shortDesc: "",
            longDesc: `You can deal piercing or bludgeoning damage with your unarmed strikes. Your piercing attacks deal an additional 1d6 points of bleed damage.`,
            prereq: "",
        },
        {
            name: "Shark Tear",
            type: "style",
            shortDesc: "",
            longDesc: `While in Shark Style, you gain 30 foot scent, but only against bleeding creatures. You also gain a +1 bonus on attack and +2 on damage rolls against bleeding creatures.`,
            prereq: "Shark Style",
        },
        {
            name: "Shark Leap",
            type: "style",
            shortDesc: "",
            longDesc: `While in Shark Style, you can perform a terrifying leap to attack opponents directly above you, and also out of your reach. This works similarly to the charge action, except you can move only straight up, and you make a single melee attack. You make a fly or swim check, and you can move upwards that distance to strike a foe, with a maximum of your movement speed. If the attack hits, it deals double damage; if the attack roll's result is also higher than 11 + the target's fly/swim modifier, the attack knocks the target off-balance until its next turn (lose dex to ac and opponents get +2 on attacks to hit it). Like with a charge, you can perform a partial version when limited to a single standard action (such as in the surprise round); in addition to moving half as far as normal for a partial charge, the attack doubles only the damage dice (as per Vital Strike) rather than the full damage roll.`,
            prereq: "Shark Tear",
        },
        {
            name: "Shielded Staff Style",
            type: "style",
            shortDesc: "",
            longDesc: `When you enter this style, you attach your shield to a polearm weapon, combining them into a weapon known as a shielded staff. While in this style, you can wield the shielded staff normally, but attacks you make with it take a -1 penalty. As long as you wield the shielded staff with two hands, you gain a +2 shield bonus to your AC (regardless of the shield or buckler's enhancement bonus). You can't make shield bash attacks with the attached buckler or shield, and detaching the buckler or shield from the weapon is a move action that provokes attacks of opportunity.

            The weapon and attached shield count as separate objects for the purposes of abilities or effects that target objects, except for disarm attempts, which treat the shielded staff as a single object.`,
            prereq: "",
        },
        {
            name: "Shielded Staff Ambush",
            type: "style",
            shortDesc: "",
            longDesc: `While in Shielded Staff Style, if you hit a target with a shielded staff, you can attempt either a bull rush, disarm, sunder, or trip combat maneuver check as an immediate action. You lose your shield bonus until the start of your next turn if you attempt this combat maneuver.`,
            prereq: "Shielded Staff Style",
        },
        {
            name: "Shielded Staff Master",
            type: "style",
            shortDesc: "",
            longDesc: `While using Shielded Staff Style, you add half the attached shield's enhancement bonus (if any) to the shield bonus you gain from this style.

            In addition, you do not take the -1 penalty to attacks made with a shielded staff. If both your shield and weapon have an enhancement bonus, use the higher of the two bonuses to determine your shielded staff's enhancement bonus to attack and damage rolls.`,
            prereq: "Shielded Staff Ambush",
        },
        {
            name: "Signature Strike Style",
            type: "style",
            shortDesc: "",
            longDesc: `You gain the ability to make called shot attacks, although you take double the normal penalty. Each creature you hit using a called shot, or the targeted strike swashbuckler deed must succeed at a Will save or be shaken for 1d3 rounds (DC = 10 + 1/2 level + highest mental modifier).

            This is a fear effect that doesn't stack with itself or with other fear effects. If a creature is already shaken and you make it shaken using this feat, the duration of the shaken condition is merely extended.`,
            prereq: "",
        },
        {
            name: "Signature Strike Taunt",
            type: "style",
            shortDesc: "",
            longDesc: `Creatures that gain the shaken condition as a result of Signature Strike Style also take a -2 penalty to AC for the duration of the shaken condition that feat causes. While the shaken condition persists, you do not provoke attacks of opportunity when performing combat maneuvers against that target.`,
            prereq: "Signature Strike Style",
        },
        {
            name: "Signature Strike Triumph",
            type: "style",
            shortDesc: "",
            longDesc: `When you use Signature Strike Style to give a creature the shaken condition, increase the duration to 1d4+1 rounds. When you confirm a critical hit against a creature marked by your Signature Strike Style, one ally within 60 feet who can see you can attempt a new saving throw against one ongoing effect with the emotion, fear, or mind-affecting descriptor caused by the marked creature.

            If the ally succeeds at this saving throw and the effect's remaining duration is 24 hours or less, the effect ends; if the remaining duration is more than 24 hours, the effect is suppressed for 1 minute.`,
            prereq: "Signature Strike Taunt",
        },
        {
            name: "Sisterhood Style",
            type: "style",
            shortDesc: "",
            longDesc: `While using this style and wielding a one handed slashing weapon and shield that isn't a tower shield or buckler, you gain a +1 bonus on Reflex and Will saving throws. In addition, when you enter the Sisterhood Style stance, you can choose a teamwork feat you have. As a swift action, you can grant that feat to an ally within 10 feet until the beginning of your next turn.`,
            prereq: "",
        },
        {
            name: "Sisterhood Rampart",
            type: "style",
            shortDesc: "",
            longDesc: `While using Sisterhood Style, increase your shield bonus to armor class if youre adjacent to someone with a shield, and you and adjacent allies gain an additional +1 bonus to the shield bonus granted by Shield Wall, and each of you adds your shield bonus to AC (not counting enhancement bonuses) to your CMD against bull rush combat maneuvers. In addition, you and adjacent allies do not provide soft cover against allies' attacks.`,
            prereq: "Sisterhood Style",
        },
        {
            name: "Sisterhood Dedication",
            type: "style",
            shortDesc: "",
            longDesc: `While using Sisterhood Style, the bonuses sisterhood style provides to reflex and will saves increases to +2, and you grant half that bonus to all allies within 20 feet. In addition, you can choose up to two teamwork feats you have when entering the Sisterhood Style stance. As a swift action, you can grant one of those feats to two allies within 20 feet until the beginning of your next turn, or you can grant both feats to one ally within 20 feet until the beginning of your next turn.`,
            prereq: "Sisterhood Rampart",
        },
        {
            name: "Skyseeker Style",
            type: "style",
            shortDesc: "",
            longDesc: `Once per round, when an opponent attacks you with a reach weapon, you can take a 5-foot step towards your opponent as an immediate action. If the movement takes you to a square that the opponent's reach weapon does not threaten, you receive a +4 bonus to AC against that attack. If you take this step, you cannot take a 5-foot step during your next turn. If you take an action to move during your next turn, subtract 5 feet from your total available movement.`,
            prereq: "",
        },
        {
            name: "Skyseeker Thrash",
            type: "style",
            shortDesc: "",
            longDesc: `While using Skyseeker Style, you gain a cumulative +1 bonus on melee damage rolls for every size category your opponent is larger than you.`,
            prereq: "Skyseeker Style",
        },
        {
            name: "Skyseeker Impact",
            type: "style",
            shortDesc: "",
            longDesc: `While using Skyseeker Style, whenever you hit an opponent larger than you with a melee attack, your weapon deals damage as if that weapon were one size category larger. You also gain a +4 bonus on sunder combat maneuver checks against targets larger than you.`,
            prereq: "Skyseeker Thrash",
        },
        {
            name: "Snake Style",
            type: "style",
            shortDesc: "",
            longDesc: `You gain a +2 bonus on Sense Motive checks, and you can deal piercing damage with your unarmed strikes. While using the Snake Style feat, when an opponent targets you with a melee or ranged attack, you can spend an immediate action to make a Sense Motive check. You can use the result as your AC or touch AC against that attack. You must be aware of the attack and not flat-footed.`,
            prereq: "",
        },
        {
            name: "Snake Sidewind",
            type: "style",
            shortDesc: "",
            longDesc: `You gain a +4 bonus to CMD against trip combat maneuvers and on Acrobatics checks and saving throws to avoid being knocked prone. While using the Snake Style feat, whenever you score a critical threat with a melee attack, you can make a Sense Motive check in place of the attack roll to confirm the critical hit. Whenever you score a critical hit with melee attack, you can spend an immediate action to take a 5-foot step even if you have otherwise moved this round.`,
            prereq: "Snake Style",
        },
        {
            name: "Snake Fang",
            type: "style",
            shortDesc: "",
            longDesc: `While using the Snake Style, when an opponent's attack misses you, you can make an unarmed strike against that opponent as an attack of opportunity. If this attack of opportunity hits, you can spend an immediate action to make another melee against the same opponent.`,
            prereq: "Snake Sidewind",
        },
        {
            name: "Snapping Turtle Style",
            type: "style",
            shortDesc: "",
            longDesc: `While using the Snapping Turtle Style feat with at least one hand free, you gain a +1 shield bonus to AC.`,
            prereq: "",
        },
        {
            name: "Snapping Turtle Clutch",
            type: "style",
            shortDesc: "",
            longDesc: `While you are using the Snapping Turtle Style feat, the shield bonus the style grants to your AC applies to your CMD and touch AC. Whenever an opponent misses you with a melee attack while you are using the Snapping Turtle Style feat, you can use an immediate action to attempt a grapple combat maneuver against that opponent, but with a -2 penalty.`,
            prereq: "Snapping Turtle Style",
        },
        {
            name: "Snapping Turtle Shell",
            type: "style",
            shortDesc: "",
            longDesc: `While you are using the Snapping Turtle Style feat, the shield bonus the style grants to your AC increases to +2, and your enemies take a -4 penalty on critical confirmation rolls against you.`,
            prereq: "Snapping Turtle Clutch",
        },
        {
            name: "Spear Dancing Style",
            type: "style",
            shortDesc: "",
            longDesc: `Choose one weapon from the polearm or spear fighter weapon groups. While using this style, you grant the chosen weapon the double special weapon feature, using the weapon's normal statistics for its main-hand end and the statistics of a light mace for its off-hand end.

            A weapon wielded in this way loses the brace and reach special weapon features.`,
            prereq: "",
        },
        {
            name: "Spear Dancing Spiral",
            type: "style",
            shortDesc: "",
            longDesc: `While using Spear Dancing Style, you gain the benefit of Weapon Finesse with the chosen weapon if it is appropriately sized for a creature of your size category. In addition, you can use any feat or ability that functions with a quarterstaff with your chosen weapon. While using Spear dancing style to make a double weapon the offhand weapon for your spear gets 1 enchantment on the main head (your choice)`,
            prereq: "Spear Dancing Style",
        },
        {
            name: "Spear Dancing Reach",
            type: "style",
            shortDesc: "",
            longDesc: `While using Spear Dancing Style and making a full attack using the chosen weapon as a double weapon, you can grant the reach special weapon feature to one or both of the weapon's ends until the end of your turn as a swift action. While using Spear dancing style to make a double weapon the offhand weapon for your spear gets all but your enchancement of the highest rarity.`,
            prereq: "Spear Dancing Spiral",
        },
        // {
        //     name: "Starfall Style",
        //     type: "style",
        //     shortDesc: "",
        //     longDesc: ``,
        //     prereq: "",
        // },
        {
            name: "Startoss Style",
            type: "style",
            shortDesc: "",
            longDesc: `While using this style and throwing weapons, you gain a bonus on damage rolls made with the weapon equal to 2 + 2 per style feat you possess that lists Startoss Style as a prerequisite (maximum +6 damage).

            You cannot use this ability if you are carrying a weapon or a shield in your off hand (except for a buckler), or when two weapon fighting with thrown weapons.`,
            prereq: "",
        },
        {
            name: "Startoss Comet",
            type: "style",
            shortDesc: "",
            longDesc: `As a standard action, you can make a single ranged thrown weapon attack at your full attack bonus with the chosen weapon. If you hit, you deal damage normally and can make a second attack (at your full attack bonus) against a target within one range increment of the first. You determine cover for this attack from the first target's space instead of your space.

            You can make only one additional attack per round with this feat. If you have Vital Strike, Improved Vital Strike, or Greater Vital Strike, you can add the additional damage from those feats to the initial ranged attack (but not the second attack).`,
            prereq: "Startoss Style",
        },
        {
            name: "Startoss Shower",
            type: "style",
            shortDesc: "",
            longDesc: `When you hit an opponent while using the Startoss Comet feat, you can continue to make attacks against foes that are within one range increment of all previous opponents. You determine cover for each attack from the most recently hit foe's space instead of your space, and you cannot attack an individual foe more than once during this attack action.

            You can make a maximum number of attacks equal to 1 + 1 per 5 points of base attack bonus you possess. If you have Vital Strike, Improved Vital Strike, or Greater Vital Strike, you can add the additional damage from those feats to the initial ranged attack, however each subsequent attack has the bonus damage dice reduced by 1.`,
            prereq: "Startoss Comet",
        },
        {
            name: "Stick-Fighting Style",
            type: "style",
            shortDesc: "",
            longDesc: `When fighting with a common or rare bludgeoning weapon, but not unarmed attack, you gain a +1 enhancement bonus on attack rolls as though it were a masterwork weapon. If the weapon is enchanted, it instead counts as having the blocking, disarm, distracting, performance, and trip special weapon qualities, even if the weapon normally doesn't have them.`,
            prereq: "",
        },
        {
            name: "Stick-Fighting Counter",
            type: "style",
            shortDesc: "",
            longDesc: `While you are fighting defensively, as a free action you can select an opponent you have attacked on that turn and prepare yourself to counter one of its attacks. Once per round, when that opponent attempts a melee attack against you and the attack misses, the attacker provokes an attack of opportunity from you, provided that it is within your threatened area. You must use one of the weapons listed in Stick-Fighting Style to perform the attack of opportunity.`,
            prereq: "Stick-Fighting Style",
        },
        {
            name: "Stick-Fighting Maneuver",
            type: "style",
            shortDesc: "",
            longDesc: `When making a full attack using only one of the weapons listed in Stick-Fighting Style, you can perform a combat maneuver as an extra attack using your full base attack bonus.`,
            prereq: "Stick-Fighting Counter",
        },
        {
            name: "Street Style",
            type: "style",
            shortDesc: "",
            longDesc: `While using this style, once per round as a swift action when you hit a target with an unarmed strike, light, or one-handed bludgeoning weapon, you can deal an extra 1d6 points of damage and attempt a bull rush combat maneuver against that target. This still provokes as normal.`,
            prereq: "",
        },
        {
            name: "Street Sweep",
            type: "style",
            shortDesc: "",
            longDesc: `While using Street Style, the first time each round that you deal damage with an unarmed strike, light, or one-handed bludgeoning weapon to a foe that you bull rushed with Street Style since the beginning of your last turn, that foe must succeed at a Fortitude save (DC = 10 + your base attack bonus) or be knocked prone and staggered for 1 round.`,
            prereq: "Street Style",
        },
        {
            name: "Street Carnage",
            type: "style",
            shortDesc: "",
            longDesc: `While using Street Style, the critical multiplier of your unarmed strikes, light, or one-handed bludgeoning weapons increases by +1.`,
            prereq: "Street Sweep",
        },
        {
            name: "Swift Iron Style",
            type: "style",
            shortDesc: "",
            longDesc: `While using this style, you treat the armor check penalty of your armor as if it were 1 less, and the maximum Dexterity bonus to AC as if it were 2 higher. For each feat you have in this chain after this one, reduce the armor check penalty your armor gives you, and increase its max dexterity bonus by 1.`,
            prereq: "",
        },
        {
            name: "Swift Iron Refuge",
            type: "style",
            shortDesc: "",
            longDesc: `Once per day when using Swift Iron Style, when you're hit by a weapon, unarmed attack, or natural weapon, you can treat all dice (including extra dice from sneak attack, critical hit, magic special weapon abilities, and Vital Strike) as having rolled 1s. You can use this ability an additional time for every 6 of your bab.`,
            prereq: "Swift Iron Style",
        },
        {
            name: "Swift Iron Sprint",
            type: "style",
            shortDesc: "",
            longDesc: `When you're charging, running, or taking no action in your turn other than movement, your armor does not reduce your movement.`,
            prereq: "Swift Iron Refuge",
        },
        {
            name: "Swordplay Style",
            type: "style",
            shortDesc: "",
            longDesc: `While using light or heavy blades, While using this style, and fighting defensively or using either the total defense action or the Combat Expertise feat, you gain a +1 shield bonus to your Armor Class. In addition, you do not take the penalty on melee attacks from Combat Expertise on the first attack roll you make each turn. You still take the penalty on additional attacks, including attacks of opportunity.`,
            prereq: "",
        },
        {
            name: "Swordplay Upset",
            type: "style",
            shortDesc: "",
            longDesc: `While using Swordplay Style, as an immediate action, you can attempt a feint against an opponent that makes a melee attack against you and misses.`,
            prereq: "Swordplay Style",
        },
        {
            name: "Swordplay Deflection",
            type: "style",
            shortDesc: "",
            longDesc: `While using Swordplay Style, when you make one or more melee attacks, you can forgo a single melee attack to prepare an action to disrupt an opponent's attack.

            This functions as a swashbuckler's opportune parry and riposte deed, except that if your result is greater than your opponent's, you gain a +4 shield bonus to your Armor Class against attacks made by your opponent until the start of your next turn instead of preventing the hit, and you cannot attempt to riposte. If you have the opportune parry and riposte deed, you gain this Armor Class bonus anytime you successfully parry an opponent's attack.`,
            prereq: "Swordplay Upset",
        },
        {
            name: "Tatzlwyrm Claw Style",
            type: "style",
            shortDesc: "",
            longDesc: `You can choose for your unarmed attacks to deal slashing damage. If you strike a target that has another creature grappled or pinned, as a swift action you can immediately attempt a grapple combat maneuver check against the target's CMD. If you succeed at the check, you can force the target to release a grappled creature or switch a pinned creature to being merely grappled.`,
            prereq: "",
        },
        {
            name: "Tatzlwyrm Grappler",
            type: "style",
            shortDesc: "",
            longDesc: `While you're using the Tatzlwyrm Claw Style feat, whenever an opponent attempts to initiate a grapple against you, you can attempt an Escape Artist check. If the result is higher than your CMD, you can use the result as your CMD against that combat maneuver. You must be aware of the attack and not flat-footed.`,
            prereq: "Tatzlwyrm Claw Style",
        },
        {
            name: "Tatzlwyrm Rake",
            type: "style",
            shortDesc: "",
            longDesc: `While using the Tatzlwyrm Claw Style feat, you can attempt a combat maneuver check to maintain a grapple without using your arms. You must use at least two limbs in order to do this, and if you use all your legs, you can't take any movement while maintaining the grapple. If your combat maneuver check succeeds by 10 or more, you are able to make a single attack against the target of the grapple as a swift action.`,
            prereq: "Tatzlwyrm Grappler",
        },
        {
            name: "Tiger Style",
            type: "style",
            shortDesc: "",
            longDesc: `While using this style, you gain a +2 bonus to your CMD against bull rush, overrun, and trip maneuvers. You can also deal slashing damage with your unarmed strikes. Whenever you score a critical hit with your slashing weapon, your opponent also takes 1d4 points of bleed damage at the start of his next two turns.`,
            prereq: "",
        },
        {
            name: "Tiger Claws",
            type: "style",
            shortDesc: "",
            longDesc: `While you are using the Tiger Style feat and have both hands free or two weapons, you can use a full-round action to make a single attack with both hands.

            Use your highest base attack bonus, rolling damage for each hand separately and multiplying both if you score a critical hit.
            
            If you use Power Attack in conjunction with this attack, increase your Strength bonus on one of the damage rolls by an additional one-half your Strength bonus.
            
            If you hit, you can attempt a bull rush maneuver with a +2 bonus on the combat maneuver check. This bull rush attempt provokes no attack of opportunity from your opponent, but you cannot move with that opponent if your bull rush is successful.`,
            prereq: "Tiger Style",
        },
        {
            name: "Tiger Pounce",
            type: "style",
            shortDesc: "",
            longDesc: `While using the Tiger Style feat, you can apply the penalty from Power Attack to your AC instead of attack rolls. Additionally, once per round as a swift action, you can move up to half your speed closer to a target you hit with an unarmed strike or made a successful combat maneuver against on this turn or your last turn.`,
            prereq: "Tiger Claws",
        },
        {
            name: "Twin Fang Style",
            type: "style",
            shortDesc: "",
            longDesc: `Each time you make a full attack wielding a pair of light slashing weapons and hit a creature with both weapons, you reduce its armor bonus to AC by 1 until the beginning of your next turn. This reduction stacks to a minimum armor bonus of +0. For example, if you hit a creature wearing a chain shirt with two primary attacks and two off-hand attacks, you would reduce its armor bonus to AC from +4 to +2.`,
            prereq: "",
        },
        {
            name: "Twin Fang Strike",
            type: "style",
            shortDesc: "",
            longDesc: `While using Twin Fang Style, when you take an attack action while wielding light slashing weapons, you can strike with both your primary and off-hand weapons. If you do so, both attacks take a -4 penalty and you apply precision damage and effects that occur when you hit only once, even if you hit with both attacks.`,
            prereq: "Twin Fang Style",
        },
        {
            name: "Twin Fang Lunge",
            type: "style",
            shortDesc: "",
            longDesc: `While using Twin Fang Style, you can spend a full-round action to move up to twice your speed and then use Twin Fang Strike as if you were taking the attack action.`,
            prereq: "Twin Fang Strike",
        },
        {
            name: "Upsetting Shield Style",
            type: "style",
            shortDesc: "",
            longDesc: `You can shield bash with a buckler as if it were a light shield, and you can use the buckler in conjunction with any feats or abilities that normally apply to light shields. While using this style, whenever you successfully deal damage to an opponent with a shield bash using your buckler, that opponent takes a -2 penalty on all attack rolls made against you until the start of your next turn.`,
            prereq: "",
        },
        {
            name: "Upsetting Strike",
            type: "style",
            shortDesc: "",
            longDesc: `While you are using Upsetting Shield Style, if a foe is taking a penalty on attack rolls against you as a result of Upsetting Shield Style, and that foe makes a melee attack roll against you that misses your AC by 5 or more, that foe provokes an attack of opportunity from you.

            You can only make one attack of opportunity against an opponent in this manner each round.`,
            prereq: "Upsetting Shield Style",
        },
        {
            name: "Upsetting Vengeance",
            type: "style",
            shortDesc: "",
            longDesc: `While using Upsetting Shield Style, the penalty on attack rolls foes take for being hit by your shield bash attack applies to their attacks against any target. If an adjacent foe taking this penalty makes an attack roll against any target and misses the target's AC by 5 or more, that foe provokes an attack of opportunity from you. You can only make one attack of opportunity against an opponent as a result of this feat or Upsetting Strike each round.`,
            prereq: "Upsetting Strike",
        },
        {
            name: "Vanguard Style",
            type: "style",
            shortDesc: "",
            longDesc: `While using this style, when an adjacent ally is required to make a Reflex saving throw, you can expend a use of an attack of opportunity to attempt the aid another action to improve your ally's Reflex save. Your ally gains a +2 bonus to all Reflex saves while adjacent to you until the beginning of your next turn.`,
            prereq: "",
        },
        {
            name: "Vanguard Ward",
            type: "style",
            shortDesc: "",
            longDesc: `While using Vanguard Style, when an adjacent ally is attacked or required to make a Reflex saving throw, you can expend a use of an attack of opportunity to use both Bodyguard and Vanguard Style to protect that ally.

            You can also lose your shield bonus to AC to grant your ally a shield bonus to AC of the same value for as long as that ally gains a bonus to Reflex saves from Vanguard Style.`,
            prereq: "Vanguard Style",
        },
        {
            name: "Vanguard Hustle",
            type: "style",
            shortDesc: "",
            longDesc: `Add half of your shield's enhancement bonus to the shield bonus to AC that you grant to an ally using the Saving Shield feat. While using Vanguard Style, your ward retains the bonuses of Vanguard Style as long as he remains within your threatened area, and you can use Bodyguard, Saving Shield, and Vanguard Style whenever an ally that is within this threatened area is the target of an attack.`,
            prereq: "Vanguard Ward",
        },
        {
            name: "Wolf Style",
            type: "style",
            shortDesc: "",
            longDesc: `While using this style, whenever you deal at least 10 points of damage to a foe with an attack of opportunity, that foe's base speed decreases by 5 feet until the end of its next turn. For every 10 points of damage your attack deals beyond 10, the foe's base speed decreases by an additional 5 feet. If the penalty meets or exceeds the total base speed of the foe, you can attempt to trip the foe as a free action after the attack of opportunity is resolved.`,
            prereq: "",
        },
        {
            name: "Wolf Trip",
            type: "style",
            shortDesc: "",
            longDesc: `While using Wolf Style, you gain a +2 bonus when you attempt a trip combat maneuver as part of an attack of opportunity. Whenever you successfully trip a creature, as a free action you can choose an available space that is both adjacent to you and the creature's original space for the tripped creature to land prone in.`,
            prereq: "Wolf Style",
        },
        {
            name: "Wolf Savage",
            type: "style",
            shortDesc: "",
            longDesc: `While using Wolf Style, when you deal at least 10 points of damage to a prone opponent with unarmed or melee weapon attacks, as a swift action you can savage that creature. When you do, your opponent must succeed at a Fortitude save (DC = 10 + 1/2 level + highest mental modifier). If the target fails the saving throw, it takes either 1d4 Charisma damage or 1d4 Constitution damage, or it becomes fatigued (your choice). Ability score damage dealt with this ability cannot equal or exceed the victim's actual ability score total.`,
            prereq: "Wolf Trip",
        },
        {
            name: "Black Seraph Style",
            type: "style",
            shortDesc: "",
            longDesc: `Against the abilities of creatures that are shaken, frightened, panicked, or cowering, you gain a +1 profane bonus to your AC and on saving throws. This bonus increases by +1 at character level 5th and at every five levels thereafter.`,
            prereq: "",
        },
        {
            name: "Black Seraph's Malevolence",
            type: "style",
            shortDesc: "",
            longDesc: `You treat creatures that are shaken, frightened, panicked, or cowering as being good-aligned for the purpose of dealing profane damage to them.`,
            prereq: "Black Seraph Style",
        },
        {
            name: "Black Seraph's Annihilation",
            type: "style",
            shortDesc: "",
            longDesc: `Creatures within 30 feet of you can be affected by fear effects even if they are normally immune to fear. Creatures within 30 feet of you that are normally immune to mind-affecting effects can still be affected by fear effects, although they gain a +5 resistance bonus on saves against such effects.`,
            prereq: "Black Seraph's Malevolence",
        },
        {
            name: "Broken Blade Style",
            type: "style",
            shortDesc: "",
            longDesc: `Your unarmed strikes ignore 1/2 your character level in damage reduction and hardness.`,
            prereq: "",
        },
        {
            name: "Broken Blade Crush",
            type: "style",
            shortDesc: "",
            longDesc: `Once per round, when you make an unarmed strike against an opponent wearing armor, you can make a sunder attempt against that opponent's armor as a free action that does not provoke attacks of opportunity. This sunder attempt takes place before your unarmed strike.`,
            prereq: "Broken Blade Style",
        },
        {
            name: "Broken Blade Rhythm",
            type: "style",
            shortDesc: "",
            longDesc: `Once per round, when you hit with a Broken Blade strike, you can make a combat maneuver attempt against a creature within your melee reach as a free action. This combat maneuver attempt does not provoke attacks of opportunity.`,
            prereq: "Broken Blade Crush",
        },
        {
            name: "Cursed Razor Style",
            type: "style",
            shortDesc: "",
            longDesc: `Whenever you damage a cursed creature with a melee attack, that creature takes 2 points of bleed damage plus an additional 2 points of bleed damage for every four character levels you possess. The creature continues to bleed until the bleeding is stopped via magical healing or a successful DC 15 Heal check.`,
            prereq: "",
        },
        {
            name: "Cursed Razor Plague",
            type: "style",
            shortDesc: "",
            longDesc: ` Whenever you cause an opponent to become cursed by an effect other than this feat, you may select an additional opponent within 30 feet of you to become cursed for the same duration. This only gives that opponent the cursed condition; it does not inflict any other effects from the first curse. This is a supernatural ability.`,
            prereq: "Cursed Razor Style",
        },
        {
            name: "Cursed Razor Massacre",
            type: "style",
            shortDesc: "",
            longDesc: `Once per round, when you hit a cursed creature with a melee attack, you can make a melee attack against a different cursed creature within your reach at your highest base attack bonus as a free action, even if it isn't your turn.`,
            prereq: "Cursed Razor Plague",
        },
        {
            name: "Elemental Flux Style",
            type: "style",
            shortDesc: "",
            longDesc: `You can change your active element once per round as a free action.`,
            prereq: "",
        },
        {
            name: "Elemental Flux Shift",
            type: "style",
            shortDesc: "",
            longDesc: `When you change your active element, your next attack before the start of your next turn deals additional damage equal to your highest initiation modifier of your previous active element's associated energy type. This is a supernatural ability.`,
            prereq: "Elemental Flux Style",
        },
        {
            name: "Elemental Flux Explosion",
            type: "style",
            shortDesc: "",
            longDesc: `Your weapons gain the benefit of the elemental burst weapon special ability appropriate to your active element's associated energy type (for example, your weapons would gain the benefit of the flaming burst weapon special ability if your active element is fire). This is a supernatural ability.`,
            prereq: "Elemental Flux Shift",
        },
        {
            name: "Eternal Guardian Style",
            type: "style",
            shortDesc: "",
            longDesc: `Whenever you succeed on a combat maneuver attempt against an opponent, they become cursed for one round. This is a supernatural ability.`,
            prereq: "",
        },
        {
            name: "Eternal Guardian Oath",
            type: "style",
            shortDesc: "",
            longDesc: `You can expend a readied counter of at least 3rd level as an immediate action to cause cursed creatures you threaten to take a -4 penalty on attack rolls against creatures other than you until the start of your next turn.`,
            prereq: "Eternal Guardian Style",
        },
        {
            name: "Eternal Guardian Endurance",
            type: "style",
            shortDesc: "",
            longDesc: `Once per round, when you reduce a cursed opponent to 0 or fewer hit points, you can recover spell points equal to the level a single maneuver known.`,
            prereq: "Eternal Guardian Oath",
        },
        {
            name: "Golden Lion Style",
            type: "style",
            shortDesc: "",
            longDesc: `Once per round, when an ally (other than yourself) misses an attack against an opponent you both flank, you can make an attack of opportunity against that opponent.`,
            prereq: "",
        },
        {
            name: "Golden Lion Charge",
            type: "style",
            shortDesc: "",
            longDesc: `Whenever an opponent within 30 feet misses an ally with an attack, you can expend a readied counter of at least 3rd level as an immediate action to move up to your speed towards that opponent, provided you end your movement with that opponent within your melee reach, and make an attack of opportunity against them.`,
            prereq: "Golden Lion Style",
        },
        {
            name: "Golden Lion Command",
            type: "style",
            shortDesc: "",
            longDesc: `You can expend a readied boost of at least 4th level as a swift action to grant all allies within 30 feet temporary hit points equal to 1/4 of your <heroic> mastery, plus every time you make an attack this round you grant additional temporary hit points equal to the expended maneuver's level/2. These temporary hit points stack with themselves and last for one round.`,
            prereq: "Golden Lion Charge",
        },
        {
            name: "Iron Tortoise Style",
            type: "style",
            shortDesc: "",
            longDesc: `You deal damage with shield bash attacks as though you were one size larger than you actually are. This stacks with other effects that increase you or your weapons' size.`,
            prereq: "",
        },
        {
            name: "Iron Tortoise Shell",
            type: "style",
            shortDesc: "",
            longDesc: `Whenever you initiate a counter, you gain evasion (as the rogue class feature) until the end of your next turn.`,
            prereq: "Iron Tortoise Style",
        },
        {
            name: "Iron Tortoise Snap",
            type: "style",
            shortDesc: "",
            longDesc: `Whenever you hit a creature with a shield bash, you can make an attack with a different weapon at your highest base attack bonus against that creature. You can only make two additional attacks per round in this manner.`,
            prereq: "Iron Tortoise Shell",
        },
        {
            name: "Mithral Current Style",
            type: "style",
            shortDesc: "",
            longDesc: `While you have a sheathed weapon on your person, you can make a feint against an opponent within your melee reach as a swift action. You may make Perform (dance) checks in place of Bluff checks when feinting in this way.`,
            prereq: "",
        },
        {
            name: "Mithral Current Flow",
            type: "style",
            shortDesc: "",
            longDesc: `Whenever an opponent misses an attack against you, you can move up to 10 feet without provoking attacks of opportunity as a free action, even if it isn't your turn.`,
            prereq: "Mithral Current Style",
        },
        {
            name: "Mithral Current Slice",
            type: "style",
            shortDesc: "",
            longDesc: `Your first attack in a round in which you drew a weapon deals damage to your target as if they were vulnerable to silver.`,
            prereq: "Mithral Current Flow",
        },
        {
            name: "Piercing Thunder Style",
            type: "style",
            shortDesc: "",
            longDesc: `While you are wielding a reach weapon, opponents provoke an attack of opportunity from you when they enter a square you threaten. If an opponent would also provoke an attack of opportunity from leaving a threatened square when they do, they still only provoke a single attack of opportunity from you.`,
            prereq: "",
        },
        {
            name: "Piercing Thunder Push",
            type: "style",
            shortDesc: "",
            longDesc: `You can ready spears or polearms against charges as if they had the brace quality. If you hit a charging opponent with your readied weapon, you push them back 5 feet (potentially stopping their charge).`,
            prereq: "Piercing Thunder Style",
        },
        {
            name: "Piercing Thunder Trample",
            type: "style",
            shortDesc: "",
            longDesc: `Whenever you charge a creature while wielding a Piercing Thunder discipline weapon, you can make a bull rush attempt and an overrun attempt against the target of your charge. These combat maneuver attempts do not provoke attacks of opportunity, and can be made before or after your charge attack in any order.`,
            prereq: "Piercing Thunder Push",
        },
        {
            name: "Primal Fury Style",
            type: "style",
            shortDesc: "",
            longDesc: `You can make Survival checks in place of Acrobatics checks to move through threatened squares. In addition, you can charge through difficult terrain and spaces containing opponents.`,
            prereq: "",
        },
        {
            name: "Primal Fury Slash",
            type: "style",
            shortDesc: "",
            longDesc: `When you charge a creature, you can make a single melee attack against another creature that is adjacent to you at any point during your movement.`,
            prereq: "Primal Fury Style",
        },
        {
            name: "Primal Fury Leap",
            type: "style",
            shortDesc: "",
            longDesc: `You can make charge attacks against opponents in the air. If you do, you are treated as having a fly speed equal to half your land speed during the charge, with good maneuverability. If you do not normally have a fly speed, you fall after this charge. You reduce the effective distance of this fall by 10 feet per initiator level.`,
            prereq: "Primal Fury Slash",
        },
        {
            name: "Riven Hourglass Style",
            type: "style",
            shortDesc: "",
            longDesc: `Whenever you miss an attack, you can expend a readied maneuver of at least 3nd level (costing spell points as normal) as an immediate action to reroll your attack roll. You must take the result of your second roll.`,
            prereq: "",
        },
        {
            name: "Riven Hourglass Eternity",
            type: "style",
            shortDesc: "",
            longDesc: `Once per round, while you maintain a Riven Hourglass stance, you can expend a readied maneuver of at least 3rd level (costing spell points as normal) as a free action to extend the duration of one spell, power, or boost affecting you by one round. This is a supernatural ability.`,
            prereq: "Riven Hourglass Style",
        },
        {
            name: "Riven Hourglass Rewind",
            type: "style",
            shortDesc: "",
            longDesc: `You can expend a readied counter of at least 5th level (costing spell points as normal) as an immediate action to suppress one ongoing condition affecting you for one round per 2 levels of the counter. This does not allow you to suppress the dead, dying, helpless or unconscious conditions. This is a supernatural ability. The duration of the condition does not continue while supressed, and if you are affected by the condition again, it affects you again as normal.`,
            prereq: "Riven Hourglass Eternity",
        },
        {
            name: "Scarlet Throne Style",
            type: "style",
            shortDesc: "",
            longDesc: `As long as you only attack with a single weapon wielded in one hand during a round, you treat that weapon as if you were wielding it in two hands for the purposes of feats and abilities that would benefit from this change. This does not increase your Strength bonus to damage with the weapon.`,
            prereq: "",
        },
        {
            name: "Scarlet Throne Dignity",
            type: "style",
            shortDesc: "",
            longDesc: `You can expend a readied counter of at least 3rd level (costing spell points as normal) as an immediate action in response to an attack being made against you. If you do, make an attack roll with a weapon you are wielding. If your attack roll is higher than your opponent's, their attack is negated, and you can take a 5-foot step, even if you have already moved or taken a 5-foot step this round.`,
            prereq: "Scarlet Throne Style",
        },
        {
            name: "Scarlet Throne Riposte",
            type: "style",
            shortDesc: "",
            longDesc: `Whenever you use an ability to negate an attack from an opponent (such as with a counter or with the Scarlet Throne Dignity feat), that opponent provokes an attack of opportunity from you. A given creature can only provoke an attack of opportunity from you in this way once per round.`,
            prereq: "Scarlet Throne Dignity",
        },
        {
            name: "Shadow Assassin Style",
            type: "style",
            shortDesc: "",
            longDesc: `Your shadows have their damage percentage increased by +10%, +5% for every additional Shadow Assassin style feat you have. You deal +1 point of damage per sneak attack dice rolled. This increases by +1 for every additional Shadow Assassin style feat you have.`,
            prereq: "",
        },
        {
            name: "Shadow Assassin Limitless Techniques",
            type: "style",
            shortDesc: "",
            longDesc: `Once per round as a free action you can spend spell points equal to twice its level to recover a single [Shadow Technique]. You cannot use it the round you recover it, or recover it the round you use it. When you do, for 1 round you gain a +2 bonus on any stealth checks. This increases by +1 per 15 <shadow> mastery.`,
            prereq: "Shadow Assassin Style",
        },
        {
            name: "Shadow Assassin Lord of Death",
            type: "style",
            shortDesc: "",
            longDesc: `When you score a critical hit with an attack that would qualify for sneak attack damage, you deal additional precision damage equal to half your shadow mastery. This damage can never be multiplied, but deals its full damage even if delivered through a shadow. If the creature is below 33% hit points, the damage increases to your full shadow mastery. If this attack kills a creature, you recover a single <death> maneuver and spell points equal to 18 minus twice the recovered maneuver's level.`,
            prereq: "Shadow Assassin Limitless Techniques",
        },
        {
            name: "Shattered Mirror Style",
            type: "style",
            shortDesc: "",
            longDesc: `When wielding one or more Shattered Mirror discipline weapons, your shield bonus to your AC increases by +2 (if you don't already have a shield bonus, you are considered to have a shield bonus of +0).`,
            prereq: "",
        },
        {
            name: "Shattered Mirror Waltz",
            type: "style",
            shortDesc: "",
            longDesc: `You ignore movement penalties from difficult terrain. Other effects of the terrain affect you as normal.`,
            prereq: "Shattered Mirror Style",
        },
        {
            name: "Shattered Mirror Duality",
            type: "style",
            shortDesc: "",
            longDesc: `Once per round, you can expend a readied boost of at least 4th level as a swift action. If you do, you roll twice for each attack roll you make this round and use the better result. This is a supernatural ability. As long as you are in this style, you gain an insight bonus to your armor class equal to +1 per 20 <shadow> mastery.`,
            prereq: "Shattered Mirror Waltz",
        },
        {
            name: "Silver Crane Style",
            type: "style",
            shortDesc: "",
            longDesc: `As a free action, you can choose to take a -1 penalty to your AC and on Reflex saves to grant other allies within 30 feet a +1 bonus to their AC and on Reflex saves until the start of your next turn. At character level 4th and at every four levels thereafter, this penalty increases by -1 and the bonuses granted increase by +1.`,
            prereq: "",
        },
        {
            name: "Silver Crane Feathers",
            type: "style",
            shortDesc: "",
            longDesc: `Whenever an ally within 30 feet would take ability damage or hit point damage, you can expend a readied counter of at least 3rd level as an immediate action to take the damage in place of that ally. This is a supernatural ability. The ally also heals hit points equal to 1/4 of your <light> mastery.`,
            prereq: "Silver Crane Style",
        },
        {
            name: "Silver Crane Wing",
            type: "style",
            shortDesc: "",
            longDesc: `When you use your Silver Crane Feathers feat you can make a Will save (DC equal to the ability damage dealt + the hit point damage dealt). If you succeed, the damage is negated rather than being redirected to you, However if you use this feature the maneuver is unavailable forever.`,
            prereq: "Silver Crane Feathers",
        },
        {
            name: "Sleeping Goddess Style",
            type: "style",
            shortDesc: "",
            longDesc: `You can spend an additional 1 spell point on sleeping goddess maneuvers, +1 for each feat in this chain you have (even if you're not in this style). You can gain psionic focus as a standard action. When you do, you recover spell points equal to the cost of a sleeping goddess maneuver you know. You can only do this during combat, and you can still use this ability if you already have psionic focus.`,
            prereq: "",
        },
        {
            name: "Sleeping Goddess Slumber",
            type: "style",
            shortDesc: "",
            longDesc: `Whenever you hit a creature with an attack, you can expend your psionic focus as a free action. If you do, that creature must succeed at a Will save (DC = 10 + 1/2 your character level + initiation modifier) or become confused for one round. A creature that successfully saves cannot be affected by this feat for 24 hours. This is a supernatural ability.`,
            prereq: "Sleeping Goddess Style",
        },
        {
            name: "Sleeping Goddess Strike",
            type: "style",
            shortDesc: "",
            longDesc: `Whenever you hit an opponent with an attack, they take a -2 penalty on saving throws against your maneuvers until the end of their next turn.`,
            prereq: "Sleeping Goddess Slumber",
        },
        {
            name: "Solar Wind Style",
            type: "style",
            shortDesc: "",
            longDesc: `Your ranged attacks deal 1 point of additional fire damage. At character level 4th and at every four levels thereafter, this damage increases by 1. In addition, once per turn when you hit a creature with a ranged attack, you can choose to have your target become outlined as if by a faerie fire spell for the rest of the round, with a caster level equal to your initiator level. Successive uses of this ability against the same creature do not stack; or extend the duration. You can suppress or resume the light on an affected creature you can see as a free action. This is a supernatural ability.`,
            prereq: "",
        },
        {   
            name: "Solar Wind Flash",
            type: "style",
            shortDesc: "",
            longDesc: `Whenever you hit a creature with a ranged attack, you can expend one of your readied boosts as a swift action. If you do, that creature must succeed at a Fortitude save (DC = 10 + maneuver level + your highest initiation modifier) or become blinded for one round. This is a supernatural ability. A maneuver expended this way becomes unavailable for the rest of the floor.`,
            prereq: "Solar Wind Style",
        },
        {
            name: "Solar Wind Inferno",
            type: "style",
            shortDesc: "",
            longDesc: `Your ranged attacks ignore up to your character level in fire resistance. In addition, you can deal fire damage to creatures that are immune to fire, treating their immunity as fire resistance 30 for the purposes of this feat and dealing damage to them.`,
            prereq: "Solar Wind Flash",
        },
        {
            name: "Steel Serpent Style",
            type: "style",
            shortDesc: "",
            longDesc: `Whenever you hit a creature with a Steel Serpent maneuver, that creature takes a -1 penalty on attack rolls and to their AC for two rounds. At character level 4th and at every four levels thereafter, this penalty increases by -1. When you damage a creature that is already affected by this, you deal additional precision damage on the attack equal to 1 per 15 <dark> mastery. This damage increases to 1 per 10 <dark> mastery if the attack is another steel serpent maneuver.`,
            prereq: "",
        },
        {
            name: "Steel Serpent Fangs",
            type: "style",
            shortDesc: "",
            longDesc: `As a swift action, you can expend a readied boost of at least 4th level to treat opponents suffering from ability damage as flat-footed until the start of your next turn.`,
            prereq: "Steel Serpent Style",
        },
        {
            name: "Steel Serpent Venom",
            type: "style",
            shortDesc: "",
            longDesc: `Whenever you deal weapon damage to a creature suffering from ability score damage, that creature must succeed at a Fortitude save (DC = 10 + 1/2 level + initiation modifier) or become nauseated for one round. Once a creature saves from this feat, it becomes immune to it for 1 round. Multiple uses of this effect do not stack, nor do they increase the duration. The DC increases by +1 per 30 <dark> mastery.`,
            prereq: "Steel Serpent Fangs",
        },
        {
            name: "Tempest Gale Style",
            type: "style",
            shortDesc: "",
            longDesc: `You can make bull rush, dirty trick, disarm, and trip attempts using a ranged weapon against any target within your first range increment. Attempting a combat maneuver in this way is a standard action that provokes an attack of opportunity (unless you have the appropriate improved combat maneuver feat). You use your Dexterity modifier instead of your Strength modifier for determining your combat maneuver bonus for these attempts. You gain a +1 bonus on these checks per 30 <air> mastery.`,
            prereq: "",
        },
        {
            name: "Tempest Gale Haze",
            type: "style",
            shortDesc: "",
            longDesc: `Ranged attacks against you suffer a 20% miss chance. This increases by 1% per 5 <air> mastery.`,
            prereq: "Tempest Gale Style",
        },
        {
            name: "Tempest Gale Storm",
            type: "style",
            shortDesc: "",
            longDesc: `You can make two different ranged combat maneuver attempts with your Tempest Gale Style feat against a single target as a standard action. You only provoke attacks of opportunity once when doing so.`,
            prereq: "Tempest Gale Haze",
        },
        {
            name: "Thrashing Dragon Style",
            type: "style",
            shortDesc: "",
            longDesc: `Once per round, when you make an attack as a standard action or attack action, you can make an additional attack with another weapon as a free action. This attack is made at your highest base attack bonus, although you take the penalties for fighting with two weapons as normal. You gain a +1 bonus on damage when making attacks with two weapons per 20 <flurry> mastery.`,
            prereq: "",
        },
        {
            name: "Thrashing Dragon Pounce",
            type: "style",
            shortDesc: "",
            longDesc: `Whenever you initiate a strike that requires you to make only single melee attack, you can make an additional attack with another weapon as a free action. This attack is made at your highest base attack bonus, although you take the penalties for fighting with two weapons as normal. This attack does not gain any of the benefits of the strike you initiated.`,
            prereq: "Thrashing Dragon Style",
        },
        {
            name: "Thrashing Dragon Whirlwind",
            type: "style",
            shortDesc: "",
            longDesc: `As a full-round action, you can make one melee attack with a weapon in your main hand and a weapon in your off hand against each opponent within reach. This attack is made at your highest base attack bonus, and you do not take the penalties for fighting with two weapons on these attacks.`,
            prereq: "Thrashing Dragon Pounce",
        },
        {
            name: "Veiled Moon Style",
            type: "style",
            shortDesc: "",
            longDesc: `Whenever you move, you can treat up to 10 feet of that movement as teleportation. This teleportation may be taken at any point during your movement, and cannot exceed the total movement you would normally be allowed to make. You must have line of sight to your destination, and cannot teleport into an occupied space. This is a supernatural ability.

            Special: You can use this feat to bypass a 5 feet worth of obstacles when making a charge; you treat a square you bypass as empty for the purposes of determining if you can charge your target.`,
            prereq: "",
        },
        {
            name: "Veiled Moon Shunt",
            type: "style",
            shortDesc: "",
            longDesc: `Once per round, when you hit with an attack, you can expend a readied maneuver of at least 4th level as a free action to forcibly teleport your target. That creature must succeed at a Will save (DC 10 + expended maneuver's level + initiation modifier) or be teleported to any unoccupied space within 30 feet of them that you can see. You need not teleport them to a location that can support them; you can teleport them into the air, into difficult terrain, or into dangerous situations as you see fit. This is a supernatural ability, and is considered a Veiled Moon maneuver for the purposes of save DCs and abilities such as the Discipline Focus feat.`,
            prereq: "Veiled Moon Style",
        },
        {
            name: "Veiled Moon Warp",
            type: "style",
            shortDesc: "",
            longDesc: `As a standard action, you may expend one of your readied strikes and make a melee attack against an opponent. If it hits, deal weapon damage as normal and the target must succeed at a Will save (DC 10 + expended maneuver's level + your highest initiation modifier) or become incorporeal for one round. The target can no longer grasp their weapons (unless they could be wielded by incorporeal creatures) but their other equipment remains on their body without becoming incorporeal, effectively rendering them incapable of using any items that do not have the ghost touch property or an equivalent effect. This is a supernatural ability. Maneuvers expended this way becomes unavailable for the rest of the floor.`,
            prereq: "Veiled Moon Shunt",
        },
        {
            name: "Scorpion Style",
            type: "style",
            shortDesc: "",
            longDesc: `To use this feat, you must make a single melee attack as a standard action. If this attack hits, you deal damage normally, and the target's base land speed is reduced to 5 feet for a number of rounds equal to your highest mental modifier unless it makes a Fortitude saving throw (DC 10 + 1/2 level + highest mental modifier).`,
            prereq: "",
        },
        {
            name: "Gorgon's Fist",
            type: "style",
            shortDesc: "",
            longDesc: `As a standard action, make a single melee attack against a foe whose speed is reduced (such as from Scorpion Style). If the attack hits, you deal damage normally and the target is staggered until the end of your next turn unless it makes a Fortitude saving throw (DC 10 + 1/2 level + your highest mental modifier). This feat has no effect on targets that are staggered.`,
            prereq: "Scorpion Style",
        },
        {
            name: "Medusa's Wrath",
            type: "style",
            shortDesc: "",
            longDesc: `Whenever you use the full-attack action and make at least one unarmed strike, you can make two additional unarmed strikes at your highest base attack bonus. These bonus attacks must be made against a dazed, flat-footed, paralyzed, staggered, stunned, or unconscious foe.`,
            prereq: "Gorgon's Fist",
        },
        {
            name: "Cockatrice Strike",
            type: "style",
            shortDesc: "",
            longDesc: `As a full-round action, you can make a single unarmed strike against a dazed, flat-footed, paralyzed, staggered, stunned, or unconscious foe. If that attack is a critical hit, the target is petrified unless it succeeds on a Fortitude saving throw with a DC of 10 + 1/2 level + highest mental modifier. This is a supernatural polymorph effect.`,
            prereq: "Medusa's Wrath",
        },





        {
            name: "Shield Wall",
            type: "teamwork",
            shortDesc: "",
            longDesc: `Whenever you are wielding a shield and are adjacent to an ally wielding a shield who also has this feat, the AC bonus from your shield increases, depending on the shield wielded by your ally.

            If your ally's shield gives a base +1 shield bonus, your shield bonus increases by +1,
            If your ally is wielding a shield that gives more than +1 but less than +5 base, your shieled bonus increase by +2,
            and if its +5 or more base, your shieled bonus increase by +3.
            You keep these bonuses even if your ally loses his shield bonus due to making a shield bash attack.
            
            If an adjacent ally with this feat uses a shield to grant total cover, you also benefit if an attack targeting you passes through the edge of the shield.`,
            prereq: "",
        },



        {
        name: "Blood Frenzy Style",
        type: "style",
        shortDesc: "",
        longDesc: `While you are using Blood Frenzy Style, you gain a +2 bonus to your Strength and Constitution, and you take a -2 penalty to AC. You can enter Blood Frenzy Style only as an immediate action when you take damage. You cannot enter this style as a swift action, as with other style feats.`,
        prereq: "",
        },
        {
            name: "Blood Frenzy Strike",
            type: "style",
            shortDesc: "",
            longDesc: `While you are using Blood Frenzy Style, when you damage an opponent with your unarmed strikes, natural attacks or light or two handed slashing weapons, you deal an extra 1d6 points of bleed damage; this bleed damage does not stack with itself. Once every 1d4 rounds when making an with one of those weapons you can choose to take a -5 penalty to the attack; if you hit, you deal an additional 2d6 points of bludgeoning damage.`,
            prereq: "Blood Frenzy Style",
        },
        {
            name: "Blood Frenzy Assault",
            type: "style",
            shortDesc: "",
            longDesc: `While you are using Blood Frenzy Style, when you make a full attack, you can make an additional unarmed or natural weapon attack for each enemy within your reach that is affected by a bleed effect. Until your next turn, you take a -2 penalty to AC for each additional attack gained in this way. In addition, the bleed damage your unarmed strikes deal from Blood Frenzy Strike increases to 2d6 points of bleed damage.`,
            prereq: "Blood Frenzy Strike",
        },
        {
            name: "Barracuda Style",
            type: "style",
            shortDesc: "",
            longDesc: `Your melee attacks deal normal damage underwater, and you don't take penalties on attack rolls with melee attacks made underwater. You add your highest mental modifier in addition to your Strength modifier on Swim checks.`,
            prereq: "",
        },
        {
            name: "Barracuda Slam",
            type: "style",
            shortDesc: "",
            longDesc: `As a movement action you can roll a swim check and move up to that many feet, plus any additional enhancement bonus to your movement speed, you move half the check if wearing medium or heavy armor. This is all normal movement and follows all normal restrictions and penalties, but you can also do it while swimming. You can also as a full round action make a charge attack, moving up to twice your swim speeds check, but following all charge rules. When you charge this way you first attack on a charge deals an additional half of your strength mod (or whichever ability score you use to deal damage).`,
            prereq: "Barracuda Style",
        },
        {
            name: "Barracuda Dash",
            type: "style",
            shortDesc: "",
            longDesc: `You gain a swim speed equal to your base speed. When you attack on a charge in water or on land and the attack hits, you can immediately make a second charge attack against a second opponent. All the normal requirements for making a charge, such as moving at least 10 feet and moving in a straight line, apply to this second attack. The total distance of the two charge attacks cannot exceed the normal maximum distance for a charge (usually double your speed).

            The movement, including leaving the first target's threatened area, provokes attacks of opportunity as normally. You cannot use pounce or other abilities that grant extra attacks on your turn if you use Barracuda Dash to make a second attack.`,
            prereq: "Barracuda Slam",
        },
        {
            name: "Electric Eel Style",
            type: "style",
            shortDesc: "",
            longDesc: `Elemental Fist and its upgraded versions costs 1 less spell point. While you are in this style, your Elemental Fist attack deals electricity damage. When a creature takes electricity damage from your Elemental Fist attack, you gain a +4 bonus for 1 round on combat maneuver checks to grapple the creature.`,
            prereq: "Elemental Fist",
        },
        {
            name: "Electric Eel Shock",
            type: "style",
            shortDesc: "",
            longDesc: `Elemental Fist and its upgraded versions costs 1 less spell point. Creatures that take electricity damage from your Elemental Fist attack must succeed at a Fortitude save (DC 10 + half your character level + your highest mental modifier) or be staggered for 1 round. This also applies to creatures that take electricity damage from your Electric Eel Conduit feat while grappled.`,
            prereq: "Electric Eel Style",
        },
        {
            name: "Electric Eel Conduit",
            type: "style",
            shortDesc: "",
            longDesc: `Elemental Fist and its upgraded versions costs 1 less spell point. When you successfully grapple a creature, you may expend two uses of Elemental Fist as a swift action to set up an electric charge between yourself and the creature. If you do, the target takes electricity damage equal to 1d6 plus your highest menal modifier each round you maintain the grapple. This damage ceases when you are no longer grappling the target.`,
            prereq: "Electric Eel Shock",
        },
        {
            name: "Djinni Style",
            type: "style",
            shortDesc: "",
            longDesc: `Elemental Fist and its upgraded versions costs 1 less spell point. While you are in this style you must use Elemental Fist to deal electricity damage and you gain a bonus on electricity damage rolls equal to your highest mental bonus. Further, while you are using this style and have more than level spell points, you also gain a +2 dodge bonus to Armor Class against attacks of opportunity. A condition that makes you lose your Dexterity bonus to AC also makes you lose this dodge bonus.`,
            prereq: "Elemental Fist",
        },
        {
            name: "Djinni Spirit",
            type: "style",
            shortDesc: "",
            longDesc: `Elemental Fist and its upgraded versions costs 1 less spell point. While using Djinni Style, you gain electricity resistance equal to your base attack bonus or level, whichever is higher. While denied your Dexterity bonus to AC you are also denied this resistance. Creatures that take electricity damage from your Elemental Fist attack must succeed at a Fortitude save (DC 10 + 1/2 level + highest mental modifier) or be deafened for 1d4 rounds.`,
            prereq: "Djinni Style",
        },
        {
            name: "Djinni Spin",
            type: "style",
            shortDesc: "",
            longDesc: `While using Djinni Style, as a standard action you can spend 8 spell points to surround yourself with a whirlwind of electrified air. Creatures adjacent to you take your unarmed strike damage plus the electricity damage from your Elemental Fist and are deafened for 1d4 rounds. A successful Fortitude save (DC 10 + 1/2 level + highest mental modifier) reduces the damage by half.`,
            prereq: "Djinni Spirit",
        },
        {
            name: "Djinni Whirlwind",
            type: "style",
            shortDesc: "",
            longDesc: `When using Djinni Spin you instead damage all creatures within your reach, and the fortitude DC is increased by +4.`,
            prereq: "Djinni Spirit",
        },
        {
            name: "Dwarven Hatred Style",
            type: "style",
            shortDesc: "",
            longDesc: `Against creatures 2 size categories or larger than you, you gain a +2 bonus on attack and damage rolls.`,
            prereq: "",
        },
        {
            name: "Dwarven Seething",
            type: "style",
            shortDesc: "",
            longDesc: `While using Dwarven Hatred Style, when an opponent hits you with an attack (including a spell that requires an attack roll), you can choose to gain a +2 dodge bonus to armor class, or a +2 bonus to attack and damage against them (regardless of the opponent's size), as an immediate action.

            This ability lasts until the opponent dies, the combat ends, you change styles, or you designate a different opponent or bonus with this ability, whichever occurs first.`,
            prereq: "Dwarven Hatred Style",
        },
        {
            name: "Dwarven Fury",
            type: "style",
            shortDesc: "",
            longDesc: `When using Dwarven Seething, the ability no longer ends when you designate a different opponent or activate a different bonus with the ability.`,
            prereq: "Dwarven Seething",
        },
        {
            name: "Unbridled Dwarven Rage",
            type: "style",
            longDesc: `If you have already activated Dwarven Seething on a creature, you can keep activating it increasing one of the bonuses (the dodge bonus, or the attack and damage) you are currently getting against it by +1.`,
            prereq: "Dwarven Fury",
        },
        {
            name: "Earth Child Style",
            type: "style",
            longDesc: `When using this style you gain a +2 dodge bonus to armor class and you can add your highest mental stat/2 as a bonus to damage with unarmed and bludgeoning weapons against creatures 2 or more size categories larger than you.`,
            prereq: "",
        },
        {
            name: "Earth Child Topple",
            type: "style",
            longDesc: `You can trip a creature up to 2 size categories larger than you. While using Earth Child Style, you add your highest mental bonus on combat maneuver checks made to trip creatures 1 size category larger than you, as well as on attack rolls to confirm a critical hit against creatures 2 size categories larger than you.`,
            prereq: "Earth Child Style",
        },
        {
            name: "Earth Child Binder",
            type: "style",
            longDesc: `You can trip a creature no matter its size. While you are using Earth Child Style, when a prone of 2 size categories larger than you stands up and provokes an attack of opportunity from you, if you make an unarmed strike or an attack with a bludgeoning weapon, you can roll damage as if you had added vital strike to the attack (you dont need vital strike to use this). If you have feats from the vital strike chain you can also add those.`,
            prereq: "Earth Child Topple",
        },
        {
            name: "Efreeti Style",
            type: "style",
            longDesc: `Elemental Fist and its upgraded versions costs 1 less spell point. While using this style and Elemental Fist to deal fire damage, you gain a bonus on fire damage rolls equal to your highest mental bonus. Further, if your Elemental Fist melee attack misses while you are using it to deal fire damage, you still deal 1d6 points of fire damage to your target.`,
            prereq: "Elemental Fist",
        },
        {
            name: "Efreeti Stance",
            type: "style",
            longDesc: `Elemental Fist and its upgraded versions costs 1 less spell point. While using Efreeti Style, you gain fire resistance equal to your base attack bonus or your monk level plus any base attack bonus gained from levels in classes other than monk, whichever is higher. While denied your Dexterity bonus to AC you are also denied this resistance. Creatures that take fire damage from your Elemental Fist attack must succeed at a Reflex save (DC 10 + 1/2 level + highest mental modifier) or catch on fire.`,
            prereq: "Efreeti Style",
        },
        {
            name: "Efreeti Touch",
            type: "style",
            longDesc: `While using Efreeti Style, as a standard action, you can spend 8 spell points to unleash a 15-foot cone-shaped burst of flame. Creatures caught in the cone take your unarmed strike damage plus the fire damage from your Elemental Fist and catch on fire. A successful Reflex save (DC 10 + 1/2 level + highest mental modifier) reduces the damage by half and prevents a target from catching on fire.`,
            prereq: "Efreeti Stance",
        },
        {
            name: "Efreeti Burst",
            type: "style",
            longDesc: `While using Efreeti Touch your cone is instead 30 feet and the reflex save DC is increased by +4.`,
            prereq: "Efreeti Touch",
        },
        {
            name: "Kyton Style",
            type: "style",
            longDesc: `When using this style, you treat Whips and chains as if they were unarmed weapons while using flurry of blows.`,
            perkPrereq: ["Flurry of Blows"],
        },
        {
            name: "Kyton Shield",
            type: "style",
            longDesc: `When using Kyton Style, you gain a +1 shield bonus to your Armor Class as long as you are wielding a chain or whip. If it is magical, add 1/2 its enhancement bonus to this shield bonus. If the spiked chain has the vicious ability, instead add its full enhancement bonus to the shield bonus.`,
            prereq: "Kyton Style",
        },
        {
            name: "Kyton Cut",
            type: "style",
            longDesc: `When using Kyton Style, your spiked or whip attacks can be brutal, both to yourself and your foe. Before attempting an attack roll with one, you can choose to make a Kyton Cut. Before making the attack, you take 1d6 points of nonlethal damage. This damage cannot be avoided or reduced in any way. If you are immune to nonlethal damage, you take normal damage instead. If the attack hits, its target takes an additional 1d6 points of nonlethal damage and a -4 penalty on concentration checks for 1 round. The penalty is a pain effect.`,
            prereq: "Kyton Shield",
        },
        {
            name: "Marid Style",
            type: "style",
            longDesc: `Elemental Fist and its upgraded versions costs 1 less spell point. While using this style and Elemental Fist to deal cold damage, you gain a bonus on cold damage rolls equal to your highest mental modifier, and your reach with melee attacks increases by 5 feet.`,
            prereq: "Elemental Fist",
        },
        {
            name: "Marid Spirit",
            type: "style",
            longDesc: `Elemental Fist and its upgraded versions costs 1 less spell point. While using Marid Style, you gain cold resistance equal to your base attack bonus, or level. While denied your Dexterity bonus to AC you are also denied this resistance. Creatures that take cold damage from your Elemental Fist attack must succeed at a Fortitude save (DC 10 + 1/2 level + highest mental modifier) or become entangled in ice for 1d4 rounds. The ice has hit points equal to three times your base attack bonus level, whichever is higher, and a break DC of 15 + your base attack bonus or level, whichever is higher. Destroying or breaking the ice ends the entangled condition.`,
            prereq: "Marid Style",
        },
        {
            name: "Marid Coldsnap",
            type: "style",
            longDesc: `While using Marid Style, as a standard action, you can spend 8 spell points to unleash a 30-foot line of frigid water. Creatures caught in the line take your unarmed strike damage plus the cold damage from your Elemental Fist attack and are entangled in ice as per the Marid Spirit feat. A successful Reflex save (DC 10 + 1/2 level + highest mental modifier) reduces the damage by half and prevents a target from becoming entangled.`,
            prereq: "Marid Spirit",
        },
        {
            name: "Marid Blizzard",
            type: "style",
            longDesc: `While using Marid Coldsnap, the line of cold increases to 60 feet.`,
            prereq: "Marid Coldsnap",
        },
        {
            name: "Shaitan Style",
            type: "style",
            longDesc: `Elemental Fist and its upgraded versions costs 1 less spell point. While using the Shaitan Style and Elemental Fist feats to deal acid damage, you gain a bonus on acid damage rolls equal to your highest mental bonus. Further, if your Elemental Fist melee attack misses while you are using it to deal acid damage, you still deal 1d6 points of acid damage to your target.`,
            prereq: "Elemental Fist",
        },
        {
            name: "Shaitan Skin",
            type: "style",
            longDesc: `Elemental Fist and its upgraded versions costs 1 less spell point. While using the Shaitan Style feat, you gain acid resistance equal to your base attack bonus, or your level, whichever is higher. While denied your Dexterity bonus to AC you are also denied this resistance. Creatures that take acid damage from your Elemental Fist attack must succeed at a Reflex save (DC 10 + 1/2 level + highest mental modifier) or be staggered for 1 round.`,
            prereq: "Shaitan Style",
        },
        {
            name: "Shaitan Earthblast",
            type: "style",
            longDesc: `While using the Shaitan Style feat, as a standard action, you can spend 8 spell points to unleash a 20-foot column of acid that has a 5-foot radius and erupts from a point of origin within 30 feet of you. Creatures caught in the column take your unarmed strike damage plus the acid damage from your Elemental Fist and are staggered for 1 round. A successful Reflex save (DC 10 + 1/2 level + highest mental modifier) reduces the damage by half and prevents a target from being staggered.`,
            prereq: "Shaitan Skin",
        },
        {
            name: "Shaitan Erruption",
            type: "style",
            longDesc: `While using the Shaitan Earthblast the column becomes 40-foot high and has a 10 foot radius.`,
            prereq: "Shaitan Earthblast",
        },
        {
            name: "Sword and Sorcery Style",
            type: "style",
            longDesc: `When you cast a spell while in this style you can also charge a single weapon you are wielding, your next attack with it before the end of your next turn deals bonus damage equal to the level of the spell.`,
            prereq: "",
        },
        {
            name: "Sword and Sorcery Rend",
            type: "style",
            longDesc: `When in sword and sorcery style if you cast a spell on a creature you have damaged with a weapon attack since the start of your last turn, they receive a -2 to the initial save it has to make against the spell, or you count as two levels higher for the damage done to them, your choice. This extra damage goes above the normal damage limit on a spell. If this creature was damaged by the bonus damage granted from sword and sorcery style the penalty increases to -3, or the level bonus change to +3.`,
            prereq: "Sword and Sorcery Style",
        },
        {
            name: "Sword and Sorcery Obliteration",
            type: "style",
            longDesc: `When in sword and sorcery style when you reduce a creature below 0 hit points with a spell you can make a weapon attack against a creature within reach and 30ft (whichever is closer) as a immediate action.`,
            prereq: "Sword and Sorcery Rend",
        },
        // {
        //     name: "Wandmage Style",
        //     type: "style",
        //     longDesc: ``,
        //     prereq: "",
        // },
        {
            name: "Wyvern Fury Style",
            type: "style",
            longDesc: `While using this style you can treat light slashing and piercing weapons and whips and chains as unarmed strikes while using flurry of blows. Only one of these attacks can be with a whip or chain.`,
            prereq: "",
            perkPrereq:["Flurry of Blows"]
        },
        {
            name: "Wyvern Sting",
            type: "style",
            longDesc: `While using Wyvern Fury Style, if you successfully attack a foe with a whip or scorpion whip, as a swift action you can choose one ally. Until the beginning of your next turn, that ally can leave spaces threatened by that foe without provoking an attack of opportunity from the foe.`,
            prereq: "Wyvern Fury Style",
        },        
        {
            name: "Wyvern Wing",
            type: "style",
            longDesc: `While using the Wyvern Fury Style feat, if you use flurry of blows and take a 5-foot step, you can take an additional 5-foot step. You can take this extra 5-foot step only between two attacks in your flurry, but you can take both your 5-foot steps consecutively without making an attack between them.`,
            prereq: "Wyvern Sting",
        },
        {
            name: "Esoteric Abjuration",
            type: "magic",
            longDesc: `When using a buff spell,  you can grant a single target of that spell a +1 competence bonus on its Fortitude, Reflex, or Will saving throws for the duration of the spell. The spell must have a duration measured in rounds or minutes, and a creature can benefit from no more than one bonus from this feat at a time. Treat your caster level as 1 higher for buff spells.`,
            prereq: "",
        },
        {
            name: "Esoteric Conjuration",
            type: "magic",
            longDesc: `When casting a spell that summons a creature, select one creature summoned, called, or moved from another plane by your spell. For 1 round, that creature hasn't fully phased onto the current plane, causing all attacks against it to suffer a 20% miss chance (attacks without attack rolls deal 20% less damage). You count as 2 levels higher for the duration of such spells.`,
            prereq: "",
        },
        {
            name: "Esoteric Enchantment",
            type: "magic",
            longDesc: `When casting a control spell, pick one creature who fails a save against the spell, they take a -2 penalty to your choice of ability checks, attack rolls, damage rolls, saving throws, or skill checks for 1 round. A creature can be affected by only one penalty from this feat at a time. This is a mind-affecting effect. Increase the DC's of your control spells by +1`,
            prereq: "",
        },
        {
            name: "Esoteric Evocation",
            type: "magic",
            longDesc: `When you cast a damage spell you can damage one creature adjacent to you. This deals 1 point of damage per caster level, and matches the damage type of your spell. You count as one level higher for the effects of damage spells. This also increases a spells maximum damage dice.`,
            prereq: "",
        },
        {
            name: "Esoteric Necromancy",
            type: "magic",
            longDesc: `When you cast a control spell, one target of that spell becomes shaken. If your spell allows a saving throw and the target succeeds at its save, it is unaffected by this effect. If the spell causes the target to become shaken or frightened, this effect doesn't increase the severity of that condition (so a spell that frightens a creature wouldn't instead cause it to become panicked due to this feat). This is a mind-affecting fear effect. When a creature fails a saving throw against one of your control spells, or takes damage from one, they take an additional 1d6 negative energy damage.`,
            prereq: "",
        },
        {
            name: "Esoteric Transmutation",
            type: "magic",
            longDesc: `When you cast a spell that changes your shape, such as enlarge person, or dragon form, you can choose to gain a +2 bonus to attack rolls, ability checks, or skill checks Your choice. This bonus lasts until the end of your next turn. When under the effects of such spells, you can also gain a +1 bonus to strength, dexterity, or constitution, your choice when you cast the spell.`,
            prereq: "",
        },
        {
            name: "Esoteric Illusion",
            type: "magic",
            longDesc: `When under the effects of a spell that uses an illusion to grant a bonus to armor class or a miss chance (such as blur, mirror image, or invisibilty), you gain a +2 bonus to your armor class.`,
            prereq: "",
        },
        {
            name: "Unstoppable Esotery",
            type: "magic",
            longDesc: `When you cast a spell that would be modified by another feat with "Esoteric" in the name, increase your caster level by 2 for it, and gain a +2 to concentration checks for the spell. If you have two feats that modify a single spell this feat stacks.`,
            prereq: "",
        },
        {
            name: "Shielded Mage",
            type: "magic",
            longDesc: `Using a shield does not prevent you from completing somatic spell components with the hand wielding the shield. Gain your shields base bonus to armor class as a bonus to concentration checks when casting defensively. When using a shield that already didn't stop you from completing somatic components, gain a +1 bonus to the shields armor bonus when you cast a spell for 1 round.`,
            prereq: "",
        },
        {
            name: "Circling Mongoose",
            type: "martial",
            longDesc: `When you are adjacent to a foe, as a full-round action, you can take a full-attack action to make melee attacks against the foe, moving 5 feet before each attack. You must move 5 feet before each melee attack you make, and can't exceed your maximum speed, exceed your maximum number of attacks in a round, or attack any other target until the beginning of your next turn.

            You must remain adjacent to the foe, and your movement provokes attacks of opportunity as normal unless you succeed at the appropriate Acrobatics checks. If your first attack against the foe hits, you are considered to be flanking the foe on your second attack. Subsequent attacks made as part of the full-attack action continue to be treated as if you were flanking the foe until one of your attacks misses, at which point your attacks are treated normally.`,
            prereq: "",
        },        
        {
            name: "Shadows Of Fear",
            type: "martial",
            longDesc: `The first time each round that you hit a creature suffering from a fear effect, you can deal hidden strike or sneak attack damage as if you were flanking that creature (improved uncanny dodge and other effects that prevent flanking also prevent a hidden strike or sneak attack from this feat). Gain 1d6 sneak attack damage against creatures suffering from a fear affect.`,
            prereq: "",
        },
        {
            name: "Artful Dodge",
            type: "martial",
            longDesc: `If you are the only character threatening an opponent, you gain a +2 dodge bonus to AC against that opponent.`,
            prereq: "",
        },
        {
            name: "Baneful Judgement",
            type: "martial",
            longDesc: `You can declare a specialized judgment against a creature as a swift action. When pronouncing this judgment, you attempt a Knowledge check to identify the creature, or refer to your previous result if you've already identified the creature. If you succeed at the check or have already identified the creature, you can spend 1 use of judgement and choose one judgment other than the healing judgment. You gain the benefits of this judgment against that creature for only 1 round plus 1 additional round for every 5 by which you exceeded the DC to identify the target. Subsequent uses of this judgment do not stack with this ability. A creature cannot be the target of this ability again for 24 hours.`,
            prereq: "",
            perkPrereq:["Judgement"],
        },
        {
            name: "Rat Wacker",
            type: "martial",
            longDesc: `You gain a +2 bonus on melee attack rolls against creatures smaller than you.`,
            prereq: "",
        },
        {
            name: "Rat Smasher",
            type: "martial",
            longDesc: `You gain a +2 bonus on melee attack rolls against creatures smaller than you. This stacks with Rat Wacker`,
            prereq: "Rat Wacker",
        },
        {
            name: "Advanced Defensive Combat Training",
            type: "utility",
            longDesc: `You gain a +4 bonus to your CMD.`,
            prereq: "",
        },
        {
            name: "Master Defensive Combat Training",
            type: "utility",
            longDesc: `You gain a +4 bonus to your CMD.`,
            prereq: "Advanced Defensive Combat Training",
        },
        {
            name: "Aerial Roll",
            type: "utility",
            longDesc: `You can perform a defensive roll while in the air. As an immediate action, you can attempt a Fly check when you are attacked while flying. If the result of the check is greater than the result of the attack roll, you dodge the attack, causing it to miss automatically. Whether you succeed or fail at the Fly check, the barrel roll leaves you off-balance and vulnerable, causing you to take a -10 penalty on Fly checks until the end of your next turn.`,
            prereq: "",
        },
        {
            name: "Aldori Style",
            type: "style",
            longDesc: `While using Aldori Style and wielding only a single sword in one hand (not using a shield, an off-hand weapon, armor spikes, unarmed strikes, or natural weapons), when you fight defensively or use Combat Expertise, you gain a +2 bonus on weapon damage rolls.`,
            prereq: "",
        },
        {
            name: "Aldori Aegis",
            type: "style",
            longDesc: `While using Aldori Style, at the beginning of your turn, you can designate a focused target as a swift action. This designation lasts until the beginning of your next turn, and you take a -2 penalty to your AC against all other creatures' attacks for that duration. As an immediate action while using Combat Expertise or fighting defensively, you can attempt to parry the focused target's attack. This functions as the swashbuckler's opportune parry and riposte deed (Pathfinder RPG Advanced Class Guide 57), except that it does not cost panache and you cannot riposte.`,
            prereq: "Aldori Style",
        },
        {
            name: "Aldori Conquest",
            type: "style",
            longDesc: `When you attempt to parry an attack using Aldori Style Aegis, you do not take any penalties on the attack roll incurred from using Combat Expertise or fighting defensively.`,
            prereq: "Aldori Aegis",
        },
        {
            name: "Heely Style",
            type: "style",
            longDesc: `You can only maintain this style while wearing heelys. While running using heely's, you can make a single attack at your highest bonus along the way, and you can make an acrobatics checks to move through enemy creatures.`,
            prereq: "",
        },
        {
            name: "Heely Stylish",
            type: "style",
            longDesc: `While using heely style, you can instead make two attacks each against a different creature while running, and you can make acrobatics checks DC 10 + 5x the amount of squares that would be difficult terrain to move through difficult terrain. Additionally you can make an additional 90 degree turn while running with heely's.`,
            prereq: "Heely Style",
        },
        {
            name: "Heely Trick Master",
            type: "style",
            longDesc: `While using heely style, you can instead make three attacks while running, you must attack at least two different creatures along the way to make three attacks, and if you have any bonus attacks because of shot on the run, or improved or greater Spring Attack (or something that would modify any of those feats), you can take those as well. Additionally, if you use an acrobatics check to move through difficult terrain or a creature, you can increase the DC by 10, if you do you gain a +1 bonus to any attack made for the rest of your run, if you made it against a creature, it is +4 against the creature you moved through, and +2 for the rest of the attacks. The bonuses from moving through terrain and creatures stack with each other, but not themselves.`,
            prereq: "Heely Stylish",
        },
        {
            name: "Black Smoke Energy Style",
            type: "style",
            longDesc: `You can only maintain this style while wearing Black Air Force 1s. The bonus you gain from Black Air Force 1s increases by an additional +1 to attack, and -2 to armor class, and you instead gain an additional 5 bonus feet to your base movement speed. For each additional feat you have in this chain increase these bonuses and penalties by the same amount again.`,
            prereq: "",
        },
        {
            name: "Black Smoke Energy Rage",
            type: "style",
            longDesc: `You can instead apply the bonus attack from Black Smoke Energy Style and Black Air Force 1s to damage while charging.`,
            prereq: "Black Smoke Energy Style",
        },
        {
            name: "Black Smoke Energy Berserk",
            type: "style",
            longDesc: `If you reduce a creature below 0 hit points and knock them out and kill them while making a charge attack, you can make an additional charge attack. All the normal requirements for making a charge, such as moving at least 10 feet and moving in a straight line, apply to this second attack. The total distance of the two charge attacks (and any more made) cannot exceed the normal maximum distance for a charge (usually double your speed). As long as you keep killing creatures you can keep making charge attacks, however You cannot use pounce or other abilities that grant extra attacks on your turn if you use black smoke berserk to make a second charge attack.`,
            prereq: "Black Smoke Energy Rage",
        },
        {
            name: "Shinigami Style",
            type: "style",
            longDesc: `This styles benefits do not work with unarmed attacks. When you reduce an opponent to 0 or fewer hit points with a melee weapon attack or kill them outright with a coup de grace, you can use a free action to move up to 10 feet. This movement does not provoke attacks of opportunity. If you take this action, you gain a +2 bonus to attack rolls and a +2 dodge bonus to AC until the end of your next turn. This bonus does not stack.`,
            prereq: "",
        },
        {
            name: "Shinigami Reap",
            type: "style",
            longDesc: `You no longer provoke attacks of opportunity when performing a coup de grace when using a scythe.

            When making an attack that allows you to attack multiple creatures as one action, such as whirlwind attack, cleave, or many strikes, you treat your reach as if it was 5 feet longer, and you don't take attack penalties from power attack when making such attacks.`,
            prereq: "Shinigami Style",
        },
        {
            name: "Shinigami Pursuit",
            type: "style",
            longDesc: `You can use the movement provided by Shinigami Style as an immediate action at any point before the start of your next turn, rather than right after reducing an opponent to 0 or fewer hit points. You can also move up to half your base speed when doing so instead of only 10 feet.

            You may move up to your speed as part of the action made to perform a coup de grace or use the Whirlwind Attack feat. This movement can be before or after you perform the coup de grace or Whirlwind Attack. You provoke attacks of opportunity as normal for this movement.`,
            prereq: "Shinigami Reap",
        },
        {
            name: "Bloody Reaper Style",
            type: "style",
            longDesc: `When you reduce a creature below 0 hit points with a piercing or slashing weapon, while also having dealt the final blow while flanking them, dealing sneak attack damage, attacking them at flat-footed, or with a critical hit, you can wretch the weapon from the body creating a gory display, and then attempting to hide in it. Choose a creature you have cover from because of the creature you just killed, make a stealth check as a swift action to hide that creature. If you succeed, you continue to count as having cover from that creature for the purposes of making stealth checks for 1 round.`,
            prereq: "",
        },
        {
            name: "Bloody Reaper Leap",
            type: "style",
            longDesc: `When you successfully use the benefit of Bloody Reaper style to hide from a creature, you can move up to half of your movement speed towards them. This is done as part of the action to hide, and still provokes from other creatures as normal.`,
            prereq: "Bloody Reaper Style",
        },
        {
            name: "Bloody Reaper Carnage",
            type: "style",
            longDesc: `When you successfully use the benefit of Bloody Reaper style to hide from a creature and move towards them, if you end your movement within reach to that creature, you can make a single attack against it at your highest base attack bonus against them. If you kill them while following the requirements of Bloody reaper style, you can reactive Bloody Reaper Style on a new creature. This reactivation is done as apart of the same swift action. Each time you kill a creature, your critical damage multiplier increases by +1, and you gain 1d6 points of sneak attack damage for the rest of your turn.`,
            prereq: "Bloody Reaper Leap",
        },

        {
            name: "Executioner Style",
            type: "style",
            longDesc: `Gain a +2 insight bonus on attacks and damage against a creature who is stunned, petrified, fascinated, pinned, cowering, or otherwise helpless. This bonus increases by +2 for each feat in the chain you have.`,
            prereq: "",
        },
        {
            name: "Executioner Cruelty",
            type: "style",
            longDesc: `While in executioner style, reduce the action it takes to cou-de-grace a creature by 1 step and it no longer provokes. When you cou-de-grace and it kills a creature you gain a morale bonus to attack, damage and saves for 1 round equal to your executioner style bonus. Your executioner style bonus now also applies to creatures who are nauseated, confused, dazed, or panicked.`,
            prereq: "Executioner Style",
        },
        {
            name: "Executioner Reap",
            type: "style",
            longDesc: `Increase your critical damage multiplier by +1 against a creature who you are gaining bonus damage to because of executioner style. Your executioner style bonus now also applies to creatures who are prone, staggered, or grappled (unless they are the in control creature). Additionally, while in the style increase the critical threat range of scythes and the sadist's stilleto by 1, this is a flat bonus, unmodified by other abilities.`,
            prereq: "Executioner Cruelty",
        },
        {
            name: "Dance-Fu",
            type: "style",
            longDesc: `While using Dance-Fu Style you may use Perform in place of Acrobatics to move through threatened squares and may move at full speed while doing so. If you successfully move through an opponent's square without provoking an attack of opportunity, you may elect to take that attack of opportunity anyway. If you do then any allies that you were flanking with at any point during your move may make an attack of opportunity against that creature with the bonus for flanking.`,
            prereq: "",
        },
        {
            name: "Terrible Two-Step",
            type: "style",
            longDesc: `Once per round, while using Dance-Fu, when you make a melee attack against a foe you may force them to make a Perception check (DC 10 + your Perform bonus) if they fail they are considered flat footed against that attack. Every 10 by which they fail renders them flat-footed against an additional attack you make this round.`,
            prereq: "Dance-Fu",
        },
        {
            name: "Dance Out Of Danger",
            type: "style",
            longDesc: `Once per round, while using Dance-Fu, when an opponent targets you with a melee or ranged attack, you can make a Perform check. You can use the result as your AC or touch AC against that attack. If it still hits you, you become flat footed until the start of your next turn. If this causes the attack to miss then you may spend an immediate action to move 5 feet. Moving in this fashion provokes an attack of opportunity (unlike a 5-foot step), which you may use Perform to avoid provoking. If you stay within that creature's reach you may make a melee attack against that creature at your highest BAB. You must be aware of the attack and not flat-footed to use this feat.`,
            prereq: "Terrible Two-Step",
        },
        {
            name: "Brutal Crocodile Style",
            type: "style",
            longDesc: `You gain the constrict special ability. Every time you maintain a successful grapple check against a foe, the foe takes damage equal to that of a slam attack two sizes larger than you (so 1d8 if the initiator is medium sized) plus 1.5x your grappling ability score modifier (strength by default).`,
            prereq: "",
        },
        {
            name: "Brutal Crocodile Tenacity",
            type: "style",
            longDesc: `While in brutal crocodile style, you do not suffer a penalty on attack rolls while grappling or pinning a creature (if you're in control), nor do you lose your dexterity bonus to AC. In addition, you may make attacks of opportunity while grappled.`,
            prereq: "Brutal Crocodile Style",
        },
        {
            name: "Brutal Crocodile Desolation",
            type: "style",
            longDesc: `While in brutal crocodile style, increase the penalties a creature you are grappling(and in control of) takes to dexterity, attack, and combat maneuvers, by an additional -2`,
            prereq: "Brutal Crocodile Tenacity",
        },
        {
            name: "Radiant Dawn Style",
            type: "style",
            longDesc: `Whenever you initiate a maneuver, you or an ally within close range (25 feet + 5 feet/2 character levels) is healed for a number of hit points equal to the maneuver level, plus the amount of essence invested in that maneuver. This effect can only trigger once per round.
            \nAdditionally, you gain 1 essence, and choose 1 radiant dawn maneuver, you can increase its maximum essence investments by 1. You can change the chosen maneuver each time you enter this stance.`,
            prereq: "",
            givesEssence:true,
        },
        {
            name: "Radiant Sunlight",
            type: "style",
            longDesc: `Whenever you restore hit points to an ally with radiant dawn style, if this healing would raise their hit points to its maximum, they are granted temporary hit points equal to any excess healing. These temporary hit points stack with other temporary hit points granted by you, up to a maximum of of half of the ally's maximum hit points, and last for one minute. 
            \nAdditionally, you gain 1 essence, and choose 1 radiant dawn maneuver, you can increase its maximum essence investments by 1. You can change the chosen maneuver each time you enter this stance.`,
            prereq: "Radiant Dawn Style",
            givesEssence:true,
        },
        {
            name: "Radiant Daybreak",
            type: "style",
            longDesc: `While in radiant dawn style, as long as an ally is benefiting from temporary hit points granted by you, they gain a +2 bonus on saves and to AC, and a +10 bonus to all movement speeds. The bonus to saves and AC increases by +1 and the bonus to movement speeds increases by +5 at 15th level and every 5 levels thereafter. 
            \nAdditionally, you gain 1 essence, and choose 1 radiant dawn maneuver, you can increase its maximum essence investments by 1. You can change the chosen maneuver each time you enter this stance.`,
            prereq: "Radiant Sunlight",
            givesEssence:true,
        },
        {
            name: "Mantis Style",
            type: "style",
            longDesc: `The DC of any effect you deliver through your unarmed strikes increases by +2.`,
            prereq: "",
        },
        {
            name: "Mantis Wisdom",
            type: "style",
            longDesc: `Treat your level as 4 higher for effects you deliver through your unarmed strikes.`,
            prereq: "Mantis Style",
        },
        {
            name: "Mantis Torment",
            type: "style",
            longDesc: `A creature that fails a save against an effect you delivered through your unarmed strike becomes dazzled for 1 round, and fatigued.`,
            prereq: "Mantis Wisdom",
        },
        {
            name: "Shielded Gauntlet Style",
            type: "style",
            longDesc: `When using this style, if you are wearing heavy or medium armor and your off-hand is free and not holding a shield, and you are not using that hand to make attacks with any weapons or shield, you gain a +1 shield bonus to AC. You lose this shield bonus whenever you attack with your hand or hold a weapon or shield in that hand. While receiving this shield bonus to AC, your off hand is treated as a buckler for the purpose of using other feats and abilities (though you are also considered to have a free hand). If you have an unarmed augmenting weapon that does not take up a slot in your off-hand this shield bonus increases by +1.`,
            prereq: "",
        },
        {
            name: "Shielded Gauntlet Attack",
            type: "style",
            longDesc: `When in shielded gauntlet style you can take one additional attack of opportunity each round that does not count toward your maximum number of attacks of opportunity. This must be used to make an attack with your empty hand or unarmed weapon, or a disarm or steal combat maneuver. This attack deals damage as if you were one size larger. You do not provoke an attack of opportunity for performing either combat maneuver, and you are able to attempt a steal combat maneuver with this attack of opportunity despite the maneuver normally requiring a standard action.`,
            prereq: "Shielded Gauntlet Style",
        },
        {
            name: "Shielded Gauntlet Master",
            type: "style",
            longDesc: `While using Shield Gauntlet Style, you no longer lose your shield bonus to AC when you attack with your gauntlet (or unarmed weapon) or use it to hold a weapon. In addition, if you are using an unarmed weapon as your shielded gauntlet your shield bonus from shielded gauntlet style increases by the weapons highest enhancement bonus as if it were a shield enchantment bonus, if you aren't wielding one, your unarmed attacks with your shielded gauntlet arm gain half your armor's bonus as an enhancement to the attacks.`,
            prereq: "Shielded Gauntlet Attack",
        },
        {
            name: "Swift Runner Style",
            type: "style",
            longDesc: `While in this style and wearing light or no armor you increase your base movement speed by 10 feet, this increases by an additional 5 feet for each additional swift runner feat you have. Gain a +2 dodge bonus against attacks of opportunity.`,
            prereq: "",
        },
        {
            name: "Swift Runner Snag",
            type: "style",
            longDesc: `While in swift runner style and using both your movement and standard action to move while wearing light or no armor, you can collect a single piece of treasure that was adjacent to you at any part of your movement as a free action, when you do you can move half your base speed as a swift action. You can also pick up weapons adjacent to you as a free action, however it still provokes as normal.`,
            prereq: "Swift Runner Style",
        },
        {
            name: "Swift Runner Acceleration",
            type: "style",
            longDesc: `While in swift runner style, each round you use your movement action to move at least half your speed while wearing light or no armor, your base speed increases by 5 feet at the start of your next turn. This bonus lasts until you dont use a movement action to move at least half your movement speed, and it can be stacked for each continuous round you continue to move. You gain a bonus to your acrobatics checks to move without provoking attacks of opportunity of +2 per 10 feet of your movement speed that is above 30. You can use Swift Runner Snag to collect something twice per turn.`,
            prereq: "Swift Runner Snag",
        },
        {
            name: "Dodging Dancer Style",
            type: "style",
            longDesc: `You can only maintain this stance while in light armor, and not wielding a shield other than a buckler. Gain a dodge bonus to armor class equal to 1/2 your base attack bonus. This bonus cannot be higher than your dexterity modifier.`,
            prereq: "",
        },
        {
            name: "Dodging Dancer Grace",
            type: "style",
            longDesc: `While in dodging style, you gain a dodge bonus to your armor class equal to your dexterity modifier. This bonus plus your dexterity modifier cannot exceed your armor's maximum dexterity modifier.`,
            prereq: "Dodging Dancer Style",
        },
        {
            name: "Dodging Dancer Phantom Step",
            type: "style",
            longDesc: `While in dodging style, double all of your dodge bonuses except the ones you gained from the prerequisite feats. Increase your armor's max dexterity bonus by +2, and double any other bonus that increases your armor's max dexterity bonus.`,
            prereq: "Dodging Dancer Grace",
        },
        {
            name: "Heart of the Maelstrom Style",
            type: "style",
            longDesc: `You can only maintain this stance while in light or no armor and not carrying a shield other than a buckler. While in this style, when using a movement action to move, you can reduce your speed by half to make an acrobatics check as you move. If you do, your armor class and touch armor class becomes equal to the result of the check until the start of your next turn (this also applies to attacks of opportunity taken while moving to activate this ability, unless they are taken before you have actually moved your first square). Your armor class against attacks that deny you your dexterity bonus to AC or you are flat-footed against suffers a -5 penalty. Any penalty or bonus that would normally apply to your touch armor class also applies to your armor class while using this ability.`,            prereq: "",
        },
        {
            name: "Heart of the Maelstrom Evasion",
            type: "style",
            longDesc: `While in Heart of the Maelstrom Style you can use its benefit while activating a maneuver that allows you to move (Must move at least 20 feet, and it reduces your movement by half still). While in a stance that gives you a bonus to your movement speed, you can gain a bonus to either your attack or dodge bonus to armor class equal of +1 per 10 feet of movement speed the stance gives. You choose at the start of each turn and it lasts for 1 round.`,
            prereq: "Heart of the Maelstrom Style",
        },
        {
            name: "Heart of the Maelstrom Overclock",
            type: "style",
            longDesc: `While in Heart of the Maelstrom Style, you can as a swift action expend a readied boost or counter of at least 5th level to gain a bonus on your next weapon attack equal to half the level of the expended maneuver, and causing it to deal an additional 1d4 points of electricity damage per level of the maneuver. You also gain a dodge bonus equal to the 1/2 the level of the expended maneuver until the start of your next turn.`,
            prereq: "Heart of the Maelstrom Evasion",
        },
        {
            name: "Armored Momentum Style",
            type: "style",
            longDesc: `You can only maintain this style while in medium armor. While in this stance you can move an additional 20 feet while charging, and when you move at least your movement speed while charging you gain an additional +2 bonus on charge attacks. This bonus increases by +1 for each feat in the chain you have. If you are wielding a polearm on charge attacks, your first attack deals damage as if you were one size larger.`,
            prereq: "",
        },
        {
            name: "Armored Momentum Dodge",
            type: "style",
            longDesc: `While in Momentum style, you can as a standard action make a single melee attack at your highest bonus at an enemy, if it succeeds you can make a bullrush attempt against yourself which doesn't provoke, if you succeed you move yourself directly away from the target struck the distance the bullrush would move you, plus an extra 5 feet. This movement doesn't provoke from the creature you used it on, and you gain a dodge bonus of +1 for each 5 feet you moved until the start of your next turn. If your bullrush also beats their CMD they are also moved, but for every 5 feet you choose to move them, you are moved 5 feet less.`,
            prereq: "Armored Momentum Style",
        },
        {
            name: "Armored Momentum Assault",
            type: "style",
            longDesc: `While in Momentum style, you no longer need to charge in a straight line, but you can only make a single turn of less than 90 degrees. All of your attacks deal damage as if you were one size larger on charge attacks (stacks with momentum style), you can also use the ability of Armored Momentum Dodge on charge attacks and strikes.`,
            prereq: "Armored Momentum Dodge",
        },
        {
            name: "Flexible Assault Style",
            type: "style",
            longDesc: `You can only maintain this style while in medium armor. While in this style, at the start of your turn as a free action you can choose to lose all of your current dexterity bonus to your armor class to instead gain an equal bonus to your melee attack rolls. This bonus cannot be more than your armor's max dexterity bonus or your strength bonus. This bonus lasts until the start of your next turn. Additionally, increase the max dex bonus of your armor by +1. This increases by +1 for each feat in the chain you have.`,
            prereq: "",
        },
        {
            name: "Flexible Assault Defense",
            type: "style",
            longDesc: `While in Flexible Assault Style, you can choose to reduce your melee attack by your strength modifier (you must make an attack to use this), if you do you gain a dodge bonus to your armor class equal to your strength modifier instead, however this bonus plus cannot be more than your armor's max dex penalty. You cannot use this bonus and the bonus given by Flexible Assault Style on the same round.`,
            prereq: "Flexible Assault Style",
        },
        {
            name: "Flexible Assault Switchup",
            type: "style",
            longDesc: `While in Flexible Assault Style, for each round in a row you swap whether you're using the bonus from Flexible Assault Style or the bonus from Defense, the bonus you gain increases by +1. This resets on floors and when leaving combat.`,
            prereq: "Flexible Assault Defense",
        },
        {
            name: "Indomitable Hulk Style",
            type: "style",
            longDesc: `You can only maintain this style while in heavy armor. While in this stance when you have not moved from your square since the beginning of your last turn, you gain DR 3/-. This DR increases by 3 for each additional feat in the chain you have.`,
            prereq: "",
        },
        {
            name: "Indomitable Hulk Unbound",
            type: "style",
            longDesc: `While in Indomitable Hulk Style, you can use your strength in place of your dexterity modifier for determining your armor class.`,
            prereq: "Indomitable Hulk Style",
        },        
        {
            name: "Indomitable Hulk Bedrock",
            type: "style",
            longDesc: `While in Indomitable Hulk Style increase the max dexterity bonus of your armor by +1 and increase its armor check penalty by -2. These are both doubled when you are gaining DR from Indomitable Hulk Style. Gain a bonus to your CMD against combat maneuvers that move or trip you (this could possible include grapples if it would move you) equal to the DR you are currently gaining from Indomitable Hulk Style.`,
            prereq: "Indomitable Hulk Unbound",
        },
        {
            name: "Unbreakable Collosus Style",
            type: "style",
            longDesc: `You can only maintain this style while wearing heavy armor, increase your armor's armor bonus by +1, this bonus increases by +1 for each feat in the chain you have.`,
            prereq: "",
        },
        {
            name: "Unbreakable Collosus Bastion",
            type: "style",
            longDesc: `While in Unbreakable Collosus Style, adjacent allies also get your armor bonus from Unbreakable Collosus Style, and you are considered to be a wall against enemies for determining cover for their attacks vs allies.`,
            prereq: "Unbreakable Collosus Style",
        },
        {
            name: "Unbreakable Collosus Rampage",
            type: "style",
            longDesc: `While in Unbreakable Collosus Style, you can use your armor like a weapon, when you do, lose 50% of your armor bonus granted by your armor until the start of your next turn, however your unarmed attacks deal additional damage equal to the armor bonus lost. If any attack you make while using this results in a natural 1, your armor becomes broken. If this happens while your armor is broken it is instead destroyed.`,
            prereq: "Unbreakable Collosus Bastion",
        },
        {
            name: "Scarred Wretch Style",
            type: "style",
            longDesc: `You can only maintain this style while wearing no armor and not wielding a shield. You can gain your constitution modifier as a racial bonus to your natural armor.`,
            prereq: "",
        },
        {
            name: "Scarred Wretch Stoicism",
            type: "style",
            longDesc: `While in Scarred Wretch Style, you gain a +4 bonus on saves related to pain, and a bonus on concentration checks made because of taking damage equal to your constitution modifier.`,
            prereq: "Scarred Wretch Style",
        },
        {
            name: "Scarred Wretch Collection",
            type: "style",
            longDesc: `While in Scarred Wretch Style, as an immediate action when an attack is declared against you, you can choose to allow it to hit you, if you do you gain DR /- equal to your constitution score for the attack, if the attack still deals lethal damage to you, you also take 1 point of damage to either your strength or dexterity, your choice, but once the hit point damage you took from the attack is healed you increase the natural armor bonus you gain from scarred wretch style and DR of this ability by +1 (scars heal seperately). If you heal the strength or dexterity damage you lose these bonuses.`,
            prereq: "Scarred Wretch Stoicism",
        },
        {
            name: "Linnorm Hunter Style",
            type: "teamwork",
            longDesc: `This is a style feat and follows those rules. Once per round while using this style, when an ally with this feat hits a target that you both threaten using a melee attack, you gain a +2 bonus on attacks of opportunity made against that target for 1 round. Enemies that provoke attacks of opportunity from your ally also provoke attacks of opportunity from you so long as you threaten them (even if the situation or an ability would normally deny you the attack of opportunity).`,
            prereq: "",
        },
        {
            name: "Linnorm Hunter Retreat",
            type: "style",
            longDesc: `When an ally with this Linnorn Hunter Style uses it and hits a target with a melee attack, you can move 5 feet as an immediate action without provoking an attack of opportunity from that target.`,
            prereq: "Linnorm Hunter Style",
        },
        {
            name: "Linnorm Hunter Coordination",
            type: "style",
            longDesc: `When you and an ally are using Linnorm Hunter Style and threatening the same target, you can make a single melee attack at your highest base attack bonus against that target as a full-round action. If your attack is successful, you deal extra damage with this feat equal to the damage of one of your ally's attacks. This extra damage is not multiplied on a critical hit.`,
            prereq: "Linnorm Hunter Retreat",
        },
        {
            name: "Share Spells",
            type: "teamwork",
            longDesc: `You can cast a spell with a target of “you” on an ally with this feat as a touch spell, as per the share spells familiar ability.`,
            prereq: "",
        },
        {
            name: "Improved Share Spells",
            type: "magic",
            longDesc: `When you cast a spell on an ally by utilizing the share spells teamwork feat, you can spend the additional spell points to cause you to also become a target of the spell, however the spell only lasts rounds equal to the spell level (or its normal duration if that would be less).`,
            prereq: "Share Spells",
        },
        {
            name: "Shikigami Style",
            type: "style",
            longDesc: `While in Shikigami style you can take a -4 penalty to attacks with your weapon to deal damage as if it were one size larger. Your weapons enchantments no longer affect the weapon's attacks, and its crit range becomes 20 x2. Any bonus to improvised weapons benefits your weapon. For every feat in the chain you have treat the weapon as an additional size category larger, to a maximum of three sizes larger than its actual size.`,
            prereq: "",
        },
        {
            name: "Shikigami Mimicry",
            type: "style",
            longDesc: `While in Shikigami Style, you can take a -2 penalty on attack rolls to treat an improvised weapon as if it had one of the following weapon special qualities until the start of your next turn: blocking, brace, disarm, distracting, nonlethal, performance, or trip. If the weapon has the fragile special quality or broken condition, you can treat it as if it had the jagged special quality.`,
            prereq: "Shikigami Style",
        },
        {
            name: "Shikigami Manipulation",
            type: "style",
            longDesc: `While in Shikigami Style and using its benefit, your weapon counts as having an enchantment modifier of +1 per enchantment it currently has, this doesn't stack for overcoming DR, except DR /magical.`,
            prereq: "Shikigami Mimicry",
        },
        {
            name: "Beastmaster Style",
            type: "teamwork",
            longDesc: `While in this stance and adjacent to someone with this feat and is using it, when an attack is made against them, if you are also adjacent to the attacking creature, you can attempt a diplomacy check as an immediate action to negate the hit. The hit is negated if your diplomacy check result is greater than the attacker's attack roll.`,
            prereq: "",
        },
        {
            name: "Beastmaster Salvation",
            type: "style",
            longDesc: `While in this stance If you are adjacent to someone with this feat and is using it when they attempt a saving throw, you can attempt a diplomacy check as an immediate action. they do not attempt the saving throw, but instead uses your diplomacy check as their result for the save.`,
            prereq: "Beastmaster Style",
        },
        {
            name: "Beastmaster Ire",
            type: "style",
            longDesc: `When you activate Beastmaster Style's benefit, you gain a +2 morale bonus on melee weapon attack rolls and +4 morale bonus on weapon damage rolls against the attacking creature. If the enemy attack dealt damage to your partner, these bonuses increase to +4 and +8, respectively. These bonuses last until the end of your next turn.`,
            prereq: "Beastmaster Salvation",
        },
        {
            name: "Stock-Striker Style",
            type: "style",
            longDesc: `You can make melee attacks with a firearm by using it like a club, a one handed firearm deals 1d6, and a two handed firearm deals 1d10, both with a crit range of 20x2. If you have the pistol whip ability you gain a +1 to attack, damage, and +2 to the cmb to knock people prone. If you successfully knock someone prone with a melee attack with a firearm, you do not provoke attacks of opportunity from the target until the end of your next turn when you make ranged attacks with your firearm. You can treat one-handed firearms as light weapons for the purpose of abilities such as Weapon Finesse when performing the pistol-whip deed.`,
            prereq: "",
        },
        {
            name: "Stock-Striker Sweep",
            type: "style",
            longDesc: `When you are using Stock-Striker Style and successfully knock a target prone with the pistol-whip deed or a melee trip attempt with a firearm, as a swift action you can either push the target 5 feet away from you or perform the pistol-whip deed or make a trip attempt a second time against a foe that is adjacent to the first and within your reach. This second use of pistol-whip costs 0 spell points.`,
            prereq: "Stock-Striker Style",
        },
        {
            name: "Stock-Striker Takedown",
            type: "style",
            longDesc: `After you knock a target prone with the pistol-whip deed or a melee trip attempt with a firearm while using Stock-Striker Style, you can fire one barrel of a loaded firearm you're wielding at the target as a move action; if your firearm has the scatter weapon quality, you can instead make a scattering shot so long as you include the target in the area of effect. For this attack, you take no attack penalty for making a ranged attack against a prone target, and the critical multiplier of your weapon increases by 1 (to a maximum of ×5).`,
            prereq: "Stock-Striker Sweep",
        },
        {
            name: "Shapeshifter Style",
            type: "style",
            longDesc: `You reshape your body, gaining one of the following benefits. You choose the benefit when you enter the style, and while in the style you can change the benefit as a swift action.
            \nBrutal Attack: Choose one of your natural attacks. You gain a +1 bonus on damage rolls with that attack when using this style, plus an additional +1 for every feat in the chain (maximum +4).
            
            \nSteady Grip: You gain a climb speed of 10 feet. Increased to 15 if you have shape shifter mastery.
            
            \nTensed Sinews: You gain a +1 bonus on Reflex saving throws and a +5 enhancement bonus to your base speed. Reflex bonus is increased to +3 if you have Shapeshifter Mastery.
            
            \nToughened Hide: You gain a +1 enhancement bonus to your existing natural armor bonus. Increased to +2 if you have Shapeshifter Mastery`,
            perkPrereq: ["Animal Focus", "Wild Shape"],
        },
        {
            name: "Shapeshifter Twist",
            type: "style",
            longDesc: `While you are using Shapeshifter Style, you gain a +2 bonus to your CMD versus bull rush, drag, grapple, overrun, reposition, and trip combat maneuvers. If you begin your turn with the grappled condition, you can attempt a combat maneuver check or an Escape Artist check as a move action to attempt to break the grapple.`,
            prereq: "Shapeshifter Style",
        },
        {
            name: "Shapeshifter Savage",
            type: "style",
            longDesc: `When you activate shapeshifter style you can make an attack with a single natural weapon against a foe within reach.`,
            prereq: "Shapeshifter Twist",
        },
        {
            name: "Shapeshifter Mastery",
            type: "style",
            longDesc: `When you take on the aspect of an animal with animal focus, you can choose a single aspect you took on, and taking it on is a swift action that costs 2 spell points, when you do, your next melee attack in the round comes with an additional benefit depending on the aspect you took on
            \nTiger Bear: Make a free grapple attempt if your attack was successful, it doesn't provoke. If it wouldn't normally provoke for you, you gain a +4 to the grapple.
            \nBat: Your attack acts as if you had blindsight. You still need to have target the right square before hand.
            \nFrog Monkey: Make a free disarm attempt if your attack was successful, it doesn't provoke. If it wouldn't normally provoke for you, you gain a +4 to the disarm.
            \nMouse: Take a 5-foot step after you attack, it doesn't provoke.
            \nStag: Your attack deals an additional 2d4 damage, if it was a charge attack, it deals 4d4 damage.
            \nWolf: Make a free trip attempt if your attack was successful, it doesn't provoke. If it wouldn't normally provoke for you, you gain a +4 to the trip.`,
            prereq: "Shapeshifter Savage",
        },
        {
        name: "Accomplished Sneak Attacker",
        type: "martial",
        shortDesc: "Your sneak attack damage increases by 1d6.",
        longDesc: "Your sneak attack damage increases by 1d6. If you dont have sneak attack you gain 1d6 of sneak attack.",
        prereq: "",
        key:true,
        repeatable:true,
        },
        {
        name: "Elemental Fist",
        type: "martial",
        shortDesc: "Your sneak attack damage increases by 1d6.",
        longDesc: "When you use Elemental Fist pick one of the following energy types: acid, cold, electricity, or fire. On a successful hit, the attack deals damage normally plus 1d6 points of damage of the chosen type. You must declare that you are using this feat before you make your attack roll (thus a failed attack roll ruins the attempt). Using elemental fist costs 3 spell points, only works with unarmed attacks, and you may attempt an Elemental Fist attack no more than once per round.",
        prereq: "",
        key:true,
        repeatable:false,
        },
        {
        name: "Improved Elemental Fist",
        type: "martial",
        shortDesc: "Your sneak attack damage increases by 1d6.",
        longDesc: "When you use Elemental Fist the damage is increased to 1d10, but it costs 1 additional spell point, and you can deliver it through any melee weapon, however if you do deliver it through an unarmed strike it deals 2d6 damage instead.",
        prereq: "Elemental Fist",
        key:false,
        repeatable:false,
        },
        {
        name: "Greater Elemental Fist",
        type: "martial",
        shortDesc: "Your sneak attack damage increases by 1d6.",
        longDesc: "When you use Elemental Fist the damage is increased to 2d6, or 2d10 if unarmed, and you can spend 4+level spell points as a swift action to make it apply to all of your melee attacks in a round.",
        prereq: "Improved Elemental Fist",
        key:false,
        repeatable:false,
        },
        {
        name: "Tenacious Survivor",
        type: "utility",
        shortDesc: "",
        longDesc: "When you are killed by hit point damage, your soul lingers in your body for a number of rounds equal to your Constitution bonus. You are still dead, but you can be healed by magic as if you were alive. If you are healed enough hit points that you would no longer be dead, you are alive again, but you gain one permanent negative level.",
        prereq: "",
        },
        {
        name: "Combat Tenacity",
        type: "martial",
        shortDesc: "",
        longDesc: "For the purpose of initiating counters, you are not considered to have expended your swift action this turn if you used the action to initiate a boost or entered a stance. For the purpose of initiating boosts and entering stances, you are not considered to have expended your swift action this turn if you used the action to initiate a counter.",
        prereq: "",
        },
        {
            name: "One-Handed Weapon Tricks",
            type: "martial",
            shortDesc: "",
            longDesc: `You gain various one handed fighting tricks, but you can only use any of these abilities while wielding a one-handed or light manufactored weapon and holding nothing in your off hand, and you must meet the prerequisite which is inside the ():
            \nMindful Dodge (wearing light armor): As an immediate action, you can gain a +4 dodge bonus to your AC against a single of which attack you are aware. You must make this decision before the attack roll is revealed. You are staggered on your next turn, but if the attack misses you because of this additional armor class you may make a free 5-foot step that doesn't provoke.
            \nStrike and Seize (Can disarm without provoking an AoO): As a standard action, you can make a single attack with your weapon and attempt to perform a disarm combat maneuver with your free hand, taking no penalties for two-weapon fighting.
            \nStylish Reposte(more than one AoO per round): When your AC exceeds the result of a foe's melee attack against you by 5 or more, that foe provokes an attack of opportunity from you. Once you make such an attack of opportunity against a foe, you can't again use this trick against the foe that day.
            \nGrab and Stab(Can grapple without provoking attacks of opportunity): When you successfully initiate a grapple with your free hand (taking the usual -4 penalty for not having two hands free), you can immediately follow up with an attack using your light or one-handed weapon as a free action.
            \nSwitch Hands(none): As a free action, you can pass a light or one-handed weapon you are wielding to your free hand. If you attempt a feint during the same round, you gain a +4 bonus on your Bluff check. Once you have used this weapon trick against a target, you can't gain the bonus against the same creature.
            \nFree Hand Maneuver(none): As an attack action, you can make a single attack with your weapon and attempt to perform a dirty trick, disarm, drag, or reposition, combat maneuver with your free hand, taking no penalties for two-weapon fighting. The combat maneuver provokes attacks of opportunities as normal, unless you have an appropriate ability or feat. You are not considered unarmed for this maneuver, but can't apply any benefits of your weapon to the combat maneuver check.`,
            prereq: "",
        },
        {
            name: "Polearm Weapon Tricks",
            type: "martial",
            shortDesc: "",
            longDesc: `You gain various polearm fighting tricks, but you can only use any of these abilities while wielding a polearm, and you must meet the prerequisite which is inside the ():
            \nChoke Up(none): You can take a -2 penalty on attack rolls and damage rolls until the beginning of your next turn in order to choke up on and wield a two-handed polearm sized for you in one hand, but you cant make any attacks with your off-hand.
            \nHaft Bash(none): You can accept a -2 penalty on attack rolls with a reach polearm in order to treat the weapon as if it lacked the reach quality until the start of your next turn.
            \nQuick Brace(none): While taking a full-attack action with a polearm with brace, you can ready an attack with the polearm in place of your final attack. The readied attack uses the attack bonus of the attack you used to ready it.
            \nSpinning Lunge(a reach greater than 10 feet): When making a full attack with a polearm your last attack counts as having 5 feet more of reach, and if you attack something you couldn't have otherwise because of this extra reach they are considered flat-footed. A creature can only be caught flat footed once with this attack.
            \nPole Vault(10 ranks in acrobatics, wearing light or no armor): You gain a +5 on acrobatics checks to move through threatened space without provoking and for moving through an enemies square, and you can ignore 10 feet of difficult terrain during a move action.`,
            prereq: "",
        },
        {
            name: "Ranged Weapon Tricks",
            type: "martial",
            shortDesc: "",
            longDesc: `You gain various fighting tricks, but you can only use any of these abilities while wielding a ranged weapon, and you must meet the prerequisite which is inside the ():
            \nHindering Shot(Precise Shot/Snap Shot): You can distract a foe at a crucial moment, making it vulnerable to your allies' abilities. You can ready an action to make a ranged attack against a foe when an ally forces the foe to attempt a saving throw. If your attack hits the foe and deals damage, the foe takes a -4 penalty on the saving throw that triggered your readied action.
            \nSupressing Shot(Precise Shot/Far Shot): You can cover an ally's momentary vulnerability. You can ready an action to make a ranged attack against a foe when it makes an attack of opportunity. If your attack hits and damages the foe, the foe's attack of opportunity automatically misses its target.
            \nDodge Roll(dodge/combat expertise/mobility): When making a full round attack with a ranged weapon you can take an additional 5-foot step. This extra step cannot be made until you've made your first attack. Gain an additional +2 dodge bonus to armor class against any creature who's threatened space you moved completely out of with this extra step.
            \nOver Stuff(using a firearm): You can overstuff a single barrel of your gun while reloading. Doing so makes that individual barrel deal an extra 1d4 points of damage, but increases the missfire chance by +1. You can overstuff multiple barrels at a time, and repeatedly overstuff each barrel, but the penalties and damage bonus stacks. You can't use this with abilities that automatically reload a firearm.
            \nCurved Shot(using a bow or crossbow): You bend an arrow's feather as a swift action, when that arrow is fired you can ignore 1 tile of cover or soft cover the target of your ranged attack may have.`,
            prereq: "",
        },
        {
            name: "Two-Handed Weapon Tricks",
            type: "martial",
            shortDesc: "",
            longDesc: `You gain various fighting tricks, but you can only use any of these abilities while wielding a two-handed weapon, and you must meet the prerequisite which is inside the ():
            \nCleaving Smash(Cleave, using power attack, vital strike): When you use a Cleave feat, you can add the additional damage from a Vital Strike feat to both your initial and your secondary attacks. You receive a -2 penalty when doing this, which stacks with the penalty for using cleave. 
            \nCrush Armor(Can sunder without provoking): When you deal damage to a foe's armor with a successful sunder combat maneuver check while using a two-handed weapon, the foe must succeed at a Fortitude save (DC = 10 + 1/2 your base attack bonus + your Strength modifier) or be fatigued for 1 round. If the armor has the broken condition after you damage it, the foe must continue making this save every round until he removes the armor or the armor loses the broken condition. If the armor is destroyed by your sunder attempt, the foe is automatically fatigued for 1 round. The foe cannot become exhausted this way.
            \nWarding Weapon(dodge/combat expertise/light or no armor): Gain a +1 dodge bonus to your armor class. While you are using the total defense action, fighting defensively, or using Combat Expertise, you gain a +1 shield bonus to AC. This increases by +1 for each 8 of your BAB.            
            \nOne-Handed Lunge(none): As a standard action, you can release one of your hands holding a two-handed weapon and make a melee attack with the weapon, increasing your reach by 5 feet for the duration of the attack. If the attack hits, you deal damage as if using a one-handed weapon, Otherwise, you take no penalty for using the weapon one-handed.`,
            prereq: "",
        },
        {
            name: "Two-Weapon Tricks",
            type: "martial",
            shortDesc: "",
            longDesc: `You gain various fighting tricks, but you can only use any of these abilities while wielding two weapons in each hand, and you must meet the prerequisite which is inside the ():
            \nArm Bind(two-weapon fighting): You can attempt a combat maneuver check to disarm a foe even if the foe has no weapons. This functions as the disarm combat maneuver. If you succeed and the foe has no weapon, you ensnare an arm of your choice, preventing your foe from using that limb until the end of your next turn. A foe can take a standard action to free its arm.
            \nDual Strike(vital strike): When making an attack action to attack, you can make an additional attack with your off-hand weapon, applying penalties for two weapon fighting. It gains no bonuses your main hand may have gained. If you have improved and greater vital strike, you get another additional attack for each, each at a -5 attack penalty from the previous.
            \nOff-Hand Opportunity(dex mod +4): You can make an additional attack of opportunity each round with your off-hand attack. If you have additional off-hand attacks because of a feat like two-weapon fighting you can make another additional attack of opportunity with your off-hand. If you also have combat reflexes (or a different ability that grants an extra AoO), you can make these additional off-hand attacks of opportunity while making an AoO with your primary weapon (only one per attack), but both get a -4 penalty. 
            \nFollowing Flurry(Step Up): After using step up to follow a creature you can make an attack with your off-hand weapon.
            \nDervish(dodge/mobility, light or no armor): When making a full-round attack with two weapons, after you finish all of your attacks you can move 10 feet, this movement doesn't provoke.`,
            prereq: "",
        },
        {
            name: "Weapon and Shield Tricks",
            type: "martial",
            shortDesc: "",
            longDesc: `You gain various fighting tricks, but you can only use any of these abilities while wielding a shield and a weapon you can wield in one hand, and you must meet the prerequisite which is inside the ():
            \nFeint and Bash(bluff 10 ranks, +4 dex)When you feint successfully against a foe you threaten with your shield, that foe provokes an attack of opportunity from you. You can only perform a shield bash with this attack of opportunity.
            \nShielded View(Perception 10 ranks): When you avert your eyes to avoid a gaze attack, you have an 80% chance to avoid having to attempt a saving throw against the gaze.
            \nWarded Movement(dodge/mobility/light or no armor): As a swift action, you can choose a foe you can see. You can pass through that foe's threatened area without provoking attacks of opportunity from that foe this round. Once you target a foe with this trick, you can't target it again that day.
            \nBlock and Counter(two-weapon fighting/dex mod +5): You can ready an action to block an attack's with your shield as a standard action, then when you are attacked with a weapon until the start of your next turn, you can expend an attack of opportunity to make an attack roll as though you were making a shield bash and using the result as your AC against that attack. If you successfully block the attack, it provokes an attack of opportunity from you.
            \nShieled Charge(shield focus): When you make a charge attack, you can attack twice—once with your shield and once with the weapon you are wielding in your other hand, applying the normal penalties for fighting with two weapons to each.`,
            prereq: "",
        },
        {
            name: "Ineffable Count of the Clock",
            type: "utility",
            shortDesc: "",
            longDesc: "Three times per day as a free action (but only once per turn), you can increase your speed by any amount up to your base speed until the end of your turn. On the subsequent round, your speed is reduced by the same amount.",
            prereq: "",
        },
        {
            name: "Ineffable Lord of the Clock",
            type: "utility",
            shortDesc: "",
            longDesc: "Instead of increasing your movement speed when using count of the clock, you can instead spend spell points equal to your level, and instead of gaining movement speed, you gain an additional movement action. On your next turn you lose your movement action. If you would also be staggered you can take no action instead.",
            prereq: "Ineffable Count of the Clock",
        },
        {
            name: "Marcher-Count of the Cerulean Abyss",
            type: "utility",
            shortDesc: "",
            longDesc: "You claim ownership of that which you strike. If you have dealt hit point damage to a creature this round, that creature takes a -2 penalty on combat maneuver checks and to its CMD until the beginning of your next round. Class features that also claim creatures such as dark claim, also apply this penalty.",
            prereq: "",
        },
        {
            name: "Marcher-Lord of the Cerulean Abyss",
            type: "utility",
            shortDesc: "",
            longDesc: "Creatures you claim (whether with count of the cerulean abyss or claim abilities) also take a -2 penalty to attack rolls and a -4 on concentration checks.",
            prereq: "Marcher-Count of the Cerulean Abyss",
        },
        {
            name: "Triple-Baron",
            type: "utility",
            shortDesc: "",
            longDesc: "Three times per day as an immediate action, when you are about to roll for an attack, saving throw, or skill check, you can roll three d20s and use the middle of the three results. This ability cannot be combined with other effects that involve rerolling dice or involve rolling twice and taking either the higher or lower result.",
            prereq: "",
        },
        {
            name: "Quadruple-Baron",
            type: "utility",
            shortDesc: "",
            longDesc: "When using triple-baron you can spend spell points equal to your level/2 to instead roll 4 times, if you do, you can instead add the results of the two lowest dice together. If any dice roll is a natural 20 you can spend level/4 spell points to make the roll count as a natural 20.",
            prereq: "Triple-Baron",
        },
        {
            name: "Lonely Death",
            type: "utility",
            shortDesc: "",
            longDesc: "You can spend level spell points when you are reduced below 0 hit points and as an immediate action you can move up to twice your base speed. If this brings you into cover or concealment, you can also attempt a Stealth check to hide.",
            prereq: "",
        },
        {
            name: "Chance Death",
            type: "utility",
            shortDesc: "",
            longDesc: "Once per day, if you would die as a result of an attack or failing a saving throw, as an immediate action you can reroll the attack or saving throw. You must use the result of the second roll, even if it is worse.",
            prereq: "",
        },
        {
            name: "Deliberate Death",
            type: "utility",
            shortDesc: "",
            longDesc: "Once per day, if you are reduced below 0 hit points as a result of an attack or ability used by another character, as an immediate action you can take a single standard action. You must use this action to attack or harm the creature that damaged you.",
            prereq: "",
        },
        {
            name: "Heaven's Light",
            type: "utility",
            shortDesc: "",
            longDesc: `As a standard action, you can emit an aura of bright light centered on a glowing halo above or behind your head. The illumination provided is equal in intensity to that of a torch. If you have at least 5 ranks in Knowledge (planes) the illumination is equivalent to that created by a daylight spell. If you have at least 15 ranks in Knowledge (planes), the light becomes further infused with Heavenly power, and each evil creature within 30 feet of you must succeed at a Fortitude save (DC = 10 + 1/2 level + highest mental modifier) or become sickened by the light for as long as it remains in range plus 1 additional round after leaving the area.

            You can use this feat's benefit for a number of rounds per day equal to your ranks in Knowledge (planes). These rounds need not be consecutive.`,
            prereq: "",
        },
        {
            name: "Burrowing Shot",
            type: "martial",
            shortDesc: "",
            longDesc: "When you successfully hit a creature with a ranged attack, as a swift action, you can have the weapon (or its ammunition, for projectile weapons) lodge itself within the creature's body, causing the creature to take a -2 penalty on ability checks, attack rolls, saving throws, and skill checks as a result of the intense pain. Penalties from multiple lodged weapons do not stack. If the creature is a spellcaster, it gains a 25% spell failure chance with all spells it casts that include somatic components. This penalty can be removed with the treat deadly wounds use of the Heal skill or by removing the lodged weapon as a standard action, which ends the penalties and causes the creature to take an amount of damage equal to the weapon's base damage (without any bonuses).",
            prereq: "",
        },
        {
            name: "Ace Trip",
            type: "martial",
            shortDesc: "",
            longDesc: "You can attempt special ranged trip combat maneuver checks against flying creatures. If the combat maneuver succeeds, the target falls at a rate of up to 100 feet per round (assuming it is conscious and attempting to remain airborne; otherwise, it falls at a rate of 500 feet per round) until it hits the ground. Upon impact, it falls prone and takes falling damage (half the normal damage if it fell 100 feet per round; otherwise, normal damage for the distance fallen).",
            prereq: "",
        },
        {
            name: "Liberating Shot",
            type: "martial",
            shortDesc: "",
            longDesc: "When you hit an opponent with a ranged attack as part of an attack action and that opponent is grappling an ally, your grappled ally can use your attack roll result in place of her combat maneuver check result, whichever is higher, to escape from the grapple during her next turn.",
            prereq: "",
        },
        {
            name: "Retributive Kick",
            type: "martial",
            shortDesc: "",
            longDesc: "When you make a full attack with a non-unarmed melee weapon and your first attack misses or is blocked, deflected, parried, or otherwise caused to not hit the target, you can immediately make an unarmed attack against the same target with the same attack bonus.",
            prereq: "",
        },
        {
            name: "Retributive Shot",
            type: "teamwork",
            shortDesc: "",
            longDesc: "When a creature takes an attack of opportunity against an ally with this feat within 30 feet of you, you can make an attack of opportunity with a ranged weapon first. If you hit and deal damage the creature gets a -4 to its attack of opportunity. If you have improved or greater snap shot this feats range increases by 15 feet for each.",
            prereq: "Snap Shot",
        },
        {
        name: "Spell Penetration",
        type: "magic",
        shortDesc: "",
        longDesc: "You get a +2 bonus on caster level checks (1d20 + caster level) made to overcome a creature's spell resistance. This stacks.",
        prereq: "",
        key:true,
        },
        {
            name: "Improved Spell Penetration",
            type: "magic",
            shortDesc: "",
            longDesc: "You get a +2 bonus on caster level checks (1d20 + caster level) made to overcome a creature's spell resistance. This stacks.",
            prereq: "Spell Penetration",
        },
        {
        name: "Greater Spell Penetration",
        type: "magic",
        shortDesc: "",
        longDesc: "You get a +3 bonus on caster level checks (1d20 + caster level) made to overcome a creature's spell resistance. This stacks.",
        prereq: "Improved Spell Penetration",
        repeatable:true,
        },
        {
        name: "Shadow Strike",
        type: "martial",
        shortDesc: "You can apply precision damage such as sneak attack to targets with concealment, but not total concealment",
        longDesc: "You can apply precision damage such as sneak attack to targets with concealment, but not total concealment",
        prereq: "",
        key:true,
        },
        {
            name: "Greater Shadow Strike",
            type: "martial",
            shortDesc: "You can apply precision damage such as sneak attack to targets with concealment, but not total concealment",
            longDesc: "You can apply precision damage such as sneak attack to targets with total concealment",
            prereq: "Shadow Strike",
        },
        {
        name: "Strong Comeback",
        type: "utility",
        shortDesc: "",
        longDesc: "Whenever you are allowed to reroll an attack, an ability check, a skill check, or a saving throw, you gain a +2 circumstance bonus on the reroll",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Exploit Lore",
        type: "martial",
        shortDesc: "",
        longDesc: "When you personally beat the DC for a knowledge check against a monster to identify its weaknesses you gain a +2 to attack and damage against it. If you beat the DC by 8 the bonus becomes a +4.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Deadly Grappler",
        type: "martial",
        shortDesc: "",
        longDesc: "You have learned to leverage a grappling creature's weight against it. While you're grappled, attacks you make against the grappler using armor spikes, a light or one-handed weapon, a natural weapon, or an unarmed strike deal damage as if the strike or weapon were one size category larger than it actually is. This size increase stacks with all others.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Psychic Healing",
        type: "utility",
        shortDesc: "",
        longDesc: "Whenever you use the bandage up or emergency aid actions with the heal skill the creature also gains temporary hitpoints equal to half the healing they received. These last up to one hour and stack up to a maximum of the creatures maximum hitpoints.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Healer's Hands",
        type: "utility",
        shortDesc: "",
        longDesc: "Bandage up or emergency aid actions with the heal skill have their action cost reduced to a standard action, and if you exceed the DC of the check by 10, or roll above a 30 on the check you can add your ranks in knowledge planes to the healing given to the creature.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Crane Style",
        type: "style",
        shortDesc: "",
        longDesc: "You take only a -2 penalty on attack rolls for fighting defensively. While using this style and fighting defensively or using the total defense action, you gain an additional +1 dodge bonus to your Armor Class.",
        prereq: "",
        },
        {
        name: "Crane Wing",
        type: "style",
        shortDesc: "",
        longDesc: `When fighting defensively with at least one hand free, you gain a +4 dodge bonus to AC against melee attacks. If a melee attack misses you by 4 or less, you lose this dodge bonus until the beginning of your next turn.

        If you using the total defense action instead, you can deflect one melee attack that would normally hit you. An attack so deflected deals no damage and has no other effect (instead treat it as a miss). You do not expend an action when using this feat, but you must be aware of the attack and not flat-footed.`,
        prereq: "Crane Style",
        },
        {
        name: "Crane Riposte",
        type: "style",
        shortDesc: "",
        longDesc: `You take only a -1 penalty on attack rolls for fighting defensively.

        Whenever you deflect an opponent's attack using Crane Wing or lose the dodge bonus from Crane Wing because an attack missed you by 4 or less, you can make an attack of opportunity against the attacker after the attack misses.
        
        In addition, when you deflect an attack using Crane Wing while taking the total defense action, you may make an attack of opportunity against that opponent (even though you could not normally do so while taking the total defense action).`,
        prereq: "Crane Wing",
        },
        {
        name: "Hollow Soul",
        type: "utility",
        shortDesc: "",
        longDesc: `As a move action, you can enter a state of emotional and spiritual hollowness. While in this state, you react to positive and negative energy as if you were undead— positive energy harms you, while negative energy heals you.
        \nWhenever you are targeted by an effect that specifically affects living creatures or undead creatures, or that affects both in different ways, you have a 50% chance to count as an undead creature rather than a living creature. You are immune to effects that specifically target your soul (such as trap the soul). However, while under the effect of this feat, you cannot benefit from beneficial mind-affecting effects, morale bonuses, or bardic performances.
        \nYou can use this feat's benefit for a number of rounds per floor equal to your ranks in Knowledge (planes).`,
        prereq: "",
        repeatable:true,
        },
        {
        name: "Wanderer's Fortune",
        type: "utility",
        shortDesc: "",
        longDesc: `As a swift action, you gain the benefits of freedom of movement until the end of your turn or until you benefit from the effects to escape a grapple or magical restraint, whichever comes first.
        \nYou can use this feat's benefit once per day, plus an additional time per day for every 5 ranks you have in Knowledge (planes).`,
        prereq: "",
        repeatable:true,
        },
        {
        name: "Wind Leaper",
        type: "utility",
        shortDesc: "",
        longDesc: `As a swift action, you can wrap your body in airy energies. This reduces your effective weight by half. While this ability is active, you gain a circumstance bonus on Acrobatics checks equal to half your ranks in Knowledge (planes), you are always treated as having a running start when attempting Acrobatics checks to jump, and your Acrobatics checks to high jump are treated as long jumps for the purpose of determining the DC.
        \nYou can use this feat's benefit for a number of rounds per day equal to your ranks in Knowledge (planes). These rounds need not be consecutive.`,
        prereq: "",
        repeatable:true,
        },
        {
        name: "Shadow's Shroud",
        type: "utility",
        shortDesc: "",
        longDesc: `As a swift action, you can shroud yourself in shifting, camouflaging shadow. While shrouded in this fashion, you can attempt Stealth checks as though you had concealment, even in areas of normal or bright light.

        Creatures that can see normally in supernatural darkness can still see you normally.
        
        You can use this feat's benefit for a number of rounds per day equal to your ranks in Knowledge (planes). These rounds need not be consecutive.`,
        prereq: "",
        repeatable:true,
        key:true,
        },
        {
        name: "Flickering Step",
        type: "utility",
        shortDesc: "",
        longDesc: `You can use dimension door as a spell-like ability with a caster level equal to your ranks in Knowledge (planes).

        You can't teleport a distance greater than twice your base speed in this way, and you must have both line of sight and line of effect to your destination.
        
        You can use this feat's benefit once per day, plus an additional time per day for every 5 ranks you have in Knowledge (planes).`,
        prereq: "",
        repeatable:true,
        },
        {
        name: "Gate Breaker",
        type: "martial",
        shortDesc: "",
        longDesc: "Whenever you would deal damage to an object, you deal normal damage plus an additional amount equal to your Strength modifier. This applies to both unattended objects and those you damage as part of a successful sunder combat maneuver check.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Relic Breaker",
        type: "martial",
        shortDesc: "",
        longDesc: "Whenever you sunder a held object, its bearer must succeed at a Reflex saving throw or the bearer catches on fire (taking 1d6 points of fire damage immediately, and an additional 1d6 points of fire damage each subsequent round the creature fails a Reflex saving throw). When your total Hit Dice reach 4, this damage increases by 1d6, and it increases by 1d6 every 4 levels thereafter. The saving throw's DC is equal to 10 + 1/2 level + highest mental modifier.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Smashing Style",
        type: "style",
        shortDesc: "",
        longDesc: "When you succeed at a sunder combat maneuver check against a suit of armor worn by an opponent, you can immediately attempt a bull rush or trip combat maneuver against that target with the same combat maneuver bonus. This maneuver does not provoke attacks of opportunity.",
        prereq: "",
        },
        {
        name: "Smashing Crush",
        type: "style",
        shortDesc: "",
        longDesc: "While using Smashing Style, if you successfully damage an object with the sunder combat maneuver, you reduce its hardness by 1. An object can't have its hardness reduced to less than 50% of its normal hardness, and its hardness is restored when the damage dealt by the sunder attack is repaired.",
        prereq: "Smashing Style",
        },
        {
        name: "Smashing Dent",
        type: "style",
        shortDesc: "",
        longDesc: "While using Smashing Style, each time you damage a suit of armor with a sunder combat maneuver, you reduce its armor bonus to its Armor Class by 1 and increase its armor check penalty by 1. Armor cannot have its armor bonus to AC reduced to less than 50% of its normal bonus or its armor check penalty more than doubled. These reductions and increases both end when the damage dealt by the sunder is repaired.",
        prereq: "Smashing Crush",
        },
        {
        name: "Sin Eater",
        type: "martial",
        shortDesc: "",
        longDesc: "Whenever a creature Claimed by you is reduced to 0 or fewer hit points, you gain temporary hit points equal to twice that creature's Hit Dice. These temporary hit points last for one minute.",
        prereq: "",
        perkPrereq:["Dark Claim","Crimson Claim","Maven's Claim", "Soul Claim"],
        repeatable:true,
        },
        {
        name: "Winds of War",
        type: "martial",
        shortDesc: "",
        longDesc: "You gain a +5-foot bonus to each of your movement speeds. This bonus increases by +5 feet for each creature you currently have Claimed.",
        prereq: "",
        perkPrereq:["Dark Claim","Crimson Claim","Maven's Claim", "Soul Claim"],  
        repeatable:true,      
        },
        {
        name: "Malevolence",
        type: "martial",
        shortDesc: "",
        longDesc: "Creatures Claimed by you become cursed and take a -2 penalty on combat maneuver checks and skill checks for as long as they are Claimed.",
        prereq: "",
        perkPrereq:["Dark Claim","Crimson Claim","Maven's Claim", "Soul Claim"],   
        repeatable:true,     
        },
        {
        name: "Grasp of Darkness",
        type: "martial",
        shortDesc: "",
        longDesc: "Whenever you use your Claim ability you can claim 3 enemies instead of one, and you recover 2 maneuvers instead of 1.",
        prereq: "",
        perkPrereq:["Dark Claim","Crimson Claim","Maven's Claim", "Soul Claim"],
        repeatable:true,
        },                
        {
        name: "Master Performer",
        type: "magic",
        shortDesc: "",
        longDesc: "Increase the bonus granted by your inspire courage by +1. You must spend the additional spell points every round to keep it active.",
        prereq: "",
        perkPrereq:["Bardic Performance"],
        repeatable:true,
        key:false,
        },
        {
        name: "Grand Master Performer",
        type: "magic",
        shortDesc: "",
        longDesc: "Increase the bonus granted by your inspire courage by an additional +1. You must spend the additional spell points every round to keep it active. Whenever you use timed advice you can add +1 to the result of the dice.",
        prereq: "Master Performer",
        perkPrereq:["Bardic Performance"],
        repeatable:true,
        },
        {
            name: "Violent Virtuoso",
            type: "martial",
            shortDesc: "",
            longDesc: "When using climax on an attack you deal additional damage equal to 3x the spell points spent instead of 2x the spell points spent.",            
            perkPrereq:["Bardic Performance"],
            repeatable:true,
        },
        // {
        //     name: "Crescendo",
        //     type: "martial",
        //     shortDesc: "",
        //     longDesc: "You can end your inspire courage as a swift action,",            
        //     perkPrereq:["Bardic Performance"],
        //     repeatable:true,
        // },
        // {
        //     name: "Unforgettable Melody",
        //     type: "martial",
        //     shortDesc: "",
        //     longDesc: "You can end your inspire courage as a swift action,",            
        //     perkPrereq:["Bardic Performance"],
        //     repeatable:true,
        // },
        {
            name: "Encore",
            type: "martial",
            shortDesc: "",
            longDesc: "You can activate climax an additional time per round. Whenever you climax on an attack that successfully confirms a critical hit, it deals bonus damage on the attack equal to your highest mental score. This bonus damage is only applied once and is not multiplied by other affects. If this attack kills the creature you restore level spell points and hit points and gain a morale bonus to your next attack roll equal to the amount of spell points spent on the previous climax.",
            prereq: "Violent Virtuoso",
        },
        {
            name: "Curtain Call",
            type: "martial",
            shortDesc: "",
            longDesc: "Every 4th time you activate climax on a floor the bonus damage you gain for it is doubled. You cannot spend more spell points on this 4th climax than you did on the previous 3 climaxes combined. Every 4th time you activate curtain call on a floor, it is an automatic potential critical hit, and its critical damage multiplier automatically becomes x4.",
            prereq: "Encore",
        },
        // {
        //     name: "Grand Finale",
        //     type: "martial",
        //     shortDesc: "",
        //     longDesc: "",
        //     prereq: "Encore",
        // },
        {
            name: "Every Movement Matters",
            type: "martial",
            shortDesc: "",
            longDesc: "Whenever you confirm a critical hit you can immediately move up to half your movement speed. This provokes as normal. When you climax, for every 4 points spent, you gain a +1 dodge bonus to your armor class until the start of your next turn, this stacks even with itself.",
            prereq: "Encore",
        },
        {
            name: "Flagbearer",
            type: "magic",
            shortDesc: "",
            longDesc: "When using inspire courage, you can use one of your hands to wield a flag (your hand becomes occupied for all purposes, and provides no other benefits), when you do so, the bonus you grant from inspire courage and timed advice increases by +1 as long as the ally can see the flag. This does not cost additional spell points per round, however it increases the activation action of inspire courage to be at least a movement action.",            
            perkPrereq:["Bardic Performance"],
        },
        {
            name: "Lord's Banner",
            type: "magic",
            shortDesc: "",
            longDesc: "If a creature who can see your flag shares an alignment component with you, or if they are the same race as you, the bonus they gain from inspire courage and timed advice increases by a further +1. This stacks if they share multiple alignment components and their race with you.",            
            prereq:"Flagbearer",
        },
        {
        name: "Dark Presence",
        type: "martial",
        shortDesc: "",
        longDesc: "Creatures claimed by you provoke attacks of opportunity when they take 5-foot steps into or out of your threatened squares.",
        prereq: "",
        perkPrereq:["Dark Claim","Crimson Claim","Maven's Claim", "Soul Claim"],        
        },
        {
        name: "Dark Authority",
        type: "martial",
        shortDesc: "",
        longDesc: "Creatures Claimed by you take a penalty on attack rolls against you equal to the number of creatures you currently have Claimed.",
        prereq: "",
        perkPrereq:["Dark Claim","Crimson Claim","Maven's Claim", "Soul Claim"],
        repeatable:true,
        },
        {
        name: "Dark Allure",
        type: "martial",
        shortDesc: "",
        longDesc: "Creatures Claimed by you take a penalty on attack rolls against creatures other than you equal to the number of creatures you currently have Claimed.",
        prereq: "",
        perkPrereq:["Dark Claim","Crimson Claim","Maven's Claim", "Soul Claim"],
        repeatable:true,
        },
        {
        name: "Battle Fervor",
        type: "martial",
        shortDesc: "",
        longDesc: "When you use fervor or lay on hands or fervor to heal yourself as a swift action or when you apply your guardian's shield to an ally, the next strike you initiate deals additional damage equal to half the amount of healing or temporary hit points granted.",
        prereq: "",
        perkPrereq:["Lay On Hands", "Fervor", "Guardian's Shield"],
        repeatable:true,
        },
        {
        name: "Trained Blacksmith",
        type: "utility",
        shortDesc: "",
        longDesc: "You can use a blanch on a weapon as a swift action, and its damage is increased by 1d6 while the blanch lasts. If the blanch has no base damage type then just increase the damage of the weapon by 1d6.",
        prereq: "",
        },
        {
        name: "Master Blacksmith",
        type: "utility",
        shortDesc: "",
        longDesc: "Your blances last 50% longer (minimum 1 round), and you can blanch an adjacent teammates weapon as a movement action. The damage increase from blancing weapons increases to 2d6.",
        prereq: "Trained Blacksmith",
        },
        {
        name: "Grandmaster Blacksmith",
        type: "utility",
        shortDesc: "",
        longDesc: "Your blanches last 100% longer (instead of 50% longer, minimum 2 rounds), and you can blanch an adjacent teammates weapon as a swift action and any weapon blanched by you has its damage dice increased by 1 step while the blanch lasts, on top of the damage increase from previous feats.",
        prereq: "Master Blacksmith",
        },
        {
        name: "Magic Blacksmith",
        type: "utility",
        shortDesc: "",
        longDesc: "When you use a spell or ability (not blanches) that empowers a weapon or armor you increase the numerical modifiers gained by that ability by 1, and weapons you empower this way deal 2d6 extra damage. This extra damage can be of the same element of the ability used if it would apply. Armor enhanced this way gives you DR -/3.",
        prereq: "Trained Blacksmith",
        },
        {
        name: "Hold the Line",
        type: "martial",
        shortDesc: "",
        longDesc: "You may make an attack of opportunity against a charging opponent who enters an area you threaten.",
        prereq: "",
        },
        // {
        // name: "Crimson Rush",
        // type: "magic",
        // shortDesc: "",
        // longDesc: "You can use your blood tap ability more than once per round, each additional time you do increase the damage you take by that tap by 25% per previous blood tap that round. When you use your blood tap ability your next siphon or damage spell that round deals 10% more damage, this stacks.",
        // prereq: "",
        // key:true,
        // perkPrereq:["Hemomancy", "Blood Tap"],
        // },
        {
        name: "Deep Well",
        type: "magic",
        shortDesc: "",
        longDesc: "Each time you blood tap you regain 3 spell points instead of 2 per dice rolled.",
        prereq: "",
        key:false,
        perkPrereq:["Hemomancy", "Blood Tap"],
        repeatable:true,
        },
        // {
        // name: "Calloused Soul",
        // type: "magic",
        // shortDesc: "",
        // longDesc: "You can apply your DR to the damage you take from blood tapping",
        // prereq: "",
        // key:false,
        // perkPrereq:["Hemomancy", "Blood Tap"],
        // },
        {
        name: "Weapon of the Chosen",
        type: "martial",
        shortDesc: "",
        longDesc: "As a swift action you can bless your weapon so that your next attack that round your weapon counts as magical for the purposes of overcoming DR and striking incorporeal creatures, and you can reroll your miss chance one time to hit your target",
        prereq: "",
        },
        {
        name: "Improved Weapon of the Chosen",
        type: "martial",
        shortDesc: "",
        longDesc: "As a swift action you can bless your weapon so that the rest of your attacks this round your weapon counts as magical for the purposes of overcoming DR and striking incorporeal creatures, and you can reroll your miss chance one time to hit your target. Your weapon also counts as your alignment for overcoming DR and bypasses material based DR requirements",
        prereq: "Weapon of the Chosen",
        },
        {
        name: "Greater Weapon of the Chosen",
        type: "martial",
        shortDesc: "",
        longDesc: "When using the attack action to make an attack you can roll twice for your attack roll and take the higher result. This reroll does not apply to confirmation rolls.",
        prereq: "Improved Weapon of the Chosen",
        },
        {
        name: "Giant Slayer",
        type: "martial",
        shortDesc: "",
        longDesc: "When you make a charge attack, you do not provoke attacks of opportunity from the target of your charge. In addition, you gain a +1 bonus on attack rolls made during charges for each size category larger than you the target of the attack is.",
        prereq: "",
        },
        {
            name: "Lurker in Darkness",
            type: "utility",
            shortDesc: "",
            longDesc: "Creatures using unusual forms of sensory perception such as blindsight, greensight, or tremorsense cannot automatically foil your use of Stealth; such creatures must make a Perception check as normal to detect you when you make use of the Stealth skill, but you gain no bonuses based on sight such as cover or invisibilty, and they gain a +10 to the check.",
            prereq: "",
        },
        {
            name: "Suffer With Grace",
            type: "utility",
            shortDesc: "",
            longDesc: "When you are forced to make a Will save against a mind-affecting effect with a duration longer than 2 rounds you may choose to automatically fail it. If this option is chosen, the effect's duration is reduced by 2 rounds to a minimum of 2 rounds. You cannot make re-saves as a full round action if you use this, (unless the ability would otherwise allow it)",
            prereq: "",
        },
        {
            name: "It Is What It Is",
            type: "utility",
            shortDesc: "",
            longDesc: "When you use Suffer With Grace you can make rerolls on your turn, but if you succeed it only reduces the duration of the affect by 1 round.",
            prereq: "Suffer With Grace",
        },
        {
            name: "You Get Used To It",
            type: "utility",
            shortDesc: "",
            longDesc: "When you use suffer with grace you can re-save as normal to end the effect prematurely as normal, or you can choose to not and just automatically reduce its duration by 1 round.",
            prereq: "It Is What It Is",
        },
        {
        name: "Reckless Offense",
        type: "martial",
        longDesc: "When you attack in melee, you can take a penalty of -4 to your Armor Class and add a +2 bonus on your melee attack roll. The bonus on attack rolls and penalty to Armor Class last until the beginning of your next turn.",
        prereq: "",
        key:true,
        repeatable:true,
        },
        {
            name: "Extreme Recklessness",
            type: "martial",
            longDesc: "The bonus to attack and penalty to AC given by reckless offense increases by 1 and -2 every 8 BAB (respectively).",
            prereq: "Reckless Offense",
        },
        {
        name: "Arcane Link",
        type: "utility",
        shortDesc: "Increase your maximum spell points by your level",
        longDesc: "You gain 6 spell points, and gain 3 additional spell points for each level you have.",
        prereq: "",
        key:true,
        repeatable:true,
        },
        {
        name: "Align Equipment",
        type: "magic",
        shortDesc: "You can imbue weapons, shields, and armor with a special ability listed in the table (see text).",
        longDesc: "In addition to the blessings provided by Bless Equipment, you can imbue weapons or armor with alignment based special abilities. Aligned equipment blessings otherwise follow all the same rules as the equipment blessings granted by Bless Equipment. If used for weapons you can spend 3 uses for anarchic, holy, axiomatic, or unholy. If used on you can spend 6 for them to grant righteous might, unbound, unrighteous, or vigilant.",
        prereq: "Bless Equipment",
        },
        {
        name: "Arcane Blast",
        type: "magic",
        shortDesc: "Sacrifice a spell to make ray attack.",
        longDesc: "As a standard action, you can sacrifice a spell slot of 1st level or higher and transform it into a ray, targeting any foe within 30 feet as a ranged touch attack. This attack deals 2d6 points of damage plus an additional 1d6 points of damage for every level of the spell or spell slot you sacrificed. 0-level spells may not be sacrificed in this manner.",
        prereq: "",
        },
        {
        name: "Arcane Insight",
        type: "magic",
        shortDesc: "You gain a +1 insight bonus to your AC for 1 round when you use the Arcane Shield feat.",
        longDesc: "Whenever you use Arcane Shield, you also gain a 1, +1 per 5 levels insight bonus to AC for 1 round.",
        prereq: "Arcane Shield",
        repeatable:true,
        },
        {
        name: "Arcane Shield",
        type: "magic",
        shortDesc: "Sacrifice a spell to gain deflection bonus to AC.",
        longDesc: "As a immediate action, you can sacrifice a spell slot of 1st level or higher and gain a deflection bonus to AC equal to the level of the spell or spell slot you sacrificed for 1 round. 0-level spells may not be sacrificed in this manner.",
        prereq: "",
        },
        {
        name: "Arcane Vendetta",
        type: "martial",
        shortDesc: "+2 bonus on damage vs. arcane spellcasters.",
        longDesc: "You deal bonus damage with weapon attacks made against any target you have witnessed casting an arcane spell (not using a spell-like ability) in the last 5 rounds. You must have successfully identified the spell with a Spellcraft check to know without a doubt that the spell is arcane. The bonus damage is equal to 1+ the level of the spell cast.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Augment Summoning",
        type: "magic",
        shortDesc: "Summoned creatures gain +4 Str and Con.",
        longDesc: "Each creature you conjure with any summon spell gains a +4 enhancement bonus to Strength and Constitution for the duration of the spell that summoned it.",
        prereq: "",
        repeatable:true,
        key:true,
        },
        {
            name: "Improved Augment Summoning",
            type: "magic",
            shortDesc: "Summoned creatures gain +4 Str and Con.",
            longDesc: "Each creature you conjure with any summon spell gains an additional +4 enhancement bonus to Strength and Constitution for the duration of the spell, on their first attack each round they gain a bonus to their damage equal to your highest mental score.",
            prereq: "Augment Summoning",
            repeatable:true,
        },
        {
            name: "Skilled Summons",
            type: "magic",
            shortDesc: "Summoned creatures gain +4 Str and Con.",
            longDesc: "When you summon a creature, they gain one martial feat you possess as a bonus feat.",
            prereq: "",
        },
        {
            name: "Cooperative Summons",
            type: "magic",
            shortDesc: "Summoned creatures gain +4 Str and Con.",
            longDesc: "When you summon a creature, they gain one teamwork feat you know as a bonus feat, though they gain its benefits only when cooperating with you or with other creatures you have summoned.",
            prereq: "",
        },        
        {
            name: "Unstable Summons",
            type: "magic",
            shortDesc: "Summoned creatures gain +4 Str and Con.",
            longDesc: "When you summon a creature you can choose for them to become unstable summons, then if they are reduced to below 0 hit points, they make a blast of energy around them, dealing 1d3 of force damage per 2 HD the creature had in a 10-ft radius burst. Creature within the range can make a reflex save to reduce the damage by half, DC 10 + summoned creature HD/2, + creatures con mod. If the creature has an elemental subtype, you can increase the damage to 1d6 of that elemental type. A creature summoned with this feat has its duration reduced by 50%.",
            prereq: "",
        },
        {
            name: "Time Bomb",
            type: "magic",
            shortDesc: "Summoned creatures gain +4 Str and Con.",
            longDesc: "When you summon a creature augmented by unstable summons, they explode if their duration runs out, or if they are killed. When they do, it deals 1d4 points of force damage per 2 HD the creature had in a 10-foot radius, though it allows a reflex save to halve (dc=10 + its HD/2). As a standard action you can command a creature you summoned that was augmented by this feat to explode, if it does the damage increases to 1d6 force damage per 2 HD, you can command multiple creatures at once to explode. If the creature explodes due to its duration running out, it deals 1d4",
            prereq: "Unstable Summons",
        },
        {
            name: "Ferocious Summons",
            type: "magic",
            shortDesc: "Summoned creatures gain +4 Str and Con.",
            longDesc: "Creatures you summon no longer disappear when they reach 0 hit points unless they also become unconscious. Additionally, creatures you summon gain the ferocity universal monster ability.",
            prereq: "",
        },
        {
            name: "Frightening Ambush",
            type: "martial",
            shortDesc: "",
            longDesc: "As a free action, you can attempt an Intimidate check to demoralize a flat-footed opponent you attack. You gain a +4 bonus on these attempts.",
        },
        {
        name: "Bestow Hope",
        type: "magic",
        shortDesc: "When you heal a creature by channeling positive energy, you also relieve its fear.",
        longDesc: "When you heal a creature using the prereq healing perk, you can expend level/2 spell points to also relieve its fear. If a creature you heal is shaken, that condition ends. If the creature is frightened, it becomes shaken instead. If the creature is panicked, it becomes frightened instead. Good creatures with this feat can activate it for free.",
        prereq: "",
        perkPrereq:["Channel Energy", "Epic Channel Energy", "Lay On Hands", "Touch of Corruption", "Guardian's Shield", "Fervor","Hemomancy", "Hexes"],
        },
        {
            name: "Foment the Blood",
            type: "magic",
            shortDesc: "When you heal a creature by channeling positive energy, you also relieve its fear.",
            longDesc: "When you use a healing prerequisite ability, instead of creating its normal effect, you can give allies a bonus on weapon damage and critical hit confirmation rolls until your next turn. This bonus is equal to the number of dice your ability normally heals or harms, however orcs, lizardfolk, hobgoblins, goblins, and mutants gain double the bonus. You can choose each creature individually on which bonus it gains.",
            prereq: "",
            perkPrereq:["Channel Energy", "Epic Channel Energy", "Lay On Hands", "Touch of Corruption", "Guardian's Shield", "Fervor", "Hemomancy", "Hexes"],
        },
        {
        name: "Bewildering Koan",
        type: "magic",
        shortDesc: "Confuse a creature by bluffing them with an impossible question.",
        longDesc: "As a swift action, spend 2 spell point and make a Bluff check by asking a creature one of the impossible questions you ponder when meditating. the creature makes a sense motive with your bluff as the dc. if it fails you choose whether it loses its next action or you gain a +2 bonus on all damage rolls you make against that creature for 1 round.",
        prereq: "",
        },
        {
            name: "Spirit's Reach",
            type: "magic",
            shortDesc: "",
            longDesc: "Your hexes have their range increased by 50%.",
            prereq: "",
            perkPrereq:["Hexes"],
        },
        {
        name: "Big Game Hunter",
        type: "martial",
        shortDesc: "+1 bonus on attack rolls and +2 bonus on weapon damage rolls against Large or larger creatures. this increases by +1 attack and +2 damage every 5 levels you posses",
        longDesc: "For each size catagory larger than large the creature is than you gain a +1 to attack and a +2 to damage with weapon attacks.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Blasting Charge",
        type: "magic",
        shortDesc: "Expend a spell slot while Raging to add force damage to your charge attack.",
        longDesc: "At the end of a charge you can expend a spell slot as a swift action to imbue your charge attack with extra power. You deal an additional 1d6 points of damage per level of the spell slot expended. This extra damage is force damage, and it's not multiplied in the case of a critical hit. If your spell has a specific energy type associated with it  you can choose to increase the damage to 1d8 points per level of the spell slot expended, and this extra damage is of that energy type.",
        prereq: "",
        },
        {
        name: "Bless Equipment",
        type: "magic",
        shortDesc: "Expend channel energy uses to grant one weapon, suit of armor, or shield a weapon, armor, or shield special ability.",
        longDesc: "As a standard action, you may expend uses of your channel energy, lay on hands, or fervor ability to touch a single weapon or armor to temporarily grant it one special ability. Different blessings cost a different amount of daily uses of channel energy. This blessing lasts for a number of rounds equal to your channel energy's dice rolled. You can grant a piece of equipment only one blessing at a time. If blessing a weapon you can spend 2 uses for bane, ghost touch or +2, 3 for disruption, lifesurge +3, or 4 for nullifying or +4. If armor you can spend 2 for deathless, stanching +2, or 3 for ghost touch or +3, or 4 for +4.",
        prereq: "",
        perkPrereq:["Channel Energy", "Epic Channel Energy", "Lay On Hands", "Touch of Corruption", "Guardian's Shield", "Fervor"],
        key:true,
        },
        {
        name: "Ultimate Mercy",
        type: "magic",
        shortDesc: "",
        longDesc: "You can expend 10 uses of your prereq healing perk to bring a single dead creature you touch back to life as a raise dead spell with a caster level equal to your level.",
        prereq: "",
        perkPrereq:["Channel Energy", "Epic Channel Energy", "Lay On Hands", "Fervor"],
        key:true,
        },
        {
        name: "Greater Mercy",
        type: "magic",
        shortDesc: "",
        longDesc: "When you heal using a prereq ability you heal an additional dice of of damage. You do not need to spend the additional spell points to use this ability.",
        prereq: "",
        perkPrereq:["Channel Energy", "Epic Channel Energy", "Lay On Hands", "Touch of Corruption", "Hexes", "Fervor", "Bardic Performance"],
        },
        {
            name: "Hands of Valor",
            type: "magic",
            shortDesc: "",
            longDesc: "Once per day when you use a healing prereq ability, you can also imbue a single ally with valor. In addition to the normal effects of the ability, the targeted ally gains a sacred bonus on attack rolls and on saves against fear effects equal to your highest mental modifier (minimum +1) for level/2 rounds.",
            prereq: "",
            perkPrereq:["Channel Energy", "Epic Channel Energy", "Lay On Hands", "Hexes", "Fervor", "Bardic Performance"],
        },
        {
        name: "Improved Bless Equipment",
        type: "magic",
        shortDesc: "Reduce the number of uses of channeled energy you must expend to bless a piece of equipment using Bless Equipment and Align Equipment decreases by one (to a minimum of one).",
        longDesc: "The number of uses of channeled energy or lay on hands you must expend to bless a piece of equipment using Bless Equipment and Align Equipment decreases by one (to a minimum of one use of channel energy per blessing). You can also bless a piece of equipment with up to two blessings at a time. Each blessing provides a different special ability drawn from the Bless Equipment list (and the Align Equipment list if you possess that feat). You expend the appropriate number of uses of channeled energy required for each blessing, taking into account the reduction granted by this feat.",
        prereq: "Bless Equipment",
        },
        {
        name: "Greater Bless Equipment",
        type: "magic",
        shortDesc: "The duration of your equipment blessings doubles and as a standard action you may bless up to two pieces of equipment with a single blessing, expending uses of channeled energy as if you had only blessed one item.",
        longDesc: "The duration of your equipment blessings doubles. In addition, as a standard action you may bless up to two pieces of equipment within range with a single blessing, expending uses of channeled energy or lay on hands as if you had only blessed one item.",
        prereq: "Improved Bless Equipment",
        },
        {
        name: "Bloatmage Initiate",
        type: "magic",
        shortDesc: "Learn the secret art of hemotheurgy to enhance your spells.",
        longDesc: "You learn the basics of the ancient art of hemotheurgy. Pick one school of magic (damage, control, buff, healing, or utility), you cast spells from this school of magic at +1 caster level. Unfortunately, the bloating side effects increase your girth to such a point that your maximum dexterity bonus to armor class becomes +3, you gain an armor check penalty of -3, and you reduce your speed by 10 feet.",
        prereq: "",
        repeatable:true,
        },
        {
            name: "All In Your Head",
            type: "utility",
            shortDesc: "",
            longDesc: "If you refuse to believe it exists, it definitely cant hurt you. Once per floor when you would make a fortitude or reflex save you can instead make a will save.",
            prereq: "",
        },
        {
        name: "Well Prepared",
        type: "utility",
        shortDesc: "",
        longDesc: "Once per floor as a movement action you can gain a piece of utility gear that has a stack size of larger than one, (but you only gain 1). When you gain it you can choose for it to be in your bag, or in your hand. This gear must be used on this floor or it disappears.",
        prereq: "",
        key:true,
        },
        {
        name: "Very Well Prepared",
        type: "utility",
        shortDesc: "",
        longDesc: "When you use well prepared you can even choose to gain a utility gear item with a stack size of one, otherwise when you gain a gear item you gain a full stack of it. Additionally, when you use well prepared the types of gear items you can gain also includes grenades and blanches, but if you do they must have a stack size larger than one, and you only gain 1 item. All gained items must still be used on the floor they are gained or they disappear.",
        prereq: "Well Prepared",
        },
        {
            name: "Never Ending Bag of Tricks",
            type: "utility",
            shortDesc: "",
            longDesc: "You can now use well prepared twice per floor. Additionally, when you use well prepared to gain a grenade or blanch it creates a full stack. It still can only be grenades or blances with more than 1 in its stack.",
            prereq: "Very Well Prepared",
        },
        {
            name: "Reveal Machinations",
            type: "utility",
            shortDesc: "",
            longDesc: "You always knew exactly this would happen, thats why you prepared accordingly. Once per floor you can activate this feat as a full-round action, while declaring 'All according to plan', all players that can hear you can pull out and use a gear item as an immediate action (except you, you're busy posing). During the full-round action to activate this feat you can also choose to use the benefit of well prepared once, or use a gear item you were already holding. All monsters that can hear and understand you with an intelligence score higher than 20 become shaken for one round, even if they would normally be immune to fear. All players who use this immediate action are staggered on their next turn (even if they are immune to stagger, and it cant be healed or reduced)",
            prereq: "Never Ending Bag of Tricks",
        },
        {
        name: "Blood Disciple",
        type: "magic",
        shortDesc: "Combine your blood and unholy water to create potions.",
        longDesc: "For 3 spell points and 1 point of constitution damage you can use your own blood to create a potion of cure light wounds or a potion of inflict light wounds as a movement action. At level 4 you create a moderate wounds potion, at 8 it becomes serious, at 12 it becomes critical, at 16 it becomes cure devastating",
        prereq: "",
        },
        {
            name: "Overwhelming Destruction",
            type: "magic",
            shortDesc: "",
            longDesc: "Critical Spells gain a +2 bonus to their DC and you gain 10% universal spell critical power.",
            prereq: "",
            hasCustomMethod: true,
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellCriticalDamage.universal += 10
            }
        },
        {
        name: "Blood Vengeance",
        type: "martial",
        shortDesc: "Enter a rage-like state when one of your allies is taken down.",
        longDesc: "Whenever one of your worthy allies (only party members) is brought to negative hit points or killed, you may enter a state similar to but less powerful than a barbarian's rage as a free action on your turn. If you have the rage class feature and are already raging, your morale bonuses to Strength and Constitution increase by +2 for the duration of your rage. If you do not have the rage class feature, or you have no more rage rounds left, this weaker rage gives you all the benefits and penalties of a rage, except your morale bonus to Strength and Constitution is only +2, and this state lasts for 4 rounds. As with a barbarian's rage, when this weaker rage ends, you are fatigued; if another ally falls before this duration ends, the weaker rage lasts for 4 more rounds after that. This feat does not allow you to enter a rage if you are fatigued. You may only use this feat if the fallen ally had at least as many Hit Dice as you - 4.",
        prereq: "",
        },
        {
        name: "Bloodletting",
        type: "martial",
        shortDesc: "Whenever you threaten a creature with a critical hit inflict bleed damage in subsequent rounds.",
        longDesc: "Whenever you threaten a critical hit with a piercing or slashing weapon (regardless of whether you confirm the critical hit or not), you deal 1 point of bleed damage +1 per 4 levels to the targeted creature.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Bolstered Resilience",
        type: "utility",
        shortDesc: "Increase DR against a single attack.",
        longDesc: "As an immediate action, you can double your DR against a single attack, to a maximum of DR 20. The type of the DR remains unchanged. If the attack you are guarding against is not successful, the increased damage reduction persists until you are hit with an attack or until the start of your next turn, whichever happens first. At the start of your next turn, you become fatigued. You cannot use this feat while you are fatigued.",
        prereq: "",
        },
        {
        name: "Branded for Retribution",
        type: "martial",
        shortDesc: "Grant ally's weapon the Bane quality against a branded opponent.",
        longDesc: "As a standard action, expend 3 rounds of your bane class feature and make a melee touch attack with the weapon affected by bane. If you hit, your target takes no damage but is branded until the start of your next turn. While this brand remains, your allies' weapons are considered to have the bane ability with which your weapon is imbued when they attack the branded creature.",
        perkPrereq: ["Bane"],
        },
        {
        name: "Burning Amplification",
        type: "magic",
        longDesc: "Gain 5 fire spell power. Whenever you cast a spell with the fire descriptor, you can take a -1 penalty on the spells' attack rolls and reduce the spell's saving throw DC by 1 to cause any target that is dealt fire damage to catch on fire. The targets do not take burning damage for catching on fire until their next turn, and each target can attempt a Reflex saving throw to put out the fire before being damaged each round. Rather than the normal DC 15 Reflex saving throw to put the fire out, the target must succeed at a Reflex saving throw with a DC equal 10 + the spell's level + the modifier of your spellcasting ability score). You must choose to use this feat before making an attack roll or before your targets attempt their saving throws. This feat has no effect on spells that neither allow a saving throw nor require an attack roll.",
        prereq: "",
        hasCustomMethod: true,
        catchUpMethod:(context)=>{
            context.stats.characterStats.spellMastery.spellPower.fire += 5
        }
        },
        {
            name: "Improved Burning Amplification",
            type: "magic",
            longDesc: "Gain 5 fire spell power. When using Burning Amplification you can choose to reduce your attack roll or DC by an additional -2 to cause creatures that catch on fire to also become shaken for 1 round. This is a mind-effecting fear effect.",
            prereq: "Burning Amplification",
            hasCustomMethod: true,
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellPower.fire += 5
            }
        },
        {
            name: "Greater Burning Amplification",
            type: "magic",
            longDesc: "Gain 5 fire spell power. When using Improved Burning Amplification you can instead choose to reduce your attack roll or DC by -4 to cause creatures that catch on fire to also become shaken for the duration of them being on fire. This is a mind-effecting fear effect, however if the creature is undead and you are using wisdom to cast the spell, it must still make the save (unless it would be immune to mind-effecting or fear effects for other reasons)",
            prereq: "Improved Burning Amplification",
            hasCustomMethod: true,
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellPower.fire += 5
            }
        },
        {
        name: "Burn! Burn! Burn!",
        type: "magic",
        shortDesc: "You deal an extra 1d4 fire damage with non-magical or alchemical attacks (such as with torches or alchemical fire) and gain a +4 competence bonus to Reflex saves to avoid catching on fire or putting yourself out when on fire.",
        longDesc: "You deal an extra 1d4 points of fire damage when you attack with fire and gain a +4 competence bonus on Reflex saving throws made to avoid catching on fire or to put yourself out when on fire.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Butterfly's Sting",
        type: "martial",
        shortDesc: "When you confirm a critical hit you may instead deal normal damage and grant the next ally to hit the same creature with a melee attack an automatic critical hit.",
        longDesc: "When you confirm a critical hit against a creature, you can choose to forgo the effect of the critical hit and grant a critical hit to the next ally who hits that creature with a melee attack before the start of your next turn. Your attack only deals normal damage, and the next ally to hit the target automatically confirms the attack as a critical hit.",
        prereq: "",
        },
        {
        name: "Careful Sneak",
        type: "utility",
        shortDesc: "Use Stealth slowly without penalty from most armor",
        longDesc: "You do not apply the armor check penalty for light and medium armor on Stealth skill checks as long as you move half your speed or less. You still cannot run or charge while using Stealth in this way.",
        prereq: "",
        },
        {
        name: "Cartwheel Dodge",
        type: "utility",
        shortDesc: "With a successful evasion you may move half your speed.",
        longDesc: "When you successfully use evasion to avoid taking damage, you can move up to half your speed as an immediate action. This movement provokes attacks of opportunity as normal.",
        prereq: "",
        perkPrereq:["Evasion"]
        },
        {
        name: "Cat's Fall",
        type: "utility",
        shortDesc: "Take less damage when falling and always land on your feet",
        longDesc: "When you succeed at a DC 15 Acrobatics skill check to soften a fall, you ignore the first 20 feet of that fall and convert the damage from the next 10 feet of the fall to nonlethal damage. You land on your feet as long as you take less than 20 points of damage from the fall.",
        prereq: "",
        },
        {
        name: "Charnel Soldiers",
        type: "magic",
        shortDesc: "When you create undead, they gain one teamwork feat you know as a bonus feat, though they gain its benefits only when cooperating with you or with other undead that you have created. If you control undead with the Command Undead feat or a spell like command undead, they likewise gain one teamwork feat you know as a bonus feat as long as they remain under your control. Intelligent undead gain no benefit from this feat.",
        longDesc: "When you create undead, they gain one teamwork feat you know as a bonus feat, though they gain its benefits only when cooperating with you or with other undead that you have created. If you control undead with the Command Undead feat or a spell like command undead, they likewise gain one teamwork feat you know as a bonus feat as long as they remain under your control. Intelligent undead gain no benefit from this feat.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Chilling Amplification",
        type: "magic",
        longDesc: "Gain 5 cold spell power. Whenever you cast a spell with the cold descriptor, you can take a -1 penalty on attack rolls made with the spell and reduce the spell saving throw's DC by 1 to cause any target that is dealt cold damage by the spell to have its movement speed reduced by 5 feet and become unable to take 5-foot steps. This effect lasts for 1 round + 1 round per 3 spell levels of the spell. You must choose to use this feat before making an attack roll or before your targets attempt their saving throws. This feat has no effect on spells that neither allow a saving throw nor require an attack roll.",
        prereq: "",
        hasCustomMethod: true,
        catchUpMethod:(context)=>{
            context.stats.characterStats.spellMastery.spellPower.cold += 5
        }
        },
        {
            name: "Improved Chilling Amplification",
            type: "magic",
            longDesc: "Gain 5 cold spell power. When using chilling amplification you can choose to also reduce the attack roll or DC by a further -1 to also cause the creature to take a -1 penalty to armor class and reflex saves, with another additional -1 penalty for each 3 levels of the spell. This penalty lasts 1 round.",
            prereq: "Chilling Amplification",
            hasCustomMethod: true,
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellPower.cold += 5
            }
        },
        {
            name: "Greater Chilling Amplification",
            type: "magic",
            longDesc: "Gain 5 cold spell power. When using Improved Chilling Amplification you can choose to also reduce the attack roll or DC by a further -2 to cause the penalty to last 1 round, +1 round per 3 spell levels. The penalty does not stack.",
            prereq: "Improved Chilling Amplification",
            hasCustomMethod: true,
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellPower.cold += 5
            }
        },
        {
            name: "Corrosive Amplification",
            type: "magic",
            shortDesc: "",
            longDesc: "Gain 5 acid spell power. Whenever you cast a spell with the acid descriptor, you can take a -1 penalty on attack rolls made with the spell and reduce the spell saving throw's DC by 1 to cause any target that is dealt acid damage by the spell to wracked with pain for 3 rounds, and take a -2 penalty on any concentration checks it must make. This penalty increases by an additional -1 for each 2 levels of the spell. You must choose to use this feat before making an attack roll or before your targets attempt their saving throws. This feat has no effect on spells that neither allow a saving throw nor require an attack roll, and this is a mind-effecting pain effect.",
            prereq: "",
            hasCustomMethod: true,
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellPower.acid += 5
            }
        },
        {
            name: "Improved Corrosive Amplification",
            type: "magic",
            shortDesc: "",
            longDesc: "Gain 5 acid spell power. When using Corrosive Amplifcation you can reduce the attack or DC by an additional -1 to also cause the creatures pain to linger, however this only effects acid spells that deal continuous damage such as acid arrow, the pain lingers as long as the acid spell continues to deal damage to the creature.",
            prereq: "Corrosive Amplification",
            hasCustomMethod: true,
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellPower.acid += 5
            }
        },
        {
            name: "Greater Corrosive Amplification",
            type: "magic",
            shortDesc: "",
            longDesc: "Gain 5 acid spell power. When using Corrosive Amplifcation you can reduce the attack or DC by an additional -2 to also cause the creatures pain to interfere with its other actions, causing it to take a -1 penalty on attack rolls, -1 for each 3 levels of the spell, this lasts as long as the pain lingers.",
            prereq: "Improved Corrosive Amplification",
            hasCustomMethod: true,
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellPower.acid += 5
            }
        },
        {
        name: "Clarity of Pain",
        type: "utility",
        shortDesc: "Damage yourself to fight off a charm or compulsion",
        longDesc: "Three times per day, as an immediate action when you fail a saving throw against a charm or compulsion effect, you can inflict 1d6 points of slashing, piercing, or bludgeoning damage to yourself in order to reroll that saving throw. You can't reroll the saving throw if you negate the damage, such as by having damage reduction greater than or equal to the damage you dealt to yourself; instead, you spend the immediate action and daily use of this feat but gain no benefit. You must take the result of the second roll, even if it is worse.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Combat Advice",
        type: "utility",
        shortDesc: "Grant an ally a competence bonus on next attack roll against a chosen enemy.",
        longDesc: "As a move action, you can offer useful advice to an ally engaged in combat at just the right moment. Designate an enemy; your ally gains a +2 competence bonus on her next attack roll against that enemy. For your ally to benefit from this feat, you must be able to clearly see your ally and the designated enemy, and your ally must be able to hear you. For every 6 ranks you have in the knowledge skill used to identify a monster's weakness, the bonus this feat grants increases by +1.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Combat Casting",
        type: "magic",
        key:true,
        shortDesc: "+4 bonus on concentration checks for casting defensively.",
        longDesc: "You get a +4 bonus on concentration checks made to cast a spell or use a spell-like ability when casting on the defensive or while grappled.",
        prereq: "",
        repeatable:true,
        },
        {
            name: "Dastardly Trick",
            type: "martial",
            shortDesc: "Your antics in combat cause others to suffer a -2 penalty to Perception and Concentration checks.",
            longDesc: "When you attempt a dirty trick combat maneuver check you can expend level/2 spell points, if the maneuver is successful, your opponent must succeed at a Will save (DC = 10 + 1/2 level + highest mental modifier) to remove its dirty trick condition.",
            prereq: "",
            featRateUp:["Improved Dirty Trick"]
        },
        {
        name: "Combat Distraction",
        type: "martial",
        shortDesc: "Your antics in combat cause others to suffer a -2 penalty to Perception and Concentration checks.",
        longDesc: "As a full-round action, you can choose to do something that seems to serve no useful purpose. Example actions could include laughing at another creature's misfortune, rooting in your pockets for a snack, bending over to pick up what looks like a weird bug, or trying to fly into the air by flapping your arms like a sea gull. Although you're acting like a lunatic, your unpredictable actions are distracting. All creatures that see you must make a will save dc 10+ your performance score or receive a -2 penalty to all d20 rolls for 1 round",
        prereq: "",
        },
        {
        name: "Conceal Scent",
        type: "utility",
        shortDesc: "Creatures cannot track you by scent.",
        longDesc: "Creatures cannot use the scent ability to track you (though they can still track you through standard means such as footprints). Creatures with scent can detect your presence by smell at half the normal distance, but cannot pinpoint your location with scent.",
        prereq: "",
        },
        {
        name: "Confounding Tumble Deed",
        type: "martial",
        shortDesc: "When you avoid attacks of opportunity and hit a foe, you can deny it its Dex bonus to AC for 1 round.",
        longDesc: "When you use Acrobatics to move through an opponent's threatened area or space without provoking an attack of opportunity from that opponent and then hit that foe with a melee attack in the same round, as a free action you can spend level/2 spell points to deny that foe its Dexterity bonus to its armor class until the end of your next turn.",
        prereq: "",
        },
        {
        name: "Contingent Channeling",
        type: "magic",
        shortDesc: "May transfer positive energy to ally who can use it to heal.",
        longDesc: "You can use a standard action to touch an ally and expend one of your daily uses of channel energy, lay on hands, or fervor to create a repository of positive energy within that ally. This repository contains the same number and type of dice as normal for your channel energy or lay on hands feature, and it lasts for 1 minute. An ally who has such a repository can use an immediate action to roll the repository's dice and regain a number of hit points equal to the result. If an ally who has such a repository is reduced to negative hit points, the repository triggers, allowing the ally to heal without using an action.",
        prereq: "",
        perkPrereq:["Channel Energy", "Epic Channel Energy", "Lay On Hands", "Touch of Corruption", "Fervor"]
        },
        {
        name: "Cooperative Counterspelling",
        type: "teamwork",
        shortDesc: "When you and an ally with this feat both ready actions to counterspell, you gain additional counterspelling options",
        longDesc: "When you and an ally who also has this feat both ready an action to counterspell, you can counter a spell if you both expend any spell of the same level and school as the spell you wish to counter. If you both attempt to counterspell with dispel magic, you each gain a +2 bonus on your caster level checks. If you have more than one ally readying an action to counterspell, you can select only one of those allies for the purpose of this feat, and that ally must also select you.",
        prereq: "",
        },
        {
        name: "Coordinated Blast",
        type: "teamwork",
        shortDesc: "Exclude allies with this feat from area spells and abilities",
        longDesc: "Whenever you use a spell or ability with an area (such as fireball or channel energy), you can exclude any number of allies who also have this feat from that area of effect.",
        prereq: "",
        },
        {
        name: "Counterpoint to Inspiration",
        type: "teamwork",
        shortDesc: "When an ally with this feat is within 60 feet and uses a bardic performance or raging song that grants allies a morale bonus or competence bonus, you may perform the same bardic performance or raging song to increase those bonuses by +1. This increase only lasts as long as you and your ally each maintain the same performance, and cannot be extended with effects like Lingering Performance. Additional bards with this feat beyond the second don't increase the bonuses further.",
        longDesc: "When an ally with this feat is within 60 feet and uses a bardic performance or raging song that grants allies a morale bonus or competence bonus, you may perform the same bardic performance or raging song to increase those bonuses by +1. This increase only lasts as long as you and your ally each maintain the same performance, and cannot be extended with effects like Lingering Performance. Additional bards with this feat beyond the second don't increase the bonuses further.",
        prereq: "",
        },
        {
        name: "Triangulate",
        type: "teamwork",
        shortDesc: "",
        longDesc: "Whenever both you and an ally who also has this feat are within 30 feet of an invisible foe of whose presence you're aware, you automatically pinpoint the foe's location. Whenever both you and an ally who has this feat are within 30 feet of a creature and you miss that creature because of its concealment, you can reroll your miss chance percentile roll.",
        prereq: "",
        },
        {
        name: "Counterspell, Improved",
        type: "magic",
        shortDesc: "Counterspell with spell of the same school.",
        longDesc: "When counterspelling, you may use a spell of the same school that is one or more spell levels higher than the target spell.",
        prereq: "",
        },
        {
        name: "Deny Death",
        type: "utility",
        shortDesc: "Use ki to stave off death.",
        longDesc: "As long as you have 1 spell point, when you fail your Constitution check to stabilize, you do not lose 1 hit point. If you succeed at the check, you can spend 1 spell point to heal 1d6 hit points. If you roll a natural 20 on the check to stabilize, you can spend 1 spell point to heal 2d6 hit points of damage instead.",
        prereq: "",
        },
        {
        name: "Destroy Identity",
        type: "martial",
        shortDesc: "Whenever you score a critical hit target takes Charisma damage and becomes staggered.",
        longDesc: "Whenever you confirm a critical hit against an opponent, in addition to dealing critical damage as normal, you maim your target so much that it takes 2 points of Charisma damage and becomes staggered for 1 round.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Destructive Dispel",
        type: "martial",
        shortDesc: "Upon successful dispel, opponent must save or is stunned.",
        longDesc: "When you successfully make a targeted dispel check against an opponent, that opponent must succeed at a Fortitude save (DC equals the DC of the spell used to dispel) or be stunned until the start of your next turn. If the save succeeds, the opponent is instead sickened until the start of your next turn.",
        prereq: "",
        },
        {
        name: "Dimensional Agility",
        type: "martial",
        shortDesc: "May take any additional actions remaining after using dimension door or abundant step",
        longDesc: "After using abundant step or casting dimension door, you can take any actions you still have remaining on your turn. You also gain a +4 bonus on Concentration checks when casting teleportation spells.",
        prereq: "",
        },
        {
        name: "Dimensional Assault",
        type: "martial",
        shortDesc: "May use dimension door or abundant step as part of a charge action.",
        longDesc: "As a full-round action, you use abundant step or cast dimension door as a special charge. Doing so allows you to teleport up to double your current speed (up to the maximum distance allowed by the spell or ability) and to make the attack normally allowed on a charge.",
        prereq: "Dimensional Agility",
        },
        {
        name: "Dimensional Dervish",
        type: "martial",
        shortDesc: "During full-attack action, you may cast dimension door or use abundant step as a swift action.",
        longDesc: "You can take a full-attack action, activating abundant step or casting dimension door as a swift action. If your do, you can teleport up to twice your speed (up to the maximum distance allowed by the spell or ability), dividing this teleportation into increments you use before your first attack, between each attack, and after your last attack. You must teleport at least 5 feet each time you teleport.",
        prereq: "Dimensional Assault",
        },
        {
        name: "Dimensional Maneuvers",
        type: "martial",
        shortDesc: "Gain +4 on combat maneuver checks while using Dimensional Dervish.",
        longDesc: "While using the Dimensional Dervish feat, you gain a +4 bonus on combat maneuver checks to bull rush, disarm, reposition, or trip an opponent.",
        prereq: "Dimensional Dervish",
        repeatable:true,
        },
        {
        name: "Dimensional Savant",
        type: "martial",
        shortDesc: "Provide flanking from all squares you attack from when using Dimensional Dervish",
        longDesc: "While using the Dimensional Dervish feat, you provide flanking from all squares you attack from. Flanking starts from the moment you make an attack until the start of your next turn. You can effectively flank with yourself and with multiple allies when using this feat.",
        prereq: "Dimensional Dervish",
        },
        {
        name: "Discordant Voice",
        type: "magic",
        shortDesc: "When using bardic performance, allies deal 1d6 extra sonic damage.",
        longDesc: "Whenever you are using bardic performance to create a spell-like or supernatural effect or using the cackling hex, allies within 30 feet of you deal an extra 1d6 points of sonic damage with successful weapon attacks. This damage stacks with other energy damage a weapon might deal. Projectile weapons bestow this extra damage on their ammunition, but the extra damage is dealt only if the projectile hits a target within 30 feet of you. This lasts only as long as your bardic performance does, or 1 round if you are using cackle.",
        prereq: "",
        repeatable:true,
        perkPrereq:["Bardic Performance", "Hexes",]
        },
        {
        name: "Disorienting Maneuver",
        type: "martial",
        shortDesc: "After successful tumble through opponent's square, gain +2 on attack rolls vs. that opponent.",
        longDesc: "If you successfully use Acrobatics to tumble through an opponent's space, you gain a +2 circumstance bonus on attack rolls against that opponent until the start of your next turn. If you choose to make a trip attempt against that opponent, you gain a +4 circumstance bonus on your combat maneuver check. This bonus on trip also lasts until the start of your next turn.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Dispel Synergy",
        type: "magic",
        shortDesc: "Dispel magic target takes a -2 penalty on saves.",
        longDesc: "If you successfully dispel an ongoing magical effect on an opponent, that opponent takes a -2 penalty on saving throws against your spells until the end of your next turn.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Dispelling Fist",
        type: "magic",
        shortDesc: "May cast dispel magic as a swift action after an attack.",
        longDesc: "If you have dispel magic prepared or can cast it spontaneously, you can cast it as a swift action after hitting an opponent with an unarmed strike. Treat this as a targeted dispel against the opponent you hit.",
        prereq: "",
        },
        {
        name: "Divine Defiance",
        type: "utility",
        shortDesc: "You gain a +2 bonus on saving throws against divine spells and the spell-like abilities granted by levels in a divine casting class.",
        longDesc: "You gain a +2 bonus on saving throws against divine spells and the spell-like abilities granted by levels in a divine casting class.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Divine Interference",
        type: "magic",
        shortDesc: "Sacrifice a spell to force an enemy to reroll a successful attack against your ally.",
        longDesc: "As an immediate action, when an enemy within 30 feet hits an ally with an attack, you can sacrifice a spell slot or and make the enemy reroll the attack roll. The second attack roll takes a penalty equal to the level of the spell you sacrifice. You must sacrifice a spell of 1st-level or higher to use this ability. Whether or not the second attack is successful, you cannot use this effect on the same enemy creature again for 1 day.",
        prereq: "",
        },
        {
        name: "Divine Protection",
        type: "utility",
        shortDesc: "Gain a bonus equal to your Charisma bonus on a saving throw.",
        longDesc: "For level/2 spell points as an immediate action before rolling a saving throw, you can add your highest mental modifier on that saving throw. If you possess the charmed life class feature, you can instead apply Divine Protection's bonus after rolling the saving throw but before the result is revealed.",
        prereq: "",
        repeatable:true,
        },        
        {
        name: "Draconic Defender",
        type: "martial",
        shortDesc: "Grant a nearby ally your dodge bonus from fighting defensively or Combat Expertise.",
        longDesc: "During your action, designate an ally within your reach. When you fight defensively or use Combat Expertise, your ally gains a natural armor bonus to AC equal to the dodge bonus you gain from fighting defensively or Combat Expertise. You can select a new ally on any action. Allies who move out of your reach lose this natural armor bonus.",
        prereq: "",
        },
        {
        name: "Draconic Discipline",
        type: "utility",
        shortDesc: "Get a retry on necromancy or mind-affecting enchantment spells.",
        longDesc: "If you are affected by a mind-affecting enchantment or necromancy effect and fail your saving throw, you can attempt it again 1 round later at the same DC. You get only this one extra chance to succeed on your saving throw (excluding a normal reroll).",
        prereq: "",
        },
        {
        name: "Dual Enhancement",
        type: "martial",
        shortDesc: "Imbue two weapons with divine bond or sacred weapon instead of just one.",
        longDesc: "When you use an ability or spell that gives an enhancement bonus to a single weapon or armor you can instead apply it to two weapons, both ends of a double weapon, or two pieces of armor. All weapons affected must be in hand or otherwise wielded.",
        prereq: "",
        },
        {
            name: "Elemental Penetration",
            type: "magic",
            shortDesc: "",
            longDesc: "Choose one energy type (acid, cold, electricity, or fire), When that is your active element for elemental flux maneuvers, your maneuvers that deal damage of that element ignore up to your level in energy resistance. Additionally, starting at character level 10th, creatures that are immune to that element's energy type take half damage instead of none from your attacks and abilities.",
            prereq: "",
        },
        {
        name: "Elemental Focus",
        type: "magic",
        shortDesc: "+1 bonus on save DCs for one energy type.",
        longDesc: "Choose one energy type (acid, cold, electricity, or fire). Add +2 to the Difficulty Class for all saving throws against spells that deal damage of the energy type you select.",
        prereq: "",
        key:true,
        },
        {
        name: "Greater Elemental Focus",
        type: "magic",
        shortDesc: "+1 bonus on save DCs for one energy type.",
        longDesc: "Add +2 to the Difficulty Class for all saving throws against spells that deal damage of the energy type you select. This bonus stacks with the bonus from Elemental Focus.",
        prereq: "Elemental Focus",
        repeatable:true,
        },
        {
        name: "Energy Channel",
        type: "magic",
        shortDesc: "Spend channel energy to deal extra energy damage with weapon attacks.",
        longDesc: "A swift action, you can expend one use of channel energy or lay on hands to grant your weapon attacks a bonus on damage rolls equal to twice the number of dice rolled for your channel energy or lay on hands. This additional damage can be acid, cold, electricity, or fire. This effect lasts for your next highest mental stat weapon attacks.",
        prereq: "",
        perkPrereq:["Channel Energy", "Epic Channel Energy", "Lay On Hands", "Touch of Corruption", "Fervor", "Guardian's Shield"],
        repeatable:true,
        },
        {
        name: "Exquisite Sneak",
        type: "utility",
        shortDesc: "Use Stealth without penalty from most armor",
        longDesc: "You do not apply the armor check penalty for light and medium armor on Stealth skill checks no matter how fast you move. You still cannot use Stealth while running or charging.",
        prereq: "",
        },
        {
        name: "Fast Crawl",
        type: "utility",
        shortDesc: "Move at half speed while prone.",
        longDesc: "While prone, you can move at half speed. This movement provokes attacks of opportunity as normal. You can take a 5-foot step while crawling. This benefit does not stack with the rogue crawl talent.",
        prereq: "",
        },
        {
        name: "Fast Drinker",
        type: "utility",
        shortDesc: "Drink as a movement action.",
        longDesc: "Drinking a potions takes a movement action rather than a standard action, you can also drink a potion while moving, you can also draw and drink a potion as a stardard action, this still provokes as usual.",
        prereq: "",
        key:true,
        },
        {
        name: "Fast Healer",
        type: "utility",
        shortDesc: "Regain additional hit points when healing.",
        longDesc: "When you regain hit points through magical healing (not fast healing) or through skill checks, you recover additional hit points equal to half your Constitution modifier (minimum +1).",
        prereq: "",
        key:true,
        repeatable:true,
        },
        {
        name: "Ferocious Horde",
        type: "teamwork",
        shortDesc: "Gain +2 morale bonus on attack rolls when you and an ally with this feat are both at or below half hit points",
        longDesc: "Whenever you are at or below half of your full hit points and an ally within 30 feet who also has this feat is at or below half of her full hit points, you gain a +2 morale bonus on attack rolls.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Fey Foundling",
        type: "utility",
        shortDesc: "Magical healing works better on you.",
        longDesc: "Your strange connection to the First World and the fey infuses you with life, and whenever you receive magical healing, you heal an additional 2 points per die rolled (a dice needs to be rolled to gain this affect). You gain a +2 bonus on all saving throws against death effects.",
        prereq: "",
        key:true,
        repeatable:true,
        },
        {
        name: "Fight On",
        type: "utility",
        shortDesc: "Gain temporary hit points when reduced to 0.",
        longDesc: "Once per day, you can gain a number of temporary hit points equal to your Constitution score. You can activate this feat as an immediate action when reduced to 0 or fewer hit points. You can use this feat to prevent yourself from dying. These temporary hit points last for 1 minute. If your hit points drop below 0 due to the loss of these temporary hit points, you fall unconscious and are dying as normal.",
        prereq: "",
        perkPrereq: ["Dwarf","Orc"],
        repeatable:true,
        },
        {
        name: "Powerful Mark",
        type: "martial",
        shortDesc: "",
        longDesc: "The penalty for your armiger's mark ability increases by 2",
        prereq: "",
        perkPrereq:["Armiger's Mark"],
        repeatable:true,
        },
        {
        name: "Take the Blow",
        type: "martial",
        shortDesc: "",
        longDesc: "When a creature within your reach who is marked by your armiger's mark targets an ally with a melee or ranged attack, you can expend a use of your armiger's mark as an immediate action to force the opponent's attack to target you instead. You are considered the target for all effects of the attack (the creature must make a successful attack roll, you are allowed a save, if any, etc.).",
        prereq: "",
        perkPrereq:["Armiger's Mark"],
        repeatable:true,
        },
        {
            name: "Guard's Glare",
            type: "utility",
            shortDesc: "",
            longDesc: "A creature that is demoralized, frightened, shaken, or panicked and marked by your armiger's mark must make a Will save (DC 10 + half your warder level + warder initiation modifier) to move in a direction away from you. A creature only needs to make this save once per round. This is a mind-affecting fear effect.",
            prereq: "",
            perkPrereq:["Armiger's Mark"],
        },
        {
        name: "Discipline focus",
        type: "martial",
        shortDesc: "",
        longDesc: "Choose one martial discipline, gain a +2 bonus to saving throw DC's when using maneuvers of the chosen discipline, and gain +2 damage while in a stance of the chosen discipline.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Fire God's Blessing",
        type: "magic",
        shortDesc: "Heal hit points when dealing fire damage to the enemy.",
        longDesc: "When in combat, if you deal fire damage to an enemy, you heal 2 hit points. You can only benefit from this healing once per round. Attacks that cause a target to catch on fire heal you each round the target takes fire damage. This healing increases by 2 every 4 levels.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Fleet",
        type: "utility",
        shortDesc: "Your base speed increases by 5 feet.",
        longDesc: "While you are wearing light or no armor, your base speed increases by 10 feet. If you are wearing medium you gain 5. You lose the benefits of this feat if you carry a medium or heavy load.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Force Dash",
        type: "magic",
        shortDesc: "Lose a prepared spell or a spell slot to increase your speed.",
        longDesc: "As a swift action, you can sacrifice a spell slot to give yourself an enhancement bonus to speed. The bonus gained is equal to 5 feet x the level of the spell sacrificed. The bonus applies to all forms of movement, and it lasts 1 round. If you charge while this bonus is in effect, you do not take the normal -2 penalty to AC until the start of your next turn, and gain a bonus to attack equal to the level of the spell sacrificed.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Friendly Switch",
        type: "utility",
        shortDesc: "Switch places with an ally as part of a 5-foot-step.",
        longDesc: "As part of your movement or as a 5-foot-step, you can move into the space occupied by an ally of your size or smaller, which displaces the ally into the space you just left. Your ally must be willing and able to move and able to occupy the space you were in. This movement does not provoke attacks of opportunity. This does not count toward your ally's movement on his next turn.",
        prereq: "",
        },
        {
        name: "Furious Finish",
        type: "martial",
        shortDesc: "Deal maximum damage and end your rage.",
        longDesc: "While raging, when you use the Vital Strike feat, you can choose not to roll your damage dice and instead deal damage equal to the maximum roll possible on those damage dice. If you do, your rage immediately ends, and you are fatigued (even if you would not normally be).",
        prereq: "Vital Strike",
        },
        {
        name: "Gliding Steps",
        type: "utility",
        shortDesc: "Use ki to provoke fewer attacks of opportunities while moving.",
        longDesc: "If you have at least spell points equal to your level, when you move you do not provoke attacks of opportunity when leaving the first square of that movement. You can spend level/2 spell points to avoid provoking attacks of opportunity during that entire move.",
        prereq: "",
        },
        {
        name: "Glorious Heat",
        type: "magic",
        shortDesc: "When you cast a divine spell with the [fire] descriptor you heal an ally within 30 ft. half your level in hp and grant the ally +1 morale bonus to attacks until end of its turn.",
        longDesc: "Whenever you cast a divine spell with the fire descriptor, choose a single ally within 30 feet that you can see. That ally heals a number of hit points equal to half your level and gains a +1 morale bonus on attack rolls until the end of its next turn, this bonus increases by +1 every 4 levels.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Godless Healing",
        type: "utility",
        shortDesc: "Heal yourself 1d8 + level hp 1/day.",
        longDesc: "For 4 spell points, when you have half your total hit points or fewer, you may heal yourself of an amount of damage equal to 1d8 plus your total Hit Dice as a move action. This is a supernatural ability.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Grappled Caster",
        type: "magic",
        shortDesc: "You gain a +4 bonus on concentration checks to cast spells while grappled. This bonus stacks with the bonus granted by Combat Casting.",
        longDesc: "You gain a +4 bonus on concentration checks to cast spells while grappled. This bonus stacks with the bonus granted by Combat Casting.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Great Fortitude",
        type: "utility",
        shortDesc: "+2 on Fortitude saves.",
        longDesc: "You get a +3 bonus on all Fortitude saving throws.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Improved Great Fortitude",
        type: "utility",
        shortDesc: "Once per day, you may reroll a Fortitude save.",
        longDesc: "Once per day, you may reroll a Fortitude save. You must decide to use this ability before the results are revealed. You must take the second roll, even if it is worse.",
        prereq: "Great Fortitude",
        repeatable:true,
        },
        {
        name: "Greater Channel Smite",
        type: "martial",
        shortDesc: "Can exchange channel positive energy to create pool of damage dice.",
        longDesc: "Before making any melee attacks on your turn, you can use a free action but only once to expend one daily use of your Prereq ability. The dice from your ability form a pool of damage dice you can access to further damage creatures normally harmed by the energy you are channeling. Prior to making each melee attack, allocate dice from the pool to be used as extra damage dice if you hit. Your target can make a Will save as normal to halve the damage. This extra damage is not multiplied when you score a critical hit. If you miss, the extra damage dice remain in your pool until spent, but you cant have more dice in your pool than the max damage of your ability.",
        prereq: "Channel Smite",
        perkPrereq:["Channel Energy", "Epic Channel Energy", "Lay On Hands", "Touch of Corruption", "Fervor","Hemomancy"],
        },
        {
        name: "Guided Hand",
        type: "magic",
        shortDesc: "May use Wisdom modifier for attack rolls",
        longDesc: "Choose a specific weapon type (augmenting, light, one-handed, two-handed, primitive, tech, armament), you can use your highest mental modifier instead of your Strength or Dexterity modifier on attack rolls with weapons of that type.",
        prereq: "",
        key:true,
        },
        {
        name: "Improved Guided Hand",
        type: "magic",
        shortDesc: "May use Wisdom modifier for damage rolls",
        longDesc: "you can use your highest mental modifier instead of your Strength or Dexterity modifier on damage rolls on the weapon type you choose in guided hand. This only affects weapons that had an ability score added to the damage.",
        prereq: "Guided Hand",
        },
        {
        name: "Gunslinger",
        type: "martial",
        shortDesc: "When you attack with a firearm, you do not provoke attacks of opportunity, and you can reduce the Action required to reload a firearm by one step",
        longDesc: "When you attack with a firearm, you do not provoke attacks of opportunity, and you can reduce the action required to reload a firearm by one step.",
        prereq: "",
        key:true,
        },
        {
        name: "Hand's Autonomy",
        type: "martial",
        shortDesc: "Your possessed hand can act independently.",
        longDesc: `You gain a +2 to attack while two weapon fighting. When you are unconscious, paralyzed, asleep, or stunned, your possessed hand can still act on your behalf in a limited fashion. The hand uses your statistics when performing any action in this manner. The hand can't take attacks of opportunity, but can draw attacks of opportunity from actions it takes. The hand can perform the following actions each turn on your initiative count. \n The hand can retrieve or pick up an item or weapon as a standard action. \n The hand can attempt any of the following skill checks at a -4 penalty: Disable Device, Escape Artist, Heal, Sleight of Hand, or Use Magic Device. \n The hand can knock you prone as a free action, and drag you while you're prone at a speed of 5 feet as a full-round action. \n The hand can perform any other action appropriate for a hand and an arm, such as pouring a held potion into your mouth or awakening you from a sleep spell. \n The hand can make a single melee or ranged attack with a light or one-handed weapon as a full-round action.`,
        prereq: "Possessed Hand",
        },
        {
            name: "Hand's Sight",
            type: "martial",
            shortDesc: "Your possessed hand can act independently.",
            longDesc: `While your possessed hand isn't carrying anything, you gain darkvision with a range of 60 feet and cannot be flanked.`,
            prereq: "Possessed Hand",
        },
        {
        name: "Hellcat Stealth",
        type: "utility",
        shortDesc: "You may make Stealth checks in normal or bright light even when observed, but at a -10 penalty.",
        longDesc: "You may make Stealth checks in normal or bright light even when observed, but at a -10 penalty.",
        prereq: "",
        },
        {
        name: "Heroic Defiance",
        type: "utility",
        shortDesc: "Once per combat, delay onset of harmful condition for 1 round.",
        longDesc: "Once per floor as an immediate action you can delay the onset of one harmful condition or affliction (such as panicked, paralyzed, stunned, and so on), including permanent and instantaneous conditions. Activating this feat delays the onset of the condition until the end of your next turn, after which time the condition takes its normal effect. This feat has no effect on hit point damage or ability damage.",
        prereq: "",
        key:true,
        repeatable:true,
        },
        {
        name: "Heroic Recovery",
        type: "utility",
        shortDesc: "Once per combat, gain new saving throw against harmful condition requiring Fort save.",
        longDesc: "Once per floor as a free action you may attempt a new saving throw against a harmful condition or affliction requiring a Fortitude save that is affecting you. If this save against the affliction fails, there is no additional effect, but a successful save counts toward curing an affliction such as poison or disease. You cannot use this feat to recover from instantaneous effects, effects that do not allow a saving throw, or effects that do not require a Fortitude save.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Improved Duck and Cover",
        type: "teamwork",
        shortDesc: "When you use Duck and Cover, an ally with evasion or improved evasion takes some of the damage.",
        longDesc: "Whenever you use Duck and Cover, your ally has evasion or improved evasion, and your ally's saving throw roll succeeds, half of the damage you would have taken is transferred to your ally. (This damage is not reduced by the ally's evasion or improved evasion.)",
        prereq: "Duck and Cover",
        },
        {
        name: "Ironhide",
        type: "utility",
        shortDesc: "+1 natural armor bonus to AC.",
        longDesc: "You gain a +2 natural armor bonus due to your unusually tough hide.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Iron Will",
        type: "utility",
        shortDesc: "+2 bonus on Will saves.",
        longDesc: "You get a +3 bonus on all Will saving throws.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Improved Iron Will",
        type: "utility",
        shortDesc: "Once per day, you may reroll a Will save.",
        longDesc: "Once per day, you may reroll a Will save. You must decide to use this ability before the results are revealed. You must take the second roll, even if it is worse.",
        prereq: "Iron Will",
        repeatable:true,
        },
        {
        name: "Juju Way",
        type: "teamwork",
        shortDesc: "Cast touch spells at a range of 20 feet when targeting a willing ally who has this feat",
        longDesc: "You can cast spells with the range of 'touch' at a range of 20 feet if the recipient is a willing ally who also has this feat.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Keen Scent",
        type: "utility",
        shortDesc: "Gain the scent special ability.",
        longDesc: "You gain the scent special ability with a range of 30 feet.",
        prereq: "",
        },
        {
        name: "Ki Stand",
        type: "utility",
        shortDesc: "Stand up as a swift action, and spend 2 spell points to not provoke attacks of opportunity when you do so.",
        longDesc: "As long as you have more than level/2 spell points you can stand up from prone as a swift action. You can spend level/2 spell points to not provoke attacks of opportunity when you stand up from prone.",
        prereq: "",
        key:true,
        },
        {
        name: "Letter Fury",
        type: "martial",
        shortDesc: "If someone reads or writes in your presence you may activate your rage ability for one round for free.",
        longDesc: "If someone reads or writes in your presence (including casting spells like glyph of warding or symbol, or uses a monster encyclopedia) you can, as an immediate action, begin to rage as the class ability for 1 round. Once you use this feat you must wait at least 1 minute after you cease raging before you can use it again. If you select this feat you lose the ability to read.",
        prereq: "",
        },
        {
        name: "Lightning Reflexes",
        type: "utility",
        shortDesc: "+2 bonus on Reflex saves.",
        longDesc: "You get a +3 bonus on all Reflex saving throws.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Improved Lightning Reflexes",
        type: "utility",
        shortDesc: "Once per day, you may reroll a Reflex save.",
        longDesc: "Once per day, you may reroll a Reflex save. You must decide to use this ability before the results are revealed. You must take the second roll, even if it is worse.",
        prereq: "Lightning Reflexes",
        repeatable:true,
        },
        {
        name: "Light Step",
        type: "utility",
        shortDesc: "Move normal speed in difficult terrain.",
        longDesc: "You can ignore the effects of difficult terrain in natural environments, as if it were normal terrain.",
        prereq: "",
        },
        {
        name: "Lingering Performance",
        type: "magic",
        shortDesc: "Bardic performance continues for 2 rounds after you stop performing.",
        longDesc: "You increase the duration of your bardic performance and hexes. The bonuses and penalties from your bardic performance continue for 2 rounds after you cease performing. If you begin a new bardic performance during this time, the effects of the previous performance immediately cease. The duration of your beneficial hexes increase by 1 round. Hexes that have a usage amount have their amount increased by 1 usage. Any other requirement, such as range or specific conditions, must still be met for the effect to continue.",
        prereq: "",
        perkPrereq:["Bardic Performance", "Hexes", "Fortune", "Protective Luck"],
        repeatable:true,
        },
        {
            name: "Extra Hexes",
            type: "magic",
            shortDesc: "",
            longDesc: "Once per day using a minor hex you can choose not expend it. Every 3 levels you gain an additional usage of this ability. Additionally, at level 6 you can expend two uses to choose to not expend a major hex. Then at level 12 you can use 3 usages to not expend a grand hex, and then at level 18 expend 5 uses to not expend a epic hex.",
            prereq: "",
            perkPrereq:["Hexes"],
            repeatable:true,
        },
        {
        name: "Loyal to the Death",
        type: "teamwork",
        shortDesc: "You can become the target of an attack directed against an adjacent ally who has this feat",
        longDesc: "Whenever an opponent makes a melee or ranged attack against one of your allies who is adjacent to you and who also has this feat, you can spend an immediate action to shield the ally with your own body. You become the target of the attack, and the opponent gains a +4 bonus on her attack roll. For the purpose of determining distance, cover and concealment, you count as being in your ally's square when the attack is resolved. If the attack misses you due to concealment, blink, or a similar effect, it instead targets your ally as if you had not used this feat's ability.",
        prereq: "",
        },
        {
        name: "Lucky",
        type: "utility",
        shortDesc: "You may roll saving throw for an ally once per day.",
        longDesc: "Once per day, when one of your allies within 30 feet makes a saving throw, you may roll the same saving throw as if you were the one subject to the effect requiring it. You may use this ability after your ally has rolled, but before the GM declares if the roll was a success or failure. Your ally may choose to use your saving throw in place of his own.",
        prereq: "",
        key:true,
        repeatable:true,
        },
        {
        name: "Lunging Spell Touch",
        type: "magic",
        shortDesc: "Increase reach of spell's touch attack by 5 feet.",
        longDesc: "You can increase the reach of your spells' melee touch attacks by 5 feet until the end of your turn by taking a -2 penalty to your AC until your next turn. You must decide to use this ability before you attempt any attacks on your turn.",
        prereq: "",
        key:true,
        },
        {
            name: "Fire Savant Combustion",
            type: "magic",
            shortDesc: "",
            longDesc: `When you damage a creature with a fire spell they catch fire, taking 1d6 fire damage at the start of their turn for the next 3 rounds, unless they succeeded the save the spell allowed. If a spell had no save allowed, they gain a reflex save against this effect (same DC the spell would have had). Gain 5 fire spell power for each fire savant feat you have.
            \n\nThis can stack up to 3 times, plus an additional time for each fire savant feat you have, however an individual spell cannot give a creature more than 1 combustion stack per round.
            \n\nA creature can resave to put out this fire like normal, however the DC to do so is equal to the DC of the highest spell that applies a combustion stack currently affecting them, +1 for each additional stack.`,
            prereq: "",
            key:true,
            hasCustomMethod:true,
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellPower.fire += 5
            }
        },
        {
            name: "Greater Fire Savant",
            type: "magic",
            shortDesc: "",
            longDesc: "Increase your caster level with fire spells by +1. You cast cold spells at -2 caster levels.",
            prereq: "Fire Savant Combustion",
            hasCustomMethod:true,
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellPower.fire += 5
            }

        },
        {
            name: "Fire Savant Persistence",
            type: "magic",
            shortDesc: "",
            longDesc: "You become immune to paralysis and gain fire resistance 10. This fire resistance stacks with any other fire resistance you may have. You take double damage from cold up to a max of 10 additional damage.",
            prereq: "Fire Savant Combustion",
            hasCustomMethod:true,
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellPower.fire += 5
            }
        },
        {
            name: "Fire Savant Inferno",
            type: "magic",
            shortDesc: "",
            longDesc: "When a creature takes damage from Fire Savant Immolation they gain 1 stack of immolation (see burning citadel discipline information). When you cast a spell that deals fire damage you cast it at +1 caster level. You cast cold spells at -2 caster levels.",
            prereq: "Fire Savant Persistence",
            hasCustomMethod:true,
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellPower.fire += 5
            }
        },
        {
            name: "Fire Savant Overheat",
            type: "magic",
            shortDesc: "",
            longDesc: "The DC of your fire spells increases by +1. Gain 2% fire spell critical chance. You can no longer deal critical damage with cold spells. Reduce the DC of your cold spells by -2.",
            prereq: "Fire Savant Inferno",
            hasCustomMethod:true,
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellPower.fire += 5
                context.stats.characterStats.spellMastery.spellCriticalChance.fire += 2
            }
        },
        {
            name: "Fire Savant Eruption",
            type: "magic",
            shortDesc: "",
            longDesc: "When you deal critical damage with a spell that deals fire damage they explode in fire, taking 3d6 per stack of combustion they currently have, and gaining immolation stacks equal to their combustion stacks. Your critical spells also cause creatures to make a fortitude save (Spells DC+immolation stacks) or become blinded for 1 round. Gain 2% fire spell critical chance.",
            prereq: "Fire Savant Overheat",
            hasCustomMethod:true,
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellPower.fire += 5
                context.stats.characterStats.spellMastery.spellCriticalChance.fire += 2
            }
        },
        {
            name: "Persistent Destruction",
            type: "magic",
            shortDesc: "",
            longDesc: "Your spells that deal damage over time, have that damage over time increased by the spells level.",
            prereq: "",
        },
        {
            name: "Ice Savant Hypothermia",
            type: "magic",
            shortDesc: "",
            longDesc: "When you damage a creature with a cold spell it takes a -1 penalty to all saving throws for 3 rounds. This stacks up to 1 time per ice savant feat you have. Gain 5 cold spell power for each ice savant feat you have.",
            prereq: "",
            key:true,
            hasCustomMethod:true,
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellPower.cold += 5
            }
        },
        {
            name: "Greater Ice Savant",
            type: "magic",
            shortDesc: "",
            longDesc: "Increase your caster level with cold spells by +1, this can go over the usual maximum caster level of spells. You cast fire spells at -2 caster levels.",
            prereq: "Ice Savant Hypothermia",
            hasCustomMethod:true,
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellPower.cold += 5
            }
        },
        {
            name: "Ice Savant Persistence",
            type: "magic",
            shortDesc: "",
            longDesc: "You become immune to paralysis and gain cold resistance 10. This cold resistance stacks with any other cold resistance you may have. You take double damage from fire up to a max of 10 additional damage.",
            prereq: "Ice Savant Hypothermia",
            hasCustomMethod:true,
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellPower.cold += 5
            }
        },
        {
            name: "Ice Savant Shattering",
            type: "magic",
            shortDesc: "",
            longDesc: "when a creature affected by your hypothermia receives a critical hit it takes bonus damage equal to your highest mental stat for each stack of hypothermia on the target (this is not modified by the critical multiplier).",
            prereq: "Ice Savant Persistence",
            hasCustomMethod:true,
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellPower.cold += 5
            }
        },
        {
            name: "Ice Savant Biting Cold",
            type: "magic",
            shortDesc: "",
            longDesc: "The DC of your cold spells increases by +1. Your cold spells gain 2% critical chance, and you gain a +1 bonus on the critical threat range of cold ray spells. This is a flat bonus that is not doubled. By default this means your cold ray spells now critical on 19-20. You can no longer deal critical damage with fire spells. Reduce the DC of your fire spells by -2",
            prereq: "Ice Savant Shattering",
            hasCustomMethod:true,
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellPower.cold += 5
                context.stats.characterStats.spellMastery.spellCriticalChance.cold += 2
            }
        },
        {
            name: "Ice Savant Void Frost",
            type: "magic",
            shortDesc: "",
            longDesc: "Your cold spells gain 30% critical spell power. All critical spells deal 1 point of dexterity drain, this scales with critical spell multiplier (100% means 2 drain etc.). Gain 2% cold spell critical chance.",
            prereq: "Ice Savant Biting Cold",
            hasCustomMethod:true,
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellPower.cold += 5
                context.stats.characterStats.spellMastery.spellCriticalChance.cold += 2
                context.stats.characterStats.spellMastery.spellCriticalDamage.cold += 30
            }
        },
        {
            name: "Air Savant Conduction",
            type: "magic",
            shortDesc: "",
            longDesc: "When you damage a creature with an electricity spell it takes 1 additional point of damage from metal weapons for 3 rounds. This stacks up to 2 times, plus 1 for each Air Savant feat you have. You also gain 5 electricity spell power for each air savant feat you have.",
            prereq: "",
            key:true,
            hasCustomMethod:true,
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellPower.electricity += 5
            }
        },
        {
            name: "Greater Air Savant",
            type: "magic",
            shortDesc: "",
            longDesc: "Increase your caster level with electricity spells by +1. Reduce the caster level of your acid spells by -2.",
            prereq: "Air Savant Conduction",
            hasCustomMethod:true,
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellPower.electricity += 5
            }

        },
        {
            name: "Air Savant Wind Step",
            type: "magic",
            shortDesc: "",
            longDesc: "You become immune to the prone condition and gain a +10 bonus on acrobatics checks to jump. You gain 10 electricity resistance, this stacks with other electricity resistance, but you take double damage from acid damage up to a max of 10 bonus damage.",
            prereq: "Air Savant Conduction",
            hasCustomMethod:true,
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellPower.electricity += 5
            }
        },
        {
            name: "Air Savant Magnetism",
            type: "magic",
            shortDesc: "",
            longDesc: "Creatures affected by Conduction have their attacks with metal weapons reduced by -1 for every stack of conduction.",
            prereq: "Air Savant Wind Step",
            hasCustomMethod:true,
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellPower.electricity += 5
            }
        },
        {
            name: "Air Savant Stormbringer",
            type: "magic",
            shortDesc: "",
            longDesc: "The DC of your electricity spells increases by +1. Gain 2% electricity spell critical chance. You can no longer deal critical damage with acid spells. Reduce the DC of your acid spells by -2.",
            prereq: "Air Savant Magnetism",
            hasCustomMethod:true,
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellCriticalChance.electricity += 2
                context.stats.characterStats.spellMastery.spellPower.electricity += 5
            }
        },
        {
            name: "Air Savant Ravaging Voltage",
            type: "magic",
            shortDesc: "",
            longDesc: "Your critital electricity spells force creatures to make a fortitude saving throw (Spells DC + conduction stacks) or become stunned for 1 round. Gain 2% electricity spell critical chance. Your critical spells automatically give 3 stacks of conduction, these stacks can go over the usual conduction stack limit.",
            prereq: "Air Savant Stormbringer",
            hasCustomMethod:true,
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellPower.electricity += 5
                context.stats.characterStats.spellMastery.spellCriticalChance.electricity += 2
            }
        },
        {
            name: "Earth Savant Crumbling",
            type: "magic",
            shortDesc: "",
            longDesc: "When you damage a creature with an acid spell it takes it loses -1 to its natural armor bonus. If a creature has no natural armor bonus it can be reduced to a negative natural armor bonus. This lasts 3 rounds, and can stack 2 times, plus one for each Earth Savant Feat you have. Gain 5 acid spell power for each earth savant feat you have.",
            prereq: "",
            key:true,
            hasCustomMethod:true,
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellPower.acid += 5
            }
        },
        {
            name: "Greater Earth Savant",
            type: "magic",
            shortDesc: "",
            longDesc: "Increase your caster level with acid spells by +1, this can go over the usual maximum caster level of spells. Your electricity spells are cast at -2 caster levels.",
            prereq: "Earth Savant Crumbling",
            hasCustomMethod:true,
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellPower.acid += 5
            }
        },
        {
            name: "Earth Savant One With Stone",
            type: "magic",
            shortDesc: "",
            longDesc: "You gain immunity to petrification and gain acid resistance 10, this stacks with your other acid resistance, but you take double damage from electricity up to a maximum of 10 bonus damage.",
            prereq: "Earth Savant Crumbling",
            hasCustomMethod:true,
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellPower.acid += 5
            }
        },
        {
            name: "Earth Savant Corrosion",
            type: "magic",
            shortDesc: "",
            longDesc: "Your Crumbling stacks also reduce the DR of creatures by 1 for each 2 stacks of crumbling on them.",
            prereq: "Earth Savant One With Stone",
            hasCustomMethod:true,
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellPower.acid += 5
            }
        },
        {
            name: "Earth Savant Caustic Amplification",
            type: "magic",
            shortDesc: "",
            longDesc: "The DC of your acid spells increases by +1. Gain 2% acid spell critical chance. You can no longer deal critical damage with electricity spells. Reduce the DC of your electricity spells by -2.",
            prereq: "Earth Savant Corrosion",
            hasCustomMethod:true,
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellPower.acid += 5
                context.stats.characterStats.spellMastery.spellCriticalChance.acid += 2
            }
        },
        {
            name: "Earth Savant Disintegration",
            type: "magic",
            shortDesc: "",
            longDesc: "Your critical hits with acid spells also deal their damage to a piece of equipment the creature is holding (your choice), it does full damage to objects (still reduced by the hardness). Your critical spells cause the creature to lose all damage reduction and hardness for 1 round. Gain 2% acid spell critical chance.",
            prereq: "Earth Savant Caustic Amplification",
            hasCustomMethod:true,
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellPower.acid += 5
                context.stats.characterStats.spellMastery.spellCriticalChance.acid += 2
            }
        },
        // {
        //     name: "Critical Failure",
        //     type: "magic",
        //     shortDesc: "",
        //     longDesc: `When a creature rolls a natural one against a saving throw for a damage spell, they must re-save against the spell, if they fail again, they take critical damage (normally x2). This critical damage only applies to the next instance of damage the creature takes from the spell. If you already have a critical range on natural 1's increase it by +1 instead, this is a flat bonus not multiplied by other effects.
        //     \n\nHowever because of the volatile nature to this kind of magic augmentation, if a creature rolls a natural 20 against the spell it can roll again to confirm it as a critical success, if it does, it takes no penalty from the spell even if it normally had a reduced effect, and gains a +5 on any further save to the spell, and takes no effect on any further success.`,
        //     prereq: "",
        //     key:true,
        //     additionalInfoTags:["Spell Critical"],
        // },
        // {
        //     name: "Assured Failure",
        //     type: "magic",
        //     shortDesc: "",
        //     longDesc: "Creatures receive a -4 penalty on their save confirmation for taking critical damage. If they do critically fail, then whichever save they failed they take a -4 penalty to for rounds equal to your critical multiplier.",
        //     prereq: "Critical Failure",
        // },
        // {
        //     name: "Critical Penetration",
        //     type: "magic",
        //     shortDesc: "",
        //     longDesc: `When you roll a natural 20 to penetrate spell resistance you can reroll to confirm it as a critical spell, dealing critical damage (normally x2). This critical damage only applies to the next instance of damage the creature takes from the spell.  If you already have a critical range on spell penetration increase it by +1 instead, this is a flat bonus not multiplied by other effects.
        //     \n\nHowever because of the volatile nature to this kind of magic augmentation, if you roll a natural 1 to penetrate spell resistance you must reroll to confirm, and if you fail you become subject to the spell you just cast, including your square as a part of the area if needed.`,
        //     prereq: "",
        //     additionalInfoTags:["Spell Critical"],
        //     key:true,
        // },
        // {
        //     name: "Shatter Resistance",
        //     type: "magic",
        //     shortDesc: "",
        //     longDesc: "Gain a +1 bonus on rolls to penetrate spell resistance. When you confirm a critical from penetrating spell resistance the creatures spell resistance is lowered by the spells level/2 (minimum 1) and it loses your critical multiplier to all of its saves for rounds equal to your critical multiplier (after the afflicting spell).",
        //     prereq: "Critical Penetration",
        //     additionalInfo:`Treat this like a critical threat range, so effects that increase a spells critical threat range also increase this range (but not effects that only modify a specific threat range, such as improved critical which only effects criticals on a rays touch attacks). This critical damage only applies to the next instance of damage the spell deals. AOE spells count as 1 instance.
        //     \nSome spells have multiple chances to gain a critical hit, if this is the case the multiplier is added together, so if you gained a crit from the attack roll and for penetrating spell resistance it becomes a 3x crit.`
        // },
        // {
        //     name: "Critomancy Focus",
        //     type: "magic",
        //     shortDesc: "",
        //     longDesc: "You gain a +4 bonus on rolls to confirm critical spells.",
        //     prereq: "",
        // },
        // {
        //     name: "Improved Critomancy",
        //     type: "magic",
        //     shortDesc: "",
        //     longDesc: "Choose one of your spell critical threat ranges (attacks, concentration, natural 1's, spell penetration) and increase it by +1. This is a flat bonus not multiplied by other abilities.",
        //     prereq: "",
        // },
        // {
        //     name: "Critical Concentration",
        //     type: "magic",
        //     shortDesc: "",
        //     longDesc: `When you roll a natural 20 on a concentration check or a combat casting check you can reroll to confirm the roll as a critical spell. This critical damage only applies to the next instance of damage the creature takes from the spell. If you already have a critical range on concentrations increase it by +1 instead, this is a flat bonus not multiplied by other effects.
        //     \n\nHowever, because of the volatile nature to this kind of magic augmentation, if you ever roll a natural 1 on a concetration check you lose the ability to cast spells until you spend a standard action rolling a concentration check DC 15 + level.`,
        //     prereq: "",
        //     additionalInfoTags:["Spell Critical"],
        //     key:true,
        // },
        {
            name: "Critomancy Expertise",
            type: "magic",
            longDesc: `Gain 4% universal spell critical chance.`,
            prereq: "",
            additionalInfoTags:["Spell Critical"],
            key:true,
            hasCustomMethod:true,
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellCriticalChance.universal += 4
            }
        },
        {
            name: "Volatile Critomancy",
            type: "magic",
            longDesc: `Your Spells gain 25% universal spell critical damage.`,
            prereq: "",
            additionalInfoTags:["Spell Critical"],
            key:true,
            hasCustomMethod:true,
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellCriticalDamage.universal += 25
            }
        },
        // {
        //     name: "Improved Magical Surges",
        //     type: "magic",
        //     shortDesc: "",
        //     longDesc: `Your wild critical spells have their chance increased by 2% (97-100)`,
        //     prereq: "Critical Surge",
        //     repeatable:true,
        // },
        // {
        //     name: "Absolute Focus",
        //     type: "magic",
        //     shortDesc: "",
        //     longDesc: "When you critically confirm the concentration on a spell reduce the cost of the spell by 50%. The minimum reduction is 1 point, but the spell cannot cost less than 1 spell point.",
        //     prereq: "Critical Concentration",            
        // },
        {
            name: "Soul Siphon",
            type: "magic",
            shortDesc: "",
            longDesc: "At the start of your turn, for each creature currently affected by one of your control spells, or when you cast a control spell that affects creatures, you heal 1 hit point per creature affected. This is not positive energy healing. If the spell stops them from taking any action, or all of their actions are controlled by you, the healing is doubled. This healing increases every 5 levels.",
            prereq: "",            
        },
        {
            name: "Mental Siphon",
            type: "magic",
            shortDesc: "",
            longDesc: "At the start of your turn if a creature is affected by one of your control spells and is unable to take any actions or its actions are controlled by you, and it has the ability to cast spells or spell like abilities, it loses its lowest spell slot and you gain spell points equal to the slot lost. If it has it has at will spell-like abilities ignore those for the effect of this feat.",
            prereq: "Soul Siphon",            
        },
        {
            name: "Elemental Flurry Style",
            type: "style",
            shortDesc: "",
            longDesc: "When you cast a spell that deals elemental damage (acid, cold, electricity, fire, or sonic), you become infused with elemental energy until the end of your next turn. While infused, if you cast another spell that deals elemental damage of a type different from all types used in your current chain of infused spells, increase its spell power by 10 x (number of spells in the chain before this one), and once the spell has finished being cast, add that spell to the chain and extend the duration of the infusion until the end of your next turn. Casting a spell that deals an elemental damage type already used in the chain ends the infusion and resets the chain (if a spell deals multiple, you can choose which element it is considered for the chain, but only ever increase your chain by 1 per spell).",
            prereq: "",
            key:true,
        },
        {
            name: "Elemental Flurry Devastation",
            type: "style",
            shortDesc: "",
            longDesc: "For every spell in your current chain, your damaging elemental spells also gain 2% spell critical chance.",
            gameDesc: "For every spell in your current chain, your damaging elemental spells also gain 3% spell critical chance.",
            prereq: "Elemental Flurry Style",
        },
        {
            name: "Elemental Flurry Apocalypse",
            type: "style",
            shortDesc: "",
            longDesc: "If you have 4 spells in your current chain, your next damaging elemental spell of a unique element gains 15% spell critical chance, 25% spell critical power, and its DC is increased by +2. If the spell is a critical, you have a 50% chance for it to not expend any spell points (only affects the base spell point cost)",
            gameDesc:"If you have 3 spells in your current chain, your next damaging elemental spell of a unique element gains 15% spell critical chance, 25% spell critical power, and its DC is increased by +2. If the spell is a critical, you have a 50% chance for it to not expend the spell.",
            prereq: "Elemental Flurry Devastation",
        },
        {
            name: "Volatile Casting Style",
            type: "style",
            shortDesc: "",
            longDesc: "Gain 8% spell critical chance and 4% spell critical failure chance.",
            prereq: "",
            key:true,
            hasCustomMethod:true,
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellCriticalChance.universal += 4
            }
        },
        {
            name: "Volatile Casting Vent",
            type: "style",
            shortDesc: "",
            longDesc: "Whenever you either critically confirm or fail a spell, you unleash a nova of energy in a 15ft. radius around you, dealing 1d6 points of force damage per the spells level to all enemies within the radius, they receive a reflex save dc 10 + level/2 + mental for half. If the spell was a benefitial spell you can cause this to instead heal 1d4 points per spell level instead.",
            prereq: "Volatile Casting Style",            
        },
        {
            name: "Volatile Casting Devastation",
            type: "style",
            shortDesc: "",
            longDesc: "Increase your spell's critical power by 25%. Whenever you cast a critical failure with a spell you become stunned for 1 round (after the spell is cast), and you increase the critical spell power of your next spell with level/2 rounds by another 25%.",
            prereq: "Volatile Casting Vent",
            hasCustomMethod:true,
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellCriticalDamage.universal += 25
            }
        },        
        {
            name: "Magical Flux Style",
            type: "style",
            shortDesc: "",
            longDesc: `You allow the natural flow of magic to guide your abilities. At the start of each of your turns roll a 1d6, each result correlates to a type of magic, except a 6, which allows you to choose.
            \n1: Damage\n2: Control\n3: Buff\n4: Utility\n5: Healing\n6: Your Choice,
            \n\nOn your turn spells cast from the rolled type cost 1 less spell point, and spells of the wrong school cost 2 additional points. If you cast 4 spells in a row of the correct type, you empower your next spell, depending on its type. An empowered spell does not count towards this feats progress.
            \nDamage/Healing: 15 spell power.\nControl: Increase the DC by +1.\nBuff: Increase a numerical modifier of the spell by +1\nUtility: Casting the spell has its action step reduced by 1.`,
            prereq: "",
        },
        {
            name: "Magical Flux Flow",
            type: "style",
            shortDesc: "",
            longDesc: `If you cast a spell of the correct type its price is reduced by an additional -1, and spells of the wrong type have their cost increased by +1 spell point. You only have to cast 3 spells in a row to empower your next spell. When you cast an empowered spell you gain a +1 bonus to saving throws for 1 round. This bonus increases by +1 for each Magical Flux feat you have, and the bonus lasts 1 round longer.`,
            prereq: "Magical Flux Style",            
        },
        {
            name: "Magical Flux Attunement",
            type: "style",
            shortDesc: "",
            longDesc: `Increase the bonus each ability grants by x2. You only have to cast 2 spells in a row to empower your next spell. When you have the chance to cast an empowered spell you can choose to suppress it, then the next time you gain the ability to cast an empowered spell you increase the bonus given by another additional step. (If its a utility spell, you can cast multiple empowered utility spells, splitting up the step reduction amoungst them as you choose)`,
            prereq: "Magical Flux Flow",            
        },
        {
            name: "Jester's Style",
            type: "style",
            shortDesc: "",
            longDesc: `You channel your whimsy into spellcasting, when you cast a buff or healing spell on a creature, roll a 1d6, each result corresponding to a bonus to a specific roll type:
            \n\n1: Roll again, but this time its a penalty, and multiply the penalty by 2! \n2: Nothing \n3: Armor Class bonus \n4: Save bonus \n5: Damage bonus \n6: Attack Bonus
            \n\nEach of these bonuses is untyped and is equal to the spells level/2 (minimum 1) and lasts 1 round per Jester's feat you have.`,
            prereq: "",
            key:true,
        },
        {
            name: "Jester's Medicine",
            type: "style",
            shortDesc: "",
            longDesc: `Whenever you use Jester's Style, you instead roll a 1d8, each result corresponding to an effect, using the effects listed in the previous feats, and these new ones:
            \n\n7: Heal 5 hit points per spells level \n8: Restore 2 spell points per spells level.`,
            prereq: "Jester's Style",
        },
        {
            name: "Jester's Chaos",
            type: "style",
            shortDesc: "",
            longDesc: `Whenever you use Jester's Style, you instead roll a 1d10, each result corresponding to an effect, using the effects listed in the previous feats, and these new ones:
            \n\n9: Roll again, instead of the target of the current spell getting the benefit, the next time you use a spell with jester's style those targets also get the effects of this roll of jester's style. \n 10:Roll twice, they gain both bonuses. If you roll this after rolling a 6, both become penalties.
            \n\nAdditionally, if the spell you cast this way was a critical spell, you can apply jester's style times equal to the critical multiplier (instead of just once), but likewise reverse the effects on the creature if the spell is a critical failure.`,
            prereq: "Jester's Medicine",
        },
        {
            name: "Shepherd Style",
            type: "style",
            shortDesc: "",
            longDesc: `When you cast a healing spell on a creature you can choose for it to either gain a morale bonus to attacks, or a deflection bonus to its armor class. Both bonuses are equal to the level of the spell and last until they successfully land an attack, or until an attack misses them (depending on the option you chose, bonus attack = when an attack hits, bonus ac = when an attack misses). When you cast a buff spell the creatures targeted heal hit points equal to 2x the level of the spell. This is positive energy.`,
            prereq: "",
            key:true,
        },
        {
            name: "Shepherd's Grace",
            type: "style",
            shortDesc: "",
            longDesc: `When you cast a healing or buff spell on a creature, the next time within rounds equal to the level of the spell the creature is attacked the attacker must make a will save dc 10 + spell level + mental or that attack is wasted. If the creature misses the attack because of this ability it doesn't count as a missed attack for the bonus armor class given by Shepherd style.`,
            prereq: "Shepherd Style",
        },
        {
            name: "Shepherd's Miracle",
            type: "style",
            shortDesc: "",
            longDesc: `You alter a spell to become a healing spell, doing so sacrifices the spell permanently. Any damage the spell would do now heals, however the rest of the spell functions normally. The spell gains the healing type and loses the damage type, unless it already had the healing type. This is positive energy.`,
            prereq: "Shepherd's Grace",
        },
        {
            name: "Divine Command Style",
            type: "style",
            shortDesc: "",
            longDesc: `While in this style, increase the DC of control spells by +1. Creatures currently affected by a control spell you cast have their saves, armor class, and attack reduced by -2. This doesn't apply to any rolls related to the control spells themselves, except for new control spells you are casting on them. This penalty stacks for each control spell affecting the target, but the penalty doesn't apply to any control spells you have already cast. A spell only counts as affecting the target if it is currently applying a negative effect to the creature, so difficult terrain created by a spell only counts as a penalty if the creature is currently moving through it, or the penalty a spell applied is still happening, such as being knocked prone by a grease spell.`,
            prereq: "",
            key:true,
        },
        {
            name: "Divine Command, Execution",
            type: "style",
            shortDesc: "",
            longDesc: `A creature affected by one of your control spells becomes extra vulnerable to damage, whenever it takes more than 5 damage from a single attack, it takes an extra 1d6 points of damage. For each level of the spell, for every additional 5 points of damage it takes from an attack it takes another 1d6 points of damage. This additional damage is of the type of damage dealt to it, and counts as apart of that damage for its source, however the 1d6 does not count towards how much damage it must take for an additional 1d6 damage. This damage is not multiplied on critical hits.`,
            prereq: "Divine Command Style",
        },
        {
            name: "Divine Command, Absolute Control",
            type: "style",
            shortDesc: "",
            longDesc: `While in Domination Style, increase the DC of control spells by +1. When a creature succeeds a saving throw against a spell you cast, you can sacrifice a spell known to force the creature to reroll that save with a penalty equal to the level of the spell sacrificed. Doing this is an immediate action, and the spell sacrificed this way becomes lost permanently.`,
            prereq: "Divine Command, Execution",            
        },
        {
            name: "Beacon of Light Style",
            type: "style",
            shortDesc: "",
            longDesc: `Your healing spells heal +1 point per dice rolled, increased by +1 for each additional Beacon of Light feat you have. Whenever you cast a healing spell, or use a perk that heals hit points, you also heal an amount equal to the spell points used for that perk or spell. Beacon of Light feats healing is all positive energy. Your spells that deal damage now deal 1 less point per dice rolled, reduced by another additional point for each beacon of light feat you have.`,
            prereq: "",
            key:true,
        },
        {
            name: "Beacon Of Light Radiance",
            type: "style",
            shortDesc: "",
            longDesc: `The effect of Beacon of Light Style now heals all allies within 10 feet of you, and healing spells that dont heal hit points now heal the spells level x the amount of beacon of light feats you have when they are cast on a creature, or the first time they effect them.`,
            prereq: "Beacon of Light Style",
        },
        {
            name: "Beacon Of Light Conduit",
            type: "style",
            shortDesc: "",
            longDesc: `Beacon of Light Radiance now heals creatures within 20 feet of you, and any healing over their maximum becomes temporary hit points (this doesn't stack with itself). When you affect creatures with beacon of Light Radiance you can sacrifice up to your highest mental modifier worth of any type of save, if you do your save is that much lower for 1 round, however each creature healed gains a sacred bonus equal to the amount you sacrificed for its next save of that type within 2 rounds.`,
            prereq: "Beacon Of Light Radiance",
        },
        {
            name: "Arcane Duelist Style",
            type: "style",
            shortDesc: "",
            longDesc: `You gain +1 bonus on initative checks for each Arcane Duelist feat you have (you gain this bonus whether you are in this style or not). While in this style, If you ready to cast a spell to deal damage to interrupt another creature casting a spell or spell like ability, increase the critical spell chance by 4%, and increase its DC by +2.`,
            prereq: "",
        },
        {
            name: "Arcane Duelist Riposte",
            type: "style",
            shortDesc: "",
            longDesc: `If you successfully save against a spell, if you cast a spell against them before the end of your next turn, increase your spells critical spell chance by 4%, and increase its DC by +2.`,
            prereq: "Arcane Duelist Style",
        },
        {
            name: "Arcane Duelist Quickdraw",
            type: "style",
            shortDesc: "",
            longDesc: `When you enter a floor, or when you gain this feat, choose a single ray spell you know that has a casting time of a standard action or less, then while you are in Arcane Duelist style, once per floor, you can fire that ray spell as an immediate action (and its treated as if you had prepared to cast the spell) in response to you being targeted or within the area of a spell or spell-like ability cast by the creature. When you do so, you both roll initiative checks, or a reflex save, whichever the creature prefers, to see who's spell goes off first, whoever wins may cause the other creature to have their spell interrupted due to concentration and ability to take actions as normal.`,
            prereq: "Arcane Duelist Riposte",
        },        
        {
            name: "Sacred Flame Style",
            type: "style",
            shortDesc: "",
            longDesc: `When you cast a spell that heals hit points of a creature other than yourself, you become charged with energy, gaining a morale bonus equal to the level of the spell on your next weapon attack before the end of your next turn. This lasts an additional attack for each Sacred Flame feat you have.`,
            prereq: "",
            key:true,
        },
        {
            name: "Sacred Flame Blessing",
            type: "style",
            shortDesc: "",
            longDesc: `When you cast a spell that heals hit points of a creature other than yourself, you also heal hit points equal to 3x the level of the spell cast (this scales with positive spell), and if you attack a creature before the end of your next turn with a weapon attack you gain a sacred bonus to your armor class against that creature equal to the level of the spell for 3 rounds.`,
            prereq: "Sacred Flame Style",
        },
        {
            name: "Sacred Flame Judgement",
            type: "style",
            shortDesc: "",
            longDesc: `When you cast a spell that heals hit points of a creature other than yourself, you become charged with energy, your next weapon attack before the end of your next turn deals bonus damage equal to half of the healing done to the creature. If the ability heals mutliple creatures you pick the highest amount healed to determine this bonus damage. This bonus damage is divine damage and not subject to damage reduction or resistance, is not multiplied on critical hits, and is ever only applied to a single creature (the first hit by the attack). This feat only counts the actual hit points restored, so overhealing as temporary hitpoints, or healing wasted beacuse of max health do not count.`,
            prereq: "Sacred Flame Blessing",
        },
        {
            name: "Elemental Conduit Style",
            type: "style",
            shortDesc: "",
            longDesc: `When you activate this style you choose a particular element, for the rest of the floor when you adopt this style it is always of the element chosen. While in this style, your spells of the particular element gain 10 spell power. Whether you have this style active or not (once you've activated for the first time on a floor), your other spells lose 15 spell power. For each addiitional Elemental Conduit Feat you have both the power bonus increases by 10 and the penalty increases by -15.`,
            prereq: "",
            key:true,
        },
        {
            name: "Elemental Conduit Imbument",
            type: "style",
            shortDesc: "",
            longDesc: `While in Elemental Conduit Style, for each Elemental Conduit feat you have, you gain resistance 5 to that element, and ignore 5 points of resistance of that element.`,
            prereq: "Elemental Conduit Style",
        },
        {
            name: "Elemental Conduit Apotheosis",
            type: "style",
            shortDesc: "",
            longDesc: `While in Elemental Conduit Style, increase the maximum damage dice a damage spell of your selected element can deal because of its level by 3. Whether you have this style active or not (once you've activated for the first time on a floor), Reduce the maximum damage dice elemental spells of the other types can deal by 4 and they lose 2% spell critical chance.`,
            prereq: "Elemental Conduit Imbument",
        },
        {
            name: "Archmage's Style",
            type: "style",
            shortDesc: "",
            longDesc: `You can sacrifice the knowledge of spells to empower your other spells. You can sacrifice a spell known while casting another spell to gain on of the various effects (choose one):
            \nGain 5 spell power per level of the spell. \nIncrease the DC by the sacrificed spells level/2 \nGain a bonus to concentration equal to the spells level.\nIncrease the spells critical range by 1% per 3 levels of the sacrificed spell.
            \n\nDoing this is a swift action, and spells sacrificed this way are lost for the rest of the floor.`,
            prereq: "",
            key:true,
        },
        {
            name: "Archmage's Metamastery",
            type: "style",
            shortDesc: "",
            longDesc: `You can sacrifice a spell as a swift action when applying a metamagic feat to a spell, sacrificing the spell permanently to apply the metamagic feat to the spell. The spell must be the same level or higher than the level adjustment of the metamagic feat, or you can sacrifice multiple spells of lower level to combine to equal the level of the metamagic feat level adjustment. You can only apply a single metamagic feat this way per spell. Applying a metamagic feat this way means the modified spell does not cost any additional spell points, require a higher level to cast, or modify its casting time, however using this ability is a swift action.`,
            prereq: "Archmage's Style",
        },
        {
            name: "Archmage's Weave Overload",
            type: "style",
            shortDesc: "",
            longDesc: `You can now sacrifice 2 spells at once when activating Archmage's styles benefit, however one of the spells lost is now lost permanently. Additionally, when you fail a saving throw you can sacrifice a spell known to reroll that save with a bonus equal to the spells level/2. Doing this is an immediate action, and the spell sacrificed this way becomes lost permanently. If you fail the saving throw even after rerolling it, you can activate this ability again, but you gain no bonus, and you must sacrifice a spell of a higher level than the previous spell. You can do this multiple times as long as you keep spending higher level spells.`,
            prereq: "Archmage's Metamastery",
        },
        {
            name: "Arcane Overload Style",
            type: "style",
            shortDesc: "",
            longDesc: `You channel exessive amounts of magical energy, regardless of the destruction to your own body for maximum destructive effect. When casting a spell you can spend additional spell points and hit points equal to 2x the spell's level to gain 1 overload point. You can do this twice per spell. You can then use those overload points to augment the spell cast with the options below, even using the same augment multiple times, their cost indicated by the number to the right:
            \n1: Increase the spell power by 10.\n1: Gain +2 to concentration checks for the spell.\n1: Gain +1 to overcome spell resistance.`,
            prereq: "",
            key:true,
        },        
        {
            name: "Arcane Overload Unleashed",
            type: "style",
            shortDesc: "",
            longDesc: `You can now have a maximum of 4 overload points on a spell. You also gain additional ways to spend your overload points:
            \n1: Increase the spell's critical chance by 2%. \n2: Increase the caster level of the spell by +1.\n3: Increase the DC by +1.`,
            prereq: "Arcane Overload Style",            
        },
        {
            name: "Uncontrolled Arcane Overload",
            type: "style",
            shortDesc: "",
            longDesc: `You can increase the maximum number of overload points you can have on a spell by 2, but these overload points cost twice the normal spell points and hit points.`,
            prereq: "Arcane Overload Unleashed",
        },
        {
            name: "Arcane Overload Overwhelming",
            type: "style",
            shortDesc: "",
            longDesc: `You can now have a maximum of 6 overload points on a spell. You also gain additional ways to spend your overload points:
            \n1:Increase your spells critical damage by 10%. \n1: Gain 4% spell critical chance, but 2% spell critical failure chance.`,
            prereq: "Arcane Overload Unleashed",            
        },        
        {
            name: "It Carries Over",
            type: "magic",
            shortDesc: "",
            longDesc: "You can apply the effects of a [critical feat] such as bleeding critical or stunning critical to your spell criticals. You can use your highest mental stat + the spell level in place of your BAB for determining its DC and effects.",
            prereq: "",            
        },
        {
            name: "Arcane Breach",
            type: "magic",
            shortDesc: "",
            longDesc: "When a creature fails a saving throw against one of your control spells they take a -2 penalty to the save of the next non-control damage spell you cast on them within 3 rounds.",
            prereq: "",
        },
        {
            name: "Just Let it Happen",
            type: "magic",
            shortDesc: "",
            longDesc: "You can roll a diplomacy or bluff check against a creature as a movement action DC 10+ sense motive or wisdom modifier, if you succeed they take a -1 penalty to their next save you cause them to make within 1 round. For each 10 you beat the check by increase the penalty by -1. This doesn't work on creatures who cant understand you. If you fail the check, they get a +2 bonus against the next save you cause them to make, +1 for each 5 you failed by.",
            prereq: "",
            key:true,
        },
        {
            name: "Strong Tail",
            type: "utility",
            shortDesc: "",
            longDesc: `Your Trail can now be used to hold and draw weapons, though they cannot be used by your tail and grant no benefit when being held this way. Drawing items with your tail no longer provokes attacks of opportunity. You gain a +2 bonus to your CMD against trip, bullrush, and repositition maneuvers.`,
            perkPrereq: ["Vanara"],
        },
        {
            name: "Return to Monkey",
            type: "utility",
            shortDesc: "",
            longDesc: `As an immediate action when you are about to make a save against a mind-affecting effect that isn't also a fear effect, you can take 1d4 points of damage to your intelligence, doing so grants double the amount lost as a bonus to the save. If you roll a natural 20 on the save, the creature who forced you to make the save takes 2d4 points of damage to its intelligence, creatures normally immune to ability damage are not immune to this.`,
            perkPrereq: ["Vanara"],
        },
        {
            name: "Monkey Mode",
            type: "utility",
            shortDesc: "",
            longDesc: `When prone you gain +2 bonus to your armor class and on melee attacks. This does not remove the penalties. When you use a movement action to move 5-feet while prone it does not provoke attacks of opportunity.`,
            perkPrereq: ["Vanara"],
        },
        {
            name: "Tree Hanger",
            type: "utility",
            shortDesc: "",
            longDesc: `You gain a +2 bonus to your CMD against all trip attacks. If your square has a branch or other sturdy large object that you could hang from, as a swift action you may make a DC 15 Acrobatics check to jump upward and use your tail to hang from that object. While hanging, you can't be tripped, you ignore the effects of difficult terrain in your square, and you gain a +2 bonus to your CMD against bull rush, drag, and reposition attacks. If you leave that square (including if you are moved against your will), you lose your grip on the object and are no longer hanging. While hanging, you cannot use your tail for anything else.`,
            perkPrereq: ["Vanara"],
        },
        {
            name: "Born of the Elements",
            type: "martial",
            shortDesc: "",
            longDesc: `You can use your suli special ability once per combat instead of once per day, and its damage dice becomes 1d10 damage instead of 1d6.`,
            perkPrereq: ["Suli"],
        },
        {
            name: "Elemental Conduit",
            type: "martial",
            shortDesc: "",
            longDesc: `When you use your suli special ability, you gain additional bonuses depending on which element you choose:
            \nFire: You heal 1d6 hit points for every 3 levels (minimum 1d6), and your attacks during the duration also deal 1 extra damage per damage dice the ability grants
            \nCold: Your melee weapon attacks have their critical damage multiplier increased by +1.
            \nElectricity: You can move half your movement speed immediately and you gain a +2 dodge bonus to armor class for the duration.
            \nAcid: You gain +5 natural armor and CMD.`,
            perkPrereq: ["Suli"],
        },
        {
            name: "Elemental Suffusion",
            type: "martial",
            shortDesc: "",
            longDesc: `When you channel an element, your resistance against that element and the opposing elemental increase to 30 for the round.`,
            perkPrereq: ["Suli"],
        },
        {
            name: "Magical Suffusion",
            type: "martial",
            shortDesc: "",
            longDesc: `When you channel an element, the bonus damage also applies to ranged weapons, and your caster level when casting spells of that element increases by +2, and their DC increases by +1. This can go over the usual level cap for spells.`,
            perkPrereq: ["Suli"],
        },
        {
            name: "Fully Fanged",
            type: "martial",
            shortDesc: "",
            longDesc: `Your bite attack base damage increases to 1d6. When you regain hit points from using your bite attack, you instead regain hit points equal to the full damage instead of half. If you ever score a critical hit with your fangs, it deals 1 point of constitution damage and you gain temporary hit points and spell points equal to your level. These last 3 rounds.`,
            perkPrereq: ["Dhampir"],
        },
        {
            name: "Undead Resistances",
            type: "utility",
            shortDesc: "",
            longDesc: `You gain a +2 bonus on will saves mind-affecting effects, stun, ability damage, ability drain, sleep.`,
            perkPrereq: ["Dhampir"],
        },
        {
            name: "Numerological Gift",
            type: "utility",
            shortDesc: "",
            longDesc: `When you select this feat roll 3d6. Once per day when you roll that number on a d20 roll, you can treat it as if you had rolled a natural 20. Additionally, once per day, as an immediate action before making a d20 roll, you can treat it as having rolled that number, or when an enemy makes a d20 roll you can treat it as if it had rolled than number. You have to see the enemy to use this ability.`,
            perkPrereq: ["Dhampir"],
        },
        {
            name: "Deadly Fangs",
            type: "martial",
            shortDesc: "",
            longDesc: `Your bite attack base damage increases to 1d8, its critical threat range becomes 19-20, and its critical damage multiplier becomes x3.`,
            prereq: "Fully Fanged",
        },
        {
            name: "Calculated Risk",
            type: "utility",
            shortDesc: "",
            longDesc: `Once per day, you may voluntarily fail a saving throw against a harmful spell or effect. After using this ability, for the next minute you may add a +4 trait bonus on one saving throw, after which the bonus is expended. You may use this bonus on an additional saving throw against the spell or effect you voluntarily failed (such as a recurring poison save or a follow-up save against hold person). If you do not use this bonus within 1 minute, it is lost. If you succeed on this new saving through, this ability recharges, but instead only grants a +2 bonus, then a +1 bonus, then it is expended.`,
            prereq: "",
        },
        {
            name: "Vampire Pounce",
            type: "martial",
            shortDesc: "",
            longDesc: `You gain a +2 bonus to grapple attempts. Whenever you initiate or maintain a grapple on a creature you may make a free bite attempt against the creature.`,
            perkPrereq: ["Dhampir"],
        },
        {
            name: "Almost Alive",
            type: "utility",
            shortDesc: "",
            longDesc: `Instead of healing from negative energy, you are just immune to it. You now heal 75% from positive energy. Any effect that provides benefits from you being undead, instead only have 50% effectiveness, or have a 50% chance to affect you.`,
            perkPrereq: ["Dhampir"],
        },
        {
            name: "One With the Wind",
            type: "utility",
            shortDesc: "",
            longDesc: `Increase your movement speed by 5 feet. When you move at least 30 feet in a round you gain a +1 dodge bonus to armor class. For each 15 feet you move after 30 feet you gain an another additional +1 dodge bonus to your armor class.`,
            perkPrereq: ["Sylph"],
        },
        {
            name: "Rockmancy",
            type: "martial",
            shortDesc: "",
            longDesc: `Increase the damage dice of your rocks by 1 dice step, their range increment by 10 feet, and you can sacrifice 1 hit point as a free action to make a rock appear in your hand.`,
            perkPrereq: ["Oread"],
        },
        {
            name: "Improved Rockmancy",
            type: "martial",
            shortDesc: "",
            longDesc: `Increase the damage dice of your rocks by another dice step, their base critical damage multiplier becomes x3.`,
            prereq: "Rockmancy",
        },
        {
            name: "Greater Rockmancy",
            type: "martial",
            shortDesc: "",
            longDesc: `Increase the damage dice of your rocks by another dice step, their base critical threat range becomes 19-20. You can sacrifice up to 5 additional hit points when making a rock to grant a created rock a +5 enhancement bonus. This does not allow it to bypass DR except DR magic.`,
            prereq: "Improved Rockmancy",
        },
        {
            name: "Magic Rocks",
            type: "martial",
            shortDesc: "",
            longDesc: `You can spend level/2 spell points when throwing a rock. When you do, they scale with acid spell power. This does not give them your spell critical chance.`,
            prereq: "Improved Rockmancy",
        },
        {
            name: "Jewels of the Earth",
            type: "utility",
            shortDesc: "",
            longDesc: `You gain a +1 bonus on all saving throws for each epic and higher ring or amulet you are wearing. If it is unique it instead becomes a +2 bonus to saving throws.`,
            perkPrereq: ["Oread"],
        },
        {
            name: "Crystal Skin",
            type: "utility",
            shortDesc: "",
            longDesc: `Gain an additional +2 armor class against rays. Once per day when a magical ray attack misses you, you can redirect that ray towards a creature within 50 feet, you make the ranged touch attack, but all other effects of the spell are determined by the original caster.`,
            perkPrereq: ["Oread"],
        },        
        {
            name: "Spirit Link",
            type: "magic",
            shortDesc: "",
            longDesc: `Whenever your Mysthral power activates successfully you restore 3 spell points.`,
            perkPrereq: ["Mysthral"],
        },
        {
            name: "Spirit Bound",
            type: "magic",
            shortDesc: "",
            longDesc: `Whenever your Mysthral power activates successfully you restore 3 + your highest mental stat spell points instead of 3.`,
            perkPrereq: ["Mysthral"],
            prereq:"Spirit Link"
        },
        {
            name: "Warrior's Pride",
            type: "martial",
            shortDesc: "",
            longDesc: `While in a martial stance you deal additional damage on weapon attacks during martial strikes equal to the level of the stance until the creature damages you for the first time. If you have multiple stances active at once, this stacks.`,
            perkPrereq: ["Hobgoblin"],
        },
        {
            name: "Feast on Terror",
            type: "martial",
            shortDesc: "",
            longDesc: `Whenever a creature you can see becomes shaken, panicked, or terrified, you gain a +1 morale bonus on attack and damage rolls for 1 round. This bonus stacks with itself, and lasts an additional round every 6 levels.`,
            perkPrereq: ["Hobgoblin"],
        },
        {
            name: "Honorless Filth",
            type: "martial",
            shortDesc: "",
            longDesc: `You reduce the numerical bonuses granted by teamwork feats for allies who are gaining benefits from a teamwork feat because of you -1, but you instead have the numerical bonuses increased by +1. If you have multiple allies sharing teamwork feats at once this bonus can stack.`,
            perkPrereq: ["Hobgoblin"],
        },
        {
            name: "Tyrant",
            type: "martial",
            shortDesc: "",
            longDesc: `Whenever an ally you can see is reduced below 0 hit points you can spend an immediate action to cause them to become frightened for 1 round. During that round they are disabled rather than dying. They are shaken for 1d4+1 rounds afterward the round.`,
            perkPrereq: ["Hobgoblin"],
        },
        {
            name: "Genetic Burst",
            type: "utility",
            shortDesc: "",
            longDesc: `Once per day as a free action you can take even when it is not your turn, you can ignore a deformity or you can double the effects of one of your mutations for 1 round. If the original mutation included a random bonus, then you can choose what it applies to. This doesn't affect reduced ability.`,
            perkPrereq: ["Mutant"],
        },
        {
            name: "True Monstrocity",
            type: "utility",
            shortDesc: "",
            longDesc: `Your racial natural armor bonus increases by +1 for each mutation you have, and you gain an additional +2 bonus to intimidate for each deformity you have.`,
            perkPrereq: ["Mutant"],
        },
        // {
        //     name: "Is this",
        //     type: "utility",
        //     shortDesc: "",
        //     longDesc: ``,
        //     perkPrereq: ["Mutant"],
        // },
        {
            name: "Fan-Bearer at the King's Right Hand",
            type: "utility",
            shortDesc: "",
            longDesc: `As a swift action you can designate a creature as your charge, as long as you are adjacent to your charge, they gain all of your bonuses from the defense section of Shabti.`,
            perkPrereq: ["Shabti"],
        },
        {
            name: "First General of the East",
            type: "martial",
            shortDesc: "",
            longDesc: `You can cast greater magic weapon once per day as a spell-like ability, however only you can wield this enchanted weapon.`,
            perkPrereq: ["Shabti"],
        },
        {
            name: "Lector Priest",
            type: "magic",
            shortDesc: "",
            longDesc: `You can roll twice taking the higher result on spell craft, knowledge religion, and knowledge arcana checks. You gain a +2 bonus to overcome spell resistance of creatures who do not share your good/neutral/evil alignment.`,
            perkPrereq: ["Shabti"],
        },
        {
            name: "Overseer of the House of Truth",
            type: "magic",
            shortDesc: "",
            longDesc: `Your mind-affecting compulsion and charm spells gain a +2 bonus to their DC. You can cast suggestion once per day as a spell-like ability. Every 7 levels you can cast it an additional time.`,
            perkPrereq: ["Shabti"],
        },
        {
            name: "Servant in the House of Truth",
            type: "utility",
            shortDesc: "",
            longDesc: `Whenever you attempt a check for a Knowledge skill you can roll the check twice and use the better of the two results.`,
            perkPrereq: ["Shabti"],
        },
        {
            name: "Immortal",
            type: "utility",
            shortDesc: "",
            longDesc: `You add your level an additional time to how negative your hit points can go before you die. When below 0 hit points, you can sacrifice 2 spell points to reduce the amount of damage taken by 1. You can even do this to the attack that reduces you below 0 hit points, however it cannot reduce the damage any more than what is required to reduce you below 0 hit points.`,
            perkPrereq: ["Shabti"],
        },
        {
            name: "Ancestral Weapon Mastery",
            type: "martial",
            shortDesc: "",
            longDesc: `You gain a +2 bonus on attacks with bows and one-handed heavy blades. You can use dexterity to determine your attack modifier with one-handed heavy blades.`,
            perkPrereq: ["Elf"],
        },                
        {
            name: "Fleet-Footed",
            type: "utility",
            shortDesc: "",
            longDesc: `You gain an additional 10 foot bonus to your running speed, reduced to 5 feet if you are wearing heavy armor. You also gain +2 initiative, and move an additional 10 feet when running or charging.`,
            perkPrereq: ["Elf"],
        },
        {
            name: "Overwhelming Magic",
            type: "magic",
            shortDesc: "",
            longDesc: `Your spells gain a +1 bonus to their DC.`,
            perkPrereq: ["Elf","High Elf","Drow"],
        },
        {
            name: "Trained Alcoholic",
            type: "utility",
            shortDesc: "",
            longDesc: `You can drink potions as a move action. This does not allow you to drink potions while moving.`,
            perkPrereq: ["Dwarf"],
        },
        {
            name: "Elves Live in Trees!",
            type: "utility",
            shortDesc: "",
            longDesc: `You gain a +2 bonus on attacks and damage with weapons from the axe weapon group. If you use an axe to attack an elf your critical threat range and multiplier both increase by a flat +1.`,
            perkPrereq: ["Dwarf"],
        },
        {
            name: "Dented Helm",
            type: "utility",
            shortDesc: "",
            longDesc: `While wearing at least medium armor, you gain a +1 bonus to your AC against critical confirmation rolls. When a critical hit is confirmed against you, as an immediate action, you can apply half of the damage from the attack to your armor rather than yourself, applying hardness as normal. If the damage destroys your armor, any leftover damage is applied to you. After using this feat, you are staggered until the end of your next turn. You may not use this feat if your armor has the broken condition or the attack ignores armor bonuses to AC.`,
            perkPrereq: ["Dwarf"],
        },
        {
            name: "Ironguts",
            type: "utility",
            shortDesc: "",
            longDesc: `You gain an +2 racial bonus on saving throws against any effect causing the nauseated or sickened conditions and against all poisons.`,
            perkPrereq: ["Dwarf","Goblin","Android","Mutant","Hobgoblin","Lizardfolk","Ratfolk", "Orc", ],
        },
        {
            name: "Toxic Recovery",
            type: "utility",
            shortDesc: "",
            longDesc: `You gain an additional +1 racial bonus on saving throws against poisons. When you succeed at a saving throw against a poison, you heal 1 point of ability damage of the type dealt by the poison. Whenever you heal ability damage naturally or magically, you heal 1 additional point of ability damage.`,
            perkPrereq: ["Dwarf"],
        },
        {
            name: "Let Them Come",
            type: "martial",
            shortDesc: "",
            longDesc: `You treat all one- or two-handed melee weapons as if they had the brace special feature. You gain a +2 bonus on all attacks made during a prepared action.`,
            perkPrereq: ["Dwarf"],
        },
        {
            name: "Ironflesh",
            type: "utility",
            shortDesc: "",
            longDesc: `You increase your racial bonus to your natural armor by +2.`,
            perkPrereq: ["Dwarf","Orc","Oread","Shabti","Half Giant","Lizardfolk","Deep One Hybrid","Mutant","Dragonborn","Android","Ganzi","Tiefling","Hobgoblin"],
            hasCustomMethod: true,
            catchUpMethod:(context)=>{
                context.stats.statsForAbilities.ac.natural += 2
            },
        },
        {
            name: "Cleaver",
            type: "martial",
            shortDesc: "",
            longDesc: `When using a cleaving attack, such as a cleave feat, whirlwind attack, or a martial maneuver that strikes multiple creatures at once, the attack gain a +1 bonus and deals an additional 1d6 damage. Every 8 BAB this bonus increases by +1 to attack and 1d6 damage.`,
            perkPrereq: ["Dwarf"],
        },
        {
            name: "Unstoppable",
            type: "utility",
            shortDesc: "",
            longDesc: `You gain +5 hit points. For every Hit Die you possess you gain an additional +2 hit points.`,
            perkPrereq: ["Dwarf"],
        },
        {
            name: "Sky Sentinel",
            type: "martial",
            shortDesc: "",
            longDesc: `Enemies on higher ground gain no attack roll bonus against you, and you gain a +1 racial bonus on attack rolls and a +2 dodge bonus to AC against flying creatures as long as you are on the ground. When directly underneath a flying creature, you treat your reach as 5 feet longer. When you hit a flying creature, the fly DC to avoid falling 5 feet increases by 10.`,
            perkRateUp: ["Dwarf"],
        },
        {
            name: "Lasting Grudge",
            type: "martial",
            shortDesc: "",
            longDesc: `When you gain this feat, they select a creature type, if outsider is selected they must select a subtype as well. They gain a +2 bonus on attacks and damage against this creature type.`,
            perkPrereq: ["Dwarf"],
        },
        {
            name: "Book of Grudges",
            type: "martial",
            shortDesc: "",
            longDesc: `When a creature confirms a critical hit against you, and that critical hit reduces you below 0 hit points, their creature type, (and subtype if it is an outsider) is added to your book of grudges, you gain a +1 bonus on damage rolls against them. This stacks stacks with lasting grudge, and itself if a creature type reduces you below 0 multiple times with a critical hit.`,
            prereq: "Lasting Grudge",
        },
        {
            name: "Viscous Blood",
            type: "utility",
            shortDesc: "",
            longDesc: `You take 1 less point of hit point damage, ability damage, or ability drain (minimum 1) from bleed and blood drain. You can attempt Heal checks to staunch your own bleeding as a swift action each round.`,
            perkRateUp: ["Dwarf"],
        },
        {
            name: "Blinding Sneak Attack",
            type: "utility",
            shortDesc: "",
            longDesc: `When you successfully deal sneak attack damage to a foe while you are within an area of magical darkness, you temporarily blind your opponent for 1 round. A successful Fortitude save (DC 10 + the amount of sneak attack damage dealt) negates this effect.`,
        },
        {
            name: "Infernal Flesh",
            type: "utility",
            shortDesc: "",
            longDesc: `You increase your resistance to cold, fire, and electricity by 5, and gain a +2 racial bonus to your natural armor.`,
            perkPrereq: ["Tiefling"],
        },
        {
            name: "Fiendish Darkness",
            type: "utility",
            shortDesc: "",
            longDesc: `You can use the darkness spell three times per day as a spell-like ability.`,
            perkPrereq: ["Tiefling"],
        },
        {
            name: "Improved Fiendish Darkness",
            type: "magic",
            shortDesc: "",
            longDesc: `You gain a +2 bonus to your effective caster level when casting darkness spells. In addition, whenever you cast a spell with the [evil] descriptor that targets another creature, you can spend a swift action to apply the effects of your darkness spell-like ability to the spell cast, with the darkness effect centered on the spell's target. Using the darkness spell-like ability in this way expends a use of your darkness spell like ability for each target of the spell if it has multiple.`,
            perkPrereq: ["Tiefling"],
        },
        {
            name: "Bringer of Doom",
            type: "utility",
            shortDesc: "",
            longDesc: `All enemies within 60 feet who can clearly see you take a -2 penalty on saving throws against fear.`,
            perkPrereq: ["Tiefling"],
        },
        {
            name: "Improved Fiendish Sorcery",
            type: "utility",
            shortDesc: "",
            longDesc: `You count as another level higher for the damage you deal with damage spells, this increase goes over the normal level damage cap.`,
            perkPrereq: ["Tiefling"],
        },
        {
            name: "Fiend Sight",
            type: "utility",
            shortDesc: "",
            longDesc: `You gain low-light vision and your darkvision improves to 120 ft. This also increases your vision distance on darkvision maps by 100% instead of the usual 50%.`,
            perkPrereq: ["Tiefling"],
        },        
        {
            name: "Improved Fiend Sight",
            type: "utility",
            shortDesc: "",
            longDesc: `You gain the see in darkness universal monster ability, which allows you to see even in magical darkness.`,
            prereq: "Fiend Sight",
        },
        {
            name: "Fury of the Tainted",
            type: "utility",
            shortDesc: "",
            longDesc: `You gain a +2 competence bonus on saves against spells with the good descriptor, or spells cast by good creatures. While raging this bonus doubles.`,
            perkPrereq: ["Tiefling"],
        },        
        {
            name: "Grasping Tail",
            type: "utility",
            shortDesc: "",
            longDesc: `You can use your tail to grab stowed items. While you cannot wield weapons with your tail, but you can grab an item from your bag once per combat as a swift action and it does not provoke.`,
            perkPrereq: ["Tiefling"],
        },
        {
            name: "Carnage Magic",
            type: "magic",
            shortDesc: "",
            longDesc: `Choose a school of magic, you lose 20 universal spell power. You gain 5% universal spell critical chance and 50% spell critical power.`,
            perkPrereq: ["Tiefling"],
            hasCustomMethod: true,
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellPower.universal -= 20
                context.stats.characterStats.spellMastery.spellCriticalChance.universal += 5
                context.stats.characterStats.spellMastery.spellCriticalDamage.universal += 50
            },
        },
        {
            name: "Maw and Claw",
            type: "martial",
            shortDesc: "",
            longDesc: `Your bite attack damage increases by 1 step, its critical damage multiplier becomes x3, and you gain 2 primary claw attacks that deal 1d4 points of damage.`,
            perkPrereq: ["Tiefling"],
        },
        {
            name: "Armor of the Pit",
            type: "utility",
            shortDesc: "",
            longDesc: `You increase your resistance to cold, fire, and electricity by 5, and increase your racial bonus to your natural armor by +2.`,
            prereq:"Infernal Flesh",
        },
        {
            name: "Infernal Resistance",
            type: "utility",
            shortDesc: "",
            longDesc: `You gain DR 3/good.`,
            prereq:"Infernal Flesh",
        },
        {
            name: "Fiendish Resistance",
            type: "utility",
            shortDesc: "",
            longDesc: `You increase your racial resistance to an element of your choice by 15.`,
            prereq:"Infernal Flesh",
        },
        {
            name: "Sunlit Strike",
            type: "utility",
            shortDesc: "",
            longDesc: `Whenever you successfully hit an enemy that is vulnerable to light (such as by the light blindness, light sensitivity, or sunlight powerlessness) with a melee weapon you've imbued with your Arcane Strike feat, you deal an additional 1d6 points of damage to the target of your attack. The struck creature must also succeed at a Fortitude saving throw (DC 10 + 1/2 level + Strength modifier) or become staggered for 1 round.`,
            prereq:"Arcane Strike",
            perkPrereq: ["Aasimar"],
        },
        {
            name: "Angelic Flesh",
            type: "utility",
            shortDesc: "",
            longDesc: `You increase your resistance to acid, cold, and electricity by 5, and gain a +2 bonus on saves against evil creatures.`,
            perkPrereq: ["Aasimar"],
        },
        {
            name: "Inner Light",
            type: "utility",
            shortDesc: "",
            longDesc: `Whenever you cast a light spell, you do so as if your caster level were one higher. Additionally, while in an area of magical darkness, you can attempt to dispel it as a standard action, making an opposed caster level check against it. You can only attempt this check a single time per individual spell.`,
            perkPrereq: ["Aasimar"],
        },
        {
            name: "Bringer of Light",
            type: "magic",
            shortDesc: "",
            longDesc: `You gain 30 positive spell power and 4% positive spell critical chance. You lose 8% universal spell critical chance and lose 15 universal spell power.`,
            perkPrereq: ["Aasimar"],
            hasCustomMethod: true,
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellPower.positive += 30
                context.stats.characterStats.spellMastery.spellCriticalChance.positive += 4
                context.stats.characterStats.spellMastery.spellPower.universal -= 15
                context.stats.characterStats.spellMastery.spellCriticalChance.universal -= 8
            },
        },
        {
            name: "Heart of the Crusader",
            type: "utility",
            shortDesc: "",
            longDesc: `Your insight bonus on attacks against evil creatures and evil outsiders from being an aasimar both increase by +1, and the DC of your spells cast against them increase by +1.`,
            perkPrereq: ["Aasimar"],
        },
        {
            name: "Heart of Charity",
            type: "magic",
            shortDesc: "",
            longDesc: `Your spells and abilities that heal hit points, have their amount increased by 1 point per dice rolled.`,
            perkPrereq: ["Aasimar"],
        },
        {
            name: "Savior",
            type: "utility",
            shortDesc: "",
            longDesc: `Once per day as an immediate action you can heal an ally within 60 feet who you can see that was just killed. The amount of healing is 1d6 per 2 levels, and can restore them to life. A creature revived this way receives a temporary negative level for 24 hours. This is a supernatural ability.`,
            perkPrereq: ["Aasimar"],
        },
        {
            name: "Lost Promise",
            type: "martial",
            shortDesc: "",
            longDesc: `You have lost your way, and become corrupt, showing demonic malformities. You gain a bite attack that deals 1d4 damage. If you are evil, this damage increases to 1d8. You take a -2 penalty on saves against abilities and spells from good creatures, but your racial bonuses that apply against evil creatures now also apply to good counterparts.`,
            perkPrereq: ["Aasimar"],
        },
        {
            name: "Smite Good",
            type: "martial",
            shortDesc: "",
            longDesc: `Once per day, You can smite a good-aligned creature. As a swift action, you choose one target within sight to smite. If this target is good, you add your highest mental modifier to attack rolls against the target and gains a bonus on damage rolls against the target equal to your level. This effect lasts up to 5 rounds.`,
            perkPrereq: ["Tiefling"],
        },
        {
            name: "Smite Evil",
            type: "martial",
            shortDesc: "",
            longDesc: `Once per day, You can smite a evil-aligned creature. As a swift action, you choose one target within sight to smite. If this target is evil, you add your highest mental modifier to attack rolls against the target and gains a bonus on damage rolls against the target equal to your level. This effect lasts up to 5 rounds.`,
            perkPrereq: ["Aasimar"],
        },
        {
            name: "Incorruptible",
            type: "magic",
            shortDesc: "",
            longDesc: `You gain a +2 bonus on saves against charm, compulsion, and possession effects from evil creatures. If you are under the effects of a spell and it forces you to attack an ally, you get an immediate resave against that ability. If this resave fails, you are granted no additional saves from this feat against that effect.`,
            perkPrereq: ["Aasimar","Tiefling"],
        },
        {
            name: "Angel Wings",
            type: "utility",
            shortDesc: "",
            longDesc: `You gain a pair of wings that grant a fly speed of 30 feet (average maneuverability) if wearing light armor or unencumbered, or 20 feet (poor maneuverability) with a medium or heavy load or medium or heavy armor.`,
            prereq: "Angelic Flesh",
        },
        {
            name: "Metallic Wings",
            type: "utility",
            shortDesc: "",
            longDesc: `You gain two wing attacks. These are secondary natural attacks that deal 1d4 points of slashing damage (or 1d3 if you are Small).`,
            prereq: "Angel Wings",
        },
        {
            name: "Angler Jaw",
            type: "martial",
            shortDesc: "",
            longDesc: `If you have undergone your final change, you also gain a bite attack that deals 1d6 damage. This bite attack has a critical damage multiplier of x3.`,
            perkPrereq: ["Deep One Hybrid"],
        },
        {
            name: "Pinnacle of Elf Kind",
            type: "magic",
            shortDesc: "",
            longDesc: `Increase your effective caster level for all magic perks by 1 and gain 15 universal spell power. You gain a +2 bonus on caster level checks.`,
            perkPrereq: ["High Elf"],
            hasCustomMethod: true,
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellPower.universal += 15
            },
        },
        {
            name: "Peasant Deflector",
            type: "utility",
            shortDesc: "",
            longDesc: `Once per floor when you would take damage, you can instead lose spell points equal to the damage dealt. Any excess damage to your spell points is dealt to you as normal. If this reduces the damage you take to 0 then the attack does not count as having hit you for any additional effects of the attack.`,
            perkPrereq: ["High Elf"],
        },
        {
            name: "Get Your Paws Off Me!",
            type: "utility",
            shortDesc: "",
            longDesc: `You can now use Peasant Shield once per combat. Additionally, when you use it, you gain your highest mental stat x2 as a bonus to your CMD against any grapple checks for 1 round.`,
            prereq: "Peasant Deflector",
        },
        {
            name: "Unwavering Sense of Superiority",
            type: "utility",
            shortDesc: "",
            longDesc: `When you are making a saving throw against an effect from a foe that is effecting multiple creatures at once, if all other targets fail the save but you succeeded, you gain a +2 bonus on all d20 rolls for 1 round. If you were not going to succeed the save, you can reroll the save with a +2 bonus, however if you fail this as well your will is shaken and you take a -2 penalty to all saves for the rest of the floor. You can only gain one of these effects on an individual saving throw.`,
            perkPrereq: ["High Elf"],
        },
        {
            name: "Arcane Talent",
            type: "magic",
            shortDesc: "",
            longDesc: `Gain 10 universal spell power. High Elves gain an additional 10.`,
            perkPrereq: ["Gnome","Elf","High Elf","Drow"],
            hasCustomMethod: true,
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellPower.universal += 10
                if(context.stats.characterStats.race == "High Elf"){
                    context.stats.characterStats.spellMastery.spellPower.universal += 10
                }
            },
        },
        {
            name: "Metallic Wings",
            type: "martial",
            shortDesc: "",
            longDesc: `You gain two wing attacks. These are secondary natural attacks that deal 1d4 points of slashing damage.`,
            perkPrereq: ["Dragonborn"],
        },
        {
            name: "Draconic Magic",
            type: "magic",
            shortDesc: "",
            longDesc: `Gain 20 spell power and 10% spell critical power based on your draconic heritage. Lose 40 spell power and 10% spell critical chance of your opposing element.`,
            perkPrereq: ["Dragonborn"],
            hasCustomMethod: true,
            catchUpMethod:(context)=>{
                let perk = context.stats.lists.perks.find(perk => perk.name == "Dragonborn")
                let element = perk.longDesc.match(/Element:\s*(\w+)/i);
                let vulnerability = perk.longDesc.match(/Vulnerability:\s*(\w+)/i);

                element = element[1].toLowerCase()
                vulnerability = vulnerability[1].toLowerCase()

                context.stats.characterStats.spellMastery.spellPower[element] += 20
                context.stats.characterStats.spellMastery.spellCriticalDamage[element] += 10
                context.stats.characterStats.spellMastery.spellPower[vulnerability] -= 40
                context.stats.characterStats.spellMastery.spellCriticalChance[vulnerability] -= 10
            },
        },
        {
            name: "Incredible Ferocity",
            type: "martial",
            shortDesc: "",
            longDesc: `When below 25% hit points you double the bonus to damage you gain from being an orc. If you are below 0 hit points, you quadruple it instead.`,
            perkPrereq: ["Orc"],
        },
        {
            name: "Will Not Die!",
            type: "utility",
            shortDesc: "",
            longDesc: `When below 0 hit points and still conscious, you gain DR -/3. This stacks with all other DR.`,
            perkPrereq: ["Orc"],
        },
        {
            name: "Ferocious Action",
            type: "martial",
            shortDesc: "",
            longDesc: `When you fall to 0 hit points or fewer, you lose 2 hit points each round, but you are not staggered. If you are in a rage (such as that caused by the barbarian rage class feature), you instead only lose 1 hit point per round.`,
            perkPrereq: ["Orc"],
        },
        {
            name: "Ratmaxxing",
            type: "utility",
            shortDesc: "",
            longDesc: `When an ally is unwilling to reduce their armor class when you are sharing their square, you can still reduce their armor class by -4 to gain 2 armor class and reflex save. When they are willing, you can now reduce their armor class by up to -8 to gain a +4 bonus to your armor class and reflex saves.`,
            perkPrereq: ["Ratfolk"],
        },
        {
            name: "Treacherous Ally",
            type: "utility",
            shortDesc: "",
            longDesc: `When you are sharing a square with an ally and an attack is made against you, you spend an immediate action to redirect that attack to that ally.`,
            perkPrereq: ["Ratfolk"],
        },
        {
            name: "Extra Lucky",
            type: "utility",
            shortDesc: "",
            longDesc: `You can reroll a dice that resulted in a natural 1 and a failed saving throw an additional time per day. Whenever you reroll a roll, you gain a +1 to the result.`,
            perkPrereq: ["Halfling"],
        },
        {
            name: "Dragon Lungs",
            type: "utility",
            shortDesc: "",
            longDesc: `Your breath weapon damage dice increases by 1 step, and your bite attack deals an additional 1d6 points of damage of your element. On the round after you use your breath weapon your bite attack instead deals an additional 2d6 + 1d6 every 5 levels of damage type of your element.`,
            perkPrereq: ["Dragonborn"],
        },
        {
            name: "Arcane Breath",
            type: "magic",
            shortDesc: "",
            longDesc: `When using your breath weapon, it can count as casting a damage spell of the element of its damage with a spell level of your level/2 (this means it scales with your spell power. If it already did scale with your spell power, increase its scaling by 100%), however doing so makes it cost level spell points. You cannot modify it with metamagic feats.`,
            perkPrereq: ["Dragonborn"],
        },
        {
            name: "Sleep Venom",
            type: "martial",
            shortDesc: "",
            longDesc: `When spitting venom you may alter the effects of your venom so the target falls unconscious. This changes the initial and secondary effect of your venom to the following: initial effect staggered for 1d4 rounds; secondary effect unconsciousness for 1d4 rounds.`,
            perkPrereq: ["Vishkanya"],
        },
        {
            name: "Dispelling Blood",
            type: "martial",
            shortDesc: "",
            longDesc: `you can alter the effects of your venom to affect magic instead of flesh. Your venom functions as a targeted dispel magic effect when it strikes a creature, using your character level as your caster level. This dispelling effect affects creatures even if they are immune to poison effects.`,
            perkPrereq: ["Vishkanya"],
        },
        {
            name: "Potent Venom",
            type: "martial",
            shortDesc: "",
            longDesc: `You can use your spit venom 3 extra times per day, the DC increases by +2, and it now deals 1d3 points of ability score damage.`,
            perkPrereq: ["Vishkanya"],
        },
        {
            name: "Aberrant Venom",
            type: "martial",
            shortDesc: "",
            longDesc: `When you spit venom you can choose for it to either deal strength, intelligence, or charisma damage instead.`,
            perkPrereq: ["Vishkanya"],
        },
        {
            name: "Spit Venom",
            type: "utility",
            shortDesc: "",
            longDesc: `As a standard action you can now spit your venom up to 15 feet, requiring a ranged touch attack. On top of the effects of your venom normally, the creature must also make a reflex save or become blinded for 1 round.`,
            perkPrereq: ["Vishkanya"],
        },
        {
            name: "Virulent Venom",
            type: "martial",
            shortDesc: "",
            longDesc: `Your ability to spit poison deals 1d6 points of acid damage plus an additional 1d6 points of acid damage for every 3 Hit Dice you have, in addition to all other effects. This additional damage affects creatures even if they are immune to poison or succeed at their Fortitude saving throws. In addition, you gain one additional use per day of the ability to spit venom.`,
            perkPrereq: ["Vishkanya"],
        },
        {
            name: "Hemorhaging Venom",
            type: "martial",
            shortDesc: "",
            longDesc: `Your ability to spit poison granted deals 2d6 points of bleed damage on a failed saving throw in addition to all other effects. The bleeding can be stopped as normal with a successful DC 15 Heal check or the application of any effect that heals hit point damage. In addition, you gain one additional use per day of the ability to spit venom.`,
            perkPrereq: ["Vishkanya"],
        },
        {
            name: "Fast Envenoming",
            type: "martial",
            shortDesc: "",
            longDesc: `Your ability to spit poison becomes a free action, or you can use the spit venom feat as a movement action.`,
            perkPrereq: ["Vishkanya"],
        },
        {
            name: "Enduring Shapeshifting",
            type: "utility",
            shortDesc: "",
            longDesc: `You can maintain your animal form for an addititional 6 rounds per day.`,
            perkPrereq: ["Skinwalker"],
        },
        {
            name: "Zest for Battle",
            type: "martial",
            shortDesc: "",
            longDesc: `Whenever you have a morale bonus to weapon attack rolls, you also receive a +2 trait bonus on weapon damage rolls. If you have a morale bonus to weapon damage rolls, you gain a +1 trait bonus to attack rolls. If wielding an axe or hammer, or attacking an elf, these bonuses double (stacks if both).`,
            perkPrereq: ["Dwarf"],
        },
        {
            name: "Rapid Repair",
            type: "utility",
            shortDesc: "",
            longDesc: `You can use your nanite surge 2 additional times per day. You can now use nanite surge as an immediate action to heal yourself for 3 + your level hit points. This is not positive energy.`,
            perkPrereq: ["Android"],
        },
        {
            name: "Rapid Recovery",
            type: "utility",
            shortDesc: "",
            longDesc: `When you heal damage using Rapid Repair you increase the amount healed by you constitution score-10, and you remove any and all of the following conditions: blinded, confused, dazzled, deafened, shaken, sickened, and staggered. You cannot cure blindness or deafness caused by loss of sensory organs.`,
            prereq: "Rapid Repair",
        },
        {
            name: "Emergency Protocols",
            type: "utility",
            shortDesc: "",
            longDesc: `You can use your nanite surge 2 additional times per day. You can now also choose to apply the bonus after you have already rolled the d20, but it now costs 2 uses and only provides half the bonus.`,
            perkPrereq: ["Android"],
        },
        {
            name: "Nanomachines!",
            type: "utility",
            shortDesc: "",
            longDesc: `You can use your nanite surge an addititional 2 times per day. You can now use your nanite surge ability as an immediate action in response to an attack or damage roll. If you use it in response to an attack roll, you gain a racial bonus to your natural armor bonus equal to 1 + half your level. If you use it in response to a damage roll you gain DR/- equal to 3 + your level.`,
            perkPrereq: ["Android"],
        },
        {
            name: "Arcane School Spirit",
            type: "magic",
            shortDesc: "",
            longDesc: `When you select this feat choose a school of magic (healing, bluff, control, damage, utility). As a full-round action you extol the virtues of your type of magic to everyone around you, hyping yourself up. Make a bluff check vs your own sense motive check, your sense motive gaining a bonus equal to your level. If you succeed, for 1 round you can choose a bonus to apply to your school of magic of choice:
            \nIncrease its DC by +1
            \nIncrease its Caster level by +1, bypassing spells normal level damage cap
            \nReduce its spell point cost by 1. This cannot reduce a spells cost below 1.
            \n\nThis lasts an additional round for each 5 you beat your own sense motive by.`,
            perkPrereq: ["Gnome"],
        },
        {
            name: "Wizard Lizard Technique",
            type: "magic",
            shortDesc: "",
            longDesc: `You can use your highest mental stat to determine your attack and damage with your natural attacks.`,
            perkPrereq: ["Wizard Lizard"],
            secret:true,
        },
        {
            name: "Yo, Did Renekton Buy Rabadons!?",
            type: "magic",
            shortDesc: "",
            longDesc: `Why would he do that? Renekton doesn't scale with AP! As a standard action you can make an attack with a single natural attack against all enemies within your reach, you cannot use your highest mental stat to determine your attack and damage when using this attack.`,
            prereq: "Wizard Lizard Technique",
            secret:true,
        },
        {
            name: "Shadow Lizard Money Gang",
            type: "magic",
            shortDesc: "",
            longDesc: `They thought you were trolling, but it was all a part of the plan. You have unlocked hidden secrets forged from the magical techniques of a powerful magical, but shadowy organization. When you use 'Yo, Did Renekton Buy Rabadons!?' to make an attack against all enemies you threaten, it does use your highest mental modifier to determine your attack and damage, and your reach increases by 5 feet. You can also make an attack with all of your natural attacks instead of just one by using a full-round action.
            \nAdditionally, all primary natural attacks deal damage as if they were two-handed weapons, and secondary natural attacks deal damage as if they were one-handed. Whenever you score a critical hit with a natural attack, you heal hit points equal to your highest mental score.
            \nLastly, if when you got 'Yo, Did Renekton Buy Rabadons!?' any of your party members questioned your decision or made fun of you, you can take up to 100 gold from them. Whatever gold you took, you get 1.5x of. If you do this, you can no longer trade gold or use your gold for other players.`,
            prereq: "Yo, Did Renekton Buy Rabadons!?",
            secret:true,
        },
        {
            name: "Shadow Wizard Money Gang Initiate",
            type: "magic",
            shortDesc: "",
            longDesc: "You have joined the shadow wizard money gang. You gain access to new feats depending on your rank. Additionally, any spell with the darkness or shadow descriptors costs 50% less spell points, and their DC's are increased by +1.",
            prereq: "",
            perkPrereq:["Possible Initiate"],
            secret:true,
        },        
        {
            name: "Grand Shadow Wizard",
            type: "magic",
            shortDesc: "",
            longDesc: "You have ranked up in the shadow wizard money gang and gain access to new feats. You can now use the power of your status to destroy the will of enemies. Make a performance check as a full round action against a creature, DC=20+HD, if you succeed the creature is stunned for 1 round. If both of you are in an area of darkness, you gain a +5 bonus to the check. Gain an additional +1 bonus to the check for every 25 gold you are carrying. If you use .ACP to gain gold, you instead gain 2 small piles instead of 1.",
            prereq: "Shadow Wizard Money Gang Initiate",
            secret:true,
        },
        {
            name: "We Love Casting Spells",
            type: "magic",
            shortDesc: "",
            longDesc: "Spells you cast have their DC increased by +1 for every 100 gold you are currently carrying.",
            prereq: "Shadow Wizard Money Gang Initiate",
            secret:true,
        },
        {
            name: "Connections in High Places",
            type: "magic",
            shortDesc: "",
            longDesc: "You can spend 1 gold instead of a spell point. You can convert as much gold at a time as you want.",
            prereq: "Shadow Wizard Money Gang Initiate",
            secret:true,
        },
        {
            name: "Legalize Nuclear Bombs",
            type: "magic",
            shortDesc: "",
            longDesc: `Allies have a -2 penalty on saves against spells cast by you. When you cast a spread, or burst damage spell with a duration of instantaneous, its area is doubled and it deals an additional 1 point of damage per dice rolled, however they rarely land where you expect. When you cast such a spell roll a 1d2 and a 1d6, the 1d2 determines the direction, 1 is closer, 2 is further away, and the 1d6 determines how many squares further or closer it spreads from. Repeat this process to determine left right angle with 1 being to the left, and 2 being to the right. 
            \nIf you ever get the chance to activate a nuclear bomb, it doesn't deal its damage to you, or kill you instantly.`,
            prereq: "Shadow Wizard Money Gang Initiate",
            secret:true,
        },
        {
            name: "Sponsored by the Shadow Government",
            type: "utility",
            shortDesc: "",
            longDesc: "When you enter a store you gain 25 gold, plus an additional 10 for every spell with the darkness or shadow descriptor you know, and +3 for every veiled moon maneuver or stance you know.",
            prereq: "Grand Shadow Wizard",
            secret:true,
        },
        {
            name: "Bee's Make Honey",
            type: "utility",
            shortDesc: "",
            longDesc: "Whenever you are in an area of darkness created by a spell, you gain fast healing equal to half your level. Additionally, you can spend gold as a free action to heal hit points equal to the gold spent.",
            prereq: "Grand Shadow Wizard",
            secret:true,
        },
        {
            name: "Grand Imperial Shadow Wizard",
            type: "magic",
            shortDesc: "",
            longDesc: "You are the highest rank of shadow wizard. Each time you enter a floor you gain 50 gold. This doesn't apply to psuedo floors. You can spend 5 gold when rolling a damage roll to increase its total by +1. This can be applied to spells or attacks, and it stacks. You can spend 100 gold to cause any roll within 100 feet to be rerolled. You have to see it and be aware of it happening to do this, it takes no action, and can be done even when it is not your turn.",
            prereq: "Grand Shadow Wizard",
            secret:true,
        },
        {
            name: "Swag Messiah",
            type: "magic",
            shortDesc: "",
            longDesc: "You are the Swag Messiah. The DC of your spells is increased by +1 for every epic and above rarity wonderous item you are currently wearing, and +2 for every piece of clothing with at least a legendary enchantment on it.",
            prereq: "Grand Imperial Shadow Wizard",
            secret:true,
        },       
        {
            name: "Human Fighter",
            type: "martial",
            shortDesc: "",
            longDesc: `Cannot normally be obtained. Hm, I wonder how you can get it and what it does.`,
            perkPrereq: ["Special"],
        },
        {
            name: "Time to Game",
            type: "martial",
            shortDesc: "",
            longDesc: `Reduce the spell point cost of using any non-supernatural maneuver by 1. This cannot reduce the cost below 0 spell points. Every 6 levels reduce the cost of non-supernatural maneuvers by an additional 1. Choose one of the following bonuses when you select this feat:
            \nGain +2 damage with one-handed weapons\nGain +3 damage with two-handed weapons\nIncrease your armors armor bonus by +1 when wearing heavy armor\nIncrease your shield bonus with shields with at least a +2 base shield bonus by +1.
            \nSpells now cost 3x their original amount, magic perks cost 50% more. Spells cast on you by allies have their spell point cost increased by 50%.`,
            prereq: "Human Fighter",
            secret:true,
        },
        {
            name: "I'm Still Standing",
            type: "martial",
            shortDesc: "",
            longDesc: `Gain a +4 bonus on saves against spells and supernatural effects. This increases by +1 every 6 levels. You must attempt to save vs all spells and supernatural abilities, even if they are used by allies. If an ability used by an ally doesn't normally have a saving throw it gains a will save, DC 10+casters level/2+their highest mental. Once per turn if you succeed a saving throw against one of these abilities you heal 1d6 hit points per two levels.
            \nYou can no longer cast spells, magic perks cost 100% more instead. Increase the spell point cost of supernatural maneuvers by 50%.`,
            prereq: "Time to Game",
            secret:true,
        },
        {
            name: "I am a Human Fighter",
            type: "martial",
            shortDesc: "",
            longDesc: `If you have a feat that grants a numerical bonus to attack or damage with weapons, it is doubled. You can now use your human fighter potential critical ability once per floor, when you do your weapons critical damage multiplier increases by +1.
            \nYou can no longer cast spells, use supernatural abilities or magic perks.`,
            prereq: "I'm Still Standing",
            secret:true,
        },
        {
            name: "Strike Back",
            type: "martial",
            shortDesc: "",
            longDesc: `You can ready an action to make a melee attack against any foe that attacks you in melee, even if the foe is outside of your reach.`,
            prereq: "",
        },
        {
            name: "Hyperfocus",
            type: "utility",
            shortDesc: "",
            longDesc: `Whatever skill you have that currently has the most amount of ranks in it, gets your level as a bonus to it. All other skills take a -2 penalty.`,
            perkPrereq: ["Gnome"],
        },
        {
            name: "Elemental Strike",
            type: "martial",
            shortDesc: "",
            longDesc: `Any weapon you wield does 1 point of damage, increasing by 1 every 4 BAB of the elemental damage associated with your race. If you are a Suli, it deals damage as the last element you used with your special ability. This stacks with any other elemental damage your weapons may deal, but counts as a single source of elemental damage.`,
            perkPrereq: ["Ifrit","Oread","Sylph","Undine","Suli"],
        },
        {
            name: "Elemental Burst",
            type: "martial",
            shortDesc: "",
            longDesc: `Increase the elemental damage you deal from elemental strike by 1d6. When you score a successful critical hit, you also multiply the elemental damage you deal if it is of the same kind as the damage you are gaining from elemental Strike.`,
            prereq: "Elemental Strike",
        },
        {
            name: "One With Wind",
            type: "utility",
            shortDesc: "",
            longDesc: `Increase your movement speed by 5 feet. As a free action you can affect yourself as the fly spell which lasts 1 round. You can do this 3 times per day, plus an additional times for every 5 ranks of knowledge planes you have. This is a spell-like ability.`,
            perkPrereq: ["Sylph","Suli"],
        },
        {
            name: "One With Fire",
            type: "utility",
            shortDesc: "",
            longDesc: `Gain fast healing 1. As a free action you can affect yourself as the haste spell for 1 round. You can do this 3 times per day, plus an additional times for every 5 ranks of knowledge planes you have. This is a spell-like ability.`,
            perkPrereq: ["Ifrit","Suli"],
        },
        {
            name: "One With Earth",
            type: "utility",
            shortDesc: "",
            longDesc: `Increase your natural armor and CMD by +1. As a free action you can affect yourself as the ironskin spell for 1 round. You can do this 3 times per day, plus an additional times for every 5 ranks of knowledge planes you have. This is a spell-like ability.`,
            perkPrereq: ["Oread","Suli"],
        },
        {
            name: "One With Water",
            type: "utility",
            shortDesc: "",
            longDesc: `For each enemy past the first threatening you, you gain a +1 dodge bonus to your armor class, to a maximum of your wisdom modifier. As a free action you can affect yourself as the freedom of movement spell for 1 round. You can do this 1 time per day, plus an additional times for every 5 ranks of knowledge planes you have. This is a spell-like ability.`,
            perkPrereq: ["Undine","Suli"],
        },
        {
            name: "Arcane School Spirit Parade",
            type: "magic",
            shortDesc: "",
            longDesc: `When you use Arcane School Spirit, your ethusiastic speech spurs on everything around you. Anything that can hear you can also make a sense motive check vs your bluff, gaining a bonus equal to your level, if they fail, they can also pick one of the benefits of the feat, its duration and effect increasing the same way the feat effects you.`,
            prereq: "Arcane School Spirit",
        },
        {
            name: "Arcane School Fervor",
            type: "magic",
            shortDesc: "",
            longDesc: `Your fervor for your chosen school of magic is overwhelming, when using Arcane School Spirit, before you roll your bluff or sense motive check, you can choose to take a -10 penalty to your bluff, if you do, you can choose to select an additional bonus granted by the feat. You can select the same bonus multiple times, its effects stack. If you have arcane school spirit parade then all creatures who can hear you can also gain additional bonuses.`,
            prereq: "Arcane School Spirit",
        },        
        {
            name: "Infinite Binding Technique",
            type: "magic",
            shortDesc: "",
            longDesc: "When you cast a control spell on a creature it takes a -2 penalty to the save for each unique control spell currently effecting it that you cast.",
            prereq: "",
        },
        {
            name: "Burning Citadel Style",
            type: "style",
            longDesc: `For each Burning Citadel Style feat you have, your immolation stacks can deal damage an additional time per round (you may choose which instance provides this additional damage), and the maximum damage of your immolation stacks increases by +1 multiple (x2,x3,x4). 
            \nWhen you enter this style, you must choose between two options, Burning Bastion Style, or Burning Vanguard Style. This choice reflects which chain of following style feats you will be benefiting from. you can swap which you are benefiting from as a swift action, or when you change from one Burning Citadel stance to another. If you have the ability to maintain two style feats as once, you can choose each to be treated as a different style to maintain both.
            \nBurning Vanguard: Whenever you remove an immolation stack from an enemy, they take untyped damage equal to the stacks removed.
            \nBurning Bastion: Whenever you remove an immolation stack from yourself or an ally, they heal 1 hit point per stack removed. All healing gained from this feat in a round counts as only a single instance of healing, unless the removal of the stacks would also heal, then it instead counts as part of the healing provided by that ability.`,
            prereq: "",
        },
        {
            name: "Burning Bastion Fire and Solace",
            type: "style",
            longDesc: "When in Burning Citadel style, you gain fast healing equal to 1/2 of your immolation stacks, up to a maximum of your initiation modifier. When you are at the maximum amount of immolation stacks to provide you this fast healing, every time you gain an immolation stack, you gain 1 temporary hit point that lasts until the end of combat. The temporary hit points increase by 1 per 8 levels.",
            prereq: "Burning Citadel Style",
        },
        {
            name: "Burning Bastion Covering Fire",
            type: "style",
            longDesc: "When in Burning Citadel style, once per round when a creature takes bonus damage due to your immolation stacks, you heal hit points equal to the amount of bonus damage dealt (you may choose which instance of damage you heal from). Additionally, whenever a critical hit is scored against you or an ally with immolation stacks you gave, they automatically heal hit points equal to the immolation stacks (positive energy), and gain an equal amount of temporary hit points that last 1 round. If you have 5 Burning Citadel Style feats, this increases to 3 rounds and the temporary hit points are doubled.",
            prereq: "Burning Bastion Fire and Solace",
        },
        {
            name: "Burning Bastion Eternal Flame",
            type: "style",
            longDesc: "When in Burning Citadel style, the fast healing you gain from Burning Bastion Fire and Solace is now 1/2 of your immolation stacks up to a maximum of 2x your initiation modifier. When you are the maximum amount of immolation stacks to provide you this fast healing, whenever you remove an immolation stack (as long as it would not reduce your amount of stacks below the required amount) you are healed for 1 hit point and gain 1 temporary hit point that lasts until the end of combat per stack removed. All healing gained from this feat in a round counts as only a single instance of healing, unless the removal of the stacks would also heal, then it instead counts as part of the healing provided by that ability.",
            prereq: "Burning Bastion Covering Fire",
        },
        {
            name: "Burning Vanguard Critical Ignition",
            type: "style",
            longDesc: `When in Burning Citadel style, whenever you score a critical hit against a creature with immolation stacks, the bonus damage from your immolation stacks is also increased by the critical multiplier, and if the attack itself would apply immolation stacks, those stacks are also multiplied. If a creature is rolling a save against one of your Burning Citadel maneuvers and rolls a natural 1, they must make an additional saving throw, if this also fails, the fire damage and immolation stacks they suffer from the attack are doubled.
            \nAdditionally, while using this feat, whenever you apply an immolation stack to an enemy, they take untyped damage equal to the stacks of immolation given.`,
            prereq: "Burning Citadel Style",
        },
        {
            name: "Burning Vanguard Hellfire Crucible",
            type: "style",
            longDesc: "When in Burning Citadel style, all of your melee attacks apply an additional 2 stacks of immolation. AoE attacks or cleaving attacks instead apply 4 additional stacks of immolation. If you have 5 or more Burning Citadel style feats, this increases to 5 on AoE attacks. This benefit only applies to melee attacks that deal fire damage (or Burning Citadel maneuvers that deal your initating weapon's damage. Can only apply once per creature per maneuver). If the attack itself would allow a save to reduce the immolation stacks, that save also reduces the immolation stacks given by this feat.",
            prereq: "Burning Vanguard Critical Ignition",
        },
        {
            name: "Burning Vanguard Supernova Execution Engine",
            type: "style",
            longDesc: "When in Burning Citadel style, the untyped damage dealt by Burning Citadel Critical Ignition is doubled. You ignore fire resistance a creature has equal to 1/2 the number of immolation stacks it has. Whenever you score a critical hit with a melee attack that dealt fire damage, and was against a creature with at least 1/2 your character level stacks of immolation, the creature becomes vulnerable to fire damage for 1 round. If this creature is killed within 1 round by an attack that dealt at least 50% fire damage, all enemies within 5 feet per initiation modifier of the slain creature take 1d6 points of fire damage per 3 immolation stacks the creature had when it died, reflex negates (DC 10 + level/2 + initiation modifier + any bonuses to Burning Citadel maneuver DC, +1 per 6 immolation stacks the creature had).",
            prereq: "Burning Vanguard Hellfire Crucible",
        },
        // {
        //     name: "Burning Citadel Maximum Inferno",
        //     type: "style",
        //     shortDesc: "When in a Burning Citadel stance, all of your melee attacks apply an additional stack of immolation. AoE attacks or cleaving attacks instead apply 2 additional stacks of immolation.",
        //     longDesc: "",
        //     prereq: "Burning Citadel Style",
        // },
        {
            name: "Seize Control",
            type: "magic",
            shortDesc: "",
            longDesc: "When you cast a control spell, you can roll your universal critical chance. If it rolls within the critical chance, it counts as a critical spell. If it rolls within the critical chance, the spell gains a +1 bonus to its DC for every 25% universal spell critical power. This only applies to the next save against it that they make. If a control spell has an elemental or positive/negative type, you can use that types spell critical chance if you'd like.",
            prereq: "",
            key:true,
        },
        {
            name: "Complete Domination",
            type: "magic",
            shortDesc: "",
            longDesc: "Your critical control spells do not allow any type of re-save for 1 round. For every 100% spell critical power, increase the duration of critical spells by 1 round. This also extends the minimum duration of the spell by the rounds it could not make a re-save.",
            prereq: "Seize Control",
        },
        {
            name: "Critical Encouragement",
            type: "magic",
            shortDesc: "",
            longDesc: "When you cast a buff spell, you can roll your universal critical chance. If it rolls within the critical chance, it counts as a critical spell. Critical buff spells have their numeric increased by your universal critical power (rounded down). If a spell grants multiple numeric modifiers this applies to only one of them. This bonus to their modifier lasts only 1 round for every 50% of your critical damage multiplier. If a buff spell has an elemental or positive/negative type, you can use that types spell critical chance if you'd like.",
            prereq: "",
            key:true,
        },
        {
            name: "Lasting Encouragement",
            type: "magic",
            shortDesc: "",
            longDesc: "Your critical buff spells modifier increase now 1 round for every 25% of your critical damage multiplier.",
            prereq: "Critical Encouragement",
        },
        {
            name: "Critical Care",
            type: "magic",
            shortDesc: "",
            longDesc: "You gain 2% positive spell critical chance and 25% positive spell critical power when the target of the healing is below 10% hit points.",
            prereq: "",
            key:true,
        },
        {
            name: "Long Term Care",
            type: "magic",
            shortDesc: "",
            longDesc: "Critical healing spells that heal hit points stop the creature from dying from hit point damage for 1 round, and critical spells that allows a creature to successfully resist an effect or condition makes it immune to that effect or condition for 1 round.",
            prereq: "Critical Care",
        },
        {
            name: "Critical Trick",
            type: "magic",
            shortDesc: "",
            longDesc: "When you cast a utility spell, you can roll your universal critical chance. If it rolls within the critical chance, it counts as a critical spell. Critical utility spells spells allow you to cast a second utility spell as a free immediate action, however this utility spell cannot be above level 1, plus 1 level for every 25% universal spell critical power. If a utility spell has an elemental or positive/negative type, you can use that types spell critical chance if you'd like. This second spell cannot be a critical spell.",
            prereq: "",
        },
        {
            name: "Endless Tricks",
            type: "magic",
            shortDesc: "",
            longDesc: "The additional spell you cast can be a critical spell, however each time you critically cast a spell, the critical chance decreases by a stacking 10%.",
            prereq: "Critical Trick",
        },
        {
            name: "Craft Wonderous Items",
            type: "utility",
            shortDesc: "",
            longDesc: "When you descend a floor and when you gain this feat you can spend 100 gold to gain a common wonderous item. You can roll a spellcraft or craft check to reduce this price by 1 gold per the result of the check. For each 2 levels of spells you know the item can be of a higher rarity. So if you know level 1 and level 2 spells it becomes a common-rare wonderous item, if you know only 8 and 9 level spells its still only a common-rare wonderous item, and if you know level 1-4 spells its a common-epic wonderous item.",
            prereq: "",
        },
        {
            name: "Craft Magical Weapons",
            type: "utility",
            shortDesc: "",
            longDesc: "When you descend a floor and when you gain this feat you can spend 125 gold to gain a common weapon enchantment. You can roll a spellcraft or craft check to reduce this price by 1 gold per the result of the check. For each 2 levels of spells you know the item can be of a higher rarity. So if you know level 1 and level 2 spells it becomes a common-rare enchantment, if you know only 8 and 9 level spells its still only a common-rare enchantment, and if you know level 1-4 spells its a common-epic enchantment.",
            prereq: "",
        },
        {
            name: "Craft Magical Armor",
            type: "utility",
            shortDesc: "",
            longDesc: "When you descend a floor and when you gain this feat you can spend 125 gold to gain a common armor enchantment. You can roll a spellcraft or craft check to reduce this price by 1 gold per the result of the check. For each 2 levels of spells you know the item can be of a higher rarity. So if you know level 1 and level 2 spells it becomes a common-rare enchantment, if you know only 8 and 9 level spells its still only a common-rare enchantment, and if you know level 1-4 spells its a common-epic enchantment.",
            prereq: "",
        },
        {
        name: "Merciless Rush",
        type: "martial",
        shortDesc: "If your bull rush exceed targets CMD by 5, move through opponent and cause trample damage.",
        longDesc: "When you bull rush a creature and your check exceeds the target's CMD by 5 or more, you deal damage equal to your Strength modifier to that target.",
        prereq: "",
        repeatable:true,
        },
        {
            name: "Fanged Crown Massacre",
            type: "martial",
            shortDesc: "",
            longDesc: `Whenever an ally within 30 feet makes an attack, you can attempt a DC 10 Perform check as an immediate action. If you are successful, the ally gains a +2 morale bonus on their attack roll. If an attack affected in this way would normally deal nonlethal damage, it deals lethal damage instead. This ability has no effect if your ally cannot hear you speak or understand your words. For each 5 you beat the DC of the performance check by, the bonus to attack increases by +1.`,
            prereq: "",
        },
        {
            name: "Falcon's Cry",
            type: "martial",
            shortDesc: "",
            longDesc: `You inspire a zeal for freedom in your allies. As a standard action for 4 spell points, you can grant everyone within 60 feet who is able to see and hear you the ability to roll twice when attempting an Escape Artist check, a Will save against compulsions, or a Strength check to break free of something restricting them, such as chains or spells. Such checks must be attempted before the beginning of your next turn. If you have another ability that includes making a cry out to an ally, such as the battle cry feat, you can apply this feat when activating it.`,
            prereq: "",
        },
        {
            name: "Tandem Attack",
            type: "teamwork",
            shortDesc: "",
            longDesc: `Whenever an ally with this feat within reach makes a melee attack against a foe you also threaten, you can expend an attack of opportunity as if attacking the creature, however instead of its normal effects, if you are successful, the ally gains a +2 circumstance bonus on their attack roll.`,
            prereq: "",
        },
        {
            name: "Double Team",
            type: "martial",
            shortDesc: "",
            longDesc: `When using tandem attack increase the bonus you give increases by +1 per 4 bab. When using tandem attack, if you successfully aid your allies attack, and your ally successfully hits the creature, your ally can use the critical threat range and multiplier of the weapon you used to attempt your attack of opportunity.`,
            prereq: "Tandem Attack",
        },
        {
            name: "Combo Move",
            type: "martial",
            shortDesc: "",
            longDesc: `When using tandem attack the bonus to attack also increases the damage. When using tandem attack, if you successfully aid your allies attack and it is a confirmed critical, it provokes an attack of opportunity from you against the creature. If you do not have an attack of opportunity to expend, you can instead attack it as an immediate action.`,
            prereq: "Double Team",
        },
        {
        name: "Necromantic Affinity",
        type: "magic",
        shortDesc: "You resist necromantic effects and heal as if undead.",
        longDesc: "Gain 15 negative energy spell power. You gain a +2 bonus on saving throws made to resist spells and effects that utilize negative energy, cause negative levels, or cause ability damage, ability drain, or ability penalties. In addition, damage caused by inflict spells heals you as if you were an undead creature, but you also take damage from conjuration healing.",
        prereq: "",
        hasCustomMethod: true,
        catchUpMethod:(context)=>{
            context.stats.characterStats.spellMastery.spellPower.negative += 15
        }
        },
        {
            name: "Greater Necromantic Affinity",
            type: "magic",
            shortDesc: "You resist necromantic effects and heal as if undead.",
            longDesc: "You gain 15 negative energy spell power. You now heal from all negative energy, and take damage from positive energy just as if you were undead. You become immune to death effects, you gain an additional +2 bonus on saves against ability drain, ability damage, ability penalties, and mind-affecting effects. Your hit points are now determined by your highest mental stat instead of constitution.",
            prereq: "Necromantic Affinity",
            hasCustomMethod: true,
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellPower.negative += 15
            }
        },
        {
        name: "Nimble Moves",
        type: "utility",
        shortDesc: "",
        longDesc: "Whenever you move, you may move through 5 feet of difficult terrain each round as if it were normal terrain. This feat allows you to take a 5-foot step into difficult terrain.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Acrobatic Steps",
        type: "utility",
        shortDesc: "Ignore 20 feet of difficult terrain when you move.",
        longDesc: "Whenever you move, you may move through up to 15 feet of difficult terrain each round as if it were normal terrain. The effects of this feat stack with those provided by Nimble Moves (allowing you to move normally through a total of 20 feet of difficult terrain each round).",
        prereq: "Nimble Moves",
        repeatable:true,
        },
        {
            name: "Light Steps",
            type: "utility",
            shortDesc: "Ignore 20 feet of difficult terrain when you move.",
            longDesc: "Whenever you move, you may move through up to 15 feet of difficult terrain each round as if it were normal terrain. The effects of this feat stack with those provided by Nimble Moves (allowing you to move normally through a total of 20 feet of difficult terrain each round).",
            prereq: "Acrobatic Steps",
            perkPrereq:["Elf"],
        },
        {
        name: "Parry Spell",
        type: "magic",
        shortDesc: "Reflect a counterspelled spell back on its caster.",
        longDesc: "Whenever you successfully counter a spell, it returns back to its caster. This works exactly like the spell turning spell.",
        prereq: "",
        },
        {
        name: "Possessed Hand",
        type: "martial",
        shortDesc: "You've made a peaceful and permanent bargain with a ghost, spirit, or outsider. It possesses your hand, guiding and aiding you in exchange for help in return.",
        longDesc: "You attract a ghost, spirit, or outsider with personal motivations to possess your hand. This usually involves some sort of mutually beneficial pact or agreement. Your possessed hand helps you in numerous ways, but its periodic, uncontrolled antics are distracting; you take a permanent -2 penalty on concentration checks once you gain this feat. Any attack you make with a one-handed weapon, light weapon, unarmed strike, or natural attack with your possessed hand gains a +1 insight bonus on the attack roll and damage roll. You also gain a +2 insight bonus on Disable Device, climb and swim checks. Once per day as a swift action, you can retrieve any stowed object you carry on your person, provided the object weighs no more than 5 pounds.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Protector's Strike",
        type: "martial",
        shortDesc: "Grant someone else a deflection bonus to AC while smiting evil instead of yourself.",
        longDesc: "When you choose the target of your smite ability, you also choose one creature other than you within line of sight. While your smite is in effect, the additional creature you chose gains a deflection bonus to AC equal to your highest mental modifier against attacks made by the target of the smite. This bonus ends when the smite ends. You do not gain the deflection bonus to AC normally granted by smite.",
        prereq: "",
        perkPrereq:["Smite"]
        },
        {
        name: "Quick Channel",
        type: "magic",
        shortDesc: "Channel energy faster by expending more uses.",
        longDesc: "You can reduce the activation time of channel energy, healing hex, healing aura, lay on hands, soothing song or fervor by 1 step by spending 2 uses of that ability. You can only use this feat once per round per ability.",
        prereq: "",
        perkPrereq:["Channel Energy", "Epic Channel Energy", "Lay On Hands", "Touch of Corruption", "Fervor", "Hexes", "Bardic Performance"],
        key:true,
        },
        {
        name: "Radiant Charge",
        type: "martial",
        shortDesc: "Expend uses of lay on hands to deal extra damage, bypassing evil creatures' resistances and immunities.",
        longDesc: "When you hit with a charge attack, you can expend spell points equal to 4 uses of your prereq ability to deal extra damage equal to that abilities damage or healing + your highest mental ability score modifier. This damage comes from holy or unholy power (depending on what type of ability used) and is not subject to damage reduction, energy immunities, or energy resistances.",
        prereq: "",
        perkPrereq:["Channel Energy", "Epic Channel Energy", "Lay On Hands", "Touch of Corruption", "Hemomancy", "Fervor", "Guardian's Shield"],
        },
        {
        name: "Blood Casting",
        type: "magic",
        shortDesc: "Sacrifice hit points for spell potency.",
        longDesc: "When you cast a spell, as a swift action you can sacrifice some of your life force to augment the spell's potency. You can opt to take up to 1d6 points of damage per spell level of the spell you are casting, choosing the amount of dice before rolling. You cannot overcome this damage in any way, and it cannot be taken from temporary hit points. For each of these damage dice you roll, the DC of the spell you are casting increases by 1.",
        prereq: "",
        key:true,
        },
        {
        name: "Raging Absorption",
        type: "utility",
        shortDesc: "Absorb arcane energy from damaging spells to refuel bloodrage.",
        longDesc: "While you are raging, if you successfully save against a damaging arcane spell that either targets you or includes you in its area, and you take no damage from that spell, you can absorb a portion of its arcane energy to replenish your rage. You regain spell point cost of 1 round of rage for every 2 levels of the spell you successfully saved against.",
        prereq: "",
        perkPrereq:["Rage", "Epic Rage"],
        },        
        {
        name: "Mage's Tattoo",
        type: "magic",
        shortDesc: "Select a school of magic (damage, control, buff, healing, utility), you cast spells from this school at +1 Caster level",
        longDesc: "",
        prereq: "",
        key:true,
        repeatable:true,
        },
        {
        name: "Raging Brutality",
        type: "martial",
        shortDesc: "Add Constitution bonus on damage rolls.",
        longDesc: "While raging and using Power Attack, you can spend spell points equal to 3 rounds of your rage as a swift action to add your Constitution bonus on damage rolls for melee attacks or thrown weapon attacks you make on your turn. If you are using the weapon two-handed, instead add 1-1/2 times your Constitution bonus. This bonus damage is not multiplied on a critical hit.",
        prereq: "",
        perkPrereq:["Rage", "Epic Rage"],
        },
        {
        name: "Raging Deathblow",
        type: "martial",
        shortDesc: "while raging kill a foe to gain 1 spell point, and 2 if the hit was a critical hit",
        longDesc: "While raging, whenever your attack reduces an opponent of a CR greater than or equal to your character level to -1 or fewer hit points, you gain 1 extra round of rage. If that attack was a critical hit, you gain 1 additional extra round of rage.",
        prereq: "",
        perkPrereq:["Rage", "Epic Rage"],
        },
        {
        name: "Raging Hurler",
        type: "martial",
        shortDesc: "Throw a two-handed weapon as a standard action.",
        longDesc: "While raging, you can throw a two-handed weapon as a standard action, and you double the range increment for weapons you throw. If you also have the Quick Draw feat, you can throw two-handed weapons at your full normal rate of attacks. Further, you can pick up an unattended object that you can use as a improvised weapon within your reach as part of the attack action to throw that item.",
        prereq: "",
        perkPrereq:["Rage", "Epic Rage"],
        },
        {
        name: "Raging Throw",
        type: "martial",
        shortDesc: "Add Con bonus on checks to bull rush.",
        longDesc: "While raging, when you attempt a bull rush combat maneuver, you can spend 1 additional round of your rage as a swift action to add your Constitution bonus on your combat maneuver check to the bull rush. Further, if you bull rush an opponent into a square another creature occupies or into a solid object, the opponent and the creature or object take bludgeoning damage equal to your Strength modifier + your Constitution modifier.",
        prereq: "",
        perkPrereq:["Rage", "Epic Rage"],
        },
        {
        name: "Raging Vitality",
        type: "martial",
        shortDesc: "+2 bonus to Con when raging, and continue raging if unconscious.",
        longDesc: "Whenever you are raging, the morale bonus to your Constitution increases by +2. Your rage does not end if you become unconscious. While unconscious you must still expend rounds of rage per day each round.",
        prereq: "",
        perkPrereq:["Rage", "Epic Rage"],
        key:true,
        },
        {
        name: "Rallying Blow",
        type: "martial",
        shortDesc: "When you confirm a critical hit against an enemy, any fear effect affecting allies within 30 feet is reduced by one step. Panicked becomes frightened, frightened becomes shaken, and shaken is removed. In addition, any ally suffering other effects from a failed save against a fear effect, such as the paralysis from a mummy‘s despair aura, receives a new save against the effect at the original DC.",
        longDesc: "When you confirm a critical hit against an enemy, any fear effect affecting allies within 30 feet is reduced by one step. Panicked becomes frightened, frightened becomes shaken, and shaken is removed. In addition, any ally suffering other effects from a failed save against a fear effect, such as the paralysis from a mummy's despair aura, receives a new save against the effect at the original DC.",
        prereq: "",
        },
        {
        name: "Razortusk",
        type: "martial",
        shortDesc: "Gain bite attack.",
        longDesc: "You can make a bite attack for 1d4 points of damage, plus your Strength modifier. You're considered proficient in this attack and can apply feats or effects appropriate to natural attacks to it. If used as part of a full attack action, the bite is considered a secondary attack and is made at your full base attack bonus -5, and adds half your Strength modifier to damage.",
        prereq: "",
        key:true,
        },
        {
        name: "Reactive Arcane Shield",
        type: "magic",
        shortDesc: "If you are aware of an attack against you that has already been declared and you choose to use the Arcane Shield feat, the immediate action to activate the feat occurs before the attack roll against you is resolved. In addition, all adjacent allies also gain the feat's deflection bonus to AC for 1 round.",
        longDesc: "If you are aware of an attack against you that has already been declared and you choose to use the Arcane Shield feat, the immediate action to activate the feat occurs before the attack roll against you is resolved. In addition, all adjacent allies also gain the feat's deflection bonus to AC for 1 round.",
        prereq: "Arcane Shield",
        },
        {
        name: "Splash Weapon Mastery",
        type: "magic",
        shortDesc: "",
        longDesc: "When throwing a splash weapon or bomb, you only take a -1 penalty to the attack roll per range increment. When you hit with a splash weapon, select one additional square adjacent to the splash area; creatures in this area also take splash damage. When you miss with a splash weapon, you may adjust the miss direction on the grid by +1 or -1.",
        prereq: "",
        },
        {
        name: "Reactive Healing",
        type: "magic",
        shortDesc: "When reduced to 0 hp or fewer, use channel energy or lay on hands to heal yourself as immediate action.",
        longDesc: "When the damage from an attack or an effect would reduce you to 0 or fewer hit points, you can expend one use of a prereq healing ability as an immediate action to heal yourself. The ability only affects you, even if it would normally affect others.",
        prereq: "",
        perkPrereq:["Channel Energy", "Epic Channel Energy", "Lay On Hands", "Touch of Corruption", "Fervor", "Hexes"],
        },
        {
        name: "Reckless Rage",
        type: "martial",
        shortDesc: "Take a penalty on attack rolls to deal more damage while raging.",
        longDesc: "When you use Power Attack while raging, you take an additional -1 penalty on melee attack rolls and combat maneuver checks, and you gain an additional +2 bonus on melee damage rolls. Modify this damage bonus appropriately based on the type of weapon you are using, as normal for Power Attack. The attack penalty and damage increase by -1 and +2 respectively every 8 bab you have.",
        prereq: "",
        perkPrereq:["Rage", "Epic Rage"],
        repeatable:true,
        },
        {
        name: "Recovered Rage",
        type: "martial",
        shortDesc: "regain the round spell point cost of raging whenever you knock out or kill a foe while raging",
        longDesc: "Whenever you reduce a foe to 0 or fewer hit points while you are raging, you regain the spell point cost of 1 round of rage or raging song (your choice if you have both abilities), as long as the number of Hit Dice that foe possesses is equal to or greater than 1/2 your character level.",
        prereq: "",
        perkPrereq:["Rage", "Epic Rage"],
        repeatable:true,
        },
        {
        name: "Reward of Grace",
        type: "martial",
        shortDesc: "With each use of lay on hands, gain a +1 sacred bonus on attack rolls.",
        longDesc: "Each time you use your healing prereq ability you gain a +1 sacred bonus on all attack rolls for 1 round. This increases by +1 every 3 dice of the prereq ability.",
        prereq: "",
        perkPrereq:["Channel Energy", "Epic Channel Energy", "Lay On Hands", "Touch of Corruption","Hexes", "Fervor", "Guardian's Shield","Hemomancy"],
        repeatable:true,
        },
        {
        name: "Reward of Life",
        type: "martial",
        shortDesc: "With each use of lay on hands, gain hit points equal to your Charisma.",
        longDesc: "Each time you use your healing prereq ability to heal a creature other than yourself, you heal a number of hit points equal to your highest mental modifier. This can only activate once per activation of the ability.",
        prereq: "",
        perkPrereq:["Channel Energy", "Epic Channel Energy", "Lay On Hands", "Touch of Corruption","Hexes", "Fervor", "Guardian's Shield","Hemomancy"],
        repeatable:true,
        },
        {
        name: "Ricochet Splash Weapon",
        type: "magic",
        shortDesc: "Make an attack roll with a splash weapon if it misses and lands in another creature's square.",
        longDesc: "Whenever your splash weapon misses and the misdirection roll indicates it lands in a square occupied by a creature, you may make an attack roll (at a -5 penalty) as if you had thrown the splash weapon at that creature. If this attack roll succeeds, the splash weapon hits and the creature takes full damage instead of splash damage. Squares adjacent to this creature still take splash damage as normal.",
        prereq: "",
        },
        {
        name: "Run",
        type: "utility",
        shortDesc: "Run at 5 times your normal speed.",
        longDesc: "When running, you move five times your normal speed (if wearing medium, light, or no armor and carrying no more than a medium load) or four times your speed (if wearing heavy armor or carrying a heavy load). If you make a jump after a running start (see the Acrobatics skill description), you gain a +4 bonus on your Acrobatics check. While running, you retain your Dexterity bonus to your Armor Class.",
        prereq: "",
        },
        {
        name: "Shatter Resolve",
        type: "magic",
        shortDesc: "Whenever a creature is damaged by your channel negative energy, and fails its Will save, it also becomes shaken.",
        longDesc: "When you damage a creature by channeling negative energy, you fill your foe with fear. A creature that fails its Will save against your channeled energy also becomes shaken for a number of rounds equal to the number of dice you roll for your channel energy ability.",
        prereq: "",
        perkPrereq:["Channel Energy", "Epic Channel Energy", "Touch of Corruption"],
        },
        {
        name: "Shocking Amplification",
        type: "magic",
        longDesc: "You gain 5 electricity spell power. Whenever you cast a spell with the electricity descriptor that targets or effects one or more creatures immediately, you can take a -1 penalty on attack rolls made with the spell and reduce the spell's saving throw DC by 1 to cause the target closest to you that is dealt electricity damage by the spell to become fatigued for 1 round. This cannot cause a creature that is already fatigued to become exhausted. You must choose to use this feat before making an attack roll or before your target attempts its saving throw. This feat has no effect on spells that neither allow a saving throw nor require an attack roll.",
        prereq: "",
        hasCustomMethod: true,
        catchUpMethod:(context)=>{
            context.stats.characterStats.spellMastery.spellPower.electricity += 5
        }
        },
        {
            name: "Improved Shocking Amplification",
            type: "magic",
            longDesc: "You gain 5 electricity spell power. When using Shocking Amplification you can instead choose to reduce your attack roll or DC by -2 to cause the creature to become exhausted for 1 round. You can choose to use this or shocking amplification.",
            prereq: "Shocking Amplification",
            hasCustomMethod: true,
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellPower.electricity += 5
            }
            
        },
        {
            name: "Greater Shocking Amplification",
            type: "magic",
            longDesc: "You gain 5 electricity spell power. When using Shocking Amplification you can instead choose to reduce your attack roll or DC by -4 to cause all creatures damaged by the spell (only the first time) to become fatigued for 1 round, or the creature closest to you to become exhausted for 3 rounds. You can only use the benefit of one shocking amplification feat at a time.",
            prereq: "Improved Shocking Amplification",
            hasCustomMethod: true,
            catchUpMethod:(context)=>{
                context.stats.characterStats.spellMastery.spellPower.electricity += 5
            }
        },
        // {
        // name: "Signifer Armor Training",
        // type: "magic",
        // shortDesc: "As a free action for 3 spell points, or as a swift action for free, you can reduce the arcane spell failure chance due to the armor you are wearing by 30% for any spells you cast this round.",
        // longDesc: "As a free action for 3 spell points, or as a swift action for free, you can reduce the arcane spell failure chance due to the armor you are wearing by 30% for any spells you cast this round. This bonus replaces, and does not stack with, the bonuses granted by Arcane Armor Mastery, Arcane Armor Training, and similar feats and effects.",
        // prereq: "",
        // },
        {
            name: "Skald's Vigor",
            type: "magic",
            shortDesc: "While maintaining a hex or inspire competence, you gain fast healing equal to the Strength bonus or competence bonus your song provides, starting in the round after you begin the song. If you stop maintaining your song, the fast healing ends, even if the effects of your song persist.",
            longDesc: "While maintaining a hex or inspire competence, you gain fast healing 1, +1 per 5 levels, starting in the round after you begin the effect.",
            prereq: "",
            perkPrereq:["Bardic Performance","Hexes", "Misfortune","Fortune","Protective Luck"],
            key:true,
            repeatable:true,
        },
        {
        name: "Greater Skald's Vigor",
        type: "magic",
        shortDesc: "Your allies share in the fast healing granted by your Skald's Vigor, starting in the round when you begin your performance. They must be able to hear the performance. If you stop maintaining the song, the fast healing ends immediately, even if other effects of your song linger.",
        longDesc: "Your allies share in the fast healing granted by your Skald's Vigor, starting in the round when you begin your performance or hex. They must be able to hear or see the performance.",
        prereq: "Skald's Vigor",
        },
        {
        name: "Skill Focus",
        type: "utility",
        shortDesc: "+6 bonus on one skill (+12 at 10 Level 10).",
        longDesc: "You get a +6 bonus on all checks involving the chosen skill. If you have 10 or more ranks in that skill, this bonus increases to +12.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Sneaking Precision",
        type: "martial",
        shortDesc: "On the second sneak attack in a round, you may apply a critical feat.",
        longDesc: "Whenever you successfully sneak attack an opponent for a second time on your turn, you can spend a swift action to apply the effects of one critical feat you know to that opponent.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Spell-Drinker",
        type: "utility",
        shortDesc: "Once per floor, as an immediate action after you succeed at a saving throw against a creature's spell or spell-like ability, you gain a number of temporary hit points equal to 1d6 plus the spell's level for 1 minute. While these temporary hit points last, you gain a +2 bonus on saving throws against spells and spell-like abilities cast by that creature. If you have 10 or more Hit Dice, the number of temporary hit points you gain from this feat doubles. These temporary hit points stack with those gained from other sources, but not with each other.",
        longDesc: "Once per floor, as an immediate action after you succeed at a saving throw against a creature's spell or spell-like ability, you gain a number of temporary hit points equal to 1d6 plus the spell's level for 1 minute. While these temporary hit points last, you gain a +2 bonus on saving throws against spells and spell-like abilities cast by that creature. For every 4 HD you have increase the temporary hit points by 1d6. These temporary hit points stack with those gained from other sources, but not with each other.",
        prereq: "",
        repeatable:true,
        },
        {
            name: "Spell Focus",
            type: "magic",
            longDesc: "Add +1 to the Difficulty Class for all saving throws against spells from the school of magic you select.",
            prereq: "",
            key:true,
        },        
        {
            name: "Improved Spell Focus",
            type: "magic",
            longDesc: "Add +1 to the Difficulty Class for all saving throws against spells from the school of magic you select. This bonus stacks with the bonus from Spell Focus.",
            prereq: "Spell Focus",
        },
        {
        name: "Greater Spell Focus",
        type: "magic",
        longDesc: "Add +1 to the Difficulty Class for all saving throws against spells from the school of magic you select. This bonus stacks with the bonus from Spell Focus.",
        prereq: "Improved Spell Focus",
        repeatable:true,
        },        
        {
        name: "Spell Perfection",
        type: "magic",
        shortDesc: "Apply any metamagic feat to one spell without penalty, up to 9th level.",
        longDesc: "Pick one spell which you have the ability to cast. Whenever you cast that spell you may apply any one metamagic feat you have to that spell without affecting its level or casting time, as long as the total modified level of the spell does not use a spell slot above 9th level.",
        prereq: "",
        key:true,
        repeatable:true,
        },
        {
            name: "Spell Apotheosis",
            type: "magic",
            shortDesc: "Apply any metamagic feat to one spell without penalty, up to 9th level.",
            longDesc: "When you cast the spell you chose with spell perfection, if you have other feats which allow you to apply a set numerical bonus to any aspect of this spell (such as Spell Focus, Spell Penetration, Weapon Focus [ray], and so on, however you cannot choose a style feat), choose up to 2 of these feats and double the bonuses granted by it. Additionally, you can apply metamagic feats to it with spell perfection as long as the total modified level of the spell does not use a spell slot above 10th level.",
            prereq: "Spell Perfection",
        },
        {
        name: "Magic Trick",
        type: "magic",
        shortDesc: "Apply any metamagic feat to one spell without penalty, up to 9th level.",
        longDesc: "When you cast an damage spell that has an instantaneous duration, and a radius or cone area of effect, you can reduce its area of effect by 5 feet to increase its damage by 1d6.",
        prereq: "",
        key:true,
        },
        {
        name: "Spell Specialization",
        type: "magic",
        shortDesc: "Pick one spell and cast it as if you were higher level.",
        longDesc: "Select one spell, treat your caster level as being two higher for all level-variable effects of the spell. Every 4 levels, you can choose a new spell to replace the spell selected with this feat, and that spell becomes your specialized spell.",
        prereq: "",
        key:true,
        repeatable:true,
        },
        {
        name: "Split Hex",
        type: "magic",
        shortDesc: "A targeted hex can affect two creatures.",
        longDesc: "When you use a basic hex or minor hex that targets a single creature, you can choose another creature within 30 feet of the first target to also be targeted by the hex. You must pay the spell point cost associated with each target.",
        prereq: "",
        perkPrereq:["Hexes", "Fortune","Misfortune", "Protective Luck"],
        key:true,
        },
        {
        name: "Split Major Hex",
        type: "magic",
        shortDesc: "A targeted hex can affect two creatures.",
        longDesc: "When you use one of your major hexes (not a grand hex) that targets a creature, you can choose another creature within 30 feet of the first target to also be targeted by the major hex. You must pay the spell point cost associated with each target.",
        prereq: "Split Hex",        
        },
        {
            name: "Enchanting Laughter",
            type: "magic",
            shortDesc: "A targeted hex can affect two creatures.",
            longDesc: "Whenever you cackle, all allies within the range of your cackle gain a +1 competence bonus on attack and weapon damage rolls and a +1 morale bonus on saving throws against charm and fear effects for 1 round. ",
            prereq: "",
            perkPrereq:["Hexes"],
            key:true,
        },
        {
            name: "Improved Enchanting Laughter",
            type: "magic",
            shortDesc: "A targeted hex can affect two creatures.",
            longDesc: "The bonuses granted from Enchanting Laugher increase by +1. If you have bardic performance, when you use inspire courage you can increase the bonuses granted by inspire courage by +1. You must pay the additional spell point per round to gain this bonus.",
            prereq: "Enchanting Laughter",            
        },
        {
            name: "Greater Enchanting Laughter",
            type: "magic",
            shortDesc: "A targeted hex can affect two creatures.",
            longDesc: "The bonuses granted from Enchanting Laugher increase by +1, including the bonus granted to inspire courage.",
            prereq: "Improved Enchanting Laughter",            
        },
        {
        name: "Squash Flat",
        type: "martial",
        shortDesc: "If your bull rush exceed targets CMD by 5, attempt a trip.",
        longDesc: "Whenever you make a bull rush attack and your combat maneuver check exceeds the target's CMD by 5 or more, you can attempt to trip the target as part of your bull rush as a free action. This does not provoke an attack of opportunity.",
        prereq: "",
        },
        {
        name: "Ability Focus",
        type: "utility",
        shortDesc: "",
        longDesc: "Choose a perk that has a DC associated with it, the DC of it goes up by 2.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Stalwart",
        type: "martial",
        shortDesc: "Forgo dodge AC bonus for equivalent DR",
        longDesc: "While using the total defense action, fighting defensively action, or Combat Expertise, you can forgo the dodge bonus to AC you would normally gain to instead gain an equivalent amount of DR until the start of your next turn. This damage reduction stacks with DR you gain from perks and your race, but not with DR from any other source. If you are denied your Dexterity bonus to AC, you are also denied this DR.",
        prereq: "",
        },
        {
        name: "Improved Stalwart",
        type: "martial",
        shortDesc: "Double DR gained from Stalwart",
        longDesc: "Double the DR you gain from Stalwart, to a maximum of DR 40/-.",
        prereq: "Stalwart",
        },
        {
        name: "Steadfast Personality",
        type: "utility",
        shortDesc: "Use your Charisma modifier on saves against mind-affecting effects.",
        longDesc: "You can add your Charisma or intelligence modifier instead of your Wisdom bonus to Will saves. If you have a Wisdom penalty, you must apply both your Wisdom penalty and your new mental modifier.",
        prereq: "",
        },
        {
        name: "Steel Soul",
        type: "utility",
        shortDesc: "+2 racial bonus on saves against spells and spell-like abilities.",
        longDesc: "You receive a +2 racial bonus on saving throws against spells and spell-like abilities. If you are a dwarf, this stacks with your default racial bonus.",
        prereq: "",
        perkRateUp: ["Dwarf"],
        repeatable:true,
        },
        {
        name: "Superior Summoning",
        type: "magic",
        shortDesc: "When summoning more than one creature, summon an extra one.",
        longDesc: "Each time you cast a summoning spell that conjures more than one creature, add one to the total number of creatures summoned.",
        prereq: "",
        key:true,
        repeatable:true,
        },
        {
        name: "Surprise Maneuver",
        type: "martial",
        shortDesc: "Gain a bonus on combat maneuver checks against flanked foes and those denied their Dex bonus to AC.",
        longDesc: "If you have sneak attack, when you attempt a combat maneuver check against a creature that you are flanking or that is denied its Dexterity bonus to AC against your attack, you gain a bonus on the combat maneuver check that's equal to the number of sneak attack dice you roll. If you have the studied combat class feature, you can use studied strike on a combat maneuver check. When you do so, you gain a bonus on the combat maneuver check equal to your number of studied strike dice.",
        prereq: "",
        },
        {
        name: "Toughness",
        type: "utility",
        shortDesc: "+3 hit points, +1 per Hit Die beyond 3.",
        longDesc: "You gain +5 hit points. For every Hit Die you possess you gain an additional +2 hit points.",
        prereq: "",
        key:true,
        repeatable:true,
        },
        {
        name: "Twist Away",
        type: "utility",
        shortDesc: "Use Reflex in place of Fortitude as an immediate action.",
        longDesc: "While you are wearing light armor or no armor, if you are forced to attempt a Fortitude saving throw, you can use an immediate action to instead attempt a Reflex saving throw (at the same DC). If you succeed at this saving throw and the attack has a reduced effect on a successful save, you avoid the effect entirely. Whether the saving throw is successful or not, you are staggered until the end of your next turn. If you are prevented from becoming staggered, you can't use Twist Away, nor can you ignore the staggered condition from Twist Away or remove it early.",
        prereq: "",
        },
        {
        name: "Versatile Channeler",
        type: "magic",
        shortDesc: "Channel both positive and negative energy.",
        longDesc: "You may make a choice whenever you use your channel energy, Lay on Hands, or Touch of Corruption class feature. If you normally channel positive energy, you may choose to channel negative energy as if your effective cleric level were 2 levels lower than normal. If you normally channel negative energy, you may choose to channel positive energy as if your effective cleric level were 2 levels lower than normal. Although the reduced level may cause the ability to cost less spell points, using this feat increases the spell point cost by 2.",
        prereq: "",
        perkPrereq:["Channel Energy", "Epic Channel Energy", "Lay On Hands", "Touch of Corruption", "Fervor",],
        },
        {
        name: "Welcome Pain",
        type: "utility",
        shortDesc: "Whenever an ongoing, or repeating, damage effect would reduce you to 0 or fewer hit points, make a Will save to ignore the damage.",
        longDesc: "Whenever you would be reduced to 0 or fewer hit points because of an ongoing or repeating damage effect (such as bleed), you may make a last-ditch effort to shed the condition. If you succeed at a DC 25 Will save, you ignore the damage that would reduce you to 0 or fewer hit points that turn. Each time you use this ability its DC increases by +2 for the rest of the floor, whether successful or not. In addition, spells or abilities that have the pain descriptor deal only half damage to you (if any).",
        prereq: "",
        },
        {
        name: "Wilding Mind",
        type: "utility",
        shortDesc: "Can take 1d3 Int damage to reroll a failed saving throw versus a fear effect or versus a mind-affecting effect",
        longDesc: "Whenever you fail a saving throw against a fear or mind-affecting effect, you can take 1d3 points of Intelligence damage as an immediate action and reroll the saving throw. This damage cannot be reduced or avoided in any way. You must take the new result, even if it is worse.",
        prereq: "",
        },
        {
        name: "Word of Healing",
        type: "magic",
        shortDesc: "Use lay on hands from a distance.",
        longDesc: "Your healing prereq ability gains or has its range increased by 30 feet. If it is an aura ability centered on you, its source can be from up to 30 feet away. You must be able to speak and have a free hand to use this ability. The healing or damage dealt is halved when you use this ability.",
        prereq: "",
        perkPrereq:["Channel Energy", "Epic Channel Energy", "Lay On Hands", "Touch of Corruption", "Fervor", "Hexes", "Bardic Performance"],
        },
        {
        name: "Acrobatic Spellcaster",
        type: "magic",
        shortDesc: "Avoid attacks of opportunity from casting with Acrobatics",
        longDesc: "When you succeed at an Acrobatics check to move through a threatened square without provoking attacks of opportunity or to move through an enemy's space, creatures denied attacks of opportunity by your Acrobatics check also cannot make attacks of opportunity against you when you cast spells for the remainder of your turn. Alternatively, you can also roll an acrobatics check against all threatening creatures CMD instead of making a combat casting check to cast a spell without provoking. Using this ability does not count as making a concentration check, but does count as making a combat casting check.",
        prereq: "",
        },
        {
        name: "Agile Maneuvers",
        type: "martial",
        shortDesc: "Use your Dex bonus when calculating your CMB",
        longDesc: "You can use your Dexterity modifier instead of your Strength modifier when determining your Combat Maneuver Bonus.",
        prereq: "",
        },
        {
            name: "Bristling Bull Rush",
            type: "martial",
            shortDesc: "Use your Dex bonus when calculating your CMB",
            longDesc: "When you bull rush a creature it takes 1d4 + str mod points of bludgeoning damage, increasing by 1d4 per 5 feet moved. If you move it through difficult terrain, those tiles instead deal 3d4 damage.",
            prereq: "",
        },
        {
            name: "Bristling Trip",
            type: "martial",
            shortDesc: "Use your Dex bonus when calculating your CMB",
            longDesc: "When you trip a creature it takes 1d8 + str or dex mod points of bludgeoning damage, increasing by 1d8 per size category above medium the creature is. If you trip it, for each square the creatures takes up that is inside of difficult terrain, increase the damage by 1d8.",
            prereq: "",
        },
        {
            name: "Bristling Drag",
            type: "martial",
            shortDesc: "Use your Dex bonus when calculating your CMB",
            longDesc: "When you Drag a creature it takes 1d4+strength mod points of bludgeoning damage, increasing by 1d4 per 5 feet moved. If you move it through difficult terrain, those tiles instead deal 3d4 damage.",
            prereq: "",
        },
        {
            name: "Aerial Roll",
            type: "martial",
            shortDesc: "Use your Dex bonus when calculating your CMB",
            longDesc: "You can perform a defensive roll while in the air. As an immediate action, you can attempt a Fly check when you are attacked while flying. If the result of the check is greater than the result of the attack roll, you dodge the attack, causing it to miss automatically. Whether you succeed or fail at the Fly check, the barrel roll leaves you off-balance and vulnerable, causing you to take a -10 penalty on Fly checks until the end of your next turn.",
            prereq: "",
        },
        {
        name: "Alchemical Strike",
        type: "martial",
        shortDesc: "You can throw a single alchemical item as a full-attack action, increasing the effectiveness of the alchemical agent thrown",
        longDesc: "You can throw a single alchemical item as a full-attack action, increasing the effectiveness of the alchemical agent thrown. When throwing a single alchemical item as a full-attack action, you increase the DC of any effects associated with that alchemical item by +2. When your base attack bonus reaches +11 and every 5 points of bonus thereafter, increase the saving throw DC of the alchemical item by an additional +2.",
        prereq: "",
        },
        {
        name: "All-Consuming Swing",
        type: "martial",
        shortDesc: "When you Cleave or Great Cleave, you can apply the additional damage you would gain from Vital Strike, Improved Vital Strike, or Greater Vital Strike to the initial target of your attack. When you do so, the strain on your body causes you to take an amount of damage equal to the extra damage dealt by your Vital Strike feat. This self-inflicted damage is not reduced by damage reduction.",
        longDesc: "Whenever you use Cleave or Great Cleave, you can apply the additional damage you would gain from Vital Strike, Improved Vital Strike, or Greater Vital Strike to the initial target of your attack. When you do so, the strain on your body causes you to take an amount of damage equal to the extra damage dealt by your Vital Strike feat. This self-inflicted damage is not reduced by damage reduction.",
        prereq: "Cleave",
        },
        {
            name: "Full Onslaught",
            type: "martial",
            shortDesc: "When you Cleave or Great Cleave, you can apply the additional damage you would gain from Vital Strike, Improved Vital Strike, or Greater Vital Strike to the initial target of your attack. When you do so, the strain on your body causes you to take an amount of damage equal to the extra damage dealt by your Vital Strike feat. This self-inflicted damage is not reduced by damage reduction.",
            longDesc: "Whenever you use Cleave or Great Cleave, you can apply the additional damage you would gain from Vital Strike, Improved Vital Strike, or Greater Vital Strike to each target of your cleave attack. If you have cleaving finish, you can also apply your vital strike to the first cleaving finish attack you make in a round. The damage you take from all-consuming swing is doubled. This self-inflicted damage is not reduced by damage reduction.",
            prereq: "All-Consuming Swing",
        },
        {
        name: "Anatomical Savant",
        type: "martial",
        shortDesc: "Choose one weapon type. When you strike an opponent that has a chance of negating critical hits or sneak attacks, such as from the fortification armor special ability, reduce that chance by 25%. Treat creatures that are normally immune to critical hits and sneak attacks as instead having a 75% chance to negate the critical hit or sneak attack, taking only the attack's normal damage",
        longDesc: "When you strike an opponent that has a chance of negating critical hits or sneak attacks, such as from the fortification armor special ability, reduce that chance by 25%. Treat creatures that are normally immune to critical hits and sneak attacks as instead having a 75% chance to negate the critical hit or sneak attack, taking only the attack's normal damage.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Ankle Biter",
        type: "martial",
        shortDesc: "Bite an opponent that targets you with a combat maneuver as an immediate action.",
        longDesc: "If you are the target of a combat maneuver you can, as an immediate action, attempt to bite your opponent in addition to any attacks of opportunity or other consequences your opponent might incur from attacking you. This bonus natural attack does not provoke an attack of opportunity itself and deals base damage appropriate for a creature two sizes smaller than you (usually 1d3 for medium creatures). If grappled or pinned, you can continue to make this additional bite attack each round as swift action on your turn. You gain a bonus on any attempt to break the grapple equal to the damage you dealt with your bite that round. Using this feat does not require you have a bite attack, but if you do, you can use it instead of the damage granted by this feat.",
        prereq: "",
        },
        {
        name: "Anticipate Dodge",
        type: "martial",
        shortDesc: "Gain up to a +2 bonus on attack rolls against creatures with a dodge bonus",
        longDesc: "You automatically know whether a creature you can see has a dodge bonus to its AC. You gain up to a +2 bonus on attack rolls against a target that has a dodge bonus. This bonus cannot exceed the dodge bonus of the creature you attack.",
        prereq: "",        
        },
        // {
        // name: "Arcane Armor Mastery",
        // type: "magic",
        // shortDesc: "Reduce your arcane spell failure chance by 20%",
        // longDesc: "As a free action for 2 spell points, or swift action for free, reduce the arcane spell failure chance due to the armor you are wearing by 20% for any spells you cast this round. This bonus replaces, and does not stack with, the bonus granted by Arcane Armor Training.",
        // prereq: "Arcane Armor Training",
        // },
        // {
        // name: "Arcane Armor Training",
        // type: "magic",
        // shortDesc: "Reduce your arcane spell failure chance by 10%",
        // longDesc: "As a free action for 2 spell points, or swift action for free, reduce the arcane spell failure chance due to the armor you are wearing by 10% for any spells you cast this round.",
        // prereq: "",
        // },
        {
            name: "Pikeman's Training",
            type: "martial",
            shortDesc: "+1 damage and weapons are considered magic",
            longDesc: "You can wield a normally two-handed polearm or spear in one hand, provided you are wielding a shield in your other hand. When wielding a weapon in this manner, you treat it in all ways as being a one-handed weapon, rather than a weapon of its normal handedness.",
            prereq: "",
        },
        {
            name: "Pinning Arrow",
            type: "martial",
            shortDesc: "+1 damage and weapons are considered magic",
            longDesc: "You can make a pinning shot in place of an attack action or an attack as part of a full attack. When you do, make a ranged attack. If it hits, it deals no damage, but the target must succeed at a Reflex save (DC=the damage your attack would have dealt) or stop in their tracks and become unable to move for one round. They can still take other actions as normal, but cannot leave their space. A flying creature that fails its saving throw falls unless it succeeds at a Fly check with the same DC as the Reflex save, potentially taking falling damage.",
            prereq: "",
        },
        {
        name: "Arcane Strike",
        type: "martial",
        shortDesc: "+1 damage and weapons are considered magic",
        longDesc: "As a swift action, you can imbue a weapon with a fraction of your power. For 1 round, your weapon deals +1 bonus damage for each level of spell you have a spell known, and is treated as magic for the purpose of overcoming damage reduction.",
        prereq: "",
        repeatable:true,
        },
        {
            name: "Energy Strike",
            type: "martial",
            shortDesc: "+1 damage and weapons are considered magic",
            longDesc: "When you use the Arcane Strike feat, rather than increasing your weapon damage, you can instead add energy damage to your strikes. You can choose either acid, cold, electricity, or fire damage, and can make a different choice each time. The damage added is equal to the amount you would have added to your attacks by Arcane Strike and is multiplied on a critical hit.",
            prereq: "Arcane Strike",
        },
        {
            name: "Magical Heart",
            type: "martial",
            shortDesc: "+1 damage and weapons are considered magic",
            longDesc: "While your weapon attacks are imbued with power from the Arcane Strike feat, a successful hit with the imbued weapon grants you a number of temporary hit points equal to the bonus damage granted by Arcane Strike. These temporary hit points do not stack with themselves. If you hit with an unarmed attack it grants twice the amount of temporary hit points.",
            prereq: "Arcane Strike",
        },
        {
            name: "Improved Magical Heart",
            type: "magic",
            shortDesc: "+1 damage and weapons are considered magic",
            longDesc: "The temporary hit points granted from Magical heart now stack, however the temporary hit points gained become equal to half the bonus to damage you gain from Arcane strike.",
            prereq: "Magical Heart",
        },
        {
            name: "Energy Discharge",
            type: "teamwork",
            shortDesc: "",
            longDesc: "If an ally with this feat cast a spell with an elemental type within 30 feet of you since your last turn, you can expend a swift action to charge your weapon with elemental energy, causing it to deal an additional 1d6 points of damage of that elemental type on its next attack. This bonus increases by 1d6 for every 3 levels of the spell.",
            prereq: "",
        },
        {
            name: "Eldritch Aid",
            type: "magic",
            shortDesc: "",
            longDesc: "As a standard action, you can expend a 1st-level or higher spell slot to grant additional magic energy to an allied spellcaster within close range (25 feet + 5 feet/2 levels). If that ally casts an instantaneous spell of an equal or lower level before the beginning of your next turn, all level-dependent calculations and caster level checks the spell requires are made as if the ally's caster level was levels higher equal to half the level of the spell slot expended.",
            prereq: "",
        },
        {
            name: "Coven Caster",
            type: "magic",
            shortDesc: "",
            longDesc: "You can attempt a special aid another action (1d20 + highest mental; DC 10). If you succeed, you can increase an adjacent spellcaster's caster level by 1 until the beginning of your next turn. If you also have the hexes feat you can apply this to all casters within 30 feet.",
            prereq: "",
        },
        {
            name: "Golden Legion Commander",
            type: "utility",
            shortDesc: "",
            longDesc: "Each round as a move action, you may issue commands to all allies within 30 feet who can see and hear you (this doesn't effect you). Each affected ally that obeys your orders gains a +1 bonus on attack rolls, Armor Class, and saving throws during that round. For each 10 ranks in diplomacy you have, this bonus increases by +1.",
            prereq: "",
        },
        {
            name: "Twilight Talon Assassin",
            type: "martial",
            shortDesc: "",
            longDesc: "The first attack you make against a target, as long as you are either flanking it, or it is denied its dexterity bonus to its armor class, your critical threat range increases by a flat +1. This first attack also deals additional precision damage equal to half your ranks in stealth. For every 15 ranks in stealth you have, the critical threat range bonus increases by +1.",
            prereq: "",
        },
        {
            name: "Steel Falcon Skirmisher",
            type: "martial",
            shortDesc: "",
            longDesc: "You deal +2 damage with weapon attacks directed at any creature against which you have concealment. If you have total concealment against the creature, this bonus is doubled. For every 5 ranks in bluff you have, this bonus increases by +1.",
            prereq: "",
        },
        {
            name: "Savage Slam",
            type: "martial",
            shortDesc: "",
            longDesc: "When you begin your turn grappling an opponent, instead of attempting a combat maneuver check to maintain the grapple, you can try to viciously slam your opponent down. As a standard action, you can attempt a grapple combat maneuver check against the opponent. If you succeed, you release your grapple and the opponent falls prone in an unoccupied square of your choice adjacent to you. If you attempt to throw your foe into a hazardous location, such as a wall of fire or a pit, the target receives a +4 bonus to its CMD against your attempt. As long as the opponent lands on solid ground or a solid object, it takes damage equal to your unarmed strike's damage.",
            prereq: "",
        },
        {
            name: "Dragonslayer",
            type: "martial",
            shortDesc: "",
            longDesc: "Whenever you confirm a critical hit against an opponent that has a breath weapon, you can forgo the extra critical damage to instead prevent your foe from using its breath weapon for a number of rounds equal to twice the critical multiplier of your attack. If the ability was already recharging, add the delayed rounds to the rounds it would take to finish recharging. This delay doesn't otherwise stack.",
            prereq: "",
        },
        {
        name: "Arcing Weapon",
        type: "magic",
        shortDesc: "As a standard action, you can cast a ray spell that requires a ranged touch attack and deliver the effect through your melee weapon, either through a melee attack or as a ranged attack. If you deliver this spell as a melee attack, this functions as the magus spellstrike ability.",
        longDesc: "As a standard action, you can cast a ray spell that requires a ranged touch attack and deliver the effect through your melee weapon, either through a melee attack, or fire it as a ray from the weapon. If you deliver this spell as a melee attack, this functions as the magus spellstrike ability. If you fire it as a ray it gains the weapons enhancement bonus to the spells damage (hitpoint damage only), and uses the weapons critical threat range, however its base critical multiplier is still x2, and if you use a spell that that could normally make multiple attacks such as scorching ray, you can only deliver a single one of them, the rest are wasted.",
        prereq: "",
        },
        {
            name: "Greater Arcing Weapon",
            type: "magic",
            shortDesc: "",
            longDesc: "When you use arcing weapons you can choose to deliver the spell through a ranged attack as well as if using the magus Eldritch Archer ranged spellstrike ability. The target must still be within the spells range.",
            prereq: "Arcing Weapon",
        },
        {
        name: "Armor Focus",
        type: "martial",
        shortDesc: "Select one class of armor, such as light or medium. The AC bonus granted by the selected armor increases by 2.",
        longDesc: "Select one type of armor, such as light or medium (not clothes). The AC bonus granted by the selected armor increases by +2.",
        prereq: "",
        key:true,
        repeatable:true,
        },
        {
            name: "Improved Armor Focus",
            type: "martial",
            shortDesc: "Select one class of armor, such as light or medium. The AC bonus granted by the selected armor increases by 2.",
            longDesc: "The armor type you selected with armor focus has its max dexterity bonus increased by +2, and its armor check penalty reduced by 2",
            prereq: "Armor Focus",
        },
        {
            name: "Greater Armor Focus",
            type: "martial",
            shortDesc: "",
            longDesc: "While wearing the armor type you selected with armor focus you increase your armor bonus by an additional +1 and gain a +4 bonus to armor class against confirming critical hits",
            prereq: "Improved Armor Focus",
        },
        {
        name: "Awesome Blow",
        type: "martial",
        shortDesc: "This creature can send opponents flying",
        longDesc: "As a standard action, you may perform an awesome blow combat maneuver using your CMB, this check can be made unarmed or with your weapon. If your maneuver succeeds against a corporeal opponent equal in size or smaller than you, they take 1d8 + strength points of damage (increased by your size), and it is knocked flying 10 feet in a direction of your choice and falls prone. You can only push the opponent in a straight line, and the opponent can't move closer to you than the square it started in. If an obstacle prevents the completion of the opponent's move, the opponent and the obstacle each take 1d6 points of damage, and the opponent is knocked prone in the space adjacent to the obstacle.",
        prereq: "",
        key:true,
        },
        {
        name: "Improved Awesome Blow",
        type: "martial",
        shortDesc: "+2 on awesome blow combat maneuver checks and to CMD against such attacks, and movement due to awesome blow provokes from allies",
        longDesc: "You receive a +2 bonus on checks to perform an awesome blow combat maneuver, and can use awesome blow on creatures one size larger than you now. You also gain a +2 bonus to your combat maneuver defense whenever an opponent tries to perform an awesome blow combat maneuver against you. Whenever you successfully perform an awesome blow combat maneuver, your opponent's movement provokes attacks of opportunity from all your allies (but not you).",
        prereq: "Awesome Blow",
        },
        {
            name: "Greater Awesome Blow",
            type: "martial",
            shortDesc: "+2 on awesome blow combat maneuver checks and to CMD against such attacks, and movement due to awesome blow provokes from allies",
            longDesc: "Gain another +2 bonus on checks to perform an awesome blow combat maneuver. When you make an awesome blow combat maneuver, for every 5 by which your combat maneuver check exceeds the target's CMD, you send the target flying 5 additional feet. When you use Awesome Blow you can instead deal damage with a weapon you are wielding instead of slam damage.",
            prereq: "Improved Awesome Blow",
        },
        {
        name: "Awesome Charge",
        type: "martial",
        shortDesc: "When you hit your opponent with a charge attack, you can attempt an awesome blow combat maneuver against that opponent as a free action.",
        longDesc: "When you hit your opponent with a charge attack, you can attempt an awesome blow combat maneuver against that opponent as a free action. You dont deal the additional damage from awesome blow, though still deal your damage for the charge attack. If you have multiple attacks on a charge, only one of the attacks allows you to use this feat, which you must decide before you have made any attack rolls.",
        prereq: "Awesome Blow",
        },
        {
        name: "Awesome Throw",
        type: "martial",
        shortDesc: "As a standard action, you can perform the awesome throw combat maneuver. You do this by making a thrown weapon attack; if you don't have the Throw Anything feat, you must use a large, bulky, and relatively regular-shaped object with a hardness of at least 5 (such as a rock or treasure chest). If that attack hits a corporeal opponent smaller than you, the opponent takes damage and is knocked away, flying 10 feet in a straight line away from you and falling prone. If an obstacle prevents the completion of your target's move, the target and the obstacle each take 1d6 points of damage, and the target is knocked prone in a space adjacent to the obstacle.",
        longDesc: "As a standard action, you can perform the awesome throw combat maneuver. You do this by making a thrown weapon attack; If that attack hits a corporeal opponent smaller or the same size as you, the opponent takes damage and is knocked away, flying 10 feet in a straight line away from you and falling prone. If an obstacle prevents the completion of your target's move, the target and the obstacle each take 1d6 points of damage, and the target is knocked prone in a space adjacent to the obstacle.",
        prereq: "",
        },
        {
        name: "Bashing Finish",
        type: "martial",
        shortDesc: "Make a free shield bash after a critical hit",
        longDesc: "Whenever you score a critical hit with a melee weapon, you can make a shield bash attack against the same target using the same bonus as a free action.",
        prereq: "",
        },
        {
        name: "Blades Above and Below",
        type: "teamwork",
        shortDesc: "When fighting with a differently sized ally, you flank an adjacent foe from any position",
        longDesc: "When you and your ally who also has this feat threaten the same enemy, you're both considered to be flanking that enemy, regardless of your actual positioning. To gain this benefit, you and your ally must be of different size categories, and your target must be the same size category as either you or your ally.",
        prereq: "",
        },
        {
        name: "Bleeding Attack",
        type: "martial",
        shortDesc: "+1d4 bleed damage with unarmed strikes",
        longDesc: "+1d4 bleed damage with unarmed strikes",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Ascetic Style",
        type: "style",
        shortDesc: "You can use feats that modify or augment unarmed strikes with weapons",
        longDesc: "You can use feats, abilities, and strikes that modify or augment unarmed strikes with any weapon.",
        prereq: "",
        key:true,
        },
        {
        name: "Blind-Fight",
        type: "martial",
        shortDesc: "Reroll miss chances for concealment",
        longDesc: "In melee, every time you miss because of concealment, you can reroll your miss chance percentile roll one time to see if you actually hit. An invisible attacker gets no advantages related to hitting you in melee. That is, you don't lose your Dexterity bonus to Armor Class, and the attacker doesn't get the usual +2 bonus for being invisible. The invisible attacker's bonuses do still apply for ranged attacks, however. You do not need to make Acrobatics skill checks to move at full speed while blinded.",
        prereq: "",
        key:true,
        },
        {
        name: "Improved Blind-Fight",
        type: "martial",
        shortDesc: "Total concealment is considered normal concealment",
        longDesc: "Your melee attacks ignore the miss chance for less than total concealment. You may still reroll your miss chance percentile roll for total concealment. If you successfully pinpoint an invisible or hidden attacker within 30 feet, that attacker gets no advantages related to hitting you with ranged attacks. That is, you don't lose your Dexterity bonus to Armor Class, and the attacker doesn't get the usual +2 bonus for being invisible.",
        prereq: "Blind-Fight",
        },
        {
        name: "Greater Blind-Fight",
        type: "martial",
        shortDesc: "Ignore miss chance for less than total concealment",
        longDesc: "Your melee attacks ignore the miss chance for less than total concealment, and you treat opponents with total concealment as if they had normal concealment (20% miss chance instead of 50%). You may still reroll a miss chance percentile roll as normal. If you successfully pinpoint an invisible or hidden attacker, that attacker gets no advantages related to hitting you with ranged attacks, regardless of the range. That is, you don't lose your Dexterity bonus to Armor Class, and the attacker doesn't get the usual +2 bonus for being invisible.",
        prereq: "Improved Blind-Fight",
        },
        {
        name: "Blooded Arcane Strike",
        type: "magic",
        shortDesc: "Gain the benefits of Arcane Strike while raging",
        longDesc: "While you are raging, you don't need to spend a swift action to use your Arcane Strike-it is always in effect. When you use this ability with Vital Strike, Improved Vital Strike, or Greater Vital Strike, the bonus on damage rolls for Arcane Strike is multiplied by the number of times (two, three, or four) you roll damage dice for one of those feats.",
        prereq: "Arcane Strike",
        perkPrereq:["Rage", "Epic Rage"]
        },
        {
        name: "Blood Feast",
        type: "martial",
        shortDesc: "Gain morale bonuses after biting living creatures",
        longDesc: "When you damage a living creature with your bite attack, you gain a +1 morale bonus on attack and damage rolls with melee weapons until the end of your next turn.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Bloody Assault",
        type: "martial",
        shortDesc: "Trade melee attack bonus for bleed damage",
        longDesc: "You can choose to take a -5 penalty on all melee attack rolls and combat maneuver checks to inflict 1d4 points of bleed damage with your weapon melee attacks, in addition to the normal damage dealt by the weapon. A creature continues to take bleed damage every round at the start of its turn. Bleed damage can be stopped by a DC 15 Heal check or through any magical healing. Bleed damage from this feat does not stack with itself. You must choose to use this feat before making the attack roll, and its effects last until your next turn (although the bleeding lasts until healed, as normal). Critical hits increase the bleed damage applied, or currently affecting the creature by an amount equal to the critical multiplier of the weapon.",
        prereq: "",
        },
        {
        name: "Bodyguard",
        type: "martial",
        shortDesc: "Use AoO to add a bonus to adjacent ally's AC",
        longDesc: "When an adjacent ally is attacked, you may use an attack of opportunity to attempt the aid another action to improve your ally's AC. You may not use the aid another action to improve your ally's attack roll with this attack.",
        prereq: "",
        },
        {
        name: "Branch Pounce",
        type: "martial",
        shortDesc: "Deal additional damage on a target you leap down upon from above",
        longDesc: "When charging a target by jumping down from above (such as when jumping out of a tree), you can soften your own fall with a melee attack. If the attack at the end of your charge hits, the attack deals damage as normal and also adds the appropriate amount of falling damage (1d6 points for a 10-foot fall, 2d6 points for a 20-foot fall, and so on). This falling damage is not multiplied on a critical hit. You land in an unoccupied square of your choosing adjacent to the target, and you take falling damage as if you had fallen 10 fewer feet. You can attempt an Acrobatics check as normal to treat the fall as an additional 10 feet shorter for the purpose of determining the damage you take from the fall and treat the first 1d6 points of damage you take from the fall as nonlethal damage. If your attack misses, you land prone in a random square adjacent to the target and automatically take the normal amount of falling damage. This bonus damage only applies to the first attack of a charge.",
        prereq: "",
        },
        {
        name: "Break Guard",
        type: "martial",
        shortDesc: "May attack opponent you attempted to disarm with your second weapon",
        longDesc: "While wielding two weapons, whenever you successfully use one weapon to disarm an opponent, you can spend a swift action to attack the opponent you attempted to disarm using your other weapon.",
        prereq: "",
        },
        {
        name: "Brutal Grappler",
        type: "teamwork",
        shortDesc: "Damage a target while grappling",
        longDesc: "When you and an ally with this feat have grappled the same creature, you may attempt to damage the opponent on your turn (whether you were the one who first initiated the grapple or were assisting your ally in doing so). You and the ally are treated as aiding each other in the grapple (+2 bonus on your grapple combat maneuver) as long as you both decide to maintain the grapple.",
        prereq: "",
        },
        {
        name: "Improved Bull Rush",
        type: "martial",
        shortDesc: "+2 bonus on bull rush attempts, no AOO",
        longDesc: "You do not provoke an attack of opportunity when performing a bull rush combat maneuver. In addition, you receive a +2 bonus on checks made to bull rush a foe. You also receive a +2 bonus to your Combat Maneuver Defense whenever an opponent tries to bull rush you.",
        prereq: "",
        },
        {
        name: "Greater Bull Rush",
        type: "martial",
        shortDesc: "Enemies you bull rush provoke attacks of opportunity",
        longDesc: "You receive a +2 bonus on checks made to bull rush a foe. This bonus stacks with the bonus granted by Improved Bull Rush. Whenever you bull rush an opponent, his movement provokes attacks of opportunity from all of your allies (but not you).",
        prereq: "Improved Bull Rush",
        },
        {
        name: "Bull Rush Strike",
        type: "martial",
        shortDesc: "Attempt a bull rush on a successful critical hit",
        longDesc: "Whenever you score a critical hit with a melee attack, you can push your opponent back, in addition to the normal damage dealt by the attack. If your confirmation roll exceeds your opponent's CMD, you may push your opponent back as if from the bull rush combat maneuver. You do not need to move with the target if successful. This provokes as normal.",
        prereq: "",
        },
        {
        name: "Bullseye Shot",
        type: "martial",
        shortDesc: "Spend a move action to gain a +4 bonus to next ranged attack before end of your turn.",
        longDesc: "You can spend a move action to steady your shot. When you do, you gain a +4 bonus on your next ranged attack roll before the end of your turn.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Bullying Blow",
        type: "martial",
        shortDesc: "As a standard action, you may make a melee attack with a -2 penalty on the attack roll. If the attack damages your opponent, you may make an Intimidate check to demoralize that opponent as a free action.",
        longDesc: "As a standard action, you may make a melee attack with a -2 penalty on the attack roll. If the attack damages your opponent, you may make an Intimidate check to demoralize that opponent as a free action.",
        prereq: "",
        },
        {
        name: "Canny Tumble",
        type: "martial",
        shortDesc: "Gain a bonus on melee attack rolls when you use Acrobatics to avoid attacks of opportunity",
        longDesc: "When you use Acrobatics to move through an opponent's threatened area or space without provoking an attack of opportunity from that opponent, you gain a +2 circumstance bonus on your next melee attack roll against that opponent and that opponent is denied its Dexterity bonus to AC, as long as you make that attack before the start of your next turn.",
        prereq: "",
        },
        {
        name: "Caster's Champion",
        type: "martial",
        shortDesc: "Three times per combat as a swift action, when you are within 30 feet of an ally who is an arcane spellcaster, you can channel a portion of her arcane power into your weapons.",
        longDesc: "Three times per combat as a swift action, when you are within 30 feet of an ally who is an arcane spellcaster, you can channel a portion of her arcane power into your weapons. For 1 round, you gain a +1 bonus on all weapon damage rolls, and your weapons are treated as magic for the purpose of overcoming damage reduction. When your base attack bonus reaches +4 and every 4 points thereafter, this bonus increases by +1",
        prereq: "",
        },
        {
        name: "Cautious Fighter",
        type: "martial",
        shortDesc: "When fighting defensively or using total defense, your dodge bonus to AC increases by 2.",
        longDesc: "When fighting defensively or using total defense, your dodge bonus to AC increases by 2. This increases by +1 every 8 levels.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Defensive Fighting Expert",
        type: "martial",
        shortDesc: "When fighting defensively or using total defense, your dodge bonus to AC increases by 2.",
        longDesc: "When fighting defensively you gain +1 to attack. This increases by 1 every 8 levels",
        prereq: "",
        key:true,
        repeatable:true,
        },
        {
        name: "Channel Smite",
        type: "martial",
        shortDesc: "Channel energy through your attack",
        longDesc: "Before you make a melee attack roll, you can choose to spend one use of a prereq ability as a swift action. If the ability channeled would harm the creature your melee attack was against it deals the abilities damage. Your target can make a Will save, dc=(10+level/2+mental mod) to halve this additional damage, unless the ability has its own save to reduce it. If your attack misses, the channeled ability is still expended with no effect.",
        prereq: "",
        perkPrereq:["Channel Energy", "Epic Channel Energy", "Hemomancy", "Fervor", "Lay On Hands", "Touch of Corruption"],
        },
        {
        name: "Channeling Force",
        type: "martial",
        shortDesc: "Spend channel energy to deal extra force damage with weapon attacks",
        longDesc: "A swift action, you can expend one use of a healing prereq perk to grant your weapon attacks a bonus on damage rolls equal to the number of dice of it. This extra damage is force damage. This lasts for your next three weapon attacks or 1 minute, whichever comes first.",
        prereq: "",
        perkPrereq:["Channel Energy", "Epic Channel Energy", "Hexes", "Bardic Performance", "Hemomancy", "Fervor", "Guardian's Shield", "Lay On Hands", "Touch of Corruption"],
        },
        {
        name: "Charge Through",
        type: "martial",
        shortDesc: "Make overrun as free action while charging",
        longDesc: "When making a charge, you can attempt to overrun one creature in the path of the charge as a free action. If you successfully overrun that creature, you can complete the charge. If the overrun is unsuccessful, the charge ends in the space directly in front of that creature.",
        prereq: "",
        },
        {
        name: "Circuitous Shot",
        type: "martial",
        shortDesc: "Bounce ranged attacks to avoid total cover",
        longDesc: "You can choose to take a -2 penalty on a ranged weapon attack to ricochet it off a stone or metal surface and resolve the attack as if it originated from the chosen ricochet point for the purpose of determining cover (but not for determining concealment). Add the entire distance the weapon or ammunition traveled to determine range penalties for the attack. Bouncing a shot this way can potentially enable you to make ranged attacks against foes who have total cover against you by going around obstacles, but such a foe still has total concealment against your attack.",
        prereq: "",
        },
        {
        name: "Cleave",
        type: "martial",
        key:true,
        shortDesc: "Make an additional attack if the first one hits",
        longDesc: "As a standard action, you can make a single attack at your full base attack bonus against a foe within reach. If you hit, you deal damage normally and can make an additional attack (using your full base attack bonus) against a foe that is adjacent to the first and also within reach. You can only make one additional attack per round with this feat. When you use this feat, you take a -2 penalty to your Armor Class until your next turn.",
        prereq: "",
        },
        {
            name: "Cleaving Expertise",
            type: "martial",
            shortDesc: "Make an additional attack if the first one hits",
            longDesc: "When you make a melee attack that targets multiple creatures at once, for each 2 creatures you are targetting at once you gain a +1 bonus to attack, and a +4 bonus to the damage. If you are making additional melee attacks because of a feat such as cleave, or a different ability that functions similairly to it, you gain a +1 bonus to attack, and a +3 bonus to damage for each previous different creature you had struck this round. If you confirm a critical hit all of your further cleave attacks also deal an additional 1d6 damage.",
            prereq: "",
        },
        {
            name: "Great Cleave",
            type: "martial",
            shortDesc: "Make an additional attack after each attack hits",
            longDesc: "As a standard action, you can make a single attack at your full base attack bonus against a foe within reach. If you hit, you deal damage normally and can make an additional attack (using your full base attack bonus) against a foe that is adjacent to the previous foe and also within reach. If you hit, you can continue to make attacks against foes adjacent to the previous foe, so long as they are within your reach. You cannot attack an individual foe more than once during this attack action. When you use this feat, you take a -2 penalty to your Armor Class until your next turn.",
            prereq: "Cleave",
        },
        {
            name: "Flexible Cleave",
            type: "martial",
            shortDesc: "Make an additional attack if the first one hits",
            longDesc: "Once per turn when you hit a creature with a melee attack, you may make an additional attack against a foe within reach and adjacent to your original target. This additional attack does not gain any of the bonuses of the original attack unless it would affect all attacks in a full-round attack. If you use this ability you gain a -4 penalty to armor class until the start of your next turn.",
            prereq: "Great Cleave",
        },
        {
            name: "Mythic Cleave",
            type: "martial",
            shortDesc: "Make an additional attack after each attack hits",
            longDesc: "Whenever you use Cleave, Great Cleave, or Flexible Cleave, one of your attacks can be made against a foe that is within your reach, but not adjacent to the foe you attacked. You can expend level spell points when you use Great Cleave to continue making attacks against foes within your reach, regardless of their position, as long as you continue to hit each foe. You can't use this ability to attack a foe more than once per round.",
            prereq: "Great Cleave",
        },
        {
        name: "Cleaving Finish",
        type: "martial",
        shortDesc: "Make additional attack if opponent is knocked out.",
        longDesc: "If you make a melee attack, and your target drops to 0 or fewer hit points as a result of your attack, you can make another melee attack using your highest base attack bonus against another opponent within reach. You can make only one extra attack per round with this feat.",
        prereq: "",
        key:true,
        },
        {
        name: "Improved Cleaving Finish",
        type: "martial",
        shortDesc: "May use Cleaving Finish any number of times/round",
        longDesc: "You can use Cleaving Finish any number of times per round.",
        prereq: "Cleaving Finish",
        },
        {
        name: "Cleave Through",
        type: "martial",
        shortDesc: "When using Cleave or Great Cleave, if your initial attack hits, you may take a single 5-foot step as a free action before making your additional attacks. If doing so places a creature within your threatened area, that creature becomes a legal target for your additional Cleave attack(s) as long as it meets all the other prerequisites.",
        longDesc: "When using Cleave, Great Cleave, or mythic cleave, if your initial attack hits, you may take a single 5-foot step as a free action before making your additional attacks. If doing so places a creature within your threatened area, that creature becomes a legal target for your additional Cleave attack(s) as long as it meets all the other prerequisites.",
        prereq: "Cleave",
        repeatable:true,
        },
        {
            name: "Curse of Vengeance",
            type: "magic",
            shortDesc: "",
            longDesc: `Once per day when you are rendered helpless or a creature kills you, you can cast a single spell or spell-like ability as an immediate action before you become helpless or are killed. The spell must have a casting time of 1 standard action or less and must target the creature who rendered you helpless or who killed you. If the spell has a range of touch and the attacker is not within your reach, you can deliver it as a ranged touch attack with a range of 30 feet.`,
            prereq: "",
        },
        {
        name: "Clinging Climber",
        type: "martial",
        shortDesc: "Cling to a surface using your legs so you can use both hands to attack.",
        longDesc: "As a move action while climbing, you can cling to your climbing surface with your legs by succeeding at a Climb check (DC = the DC to climb the surface as a move action). If successful, you can make attacks with a two-handed ranged weapon and reload ranged weapons until you resume climbing. The GM may rule that this feat doesn't work on certain climbing surfaces.",
        prereq: "",
        },
        {
        name: "Close-Quarters Thrower",
        type: "martial",
        shortDesc: "Attacks with selected weapons do not provoke attacks of opportunity",
        longDesc: "Choose a type of thrown weapon. You do not provoke attacks of opportunity for making ranged attacks using the selected weapon. If you are an alchemist, and you select this feat and choose alchemist bombs, you do not provoke attacks of opportunity for the process of drawing components of, creating, and throwing a bomb.",
        prereq: "",
        },
        {
        name: "Clustered Shots",
        type: "martial",
        shortDesc: "Total damage from full-round ranged attacks before applying DR",
        longDesc: "When you use a full-attack action to make multiple ranged weapon attacks against the same opponent, total the damage from all hits before applying that opponent's damage reduction.",
        prereq: "",
        },
        {
        name: "Combat Expertise",
        type: "martial",
        shortDesc: "Trade attack bonus for AC bonus",
        longDesc: "You can choose to take a -1 penalty on melee attack rolls and combat maneuver checks to gain a +1 dodge bonus to your Armor Class. When your base attack bonus reaches +4, and every +4 thereafter, the penalty increases by -1 and the dodge bonus increases by +1. You can only choose to use this feat when you declare that you are making an attack or a full-attack action with a melee weapon. The effects of this feat last until your next turn.",
        prereq: "",
        repeatable:true,
        key:true,
        },
        {
            name: "Misdirection Tactics",
            type: "martial",
            shortDesc: "Trade attack bonus for AC bonus",
            longDesc: "While you are using the total defense action, if a melee attack would still hit your AC, you can attempt a Bluff check with a DC equal to the foe's attack roll as an immediate action. If you succeed at the check, you negate the attack (treat it as a miss). You cannot use this ability against the same creature more than once.",
            prereq: "Combat Expertise",            
        },
        {
            name: "Misdirection Redirection",
            type: "martial",
            shortDesc: "Trade attack bonus for AC bonus",
            longDesc: "When you successfully use the Misdirection Tactics feat to negate a melee weapon attack, you redirect your foe's attack and trick your foe into striking another creature of your choice within the foe's melee reach. To resolve this attack, your foe must make a new attack roll against the new target.",
            prereq: "Misdirection Tactics",            
        },
        {
        name: "Combat Patrol",
        type: "martial",
        shortDesc: "Increase threatened area for AOO",
        longDesc: "As a full-round action, you may set up a combat patrol, increasing your threatened area by 5 feet for every 5 points of your base attack bonus. Until the beginning of your next turn, you may make attacks of opportunity against any opponent in this threatened area that provokes attacks of opportunity. You may move as part of these attacks, provided your total movement before your next turn does not exceed your speed. Any movement you make provokes attacks of opportunity as normal.",
        prereq: "",
        },
        {
        name: "Combat Reflexes",
        type: "martial",
        key:true,
        shortDesc: "Make additional attacks of opportunity",
        longDesc: "You may make a number of additional attacks of opportunity per round equal to your Dexterity bonus. With this feat, you may also make attacks of opportunity while flat-footed.",
        prereq: "",
        },
        {
        name: "Concentrated Splash",
        type: "magic",
        shortDesc: "Forgo dealing splash damage to increase damage done by direct hit with splash weapon",
        longDesc: "When you deal a direct hit to a creature with a splash weapon that normally also deals splash damage, you can choose to forgo dealing splash damage. If you do, the damage dealt to the target of the direct hit increases by 50%. This damage is multiplied on a critical hit.",
        prereq: "",
        },
        {
        name: "Cornugon Smash",
        type: "martial",
        shortDesc: "Make free Intimidate checks when you Power Attack",
        longDesc: "When you damage an opponent with a Power Attack, you may make an immediate Intimidate check as a free action to attempt to demoralize your opponent.",
        prereq: "",
        },
        {
        name: "Hurtful",
        type: "martial",
        shortDesc: "When you successfully demoralize an opponent within your melee reach with an Intimidate check, you can make a single melee attack against that creature as a swift action. If your attack fails to damage the target, its shaken condition from being demoralized immediately ends.",
        longDesc: "When you successfully demoralize an opponent within your melee reach with an Intimidate check, you can make a single melee attack against that creature as a swift action. If your attack fails to damage the target, its shaken condition from being demoralized immediately ends.",
        prereq: "",
        },
        {
        name: "Counterpunch",
        type: "martial",
        shortDesc: "When you fight unarmed and a foe misses with all melee attacks, it provokes attacks of opportunity from you",
        longDesc: "Once per round, when you are fighting unarmed with both hands free and an opponent misses you with a melee attack, the opponent provokes an attack of opportunity from you. You must use an unarmed strike for this attack of opportunity.",
        prereq: "",
        key:true,
        repeatable:true,
        },
        {
        name: "Counter Reflexes",
        type: "martial",
        shortDesc: "Opponents with Mobility do not gain a bonus when they provoke attacks of opportunity from you",
        longDesc: "Opponents with the Mobility feat do not gain the dodge bonus granted by that feat when they provoke attacks of opportunity by moving out of or within your threatened area.",
        prereq: "",
        },
        {
        name: "Covering Fire",
        type: "teamwork",
        shortDesc: "You can use the aid another action with a ranged attack against an opponent, regardless of whether the opponent threatens an ally.",
        longDesc: "When you hit a foe with a ranged attack, that creature takes a -2 penalty on attack rolls for 1 round against any other ally that also has this feat; this changes to a -4 penalty on attacks of opportunity. The penalty applied by this feat does not stack with itself. However, if both you and an ally with this feat attack the same foe, you can cover each other (since a penalty you impose with this feat doesn't apply to attacks against you).",
        prereq: "",
        },
        {
        name: "Critical Focus",
        type: "martial",
        shortDesc: "+4 bonus on attack rolls made to confirm critical hits",
        longDesc: "You receive a +4 circumstance bonus on attack rolls made to confirm critical hits.",
        prereq: "",
        repeatable:true,
        },
        
        {
        name: "Critical Mastery",
        type: "martial",
        shortDesc: "Apply two effects to your critical hits",
        longDesc: "When you score a critical hit, you can apply the effects of two critical feats in addition to the damage dealt.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Crossbow Mastery",
        type: "martial",
        shortDesc: "Reload crossbow as free action and make full attacks",
        longDesc: "The time required for you to reload any type of crossbow is reduced by 2 steps, regardless of the type of crossbow used.",
        prereq: "Rapid Reload",
        },
        {
        name: "Crusader's Fist",
        type: "martial",
        shortDesc: "May use lay on hands or touch of corruption upon successful unarmed strike",
        longDesc: "Once per round when you attack with an unarmed strike and hit a creature that you can harm with a prereq perk, you can use a swift action to expend a daily use of that feature to deal its normal damage as if you had hit with the feature's normal touch attack. This extra damage is not multiplied if you scored a critical hit. It only affects the target of the melee attack even if it would normally hit multiple.",
        prereq: "",
        perkPrereq:["Channel Energy", "Epic Channel Energy", "Lay On Hands", "Touch of Corruption", "Hemomancy", "Fervor"],
        },
        {
        name: "Crushing Blow",
        type: "martial",
        shortDesc: "Stunning Fist reduces target's AC",
        longDesc: "You must declare that you are using this feat before you make your attack roll (thus, a failed attack roll ruins the attempt). Crushing Blow forces a foe damaged by your attack to make a Fortitude saving throw (DC 10 + 1/2 level + highest mental modifier). In addition to dealing damage normally, a defender who fails this saving throw has their AC reduced by an amount equal to your highest mental modifier for 1 minute. This penalty does not stack with other penalties applied due to Crushing Blow. This ability costs level/2 spell points, and can be used no more than once per round. Constructs, oozes, plants, undead, incorporeal creatures, and creatures immune to critical hits cannot be affected by this ability.",
        prereq: "",
        },
        {
        name: "Dazing Assault",
        type: "martial",
        shortDesc: "Trade melee attack bonus to daze opponents",
        longDesc: "You can choose to take a -5 penalty on all melee attack rolls and combat maneuver checks to daze opponents you hit with your melee attacks for 1 round, in addition to the normal damage dealt by the attack. A successful Fortitude save negates the effect. The DC of this save is 10 + your base attack bonus. You must choose to use this feat before making the attack roll, and its effects last until your next turn.",
        prereq: "",
        },
        {
        name: "Dazing Fist",
        type: "martial",
        shortDesc: "Daze foes with your unarmed strikes",
        longDesc: "You must declare that you are using this feat before you make your attack roll (thus, a failed attack roll ruins the attempt). Dazing Fist forces a foe damaged by your unarmed attack to attempt a Fortitude saving throw (DC = 10 + 1/2 level + highest mental modifier). In addition to dealing damage normally, a foe who fails this saving throw is dazed for 1 round, until just before your next turn. It costs 4 + level/2 spell points to activate this ability, and you can activate it no more than once per round. Constructs, incorporeal creatures, plants, undead, and creatures that are immune to critical hits cannot be affected by this ability.",
        prereq: "",
        },
        {
            name: "Sneaking Critical",
            type: "martial",
            shortDesc: "",
            longDesc: "Whenever you confirm a critical hit on a sneak attack, or what would count as a sneak attack, you can roll an additional number of sneak attack dice equal to your weapon's critical modifier. If you have sneak attack dice not from this feat, you also deal an extra point of damage per sneak attack dice you have.",
            prereq: "",
        },
        {
            name: "Solitary Survivor",
            type: "martial",
            shortDesc: "",
            longDesc: "When you have no conscious allies, you can call upon your solitary prowess to enter a focused state. While in this state, your melee attacks deal an additional 1d6 points of damage. This damage is not multiplied on a critical hit. If all of your allies are dead you instead gain a +2 bonus on attack rolls, saves, and an additional 2d6 damage on all weapon attacks, and a +4 dodge bonus to armor class.",
            prereq: "",
        },
        {
        name: "Dazzling Display",
        type: "martial",
        shortDesc: "Intimidate all foes within 30 feet",
        longDesc: "You can perform a bewildering show of prowess as a full-round action. Make an Intimidate check to demoralize all foes within 30 feet who can see your display.",
        prereq: "",
        },
        {
            name: "Motivating Display",
            type: "martial",
            shortDesc: "Intimidate all foes within 30 feet",
            longDesc: "Whenever you use Dazzling Display to demoralize foes, you can motivate your allies to better serve you. In addition to possibly demoralizing foes within 30 feet, your Intimidate check while using Dazzling Display also applies to allies within 30 feet who can see you. The DC for this effect is the same as it would be to demoralize your allies. Each ally so affected gains a +1 morale bonus on attack rolls and skill checks for the duration that it would normally be shaken.",
            prereq: "Dazzling Display",
            },
        {
        name: "Deadly Aim",
        type: "martial",
        shortDesc: "Trade ranged attack bonus for damage",
        longDesc: "You can choose to take a -1 penalty on all ranged attack rolls to gain a +2 bonus on all ranged damage rolls. When your base attack bonus reaches +4, and every +4 thereafter, the penalty increases by -1 and the bonus to damage increases by +2. You must choose to use this feat before making an attack roll and its effects last until your next turn. The bonus damage does not apply to touch attacks or effects that do not deal hit point damage.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Deadly Stroke",
        type: "martial",
        shortDesc: "Deal double damage plus 1 Con bleed",
        longDesc: "As a standard action, make a single attack with the weapon against a stunned or flat-footed opponent. If you hit, you deal double the normal damage and the target takes 1 point of Constitution bleed. The additional damage and bleed is not multiplied on a critical hit.",
        prereq: "",
        },
        {
        name: "Death from Above",
        type: "martial",
        shortDesc: "Gain +5 bonus on attack rolls when charging from higher ground or flying",
        longDesc: "Whenever you charge an opponent from higher ground, or from above while flying, you gain a +5 bonus on attack rolls in place of the bonuses from charging and being on higher ground.",
        prereq: "",
        },
        {
        name: "Death or Glory",
        type: "martial",
        shortDesc: "Gain +4 on attack, damage, and critical rolls vs. Large or larger opponents",
        longDesc: "Against a creature of a size larger than you, you can make a single melee attack as a full-round action, gaining a +4 bonus on the attack roll, damage roll, critical confirmation roll, and a +1 to critical damage multiplier. You gain an additional +1 on these bonus every 5 levels except the increase of critical damage multiplier. After you resolve your attack, the opponent you attack can spend an immediate action to make a single melee attack against you with the same bonuses.",
        prereq: "",
        },
        {
        name: "Final Gambit",
        type: "martial",
        shortDesc: "",
        longDesc: "While using death or glory, if all party members are dead or unconscious while using it, your attack is an automatic critical threat, however the target of the attack has their immediate action become an automatic critical threat as well.",
        prereq: "Death or Glory",
        },
        {
        name: "Deflect Arrows",
        type: "martial",
        shortDesc: "Avoid one ranged attack per round",
        longDesc: "You must have at least one hand free (holding nothing) to use this feat. Once per round when you would normally be hit with an attack from a ranged weapon, you may deflect it so that you take no damage from it. You must be aware of the attack and not flat-footed. Attempting to def lect a ranged attack doesn't count as an action. Unusually massive ranged weapons (such as boulders or ballista bolts) and ranged attacks generated by natural attacks or spell effects can't be deflected.",
        prereq: "",
        key:true,
        },
        {
            name: "Agile Maiden",
            type: "martial",
            shortDesc: "Avoid one ranged attack per round",
            longDesc: "For the purposes of perks and feats, you can treat heavy armor as either medium or heavy armor, whichever is more beneficial to a given ability. This does not affect the armor's statistics, and it is still considered heavy armor for all other purposes.",
            prereq: "",
        },
        {
        name: "Destroyer's Blessing",
        type: "martial",
        shortDesc: "Regain spell point by sundering.",
        longDesc: "When you succeed at a sunder attempt, you regain 1 spell point per 3 levels. If the sunder attempt causes the object to gain the broken condition, you heal your constitution modifier of hit points. This is not positive energy. If you are raging when you use this feat, the spell and hit points recovered is doubled.",
        prereq: "",
        perkRateUp:["Rage", "Epic Rage"],
        },
        {
        name: "Devastating Strike",
        type: "martial",
        shortDesc: "Deal extra damage when using Vital Strike bonus",
        longDesc: "Whenever you use Vital Strike, Improved Vital Strike, or Greater Vital Strike, you gain a +2 bonus on each extra weapon damage dice roll those feats grant. This bonus damage is multiplied on a critical hit.",
        prereq: "Vital Strike",
        repeatable:true,
        },
        {
        name: "Improved Devastating Strike",
        type: "martial",
        shortDesc: "Gain bonus on rolls to confirm critical hits",
        longDesc: "Whenever you use Vital Strike, Improved Vital Strike, or Greater Vital Strike, you gain a bonus on attack rolls to confirm a critical hit equal to the bonus on damage rolls you gain from Devastating Strike.",
        prereq: "Devastating Strike",
        repeatable:true,
        },
        {
        name: "Improved Dirty Trick",
        type: "martial",
        shortDesc: "+2 bonus on dirty trick attempts, no AOO",
        longDesc: "You do not provoke an attack of opportunity when performing a dirty trick combat maneuver. In addition, you receive a +2 bonus on checks made to attempt a dirty trick. You also receive a +2 bonus to your Combat Maneuver Defense when an opponent tries a dirty trick on you.",
        prereq: "",
        },
        {
        name: "Greater Dirty Trick",
        type: "martial",
        shortDesc: "Dirty trick penalty lasts 1d4 rounds.",
        longDesc: "You receive a +2 bonus on checks made to attempt a dirty trick. This bonus stacks with the bonus granted by Improved Dirty Trick. Whenever you successfully perform a dirty trick, the penalty lasts for 1d4 rounds, plus 1 round for every 5 by which your attack exceeds the target's CMD. In addition, removing the condition requires the target to spend a standard action.",
        prereq: "Improved Dirty Trick",
        },
        {
        name: "Dirty Trick Master",
        type: "martial",
        shortDesc: "Whenever you successfully perform a dirty trick against an opponent still affected by a previous dirty trick you can cause the condition to worsen.",
        longDesc: "Whenever you successfully perform a dirty trick combat maneuver against an opponent who is still affected by a condition inflicted by a previous dirty trick (whether your own or another creature's), you can cause the condition to worsen. In addition to increasing the duration of the condition as normal, you cause an opponent who is dazzled to become dazed, entangled to become pinned, shaken to become frightened, and sickened to become nauseated. This worsened condition replaces the previous dirty trick condition, and lasts for the duration of the dirty trick (including any rounds remaining from the previous dirty trick condition) or until the opponent uses a standard action to remove the condition (whichever comes first).",
        prereq: "",
        featRateUp:["Improved Dirty Trick"]
        },
        {
        name: "Improved Disarm",
        type: "martial",
        shortDesc: "+2 bonus on disarm attempts, no AOO",
        longDesc: "You do not provoke an attack of opportunity when performing a disarm combat maneuver. In addition, you receive a +2 bonus on checks made to disarm a foe. You also receive a +2 bonus to your Combat Maneuver Defense whenever an opponent tries to disarm you.",
        prereq: "",
        },
        {
        name: "Greater Disarm",
        type: "martial",
        shortDesc: "Disarmed weapons are knocked away from your enemy",
        longDesc: "You receive a +2 bonus on checks made to disarm a foe. This bonus stacks with the bonus granted by Improved Disarm. Whenever you successfully disarm an opponent, the weapon lands 15 feet away from its previous wielder, in a random direction.",
        prereq: "Improved Disarm",
        },
        {
        name: "Disarm, Directed",
        type: "martial",
        shortDesc: "You can choose the direction a disarmed weapon is thrown, or alternatively, make a ranged attack with the disarmed weapon",
        longDesc: "Whenever you successfully use a combat maneuver to disarm an opponent, the disarmed weapon lands up to 15 feet away from its wielder, in the direction you choose. Alternatively, you can make a ranged attack as an immediate action with the disarmed weapon against another opponent, as long as the disarmed weapon is a light or one-handed weapon. If the weapon is not a thrown weapon, you take a -4 penalty on the attack roll. You take a -4 penalty on your attack roll if you do not have a free hand.",
        prereq: "",
        featRateUp:["Improved Disarm"]
        },
        {
        name: "Disarming Strike",
        type: "martial",
        shortDesc: "Attempt a disarm on a successful critical hit",
        longDesc: "Whenever you score a critical hit with a melee attack, you can disarm your opponent, in addition to the normal damage dealt by the attack. If your confirmation roll exceeds your opponent's CMD, you may disarm your opponent as if from the disarm combat maneuver. This provokes as normal.",
        prereq: "",
        featRateUp:["Improved Disarm"]
        },
        {
            name: "One-Inch Punch",
            type: "martial",
            shortDesc: "Attempt a disarm on a successful critical hit",
            longDesc: "When making a full attack against a corporeal foe, you can forgo multiple attacks to make one unarmed strike at your highest base attack bonus. For each attack you forgo, you can add half your Strength modifier (minimum +0) to your damage roll. If you hit with this attack, you can attempt a bull rush combat maneuver check as a free action, substituting your attack roll result for the combat maneuver check result and adding a bonus equal to half your Strength modifier for each attack you forgo. This bull rush does not provoke an attack of opportunity, and you do not move as a result of the bull rush.",
            prereq: "",
        },
        {
        name: "Disengaging Feint",
        type: "martial",
        shortDesc: "Feint lets you move your speed without provoking attacks of opportunity",
        longDesc: "As a standard action, use Bluff to feint against an opponent. Instead of denying that opponent his Dexterity bonus to AC, a successful feint allows you to move up to your speed without provoking an attack of opportunity from the opponent you feinted for leaving the square you start in.",
        prereq: "",
        },
        {
        name: "Disengaging Flourish",
        type: "martial",
        shortDesc: "Successful feint causes your starting square to not count as threatened",
        longDesc: "As a standard action, make a Bluff check against each opponent that currently threatens you. If you succeed against at least one opponent, you can move up to your speed. This movement does not provoke attacks of opportunity from any opponent you succeeded at feinting against.",
        prereq: "Disengaging Feint",
        },
        {
        name: "Disengaging Shot",
        type: "martial",
        shortDesc: "When using Disengaging Flourish, you may make a single attack",
        longDesc: "Whenever you use Disengaging Feint or Disengaging Flourish, you can make a single melee attack against one opponent you succeeded at feinting against. That opponent is denied his Dexterity bonus to AC against this attack.",
        prereq: "Disengaging Flourish",
        },
        {
        name: "Disheartening Display",
        type: "martial",
        shortDesc: "Use Dazzling Display to increase a fear effect",
        longDesc: "When you successfully use Dazzling Display against any shaken, frightened, or panicked opponents, their fear increases by one step. An already panicked creature demoralized by this feat cowers. Once affected by this feat, a creature cannot be affected by it again (by you or anyone else) for 24 hours.",
        prereq: "Dazzling Display",
        },
        {
        name: "Disrupting Shot",
        type: "martial",
        shortDesc: "Ranged attacks increase enemy's DC to cast spells",
        longDesc: "If you ready an action to shoot an opponent casting a spell within 30 feet and successfully hit that opponent with a ranged attack, the concentration DC to successfully cast the spell is increased by +4.",
        prereq: "",
        },
        {
        name: "Disruptive",
        type: "martial",
        shortDesc: "Increases the DC to cast spells adjacent to you",
        longDesc: "The DC to cast spells defensively increases by +4 for all enemies that are within your threatened area. This increase to casting spells defensively only applies if you are aware of the enemy's location and are capable of taking an attack of opportunity. If you can only take one attack of opportunity per round and have already used that attack, this increase does not apply.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Distance Thrower",
        type: "martial",
        shortDesc: "Reduce ranged penalties for thrown weapons by 2",
        longDesc: "With a thrown weapon, you reduce your penalty on ranged attack rolls due to range by 2.",
        prereq: "",
        },
        {
        name: "Distracting Charge",
        type: "teamwork",
        shortDesc: "When an ally with this feat charges, you gain a +2 bonus on attack rolls against the creature charged",
        longDesc: "When your ally with this feat uses the charge action and hits, you gain a +2 bonus on your next attack roll against the target of that charge. This bonus must be used before your ally's next turn, or it is lost.",
        prereq: "",
        },
        {
            name: "Way of the Shooting Star",
            type: "magic",
            shortDesc: "you can use your highest mental stat for attack and damage on one handed weapons",
            longDesc: "[Divine Fighting Technique] You can use your highest mental stat in place of the regular ability modifier to attack and damage for attack and damage with light piercing or slashing weapons.",
            prereq: "",
            key:true,
        },
        {
            name: "Master of the Shooting Star",
            type: "magic",
            shortDesc: "",
            longDesc: "You can make a special attack with thrown weapons weapons or light piercing or slashing weapons, as a full-round action, make a single attack with the weapon, whether thrown or melee, rolling 1d4 to determine how effective the attack you made. If the attack hits, you deal damage as if you had hit with that many attacks. Precision and critical hit damage is only dealt once for this attack, and damage reduction applies to each instance of damage.",
            prereq: "Way of the Shooting Star",
        },
        {
            name: "Way of the Divine Star",
            type: "magic",
            shortDesc: "",
            longDesc: "When you make your special attack with master of the shooting star, you can choose to either make it as a standard action, or roll 2d4 instead of 1d4. Additionally, you can apply precision and critical damage an additional time, if the attack would qualify for the additional damage.",
            prereq: "Master of the Shooting Star",
        },
        {
            name: "Way of the Silent Shiv",
            type: "martial",
            shortDesc: "",
            longDesc: "[Divine Fighting Technique] Whenever you attack an opponent that is unaware of your presence (such as when you are using the Stealth skill or invisible), your attack deals damage as if you were one size category larger. This benefit applies only to the first attack that you make against the target, and only with attacks made with light or one-handed weapons intended for creatures of your size (including thrown attacks).",
            prereq: "",
        },
        {
            name: "Master of the Silent Shiv",
            type: "martial",
            shortDesc: "",
            longDesc: "At the start of each round, choose one opponent that you can see and attempt a Stealth check as a swift action. If the result of your check exceeds the target's CMD, treat the target as if it were unaware of your presence for the purpose of the initial benefit of this divine fighting technique. If you beat the target's CMD by 5 or more, you also treat it as being completely unaware of your presence for the purposes of all perks and feats you have.",
            prereq: "Way of the Silent Shiv",
        },
        {
            name: "Way of the Profane Shiv",
            type: "martial",
            shortDesc: "",
            longDesc: "You can choose two opponents you can see when using master of the silent shiv. Increase (or gain) your sneak attack by 2d6, with light or one-handed weapons. When using master of the silent shiv ability, for each interval of 5 you beat their CMD by, you gain an additional 1d6 sneak attack damage for your first attack against them.",
            prereq: "Master of the Silent Shiv",
        },
        {
            name: "Way of Hunger",
            type: "martial",
            shortDesc: "",
            longDesc: "[Divine Fighting Technique] When making an attack with a two-handed weapon, you can spend level spell points as a swift action, this must be done before the attack is rolled, but after it has been declared. If your attack hits you gain temporary hit points equal to half the damage done, these temporary hit points last 1 minute and do not stack. If you make this attack with a scythe, it instead gives temporary hit points equal to the damage done.",
            prereq: "",
        },
        {
            name: "Master of Hunger",
            type: "martial",
            shortDesc: "",
            longDesc: "You can spend level spell points to exacerbate any lingering contagions within a target's body upon making a successful melee attack with a two handed weapon. Activating this ability is a swift action, and causes the target to immediately attempt additional saving throws against all diseases and poisons with which it is currently afflicted. Any failed saves cause the target to immediately take the effects of that disease or poison, while a successful save does not count toward the number of consecutive saves that the target must succeed at in order to cure the disease.",
            prereq: "Way of Hunger",
        },
        {
            name: "Way of Profane Hunger",
            type: "martial",
            shortDesc: "",
            longDesc: "When using the benefit of master of hunger, if the target of the attack has any kind of poison or disease effects it applies with attacks or Su abilities, it must make a save against it or contract it. This ignores the normal immunity a creature has to its own affects, unless it would be immune to that effect otherwise.",
            prereq: "Master of Hunger",
        },
        {
            name: "Way of War",
            type: "martial",
            shortDesc: "",
            longDesc: "[Divine Fighting Technique] If you have a Vital Strike feat, you can apply its effect to an attack you make with a two handed weapon at the end of a charge. If you don't have a Vital Strike feat, that attack deals 1 additional point of damage per base damage dice of the weapon instead. The first time you make an attack of opportunity with a two handed weapon after using a Vital Strike feat with a two handed weapon on your turn, you can apply a Vital Strike feat to that attack of opportunity.",
            prereq: "",
        },
        {
            name: "Master of War",
            type: "martial",
            shortDesc: "",
            longDesc: "When you use a Vital Strike feat with a two handed weapon, the damage counts as continuous damage from an injury for the purpose of determining whether a target must attempt a concentration check to cast spells.",
            prereq: "Way of War",
        },
        {
            name: "Way of the Divine War",
            type: "martial",
            shortDesc: "",
            longDesc: "You can use a cleave feat, or whirlwind attack, while also adding a vital strike feat at the same time. When you make a full-round action, you can apply a vital strike feat to the first attack.",
            prereq: "Master of War",
        },
        {
            name: "Way of the Inspiring Sword",
            type: "martial",
            shortDesc: "",
            longDesc: "[Divine Fighting Technique] While wielding a one handed slashing weapon, you can perform an impressive display of prowess as a full-round action while in combat. All allies within 30 feet who can see your display gain a +2 sacred bonus on attack rolls, saving throws, and skill checks for 1 round + 1 round per 5 points of base attack bonus you have.",
            prereq: "",
        },
        {
            name: "Master of the Inspiring Sword",
            type: "martial",
            shortDesc: "",
            longDesc: "As a standard action or at the end of a charge, you can make an attack against a foe with a one handed slashing weapon (only once per charge). If you succeed, you grant all allies who can see your attack a +2 sacred bonus on attack rolls, saving throws, and skill checks for 3 rounds.",
            prereq: "Way of the Inspiring Sword",
        },
        {
            name: "Way of the Divine Sword",
            type: "martial",
            shortDesc: "",
            longDesc: "Way and Master of The Inspiring Sword now stack. You can reapply either one increasing the duration of the effect by 1 round, and increasing the bonus by +1, to a maximum of +2, +1 per 6 bab for for either.",
            prereq: "Master of the Inspiring Sword",
        },
        {
            name: "Way of the Distracting Shot",
            type: "martial",
            shortDesc: "",
            longDesc: "[Divine Fighting Technique] As a standard action, you can fire a distracting shot from your bow; when you do, select one ally who is adjacent to the creature you are targeting with the distracting shot. If you hit the creature, the chosen ally gains a +2 bonus to their Armor Class against that creature. This bonus to their Armor Class lasts until the start of your next turn.",
            prereq: "",
        },
        {
            name: "Master of the Distracting Shot",
            type: "martial",
            shortDesc: "",
            longDesc: "When you fire a distracting shot at a creature and hit the creature, you grant a +4 Armor Class bonus to the selected adjacent ally and a +2 Armor Class bonus to all other allies within 30 feet of the selected adjacent ally against attacks by the targeted creature.",
            prereq: "Way of the Distracting Shot",
        },
        {
            name: "Way of the Divine Shot",
            type: "martial",
            shortDesc: "",
            longDesc: "Your first bow attack each round applies Way of the Distracting Shot (doesn't include the benefit of Master of the distracting Shot). When you score a critical hit with a bow you can apply Master of the Distracting Shot, whether it is the first attack or not. This stacks with Way of the Distracting Shot, but not with itself.",
            prereq: "Master of the Distracting Shot",
        },
        {
            name: "Way of the Mace",
            type: "martial",
            shortDesc: "",
            longDesc: "[Divine Fighting Technique] Whenever you threaten a critical hit with a light or one handed bludgeoning weapon (not unarmed strike) on a foe, that foe becomes sickened for 1 round. If you confirm the critical hit, the sickened effect lasts for 2 rounds. The duration of the sickened effect doesn't stack with multiple critical threats.",
            prereq: "",
        },
        {
            name: "Master of the Mace",
            type: "martial",
            shortDesc: "",
            longDesc: "An opponent that you hit with a light or one handed bludgeoning weapon (not unarmed strike) who is denied his Dexterity bonus to AC is also hindered by the attack. You can attempt a dirty trick combat maneuver check as a swift action that doesn't provoke an attack of opportunity immediately after damage from the attack is resolved.",
            prereq: "Way of the Mace",
        },
        {
            name: "Way of the Profane Mace",
            type: "martial",
            shortDesc: "",
            longDesc: "It becomes a free action to use a dirty trick with Master of the Mace. If you can normally make dirty tricks without provoking you gain a +2 to the check.",
            prereq: "Master of the Mace",
        },
        {
            name: "Way of the Carving Blade",
            type: "martial",
            shortDesc: "",
            longDesc: "[Divine Fighting Technique] As a standard action, you can make a single attack with a slashing light or two handed weapon in order to deal bleed damage to the target. When you make this attack, you do not apply your ability modifier (normally Strength, but potentially other modifiers) to the hit point damage dealt by your attack—instead, add an amount of bleed damage equal to this modifier. The bleeding can be stopped by a successful DC 15 Heal check or any amount of magical healing. Bleed damage from this benefit doesn't stack with itself.",
            prereq: "",
        },
        {
            name: "Master of the Carving Blade",
            type: "martial",
            shortDesc: "",
            longDesc: `Whenever you hit a bleeding creature with a melee attack using a light or two handed slashing weapon, that creature must succeed at a Fortitude save (DC = 10 + your base attack bonus) or become staggered for 1 round.
            \nMultiple attacks do not cause this condition to stack, and a creature that successfully saves against this staggering effect is immune to this effect for 1 round.`,
            prereq: "Way of the Carving Blade",
        },
        {
            name: "Way of the Profane Blade",
            type: "martial",
            shortDesc: "",
            longDesc: `Your first attack every round can cause bleeding as Way of the Carving Blade Feat. If you hit a creature already bleeding with way of the carving blade, you can choose to increase the bleed damage by your BAB/2 instead of using the highest amount.`,
            prereq: "Master of the Carving Blade",
        },
        {
            name: "Way of the Pinning Crossbow",
            type: "martial",
            shortDesc: "",
            longDesc: `[Divine Fighting Technique] You can attempt a ranged steal and disarm combat maneuvers with crossbows, using your Dexterity modifier in place of your Strength modifier to calculate your Combat Maneuver Bonus. If you use a steal maneuver, the stolen item is knocked away by the bolt; if the bolt can pierce any part of the item and the item weighs 2 pounds or less, the bolt continues past the creature and carries the item up to one range increment away, pinning it to whatever surface it lands on.`,
            prereq: "",
        },
        {
            name: "Master of the Pinning Crossbow",
            type: "martial",
            shortDesc: "",
            longDesc: `When fighting a foe adjacent to a firm surface, you can attempt a ranged dirty trick combat maneuver check with a crossbow, using your Dexterity modifier in place of your Strength modifier to calculate your Combat Maneuver Bonus. If you succeed, your bolt pins the target's clothing (or feathers, hide, or the like) to the surface, preventing the target from leaving that space until it breaks free by destroying the bolt or removing it with a successful Strength check (DC = the result of your combat maneuver check to pin it).`,
            prereq: "Way of the Pinning Crossbow",
        },
        {
            name: "Way of the Divine Crossbow",
            type: "martial",
            shortDesc: "",
            longDesc: `Creatures Pinned receive a -2 penalty to attack, damage, and armor class, increasing by -1 every 8 bab. You can add your highest mental modifier for determing your damage with crossbows. This cannot be combined with another ability that adds an ability score to your damage with crossbows, except a crossbows base ability score damage.`,
            prereq: "Master of the Pinning Crossbow",
        },
        {
            name: "Way of Thunder",
            type: "martial",
            shortDesc: "",
            longDesc: `[Divine Fighting Technique] Whenever you succeed at a dirty trick combat maneuver check against an opponent, you deal an amount of nonlethal damage equal to 1d6 + your highest mental modifier.`,
            prereq: "",
        },
        {
            name: "Master of Thunder",
            type: "martial",
            shortDesc: "",
            longDesc: `Anytime you use Power Attack with a two handed weapon or a natural attack, you ignore an amount of the target's hardness or damage reduction equal to the penalty Power Attack imparts to your attack roll.`,
            prereq: "Way of Thunder",
        },
        {
            name: "Way of Profane Thunder",
            type: "martial",
            shortDesc: "",
            longDesc: `When you succeed a dirty trick you instead deal 2d6 + 2x your highest mental modifier non-lethal damage. Your power attack with two handed weapons deals +1 additional damage, increasing by +1 for every 4 bab. You can choose to double your power attack penalty to double this additional damage.`,
            prereq: "Master of Thunder",
        },
        {
            name: "Way of Mercy",
            type: "martial",
            shortDesc: "",
            longDesc: `[Divine Fighting Technique] You take no penalty on attack rolls for using a one handed slashing weapon to deal nonlethal damage. If your attack with the weapon would normally deal additional damage (such as via sneak attack, the flaming weapon special ability, or the like), this additional damage can be nonlethal damage. You can also alter spells with the fire, good, or light descriptor and inflict spells so that the damage they deal is nonlethal damage instead. You can choose to apply this effect as the spell is cast.`,
            prereq: "",
        },
        {
            name: "Master of Mercy",
            type: "martial",
            shortDesc: "",
            longDesc: `Once per round as you strike a foe with a weapon and deal nonlethal damage with that attack, you regain 1d6 hit points.

            If the attack that dealt nonlethal damage was from a one handed slashing weapon, you instead regain 2d6 hit points, and 3d6 points if its with a scimatar. You can gain the benefit of this healing only once per round, regardless of how many successful attacks you make with the weapon.`,
            prereq: "Way of Mercy",
        },
        {
            name: "Way of Divine Mercy",
            type: "martial",
            shortDesc: "",
            longDesc: `After the first time you heal from master of mercy, you can continue to do so, but you only heal 2 points per dice you would have rolled to heal. When dealing non-lethal damage increase the damage dealt by 2d6.`,
            prereq: "Master of Mercy",
        },
        {
            name: "Way of Patient Strikes",
            type: "martial",
            shortDesc: "",
            longDesc: `[Divine Fighting Technique] Whenever you wield a one-handed bludgeoning weapon, add your Wisdom bonus to the total number of attacks of opportunity that you can make per round (but have to be taken with that weapon). These additional attacks of opportunity don't stack with those granted by Combat Reflexes. In addition, you can make attacks of opportunity while you're flat-footed.`,
            prereq: "",
        },
        {
            name: "Master of Patient Strikes",
            type: "martial",
            shortDesc: "",
            longDesc: `Once per round, before you make an attack of opportunity with a one handed bludgeoning weapon, you can declare an opportunistic strike. If the attack hits, you can apply the effects of a Vital Strike feat. If you confirm a critical hit with an opportunistic strike, you can attempt a disarm or trip combat maneuver check against the target as a free action—this combat maneuver does not provoke an attack of opportunity.`,
            prereq: "Way of Patient Strikes",
        },
        {
            name: "Way of Divine Patience",
            type: "martial",
            shortDesc: "",
            longDesc: `You can use make an additional opportunistic strike per round for 3 spell points. You can apply an extra .5 ability score modifier when making an Opportunistic strike. You can make multiple attacks of opportunity for one action as long as you have multiple abilities that grant it (except moving through multiple squares).`,
            prereq: "Master of Patient Strikes",
        },
        {
            name: "Way of the Flensing Chain",
            type: "martial",
            shortDesc: "",
            longDesc: `[Divine Fighting Technique] Once per round, when you hit a foe with a spiked chain or whip, you can twist the it so it painfully flenses both of you. You and your target are both sickened for 1 round, and the target must succeed at a Fortitude save (DC = 10 + 1/2 level + highest mental bonus) or be sickened for an additional 1d4+1 rounds.`,
            prereq: "",
        },
        {
            name: "Master of the Flensing Chain",
            type: "martial",
            shortDesc: "",
            longDesc: `Whenever you sicken a foe with pain using a spiked chain or whip, (whether by flensing, as a dirty trick combat maneuver, or otherwise), the victim must succeed at a Fortitude save (DC = 10 + 1/2 level + highest mental bonus) or be nauseated for the first round of the duration.`,
            prereq: "Way of the Flensing Chain",
        },
        {
            name: "Way of the Profane Chain",
            type: "martial",
            shortDesc: "",
            longDesc: `You can apply sickened to a creature that is already sickened, if you do you increase the penalty they are receiving from the sickened effect by -1, to a maximum of -4. For each 8 of your BAB, the penalty can be increased by an additional -1.`,
            prereq: "Master of the Flensing Chain",
        },
        {
            name: "Way of the Perfect Fist",
            type: "martial",
            shortDesc: "",
            longDesc: `[Divine Fighting Technique] You can take a -2 penalty on all attack rolls made with your unarmed strikes in order to deal the average amount of damage (rounded down) with each successful attack instead of rolling your weapon damage. For instance, if your unarmed strike would normally deal 1d4 points of weapon damage, you instead deal 2 points of weapon damage. Apply bonuses and modifiers to this result as if you had rolled your damage normally. You must choose to use this benefit before making an attack roll, and its effects last until your next turn. You do not average additional damage dice (such as those granted by a sneak attack) when using this ability.`,
            prereq: "",
        },
        {
            name: "Master of the Perfect Fist",
            type: "martial",
            shortDesc: "",
            longDesc: `You no longer take a -2 penalty on attack rolls with your unarmed strikes when you choose to deal the average amount of damage. If you critically hit a creature when using this ability, you automatically inflict maximum weapon damage for that critical hit (although you must still roll sneak attack dice or any other dice-based additional damage).`,
            prereq: "Way of the Perfect Fist",
        },
        {
            name: "Way of the Divine Fist",
            type: "martial",
            shortDesc: "",
            longDesc: `You now gain +1 to attack while dealing average damage. You can choose to also roll average on all additional dice, and they are also maximized on a critical hit, if you do you gain an additional +1 bonus to attack.`,
            prereq: "Master of the Perfect Fist",
        },
        {
            name: "Way of the Poisoned Lash",
            type: "martial",
            shortDesc: "",
            longDesc: `[Divine Fighting Technique] When you deal damage with a whip or spiked chain, your attack deals an additional 1d4 damage. Creatures immune to poison are also immune to this damage. As a movement action you can apply a poison to your lash, which deals 1 point of damage to strength, or dexterity, your choice, on a failed fortitude save dc=10+mental + bab/2, on your next successful attack.`,
            prereq: "",
        },
        {
            name: "Master of the Poisoned Lash",
            type: "martial",
            shortDesc: "",
            longDesc: `You now deal 3d4 damage with the benefit of Way of the Poisoned Lash. It is still poison damage. You can apply poison to your lash as a swift action instead of movement, and it deals 2 damage and can also deal damage to intelligence, or charisma.`,
            prereq: "Way of the Poisoned Lash",
        },
        {
            name: "Master of the Divine Poison Lash",
            type: "martial",
            shortDesc: "",
            longDesc: `You can now deal 1d4 + highest mental damage with the benefit of Way of the Poisoned Lash. It is still poison damage. You can apply poison to your lash as a swift action instead of movement and it lasts for the rest of your attacks in a round.`,
            prereq: "Master of the Poisoned Lash",
        },
        
        {
        name: "Dodge",
        type: "utility",
        shortDesc: "+1 dodge bonus to AC",
        longDesc: "You gain a +2 dodge bonus to your AC. A condition that makes you lose your Dex bonus to AC also makes you lose the benefits of this feat.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Double Slice",
        type: "martial",
        shortDesc: "Add your Str bonus to off-hand damage rolls",
        longDesc: "Add your full Strength bonus to damage rolls made with your off-hand weapon.",
        prereq: "",
        },
        {
        name: "Drag Down",
        type: "martial",
        shortDesc: "If tripped, you can attempt a trip against that foe",
        longDesc: "Whenever an opponent successfully trips you, you can attempt to trip that opponent as an immediate action.",
        prereq: "",
        },
        {
        name: "Improved Drag",
        type: "martial",
        shortDesc: "+2 bonus on drag attempts, no AOO",
        longDesc: "You do not provoke an attack of opportunity when performing a drag combat maneuver. In addition, you receive a +2 bonus on checks made to drag a foe. You also receive a +2 bonus to your Combat Maneuver Defense when an opponent tries to drag you.",
        prereq: "",
        },
        {
        name: "Greater Drag",
        type: "martial",
        shortDesc: "Enemies you drag provoke attacks of opportunity",
        longDesc: "You receive a +2 bonus on checks made to drag a foe. This bonus stacks with the bonus granted by Improved Drag. Whenever you drag a foe, his movement provokes attacks of opportunity from all of your allies (but not you).",
        prereq: "Improved Drag",
        },
        {
        name: "Elephant Stomp",
        type: "martial",
        shortDesc: "Combine an attack with a successful overrun.",
        longDesc: "When you overrun an opponent and your maneuver check exceeds your opponent's CMD by 5 or more, instead of moving through your opponent's space and knocking her prone, you may stop in the space directly in front of the opponent (or the nearest adjacent space) and make one attack with an unarmed strike or a natural weapon against that opponent as an immediate action.",
        prereq: "",
        },
        {
        name: "Elven Accuracy",
        type: "martial",
        shortDesc: "Reroll miss chance due to concealment when using a bow",
        longDesc: "If you miss due to concealment when making a ranged attack with a bow, you can reroll your miss chance roll one time to see if you actually hit.",
        prereq: "",
        perkRateUp:["Elf"]
        },
        {
        name: "Exceptional Pull",
        type: "martial",
        shortDesc: "When you wield a ranged weapon that you are proficient with and that has a strength rating, add 2 to the weapon's strength rating. You don't take a penalty on attack rolls for having a Strength modifier lower than the strength rating of a weapon, provided you're proficient with that weapon.",
        longDesc: "When wielding a bow to make a ranged attack and using strength to determine its damage you gain 1.5x your strength modifier to determine its damage.",
        prereq: "",
        key:true
        },
        {
        name: "Explosive Weapon",
        type: "magic",
        shortDesc: "As a standard action, you can cast a spell with an area of effect and a duration of instantaneous, such as fireball, and release it through your melee weapon as part of a melee attack. This functions as the magus spellstrike ability, except the spell damage does not multiply on a critical hit, the spell effect is centered on you, and you are excluded from its effects.",
        longDesc: "",
        prereq: "",
        },
        {
        name: "False Opening",
        type: "martial",
        shortDesc: "May choose to provoke attacks of opportunity; gain +4 AC vs. attacks",
        longDesc: "Choose a ranged weapon or a thrown weapon. When you make a ranged attack using that weapon and you would normally not provoke attacks of opportunity, you can choose to provoke an attack of opportunity from one or more opponents who threaten you. You gain a +4 dodge bonus against such attacks. An opponent that makes such an attack and misses you loses his Dexterity bonus to AC against you until the end of your turn.",
        prereq: "",
        },
        {
        name: "Far Shot",
        type: "martial",
        shortDesc: "Decrease ranged penalties by half",
        longDesc: "You only suffer a -1 penalty per full range increment between you and your target when using a ranged weapon.",
        prereq: "",
        },
        {
        name: "Feinting Flurry",
        type: "martial",
        shortDesc: "You can forgo your first attack in a flurry of blows action to make a Bluff check to feint instead.",
        longDesc: "While using flurry of blows to make melee attacks, you can forgo your first attack to make a Bluff check to feint.",
        prereq: "",
        perkPrereq:["Flurry of Blows"],
        },
        {
        name: "Greater Feint",
        type: "martial",
        shortDesc: "Enemies you feint lose their Dex bonus for 1 round",
        longDesc: "Whenever you use feint to cause an opponent to lose his Dexterity bonus, he loses that bonus until the beginning of your next turn, in addition to losing his Dexterity bonus against your next attack.",
        prereq: "Improved Feint",
        },
        {
        name: "Improved Feinting Flurry",
        type: "martial",
        shortDesc: "While using Feinting Flurry, if you successfully feint, your opponent is denied its Dexterity bonus to AC until the end of your turn.",
        longDesc: "While using Feinting Flurry, if you successfully feint, your opponent is denied its Dexterity bonus to AC until the end of your turn.",
        prereq: "Feinting Flurry",
        },
        {
        name: "Improved Feint",
        type: "martial",
        shortDesc: "Feint as a move action",
        longDesc: "You can make a Bluff check to feint in combat as a move action.",
        prereq: "",
        },
        {
        name: "Felling Escape",
        type: "martial",
        shortDesc: "Trip a foe when you break a grapple",
        longDesc: "When you break an opponent's grapple with a combat maneuver check or Escape Artist check, you can spend a swift action to make a trip attempt against that opponent.",
        prereq: "",
        },
        {
        name: "Felling Smash",
        type: "martial",
        shortDesc: "Trip a foe when you make a Power Attack",
        longDesc: "If you use the attack action to make a single melee attack at your highest base attack bonus while using Power Attack and you hit an opponent, you can spend a swift action to attempt a trip combat maneuver against that opponent.",
        prereq: "",
        },
        {
        name: "Ferocious Tenacity",
        type: "martial",
        shortDesc: "Negate some damage when it would otherwise kill you by expending rage points.",
        longDesc: "When raging, if you are hit by an attack that would deal enough hit points of damage to kill you (negative hit points equal to your Constitution score), as an immediate action you may expend 1 or more rounds of rage to negate some of this damage and keep yourself alive. Each round of rage you spend reduces the attack's damage by your raging Constitution bonus, but cannot reduce the damage taken below 1 hit point.",
        prereq: "",
        perkPrereq:["Rage", "Epic Rage"],
        },
        {
        name: "Flinging Charge",
        type: "marital",
        shortDesc: "Attack with a thrown weapon during a charge and then end the charge with a melee weapon attack",
        longDesc: "If you have a thrown weapon in hand when you begin charging, you can make a ranged attack with that weapon against the target of your charge at any point during your charge. You gain the +2 bonus for charging on the attack roll for this ranged attack. You can then immediately draw a melee weapon during your charge. You take a -5 penalty on the melee attack made at the end of the charge.",
        prereq: "",
        },
        {
        name: "Following Step",
        type: "martial",
        shortDesc: "Move up to 10 feet as an immediate action",
        longDesc: "When using the Step Up feat to follow an adjacent foe, you may move up to 10 feet. You may still take a 5-foot step during your next turn, and any movement you make using this feat does not subtract any distance from your movement during your next turn.",
        prereq: "Step Up",
        },
        {
        name: "Friendly Fire Maneuvers",
        type: "teamwork",
        shortDesc: "Allies who also have this feat cannot provide soft cover to enemies, allowing you to make attacks of opportunity against an enemy even if those allies grant you soft cover against that foe's attacks.",
        longDesc: "Allies who also have this feat cannot provide soft cover to enemies, allowing you to make attacks of opportunity against an enemy even if those allies grant you soft cover against that foe's attacks. If an ally who also has this feat casts a spell that targets the area you are in as it allows a Ref lex saving throw to avoid the effect (such as fireball), you gain a +4 dodge bonus on that saving throw.",
        prereq: "",
        },
        {
        name: "Furious Focus",
        type: "martial",
        shortDesc: "Do not take the Power Attack penalty on the first attack each round",
        longDesc: "When you are wielding a two-handed weapon or a one-handed weapon with two hands, and using the Power Attack feat, you do not suffer Power Attack's penalty on melee attack rolls on the first attack you make each turn. You still suffer the penalty on any additional attacks, including attacks of opportunity. Each time you gain these feat an additional attack per round does not receive the power attack penalty.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Fury's Fall",
        type: "martial",
        shortDesc: "Add your dexterity bonus to CMB with trip attacks.",
        longDesc: "When making a trip attack, add your Dexterity bonus to your CMB. If you're already using dexterity for your trip CMB you can add 1.5x dexterity modifier.",
        prereq: "",
        },
        {
        name: "Gang Up",
        type: "martial",
        shortDesc: "Flank an opponent if at least two allies are adjacent to it",
        longDesc: "You are considered to be flanking an opponent if you and at least two of your allies are threatening that opponent, regardless of your actual positioning.",
        prereq: "",
        key:true,
        },
        {
            name: "Merciless Beating",
            type: "martial",
            shortDesc: "Flank an opponent if at least two allies are adjacent to it",
            longDesc: "Whenever you and two or more allies threaten an opponent, you can choose to forgo your flanking bonus to grant each of your allies a +1 flanking bonus on their attack and damage rolls against the threatened creature. This bonus stacks with any flanking bonuses your allies might already have.",
            prereq: "Gang Up",
        },
        {
            name: "Moonlight Stalker",
            type: "martial",
            shortDesc: "Flank an opponent if at least two allies are adjacent to it",
            longDesc: "While you have concealment from an opponent, you gain a +2 bonus on attack and damage rolls against that opponent.",
            prereq: "",
        },
        {
            name: "Moonlight Stalker Feint",
            type: "martial",
            shortDesc: "Flank an opponent if at least two allies are adjacent to it",
            longDesc: "Once per round, against an opponent from whom you have concealment, you can spend a swift action to make a Bluff check to feint.",
            prereq: "Moonlight Stalker",
        },
        {
            name: "Moonlight Stalker Master",
            type: "martial",
            shortDesc: "Flank an opponent if at least two allies are adjacent to it",
            longDesc: "While you have concealment, your opponents' miss chance against you increases by 10%. If an opponent misses you due to your concealment, you can spend an immediate action to move 5 feet, this movement does not provoke attacks of opportunity and does not count as a 5-foot step.",
            prereq: "Moonlight Stalker Feint",
        },
        {
        name: "Underfoot",
        type: "martial",
        shortDesc: "Flank an opponent if at least two allies are adjacent to it",
        longDesc: "You receive a +4 dodge bonus on Acrobatics checks to move past opponents without provoking attacks of opportunity, so long as they are larger than you. In addition, you gain a +2 dodge bonus to Armor Class against attacks of opportunity caused when you move out of or within a larger opponent's threatened area",
        prereq: "",
        key:false,
        },
        {
        name: "Swift Aid",
        type: "martial",
        shortDesc: "Flank an opponent if at least two allies are adjacent to it",
        longDesc: "As a swift action, you can attempt the aid another action, however it only grants an ally a +1 instead of a +2 his next attack roll or bonus to his AC against the next attack against him.",
        prereq: "",
        key:false,
        },
        {
        name: "Team Up",
        type: "martial",
        shortDesc: "Flank an opponent if at least two allies are adjacent to it",
        longDesc: "When you and at least two of your allies are adjacent to an opponent, you can attempt the aid another action as a move action, and increase the bonus to aid another by +1.",
        prereq: "",
        key:false,
        },        
        {
        name: "Goblin Cleaver",
        type: "martial",
        shortDesc: "When using Cleave or Great Cleave, if your initial attack hits, you may take your additional attacks against any creature smaller than you that you threaten; your targets need not be adjacent to one another. Additional attacks you make against humanoids (goblinoid) gain a +2 circumstance bonus on attack rolls.",
        longDesc: "When using Cleave or Great Cleave, if your initial attack hits, you may take your additional attacks against any creature smaller than you that you threaten; your targets need not be adjacent to one another. Additional attacks you make against humanoids (goblinoid) gain a +2 circumstance bonus on attack rolls.",
        prereq: "Cleave",
        },
        {
        name: "Giant Killer",
        type: "martial",
        shortDesc: "This functions as Goblin Cleaver, but your additional attacks can be made against creatures one size category larger than you or smaller. In addition, any such attacks made against humanoids (giant) gain a +2 circumstance bonus on attack rolls.",
        longDesc: "This functions as Goblin Cleaver, but your additional attacks can be made against creatures one size category larger than you or smaller. In addition, any such attacks made against humanoids (giant) gain a +2 circumstance bonus on attack rolls.",
        prereq: "Goblin Cleaver",
        },
        {
        name: "Gore Fiend",
        type: "martial",
        shortDesc: "Regain spell points by dealing or suffering critical hits.",
        longDesc: "When you are raging and you confirm a critical hit with a melee weapon or suffer a critical hit yourself (whether by a melee weapon, spell, or ranged weapon), you regain spell points equal to the cost of 1 round of rage.",
        prereq: "",
        perkPrereq:["Rage", "Epic Rage"]
        },
        {
        name: "Got Your Back",
        type: "teamwork",
        shortDesc: "If you successfully use the aid another action to give an ally who also has this feat a +2 bonus to AC against an opponent's next attack, the ally is also not considered flanked or flat-footed against that opponent until the beginning of your next turn.",
        longDesc: "",
        prereq: "",
        },
        {
        name: "Improved Grapple",
        type: "martial",
        shortDesc: "+2 bonus on grapple attempts, no AOO",
        longDesc: "You do not provoke an attack of opportunity when performing a grapple combat maneuver. In addition, you receive a +2 bonus on checks made to grapple a foe. You also receive a +2 bonus to your Combat Maneuver Defense whenever an opponent tries to grapple you.",
        prereq: "",
        },
        {
        name: "Greater Grapple",
        type: "martial",
        shortDesc: "Maintain your grapple as a move action",
        longDesc: "You receive a +2 bonus on checks made to grapple a foe. This bonus stacks with the bonus granted by Improved Grapple. Once you have grappled a creature, maintaining the grapple is a move action. This feat allows you to make two grapple checks each round (to move, harm, or pin your opponent), but you are not required to make two checks. You only need to succeed at one of these checks to maintain the grapple.",
        prereq: "Improved Grapple",
        },
        {
        name: "Grasping Strike",
        type: "martial",
        shortDesc: "Entangle those you hit with Vital Strike",
        longDesc: "When you use Vital Strike (or Improved Vital Strike or Greater Vital Strike), you can spend 4 spell points to cause the foliage in the area to reach out and entangle your foe (as the condition) if it fails a Reflex save (DC = 10 + 1/2 your character level + highest mental modifier). The effect lasts for mental stat rounds or until the enemy breaks free with a successful Strength check or an Escape Artist check (DC = the effect's saving throw DC), whichever comes first. You can choose to use this ability as a free action after you hit the enemy with the attack. This is a supernatural ability.",
        prereq: "Vital Strike",
        },        
        {
        name: "Spring-Heeled Style",
        type: "style",
        shortDesc: "",
        longDesc: "If using this style any round you move at least 10 feet gain a +2 bonus on weapon attack rolls until the start of your next turn. While using this style if you have the feat mobility gain its benefits against attacks of opportunity for reloading or firing a ranged weapon.",
        prereq: "",
        },
        {
        name: "Spring-Heeled Sprint",
        type: "style",
        shortDesc: "",
        longDesc: "While using spring-heeled style you can move up to twice your speed when using the shot on the run or spring attack feats.",
        prereq: "Spring-Heeled Style",
        },
        {
        name: "Spring-Heeled Reaping",
        type: "style",
        shortDesc: "",
        longDesc: "While using spring-heeled style whenever you use the shot on the run or spring attack feats you can attack one additional time against a different target during your movement. The additional attack is made at your full attack bonus. Any creature you attack in melee with this feat cannot make attacks of opportunity against you for that movement as normal for spring attack.",
        prereq: "Spring-Heeled Sprint",
        },
        {
        name: "Grudge Fighter",
        type: "martial",
        shortDesc: "You gain a +1 morale bonus on attack and damage rolls made against any creature that attacked you in the current combat.",
        longDesc: "You gain a +1 morale bonus on attack and damage rolls made against any creature that attacked you in the current combat. This bonus increases by +1 every 6 levels",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Hammer the Gap",
        type: "martial",
        shortDesc: "With a full-attack action, each hit against the same opponent deals extra damage",
        longDesc: "When you take a full-attack action, each consecutive hit against the same opponent deals extra damage equal to the number of previous consecutive hits you have made against that opponent this turn. This damage is multiplied on a critical hit.",
        prereq: "",
        },
        {
        name: "Harrying Partners",
        type: "teamwork",
        shortDesc: "When you successfully use the aid another action to improve the Armor Class or attack roll of an ally who also has this feat, the benefit from aid another lasts until the beginning of your next turn.",
        longDesc: "When you successfully use the aid another action to improve the Armor Class or attack roll of an ally who also has this feat, the benefit from aid another lasts until the beginning of your next turn.",
        prereq: "",
        },
        {
        name: "Hex Strike",
        type: "magic",
        shortDesc: "Upon successful unarmed strike, you may use a hex",
        longDesc: "When you gain this feat, choose one hex that you can use to affect no more than one opponent. If you make a successful melee against an opponent, in addition to dealing your attack damage, you can use a swift action to deliver the effects of the chosen hex to that opponent. Doing so does not provoke attacks of opportunity.",
        prereq: "",
        perkPrereq:["Hexes", "Misfortune"],
        key:true,
        },
        {
        name: "Impact Critical Shot",
        type: "martial",
        shortDesc: "You can bull rush on a critical hit",
        longDesc: "Whenever you score a critical hit with a ranged attack, in addition to the normal damage your attack deals, if your confirmation roll exceeds your opponent's CMD, you can push your opponent back as if from the bull rush combat maneuver or knock that target prone as if from a trip combat maneuver. If you choose to bull rush, you cannot move with the target. Your maneuver does not provoke an attack of opportunity.",
        prereq: "",
        },
        {
        name: "Improved Initiative",
        type: "utility",
        shortDesc: "+4 bonus on initiative checks",
        longDesc: "You get a +4 bonus on initiative checks.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Low Blow",
        type: "martial",
        shortDesc: "Your bonus to confirm critical hits against opponents larger than yourself improves to +2. Furthermore, once per day, after you fail to hit with a critical hit confirmation roll, you can reroll the confirmation roll, but must take the new result even if it is worse.",
        longDesc: "Your gain a +2 bonus to confirm critical hits against creatures larger than you. Furthermore, once per day, after you fail to hit with a critical hit confirmation roll, you can reroll the confirmation roll, but must take the new result even if it is worse.",
        prereq: "",
        },
        {
        name: "Exploiting Strike",
        type: "martial",
        shortDesc: "",
        longDesc: "Whenever you attack a creature that has been successfully feinted within one round your attacks deal an additional 1d6 points of precision damage. This bonus damage increases by +1 every 4 levels.",
        prereq: "",
        },
        {
        name: "Devastating Vulnerability",
        type: "martial",
        shortDesc: "",
        longDesc: "Increase the damage you deal with Exploiting Strike by 1d6 for every 6 bab you have.",
        prereq: "Exploiting Strike",
        },
        {
        name: "Skewer",
        type: "martial",
        shortDesc: "",
        longDesc: "Once per turn you can spend bab/2 spell points to double the damage you deal with the prerequisite feats for 1 attack. You must declare using this before you make the attack.",
        prereq: "Devastating Vulnerability",
        },
        {
        name: "Improved Spring Attack",
        type: "martial",
        shortDesc: "When you use Spring Attack, you can select two targets to attack during your movement instead of one. The second attack made this way is made at your full base attack bonus - 5. All restrictions of Spring Attack apply to both targets, and your movement does not provoke attacks of opportunity from either target. You can't target the same creature twice.",
        longDesc: "",
        prereq: "Spring Attack",
        },
        {
            name: "Greater Spring Attack",
            type: "martial",
            shortDesc: "",
            longDesc: "When you use Spring Attack, you can select three targets to attack during your movement instead of one. The second attack made this way is made at your full base attack bonus - 5, and the third attack made this way is made at your full base attack bonus - 10. All restrictions of Spring Attack apply to each target, and your movement does not provoke attacks of opportunity from any of your targets. You can't target the same creature more than once.",
            prereq: "Improved Spring Attack",
        },
        {
        name: "Improved Swap Places",
        type: "teamwork",
        shortDesc: "When you use Swap Places, your ally can be smaller or larger and your movement does not provoke attacks of opportunity",
        longDesc: "When you and your ally use Swap Places, your ally can be up to one size larger or smaller than you, and your movement into the ally's square does not provoke an attack of opportunity. If your ally cannot fit into the space you had been occupying and there are no available adjacent squares to accommodate the rest of the ally's space, the ally must squeeze. Alternatively, as part of its movement, the ally can attempt a bull rush combat maneuver against a creature that occupies a space your ally would occupy, but this bull rush cannot move the creature more than 5 feet.",
        prereq: "Swap Places",
        },
        {
        name: "Improved Two-Weapon Feint",
        type: "martial",
        shortDesc: "Make a Bluff check instead of your first attack",
        longDesc: "While using Two-Weapon Fighting to make melee attacks, you can forgo your first primary-hand melee attack to make a Bluff check to feint an opponent. If you successfully feint, that opponent is denied his Dexterity bonus to AC until the end of your turn.",
        prereq: "Two-Weapon Feint",
        },
        {
        name: "In Harm's Way",
        type: "martial",
        shortDesc: "Take the damage of a successful attack upon an adjacent ally",
        longDesc: "While using the aid another action to improve an adjacent ally's AC, you can intercept a successful attack against that ally as an immediate action, taking full damage from that attack and any associated effects (bleed, poison, etc.). A creature cannot benefit from this feat more than once per attack.",
        prereq: "",
        },
        {
        name: "Intercept Charge",
        type: "teamwork",
        shortDesc: "Move up to your speed to intercept charging foe as an immediate action",
        longDesc: "When an opponent charges your ally with this feat, as an immediate action you can move up to your speed toward any square in the path of the charge. If you end your movement in the path of the charge, the opponent must stop when it becomes adjacent to you and then attack you instead of your ally. Your movement from using this feat counts toward your movement on your next turn.",
        prereq: "",
        },
        {
        name: "Intimidating Prowess",
        type: "martial",
        shortDesc: "Add Str to Intimidate in addition to Cha",
        longDesc: "Add your Strength modifier to Intimidate skill checks in addition to your Charisma modifier.",
        prereq: "",
        },
        {
            name: "Killing Flourish",
            type: "martial",
            shortDesc: "",
            longDesc: "When you reduce your target to below 0 hit points with a melee attack, as a swift action you can attempt an Intimidate check to demoralize all foes within 30 feet who can see your attack.",
            prereq: "",
        },
        {
            name: "Gruesome Slaughter",
            type: "martial",
            shortDesc: "",
            longDesc: "Creatures you demoralize by using the Killing Flourish feat must succeed at a Fortitude save (DC = 10 + 1/2 your character level + the higher of your Strength or Dexterity modifier) or become sickened for 1 minute.",
            prereq: "Killing Flourish",
        },
        {
        name: "Neckbreaker",
        type: "martial",
        shortDesc: "May deal Str or Dex damage to pinned opponent",
        longDesc: "If you have an opponent your size or smaller helpless or pinned, after you initiate or maintain a grapple, you can make a Stunning Fist attempt at a -5 penalty on the attack roll. If you succeed, you wrench that opponent's neck, dealing 2d6 Strength or Dexterity damage. If the targeted ability score is reduced to 0, any remaining damage is dealt to that opponent's Constitution score. A creature that is immune to critical hits or that has no discernible head and neck is immune to the effects of this feat.",
        prereq: "Stunning Fist",
        },
        {
            name: "Stunning Pin",
            type: "martial",
            shortDesc: "May deal Str or Dex damage to pinned opponent",
            longDesc: "Whenever you pin an opponent, you can spend a swift action to make a Stunning Fist attempt against that opponent.",
            prereq: "Stunning Fist",
        },
        {
        name: "Juke",
        type: "martial",
        shortDesc: "When an opponent charges you, you gain a +4 dodge bonus to your AC. If the charger's attack roll misses you and his movement ends while he is adjacent to you, you can switch places with the opponent as an immediate action, and he is considered to be flanked by you until the end of your next turn. You can't use the benefits of Juke if you ready an action to set a weapon with the brace special quality against a charging foe.",
        longDesc: "When an opponent charges you, you gain a +4 dodge bonus to your AC. If the charger's attack roll misses you and his movement ends while he is adjacent to you, you can switch places with the opponent as an immediate action, and he is considered to be flanked by you until the end of your next turn. You can't use the benefits of Juke if you ready an action to set a weapon with the brace special quality against a charging foe.",
        prereq: "",
        },
        {
        name: "Just out of Reach",
        type: "martial",
        shortDesc: "When a foe more than 5 ft. away from you makes a melee attack against you using reach, you gain a +4 dodge bonus to your AC against the attack.",
        longDesc: "",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Landing Roll",
        type: "utility",
        shortDesc: "If tripped, move 5 feet as an immediate action",
        longDesc: "If you are tripped, you can spend an immediate action to move 5 feet without provoking an attack of opportunity. This does not count as taking a 5-foot step. You fall prone after this movement.",
        prereq: "",
        },
        {
        name: "Leaping Evasion",
        type: "utility",
        shortDesc: "When you succeed at a Reflex save against a spell or effect that affects an area, as an immediate action you can attempt an Acrobatics check to jump out of the effect's area.",
        longDesc: "When you succeed at a Reflex save against a spell or effect that affects an area, as an immediate action you can attempt an Acrobatics check to jump out of the effect's area. You must move to the nearest space you can see outside of the affected area. The DC for this Acrobatics check is equal to the number of feet you must move to escape the area, and you can't travel farther than your normal movement. If you use this feat, you are staggered on your next turn. This movement doesn't provoke attacks of opportunity from creatures in the area of the effect you are escaping.",
        prereq: "",
        },
        {
        name: "Lightning Stance",
        type: "utility",
        shortDesc: "Gain 50% concealment if you move",
        longDesc: "If you take two actions to move or a withdraw action in a turn, you gain 50% concealment for 1 round.",
        prereq: "Wind Stance",
        },
        {
        name: "Lob Shot",
        type: "martial",
        shortDesc: "While making a ranged attack, you can ignore any cover bonuses to AC, including total cover, unless the target also has cover from above, such as a roof or forest canopy. When using this feat, treat your target as if it were one range increment farther away. You can't use this feat unless you have headroom equal to at least half the attack's range.",
        longDesc: "While making a ranged attack (not a spell), you can ignore any cover bonuses to AC, including total cover, unless the target also has cover from above, such as a roof or forest canopy. When using this feat, treat your target as if it were one range increment farther away. You can't use this feat unless you have headroom equal to at least half the attack's range.",
        prereq: "",
        },
        {
        name: "Low Profile",
        type: "utility",
        shortDesc: "+1 dodge bonus to AC against ranged attacks",
        longDesc: "You gain a +1 dodge bonus to AC against ranged attacks. In addition, you do not provide soft cover to creatures when ranged attacks pass through your square.",
        prereq: "",
        },
        {
        name: "Lunge",
        type: "martial",
        shortDesc: "Take a -2 penalty to your AC to attack with reach",
        longDesc: "You can increase the reach of your melee attacks by 5 feet until the end of your turn by taking a -2 penalty to your AC until your next turn. You must decide to use this ability before any attacks are made.",
        prereq: "",
        key:true,
        repeatable:true,
        },
        {
        name: "Mad Magic",
        type: "magic",
        shortDesc: "Magic is in your blood, allowing you to cast spells no matter how furious you become.",
        longDesc: "You can cast spells while raging without penalty, and you gain a +2 bonus to the save DCs of spells you cast while in rage.",
        prereq: "",
        perkPrereq:["Rage","Epic Rage"],
        key:true,
        },
        // {
        //     name: "Long Shot",
        //     type: "martial",
        //     shortDesc: "Shoot two arrows simultaneously",
        //     longDesc: "Increase the range increment of all ranged weapons by 30 feet. Increa all ranged weapons by 30 feet.",
        //     prereq: "",
        //     key:true,
        // },
        {
            name: "Manyshot",
            type: "martial",
            shortDesc: "Shoot two arrows simultaneously",
            longDesc: "When making a full-attack action with a bow, your first attack fires two arrows. If the attack hits, both arrows hit. Apply precision-based damage (such as sneak attack) and critical hit damage only once for this attack. Damage bonuses from using a composite bow with a high Strength bonus apply to each arrow, as do other damage bonuses, such as a ranger's favored enemy bonus. Damage reduction and resistances apply separately to each arrow.",
            prereq: "",
            key:true,
        },
        {
            name: "Greater Manyshot",
            type: "martial",
            shortDesc: "Shoot two arrows simultaneously",
            longDesc: "When making a full-attack action with a bow, your first and second attack two arrows.",
            prereq: "Manyshot",
            perkPrereq:["Ranged Training"]
        },
        {
        name: "Merciless Beating",
        type: "teamwork",
        shortDesc: "Whenever you and two or more allies threaten an opponent, you can choose to forgo your flanking bonus to grant each of your allies a +1 flanking bonus on their attack rolls against the threatened creature. This bonus stacks with any flanking bonuses your allies might already have.",
        longDesc: "Whenever you and two or more allies threaten an opponent, you can choose to forgo your flanking bonus to grant each of your allies a +1 flanking bonus on their attack rolls against the threatened creature. This bonus stacks with any flanking bonuses your allies might already have.",
        prereq: "",
        },        
        {
        name: "Missile Shield",
        type: "martial",
        shortDesc: "Deflect one ranged attack per round with shield",
        longDesc: "You must be using a shield with a base shield bonus of at least +2 to use this feat. Once per round when you would normally be hit with an attack from a ranged weapon (not including spell effects, natural attacks, or massive ranged weapons), you may def lect it so that you take no damage, as if you had the Def lect Arrows feat. You must be aware of the attack and not flat-footed.",
        prereq: "",
        },
        {
        name: "Mobility",
        type: "martial",
        shortDesc: "+4 AC against attacks of opportunity from movement",
        longDesc: "You get a +4 dodge bonus to Armor Class against attacks of opportunity caused when you move out of or within a threatened area. A condition that makes you lose your Dexterity bonus to Armor Class (if any) also makes you lose dodge bonuses. Dodge bonuses stack with each other, unlike most types of bonuses.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Monkey Lunge",
        type: "martial",
        shortDesc: "Use Lunge without suffering a penalty to AC.",
        longDesc: "you can use the Lunge feat to increase the reach of your melee attacks by 5 feet until the end of your turn, without suffering a penalty to your AC. You cannot use this feat if you carry a medium or heavy load.",
        prereq: "Lunge",
        },
        {
        name: "Nimble Striker",
        type: "martial",
        shortDesc: "You do not take a -2 penalty to AC when you use the Cleave feat, Lunge feat, or when you charge.",
        longDesc: "You do not take a -2 penalty to AC when you use the Cleave feat, Lunge feat, or when you charge.",
        prereq: "",
        },
        {
        name: "Open Up",
        type: "teamwork",
        shortDesc: "When you successfully use the aid another action to improve the next attack roll against an opponent by an ally who also has this feat, that attack also ignores any Armor Class bonus granted by the opponent's shield. This benefit affects only physical shields, not shield bonuses from spells or other sources.",
        longDesc: "When you successfully use the aid another action to improve the next attack roll against an opponent by an ally who also has this feat, that attack also ignores any Armor Class bonus granted by the opponent's shield. This benefit affects only physical shields, not shield bonuses from spells or other sources.",
        prereq: "",
        },
        {
        name: "Opening Volley",
        type: "martial",
        shortDesc: "Successful ranged attack grants +4 on next melee attack roll",
        longDesc: "Whenever you deal damage with a ranged attack, you gain a +4 circumstance bonus on the next melee attack roll you make against the opponent. This attack must occur before the end of your next turn.",
        prereq: "",
        },
        {
        name: "Osyluth Guile",
        type: "utility",
        shortDesc: "Get a bonus to your AC equal to Charisma modifier against one opponent.",
        longDesc: "While you are fighting defensively or using the total defense action, select one opponent. Add your highest mental bonus to your AC as a dodge bonus against that opponent's melee attacks until your next turn. You cannot use this feat if you cannot see the selected opponent.",
        prereq: "",
        },
        {
        name: "Outflank",
        type: "teamwork",
        shortDesc: "Double flanking bonuses with an ally",
        longDesc: "Whenever you and an ally who also has this feat are flanking the same creature, your flanking bonus on attack rolls increases to +4. In addition, whenever you score a critical hit against the flanked creature, it provokes an attack of opportunity from your ally.",
        prereq: "",
        },        
        {
        name: "Improved Outflank",
        type: "martial",
        shortDesc: "Double flanking bonuses with an ally",
        longDesc: "Whenever you and an ally who also has outflank are threatening the same foe, you are considered to be flanking that foe if you are adjacent to an unoccupied square from which you would be able to flank the foe with your ally.",
        prereq: "Outflank",
        },
        {
            name: "Drinking Buddies",
            type: "teamwork",
            shortDesc: "Double flanking bonuses with an ally",
            longDesc: "The action to feed an ally with this feat a potion reduces by one step, by default, a movement action if they are unable to take actions, or a standard if they are.",
            prereq: "",
        },
        {
        name: "Improved Overrun",
        type: "martial",
        shortDesc: "+2 bonus on overrun attempts, no AOO",
        longDesc: "You do not provoke an attack of opportunity when performing an overrun combat maneuver. In addition, you receive a +2 bonus on checks made to overrrun a foe. You also receive a +2 bonus to your Combat Maneuver Defense whenever an opponent tries to overrun you. Targets of your overrun attempt may not choose to avoid you.",
        prereq: "",
        },
        {
        name: "Greater Overrun",
        type: "martial",
        shortDesc: "Enemies you overrun provoke attacks of opportunity",
        longDesc: "You receive a +2 bonus on checks made to overrun a foe. This bonus stacks with the bonus granted by Improved Overrun. Whenever you overrun opponents, they provoke attacks of opportunity if they are knocked prone by your overrun.",
        prereq: "Improved Overrun",
        },
        {
        name: "Paired Opportunists",
        type: "teamwork",
        shortDesc: "Whenever you are adjacent to an ally who also has this feat, you receive a +4 circumstance bonus on attacks of opportunity against creatures that you both threaten. Enemies that provoke attacks of opportunity from your ally also provoke attacks of opportunity from you so long as you threaten them (even if the situation or an ability would normally deny you the AOO). This does not allow you to take more than one AOO against a creature for a given action.",
        longDesc: "Whenever you are adjacent to an ally who also has this feat, you receive a +4 circumstance bonus on attacks of opportunity against creatures that you both threaten. Enemies that provoke attacks of opportunity from your ally also provoke attacks of opportunity from you so long as you threaten them (even if the situation or an ability would normally deny you the attack of opportunity). This does not allow you to take more than one attack of opportunity against a creature for a given action.",
        prereq: "",
        },
        {
        name: "Parting Shot",
        type: "martial",
        shortDesc: "Make a ranged attack when withdrawing",
        longDesc: "Once per encounter, when using the withdraw action, you can make a single ranged attack at any point during your movement.",
        prereq: "",
        },
        {
        name: "Passing Trick",
        type: "martial",
        shortDesc: "Successful Acrobatics check allows you to feint",
        longDesc: "Whenever you make a successful Acrobatics check to move through an opponent's space, you can spend a swift action to make a Bluff check against that opponent to feint in combat.",
        prereq: "",
        },
        {
        name: "Penetrating Strike",
        type: "martial",
        shortDesc: "Your attacks ignore 5 points of damage reduction",
        longDesc: "Choose a class of weapon, while wielding it you can ignore up to 5 points of damage reduction. This feat does not apply to damage reduction without a type (such as DR 10/-).",
        prereq: "",
        },
        {
        name: "Greater Penetrating Strike",
        type: "martial",
        shortDesc: "Your attacks ignore 10 points of damage reduction",
        longDesc: "Your attacks made with weapons selected by penetrating strike ignore up to 10 points of damage reduction. This amount is reduced to 5 points for damage reduction without a type (such as DR 10/-).",
        prereq: "Penetrating Strike",
        },
        {
        name: "Perfect Strike",
        type: "martial",
        shortDesc: "Roll twice for unarmed strikes and take the better roll",
        longDesc: "You must declare that you are using this feat before you make your attack roll (thus a failed attack roll ruins the attempt). You must be using an unarmed strike to use this ability. You can roll your attack roll twice and take the higher result. If one of these rolls is a critical threat, the other roll is used as your confirmation roll (your choice if they are both critical threats). You can attempt a perfect strike no more than once per round, and it costs level spell points",
        prereq: "",
        },
        {
        name: "Pinpoint Targeting",
        type: "martial",
        shortDesc: "No armor or shield bonus on one ranged attack",
        longDesc: "As a standard action, make a single ranged attack. The target does not gain any armor, natural armor, or shield bonuses to its Armor Class. You do not gain the benefit of this feat if you move this round.",
        prereq: "",
        },
        {
        name: "Pin Down",
        type: "martial",
        shortDesc: "Opponents that take 5-foot step or withdraw provoke AOO from you",
        longDesc: "Whenever an opponent you threaten takes a 5-foot step or uses the withdraw action, that opponent provokes an attack of opportunity from you. If the attack hits, you deal no damage, but the targeted creature is prevented from making the move action that granted a 5-foot step or the withdraw action and does not move.",
        prereq: "",
        },
        {
        name: "Point-Blank Master",
        type: "martial",
        shortDesc: "You do not provoke attacks of opportunity while firing ranged weapons.",
        longDesc: "",
        prereq: "",
        },
        {
        name: "Point-Blank Shot",
        type: "martial",
        shortDesc: "+1 attack and damage on targets within 30 feet.",
        longDesc: "You get a +2 bonus on attack and damage rolls with ranged weapons at ranges of up to 30 feet.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Power Attack",
        type: "martial",
        key:true,
        shortDesc: "Trade melee attack bonus for damage.",
        longDesc: "You can choose to take a -1 penalty on all melee attack rolls and combat maneuver checks to gain a +2 bonus on all melee damage rolls. This bonus to damage is increased by half (+50%) if you are making an attack with a two-handed weapon, a one handed weapon using two hands, or a primary natural weapon that adds 1-1/2 times your Strength modif ier on damage rolls. This bonus to damage is halved (-50%) if you are making an attack with an off-hand weapon or secondary natural weapon. When your base attack bonus reaches +4, and every 4 points thereafter, the penalty increases by -1 and the bonus to damage increases by +2. You must choose to use this feat before making an attack roll, and its effects last until your next turn. The bonus damage does not apply to touch attacks or effects that do not deal hit point damage.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Precise Shot",
        type: "martial",
        key: true,
        shortDesc: "No penalty for shooting into melee.",
        longDesc: "You can shoot or throw ranged weapons at an opponent engaged in melee without taking the standard -4 penalty on your attack roll.",
        prereq: "",
        },
        {
        name: "Improved Precise Shot",
        type: "martial",
        shortDesc: "No cover or concealment chance on ranged attacks.",
        longDesc: "Your ranged attacks ignore the AC bonus granted to targets by anything less than total cover, and the miss chance granted to targets by anything less than total concealment. Total cover and total concealment provide their normal benefits against your ranged attacks.",
        prereq: "Precise Shot",
        },
        {
        name: "Precise Strike",
        type: "teamwork",
        shortDesc: "Deal +1d6 points of precision damage with melee attacks.",
        longDesc: "Whenever you and an ally who also has this feat are flanking the same the creature, you deal an additional 1d6 points of precision damage with each successful melee attack. This bonus damage stacks with other sources of precision damage, such as sneak attack. This bonus damage is not multiplied on a critical hit.",
        prereq: "",
        repeatable:true,
        },
        {
            name: "Improved Precise Strike",
            type: "teamwork",
            shortDesc: "Deal +1d6 points of precision damage with melee attacks.",
            longDesc: "Increase the damage you deal with precise strike by 1d6. Whenever you deal additional damage with Precise Strike, you also deal 2 points of bleed damage. This bleed damage does not stack with itself, but it increases by +1 for each additional d6 of precision damage your attacks deals as long as you also deal damage with precise strike.",
            prereq: "Precise Strike",
            repeatable:true,
        },
        {
        name: "Press to the Wall",
        type: "martial",
        shortDesc: "If you are the only character threatening an opponent, you can treat solid, immovable objects that occupy a square (such as columns, tree trunks, and walls) and are adjacent to that opponent as allies threatening the opponent when determining whether you flank the foe.",
        longDesc: "If you are the only character threatening an opponent, you can treat solid, immovable objects that occupy a square (such as columns, tree trunks, and walls) and are adjacent to that opponent as allies threatening the opponent when determining whether you flank the foe.",
        prereq: "",
        },
        {
        name: "Prone Shooter",
        type: "martial",
        shortDesc: "Take a reduced penalty to your AC against melee attacks while prone.",
        longDesc: "If you have been prone since the end of your last turn, the penalty to your Armor Class against melee attacks made against you is reduced to -2. In addition, the bonus to your Armor Class against ranged attacks made against you is increased to +6.",
        prereq: "",
        },
        {
        name: "Punishing Kick",
        type: "martial",
        shortDesc: "Knock down or push back foes with unarmed strikes.",
        longDesc: "You must declare that you are using this feat before you make your attack roll (thus a failed attack roll ruins the attempt). On a successful unarmed attack, the attack deals damage normally and you can choose to push your target 5 feet or attempt to knock them prone. If you decide to push the target, it is moved 5 feet directly away from you. This movement does not provoke attacks of opportunity, and the target must end this move in a safe space it can stand in. If you decide to attempt to knock the target prone, the target receives a Fortitude saving throw with a DC of 10 + 1/2 level + highest mental modifier to avoid the effect. It costs 2 + level/2 spell points to activate this ability, and you can activate it no more than once per round.",
        prereq: "",
        },
        {
        name: "Pursuit of Glory",
        type: "teamwork",
        shortDesc: "Gain a +2 morale bonus on one attack roll made as part of a charge if you start or end the charge adjacent to an ally",
        longDesc: "Whenever you start or end a charge attack in a space adjacent to an ally who also has this feat, you gain a +2 morale bonus on one attack roll you make as part of the charge. Furthermore, you can charge through a space containing an ally who also has this feat.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Pushing Assault",
        type: "martial",
        shortDesc: "Push a foe back with a two-handed weapon.",
        longDesc: "When you hit a creature your size or smaller with a two-handed weapon attack modified by the Power Attack feat, you can choose to push the target 5 feet directly away from you instead of dealing the extra damage from Power Attack. If you score a critical hit, you can instead push the target 10 feet directly away from you. This movement does not provoke attacks of opportunities, and the target must end this move in a safe space it can stand in. You choose which effect to apply after the attack roll has been made, but before the damage is rolled.",
        prereq: "",
        },
        {
        name: "Quick Bull Rush",
        type: "martial",
        shortDesc: "May bull rush in place of one of your melee attacks.",
        longDesc: "On your turn, you can perform a single bull rush combat maneuver in place of one of your melee attacks. You must choose the melee attack with the highest base attack bonus to make the bull rush.",
        prereq: "",
        },
        {
        name: "Quick Dirty Trick",
        type: "martial",
        shortDesc: "May perform a dirty trick in place of one of your melee attacks.",
        longDesc: "On your turn, you can perform a single dirty trick combat maneuver in place of one of your melee attacks. You must choose the melee attack with the highest base attack bonus to make the dirty trick combat maneuver.",
        prereq: "",
        },
        {
        name: "Quick Drag",
        type: "martial",
        shortDesc: "May perform a drag maneuver in place of one of your melee attacks.",
        longDesc: "On your turn, you can perform a single drag combat maneuver in place of one of your melee attacks. You must choose the melee attack with the highest base attack bonus to make the drag.",
        prereq: "",
        },
        {
        name: "Quick Draw",
        type: "martial",
        shortDesc: "Draw weapon as a free action.",
        longDesc: "You can draw a weapon as a free action instead of as a move action. You can draw a hidden weapon (see the Sleight of Hand skill) as a move action. A character who has selected this feat may throw weapons at his full normal rate of attacks (much like a character with a bow). Alchemical items, potions, scrolls, and wands cannot be drawn quickly using this feat.",
        prereq: "",
        key:true,
        },
        {
        name: "Improved Quick Draw",
        type: "martial",
        shortDesc: "Draw weapon as a free action.",
        longDesc: "You can draw items from your bag except potions as a swift action instead of as a movement action. Additionally, drawing items, including potions no longer provokes attacks of opportunity.",
        prereq: "Quick Draw",
        key:false,
        },
        {
        name: "Quick Reposition",
        type: "martial",
        shortDesc: "May reposition in place of one of your melee attacks.",
        longDesc: "On your turn, you can perform a single reposition combat maneuver in place of one of your melee attacks. You must choose the melee attack with the highest base attack bonus to make the reposition.",
        prereq: "",
        },
        {
        name: "Quiet Death",
        type: "martial",
        shortDesc: "Drop your foes before they make a sound",
        longDesc: "When you ambush an enemy or enemies that are unaware of your presence, you can roll a Stealth check with a -5 penalty. The result indicates the Perception DC to hear your attacks (rather than the normal DC of -10 to hear pitched combat) until an opponent's first action, when the DC returns to -10. Other enemies present can still see the attack; Quiet Death only prevents the sounds of battle from alerting further enemies.",
        prereq: "",
        },
        {
        name: "Ranged Disarm",
        type: "martial",
        shortDesc: "As a full-round action, you can attempt a disarm combat maneuver with any ranged weapon at a -2 penalty.",
        longDesc: "As a full-round action, you can attempt to perform a disarm combat maneuver with any ranged weapon at a -2 penalty. Add your Dexterity modifier to your CMB in place of your Strength modifier and apply range penalties to your combat maneuver check, doubling the penalties from range increments. If your target is more than 30 feet away, you take an additional -2 penalty. If the disarm attempt is successful, the target also takes damage as if you had made a successful attack with that weapon. You cannot be disarmed by failing this disarm attempt.",
        prereq: "",
        },
        {
        name: "Ranged Feint",
        type: "martial",
        shortDesc: "Feint with a ranged weapon",
        longDesc: "You can feint with a ranged weapon by throwing a thrown weapon or firing one arrow, bolt, bullet, or other piece of ammunition; this feint takes the same action as normal to feint, but depending on your weapon, you might have to reload or draw another weapon afterward. When you successfully use a ranged feint, you deny that enemy its Dexterity bonus to AC against your ranged attacks as well as your melee attacks for the same duration as normal. If your feints normally deny a foe its Dexterity bonus to AC against attacks other than your own, this applies only against others' melee attacks.",
        prereq: "",
        },
        {
        name: "Ranged Trip",
        type: "martial",
        shortDesc: "As a full-round action, you can attempt a trip combat maneuver with any ranged weapon at a -2 penalty.",
        longDesc: "As a full-round action, you can attempt to perform a trip combat maneuver with any ranged weapon at a -2 penalty. Add your Dexterity modifier to your CMB in place of your Strength modifier and apply range penalties to your combat maneuver check, doubling the penalties from range increments. If your target is more than 30 feet away, you take an additional -2 penalty. If the trip attempt is successful, the target also takes damage as if you had made a successful attack with that weapon. You can't be knocked prone by failing the trip attempt.",
        prereq: "",
        },
        {
        name: "Rapid Grappler",
        type: "martial",
        shortDesc: "Spend a swift action to make a combat maneuver check to grapple while using Greater Grapple.",
        longDesc: "Whenever you use Greater Grapple to successfully maintain a grapple as a move action, you can then spend a swift action to make a grapple combat maneuver check at a -5 penalty.",
        prereq: "Greater Grapple",
        },
        {
        name: "Rapid Reload",
        type: "martial",
        key: true,
        shortDesc: "Reload your weapon quickly.",
        longDesc: "Each ranged weapon has its reload time reduced, the specific amount given in items description. Reloading a crossbow or firearm still provokes attacks of opportunity. If the time it takes to fire a weapon is reduced to a free action, you may fire that weapon as many times in a full-attack action as you could attack if you were using a bow.",
        prereq: "",
        },
        {
            name: "High-speed Reload",
            type: "martial",
            shortDesc: "Reduce the reload action of crossbows and firearms by 1 additional step.",
            longDesc: "Reduce the reload action of crossbows and firearms by 1 additional step.",
            prereq: "Rapid Reload",
            perkPrereq:["Ranged Training"]
        },
        {
            name: "Incredible Reloading",
            type: "martial",
            shortDesc: "Reduce the reload action of crossbows and firearms by 1 additional step.",
            longDesc: "Reduce the reload action of crossbows and firearms by 1 additional step.",
            prereq: "High-speed Reload",
            perkPrereq:["Ranged Training"]
        },
        {
            name: "Tech Sniper",
            type: "martial",
            shortDesc: "Reduce the reload action of crossbows and firearms by 1 additional step.",
            longDesc: "With firearms you increase their range increment by 20 feet. With crossbows, when you make an attack against a target within 20 feet, the attack is resolved as a touch attack, like with a firearm.",
            prereq: "Rapid Reload",
            perkPrereq:["Ranged Training"]
        },
        {
            name: "Rapid Shot",
            type: "martial",
            shortDesc: "Make one extra ranged attack.",
            longDesc: "When making a full-attack action with a ranged weapon, you can fire one additional time this round at your highest bonus. All of your attack rolls take a -2 penalty when using Rapid Shot.",
            prereq: "",
            key:true,
            repeatable:true,
        },
        {
            name: "Greater Rapid Shot",
            type: "martial",
            shortDesc: "Make one extra ranged attack.",
            longDesc: "When making a full-attack action with a ranged weapon, you can choose to either give all ranged attacks this round +2 bonus on their attacks, or fire one additional attack this round at your highest bonus.",
            prereq: "Rapid Shot",
            perkPrereq:["Ranged Training"],
        },
        {
        name: "Rat Catcher",
        type: "martial",
        shortDesc: "You gain a +1 dodge bonus against attacks made by creatures at least two size categories smaller than yourself, and gain a +1 bonus to attack and damage rolls against such creatures. Additionally, you take only half damage from swarm attacks, and as a full-round action can make a single attack with a natural or bludgeoning weapon against an adjacent swarm. If the attack hits, you deal half damage to the target, even if the swarm is small enough to normally be immune to such attacks.",
        longDesc: "You gain a +1 dodge bonus against attacks made by creatures at least two size categories smaller than yourself, and gain a +1 bonus to attack and damage rolls against such creatures. Additionally, you take only half damage from swarm attacks, and as a full-round action can make a single attack with a natural or bludgeoning weapon against an adjacent swarm. If the attack hits, you deal half damage to the target, even if the swarm is small enough to normally be immune to such attacks.",
        prereq: "",
        },
        {
        name: "Ray Shield",
        type: "martial",
        shortDesc: "Deflect one ranged touch attack per round with shield.",
        longDesc: "You must be using a shield with a +2 base shield bonus to use this feat. Once per round when you would normally be hit with a ranged touch attack (including rays and similar magical effects), you may def lect it so that you take no damage from it. Your shield suffers the full effects of the spell or effect, if applicable.",
        prereq: "",
        key:true,
        },
        {
        name: "Reckless Aim",
        type: "martial",
        shortDesc: "Take a -1 penalty to AC and gain a +2 competence bonus on attack roll with a ranged attack against opponent engaged in melee. If you roll a natural 1 the attack, you hit a random adjacent creature threatening the target instead.",
        longDesc: "When you shoot or throw ranged weapons at an opponent engaged in melee, you can choose to take a -1 penalty to your AC and gain a +2 competence bonus on your attack roll. However, when you roll a natural 1 on a ranged attack roll made with this bonus, you automatically hit a random adjacent creature that threatens your intended target. Or if using friendly fire rules instead if you miss by 8 or more you hit a friendly target engaged in melee with the target.",
        prereq: "",
        },
        {
        name: "Redirect Attack",
        type: "martial",
        shortDesc: "Once per turn, when an opponent only you threaten fails an attack against you, you can redirect the attack to target another foe. The new target must be adjacent to you and within reach of the opponent that missed you. Attempt a combat maneuver check; if the result exceeds both the Combat Maneuver Defense of the opponent who missed you and the Armor Class of the new target, the attack strikes and deals its normal damage.",
        longDesc: "Once per turn, when an opponent only you threaten fails an attack against you, you can redirect the attack to target another foe. The new target must be adjacent to you and within reach of the opponent that missed you. Attempt a combat maneuver check; if the result exceeds both the Combat Maneuver Defense of the opponent who missed you and the Armor Class of the new target, the attack strikes and deals its normal damage.",
        prereq: "",
        },
        {
        name: "Relentless Shot",
        type: "martial",
        shortDesc: "When you trip an opponent within 30 feet with a ranged attack, you also threaten that opponent until your next turn and you can make attacks of opportunity against that opponent with ranged weapons.",
        longDesc: "When you successfully trip an opponent within 30 feet with a ranged attack, you threaten that opponent until your next turn. You can make attacks of opportunity against that opponent with ranged weapons. This effect ends if you attack another target or the opponent moves from its current square.",
        prereq: "",
        },
        {
        name: "Rending Fury",
        type: "martial",
        shortDesc: "Need half the normal number of attacks to deal rend damage.",
        longDesc: "Your first rend in a turn only requires you hit half the normal attacks. This does not grant you the ability to rend an additional time per round.",
        prereq: "",
        },
        {
        name: "Improved Rending Fury",
        type: "martial",
        shortDesc: "Deal extra damage on a successful rend.",
        longDesc: "Whenever you successfully rend an opponent, you deal an extra 1d6 damage. This damage is not multiplied on a critical hit.",
        prereq: "Rending Fury",
        repeatable:true,
        },
        {
        name: "Greater Rending Fury",
        type: "martial",
        shortDesc: "When you rend an opponent, you deal bleed damage.",
        longDesc: "Whenever you rend an opponent, you deal 1d6 bleed damage to that opponent. This is an addition to the effects of the rend. Each time you rend a creature another time you increase this bleed damage by +1.",
        prereq: "Improved Rending Fury",
        },
        {
        name: "Improved Reposition",
        type: "martial",
        shortDesc: "+2 bonus on reposition attempts, no AOO.",
        longDesc: "You do not provoke an attack of opportunity when performing a reposition combat maneuver. In addition, you receive a +2 bonus on checks made to reposition a foe. You also receive a +2 bonus to your Combat Maneuver Defense when an opponent tries to reposition you.",
        prereq: "",
        },
        {
        name: "Greater Reposition",
        type: "martial",
        shortDesc: "Enemies you reposition provoke attacks of opportunity.",
        longDesc: "You receive a +2 bonus on checks made to reposition a foe. This bonus stacks with the bonus granted by Improved Reposition. Whenever you reposition a foe, his movement provokes attacks of opportunity from all of your allies (but not you).",
        prereq: "Improved Reposition",
        },
        {
        name: "Repositioning Strike",
        type: "martial",
        shortDesc: "Attempt a reposition attack on a successful critical hit.",
        longDesc: "Whenever you score a critical hit with a melee attack, you can move your opponent, in addition to the normal damage dealt by the attack. If your confirmation roll exceeds your opponent's CMD, you may move your opponent as if from the reposition combat maneuver. This provokes as normal.",
        prereq: "",
        },
        {
        name: "Tactical Reposition",
        type: "martial",
        shortDesc: "You can reposition a foe into a dangerous space such as a pit or blade barrier.",
        longDesc: "When making a reposition combat maneuver, you can move an enemy into a trap or other hazardous area, such as a pit, wall scythe, or blade barrier. When you do so, the moved enemy is treated as though it had activated the trap or triggered the hazard, and it takes a -2 penalty to AC and on saving throws to mitigate the trap or hazard's effects.",
        prereq: "",
        },
        {
        name: "Returning Throw",
        type: "teamwork",
        shortDesc: "When an ally misses with a thrown weapon attack, you can catch the weapon and use it to attack the original target",
        longDesc: "Whenever an ally who also has this feat makes an attack with a thrown weapon and misses the target by 4 or less, you can catch the weapon as an immediate action. Both you and your ally must be within 30 feet of the target, and you must be able to trace a line from any part of your space to any part of your ally's space so that the line passes through the target's space. As part of the action to catch the weapon, you can throw it at the target of the original attack. If your target has never seen you perform this maneuver before, it is denied its Dexterity bonus to AC against your attack. You must have at least one hand free to use this feat. You must be aware of the attack and not flat-footed.",
        prereq: "",
        },
        {
        name: "Reverse-Feint",
        type: "martial",
        shortDesc: "As a move action, you can leave a gap in your defenses for one adjacent opponent to use. If the opponent attacks you on its next turn, it gains a +4 bonus on its attack roll. Whether or not the opponent successfully hits, you may attack it as an immediate action with a single melee attack, gaining a +2 bonus on your attack roll.",
        longDesc: "As a move action, you can leave a gap in your defenses for one adjacent opponent to use. If the opponent attacks you on its next turn, it gains a +4 bonus on its attack roll. Whether or not the opponent successfully hits, you may attack it as an immediate action with a single melee attack, gaining a +2 bonus on your attack roll.",
        prereq: "",
        },
        {
        name: "Riptide Attack",
        type: "martial",
        shortDesc: "You may automatically drag a tripped target as a swift action.",
        longDesc: "Whenever you succeed at a trip combat maneuver, you can automatically attempt a drag combat maneuver against your tripped target as a swift action.",
        prereq: "",
        },
        {
        name: "Risky Striker",
        type: "martial",
        shortDesc: "You can choose to take a -1 penalty to AC to gain a +2 bonus on melee damage rolls against creatures two or more size categories larger than you. When your BAB reaches +4 and every four levels thereafter, the damage increases by 2. The bonus damage is multiplied in the case of a critical hit. You can only choose to use this feat when you declare that you are making an attack action or a full-attack action with a melee weapon. The effects last until your next turn.",
        longDesc: "You can choose to take a -1 penalty to AC to gain a +2 bonus on melee damage rolls against creatures two or more size categories larger than you. When your base attack bonus reaches +4 and every 4 levels thereafter, the penalty increases by -1 and the damage bonus increases by 2. The bonus damage is multiplied in the case of a critical hit. You can only choose to use this feat when you declare that you are making an attack action or a full-attack action with a melee weapon. The effects last until your next turn.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Riving Strike",
        type: "magic",
        shortDesc: "Those damaged by your Arcane Strike take a penalty on saves against spells and spell-like abilities.",
        longDesc: "If you have a weapon that is augmented by your Arcane Strike feat, when you damage a creature with an attack made with that weapon, that creature takes a -2 penalty on saving throws against spells and spell-like abilities. This effect lasts for 1 round.",
        prereq: "Arcane Strike",
        },
        {
            name: "Spell Cartridges",
            type: "martial",
            shortDesc: "",
            longDesc: "While your gun is imbued with power from the Arcane Strike feat, you can fire force bullets instead of regular ammunition. A force bullet deals 1d4 points of force damage for every four levels you have. Force bullets do not use black powder or ammunition and count as magic for the purpose of bypassing damage reduction. You still must reload to fire your gun as normal.",
            prereq: "Arcane Strike",
        },
        {
            name: "Deadly Charge",
            type: "martial",
            shortDesc: "",
            longDesc: "When you charge and move at least your movement speed your first attack on the charge deals additional damage equal to your BAB. Attacks with lances instead deal double damage.",
            prereq: "",
        },
        {
            name: "Spirited Charge",
            type: "martial",
            shortDesc: "",
            longDesc: "When you charge and move at least your movement speed, instead of dealing bonus damage equal to your BAB, you can instead deal double damage. If you are wielding a lance it instead deals triple damage.",
            prereq: "Deadly Charge",
        },
        {
            name: "Sprightly Armor",
            type: "utility",
            shortDesc: "",
            longDesc: "You add your armor's total enhancement bonus as a bonus on your initiative checks.",
            prereq: "",
        },
        {
            name: "Strike True",
            type: "martial",
            shortDesc: "",
            longDesc: "You can focus yourself as a move action. When focused, you gain a +4 bonus on your next melee attack roll before the end of your turn.",
            prereq: "",
        },
        {
        name: "Gun Twirling",
        type: "martial",
        shortDesc: "",
        longDesc: "You can reload firearms and crossbows even if you don't have a hand free as long as your hands are not restrained, and you're not grappled.",
        prereq: "",
        },
        {
        name: "Roll With It",
        type: "martial",
        shortDesc: "Reduce damage you take from an attack and get tossed aside.",
        longDesc: "If you are struck by a melee weapon you can try to convert some or all of that damage into movement that sends you off in an uncontrolled bouncing roll. When doing so you must make an Acrobatics check as an immediate action, reducing the damage from the actual attack equal to the total of your roll -5, and instead convert that damage into movement with each point equating to 1 foot of movement. If this movement would make you strike an object or creature of your size or larger, the movement immediately ends, you take 1d4 points of damage, and fall prone in that square. This involuntary movement provokes attacks of opportunity normally if you move through threatened squares, but does not provoke an attack of opportunity from the creature that struck you in the first place. You are staggered for 1 round after you attempt to use this feat, whether or not you succeed.",
        prereq: "",
        },
        {
        name: "Ruthless Opportunist",
        type: "teamwork",
        shortDesc: "When an ally with this feat hits a foe using an AOO, gain +2 on attacks against that foe for 1 round",
        longDesc: "When an ally with this feat hits with an attack of opportunity against an enemy both you and that ally are threatening, you gain a +2 circumstance bonus on your melee attack rolls against that enemy for 1 round.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Saving Shield",
        type: "martial",
        shortDesc: "Grant shield bonus to an adjacent ally.",
        longDesc: "Whenever an adjacent ally is the target of an attack, you can, as an immediate action, grant that adjacent ally a +2 shield bonus to AC. You must be wielding a shield, but not a buckler to use this feat.",
        prereq: "",
        },
        {
        name: "Second Chance",
        type: "martial",
        shortDesc: "Exchange later attacks to reroll missed first attack.",
        longDesc: "When making a full attack, if you miss on your first attack, you can forgo making any other attacks for the rest of your turn to reroll that attack at your highest base attack bonus.",
        prereq: "",
        },
        {
        name: "Second Chance, Improved",
        type: "martial",
        shortDesc: "Take a -5 penalty on later attacks to reroll missed attack.",
        longDesc: "When you reroll a missed attack using the Second Chance feat, you can still make the rest of your attacks that turn, albeit at a -5 penalty to each attack.",
        prereq: "Second Chance",
        },
        {
        name: "Shatter Defenses",
        type: "martial",
        shortDesc: "Hindered foes are flat-footed.",
        longDesc: "Any shaken, frightened, or panicked opponent hit by you this round is flat-footed to your attacks until the end of your next turn. This includes any additional attacks you make this round.",
        prereq: "",
        },
        {
        name: "Shatterspell",
        type: "martial",
        shortDesc: "As a standard action, you can attempt to sunder an ongoing spell effect as if you had the spell sunder rage power. You may use this feat once per day, plus one additional time per day for every 5 points by which your BAB exceeds +10.",
        longDesc: "As a standard action for 6 + level/2 spell points, you can attempt to sunder an ongoing spell effect by succeeding at a combat maneuver check. For any effect other than one on a creature, you must make a combat maneuver check against a CMD of 15 plus the effect's caster level. To sunder an effect on a creature, you must succeed at a normal sunder combat maneuver against the creature's CMD + 5, ignoring any miss chance caused by a spell or spell-like ability. If successful, you suppress the effect for 1 round, or 2 rounds if you exceeded the CMD by 5 to 9. If you exceeds the CMD by 10 or more, the effect is dispelled.",
        prereq: "",
        },
        {
        name: "Shield Bash, Improved",
        type: "martial",
        shortDesc: "Keep your shield bonus when shield bashing.",
        longDesc: "When you perform a shield bash, you may still apply the shield's shield bonus to your AC.",
        prereq: "",
        },
        {
        name: "Shield Focus",
        type: "martial",
        shortDesc: "Gain a +1 bonus to your AC when using a shield.",
        longDesc: "Increase the AC bonus granted by any shield you are using by +1.",
        prereq: "",
        },
        {
        name: "Improved Shield Focus",
        type: "martial",
        shortDesc: "You reduce the armor check penalty of any shield you are using by 1. You also use your character level in place of your BAB for the purpose of shield mastery feat prerequisites.",
        longDesc: "You reduce the armor check penalty of any shield you are using by 1 and increase the its shield bonus to armor class by +1",
        prereq: "Shield Focus",        
        },
        {
        name: "Greater Shield Focus",
        type: "martial",
        shortDesc: "Gain a +1 bonus to your AC when using a shield.",
        longDesc: "Increase the AC bonus granted by any shield you are using by 2.",
        prereq: "Improved Shield Focus",
        repeatable:true,
        },
        {
            name: "Shield Master",
            type: "martial",
            shortDesc: "No two-weapon penalties when attacking with a shield.",
            longDesc: "You do not suffer any Two-Weapon Fighting penalties on attack rolls made with a shield while you are wielding another weapon, or a tower shields penalty to attack rolls. Add your shield's highest enhancement bonus to attacks and damage rolls made with the shield as if it was a weapon enhancement bonus.",
            prereq: "",
        },
        {
            name: "Shield Grandmaster",
            type: "martial",
            shortDesc: "No two-weapon penalties when attacking with a shield.",
            longDesc: "You can add your shield's entire enhancement bonus to attacks and damage rolls made with the shield as if it was a weapon enhancement bonus.",
            prereq: "Shield Master",
        },
        {
        name: "Shield of Swings",
        type: "martial",
        shortDesc: "Reduce damage with a two handed weapon to gain a +4 shield bonus.",
        longDesc: "When you take a full-attack action while wielding a two-handed weapon, you can choose to reduce the damage by 1/2 to gain a +4 shield bonus to AC and CMD until the beginning of your next turn. The reduction in damage applies until the beginning of your next turn. The shield bonus to AC and CMD increases by +1 for every 5 of your bab.",
        prereq: "",
        },
        {
        name: "Shield Specialization",
        type: "martial",
        shortDesc: "+2 bonus to AC against criticals with one type of shield.",
        longDesc: "While wielding a shield you gain a +3 bonus to your Armor Class against critical hit confirmation rolls. In addition, you may add your base shield bonus (including the bonus from Shield Focus but not including enhancement bonuses) to your CMD.",
        prereq: "",
        },
        {
        name: "Greater Shield Specialization",
        type: "martial",
        shortDesc: "+2 bonus to AC against criticals, and negate critical hit once per day.",
        longDesc: "While wielding a shield you gain a +3 bonus to your Armor Class against critical hit confirmation rolls (this bonus stacks with that from Shield Specialization). In addition, once per day you may negate a critical hit, and damage is instead rolled normally.",
        prereq: "Shield Specialization",
        repeatable:true,
        },
        {
        name: "Shield Slam",
        type: "martial",
        shortDesc: "Free bull rush with a bash attack",
        longDesc: "Any opponents hit by your shield bash are also hit with a free bull rush attack, substituting your attack roll for the combat maneuver check. This bull rush does not provoke an attack of opportunity. Opponents who cannot move back due to a wall or other surface are knocked prone after moving the maximum possible distance. You may choose to move with your target if you are able to take a 5-foot step or to spend an action to move this turn.",
        prereq: "",
        },
        {
        name: "Defended Movement",
        type: "martial",
        shortDesc: "You gain a +2 bonus to your AC against attacks of opportunity.",
        longDesc: "You gain a +2 bonus to your AC against attacks of opportunity.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Greater Ray Shield",
        type: "martial",
        shortDesc: "When you use the Ray Shield feat, your shield is not affected by the deflected ranged touch attack.",
        longDesc: "When you use the Ray Shield feat, your shield is not affected by the deflected ranged touch attack.",
        prereq: "Ray Shield",
        },
        {
        name: "Guarded Charge",
        type: "martial",
        shortDesc: "When performing a bull rush or overrun combat maneuver as part of a charge, you don't provoke an attack of opportunity for that maneuver. If you already have the Improved Bull Rush or Improved Overrun feats, you gain an additional +2 bonus on your combat maneuver check when attempting the respective maneuver.",
        longDesc: "When performing a bull rush or overrun combat maneuver as part of a charge, you don't provoke an attack of opportunity for that maneuver. If you already have the Improved Bull Rush or Improved Overrun feats, you gain an additional +2 bonus on your combat maneuver check when attempting the respective maneuver.",
        prereq: "",
        },
        {
        name: "Shield Brace",
        type: "martial",
        shortDesc: "You can use a two-handed weapon sized appropriately for you from the polearm or spears weapon group while also using a shield. The shield's armor check penalty (if any) applies to attacks made with the weapon.",
        longDesc: "",
        prereq: "",
        key:true,
        },
        // {
        // name: "Shielded Mage",
        // type: "magic",
        // shortDesc: "You reduce the arcane spell failure of any shield you use by 15% (to a minimum of 0%). Using a shield does not prevent you from completing somatic spell components with the hand wielding the shield.",
        // longDesc: "You reduce the arcane spell failure of any shield you use by 15% (to a minimum of 0%). Using a shield does not prevent you from completing somatic spell components with the hand wielding the shield.",
        // prereq: "",
        // },
        {
        name: "Shielded Stand",
        type: "martial",
        shortDesc: "As a swift action, you can prevent yourself or an adjacent ally from provoking an attack of opportunity when standing from prone or when picking up an object from the ground.",
        longDesc: "As a swift action, you can prevent yourself or an adjacent ally from provoking an attack of opportunity when standing from prone or when picking up an object from the ground.",
        prereq: "",
        key:true,
        },
        {
        name: "Stumbling Bash",
        type: "martial",
        shortDesc: "Creatures struck by your shield bash take a -2 penalty to their AC until the end of your next turn.",
        longDesc: "Creatures struck by your shield bash take a -2 penalty to their AC until the end of your next turn.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Toppling Bash",
        type: "martial",
        shortDesc: "",
        longDesc: "As a swift action when you hit a creature with a shield bash, you can attempt a trip combat maneuver against that creature at a -5 penalty. This does not provoke an attack of opportunity, and if your attempt fails by 10 or more, you are not knocked prone.",
        prereq: "",
        },
        {
            name: "Flumefire Rage",
            type: "magic",
            shortDesc: "",
            longDesc: "When casting an elemental damage spell you can increase the damage by +1 damage per dice, if you do you must succeed at a fortitude save DC 15 + 2x the spells level or you become fatigued. You cannot use this feat while fatigued (or worse) or if you cannot become fatigued. If you are raging, such as through the rage perk or spell, this damage increases to +2 points per die and you roll twice when attempting the fortitude save and take the better result.",
            prereq: "",
        },
        {
            name: "Dueling Dodge",
            type: "utility",
            shortDesc: "",
            longDesc: "When you are targeted by an attack or something that would cause a reflex save, you can spend an immediate action to get a +4 circumstance bonus to your armor class against that triggering attack or the reflex save. After activating this you take a -2 penalty to your armor class and reflex saves until the start of your next turn.",
            prereq: "",
            key:true,
        },
        {
            name: "Dueling Parry",
            type: "martial",
            shortDesc: "",
            longDesc: "When you are the target of a melee or ranged weapon attack, you can as an immediate action attempt to parry it. Make an attack roll with the weapon you are wielding at a -5 penalty, if your attack roll is higher than your opponents the attack misses. You take a -4 penalty to this if you are using an unarmed weapon. If you have a perk or feat that allows you to make a parry such as parry and riposte or Aldori Aegis you can use this feat once per round without expending an immediate action.",
            prereq: "",
            key:true,
        },
        {
            name: "Dueling Resolve",
            type: "martial",
            shortDesc: "",
            longDesc: `When you fail a fortitude or will saving throw, or are brought below 0 hit points, you can use dueling resolve as an immediate action, you can attempt another saving throw, using the same bonus. If this second saving throw is a success, the spell or effect prompting the saving throw does not take effect until the end of his next turn, and the duration is increased by 1 round. if you are reduced to fewer than 0 hit points (but not slain), you do not fall unconscious or gain the staggered condition, and can act normally until the end of your next turn, at which point you becomes staggered or unconscious based on your current hit points.
            If, by the end of your next turn, the spell or effect ends or you are brought to above 0 hit points, you are fatigued, but otherwise suffers no ill effect. A character can only use this feat once per combat.`,
            prereq: "",
            key:true,
        },
        {
            name: "Falling Water Gambit",
            type: "martial",
            shortDesc: "",
            longDesc: "When attacking a creature denied its Dexterity bonus to AC because of your successful feint, you increase the threat range of your attacks with one handed blades by +1, and gain a +2 bonus on attack rolls to confirm critical hits. If you have either the Dueling Dodge or Dueling Parry feat, if you successfully use one of them you can make an attack of opportunity against the foe who attacked you if that foe is shaken, frightened, or panicked. To gain these benefits, you must be wielding only a one handed sword (not using a shield, an off-hand weapon, armor spikes, unarmed strikes, or natural weapons).",
            prereq: "",
        },
        {
            name: "Fearsome Barricade",
            type: "utility",
            shortDesc: "",
            longDesc: "Choose an adjacent ally as a free action on your turn. Once per round, when an opponent attacks that ally, you may make an Intimidate check to demoralize the opponent as an immediate action.",
            prereq: "",
        },
        {
            name: "Final Embrace",
            type: "martial",
            shortDesc: "",
            longDesc: "You gain the constrict special ability with damage equal to to your unarmed strike or a primary natural weapon. You can grapple creatures one size larger than you normally could.",
            prereq: "",
        },
        {
            name: "Final Embrace Horror",
            type: "martial",
            shortDesc: "",
            longDesc: "A creature that takes damage from your constrict attack is also shaken until the start of your next turn.",
            prereq: "Final Embrace",
        },
        {
            name: "Final Embrace Master",
            type: "martial",
            shortDesc: "",
            longDesc: "Double the number of damage dice for your constrict special attack, as if you had used vital strike.",
            prereq: "Final Embrace Horror",
        },
        {
            name: "Final Embrace Death Grab",
            type: "martial",
            shortDesc: "",
            longDesc: "When making a full round attack with natural weapons or unarmed strikes, your first attack in a round that is with such a weapon gains the grab special ability.",
            prereq: "Final Embrace Master",
        },
        {
            name: "Snatch and Drop",
            type: "martial",
            shortDesc: "",
            longDesc: "Once per round when you succeed on a grapple check to initiate a grapple you can as a free action move up to half your remaining movement speed, and then let go of the target of the grapple. Moving a creature this way requires another successful CMB check against the creature (which doesn't provoke). Any bonuses to drag or reposition apply this check. You cannot use this feat on a creature that weighs more than your heavy load.",
            prereq: "",
        },
        {
            name: "Fling",
            type: "martial",
            shortDesc: "",
            longDesc: "When move a creature with snatch and drop, you can at the end of the movement fling your target at at another target at the end of your movement. To do this you make a CMB check against the creature to determine how far you can fling it with a +5 bonus, any bonuses to bullrush apply to this, if you succeed make a ranged touch attack against another target within range, if you hit you deal damage to both the creature and the target as if a creature two sizes larger than the flung creature had used a slam attack (1d8) plus your strength modifier. The flung creature lands prone in a space adjacent to the target, and the target must also succeed a reflex save (dc=10+damage dealt) or be knocked prone. You can fling creatures at walls or the ground this way, but if you do the flung creature gets the reflex save to avoid failling prone, and if flinging the creature breaks the object, the creature takes half damage.",
            prereq: "Snatch and Drop",
        },
        {
            name: "Focused Discipline",
            type: "martial",
            shortDesc: "",
            longDesc: "You gain a +2 bonus on all saving throws against fear effects. Whenever a fear effect targets you and fails to affect you (either because of a successful saving throw or because of immunity to fear), you gain a +2 morale bonus on attack rolls, weapon damage rolls, and CMB checks against the creature that attempted to use the fear affect on you for 1 round.",
            prereq: "",
        },
        {
            name: "Garen's Discipline",
            type: "martial",
            shortDesc: "",
            longDesc: "Whenever you use Combat Expertise, fight defensively, or take the total defense action, choose a type of saving throw. (You can choose a different type each time you take such an action.) Once per round before attempting a saving throw using the selected save, you gain a +2 bonus on that save. If you have a base attack bonus of +11 or higher, this bonus increases to +3. If you have a base attack bonus of +16 or higher, the bonus instead increases to +4.",
            prereq: "",
        },
        {
            name: "Rune Mage",
            type: "magic",
            shortDesc: "",
            longDesc: "Symbol spells activate 1 round earlier and can be triggered an additional time per casting. The first and last time a symbol spell is triggered, its DC increases by +1.",
            prereq: "",
        },
        {
            name: "Rune Spitter",
            type: "magic",
            shortDesc: "",
            longDesc: "You can activate symbol spells as an immediate action, and increase the casting range of rune spells by 25 feet. This does not effect their trigger radius.",
            prereq: "",
        },
        {
            name: "Counter Activation",
            type: "magic",
            shortDesc: "",
            longDesc: "When a creature other than you tries to activate a symbol spell you can make an opposed spellcraft check as an immediate action to negate the activation of it, if you succeed, you can activate it any time within the next round as a free action you can take even when not your turn.",
            prereq: "",
        },
        {
            name: "Lockdown",
            type: "magic",
            shortDesc: "",
            longDesc: "If you successfully effect a creature with a control spell that it was already being affected by, the next time it rerolls to reduce or negate the effect, it must roll twice succeeding on both to negate or reduce the effect. This does not stack.",
            prereq: "",
        },
        {
            name: "Complete Lockdown",
            type: "magic",
            shortDesc: "",
            longDesc: "Instead of the creature rolling twice and needing to succeed on both, it must save an additional time before the effect is reduced or negated. This does not stack.",
            prereq: "Lockdown",
        },
        
        {
            name: "Follow-Up Strike",
            type: "martial",
            shortDesc: "",
            longDesc: "Whenever you succeed at a combat maneuver check to disarm an opponent, you can spend a swift action to make an unarmed strike attack at your highest base attack bonus against the target you disarmed.",
            prereq: "",
        },
        {
            name: "Combat Vigor",
            type: "martial",
            shortDesc: "",
            longDesc: "You gain a combat vigor pool equal to your constitution modifier. As a standard action, you can spend up to 1 vigor point per 3 Hit Dice you have (minimum 1) to regain 1d6 hit points per vigor point spent. This is not magical healing. Each time you spend vigor points, you become fatigued for 3 rounds. You cannot spend vigor points while fatigued or exhausted. Spending vigor points doesn't provoke attacks of opportunity. The points in your vigor pool are replenished to their maximum at the start of each floor. Changes to your constitution modifier in the floor increase and reduce your vigor pool.",
            prereq: "",
            key:true,
        },
        {
            name: "Renewed Vigor",
            type: "martial",
            shortDesc: "",
            longDesc: "Your vigor pool gains 1 vigor point. When you confirm a critical hit you restore 1 point of vigor.",
            prereq: "Combat Vigor",
        },
        {
            name: "Incredible Vigor",
            type: "martial",
            shortDesc: "",
            longDesc: "Your vigor pool gains 1 vigor point. You can add half your constitution modifier to the hit points you heal with combat vigor.",
            prereq: "Combat Vigor",
        },
        {
            name: "Second Wind",
            type: "martial",
            shortDesc: "",
            longDesc: "Your vigor pool gains 1 vigor point. You can use combat vigor as an immediate action when you would be reduced below 0 hit points, and when you do you also gain temporary hit points equal to the amount you heal that last until the end of your next turn.",
            prereq: "Combat Vigor",
        },
        {
            name: "Swift Vigor",
            type: "martial",
            shortDesc: "",
            longDesc: "Your vigor pool gains 1 vigor point. You can spend combat vigor as a movement action, but it costs twice as much vigor to do so.",
            prereq: "Combat Vigor",
        },
        {
            name: "Fortuitous Vigor",
            type: "martial",
            shortDesc: "",
            longDesc: "Your vigor pool gains 1 vigor point. Whenever you roll a natural 20 on an ability check, attack roll, saving throw, or skill check, and whenever you threaten a critical hit with an attack, you can spend 1 or more vigor points as a swift action to regain hit points as described in the Combat Vigor feat.",
            prereq: "Combat Vigor",
        },
        {
            name: "Restorative Vigor",
            type: "martial",
            shortDesc: "",
            longDesc: "Your vigor pool gains 1 vigor point. Whenever you spend vigor points, you can recover from 1d3 points of ability score damage from one physical ability score (Strength, Dexterity, or Constitution) instead of regaining 1d6 hit points. You can choose separately for each vigor point spent. For example, if you spend 2 vigor points, you could regain 2d6 hit points; recover 2d3 points of ability damage from up to two physical ability scores total; or regain 1d6 hit points and recover from 1d3 points of ability damage from one physical ability score.",
            prereq: "Combat Vigor",
        },
        {
            name: "Take a Breather",
            type: "martial",
            shortDesc: "",
            longDesc: "Your vigor pool gains 1 vigor point. Whenever an opponent that you threaten provokes an attack of opportunity from you, as a swift action you can spend 1 or more vigor points to regain hit points as described by the Combat Vigor feat, instead of making an attack of opportunity against that opponent. Spending vigor in this manner does not count against the total number of attacks of opportunity that you can make during a round. You can instead spend an immediate action it but costs 2x as much vigor.",
            prereq: "Combat Vigor",
        },
        {
            name: "Vim and Vigor",
            type: "martial",
            shortDesc: "",
            longDesc: "Your vigor pool gains 1 vigor point. The fatigued condition that you gain from spending vigor points (as described by the feat) lasts for 2 rounds instead of 3, but you can spend an additional vigor point to reduce it to last 1 round instead. In addition, when you take this feat, you gain a +2 bonus on saving throws against effects that cause fatigue or exhaustion.",
            prereq: "Combat Vigor",
        },
        {
            name: "Vigorous Assault",
            type: "martial",
            shortDesc: "",
            longDesc: "You can spend a point from your Vigor pool when making a melee attack to gain a +1 bonus to the attack and damage roll. You can spend up to as many vigor points as you could normally, and you are fatigued as normal as well.",
            prereq: "Combat Vigor",
        },
        {
            name: "Piss and Vinegar",
            type: "martial",
            shortDesc: "",
            longDesc: "Your vigor pool gains 5 vigor points.",
            prereq: "Combat Vigor",
        },
        {
            name: "Combat Rhythm",
            type: "martial",
            shortDesc: "",
            longDesc: "[Combination] When you deal damage with a melee attack to an opponent you have already damaged this round, you can reduce the total of any voluntary penalties to your melee attack rolls imposed by actions or feats (such as the Power Attack feat) by 1 (to a minimum penalty of 0). This reduction in penalties lasts until the beginning of your next turn and stacks with itself.",
            prereq: "",
        },
        {
            name: "Eroding Strikes",
            type: "martial",
            shortDesc: "",
            longDesc: "[Combination] When you deal damage with a melee attack with a bludgeoning weapon to an opponent you have already damaged this round, you can also reduce the value of that target's damage reduction by 1 until the beginning of your next turn. This reduction stacks with itself.",
            prereq: "",
        },
        {
            name: "Cracking the Shell",
            type: "martial",
            shortDesc: "",
            longDesc: "[Combination] When you deal damage with a melee attack with a piercing weapon to an opponent you have already damaged this round, you can also reduce the value of that target's spell resistance or energy resistances by 1 until the start of your next turn. This reduction stacks with itself.",
            prereq: "",
        },
        {
            name: "Finishing Cascade",
            type: "martial",
            shortDesc: "",
            longDesc: "[Combination] When making an attack during a full round attack, you can forgo the rest of your attacks that turn to deal bonus damage on your current attack equal to attacks forgone x attacks already hit this turn x 2.",
            prereq: "",
        },
        {
            name: "Devastating Combo",
            type: "martial",
            shortDesc: "",
            longDesc: "The first time in a round you use a combination feat to apply a reduction or penalty to yourself or an enemy, you can double the feat's numerical modifier. For example, you can double the reduction granted by Combat Rhythm to -2. This does not double any other effects of combination feats, such as damage.",
            prereq: "",
        },
        {
            name: "Visceral Threat",
            type: "martial",
            shortDesc: "",
            longDesc: "You may use Intimidate, rather than Bluff, to attempt a feint against a creature within your melee reach.",
            prereq: "",
        },
        {
            name: "Instinctual Terror",
            type: "martial",
            shortDesc: "",
            longDesc: "When you succeed on an intimidate check to intimidate a creature that is within your melee reach, that creature also counts as being feinted.",
            prereq: "Visceral Threat",
        },
        {
            name: "Practical Kata",
            type: "martial",
            shortDesc: "",
            longDesc: "[Combination] When you hit with a melee attack against an opponent you have already damaged this round, you can forgo dealing damage to instead regain level spell points. This feat can only be used once per combat.",
            prereq: "",
        },
        {
            name: "Sculpting the River",
            type: "martial",
            shortDesc: "",
            longDesc: "[Combination] When you deal damage with an unarmed attack to an opponent you have already damaged this round, you can impose a -1 penalty on that target's attacks against creatures other than you. The penalties stack and remain until the target misses an attack or the start of your next turn, whichever comes first.",
            prereq: "",
        },
        {
            name: "Thousand Cuts",
            type: "martial",
            shortDesc: "",
            longDesc: "[Combination] When you deal damage with a melee attack with a slashing weapon to an opponent you have already damaged this round, you can also deal 1 point of bleed damage that lasts for 2 rounds. This bleed damage stacks with itself, but only if dealt in the same round.",
            prereq: "",
        },
        {
            name: "Wave Strike",
            type: "martial",
            shortDesc: "",
            longDesc: "If on your first turn of combat you draw a melee weapon to attack an opponent within your reach, you can spend a swift action to make a Bluff check to feint against that opponent.",
            prereq: "",
        },
        {
            name: "Volley Fire",
            type: "teamwork",
            shortDesc: "",
            longDesc: "You gain a +1 bonus on ranged attack rolls for each ally with this feat who made a ranged attack since the end of your last turn against a target within 15 feet of your target, to a maximum of +4. These allies don't provide cover against your attacks.",
            prereq: "",
        },
        {
            name: "Wings of the Sphinx",
            type: "martial",
            shortDesc: "",
            longDesc: "You gain a +2 bonus to AC against charge attacks. If a creature charges you and fails its attack roll, as an immediate action you can attempt a reposition combat maneuver (provoking as normal) to reposition that foe. If you use a readied action to attack a creature charging you, you can roll to attack and then attempt to reposition that creature as a free action before it resolves its charge attack.",
            prereq: "",
        },
        {
            name: "Horn of the Sphinx",
            type: "martial",
            shortDesc: "",
            longDesc: "Whenever you make a successful charge attack while wielding a two-handed weapon in both hands, or both hands are empty or wielding unarmed weapons, you increase the bonus to damage you gain from your base ability score modifier by 50%.",
            prereq: "",
        },
        {
            name: "Hurricane Punch",
            type: "martial",
            shortDesc: "",
            longDesc: "When you hit the same creature with unarmed strikes at least twice in the same round, you can attempt a bull rush combat maneuver against that creature as a swift action. You can also move with the target even if you have no movement remaining, but the distance you move can't exceed half your speed.",
            prereq: "",
        },
        {
            name: "Poised Bearing",
            type: "martial",
            shortDesc: "",
            longDesc: "You treat your size as one category larger for the purposes of determining the size of creatures against which you can attempt bull rush, drag, overrun, and trip combat maneuvers.",
            prereq: "",
        },
        {
            name: "Imposing Bearing",
            type: "martial",
            shortDesc: "",
            longDesc: "You treat your size as two categories larger for the purposes of determining the size of creatures against which you can attempt bull rush, drag, overrun, and trip combat maneuvers (instead of one).",
            prereq: "Poised Bearing",
        },
        {
            name: "Forceful Charge",
            type: "martial",
            shortDesc: "",
            longDesc: "Once per round when you hit an opponent with a charge attack, you can initiate a bull rush against that target as a free action. If you moves your full speed as part of the charge, you gains a +4 bonus on its combat maneuver check to resolve this bull rush.",
            prereq: "",
        },
        {
            name: "Improved Forceful Charge",
            type: "martial",
            shortDesc: "",
            longDesc: "When using forceful charge you can bull rush a target that is up to two size categories larger than you. If you push the target at least 10 feet as a result of this bull rush, you can attempt a trip combat maneuver check against the target as a free action. This trip combat maneuver provokes attacks of opportunity as normal.",
            prereq: "Forceful Charge",
        },
        {
            name: "Intercept Blow",
            type: "martial",
            shortDesc: "",
            longDesc: "When you are adjacent to an ally that is the target of a melee attack, you can expend an attack of opportunity as a free action, even if it isn't your turn, to attempt to intercept the attack. Make an attack roll at your highest attack bonus with one of your melee attacks, as if it were making an attack of opportunity, with a -2 penalty for each size category the attacking creature is larger than you. If the result of this attack roll is greater than the attacking creature's attack roll result, your ally takes only half damage from the attack, and the other half of the damage is dealt to you. Effects that trigger on every successful hit (such as bleed or the trip special ability) affect both the you and your ally, as if both were hit by the attack; however, if it matters (such as for a touch spell that expires after a single hit), you are treated you had been hit first.",
            prereq: "",
        },
        {
            name: "Reflexive Interception",
            type: "martial",
            shortDesc: "",
            longDesc: "Whenever you are adjacent to an ally and they must attempts a Reflex save, you can expend an attack of opportunity as a free action, even if it isn't your turn, to attempt a Reflex save to intervene. When using this ability, you lose the benefits of evasion (and improved evasion if you have it), but if you succeed at your saving throw, your ally gains the benefit of your evasion (or improved evasion if you have it).",
            prereq: "",
            perkPrereq:["Evasion"]
        },
        {
            name: "Improved Intercept Blow",
            type: "martial",
            shortDesc: "",
            longDesc: "When you use Intercept Blow to intercept an opponent's melee attack and succeeds, you can take all the damage from the intercepted attack, in which case your ally takes no damage from the intercepted attack and doesn't suffer effects that trigger on a hit.",
            prereq: "Intercept Blow",
        },
        {
            name: "Balor Whip",
            type: "martial",
            shortDesc: "",
            longDesc: "You can perform Drag combat maneuvers with a whip or spiked chain, when you do you can choose not to move with your target, instead bringing your target closer to you. If you do this, you can't drag the target any farther than the distance it takes to move it adjacent to you, even if your result was high enough to drag the target farther. You gain a +2 bonus on drag combat maneuver checks when using a whip or spiked chain to drag.",
            prereq: "",
        },        
        {
            name: "Improved Balor Whip",
            type: "martial",
            shortDesc: "",
            longDesc: "When you succeed at a drag attempt with your whip against a non-adjacent target and the target ends the drag adjacent to you, as a free action you can make a single attack against the target at your highest attack bonus using the melee weapon held in your other hand. You gain an additional +2 bonus on drag combat maneuver checks when using a whip or spiked chain to drag.",
            prereq: "Balor Whip",
        },
        {
            name: "Wrist Grab",
            type: "martial",
            shortDesc: "",
            longDesc: "When an opponent's attack misses you by 5 or more, you can attempt a disarm combat maneuver check (provoking as normal) against that foe as an immediate action.",
            prereq: "",
        },
        {
            name: "Wingclipper",
            type: "martial",
            shortDesc: "",
            longDesc: "Whenever you confirm a critical hit against an opponent that uses wings to fly, you can forgo the extra critical damage to instead prevent it from flying for a number of rounds equal to twice the critical multiplier of your attack. Opponents that are flying at the time of the critical effect must succeed at a DC 20 Fly check to avoid taking falling damage.",
            prereq: "",
        },
        {
            name: "Courage",
            type: "martial",
            shortDesc: "",
            longDesc: "Whenever you use Combat Expertise, fight defensively, or take the total defense action, choose a type of saving throw. (You can choose a different type each time you take such an action.) Once per round before attempting a saving throw using the selected save, you gain a +2 bonus on that save. If you have a base attack bonus of +11 or higher, this bonus increases to +3. If you have a base attack bonus of +16 or higher, the bonus instead increases to +4.",
            prereq: "",
        },
        {
            name: "Giant's Wallop",
            type: "martial",
            shortDesc: "",
            longDesc: "Once per round if you hit a creature at least one size category smaller than you with a melee attack while using both Power Attack and Vital Strike, the creature you attacked is also dazed for 1 round. A successful Fortitude save negates this effect (DC = 10 + your base attack bonus). You must choose to use this feat before making the attack roll.",
            prereq: "Vital Strike",
        },
        {
            name: "Chrysanthemum's Blooming",
            type: "martial",
            shortDesc: "",
            longDesc: "When you use the spring attack feat your attacks deal an additional +2 damage. If you have a vital strike feat you can apply the benefits of that feat when you use a spring attack feat.",
            prereq: "Spring Attack",
        },
        {
            name: "Giant's Crush",
            type: "martial",
            shortDesc: "",
            longDesc: "Once per round if you hit a creature at least one size category smaller than you with a melee attack while using both Power Attack and Vital Strike, the creature that you attacked is also knocked prone. A successful Reflex save negates this effect (DC = 10 + your base attack bonus). You must choose to use this feat before making the attack roll.",
            prereq: "Vital Strike",
        },
        {
        name: "Tower Shield Specialist",
        type: "martial",
        shortDesc: "You reduce the armor check penalty for tower shields by 3, and if you have the armor training class feature, you modify the armor check penalty and maximum Dexterity bonus of tower shields as if they were armor.",
        longDesc: "You reduce the armor check penalty for tower shields, great shields, and kite shields by 3, and gain +2 to its maximum dexterity modifier, and gain a +1 on melee weapon attacks when wielding a tower shield or kite shield, and a +2 bonus on melee weapon attacks when wielding a great shield.",
        prereq: "",
        },
        {
        name: "Unhindering Shield",
        type: "martial",
        shortDesc: "You still gain a buckler's bonus to AC even if you use your shield hand for some other purpose. When you wield a buckler, your shield hand is considered free for the purposes of casting spells, wielding weapons, and using any other abilities that require you to have a free hand or interact with your shield, such as the swashbuckler's precise strike deed or the Weapon Finesse feat.",
        longDesc: "You still gain a buckler's bonus to AC even if you use your shield hand for some other purpose. When you wield a buckler, your shield hand is considered free for the purposes of casting spells, wielding weapons, and using any other abilities that require you to have a free hand or interact with your shield, such as the swashbuckler's precise strike deed or the Weapon Finesse feat.",
        prereq: "",
        key:true,
        },
        {
        name: "Shot on the Run",
        type: "martial",
        shortDesc: "Make ranged attack at any point during movement",
        longDesc: "As a full-round action, you can move up to your speed and make a single ranged attack at any point during your movement.",
        prereq: "",
        },
        {
            name: "Improved Shot on the Run",
            type: "martial",
            shortDesc: "Make ranged attack at any point during movement",
            longDesc: "When you use Shot on the run, you can select two targets to attack during your movement instead of one. The second attack made this way is made at your full base attack bonus - 5. All restrictions of shot on the run apply to each target. You can't target the same creature more than once.",
            prereq: "Shot on the Run",
        },
        {
            name: "Greater Shot on the Run",
            type: "martial",
            shortDesc: "",
            longDesc: "When you use Shot on the Run, you can select three targets to attack during your movement instead of one. The second attack made this way is made at your full base attack bonus - 5, and the third attack made this way is made at your full base attack bonus - 10. All restrictions of Shot on the run apply to each target. You can't target the same creature more than once.",
            prereq: "Improved Shot on the Run",
        },
        {
        name: "Shrewd Tactician",
        type: "utility",
        shortDesc: "Opponents do not gain a +2 bonus on attack rolls for flanking you.",
        longDesc: "Opponents do not gain a +2 bonus on attack rolls for flanking you, although they can still sneak attack you. You also gain a +3 bonus on Sense Motive checks made to resist a foe's Bluff checks to feint in combat.",
        prereq: "",
        },
        {
        name: "Sidestep",
        type: "martial",
        shortDesc: "Make 5-foot step immediately after an opponent misses",
        longDesc: "Whenever an opponent misses you with a melee attack, you may move 5 feet as an immediate action so long as you remain within that opponent's threatened area. This movement does not provoke attacks of opportunity. If you take this step, you cannot take a 5-foot step during your next turn. If you take an action to move during your next turn, subtract 5 feet from your total movement.",
        prereq: "",
        },
        {
        name: "Sidestep, Improved",
        type: "martial",
        shortDesc: "Sidestep without using your 5-foot step on your next turn",
        longDesc: "After sidestepping an opponent's missed attack using the Sidestep feat, you may still take a 5-foot step during your next turn, or you may move up to your full speed if you take an action to move during your next turn.",
        prereq: "Sidestep",
        },
        {
        name: "Slayer's Feint",
        type: "martial",
        shortDesc: "Use Acrobatics instead of Bluff to feint",
        longDesc: "You can use Acrobatics instead of Bluff to feint in combat.",
        prereq: "",
        },
        {
        name: "Sliding Dash",
        type: "martial",
        shortDesc: "Charge through a foe for a flank attack",
        longDesc: "When charging, instead of moving to the closest space from which you can attack your target, you can move to the space adjacent to your target and on the other side of it, as long as you move through the closest space from which you can attack the target and through the target's space to get there. When you move through the target's space, you must attempt an Acrobatics check with a DC equal to 10 + your opponent's CMD. Success allows you to move through the target's space without provoking an attack of opportunity from that target, and when you arrive in the destination space and make your attack, the target is considered flanked for that attack (or the first attack if you have more than one attack on a charge). On a failed check, you instead provoke an attack of opportunity and complete the charge as normal. Whether or not you succeed at the Acrobatics check, you take a -4 penalty to your AC until the start of your turn, instead of the normal -2 penalty.",
        prereq: "",
        },
        {
            name: "Diehard",
            type: "utility",
            shortDesc: "Charge through a foe for a flank attack",
            longDesc: `When your hit point total is below 0, but you are not dead, you automatically stabilize. You may also choose to act as if you were disabled, rather than dying. You must make this decision as soon as you are reduced to negative hit points (even if it isn't your turn). If you do not choose to act as if you were disabled, you immediately fall unconscious.

            When using this feat, you are staggered. You can take a move action without further injuring yourself, but if you perform any standard action (or any other action deemed as strenuous, including some swift actions, such as casting a quickened spell) you take 1 point of damage after completing the act.`,
            prereq: "",
        },
        {
            name: "To the Last",
            type: "utility",
            shortDesc: "Use Acrobatics instead of Bluff to feint",
            longDesc: "When you are disabled, you are not staggered, though performing standard actions still deals 1 point of damage to you. Taking a full-round action deals 2 points of damage to you.",
            prereq: "Diehard",
        },
        {
            name: "Topple Foe",
            type: "teamwork",
            shortDesc: "",
            longDesc: `If you attempt to trip a foe that is larger than you, you gain a +1 bonus on your CMB check to trip the foe as long as an ally with Topple Foe is flanking the foe with you. If multiple allies with Topple Foe are flanking the foe with you, you gain an additional +2 bonus on your CMD check for each additional ally that's flanking the target. The bonuses granted by this feat stack with those granted by Improved Trip and Greater Trip.
            Each time you attempt to trip the same foe in consecutive rounds, the bonus granted to your trip attempt increases by +1 per ally, to a maximum bonus of +4 per flanking ally on the 4th round of consecutive trip attempts.`,
            prereq: "",
        },
        {
            name: "Defensive Combat Training",
            type: "martial",
            shortDesc: "",
            longDesc: `You can use your level instead of your BAB for determining your CMD`,
            prereq: "",
        },
        {
            name: "Enrage Opponent",
            type: "utility",
            shortDesc: "",
            longDesc: `As a swift action, you can spend 3 spell points to enrage a creature with an Intelligence of 4 or more within 60 feet that can see or hear you. Attempt an Intimidate check as if to demoralize the creature, though you can also use your performance skill instead. If you succeed, the creature takes a -2 penalty to its AC until it has made at least one attack against you (including area effects that include you) or until it can no longer see or hear you. You can have only one opponent enraged at you with this feat at a time, and once you've enraged a creature, you can't enrage it again for 24 hours.`,
            prereq: "",
        },
        {
            name: "Bear's Balance",
            type: "utility",
            shortDesc: "",
            longDesc: `You gain a +4 bonus on Intimidate checks when not raging. If you have the ability to rage, when you fail a saving throw against a fear effect, you can choose to enter your rage rather than succumb to fear. You can not voluntarily end your rage until the fear effect expires or is ended in some other way (such as due to the death of the fear-inducing creature) or you exhaust your rounds of rage for the day. This feat has no effect if you are already raging when exposed to a fear effect.`,
            prereq: "",
        },
        {
            name: "Body Shield",
            type: "utility",
            shortDesc: "",
            longDesc: `As an immediate action while you are grappling an adjacent creature, you can make a grapple combat maneuver check against that creature to gain cover against a single attack. If you are successful and the attack misses you, that attack targets the creature you used as cover, using the same attack roll. You cannot use this feat against a creature grappling you, and the cover you gain ends after the attack you gained cover against is resolved.`,
            prereq: "",
        },
        {
            name: "Covering Shot",
            type: "martial",
            shortDesc: "",
            longDesc: `You can use the aid another action with a ranged attack against an opponent, regardless of whether the opponent threatens an ally. Range penalties apply to this attack roll. Choose one ally when making the attack. If the attack is successful, that ally gains a +2 bonus to AC against that opponent's next attack, as long as the attack comes before the beginning of your next turn. All allies with this feat also gain this bonus against that opponent.`,
            prereq: "",
        },
        {
            name: "Blundering Defense",
            type: "utility",
            shortDesc: "",
            longDesc: `Whenever you fight defensively or use the total defense action, allies gain a luck bonus to AC and CMD equal to 1/2 the dodge bonus you gain from the action you are taking. Allies only gain this bonus while they are adjacent to you.`,
            prereq: "",
        },
        {
            name: "Befuddling Initiative",
            type: "utility",
            shortDesc: "",
            longDesc: `On the first round of each combat you treat all creatures as flat-footed to you. On arena style maps this only applies to new creatures who have entered the combat.`,
            prereq: "",
        },
        {
            name: "Battle Cry",
            type: "utility",
            shortDesc: "",
            longDesc: `For 4 spell points you can let out a battle cry as a swift action. When you do, allies within 30 feet who can hear you gain a +1 morale bonus on attack rolls and a +4 morale bonus on saving throws against fear. This effect lasts for 3 rounds.
            If an ally is under the effect of this feat and fails a saving throw against a fear effect, she can choose to end the battle cry's effect on her to reroll the failed save. The ally must take the result of the reroll, even if it's lower. Each ally can use this effect only once per use of this feat.`,
            prereq: "",
        },
        {
            name: "Extend the Bulwark",
            type: "teamwork",
            shortDesc: "",
            longDesc: `If you are wearing medium or heavy armor and are adjacent to an ally who also has this feat, as a free action, you may give your ally a circumstance bonus to her AC equal to half the armor bonus provided by your armor. This bonus lasts for 1 round. During this round, you gain no bonus to your AC from your armor.`,
            prereq: "",
        },
        {
            name: "Lord of the Hunt's Blessing",
            type: "martial",
            shortDesc: "",
            longDesc: `You can use your highest mental modifier instead of your dexterity for ranged attacks with bows and crossbows.`,
            prereq: "",
        },
        {
            name: "Explosive Escape",
            type: "martial",
            shortDesc: "",
            longDesc: `When you succeed at a combat maneuver check to break a grapple, you can choose to throw back any enemies participating in the grapple who are up to one size category larger than you. Such foes are thrown 5 feet directly away from you and take an amount of nonlethal damage equal to that of your unarmed attack.`,
            prereq: "",
        },
        {
            name: "Desperate Swing",
            type: "martial",
            shortDesc: "",
            longDesc: `Once per day, you can make a single melee attack while taking the total defense action. You take a -4 penalty on attack rolls when making this attack. You also gain a +4 bonus on critical confirmation rolls made while fighting defensively or making an attack of opportunity using this feat.`,
            prereq: "",
        },
        {
            name: "Desperate Battler",
            type: "martial",
            shortDesc: "",
            longDesc: `You can instead use desperate swing once per round.`,
            prereq: "Desperate Swing",
        },
        {
            name: "Twin Thunders",
            type: "martial",
            shortDesc: "",
            longDesc: `Once per round, when wielding a bludgeoning weapon in each hand against a creature at least two sizes larger than you, if you hit the creature with your off-hand weapon after you hit with your primary weapon, roll the damage dice for your off-hand weapon twice and add the results together before adding any bonuses. Such extra weapon damage dice are not multiplied on a critical hit.`,
            prereq: "",
        },
        {
            name: "Twin Thunders Flurry",
            type: "martial",
            shortDesc: "",
            longDesc: `You can trip a creature of up to Huge size, and you gain a +2 bonus on damage rolls against creatures two sizes larger than you when wielding bludgeoning weapons. Further, each time you hit a creature of the giant subtype with your off-hand weapon after you hit that creature with your primary weapon, you can deal the extra off-hand weapon damage Twin Thunders grants you.`,
            prereq: "Twin Thunders",
        },
        {
            name: "Twin Thunders Master",
            type: "martial",
            shortDesc: "",
            longDesc: `Whenever you deal an opponent extra damage with the Twin Thunders feat, that opponent is shaken for 1 round. You also force that opponent to succeed at a Fortitude saving throw (DC 10 + half your level + your Str modifier) or become staggered for 1 round. If you use this feat to render staggered an opponent that is already staggered, you daze that opponent instead. In a similar way, you can stun an opponent that is already dazed.`,
            prereq: "Twin Thunders Flurry",
        },
        {
            name: "Toppling Pileup",
            type: "martial",
            shortDesc: "",
            longDesc: `When you succeed on a trip combat maneuver you can attempt another trip combat maneuver on another creature within your reach and adjacent to the first tripped creature. For each creature previously tripped with this feat, you gain a +4 on trip maneuvers for the rest of the turn.`,
            prereq: "",
        },
        {
        name: "Snap Shot",
        type: "martial",
        shortDesc: "Threaten squares within 5 feet of you when wielding a ranged weapon",
        longDesc: "While wielding a ranged weapon, you threaten squares within 5 feet of you. You can make attacks of opportunity with that ranged weapon. You do not provoke attacks of opportunity when making a ranged attack as an attack of opportunity.",
        prereq: "",
        key:true,
        },
        
        {
        name: "Improved Snap Shot",
        type: "martial",
        shortDesc: "You threaten an additional 5 feet with Snap Shot",
        longDesc: "You threaten an additional 5 feet with Snap Shot.",
        prereq: "Snap Shot",
        },
        {
        name: "Greater Snap Shot",
        type: "martial",
        shortDesc: "Gain bonus on damage and critical confirmation when using ranged weapons",
        longDesc: "Whenever you make an attack of opportunity using a ranged weapon and hit, you gain a +2 bonus on the damage roll and a +2 bonus on rolls to confirm a critical hit with that attack. These bonuses increase by +2 for every 8 of your BAB.",
        prereq: "Improved Snap Shot",
        },
        {
            name: "Heroic Interposition",
            type: "utility",
            shortDesc: "Spend a swift action to bull rush opponent, move it, then knock it prone",
            longDesc: "For level spell points, you can move up to your speed as an immediate action, but you must end this movement adjacent to an opponent who is about to make an attack against an ally. As long as you are visible to the opponent you moved next to, that opponent takes a -2 penalty on the attack roll to which you moved in response.",
            prereq: "",
        },
        {
        name: "Snatch Arrows",
        type: "martial",
        shortDesc: "Catch one ranged attack per round.",
        longDesc: "When using the Deflect Arrows feat you may choose to catch the weapon instead of just deflecting it. Thrown weapons can immediately be thrown back as an attack against the original attacker (even though it isn't your turn) or kept for later use. You must have at least one hand free (holding nothing) to use this feat.",
        prereq: "Deflect Arrows",
        },
        {
        name: "Spellbreaker",
        type: "martial",
        shortDesc: "Enemies provoke attacks if their spells fail",
        longDesc: "Enemies in your threatened area that fail their checks to cast spells defensively provoke attacks of opportunity from you.",
        prereq: "",
        },
        {
        name: "Spiked Destroyer",
        type: "martial",
        shortDesc: "When you succeed a bull rush or overrun you may automatically attack with armor spikes against the same target.",
        longDesc: "When you succeed at a bull rush or overrun combat maneuver, you may automatically make an attack roll with an unarmed attack or shield against the target of the maneuver as a swift action, using your highest attack bonus. You must be wearing medium or heavy armor to do this.",
        prereq: "",
        },
        {
        name: "Spinning Throw",
        type: "martial",
        shortDesc: "Spend a swift action to bull rush opponent, move it, then knock it prone",
        longDesc: "On a successful unarmed trip combat maneuver against an opponent your size or smaller, you can spend a swift action to attempt a bull rush combat maneuver against that opponent. If your bull rush succeeds, you can move that opponent to any unoccupied square you threaten, then push that opponent the number of 5-foot increments your successful bull rush allows. The target is then knocked prone. If the bull rush fails, you can use the Ki Throw feat as normal. If you also have the Improved Ki Throw feat, a successful bull rush allows you to push the opponent into a space secondary targets occupy. You resolve this effect as if you used the Improved Ki Throw feat to throw the opponent into that space.",
        prereq: "",
        },
        {
            name: "Binding Trip",
            type: "martial",
            shortDesc: "",
            longDesc: "On a successful unarmed trip attack against a target you can attempt a grapple combat maneuver as a swift action. This provokes as normal.",
            prereq: "",
        },
        {
            name: "Dislocate",
            type: "utility",
            shortDesc: "",
            longDesc: "As a swift action, you can deal 1d8 points of damage to yourself as you pop your joints from their sockets, making yourself more flexible though suffering incredible pain. Any Escape Artist checks you attempt this turn gain a +4 bonus. If you have 6 or more hit dice the damage increases to 2d8, and you gain a +8 bonus to your escape artist attempts instead. If you have 12 or more HD the damge increases to 4d8, and you can make an escape artist attempt that is usually done as a standard action as a move action instead.",
            prereq: "",
        },
        {
            name: "Dastardly Finish",
            type: "martial",
            shortDesc: "",
            longDesc: "You can deliver a coup de grace to cowering or stunned targets.",
            prereq: "",
        },
        {
            name: "Deadly Troupe",
            type: "teamwork",
            shortDesc: "",
            longDesc: "When at least one ally who also has this feat is threatening a foe, you gain a +4 circumstance bonus against that foe on Bluff checks to feint, Bluff checks to create a diversion to hide, and Acrobatics checks to move through that foe's threatened squares. You also gain a +2 circumstance bonus on steal and dirty trick combat maneuver checks made against that foe.",
            prereq: "",
        },
        {
            name: "Fearless Curiosity",
            type: "utility",
            shortDesc: "Spend a swift action to bull rush opponent, move it, then knock it prone",
            longDesc: "You gain a +1 bonus on saving throws against effects with the emotion descriptor. In addition, for any round in which you begin your turn affected by a fear effect, you gain a new save at the beginning of your turn to reduce the severity of the fear effect, from panicked to frightened, frightened to shaken, and shaken to unaffected. This is in addition to any other saves you might get.",
            prereq: "",
        },
        {
            name: "Intimidating Confidence",
            type: "martial",
            shortDesc: "Spend a swift action to bull rush opponent, move it, then knock it prone",
            longDesc: "You gain a +1 bonus on saving throws against effects with the emotion descriptor; this bonus stacks with the bonus granted by Fearless Curiosity. When you confirm a critical hit, as a free action you can make an Intimidate check to demoralize one creature you threaten. If you have the Dazzling Display feat, you can make Intimidate checks to demoralize all creatures you threaten instead. You gain a 2 bonus on this check equal to the critical multiplier of the confirmed attack.",
            prereq: "",
        },
        {
            name: "Ki Throw",
            type: "martial",
            shortDesc: "Spend a swift action to bull rush opponent, move it, then knock it prone",
            longDesc: "On a successful unarmed trip attack against a target, you may throw the target prone in any square you threaten rather than its own square. This movement does not provoke attacks of opportunity, and you cannot throw the creature into a space occupied by other creatures.",
            prereq: "",
        },
        {
            name: "Improved Ki Throw",
            type: "martial",
            shortDesc: "Spend a swift action to bull rush opponent, move it, then knock it prone",
            longDesc: `When using the Ki Throw feat, you may throw your target into any square you threaten that is occupied by another creature. Make a bull rush combat maneuver check with a -4 penalty against the secondary target. If this check succeeds, the thrown creature lands prone in the secondary target's square, while the secondary target is pushed back and knocked prone in an adjacent square. If the check fails, the thrown creature lands prone in the nearest square you threaten adjacent to the secondary target.
            If you throw a Large or larger creature into an area containing multiple secondary targets, you take an additional penalty of -4 on your combat maneuver check for each target after the first.`,
            prereq: "Ki Throw",
        },
        {
            name: "Binding Throw",
            type: "martial",
            shortDesc: "Spend a swift action to bull rush opponent, move it, then knock it prone",
            longDesc: `After you successfully use the Ki Throw feat on an opponent, you can use a swift action to attempt a grapple combat maneuver against that opponent.`,
            prereq: "Ki Throw",
        },
        {
            name: "Enhanced Ki Throw",
            type: "martial",
            shortDesc: "Spend a swift action to bull rush opponent, move it, then knock it prone",
            longDesc: `When using the Ki Throw feat, you can expend level/2 spell points to amplify the force of your attack. If your ki throw succeeds, when the target hits the ground, it takes damage as if you had hit it with an unarmed strike.`,
            prereq: "Ki Throw",
        },
        {
            name: "Bludgeon Trip",
            type: "martial",
            shortDesc: "Spend a swift action to bull rush opponent, move it, then knock it prone",
            longDesc: `When you successfully trip a creature, as long as it is within your natural reach, you can expend either an attack of opportunity, or level/2 spell points to deal damage to the creature as if you had struck them with an unarmed attack. This attack always deals off-hand damage.`,
            prereq: "",
        },
        {
            name: "Bludgeoning Shove",
            type: "martial",
            shortDesc: "Spend a swift action to bull rush opponent, move it, then knock it prone",
            longDesc: `When you successfully bull rush a creature, as long as it is within your natural reach, you can expend either an attack of opportunity, or level/2 spell points to deal damage to the creature as if you had struck them with an unarmed attack. This attack always deals off-hand damage.`,
            prereq: "",
        },
        {
            name: "Bludgeoning Grab",
            type: "martial",
            shortDesc: "Spend a swift action to bull rush opponent, move it, then knock it prone",
            longDesc: `When you successfully grapple a creature, you can expend either an attack of opportunity, or level/2 spell points to deal damage to the creature as if you had struck them with an unarmed attack. This attack always deals off-hand damage.`,
            prereq: "",
        },
        {
        name: "Spring Attack",
        type: "martial",
        shortDesc: "Move before and after melee attack",
        longDesc: "As a full-round action, you can move up to your speed and make a single melee attack without provoking any attacks of opportunity from the target of your attack. You can move both before and after the attack, but you must move at least 10 feet before the attack and the total distance that you move cannot be greater than your speed. You cannot use this ability to attack a foe that is adjacent to you at the start of your turn.",
        prereq: "",
        },
        {
        name: "Stabbing Shot",
        type: "martial",
        shortDesc: "Use arrow as a melee attack to push enemies back",
        longDesc: "When adjacent to an opponent and making a full-attack action with a bow, you may choose to make a melee attack against that opponent with a drawn arrow rather than firing it. If the attack hits-whether or not it does damage-your target is pushed back 5 feet away from you. You can then fire arrows from your bow normally, at the original target, or at another target within range. This melee attack replaces the extra attack from Rapid Shot, and all of your attack rolls for the round (the melee attack and the ranged attacks) take a -2 penalty. If your initial attack leaves you with no enemies threatening you, you can make the subsequent ranged attack or attacks without provoking attacks of opportunity.",
        prereq: "",
        },
        {
        name: "Stand Still",
        type: "martial",
        shortDesc: "Stop enemies from moving past you",
        longDesc: "When a foe provokes an attack of opportunity due to moving through your adjacent squares, you can make a combat maneuver check as your attack of opportunity. If successful, the enemy cannot move for the rest of his turn. An enemy can still take the rest of his action, but cannot move. This feat also applies to any creature that attempts to move from a square that is adjacent to you if such movement provokes an attack of opportunity.",
        prereq: "",
        },
        {
        name: "Steady Engagement",
        type: "martial",
        shortDesc: "If you prevent an opponent from moving via Stand Still, may disarm or trip the target as an immediate action.",
        longDesc: "If you use Stand Still to prevent an opponent from moving, you may make a disarm or trip combat maneuver against your target as an immediate action.",
        prereq: "Stand Still",
        },
        {
        name: "Step Up",
        type: "martial",
        shortDesc: "Take a 5-foot step as an immediate action",
        longDesc: "Whenever an adjacent foe attempts to take a 5-foot step away from you, you may also make a 5-foot step as an immediate action so long as you end up adjacent to the foe that triggered this ability. If you take this step, you cannot take a 5-foot step during your next turn. If you take an action to move during your next turn, subtract 5 feet from your total movement.",
        prereq: "",
        },
        {
        name: "Step Up and Strike",
        type: "martial",
        shortDesc: "Follow adjacent creature and attack as an immediate action",
        longDesc: "When using the Step Up or Following Step feats to follow an adjacent foe, you may also make a single melee attack against that foe at your highest base attack bonus. This attack counts as one of your attacks of opportunity for the round. Using this feat does not count toward the number of actions you can usually take each round.",
        prereq: "Step Up",
        },
        {
            name: "Heaven's Step",
            type: "martial",
            shortDesc: "Follow adjacent creature and attack as an immediate action",
            longDesc: "When you make an attack using Step Up and Strike, you can also make an extra attack with your offhand weapon using your highest base attack bonus. Both attacks take the normal penalties for two-weapon fighting.",
            prereq: "Step Up and Strike",
        },
        {
            name: "Improved Parry",
            type: "martial",
            shortDesc: "",
            longDesc: "When you successfully use an ability that includes you making an attack roll to make an opponents attack roll miss, your next melee attack against the target does not allow the enemy to apply its Dexterity bonus to AC (if any). This attack must be made before the end of your next turn.",
            prereq: "",
        },
        {
            name: "Punishing Step",
            type: "martial",
            shortDesc: "",
            longDesc: "Gain a +2 dodge bonus to your CMD. When a creature attempts a combat maneuver against you and fails, you gain a +2 circumstance bonus on attack rolls against that creature until the end of your next turn.",
            prereq: "",
        },        
        {
            name: "Punishing Dodge",
            type: "martial",
            shortDesc: "",
            longDesc: "Gain a +1 dodge bonus to your armor class against charge attacks. When a creature charges you and misses with its attack, it loses its Dexterity bonus to AC against the next melee attack you make against it before the end of your next turn. If a creature misses with multiple attacks (such as when using the pounce ability), you can make one such attack against the creature's flat-footed AC before the end of your next turn for each of that creature's attacks that missed you.",
            prereq: "",
        },
        {
            name: "Intense Blows",
            type: "martial",
            shortDesc: "",
            longDesc: "When you are using Power Attack, you gain a +1 bonus to your CMD until the beginning of your next turn. When your base attack bonus reaches +4, and every 4 points thereafter, this bonus increases by another 1.",
            prereq: "",
        },
        {
            name: "Incredible Healer",
            type: "utility",
            shortDesc: "",
            longDesc: "When using the heal skill to badage up a creature, you heal hit points equal to the result of the check, instead of the result -15. The time it takes to bandage up wounds and emergency aid reduces to a full-round action.",
            prereq: "",
        },
        {
            name: "Impossible Healer",
            type: "utility",
            shortDesc: "",
            longDesc: "When using the heal skill to badage up a creature, you heal hit points equal to the result of the check, and half of the result of the check is gained as temporary hit points that last 5 rounds. The time it takes to bandage up wounds and emergency aid reduces to a standard action.",
            prereq: "Incredible Healer",
        },
        {
            name: "Intrepid Rescuer",
            type: "martial",
            shortDesc: "",
            longDesc: "Whenever an opponent you threaten makes an attack against a helpless, prone, or stunned ally, that opponent provokes an attack of opportunity from you. If your attack of opportunity hits your foe, she takes a -4 penalty on the attack roll that provoked this attack of opportunity.",
            prereq: "",
        },
        {
            name: "Jaguar Pounce",
            type: "martial",
            shortDesc: "",
            longDesc: "When making a charge or using Spring Attack against an opponent who is flat-footed or helpless, you treat your first melee attack against that target as if you had the Improved Critical feat. If you already are doubling the critical threat range of your attack, it gains a flat +1 bonus to the critical threat range, unmodified by other abilities.",
            prereq: "",
        },
        {
            name: "Know Weakness",
            type: "martial",
            shortDesc: "",
            longDesc: "When you successfully identify a creature with the appropriate Knowledge check (dc=20+hd), you gain a +2 bonus on attack and damage rolls against that creature for 1 round. If you beat the DC by 8, this increases to +4 for 2 rounds.",
            prereq: "",
        },
        {
            name: "Exploit Knowledge",
            type: "magic",
            shortDesc: "",
            longDesc: "Increase the DC's of your spells against creatures you have personally identified with a knowledge check by +2 (dc=20+hd). This increases to +3 against creatures you beat the DC of the knowledge check by 8",
            prereq: "",
        },
        {
            name: "Kraggodan's Stance",
            type: "martial",
            shortDesc: "",
            longDesc: "As a move action when wearing heavy armor and using a shield with a base shield bonus of +2, you increase the bonus to AC granted by your armor and your shield by 1 each until you move or are moved from your current square. You must be in contact with solid ground to gain this benefit. You can never increase an armor or shield bonus to AC by more than 1 each in this way.",
            prereq: "",
        },
        {
            name: "Lead by Example",
            type: "martial",
            shortDesc: "",
            longDesc: "Whenever you confirm a critical hit in combat, all allies within 30 feet gain a +2 morale bonus on attack rolls for the next round. If your critical hit killed or knocked the target unconcious, this increases to +4.",
            prereq: "",
        },
        {
            name: "Lead from the Back",
            type: "utility",
            shortDesc: "",
            longDesc: "During any round in which you gain the benefit of cover or concealment against at least one opponent, and you are not threatened by any opponent, you can bark orders and encouragement to your allies as a swift action. Doing so grants all allies within 30 feet a +1 bonus on all weapon damage rolls for 1 round. This bonus increases to +2 on rounds you take the withdraw action.",
            prereq: "",
        },     
        {
        name: "Stick Together",
        type: "teamwork",
        shortDesc: "When an adjacent ally with this feat moves, you can move up to your speed as an immediate action, as long as your movement ends adjacent to that ally. If you do so, you are staggered on your next turn. This movement provokes attacks of opportunity as normal.",
        longDesc: "When an adjacent ally with this feat moves, you can move up to your speed as an immediate action, as long as your movement ends adjacent to that ally. If you do so, you are staggered on your next turn. This movement provokes attacks of opportunity as normal.",
        prereq: "",
        },
        {
        name: "Stunning Assault",
        type: "martial",
        shortDesc: "Trade melee attack bonus to stun opponents",
        longDesc: "You can choose to take a -5 penalty on all melee attack rolls and combat maneuver checks to stun targets you hit with your melee attacks for 1 round. A successful Fortitude save negates the effect. The DC of this save is 10 + your base attack bonus. You must choose to use this feat before making the attack roll, and its effects last until your next turn.",
        prereq: "",
        },
        {
        name: "Stunning Fist",
        type: "martial",
        shortDesc: "Stun opponent with an unarmed strike",
        longDesc: "You must declare that you are using this feat before you make your attack roll (thus, a failed attack roll ruins the attempt). Stunning Fist forces a foe damaged by your unarmed attack to make a Fortitude saving throw (DC 10 + 1/2 level + highest mental modifier), in addition to dealing damage normally. A defender who fails this saving throw is stunned for 1 round (until just before your next turn). A stunned character can't take actions, loses any Dexterity bonus to AC, and takes a -2 penalty to AC. This ability costs 4 + level/2 spell points, and can be used no more than once per round. Constructs, oozes, plants, undead, incorporeal creatures, and creatures immune to critical hits cannot be stunned.",
        prereq: "",
        },
        {
            name: "Joyless Toil",
            type: "martial",
            shortDesc: "Stun opponent with an unarmed strike",
            longDesc: "You must declare that you are using this feat before you make your attack roll (thus, a failed attack roll ruins the attempt). Joyless Toil forces a foe damaged by your unarmed attack to make a Fortitude saving throw (DC 10 + 1/2 level + your highest mental modifier), in addition to dealing damage normally. An opponent who fails this saving throw is nauseated for 1 round or until the opponent is attacked. This ability costs 4 + level/2 spell points, and can be used no more than once per round. Constructs, oozes, plants, undead, incorporeal creatures, and creatures immune to critical hits cannot be affected by this ability.",
            prereq: "",
        },
        {
            name: "Ability Mastery",
            type: "utility",
            shortDesc: "",
            longDesc: "When decending a floor or when getting this feat you can choose a piece of armor or clothing, while wearing that armor, you gain an enhancement bonus equal to the armor's highest enhancement modifier as an enhancement bonus on an ability score of your choice. If the highest bonus of that item changes you can keep using the highest bonus. If the armor is ever broken you reduce the bonus by half for the rest of the floor, and if it is destroyed you lose this bonus for the rest of the floor.",
            prereq: "",
        },
        {
            name: "Meditation Master",
            type: "utility",
            shortDesc: "",
            longDesc: "You can spend 1 round meditating to gain bonuses, this also activated between floors. This meditation can be broken multiple ways, when you take damage you must make a will save dc=damage taken, any bonus to concentration you have can be used for this save, by failing any save, or by being affected by any mind-affecting, emotion or fear effect, or by becoming unconscious. If you complete your meditation you gain a the ability to use meditative insight: Gain +2 insight bonus that you can apply to any d20 roll without using an action. The bonus may be applied after the roll is made, but must be applied before the results of the roll are determined. Once used it cannot be used again until you meditate again. Meditating multiple times does not allow you to use this multiple times per meditation.",
            prereq: "",
        },
        {
            name: "Improved Meditation Master",
            type: "utility",
            shortDesc: "",
            longDesc: "Increase the bonus you gain from meditative insight by +2, and you can use it an additional time per meditation.",
            prereq: "Meditation Master",
        },
        {
            name: "Incredible Meditation",
            type: "utility",
            shortDesc: "",
            longDesc: "You can use meditative insight an additional 3 times per meditation. On the round after you finish meditating, you gain 3 medatative insights that only last 1 round.",
            prereq: "Improved Meditation Master",
        },
        {
            name: "In the Zone",
            type: "utility",
            shortDesc: "",
            longDesc: "When you confirm a critical hit you regain a use of meditative insight, and gain a +1 insight bonus to all d20 rolls for 1 round.",
            prereq: "Improved Meditation Master",
        },
        {
            name: "Restore Mind",
            type: "utility",
            shortDesc: "",
            longDesc: "You can expend meditative insight to restore level/2 spell points + any bonus you would gain from meditative insight.",
            prereq: "Meditation Master",
        },
        {
            name: "Meditative Concentration",
            type: "utility",
            shortDesc: "",
            longDesc: "For 1 round per 2 levels after you perform meditation, whenever you attempt a concentration check or a Fortitude save to resist a distraction effect (such as the distraction ability of a swarm), you gain a +4 bonus on the check. You can expend a use of meditative insight when making a save against a mind-affecting effect to gain a +4 bonus on it. You must use this before you make the roll.",
            prereq: "Meditation Master",
        },
        {
            name: "Mindfulness Mastery",
            type: "utility",
            shortDesc: "",
            longDesc: "For 1 round per 2 levels after you perform meditation, whenever you fail your saving throw against a charm, compulsion, emotion, or fear effect, you can attempt a new saving throw again 1 round later at the same DC as a free action. This is on top of any other save you would gain. You get only this one extra chance to succeed at your saving throw, however after that round, you can once per round expend a use of meditative insight to reroll again.",
            prereq: "Meditation Master",
        },
        {
            name: "Perfect Awareness",
            type: "utility",
            shortDesc: "",
            longDesc: "You can expend a use of meditative insight to either gain a +20 bonus on a perception check and to automatically detect and pinpoint the location of any invisible or hidden creature within 30 feet, or to become immune to being flanked or flat-footed for 1 round and to gain half your meditative insight bonus as an insight bonus to armor class for the next attack against you.",
            prereq: "Meditation Master",
        },
        {
            name: "Slow Time",
            type: "utility",
            shortDesc: "",
            longDesc: "When you meditate you gain the effects of the haste for 1 round per 3 character levels. This is an extraordinary effect. This doesn't stack with normal haste.",
            prereq: "Meditation Master",
        },        
        {
            name: "Greater Meditation Master",
            type: "utility",
            shortDesc: "",
            longDesc: "Increase the bonus you gain from meditative insight by +2, and you can use it an additional time per meditation.",
            prereq: "Improved Meditation Master",
        },
        {
            name: "Combat Meditation",
            type: "utility",
            shortDesc: "",
            longDesc: "You can now meditate as a standard action, and you gain a +4 bonus on concentration checks. You can now expend your meditative insight to roll twice when attempting an ability check, attack roll, saving throw, or skill check, taking the better of the two results. You must decide to use this ability before the initial roll is made.",
            prereq: "Meditation Master",
        },
        {
            name: "Improved Combat Meditation",
            type: "utility",
            shortDesc: "",
            longDesc: "When using meditative insight to roll twice, you can apply the insight bonus you gain from meditative insight on top of rolling twice. You can use meditative insight an additional time per meditation. When you meditate you gain 1 spell point for each level of maneuver you know.",
            prereq: "Combat Meditation",
        },
        {
            name: "Greater Combat Meditation",
            type: "utility",
            shortDesc: "",
            longDesc: "For each use of meditative insight you have left, you gain a +1 insight bonus on attack rolls and insight bonus to your armor class. You can use meditative insight an additional time per meditation. When you meditate you instead gain 2 spell points for each level of maneuver you know.",
            prereq: "Combat Meditation",
        },
        {
            name: "Bend With the Wind",
            type: "utility",
            shortDesc: "",
            longDesc: "For rounds equal to your level/2 after meditating you gain cold and fire resistance 5. You can expend a meditative insight to increase it by 5 + meditative insight bonus.",
            prereq: "Meditation Master",
        },
        {
            name: "Body Control",
            type: "utility",
            shortDesc: "",
            longDesc: "For rounds equal to your level/2 after meditating you gain a +2 bonus on Fortitude saving throws against poison, disease, starvation, and effects that would make you fatigued or exhausted. Additionally, the bonus from meditative insight increases by +1.",
            prereq: "Meditation Master",
        },
        {
            name: "Body Mastery",
            type: "utility",
            shortDesc: "",
            longDesc: "For rounds equal to your level/2 after meditating you damage reduction 2/-. This damage reduction stacks with out damage reduction. Additionally, you can use meditative insight an additional time per meditation.",
            prereq: "Body Control",
        },
        {
        name: "Stunning Irruption",
        type: "martial",
        shortDesc: "When you smash your way into a room, you gain more than just the element of surprise.",
        longDesc: "Before starting combat, you can attempt to break through a door, window, or wall to enter a room. If you succeed, the violence of your arrival is so great that all characters within 20 feet of your entry point must succeed at a Fortitude saving throw (DC = 10 + your base attack bonus) or be stunned instead of acting in the surprise round (if there is one) plus 1 round thereafter. Characters who succeed at this save are instead shaken for 1d4 rounds.",
        prereq: "",
        },
        {
        name: "Improved Sunder",
        type: "martial",
        shortDesc: "+2 bonus on sunder attempts, no AOO",
        longDesc: "You do not provoke an attack of opportunity when performing a sunder combat maneuver. In addition, you receive a +2 bonus on checks made to sunder an item. You also receive a +2 bonus to your Combat Maneuver Defense whenever an opponent tries to sunder your gear.",
        prereq: "",
        },
        {
        name: "Greater Sunder",
        type: "martial",
        shortDesc: "Damage from sunder attempts transfers to your enemy",
        longDesc: "You receive a +2 bonus on checks made to sunder an item. This bonus stacks with the bonus granted by Improved Sunder. Whenever you sunder to destroy a weapon, shield, or suit of armor, any excess damage is applied to the item's wielder. No damage is transferred if you decide to leave the item with 1 hit point.",
        prereq: "Improved Sunder",
        },
        {
        name: "Sunder Blessing",
        type: "martial",
        shortDesc: "You can attempt to sunder an ongoing divine spell effect or divine spell-like ability by succeeding at a combat maneuver check.",
        longDesc: "You can attempt to sunder an ongoing divine spell effect or divine spell-like ability by succeeding at a combat maneuver check. For any effect other than one on a creature, you must succeed at a combat maneuver check against a CMD of 15 + the effect's caster level. To sunder an effect on a creature, you must succeed at a normal sunder combat maneuver check against the creature's CMD + 5, ignoring any miss chance caused by a spell or spell-like ability. On a success, you suppress the effect for 1 round. If you exceed the CMD by 5 or more, you suppress the effect for 2 rounds. If you exceed the CMD by 10 or more, the effect is dispelled instead. If you fail to sunder a spell, you cannot attempt to sunder that effect again for 1 minute.",
        prereq: "",
        },
        {
        name: "Sundering Strike",
        type: "martial",
        shortDesc: "Attempt a sunder attack on a successful critical hit",
        longDesc: "Whenever you score a critical hit with a melee attack, you can sunder your opponent's weapon, in addition to the normal damage dealt by the attack. If your confirmation roll exceeds your opponent's CMD, you may deal damage to your opponent's weapon as if from the sunder combat maneuver (roll normal damage to the weapon separately). This provokes as normal.",
        prereq: "",
        },
        {
        name: "Suppressive Fire",
        type: "teamwork",
        shortDesc: "When you damage a target with a ranged attack, it can't make attacks of opportunity against allies who have this feat",
        longDesc: "Whenever you damage a target using a ranged attack, that target can't make attacks of opportunity for 1 round against your allies who also have this feat when they move out of one of the target's threatened squares.",
        prereq: "",
        },
        {
        name: "Surprise Follow-Through",
        type: "martial",
        shortDesc: "When using Cleave or Great Cleave, the second foe you attack on your turn is denied its Dexterity bonus against you.",
        longDesc: "When using Cleave or Great Cleave, the second foe you attack on your turn is denied its Dexterity bonus against you.",
        prereq: "Cleave",
        },
        {
            name: "Improved Surprise Follow-Through",
            type: "martial",
            shortDesc: "When using Great Cleave, each opponent you attack on your turn (other than the first) is denied his Dexterity bonus against you.",
            longDesc: "When using Great Cleave, each opponent you attack on your turn (other than the first) is denied his Dexterity bonus against you.",
            prereq: "Surprise Follow-Through",
        },
        {
        name: "Swap Places",
        type: "teamwork",
        shortDesc: "Whenever you are adjacent to an ally who also has this feat, you can move into your ally's square as part of normal movement. At the same time, your ally moves into your previous space as an immediate action. Both you and your ally must be willing and able to move to take advantage of this feat. Your ally must be the same size as you to utilize this feat. Your ally does not provoke an AOO from this movement, but you provoke as normal. This movement does not count against your ally's movement on his next turn.",
        longDesc: "Whenever you are adjacent to an ally who also has this feat, you can move into your ally's square as part of normal movement. At the same time, your ally moves into your previous space as an immediate action. Both you and your ally must be willing and able to move to take advantage of this feat. Your ally must be the same size as you to utilize this feat. Your ally does not provoke an attack of opportunity from this movement, but you provoke as normal. This movement does not count against your ally's movement on his next turn.",
        prereq: "",
        },
        {
        name: "Sympathetic Rage",
        type: "teamwork",
        shortDesc: "Enter a rage-like state when near an ally who is raging.",
        longDesc: "Whenever you are adjacent to an ally who is raging, you may choose to enter a similar but less powerful rage as a free action on your turn. This weaker rage gives you all the benefits and penalties of a barbarian's rage, except your morale bonus to Strength and Constitution is only +2. There is no limit to how long you can rage, as long as you remain adjacent to a raging ally (for example, you could take a 5-foot step away from one raging ally toward another raging ally and maintain your rage). As with a barbarian's rage, when this weaker rage ends, you are fatigued. You cannot use this feat if you are fatigued.",
        prereq: "",
        },
        {
        name: "Tangle Feet",
        type: "martial",
        shortDesc: "When you successfully make an Acrobatics check to avoid provoking an AOO from a larger opponent when you move through its threatened area or its space, you can make that opponent lose its balance until the end of its next turn as a free action. While that creature's balance is lost, if it attempts to move, it must make a successful DC 15 Acrobatics check or fall prone, wasting the move action. You can only affect one creature with this effect each round.",
        longDesc: "When you successfully make an Acrobatics check to avoid provoking an attack of opportunity from a larger opponent when you move through its threatened area or its space, you can make that opponent lose its balance until the end of its next turn as a free action. While that creature's balance is lost, if it attempts to move, it must make a successful DC 15 Acrobatics check or fall prone, wasting the move action. You can only affect one creature with this effect each round.",
        prereq: "",
        },
        {
        name: "Teleport Tactician",
        type: "martial",
        shortDesc: "Teleporting creatures provoke attacks of opportunity",
        longDesc: "Any creature using a teleportation effect to enter or leave a square threatened by you provokes an attack of opportunity, even if casting defensively or using a supernatural ability.",
        prereq: "",
        },
        {
        name: "Throw Back Arrows",
        type: "martial",
        shortDesc: "When using the Snatch Arrows feat, you can throw a caught piece of ranged ammunition (such as an arrow, bolt, or sling bullet, but not a firearm bullet) as though it were a thrown weapon.",
        longDesc: "When using the Snatch Arrows feat, you can throw a caught piece of ranged ammunition (such as an arrow, bolt, or sling bullet, but not a firearm bullet) as though it were a thrown weapon with a range increment of 20 feet (even though it isn't your turn). The thrown ammunition deals the normal amount of damage for its type plus your Strength modifier, and you don't take a penalty for throwing a weapon that isn't designed to be thrown. This attack provokes attacks of opportunity as normal. You must have at least one hand free (holding nothing) to use this feat.",
        prereq: "Snatch Arrows",
        },
        {
        name: "Improved Trip",
        type: "martial",
        shortDesc: "+2 bonus on trip attempts, no AOO",
        longDesc: "You do not provoke an attack of opportunity when performing a trip combat maneuver. In addition, you receive a +2 bonus on checks made to trip a foe. You also receive a +2 bonus to your Combat Maneuver Defense whenever an opponent tries to trip you.",
        prereq: "",
        },
        {
        name: "Greater Trip",
        type: "martial",
        shortDesc: "Enemies you trip provoke attacks of opportunity",
        longDesc: "You receive a +2 bonus on checks made to trip a foe. This bonus stacks with the bonus granted by Improved Trip. Whenever you successfully trip an opponent, that opponent provokes attacks of opportunity.",
        prereq: "Improved Trip",
        },
        {
        name: "Tripping Strike",
        type: "martial",
        shortDesc: "Attempt a trip attack on a successful critical hit",
        longDesc: "Whenever you score a critical hit with a melee attack, you can trip your opponent, in addition to the normal damage dealt by the attack. If your confirmation roll exceeds your opponent's CMD, you may knock your opponent prone as if from the trip combat maneuver. This provokes as normal. If you are tripped during your own trip attempt, you can drop your weapon to avoid being tripped.",
        prereq: "",
        },
        {
        name: "Tripping Twirl",
        type: "martial",
        shortDesc: "Use a staff w to make a trip attempt against all adjacent enemies .",
        longDesc: "As a full-round action, while wielding a staff weapon two-handed, you can attempt a trip combat maneuver against each enemy adjacent to you.",
        prereq: "",
        },
        // {
        // name: "Twin Thunders",
        // type: "martial",
        // shortDesc: "Substitute disarm, sunder, and trip for any of your attacks vs. giants",
        // longDesc: "Once per round, when wielding a bludgeoning weapon in each hand against a creature with the giant subtype, if you hit the creature with your off-hand weapon after you hit with your primary weapon, roll the damage dice for your off-hand weapon twice and add the results together before adding any bonuses. Such extra weapon damage dice are not multiplied on a critical hit.",
        // prereq: "",
        // },
        {
        name: "Twinned Feint",
        type: "martial",
        shortDesc: "After succeeding at a feint, you can attempt a feint against a second target",
        longDesc: "As a standard action, you can attempt to feint against a foe within your reach. If you succeed at the feint, you can make an additional feint attempt against a foe that is adjacent to the first one and also within reach. You can attempt only one additional feint per action with this feat. When you use this feat, you take a -2 penalty to your AC until your next turn.",
        prereq: "",
        },
        {
        name: "Two-Handed Thrower",
        type: "martial",
        shortDesc: "Gain Str bonus when using two hands to throw a one or two-handed weapon",
        longDesc: "Whenever you use two hands to throw a one handed or two-handed weapon, you gain a bonus on damage rolls equal to 1-1/2 times your Strength bonus. Using two hands to throw any weapon requires only a standard action for you. If you also have the Quick Draw feat, you can throw two-handed weapons at your full normal rate of attacks.",
        prereq: "",
        },
        {
        name: "Two-Weapon Defense",
        type: "martial",
        shortDesc: "Gain +1 shield bonus when fighting with two weapons",
        longDesc: "When wielding a double weapon or two weapons (not including natural weapons or unarmed strikes), you gain a +1 shield bonus to your AC. When you are fighting defensively or using the total defense action, this shield bonus increases to +2. Both bonuses increase by +1 and +2 respectively every 8 levels.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Two-Weapon Feint",
        type: "martial",
        shortDesc: "Forgo first melee attack to feint",
        longDesc: "While using Two-Weapon Fighting to make melee attacks, you can forgo your first primary-hand melee attack to make a Bluff check to feint an opponent.",
        prereq: "",
        },
        {
        name: "Two-Weapon Fighting",
        type: "martial",
        key:true,
        shortDesc: "Reduce two-weapon fighting penalties",
        longDesc: "Your penalties on attack rolls for fighting with two weapons are reduced. The penalty for your primary hand lessens by 2 and the one for your off hand lessens by 4, to a minimum penalty of 0,0",
        prereq: "",
        },
        {
        name: "Improved Two-Weapon Fighting",
        type: "martial",
        shortDesc: "Gain additional off-hand attack",
        longDesc: "In addition to the standard single extra attack you get with an off-hand weapon, you get a second attack with it, albeit at a -5 penalty.",
        prereq: "Two-Weapon Fighting",
        },
        {
        name: "Greater Two-Weapon Fighting",
        type: "martial",
        shortDesc: "Gain a third off-hand attack",
        longDesc: "You get a third attack with your off-hand weapon, albeit at a -10 penalty. You gain a +1 to all attacks while two-weapon fighting.",
        prereq: "Improved Two-Weapon Fighting",
        },
        {
        name: "Legendary Two-Weapon Fighting",
        type: "martial",
        shortDesc: "Gain a third off-hand attack",
        longDesc: "You get an additional attack with your off-hand weapon, but at a -20 penalty. You gain an additional +1 to all attacks while two-weapon fighting.",
        prereq: "Greater Two-Weapon Fighting",
        repeatable:true,
        },
        {
            name: "Mythic Two-Weapon Fighting",
            type: "martial",
            shortDesc: "Gain a third off-hand attack",
            longDesc: "You gain an additional attack with your off-hand weapon, but at an attack penalty equal to -5 for each other off-hand attack you have or will make during your full-round attack. You gain an additional +2 to all attacks made while two-weapon fighting.",
            prereq: "Legendary Two-Weapon Fighting",
            perkPrereq:["Finesse Training"],
            repeatable:true,
        },
        {
            name: "Two-Weapon Grace",
            type: "martial",
            key:true,
            shortDesc: "",
            longDesc: "You can use dexterity to deterimine your damage when two-weapon fighting. Increase your attack penalty from two-weapon fighting by -2, and you cannot reduce the penalty of two weapon fighting below -2. If you have the ability to use your dexterity for damage while two-weapon fighting and also have this feat you increase the damage for your off-hand attacks by 0.5 of your dexterity modifier.",
            prereq: "Improved Two-Weapon Fighting",
        },
        {
        name: "Two-Weapon Rend",
        type: "martial",
        shortDesc: "Rend a foe hit by both your weapons",
        longDesc: "If you hit an opponent with both your primary hand and your off-hand weapon, you deal an additional 1d10 points of damage + 1.5x your Strength modifier (cannot be changed). You can only deal this additional damage once each round, and this damage counts as a part of the attack that activated the rend, meaning it gains no additional damage from abilities that increase damage such as power attack or critical hits, similair to sneak attack.",
        prereq: "",
        },
        {
            name: "Improved Two-Weapon Rend",
            type: "martial",
            shortDesc: "Rend a foe hit by both your weapons",
            longDesc: "If you hit with both your primary and off-hand weapon twice in a round you can apply deal rend damage a second time, however it only deals 1d10 + strength modifier",
            prereq: "Two-Weapon Rend",
        },
        {
            name: "Greater Two-Weapon Rend",
            type: "martial",
            shortDesc: "Rend a foe hit by both your weapons",
            longDesc: "If you hit with both your primary and off-hand weapon three times in a round you can apply deal rend damage a third time, however it only deals 1d10 + 0.5x strength modifier",
            prereq: "Improved Two-Weapon Rend",
        },
        {
            name: "Legendary Two-Weapon Rend",
            type: "martial",
            shortDesc: "Rend a foe hit by both your weapons",
            longDesc: "If you hit with both your primary and off-hand weapon four times in a round you can apply deal rend damage a fourth time, however it only deals 1d10 + 0.5x strength modifier. All of your other rends deal an additional 0.5x strength modifier damage.",
            prereq: "Greater Two-Weapon Rend",
            perkPrereq:["Finesse Training"],
            repeatable:true,
        },
        {
            name: "Mythic Two-Weapon Rend",
            type: "martial",
            shortDesc: "Rend a foe hit by both your weapons",
            longDesc: "Increase the damage of all of your rends by 1d10 damage.",
            prereq: "Legendary Two-Weapon Rend",
            repeatable:true,
        },
        {
            name: "One-Handed Grace",
            type: "martial",
            shortDesc: "",
            longDesc: "While wielding a a weapon in one hand, you can add your Dexterity modifier instead of your Strength modifier to that weapon's damage. The weapon must be one appropriate for your size. You do not gain this benefit while fighting with two weapons or using flurry of blows, or anytime another hand is otherwise occupied. If you already have the ability to add your dexterity to damage, you can instead increase the damage to your weapon by 0.5x your dexterity modifier.",
            prereq: "",
        },
        {
            name: "Daisho Expertise",
            type: "martial",
            shortDesc: "",
            longDesc: "Increase the damage of Wakizachi, Katanas, Odachi, and Masamune by 2 dice steps. If you could use dexterity to attack with any of those weapons you can also use dexterity to damage, if you could not, you can instead use dexterity to attack with the weapon.",
            prereq: "",
        },
        {
        name: "Unarmed Strike, Improved",
        type: "martial",
        shortDesc: "Always considered armed",
        longDesc: "You are considered to be armed even when unarmed-you do not provoke attacks of opportunity when you attack foes while unarmed. Your unarmed strikes can deal lethal or nonlethal damage, at your choice, and increase the damage you dealt with unarmed attacks by 1 step.",
        prereq: "",
        key:true,        
        },
        {
        name: "Uncanny Defense",
        type: "martial",
        shortDesc: "While fighting defensively or taking the total defense action, you gain a bonus on your Reflex saving throws and to your CMD equal to 1/2 of the dodge bonus to AC you gained from taking that action.",
        longDesc: "While fighting defensively or taking the total defense action, you gain a bonus on your Reflex saving throws and to your CMD equal to 1/2 of the dodge bonus to AC you gained from taking that action.",
        prereq: "",
        },
        {
        name: "Under and Over",
        type: "martial",
        shortDesc: "Failed grapples against you cause attacker to fall prone",
        longDesc: "If an opponent larger than you attempts to grapple you and fails, you may make a trip attack as an immediate action against that opponent with a +2 bonus. This does not provoke an attack of opportunity.",
        prereq: "",
        },
        {
        name: "Vicious Stomp",
        type: "martial",
        shortDesc: "When opponent falls prone, it provokes an AOO from you",
        longDesc: "Whenever an opponent falls prone adjacent to you, that opponent provokes an attack of opportunity from you. This attack must be an unarmed strike.",
        prereq: "",
        },
        {
        name: "Violent Display",
        type: "martial",
        shortDesc: "When you land a successful sneak attack or confirm a critical hit against a creature with a weapon with which you have Weapon Focus, you can use Dazzling Display as an immediate action.",
        longDesc: "When you land a successful sneak attack or confirm a critical hit against a creature with a weapon you can use Dazzling Display as an immediate action.",
        prereq: "Dazzling Display",
        },
        {
        name: "Vital Strike",
        type: "martial",
        shortDesc: "Deal twice the normal damage on a single attack",
        longDesc: "When you use the attack action, you can make one attack at your highest base attack bonus that deals additional damage. Roll the weapon's damage dice for the attack twice and add the results together before adding bonuses from Strength, weapon abilities (such as flaming), precision-based damage, and other damage bonuses. These extra weapon damage dice are not multiplied on a critical hit, but are added to the total.",
        prereq: "",
        key:true,
        },
        {
        name: "Improved Vital Strike",
        type: "martial",
        shortDesc: "Deal three times the normal damage on a single attack",
        longDesc: "When you use the attack action, you can make one attack at your highest base attack bonus that deals additional damage. Roll the weapon's damage dice for the attack three times and add the results together before adding bonuses from Strength, weapon abilities (such as flaming), precision-based damage, and other damage bonuses. These extra weapon damage dice are not multiplied on a critical hit, but are added to the total.",
        prereq: "Vital Strike",
        },
        {
            name: "Precipice Strike",
            type: "martial",
            longDesc: "When you and the target of your attack are both in difficult terrain, treat the target as if he were flat-footed. In addition, if you attack a flat-footed enemy from a higher elevation (including while falling), you gain a +2 circumstance bonus on your attack roll.",
            prereq: "",
        },
        {
        name: "Greater Vital Strike",
        type: "martial",
        shortDesc: "Deal four times the normal damage on a single attack",
        longDesc: "When you use the attack action, you can make one attack at your highest base attack bonus that deals additional damage. Roll the weapon's damage dice for the attack four times and add the results together before adding bonuses from Strength, weapon abilities (such as flaming), precision-based damage (such as sneak attack), and other damage bonuses. These extra weapon damage dice are not multiplied on a critical hit, but are added to the total.",
        prereq: "Improved Vital Strike",
        },
        {
            name: "Legendary Vital Strike",
            type: "martial",
            shortDesc: "Deal four times the normal damage on a single attack",
            longDesc: "When you use vital strike roll the weapon's damage dice for the attack an additional time over what you would add for any other vital strike feat and add the results together before adding bonuses from Strength, weapon abilities (such as flaming), precision based damage, and other damage bonuses. These extra weapon damage dice are not multiplied on a critical hit, but are added to the total.",
            prereq: "Greater Vital Strike",
            perkPrereq:["Mighty Strikes"],
        },
        
        // {
        // name: "Mythic Vital Strike",
        // type: "martial",
        // shortDesc: "",
        // longDesc: "When you use vital strike, improved vital strike or greater vital strike you can multiple all bonuses that would normally be multiplied on a critical hit by the number of weapon damage dice you roll for that feat.",
        // prereq: "Vital Strike",
        // },
        {
        name: "Warning Shot",
        type: "martial",
        shortDesc: "As a standard action, you can make a ranged touch attack using a ranged weapon with which you have Weapon Focus. If successful, instead of dealing damage or applying any other effects of the attack, you may attempt an Intimidate check to demoralize the target as a free action. The target doesn't need to be within 30 feet, nor does it need to be able to see or hear you.",
        longDesc: "As a standard action, you can make a ranged touch attack using a ranged weapon. If successful, instead of dealing damage or applying any other effects of the attack, you may attempt an Intimidate check to demoralize the target as a free action. The target doesn't need to be within 30 feet, nor does it need to be able to see or hear you.",
        prereq: "",
        },
        {
        name: "Weapon Finesse",
        type: "martial",
        key:true,
        shortDesc: "Use Dex instead of Str on attack rolls with light weapons",
        longDesc: "You may use your Dexterity modifier instead of your Strength modifier on attack rolls with any melee weapon. If you carry a shield, its armor check penalty applies to your attack rolls.",
        prereq: "",
        },
        {
        name: "Weapon Focus",
        type: "martial",
        shortDesc: "+2 bonus on all attack rolls",
        longDesc: "When you gain this feat select a type of weapon, (augmenting, light, one-handed, two-handed, primitive, tech, armament, rays) You gain a +2 bonus on all attack rolls with that weapon type",
        prereq: "",
        key:true,
        },
        {
        name: "Greater Weapon Focus",
        type: "martial",
        shortDesc: "+2 bonus on attack rolls with one weapon",
        longDesc: "You gain a +2 bonus on attack rolls you make using the selected weapon. This bonus stacks with other bonuses on attack rolls, including those from Weapon Focus.",
        prereq: "Weapon Focus",
        repeatable:true,
        },
        {
        name: "Weapon Specialization",
        type: "martial",
        shortDesc: "+4 bonus on damage rolls with one weapon",
        longDesc: "When you gain this feat choose one type of weapon, (augmenting, light, one-handed, two-handed, primitive, tech, armament), you gain a +3 bonus on all damage rolls you make using the selected weapon.",
        prereq: "",
        key:true,
        },
        {
        name: "Greater Weapon Specialization",
        type: "martial",
        shortDesc: "+4 bonus on damage rolls with one weapon",
        longDesc: "Choose one weapon type you chose for weapon specialization, you deal +3 damage with that weapon type. This bonus to damage stacks with other damage roll bonuses, including any you gain from Weapon Specialization.",
        prereq: "Weapon Specialization",
        repeatable:true,
        },
        {
        name: "Whirlwind Attack",
        type: "martial",
        shortDesc: "Make one melee attack against all foes within reach",
        longDesc: "When you use the full-attack action, you can give up your regular attacks and instead make one melee attack at your highest base attack bonus against each opponent within reach. You must make a separate attack roll against each opponent. When you use the Whirlwind Attack feat, you also forfeit any bonus or extra attacks granted by other feats, spells, or abilities.",
        prereq: "",
        },
        {
        name: "Wilding Strike",
        type: "martial",
        shortDesc: "Your unarmed and close weapon damage increases one damage step",
        longDesc: "Your unarmed and close weapon damage increases by one dice step",
        key:true,
        prereq: "",
        repeatable:true,
        },
        {
        name: "Improved Wilding Strike",
        type: "martial",
        shortDesc: "Your unarmed and close weapon damage increases another damage step and increase the crit range of unarmed strikes by 1",
        longDesc: "Your unarmed and close weapon damage increases another dice step and increase the crit range of such attacks increases by 1. This stacks with the bonuses given by wilding strike. This is a base change and can be modified by abilities like keen.",
        prereq: "Wilding Strike",
        },
        {
        name: "Greater Wilding Strike",
        type: "martial",
        shortDesc: "Your unarmed and close weapon damage increases another damage step and increase the crit range of unarmed strikes by 1 and the critical damage multiplier by 1",
        longDesc: "Your unarmed and close weapon damage increases another dice step and increase their critical damage multiplier by 1. This stacks with the bonuses given by improved wilding strike.",
        prereq: "Improved Wilding Strike",
        },
        {
        name: "Wind Stance",
        type: "utility",
        shortDesc: "Gain 20% concealment if you move",
        longDesc: "If you move more than 5 feet this turn, you gain 20% concealment for 1 round against ranged attacks.",
        prereq: "",
        },
        {
        name: "Winter's Strike",
        type: "martial",
        shortDesc: "Target of your Vital Strike must successfully save or become fatigued",
        longDesc: "For 4 spell points, when you use Vital Strike (or Improved Vital Strike or Greater Vital Strike), your strike saps the strength of your opponent. The creature hit must succeed at a Fortitude save (DC = 10 + 1/2 your character level + your highest mental stat) or become fatigued for a number of rounds equal to your highest mental stat (minimum 1). You can choose to use this ability as a free action after you hit the target with the attack. This is a supernatural ability.",
        prereq: "Vital Strike",
        },
        {
        name: "Witty Feint",
        type: "martial",
        shortDesc: "When using feint gain a dodge bonus to AC instead of denying an opponent their Dex bonus.",
        longDesc: "When you successfully feint against an opponent in combat, instead of denying the opponent his Dexterity bonus, you may gain a dodge bonus to your AC against his attacks. This bonus is equal to 1, increasing by 1 every 4 levels you have, and an additional +2 if you have weapon focus, and another +2 if you have greater weapon focus. The bonus lasts until combat ends, you switch opponents, or you switch to a different weapon, whichever comes first.",
        prereq: "",
        },
        {
        name: "Wounded Paw Gambit",
        type: "teamwork",
        shortDesc: "When you use Broken Wing Gambit, nearby allies can attempt a ranged attack against the attacker",
        longDesc: "Whenever you use Broken Wing Gambit and an opponent attacks you as a result, each ally who has this feat and is within 30 feet of that opponent can attempt a ranged attack against it as an immediate action. The ally's ranged weapon must be in hand, loaded, and ready to be fired or thrown in order to make this attack possible. An ally who has this feat and Broken Wing Gambit can instead use Broken Wing Gambit to attempt an attack of opportunity against the foe, but cannot attempt both that attack of opportunity and this ranged attack.",
        prereq: "Broken Wing Gambit",
        },
        {
        name: "Amplified Rage",
        type: "teamwork",
        shortDesc: "Increase your bonuses to Strength and Constitution by raging near a fellow rager.",
        longDesc: "Whenever you are raging and adjacent to a raging ally who also has this feat or flanking the same opponent as a raging ally with this feat, your morale bonuses to Strength and Constitution increase by +4. This feat does not stack with itself (you only gain this bonus from one qualifying ally, regardless of how many are adjacent to you).",
        prereq: "",
        },
        {
        name: "Back to Back",
        type: "teamwork",
        shortDesc: "Gain a +2 to AC against flanking opponents",
        longDesc: "While you are flanked and adjacent to an ally with this feat, you receive a +2 circumstance bonus to AC against attacks from opponents flanking you.",
        prereq: "",
        },
        {
        name: "Improved Back to Back",
        type: "teamwork",
        shortDesc: "Grant adjacent ally +2 to AC against flanking opponents",
        longDesc: "While you are adjacent to an ally who is flanked and also has this feat, you can spend a swift action to gain a +2 bonus to AC against all flankers until the start of your next turn.",
        prereq: "Back to Back",
        },
        {
        name: "Broken Wing Gambit",
        type: "teamwork",
        shortDesc: "Grant opponent bonus to hit you, but opponent's attack provokes attacks of opportunity",
        longDesc: "Whenever you make a melee attack and hit your opponent, you can use a free action to grant that opponent a +2 bonus on attack and damage rolls against you until the end of your next turn or until your opponent attacks you, whichever happens first. If that opponent attacks you with this bonus, it provokes attacks of opportunity from your allies who have this feat.",
        prereq: "",
        },
        {
        name: "Callous Casting",
        type: "magic",
        shortDesc: "Include an ally in the area of effect of a damaging spell the ally is not immune to in order to shaken your enemies.",
        longDesc: "You initiate this feat by including an abetting ally in the area of any spell that deals damage of a type to which the abettor is not immune. The callousness of the attack disheartens foes in the area, who must succeed at a Will save against the spell's DC or be shaken for 1 round per spell level. After you resolve the spell's effects, the abettor can move up to her speed as an immediate action. Any movement undertaken using this action is then subtracted from her speed until the end of her next turn. This movement can still provoke attacks of opportunity as normal. Once a foe has attempted a Will save against this feat, he is immune to this effect from that initiator for 24 hours thereafter.",
        prereq: "",
        },
        {
        name: "Circling Offense",
        type: "teamwork",
        shortDesc: "You receive a +1 dodge bonus to your Armor Class against attacks of opportunity provoked by moving through a creature's reach, provided the creature is of a larger size category than you and provided at least one other ally with Circling Offense is within the creature's reach. If a creature that you're receiving this dodge bonus against attacks you and misses with the attack, it provokes attacks of opportunity from any of your allies who possess Circling Offense.",
        longDesc: "You receive a +1 dodge bonus to your Armor Class against attacks of opportunity provoked by moving through a creature's reach, provided the creature is of a larger size category than you and provided at least one other ally with Circling Offense is within the creature's reach. If a creature that you're receiving this dodge bonus against attacks you and misses with the attack, it provokes attacks of opportunity from any of your allies who possess Circling Offense.",
        prereq: "",
        },
        {
        name: "Cooperative Rend",
        type: "teamwork",
        shortDesc: "Whenever you and an ally who has this feat are both threatening the same creature, you must hit the target with at least one of your claw attacks to use your rend ability.",
        longDesc: "Whenever you and an ally who has this feat are both threatening the same creature, you must hit the target with only 1 attack to activate your rend ability.",
        prereq: "",
        },
        {
        name: "Coordinated Charge",
        type: "teamwork",
        shortDesc: "You may charge the same foe when an ally does",
        longDesc: "When an ally with this feat charges a creature that is no further away from you than your speed, you can, as an immediate action, charge that creature. You must be able to follow all of the normal charge rules.",
        prereq: "",
        },
        {
        name: "Coordinated Defense",
        type: "teamwork",
        shortDesc: "+2 bonus to CMD.",
        longDesc: "Whenever you are adjacent to an ally who also has this feat, you receive a +2 competence bonus to your Combat Maneuver Defense. This bonus increases to +4 if the creature attempting the maneuver is larger than both you and your ally.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Coordinated Distraction",
        type: "teamwork",
        shortDesc: "When you and at least one ally with this feat threaten the same enemy, the enemy treats the DC to cast spells defensively as 2 higher for each threatening character with this feat. If you or your allies are incapable of taking an attack of opportunity against the target for any reason, the effects of this feat do not apply.",
        longDesc: "When you and at least one ally with this feat threaten the same enemy, the enemy treats the DC to cast spells defensively as 2 higher for each threatening character with this feat. If you or your allies are incapable of taking an attack of opportunity against the target for any reason, the effects of this feat do not apply.",
        prereq: "",
        },
        {
        name: "Coordinated Maneuvers",
        type: "teamwork",
        shortDesc: "+2 bonus on combat maneuver checks.",
        longDesc: "Whenever you are adjacent to an ally who also has this feat, you receive a +2 competence bonus on all combat maneuver checks. This bonus increases to +4 when attempting to break free from a grapple.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Coordinated Reposition",
        type: "teamwork",
        shortDesc: "Whenever an ally with this feat who is threatening a creature you are threatening takes a 5-foot step, you can move 5 feet as an immediate action. This movement does not provoke attacks of opportunity.",
        longDesc: "Whenever an ally with this feat who is threatening a creature you are threatening takes a 5-foot step, you can move 5 feet as an immediate action. This movement does not provoke attacks of opportunity.",
        prereq: "",
        },
        {
        name: "Coordinated Shot",
        type: "teamwork",
        shortDesc: "When an ally with this feat threatens a foe, gain a +1 bonus on ranged attack rolls, or +2 if that ally is flanking the foe",
        longDesc: "If your ally with this feat is threatening an opponent and is not providing cover to that opponent against your ranged attacks, you gain a +1 bonus on ranged attacks against that opponent. If your ally with this feat is flanking that opponent with another ally (even if that other ally doesn't have this feat), this bonus increases to +2.",
        prereq: "",
        },
        {
        name: "Darting Retrieval",
        type: "teamwork",
        shortDesc: "When an ally who also has this feat disarms an opponent and the disarmed item lands within your melee reach, as an immediate action you can move the disarmed item to another square within your melee reach. If you have at least one hand free and could carry the disarmed item, you can instead pick it up. Using this feat does not provoke an attack of opportunity.",
        longDesc: "When an ally who also has this feat disarms an opponent and the disarmed item lands within your melee reach, as an immediate action you can move the disarmed item to another square within your melee reach. If you have at least one hand free and could carry the disarmed item, you can instead pick it up. Using this feat does not provoke an attack of opportunity.",
        prereq: "",
        },
        {
        name: "Disarm Partner",
        type: "teamwork",
        shortDesc: "When an ally with this feat fails a disarm combat maneuver check made on his turn against an opponent within your melee reach, as an immediate action you can attempt a disarm combat maneuver check against that foe.",
        longDesc: "When an ally with this feat fails a disarm combat maneuver check made on his turn against an opponent within your melee reach, as an immediate action you can attempt a disarm combat maneuver check against that foe.",
        prereq: "",
        },
        {
        name: "Improved Disarm Partner",
        type: "teamwork",
        shortDesc: "When an ally with this feat fails a disarm combat maneuver check made on his turn against a foe that's within your melee reach, you can make an attack of opportunity against that foe. If that attack of opportunity hits the foe, you can also attempt a disarm combat maneuver check against that opponent as part of that attack of opportunity.",
        longDesc: "When an ally with this feat fails a disarm combat maneuver check made on his turn against a foe that's within your melee reach, you can make an attack of opportunity against that foe. If that attack of opportunity hits the foe, you can also attempt a disarm combat maneuver check against that opponent as part of that attack of opportunity.",
        prereq: "Disarm Partner",
        },
        {
        name: "Duck and Cover",
        type: "teamwork",
        shortDesc: "Take ally's result on Reflex saving throw.",
        longDesc: "Whenever you are adjacent to an ally who also has this feat, and both of you are required to make a Reflex saving throw against a spell or effect, you may take the result of your die roll or that of your ally (your modifiers still apply to the roll, regardless of which result you take). If you take your ally's result, you are knocked prone (or staggered on your next turn, if you are already prone or cannot be knocked prone). In addition, you receive a +2 cover bonus to your AC against ranged attacks as long as your ally is wielding a shield.",
        prereq: "",
        },
        {
        name: "Enfilading Fire",
        type: "teamwork",
        shortDesc: "When ally flanks opponent, you gain +2 on ranged attack rolls against opponent",
        longDesc: "You receive a +2 bonus on ranged attacks made against a foe flanked by 1 or more allies with this feat.",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Escape Route",
        type: "teamwork",
        shortDesc: "You do not provoke attacks of opportunity when moving through spaces adjacent to allies",
        longDesc: "An ally who also has this feat provokes no attacks of opportunity for moving through squares adjacent to you or within your space.",
        prereq: "",
        },
        {
        name: "Feint Partner",
        type: "teamwork",
        shortDesc: "When ally successfully feints, opponent loses Dex bonus against your next attack",
        longDesc: "Whenever an ally who also has this feat successfully feints an opponent, that opponent also loses his Dexterity bonus to AC against the next attack you make against him before the end of the feinting ally's next turn.",
        prereq: "",
        },
        {
        name: "Improved Feint Partner",
        type: "teamwork",
        shortDesc: "When ally successfully feints, you gain attack of opportunity against opponent",
        longDesc: "Whenever an ally who also has this feat successfully feints against an opponent, that opponent provokes an attack of opportunity from you.",
        prereq: "Feint Partner",
        },
        {
        name: "Fighting Frenzy",
        type: "teamwork",
        shortDesc: "When you are in a rage and an ally with this feat within 60 feet is in a rage, you don't take the normal -2 penalty to AC for being in a rage. If you would take a larger penalty to AC for being in a rage, reduce that penalty by 2.",
        longDesc: "When you are in a rage and an ally with this feat within 60 feet is in a rage, you don't take the normal -2 penalty to AC for being in a rage. If you would take a larger penalty to AC for being in a rage, reduce that penalty by 2.",
        prereq: "",
        perkPrereq:["Rage","Epic Rage"]
        },
        {
        name: "Focusing Blow",
        type: "teamwork",
        shortDesc: "An ally who also has this feat can deal damage to you in order to break an ongoing mind-affecting effect that allows a saving throw. The ally must cause at least 5 points of damage to you with an attack, spell, or other ability. You then reroll your saving throw, with a +1 bonus for every 5 additional points of damage the attack caused. If your save is successful, the mind-affecting effect ends. Only damage actually dealt counts for purposes of this feat; nonlethal damage and damage reduced or eliminated by damage reduction, resistances, and so on does not qualify.",
        longDesc: "An ally who also has this feat can deal damage to you in order to break an ongoing mind-affecting effect that allows a saving throw. The ally must cause at least 5 points of damage to you with an attack, spell, or other ability. You then reroll your saving throw, with a +1 bonus for every 5 additional points of damage the attack caused. If your save is successful, the mind-affecting effect ends. Only damage actually dealt counts for purposes of this feat; nonlethal damage and damage reduced or eliminated by damage reduction, resistances, and so on does not qualify.",
        prereq: "",
        },
        {
        name: "Friendly Fire",
        type: "martial",
        shortDesc: "Make a careless ranged attack into a melee one of your allies is in and risk hitting your ally.",
        longDesc: "When making a ranged attack against a foe engaged in melee with at least one abettor. This shot deliberately forsakes normal precautions, putting your abettor at risk, but also is unexpected enough to surprise your mutual opponent. You gain a +2 bonus on your attack roll if the attack passes through an abettor's space. If your shot misses the target, you must immediately make a second attack roll with all the same modifiers against the abettor, potentially hitting her with the attack instead of the opponent. When the attack resolves (regardless of whether either potential target was hit), the intended target's startled reaction provokes an attack of opportunity from the abettor, but only once per round.",
        prereq: "",
        },
        {
            name: "Ancestral Scorn",
            type: "utility",
            shortDesc: "Make a careless ranged attack into a melee one of your allies is in and risk hitting your ally.",
            longDesc: "Whenever you successfully demoralize a creature that is at least 2 alignment steps away from you with a use of the intimidate skill and beat the DC by at least 5 the creature is also sickened for rounds equal to the duration it would be shaken -1.",
            prereq: "",
        },
        {
            name: "Antagonize",
            type: "utility",
            shortDesc: "",
            longDesc: "You can make an intimidate check to force a creature to respond with hostility. This is a standard action that does not provoke and has a DC equal to 10 + target's HD + target's wisdom modifier and counts as a mind-affecting effect. If you succeed the target flies into a rage. On its next turn, the target must attempt to do one of the following: make a melee attack against you, make a ranged attack against you, target you with a spell, or include you in the area of a spell. The effect ends if the creature is prevented from attempting one of these things, or doing so would endanger it (for example, if you are on the other side of a chasm or a wall of fire). If it cannot attack you on its turn, you may make the check again as an immediate action to extend the effect for 1 round (but cannot extend it thereafter). The effect ends as soon as the creature attacks you. Once you have targeted a creature with this ability, you cannot target it again.",
            prereq: "",
        },
        {
            name: "Mock",
            type: "utility",
            shortDesc: "",
            longDesc: "You can make a diplomacy check to mock a creature. This is a standard action that does not provoke, and has a DC equal to 10 + target's HD + target's wisdom modifier and counts as a mind-affecting effect, if you succeed the target becomes flustered. For the next minute, the target takes a -2 penalty on all attacks rolls made against creatures other than you and has a 10% spell failure chance on all spells that do not target you or that have you within their area of effect. For each 10 you beat the DC by, the penalty increases by an additional -1, and the spell failure chance increases by 5%. Once you have targeted a creature with this ability, you cannot target it again.",
            prereq: "",
        },
        {
            name: "Insightful Eye",
            type: "utility",
            shortDesc: "",
            longDesc: "You can make a sense motive check on a creature you can see as a swift action, DC 10+HD, if you succeed you gain an insight bonus to any bluff, intimidate, or diplomacy checks against it equal to your highest mental modifier until the start of your next turn, and the DC to use any of these checks against you increases by the same amount.",
            prereq: "",
        },
        {
            name: "Halfling Jinx",
            type: "utility",
            shortDesc: "",
            longDesc: "As a standard action you can attempt to jinx a creature you can see. The creature makes a will save DC 10 + level/2 + Charisma modifier, if they fail they take a -1 penalty to all saving throws for 24 hours or until death (yours or its). You gain a +1 luck bonus to your saving throws for each creature you currently have jinxed.",
            perkPrereq: ["Halfling"],
        },
        {
            name: "Area Jinx",
            type: "utility",
            shortDesc: "",
            longDesc: "When you use your jinx, you create an instantaneous invisible burst with a maximum radius of 10 feet anywhere within the normal range of your jinx that affects multiple targets. Any creature within this burst, regardless of whether or not you can see it, must make a saving throw to resist your jinx. If you use your jinx again, all of your current jinxes immediately end. If you have the 'Arcane Jinxer' feat, for every 3 levels of the spell sacrificed the area of 'Area Jinx' also increases by 5 feet.",
            prereq: "Halfling Jinx",
        },
        {
            name: "Arcane Jinxer",
            type: "magic",
            shortDesc: "",
            longDesc: "When you use Halfling Jinx you can also expend the use of a control spell to increase the DC by the level of the spell. For every 3 levels of the spell level the penalty to saves also increases by -1.",
            prereq: "Halfling Jinx",
        },
        {
        name: "Overwhelm",
        type: "teamwork",
        shortDesc: "You are considered to be flanking an opponent if at least one ally who also has this feat is threatening that opponent and the opponent is at least two size categories larger than the larger of you or your ally, regardless of your actual positioning.",
        longDesc: "You are considered to be flanking an opponent if at least one ally who also has this feat is threatening that opponent and the opponent is at least two size categories larger than the larger of you or your ally, regardless of your actual positioning.",
        prereq: "",
        },
        {
            name: "Ally Shield",
            type: "teamwork",
            shortDesc: "",
            longDesc: "Whenever you are the target of a melee or ranged attack and are adjacent to an ally who also has this feat, you can initiate this feat to skillfully pull the abettor into harm's way or dodge behind the abettor as an immediate action. You gain cover against that attack (and only that attack). If the attack misses you but would have hit you if not for the cover bonus to your Armor Class, the abettor becomes the target of the attack and the attacker must make a new attack roll (with all the same modifiers) against the abettor's Armor Class.",
            prereq: "",
        },
        {
        name: "Pack Attack",
        type: "teamwork",
        shortDesc: "Ally's attack allows you to take a 5-foot step",
        longDesc: "When you are adjacent to an ally with this feat, the first time you melee attack an opponent, you can spend an immediate action to take a 5-foot step, even if you have otherwise moved this round.",
        prereq: "",
        },
        {
        name: "Pack Flanking",
        type: "teamwork",
        shortDesc: "You and your companion creature flank regardless of position",
        longDesc: "When you and your companion creature have this feat, your companion creature is adjacent to you or sharing your square, and you both threaten the same opponent, you are both considered to be flanking that opponent, regardless of your actual positioning.",
        prereq: "",
        },
        {
        name: "Phalanx Fighter",
        type: "teamwork",
        shortDesc: "You gain a sacred bonus to your AC against the attacks of evil creatures and a sacred bonus to saves against the spells and abilities of evil creatures equal to the number of adjacent allies who also have this feat.",
        longDesc: "",
        prereq: "",
        },
        {
        name: "Punch Through",
        type: "teamwork",
        shortDesc: "As a full-round action, you may make a single attack against a target. If the attack hits and deals damage to the target, all of your allies with this feat ignore up to 5 points of damage reduction against the same target for 1 round. This feat does not apply to damage reduction without a type (such as DR 10/—).",
        longDesc: "As a full-round action, you may make a single attack against a target. If the attack hits and deals damage to the target, all of your allies with this feat ignore up to 5 points of damage reduction against the same target for 1 round. This feat does not apply to damage reduction without a type (such as DR 10/-).",
        prereq: "",
        },
        {
        name: "Seize the Moment",
        type: "teamwork",
        shortDesc: "When ally confirms a critical threat, you gain an attack of opportunity",
        longDesc: "When an ally who also has this feat confirms a critical hit against an opponent that you also threaten, you can make an attack of opportunity against that opponent.",
        prereq: "",
        },
        {
        name: "Shake It Off",
        type: "teamwork",
        shortDesc: "Gain +1 to all saving throws per adjacent ally",
        longDesc: "When you are adjacent to one or more allies who also have this feat, you gain a +1 bonus on saving throws per such ally (maximum +4).",
        prereq: "",
        },
        {
        name: "Snapping Flank",
        type: "teamwork",
        shortDesc: "Whenever you are flanking with an ally who also has this feat, as a swift action you can make a bite attack against the opponent you and your ally are flanking.",
        longDesc: "Whenever you are flanking with an ally who also has this feat, as a swift action you can make a bite attack against the opponent you and your ally are flanking.",
        prereq: "",
        },
        {
        name: "Swing About",
        type: "teamwork",
        shortDesc: "If you have a free hand, as a move action you can grab a willing adjacent ally who also has this feat and place her in any other space adjacent to you. This movement does not provoke attacks of opportunity. You can do this only with allies who are able to move freely (not grappled, held, prone, slowed, or otherwise suffering restricted movement) and who are of your size or smaller.",
        longDesc: "If you have a free hand, as a move action you can grab a willing adjacent ally who also has this feat and place her in any other space adjacent to you. This movement does not provoke attacks of opportunity. You can do this only with allies who are able to move freely (not grappled, held, prone, slowed, or otherwise suffering restricted movement) and who are of your size or smaller.",
        prereq: "",
        },
        {
        name: "Tandem Trip",
        type: "teamwork",
        shortDesc: "When you make a trip against an opponent threatened by any ally, roll twice and take the higher result",
        longDesc: "Whenever you attempt a trip combat maneuver against an enemy threatened by an ally with this feat, you roll twice and take the better result.",
        prereq: "",
        },
        {
        name: "Target of Opportunity",
        type: "teamwork",
        shortDesc: "When an ally hits with a ranged attack, you may make an attack as an immediate action",
        longDesc: "When an ally who also has this feat makes a ranged attack and hits an opponent within 30 feet of you, you can spend an immediate action to make a single ranged attack against that opponent. Your ranged weapon must be in hand, loaded, and ready to be fired or thrown for you to make the ranged attack.",
        prereq: "",
        },
        {
        name: "Underhanded Teamwork",
        type: "teamwork",
        shortDesc: "Whenever an ally who also has this feat performs a dirty trick combat maneuver against a foe you both threaten, you can use an immediate action to increase the inflicted condition's duration by 1 round.",
        longDesc: "Whenever an ally who also has this feat performs a dirty trick combat maneuver against a foe you both threaten, you can use an immediate action to increase the inflicted condition's duration by 1 round.",
        prereq: "",
        },
        {
        name: "Improved Underhanded Teamwork",
        type: "teamwork",
        shortDesc: "Whenever an ally who also has this feat performs the dirty trick combat maneuver against a foe that you both threaten, you may attempt a dirty trick combat maneuver against the same foe as an immediate action to inflict a second condition. If the foe uses an action to remove the first condition, it also removes the condition imposed by your immediate action.",
        longDesc: "Whenever an ally who also has this feat performs the dirty trick combat maneuver against a foe that you both threaten, you may attempt a dirty trick combat maneuver against the same foe as an immediate action to inflict a second condition. If the foe uses an action to remove the first condition, it also removes the condition imposed by your immediate action.",
        prereq: "Underhanded Teamwork",
        },
        {
        name: "Wild Flanking",
        type: "teamwork",
        shortDesc: "When flanking, you use your position to rain grievous blows upon a trapped foe, though you have little regard to the well-being of your flanking partner as you wildly hack away",
        longDesc: "When you are flanking an opponent with an ally who also possesses this feat, you can throw yourself into your attacks in such a way that your opponent takes extra damage, at the risk of these attacks striking your ally as well. When you choose to use this feat, check the results of your attack roll against both your opponent's AC and your ally's AC. If you hit your opponent, you deal bonus damage as though you were using Power Attack. If you hit your ally, the ally takes no damage from your attack except this bonus damage. It is possible to hit both your enemy and your abettor with one attack. Extra damage from this feat stacks with Power Attack.",
        prereq: "",
        },
        {
        name: "Improved Critical",
        type: "martial",
        shortDesc: "Double the threat range of one weapon",
        longDesc: "Select a weapon type (augmenting, light, one-handed, two-handed, primitive, tech, armament, rays) When using the weapon type you selected, your threat range is doubled. If you have another ability that doubles your critical threat range, this instead grants a flat +1 bonus to critical threat range. This feat never doubles critical threat ranges gained from flat increases (Eg: +1 to critical threat range)",
        prereq: "",
        repeatable:true,
        },
        {
        name: "Accursed Critical",
        type: "magic",
        shortDesc: "Confirm a critical hit and cast a curse as part of the attack.",
        longDesc: "When you confirm a critical hit with a spell or spell-like ability, you may cast a control spell that only affects a single target and has a casting time of a standard action or less on them as an immediate action. This cost 2x the normal spell points. After using this feat, you are staggered on your next turn. The spell cast must be a control only spell, it cannot have additional tags.",
        prereq: "",
        },
        {
            name: "Magical Surge",
            type: "magic",
            longDesc: "Whenever you cast a critical spell, you gain 10 spell power until the end of your next turn. This stacks.",
            prereq: "",
        },
        {
        name: "Bleeding Critical",
        type: "martial",
        shortDesc: "Whenever you score a critical hit, the target takes 2d6 bleed",
        longDesc: "[critical feat]Whenever you score a critical hit with a slashing or piercing weapon, your opponent takes 2d6 points of bleed damage each round on his turn, in addition to the damage dealt by the critical hit. Bleed damage can be stopped by a DC 15 Heal skill check or through any magical healing. The effects of this feat stack.",
        prereq: "",
        additionalInfo:"You can only apply the effects of a single critical feat to a critical hit"
        },
        {
        name: "Blinding Critical",
        type: "martial",
        shortDesc: "Whenever you score a critical hit, the target is blinded",
        longDesc: "[critical feat]Whenever you score a critical hit, your opponent is permanently blinded. A successful Fortitude save reduces this to dazzled for 1d4 rounds. The DC of this Fortitude save is equal to 10 + your base attack bonus. This feat has no effect on creatures that do not rely on eyes for sight or creatures with more than two eyes (although multiple critical hits might cause blindness, at the GM's discretion). Blindness can be cured by heal, regeneration, remove blindness, or similar abilities.",
        prereq: "",
        additionalInfo:"You can only apply the effects of a single critical feat to a critical hit"
        },
        {
        name: "Crippling Critical",
        type: "martial",
        shortDesc: "Whenever you score a critical hit, the target's speed is halved",
        longDesc: "[critical feat]Whenever you score a critical hit against an opponent, its speed is halved for 1 minute. A successful Fortitude save reduces this duration to 1d4 rounds. The DC of this save is equal to 10 + your base attack bonus. Against creatures with multiple types of movement, you must choose which movement type to affect. A flying creature hit by this attack must make a DC 10 Fly check to remain airborne, and has its maneuverability reduced by one step.",
        prereq: "",
        additionalInfo:"You can only apply the effects of a single critical feat to a critical hit"
        },
        {
        name: "Deafening Critical",
        type: "martial",
        shortDesc: "Whenever you score a critical hit, the target is deafened",
        longDesc: "[critical feat]Whenever you score a critical hit against an opponent, the victim is permanently deafened. A successful Fortitude save reduces the deafness to 1 round. The DC of this Fortitude save is equal to 10 + your base attack bonus. This feat has no effect on deaf creatures. This deafness can be cured by heal, regeneration, remove deafness, or a similar ability.",
        prereq: "",
        additionalInfo:"You can only apply the effects of a single critical feat to a critical hit"
        },
        {
        name: "Exhausting Critical",
        type: "martial",
        shortDesc: "Whenever you score a critical hit, the target is exhausted",
        longDesc: "[critical feat]When you score a critical hit on a foe, your target immediately becomes exhausted. This feat has no effect on exhausted creatures.",
        prereq: "",
        additionalInfo:"You can only apply the effects of a single critical feat to a critical hit"
        },
        {
        name: "Impaling Critical",
        type: "martial",
        shortDesc: "May impale and deal extra damage to opponent with a critical hit",
        longDesc: "[critical feat]Whenever you score a critical hit with the selected piercing melee weapon, you can impale your opponent on your weapon. While your opponent is impaled in this way, each time he starts his turn, you deal damage equal to your weapon's damage dice plus the extra damage dice from your weapon's properties. As an immediate action, you can pull your weapon out of your opponent. If your opponent is ever outside your reach, you must spend a free action to let go of your weapon or pull it out of him. Your opponent can also spend a move action to pull your weapon out. When the weapon comes out, your opponent takes damage as if starting his turn impaled. While you impale your opponent with your weapon, you cannot use it to attack, and you must hold on to it.",
        prereq: "",
        additionalInfo:"You can only apply the effects of a single critical feat to a critical hit"
        },
        {
        name: "Improved Impaling Critical",
        type: "martial",
        shortDesc: "Impaled opponent must succeed at a grapple maneuver to pull your weapon out",
        longDesc: "[critical feat]While you are using Impaling Critical to impale an opponent, and you are still holding onto that weapon, that opponent must succeed at a grapple combat maneuver check against you to pull your weapon out. If you have let go of your weapon, the impaled opponent must spend a standard action to remove the weapon. Until the opponent pulls the weapon out, his speed in all modes is halved and his maneuverability, if any, is reduced by one step. When the weapon comes out, instead of dealing the damage normal for Impaling Critical, you can deal bleed damage equal to your weapon's damage dice result once per round at the start of that opponent's turn.",
        prereq: "Impaling Critical",
        additionalInfo:"You can only apply the effects of a single critical feat to a critical hit"
        },
        {
        name: "Sickening Critical",
        type: "martial",
        shortDesc: "Whenever you score a critical hit, the target is sickened",
        longDesc: "[critical feat]Whenever you score a critical hit, your opponent becomes sickened for 1 minute. The effects of this feat do not stack. Additional hits instead add to the effect's duration.",
        prereq: "",
        additionalInfo:"You can only apply the effects of a single critical feat to a critical hit"
        },
        {
        name: "Staggering Critical",
        type: "martial",
        shortDesc: "Whenever you score a critical hit, the target is staggered",
        longDesc: "[critical feat]Whenever you score a critical hit, your opponent becomes staggered for 1d4+1 rounds. A successful Fortitude save reduces the duration to 1 round. The DC of this Fortitude save is equal to 10 + your base attack bonus. The effects of this feat do not stack. Additional hits instead add to the duration.",
        prereq: "",
        additionalInfo:"You can only apply the effects of a single critical feat to a critical hit"
        },
        {
            name: "Staggering Blow",
            type: "martial",
            shortDesc: "Whenever you score a critical hit, the target is staggered",
            longDesc: "When you attack a foe using Vital Strike, you can choose to take a -2 penalty on your attack roll to also make the attack a staggering strike. You must make this choice before making the attack roll. If your attack roll is successful, your target must succeed at a Fortitude saving throw (DC = 10 + 1/2 your character level + your Strength modifier) or be staggered until the start of your next turn. Once a creature that failed its save recovers from the effects of your staggering blow, it is immune to the effects of this feat for 24 hours. Constructs, oozes, plants, undead, incorporeal creatures, and creatures that are immune to critical hits are immune to this effect.",
            prereq: "Vital Strike",
        },
        {
        name: "Stunning Critical",
        type: "martial",
        shortDesc: "Whenever you score a critical hit, the target is stunned",
        longDesc: "[critical feat]Whenever you score a critical hit, your opponent becomes stunned for 1d4 rounds. A successful Fortitude save reduces this to staggered for 1d4 rounds. The DC of this Fortitude save is equal to 10 + your base attack bonus. The effects of this feat do not stack. Additional hits instead add to the duration.",
        prereq: "",
        additionalInfo:"You can only apply the effects of a single critical feat to a critical hit"
        },
        {
            name: "Flaying Critical",
            type: "martial",
            shortDesc: "Whenever you score a critical hit, the target is stunned",
            longDesc: "[critical feat]Whenever you score a critical hit, your opponent takes a -2 penalty to its natural armor bonus for the duration of the encounter. This penalty is cumulative, but cannot reduce an opponent's natural armor bonus below 0.",
            prereq: "",
            additionalInfo:"You can only apply the effects of a single critical feat to a critical hit"
        },
        {
            name: "Flanking Foil",
            type: "martial",
            shortDesc: "Whenever you score a critical hit, the target is staggered",
            longDesc: "Whenever you hit an adjacent opponent with a melee attack, until the start of your next turn, that opponent does not gain any flanking bonus on attack rolls while it is flanking you and cannot deal sneak attack damage to you. It can still provide a flank for its allies.",
            prereq: "",
        },
        {
        name: "Tiring Critical",
        type: "martial",
        shortDesc: "Whenever you score a critical hit, the target is fatigued",
        longDesc: "[critical feat]Whenever you score a critical hit, your opponent becomes fatigued. This feat has no additional effect on a fatigued or exhausted creature.",
        prereq: "",
        additionalInfo:"You can only apply the effects of a single critical feat to a critical hit"
        },
        {
            name: "Censoring Critical",
            type: "martial",
            shortDesc: "Whenever you score a critical hit, the target is fatigued",
            longDesc: "[critical feat]Whenever you score a critical hit against an opponent, the victim is unable to speak for 1d4+1 rounds. This prevents spellcasters from using spells with verbal components. A successful Fortitude saving throw reduces this muteness to 1 round. The DC of this Fortitude save is equal to 10 + your base attack bonus.",
            prereq: "",
            additionalInfo:"You can only apply the effects of a single critical feat to a critical hit"
        },
        {
            name: "Blighted Critical",
            type: "magic",
            shortDesc: "Whenever you score a critical hit, the target is fatigued",
            longDesc: "Whenever you confirm a critical hit with a spell against an opponent, the victim gains a random minor spellblight. (https://www.d20pfsrd.com/magic/variant-magic-rules/spellblights/)",
            prereq: "",            
        },
        {
            name: "Greater Blighted Critical",
            type: "magic",
            shortDesc: "Whenever you score a critical hit, the target is fatigued",
            longDesc: "Whenever you confirm a critical hit with a spell against an opponent, the victim gains a random major spellblight instead. (https://www.d20pfsrd.com/magic/variant-magic-rules/spellblights/)",
            prereq: "Blighted Critical",
        },
        {
            name: "Blighted Critical Mastery",
            type: "magic",
            shortDesc: "Whenever you score a critical hit, the target is fatigued",
            longDesc: "whenever you apply a spellblight through blighted critical or greater blighted critical you can choose which blight to inflict. (https://www.d20pfsrd.com/magic/variant-magic-rules/spellblights/)",
            prereq: "Greater Blighted Critical",
        },
        {
        name: "Channel Hate",
        type: "magic",
        shortDesc: "As a standard action, expend one channel energy to grant one creature within 30-ft. with vengeful outrage. If you expend an extra use of channel energy the target does not gain a second saving throw against this effect if you designate the target's friend or loved one as its hated enemy.",
        longDesc: "As a standard action, you can expend one use of your channel energy ability to affect a single creature within 30 feet as if you had cast vengeful outrage (caster level equal to your level). Upon obtaining channel energy 9d6, you can affect a number of creatures within 30 feet equal to your second highest mental modifier (minimum 2 creatures) with this feat instead. If you expend an extra use of channel energy when using this feat, the target does not gain a second saving throw against this effect if you designate the target's friend or loved one as its hated enemy.",
        prereq: "",
        perkPrereq:["Channel Energy", "Epic Channel Energy"]
        },
        {
        name: "Channel Ray",
        type: "magic",
        shortDesc: "Channel energy in a ray instead of a burst.",
        longDesc: "When you channel energy, you can project a ray from your holy symbol instead of creating a burst. You must succeed at a ranged touch attack to hit an unwilling target; your target is then affected by the channeled energy as normal and receives a saving throw. You need not make an attack roll to affect a willing creature with the ray. The ray has a range of 30 feet per channel energy die, and its save DC is increased by 2, and its dice increases to 1d8.",
        prereq: "",
        perkPrereq:["Channel Energy", "Epic Channel Energy", "Fervor"]
        },
        {
        name: "Channeled Revival",
        type: "magic",
        shortDesc: "May expend channel energy to cast breath of life.",
        longDesc: "As a full-round action that provokes attacks of opportunity you can expend three uses of your channel energy, lay on hands, touch of corruption, or Fervor, (max dice rolled only) class feature to restore a dead creature to life as if you had cast the breath of life spell.",
        prereq: "",
        perkPrereq:["Channel Energy", "Epic Channel Energy", "Lay On Hands", "Touch of Corruption", "Fervor"],
        },
        {
        name: "Channeled Shield Wall",
        type: "magic",
        shortDesc: "Enhance your shield and the shields of allies adjacent to you.",
        longDesc: "As a swift action, you can spend a use of a healing Prereq to grant yourself a +2 deflection bonus while using a shield. This bonus lasts 1 round per level. While you benefit from this bonus, allies with shields also gain a +2 deflection bonus while they are adjacent to you.",
        prereq: "",
        perkPrereq:["Channel Energy", "Epic Channel Energy", "Hexes", "Bardic Performance", "Hemomancy", "Fervor", "Guardian's Shield", "Lay On Hands", "Touch of Corruption"],
        },
        {
        name: "Channel Surge",
        type: "magic",
        shortDesc: "You may expend two uses of channel energy, lay on hands, or healing hex, as a full-round action to increase the amount of healing or damage you do by +50%.",
        longDesc: "When you use a healing ability prereq, you may expend two uses of the ability to increase the amount of healing or damage (choose one if it would do both) the ability does by +50%, as the empower feat.",
        prereq: "",
        perkPrereq:["Channel Energy", "Epic Channel Energy", "Hexes", "Bardic Performance", "Hemomancy", "Fervor", "Guardian's Shield", "Lay On Hands", "Touch of Corruption"],
        },
        {
        name: "Channel Viciousness",
        type: "magic",
        shortDesc: "As a standard action, expend one channel energy to grant melee weapons of allies within 30-ft. of you the vicious weapon special ability for 1 minute × your Cha bonus (minimum 1 minute).",
        longDesc: "As a standard action, you can expend one of your uses of use channel energy, Lay on Hands, Fervor, Hemomancy, Healing Hex/Healing Aura, or Soothing Song, to charge the melee weapons of allies who would have been affected if you had used the ability. Affected melee weapons gain the vicious magic weapon special ability for rounds equal to your second highest mental modifier (minimum 1).",
        prereq: "",
        perkPrereq:["Channel Energy", "Epic Channel Energy", "Hexes", "Bardic Performance", "Hemomancy", "Fervor", "Guardian's Shield", "Lay On Hands", "Touch of Corruption"],
        },
        {
            name: "Adept Channel",
            type: "magic",
            shortDesc: "",
            longDesc: "Increase the dice rolled for your prerequisite healing ability by 2. You must still spend the spell point cost associated with these extra dice.",
            prereq: "",
            perkPrereq:["Channel Energy", "Epic Channel Energy", "Hexes", "Fervor", "Guardian's Shield", "Lay On Hands"],
        },
        {
            name: "Adept Champion",
            type: "martial",
            shortDesc: "",
            longDesc: "As a swift action at the start of your turn you can forgo the bonus on damage rolls and instead gain half the bonus as a bonus on combat maneuver checks against the target of your smite. Your smite returns to normal at the start of your next turn.",
            prereq: "",
            perkPrereq:["Smite"],
        },
        {
            name: "Amplified Hex",
            type: "magic",
            shortDesc: "",
            longDesc: "You can augment the power of a hex by expending a spell slot or prepared spell of at least 1st level. When you amplify a hex, you can choose one: increase its saving throw DC by 1, double its range (if it already has at least a 10-foot range), or increase its duration by 1 round (if it already has a duration of at least 1 round). Each additional time you use this ability in the same day, it requires a prepared spell or spell slot 1 level higher (a 2nd-level spell the second time, a 3rdlevel spell the third time, and so on).",
            prereq: "",
            perkPrereq:["Hexes","Misfortune"],
        },
        {
        name: "Fateful Channel",
        type: "magic",
        shortDesc: "When you channel positive energy to heal living creatures, you grant each creature you heal the ability to roll twice and take the better result on a single attack roll, skill check, or saving throw of their choice within a number of rounds equal to your Cha bonus (minimum 1). Multiple uses of this ability do not stack, but they do reset the effect's duration. A creature can only benefit from one instance of this channel effect at a time.",
        longDesc: "When you use channel positive energy, Lay on Hands, Fervor, Hemomancy, Healing Hex/Healing Aura, or Soothing Song, you grant each creature you heal the ability to roll twice and take the better result on a single attack roll, skill check, or saving throw of their choice within a number of rounds equal to your second highest mental modifier (minimum 1). Multiple uses of this ability do not stack, but they do reset the effect's duration. A creature can only benefit from one instance of this effect at a time.",
        prereq: "",
        perkPrereq:["Channel Energy", "Epic Channel Energy", "Hexes", "Bardic Performance", "Hemomancy", "Fervor", "Guardian's Shield", "Lay On Hands"],
        },
        {
        name: "Forceful Channel",
        type: "magic",
        shortDesc: "1/day when you channel negative energy to deal damage to living creatures, you can cause affected creatures to make Fort saves instead of Will saves. Affected creatures take the amount of damage channeled in force damage (a successful save halves). Creatures that fail their saves are also knocked prone.",
        longDesc: "For Level spell points when use channel negative energy, Hemomancy, or Touch Of Corruption you can cause affected creatures to make Fortitude saves instead of Will saves (or a fortitude save if it would be allowed none). Affected creatures take the amount of damage channeled in force damage (a successful save halves). Creatures that fail their saves are also knocked prone. Hemomancy no longer heals if you use this.",
        prereq: "",
        perkPrereq:["Channel Energy", "Epic Channel Energy", "Touch of Corruption", "Hemomancy", "Fervor"],
        },
        {
        name: "Liberation Channel",
        type: "magic",
        shortDesc: "When you channel positive energy, any creature healed by the channel also gains the effect of freedom of movement for a number of rounds equal to half your highest mental modifier (minimum 1 round).",
        longDesc: "When you heal using the prereq ability, you can spend 2 additional uses of the ability to cause any creature healed to also gain the effect of freedom of movement for a number of rounds equal to your second highest mental modifier or dice rolled, whichever is lower (minimum 1 round). This effect has a caster level equal to your effective level.",
        prereq: "",
        perkPrereq:["Channel Energy", "Epic Channel Energy", "Hexes", "Bardic Performance", "Hemomancy", "Fervor", "Guardian's Shield", "Lay On Hands"],
        },
        {
        name: "Selective Channeling",
        type: "magic",
        shortDesc: "Choose whom to affect with channel energy",
        longDesc: "When you use your healing prereq perk, you can choose a number of targets in the area up to your second highest mental modifier, these targets are not affected by your ability.",
        prereq: "",
        perkPrereq:["Channel Energy", "Epic Channel Energy", "Hexes", "Fervor"],
        key:true,
        },
        {
        name: "Siphon Channel",
        type: "magic",
        shortDesc: "1/day when you channel negative energy to damage living creatures, you gain a number of temporary hit points equal to half the die result of your channeled energy +1 per creature affected by the channeled energy. For each affected creature that did not succeed at its saving throw against the channeled energy, you gain an additional temporary hit point. These temporary hit points disappear after 1 hour.",
        longDesc: "For level spell points when you deal damage with your prereq ability, you gain a number of temporary hit points equal to half the die result of your ability. If multiple creatures are affected you increase the amount by +1 per dice rolled for each additional enemy affected. For each affected creature that was allowed a saving throw, but failed, you gain an additional temporary hit point per dice rolled. These temporary hit points disappear after 1 hour and do not stack with themselves.",
        prereq: "",
        perkPrereq:["Channel Energy", "Epic Channel Energy", "Touch Of Corruption", "Hemomancy"],
        },
        {
        name: "Steelskin Channel",
        type: "magic",
        shortDesc: "1/day when you channel positive energy to heal living creatures, you can grant healed creatures DR 2/— (or increase their DR/— by 2, if they already have DR/—) for a number of rounds equal to your Cha bonus (minimum 1 round).",
        longDesc: "For level spell points when you heal using the prerequisite ability, you can grant healed creatures damage resistance. Affected creatures gain DR /- (or increase their DR/-, if they already have DR/-) by an amount equal to your channel dice amount for a number of rounds equal to your second highest mental modifier (minimum 1 round).",
        prereq: "",
        perkPrereq:["Channel Energy", "Epic Channel Energy", "Hexes", "Bardic Performance", "Hemomancy", "Fervor", "Guardian's Shield", "Lay On Hands",],
        },
        {
        name: "Trailblazing Channel",
        type: "magic",
        shortDesc: "1/day when you channel positive energy, allow healed creatures to ignore difficult terrain for minutes equal to your Cha modifier (minimum 1 minute).",
        longDesc: "For level spell points when you heal using the prerequisite ability, you can cause healed creatures to be unimpeded by difficult terrain for a number of rounds equal to your second highest mental modifier (minimum 1 round).",
        prereq: "",
        perkPrereq:["Channel Energy", "Epic Channel Energy", "Lay On Hands", "Hemomancy", "Fervor", "Hexes", "Bardic Performance", "Guardian's Shield"],
        },
        {
            name: "Channel Angelfire",
            type: "magic",
            shortDesc: "1/day when you channel positive energy, allow healed creatures to ignore difficult terrain for minutes equal to your Cha modifier (minimum 1 minute).",
            longDesc: "Whenever an enemy is within the area of your channel energy they are dazzled for 1 round.",
            prereq: "",
            perkPrereq:["Channel Energy", "Epic Channel Energy", "Fervor",],
        },
        {
        name: "Deadly Agility",
        type: "martial",
        key:true,
        shortDesc: "You can use dexterity to damage with all weapons you can use weapon finesse with",
        longDesc: "You can use dexterity to damage with all melee weapons you can use dexterity to attack with. This damage multipier is increased or decreased the same way strength would be if the weapon is wielded in two hands or your off-hand.",
        prereq: "",
        },
        {
        name: "Deadly Pairing",
        type: "teamwork",
        shortDesc: "Whenever you and another ally flank a creature both you and that ally increase the critical threat range of your weapons by 1. This additional critical threat range is not multiplied by abilities such as keen or the Improved Critical feat and is applied after abilities such as those are applied.",
        longDesc: "Whenever you and another ally flank a creature both you and that ally increase the critical threat range of your weapons by 1. This additional critical threat range is not multiplied by abilities such as keen or the Improved Critical feat and is applied after abilities such as those are applied.",
        prereq: "",
        },
        {
        name: "Defensive Expertise",
        type: "martial",
        shortDesc: "Your shield bonus to armor class applies against touch attacks. Additionally, you may add the enhancement bonus of your shield (if any) as a competence bonus to Reflex saves.",
        longDesc: "Your shield bonus to armor class applies against touch attacks. Additionally, you may add the enhancement bonus of your shield (if any) as a competence bonus to Reflex saves.",
        prereq: "",
        },
        {
        name: "Haft Strike",
        type: "martial",
        shortDesc: "Take a -2 penalty to AC to attack adjacent creatures with a reach weapon",
        longDesc: "Take a -2 penalty to AC to attack adjacent creatures with a reach weapon.",
        prereq: "",
        },
        {
        name: "Martial Charge",
        type: "martial",
        shortDesc: "Initiate strike at the end of a charge",
        longDesc: "As a full-round action, you can make a special charge attack. First, move up to twice your speed in a straight line towards a creature, obeying the normal restrictions on movement during a charge, as well as applying any effects or benefits you might have to such movement. Then, at the end of your movement, you can initiate a strike on the creature you moved towards with an initiation action of 1 standard action. You gain a +2 bonus on attack rolls during the strike, and take a -2 penalty to your AC until the start of your next turn. During the strike, you do not gain any other benefits you would have gained for charging, such as pounce.",
        prereq: "",
        },
        {
        name: "Prodigious Two-Weapon Fighting",
        type: "martial",
        shortDesc: "",
        longDesc: "You can fight with a one-handed weapon in your off-hand as if it were a light weapon, and you can use your strength modifier instead of dexterity modifier while determining the penalties for two weapon fighting.",
        prereq: "",
        },
        {
        name: "Martial Power",
        type: "martial",
        shortDesc: "Take a penalty on attack rolls to gain temporary hit points",
        longDesc: "You can choose to take a -1 penalty on attack rolls and combat maneuver checks to gain 2 temporary hit points. This bonus is increased by half (50%) when you are using a shield of any kind. When your base attack bonus reaches +3 and every +2 thereafter, the penalty increases by -1 and the temporary hit point bonus increases by 2. You can only choose to use this feat when you declare that you are making an attack or a full-attack action with a melee weapon, or when you are initiating a maneuver. The penalty to attack rolls and temporary hit points gained from use of this feat last until the start of your next turn.",
        prereq: "",
        key:true,
        },
        {
        name: "Nemean Lion Hide",
        type: "martial",
        shortDesc: "Take a penalty on attack rolls to gain temporary hit points",
        longDesc: "Whenever you use the Martial Power feat you also gain damage reduction/- equal to your half your highest mental modifier until the start of your next turn. If you are maintaining a Golden Lion or Iron Tortoise stance, this instead becomes damage reduction equal to your full highest mental modifier.",
        prereq: "Martial Power",
        },
        {
        name: "Mixed Combat",
        type: "martial",
        shortDesc: "You can sheathe a weapon as a free action that does not provoke attacks of opportunity, even if it isn't your turn. If you hit a creature with a melee attack, your attacks with ranged weapons until the end of your turn do not provoke attacks of opportunity from that creature.",
        longDesc: "You can sheathe a weapon as a free action that does not provoke attacks of opportunity, even if it isn't your turn. If you hit a creature with a melee attack, your attacks with ranged weapons until the end of your turn do not provoke attacks of opportunity from that creature.",
        prereq: "",
        },
        {
        name: "Seize the Opportunity",
        type: "martial",
        shortDesc: "When you make an attack of opportunity, you can take an attack action (such as when using the Vital Strike feat) or attempt a combat maneuver (such as a bull rush, disarm or dirty trick) in place of your attack of opportunity. This feat does not allow you to move when it isn't your turn.",
        longDesc: "",
        prereq: "",
        key:true,
        },
        {
        name: "Accursed Hex",
        type: "magic",
        shortDesc: "When you target a creature with a hex that cannot target the same creature more than once per day, and that creature succeeds at its saving throw against the hex's effect, you can target the creature with the same hex a second time before the end of your next turn. If the second attempt fails, you can make no further attempts to target that creature with the same hex for 1 day.",
        longDesc: "When you target a creature with a hex that cannot target the same creature more than once per day, and that creature succeeds at its saving throw against the hex's effect, you can target the creature with the same hex a second time before the end of your next turn. If the second attempt fails, you can make no further attempts to target that creature with the same hex for 1 day.",
        prereq: "",
        perkPrereq:["Hexes","Misfortune"],
        },
        {
            name: "Faster Summons",
            type: "magic",
            shortDesc: "When you target a creature with a hex that cannot target the same creature more than once per day, and that creature succeeds at its saving throw against the hex's effect, you can target the creature with the same hex a second time before the end of your next turn. If the second attempt fails, you can make no further attempts to target that creature with the same hex for 1 day.",
            longDesc: "When you cast a conjuration(summoning) spell that summons one or more monsters, it has its casting time reduced by 1 step, (1 round to 1 full-round, 1 full-round to standard, etc.)",
            prereq: "",
            perkRateUp:["Summon Monster"],
        },
        {
        name: "Cut from the Air",
        type: "martial",
        shortDesc: "",
        longDesc: "When a ranged attack is made against you or a target adjacent to you, you can cut the weapon (or ammunition) out of the air, deflecting the attack so the target takes no damage. As an attack of opportunity, make a melee attack roll at your highest bonus. If the result is greater than the attack roll total of the ranged attack, the attack is deflected. You must be aware of the attack and not flat-footed. Unusually massive ranged weapons (such as boulders or ballista bolts) and ranged attacks generated by spell effects cannot be deflected.",
        prereq: "",
        },
        {
        name: "Smash from the Air",
        type: "martial",
        shortDesc: "",
        longDesc: "You can use Cut from the Air against unusually massive ranged weapons (such as boulders or ballista bolts) and ranged attacks generated by spell effects. Spell effects that do not require attack rolls cannot be deflected.",
        prereq: "Cut from the Air",
        },
        {
            name: "Spellcut",
            type: "martial",
            shortDesc: "Once per round, you can use your base attack bonus in place of your total saving throw bonus for a spell, spell-like ability, or supernatural ability that either allows a Reflex save or is not a melee attack and targets only you.",
            longDesc: "",
            prereq: "Smash from the Air",
        },
]
export const metamagic = [
    {
    name: "Authoritative Spell",
    prereq: "",
    cost: "2",
    type: "metamagic",
    shortDesc: "You can alter any spell that targets a single creature to become an authoritative spell. When you cast an authoritative spell, choose one of the following activities to prohibit: move closer to you, move away from you, make a melee weapon attack, make a ranged weapon attack, cast an offensive spell, or cast a non-offensive spell. A creature that is affected by the spell and fails its saving throw against that spell (if the spell allows a saving throw to resist) cannot perform any action of the selected type on its next turn. An authoritative spell gains the lawful descriptor, and the additional effect is a mind-affecting compulsion effect.",
    longDesc: `You can alter any spell that targets a single creature to become an authoritative spell. When you cast an authoritative spell, choose one of the following activities to prohibit: move closer to you, move away from you, make a melee weapon attack, make a ranged weapon attack, cast an offensive spell, or cast a nonoffensive spell. A creature that is affected by the spell and fails its saving throw against that spell (if the spell allows a saving throw to resist) cannot perform any action of the selected type on its next turn. An authoritative spell gains the lawful descriptor, and the additional effect is a mind-affecting compulsion effect. An authoritative spell uses a spell slot 2 levels higher than the spell's normal spell level. Spells with the chaotic descriptor can't be authoritative spells.`,
    },
    {
        name: "Apocalyptic Spell",
        prereq: "",
        cost: "1",
        type: "metamagic",
        shortDesc: "",
        longDesc: `You can alter a spell with an area of effect and a duration of instantaneous to become an apocalyptic spell.
        \nWhen you cast the spell, the area affected by the spell's instantaneous effect becomes ruined and devastated in appearance. All surfaces in the area are treated as difficult terrain, and Climb, Fly, and Swim checks attempted in the area take a penalty equal to the spell's original spell level.    
        \nThe difficult terrain and skill penalties last for a number of rounds equal to the spell's original spell level. An apocalyptic spell gains the evil descriptor. Spells with the good descriptor can't be apocalyptic spells.`,
    },
    {
    name: "Blissful Spell",
    prereq: "",
    cost: "1",
    type: "metamagic",
    shortDesc: "You can alter any spell that targets a single creature to become a blissful spell, although the exact effects of the metamagic vary depending on whether the spell is beneficial or offensive. A creature successfully hit by an offensive blissful spell (if the spell requires an attack roll) or that fails its saving throw against an offensive blissful spell takes a -2 penalty on attack rolls and weapon damage rolls for 1 round. A beneficial blissful spell instead grants affected creatures a +2 morale bonus on skill checks and saving throws for 1 round in addition to its normal effects. A blissful spell gains the good descriptor, and the additional effect is a mind-affecting compulsion effect.",
    longDesc: `You can alter any spell that targets a single creature to become a blissful spell, although the exact effects of the metamagic vary depending on whether the spell is beneficial or offensive. A creature successfully hit by an offensive blissful spell (if the spell requires an attack roll) or that fails its saving throw against an offensive blissful spell takes a -2 penalty on attack rolls and weapon damage rolls for 1 round. A beneficial blissful spell instead grants affected creatures a +2 morale bonus on skill checks and saving throws for 1 round in addition to its normal effects. A blissful spell gains the good descriptor, and the additional effect is a mind-affecting compulsion effect. A blissful spell uses a spell slot 1 level higher than the spell's normal spell level. Spells with the evil descriptor can't be blissful spells.`,
    },
    {
        name: "Breakshield Spell",
        prereq: "",
        cost: "0",
        type: "metamagic",
        shortDesc: "",
        longDesc: `This feat can be applied only to spells with the water, earth, or wind descriptor. You can modify the spell to surround you with a thin sheath of the element in addition to the spell's normal effect. Depending on the element you gain a different kind of damage reduction equal to the spells level for 1 round after you finish casting the spell. Water grants DR/piercing, earth gives DR/blundgeoning, and air gives DR/slashing.`,
    },
    {
        name: "Brisk Spell",
        prereq: "",
        cost: "0",
        type: "metamagic",
        shortDesc: "",
        longDesc: `You can alter spells that grant a creature a movement type it doesn't normally have to increase the speed for that movement type by 10 feet.`,
    },
    {
    name: "Bouncing Spell",
    prereq: "",
    cost: "1",
    type: "metamagic",
    shortDesc: "You can direct a failed spell against a different target.",
    longDesc: `Whenever a bouncing spell targeting a single creature has no effect on its intended target (whether due to spell resistance or a successful saving throw) you may, as a swift action, redirect it to target another eligible creature within range. The redirected spell behaves in all ways as if its new target were the original target for the spell. Spells that affect a target in any way (including a lesser effect from a successful saving throw) may not be redirected in this manner. A bouncing spell uses up a spell slot one level higher than the spell's actual level.`,
    },
    {
    name: "Burning Spell",
    prereq: "",
    cost: "2",
    type: "metamagic",
    shortDesc: "Spell with the [acid] or [fire] descriptor deals extra damage the next round.",
    longDesc: `The acid or fire effects of the affected spell adhere to the creature, causing more damage the next round. When a creature takes acid or fire damage from the affected spell, that creature takes damage equal to 2 x the spell's actual level at the start of its next turn. The damage is acid or fire, as determined by the spell's descriptor. If a burning spell has both the fire and acid descriptor, the caster chooses what kind of damage is dealt by the burning spell effect. A burning spell uses up a slot two levels higher than the spell's actual level.`,
    },
    {
    name: "Centered Spell",
    prereq: "",
    cost: "0",
    type: "metamagic",
    shortDesc: "You can center the area of a spell with an area effect and duration of instantaneous on you, and exclude yourself from the effects of the spell. Your familiar (if any) is also excluded from the effect, provided that it is in your square and at least one size category smaller than you.",
    longDesc: `You can center the area of a spell with an area effect and duration of instantaneous on you, and exclude yourself from the effects of the spell. A centered spell does not use up a higher-level spell slot than the spell's actual level.`,
    },
    {
        name: "Coaxing Spell",
        prereq: "",
        cost: "2",
        type: "metamagic",
        shortDesc: "",
        longDesc: `This feat only works with mind-affecting effects. A coaxing spell affects mindless oozes and vermin as if they weren't mindless, but has no effect on other creature types.`,
    },
    {
    name: "Cherry Blossom Spell",
    prereq: "",
    cost: "3",
    type: "metamagic",
    shortDesc: "When a living creature takes damage from the affected spell, that creature also takes 2 points of damage to Strength, Dexterity, and Constitution or 2 points of damage to Intelligence, Wisdom, and Charisma (your choice). If the spell does not normally allow a save, the target can attempt a Fortitude save to negate the effect. Ageless or immortal creatures are immune to this effect. This is a magical aging effect, but it does not alter the creature's true age—it merely simulates the effects of old age on the flesh or the reversion to a more infantile mental age.",
    longDesc: `When a living creature takes damage from the affected spell, that creature also takes 2 points of damage to Strength, Dexterity, and Constitution or 2 points of damage to Intelligence, Wisdom, and Charisma (your choice). If the spell does not normally allow a save, the target can attempt a Fortitude save to negate the effect. Ageless or immortal creatures are immune to this effect. This is a magical aging effect, but it does not alter the creature's true age—it merely simulates the effects of old age on the flesh or the reversion to a more infantile mental age. A cherry blossom spell uses up a slot 3 levels higher than the spell's actual level. Spells that don't deal damage don't benefit from this feat.`,
    },
    {
        name: "Concussive Spell",
        prereq: "",
        cost: "2",
        type: "metamagic",
        shortDesc: "",
        longDesc: `With sonic damage comes a concussive wave of energy that rattles creatures affected by the spell. A concussive spell causes creatures that take damage from a spell that has the sonic descriptor to take a -2 penalty on attack rolls, saving throws, skill checks, and ability checks for a number of rounds equal to the actual spell level of the spell. A concussive spell only affects spells with the sonic descriptor.`,
    },
    {
        name: "Consecrate Spell",
        prereq: "",
        cost: "2",
        type: "metamagic",
        shortDesc: "",
        longDesc: `A consecrated spell is treated as an empowered spell against evil creatures and creatures with the evil subtype (50% increased damage). Against all other creatures, this feat does not modify the spell in any way (for example, a consecrated fireball acts as a normal fireball against neutral or good creatures). You cannot cast spells with the evil descriptor with this feat.`,
    },
    {
        name: "Contingent Spell",
        prereq: "",
        cost: "2",
        type: "metamagic",
        shortDesc: "",
        longDesc: `A contingent spell infuses a target with a dormant healing or restorative spell that can trigger when the target needs it the most. This metamagic feat can be applied to only conjuration(healing) spells; or any harmless spell that can be used to remove ability score damage, ability score drain, or a negative condition or effect (including break enchantment, neutralize poison, and remove disease). When you cast a contingent spell, you must set a specific trigger that dictates under what circumstances the target is immediately subject to the spell's effects (for instance, “When the target dies, breath of life takes effect”). The contingent spell's effects can remain dormant within the target for up to 10 minutes per caster level you have. A creature can be infused with only one contingent spell at a time.`,
    },
    
    {
    name: "Dazing Spell",
    prereq: "",
    cost: "3",
    type: "metamagic",
    shortDesc: "You can daze creatures with the power of your spells.",
    longDesc: `You can modify a spell to daze a creature damaged by the spell. When a creature takes damage from this spell, they become dazed for a number of rounds equal to the original level of the spell. If the spell allows a saving throw, a successful save negates the daze effect. If the spell does not allow a save, the target can make a Will save to negate the daze effect. If the spell effect also causes the creature to become dazed, the duration of this metamagic effect is added to the duration of the spell. A dazing spell uses up a spell slot three levels higher than the spell's actual level. Spells that do not inflict damage do not benefit from this feat.`,
    },
    {
    name: "Delayed Spell",
    prereq: "",
    cost: "2",
    type: "metamagic",
    shortDesc: "You can set a spell to trigger on a delay.",
    longDesc: `A delayed spell can be activated as a swift action anytime within 1 minute per spell level of being cast. Only spells that target one or more squares or grid intersections can be affected by Delayed Spell, and the target (as well as any other variables determined at the time of casting) cannot be changed once the delayed spell is cast. You can have as many delayed spells as you wish at any given time, but only one spell can be triggered in a single swift action. Though a delayed spell does not manifest until it is triggered, it emits a magical aura as normal and can be identified with Knowledge (arcana) as a spell effect in place. A delayed spell uses up a spell slot 2 levels higher than the spell's actual level.`,
    },
    {
        name: "Detonating Spell",
        prereq: "",
        cost: "2",
        type: "metamagic",
        shortDesc: "",
        longDesc: `Your spell becomes volatile and explosive. You can only alter spells that target and deal damage to a single creature with this feat. If that spell successfully damages the target of the spell it explodes, dealing splash damage equal to the level of the spell cast to adjacent creatures. The splash damage dealt is of the same type the spell deals. This splash damage has none of the additional effects of the original spell.`,
    },
    {
    name: "Disruptive Spell",
    prereq: "",
    cost: "1",
    type: "metamagic",
    shortDesc: "Your magical energies cling to enemies, interfering with their spellcasting.",
    longDesc: `Targets affected by a disruptive spell must make concentration checks when using spells or spell-like abilities (DC equals the save DC of the disruptive spell plus the level of the spell being cast) for 1 round. Targets that avoid the spell's effects avoid this feat's effect as well. A disruptive spell uses up a spell slot one level higher than the spell's actual level.`,
    },
    {
        name: "Draining Spell",
        prereq: "",
        cost: "1",
        type: "metamagic",
        shortDesc: "",
        longDesc: `You gain temporary hit points equal to 1/3 of the hit point damage dealt by a draining spell. If the draining spell deals damage to multiple victims (such as a draining fireball), calculate the temporary hit points gained based on the victim that suffered the most damage. These temporary hit points do not stack with themselves and last for up to 1 hour. A draining spell uses up a spell slot 1 level higher than the spell's actual level. If you are a Dhampir or hemomancer this instead becomes 1/2 of the damage dealt.`,
    },
    {
    name: "Echoing Spell",
    prereq: "",
    cost: "3",
    type: "metamagic",
    shortDesc: "Cast a spell a second time.",
    longDesc: `When you cast an echoing spell, you retain much of the energy used to cast it, allowing you to cast the spell again later without expending spell points. You can apply augmentations to this echoed spell, but you must pay them seperately. You must cast it within the same day or the spell is lost. An echoing spell uses up a spell slot three levels higher than the spell's actual level.`,
    },
    {
        name: "Improved Echoing Spell",
        prereq: "Echoing Spell",
        cost: "3",
        type: "metamagic",
        shortDesc: "Cast a spell a second time.",
        longDesc: `When you cast an echoing spell, you can choose its normal benefit, or instead the spell automatically echos 1d4+1 rounds after you cast it. On this round the spell is cast again from the location you cast it, targetting the location or creature you targetted. Area of effect spells target the same place in space even if it fired at a specific creature. Spells that target specific creatures target them again as long as they are valid targets from the original source of the spell. Any rolls required use the original rolls made when casting the spell. An echoing spell used this way has its duration and effectiveness reduced by 50%, and any DC lowered by 4. You cannot use any augments on this echoed spell.`,
    },
    {
        name: "Eclipsed Spell",
        prereq: "",
        cost: "0",
        type: "metamagic",
        shortDesc: "",
        longDesc: `Only spells that create areas of light or darkness can be eclipsed spells. If the eclipsed spell creates an area that shines like a torch or raises the light level by one step, you can choose to have the spell lower the illumination level in the affected area by one step, functioning like darkness. If the eclipsed spell creates an area that shines like daylight or raises the light level by two steps, you can choose to have the spell lower the illumination level in the affected area by two steps and create an area of magical darkness, functioning like deeper darkness.
        \nIf the eclipsed spell lowers the illumination level in the affected area by one step, you can choose to have the spell cause the affected area to glow with normal light, functioning like light. If the eclipsed spell lowers the illumination level in the affected area by two steps, you can choose to have the spell cause the affected area to shed bright light, functioning like daylight.`,
    },
    {
        name: "Ectoplasmic Spell",
        prereq: "",
        cost: "1",
        type: "metamagic",
        shortDesc: "",
        longDesc: `An ectoplasmic spell has full effect against incorporeal or ethereal creatures.`,
    },
    {
    name: "Elemental Spell",
    prereq: "",
    key:true,
    cost: "1",
    type: "metamagic",
    shortDesc: "You can manipulate the elemental nature of your spells.",
    longDesc: `Choose one energy type: acid, cold, electricity, or fire. You may replace a spell's normal damage with that energy type or split the spell's damage, so that half is of that energy type and half is of its normal type. An elemental spell uses up a spell slot one level higher than the spell's actual level.`,
    },
    {
    name: "Empower Spell",
    key:true,
    prereq: "",
    cost: "2",
    type: "metamagic",
    shortDesc: "Increase spell variables by 50%",
    longDesc: `For damage spells, gain 50 spell power. For non-damage spells All variable, numeric effects of an empowered spell are increased by half, including bonuses to those dice rolls. Saving throws and opposed rolls are not affected, nor are spells without random variables. 
    \nAn empowered spell uses up a spell slot two levels higher than the spell's actual level.`,
    },
    {
    name: "Encouraging Spell",
    prereq: "",
    cost: "1",
    type: "metamagic",
    shortDesc: "Any morale bonus granted by an encouraging spell is increased by 1.",
    longDesc: `Any morale bonus granted by an encouraging spell is increased by 1. An encouraging spell uses up a spell slot 1 level higher than the spell's actual level.`,
    },
    {
    name: "Enlarge Spell",
    prereq: "",
    cost: "1",
    type: "metamagic",
    shortDesc: "Double spell range",
    longDesc: `You can alter a spell with a range of close, medium, or long to increase its range by 100%. An enlarged spell with a range of close now has a range of 50 ft. + 5 ft./ level, while medium-range spells have a range of 200 ft. + 20 ft./level and long-range spells have a range of 800 ft. + 80 ft./level. An enlarged spell uses up a spell slot one level higher than the spell's actual level. Spells whose ranges are not defined by distance, as well as spells whose ranges are not close, medium, or long, do not benefit from this feat.`,
    },
    {
    name: "Extend Spell",
    prereq: "",
    cost: "1",
    type: "metamagic",
    shortDesc: "Double spell duration",
    longDesc: `An extended spell lasts twice as long as normal. A spell with a duration of concentration, instantaneous, or permanent is not affected by this feat. An extended spell uses up a spell slot one level higher than the spell's actual level.`,
    },
    {
    name: "Fearsome Spell",
    prereq: "",
    cost: "2",
    type: "metamagic",
    shortDesc: "Spell damage causes the shaken condition",
    longDesc: `When a creature takes damage from a fearsome spell, if that creature failed its save against the spell, it becomes shaken for a number of rounds equal to the spell's original level. If the spell doesn't allow a save, creatures harmed by it can attempt a Will save (against the same DC the spell would have if it did allow a save) to negate the shaken effect. If the spell effect already causes creatures to become shaken, on a failed save, add the duration of this metamagic effect to the duration of the shaken condition imposed by the spell. A fearsome spell can't cause a creature to become frightened, even if that creature is already shaken. A fearsome spell uses up a spell slot 2 levels higher than the spell's actual level.`,
    },
    {
        name: "Flaring Spell",
        prereq: "",
        cost: "1",
        type: "metamagic",
        shortDesc: "",
        longDesc: `The electricity, fire, or light effects of the affected spell create a flaring that dazzles creatures that take damage from the spell. A flare spell causes a creature that takes fire or electricity damage from the affected spell to become dazzled for a number of rounds equal to the actual level of the spell. A flaring spell only affects spells with a fire, light, or electricity descriptor.`,
    },
    {
        name: "Fleeting Spell",
        prereq: "",
        cost: "0",
        type: "metamagic",
        shortDesc: "",
        longDesc: `A fleeting spell's duration becomes dismissible, if it is not already. You can dismiss your own fleeting spell as a swift action. The DC of dispel checks to counter a fleeting spell is reduced by 2, and once active, dispel magic removes a fleeting spell without a caster level check. A fleeting spell has half its normal duration (with an extended fleeting spell, these duration adjustments cancel out). Only spells with a duration of at least 2 rounds can be made fleeting, and instantaneous or permanent spells cannot be fleeting spells.`,
    },
    {
        name: "Jinxed Spell",
        cost: "1",
        type: "metamagic",
        shortDesc: "",
        prereq:"Halfling Jinx",
        longDesc: `Any creature that fails its saving throw against a jinxed spell also suffers the effects of your jinx. This feat has no effect on spells that do not allow a saving throw. If the spell affects an area or multiple creatures, you must select one creature to take the jinx, unless you have the Area Jinx feat; if you have the Area Jinx feat, choose a jinx burst area within the spell's area or among its targets and apply the jinx to those in the burst that failed their save.`,
    },
    {
    name: "Focused Spell",
    prereq: "",
    cost: "1",
    type: "metamagic",
    shortDesc: "When you cast a spell that affects more than one creature, one opponent finds it more difficult to resist.",
    longDesc: `When casting a spell that affects or targets more than one creature, you can choose one target or creature within the spell effect. That creature's saving throw DC to resist the spell is increased by +2. You must choose which target to focus the spell on before casting the spell. A focused spell uses up a spell slot one level higher than the spell's actual level. Spells that do not require a saving throw to resist or lessen the spell's effect do not benefit from this feat.`,
    },
    {
    name: "Furious Spell",
    prereq: "",
    key:true,
    cost: "1",
    type: "metamagic",
    shortDesc: "Spell deals more damage and can be cast while in a rage",
    longDesc: `A furious spell that deals hit point damage adds twice the spell's original level to the amount of damage dealt by the spell. Spells that affect multiple targets deal the extra damage once to each target, regardless of whether the spell deals its damage all at once or in multiple hits (in the latter case, add the extra damage to the first hit against each target). In addition, a furious spell can be cast while the caster is enraged, including during a barbarian rage or while affected by a rage spell. Even a furious spell that requires an emotion component can be cast while enraged. The caster gains a +2 circumstance bonus on concentration checks and caster level checks related to casting a furious spell if she is enraged. A furious spell uses up a spell slot 1 level higher than the spell's actual level.`,
    },
    {
    name: "Heighten Spell",
    prereq: "",
    key:true,
    cost: "0",
    type: "metamagic",
    shortDesc: "Treat spell as a higher level",
    longDesc: `A heightened spell has a higher spell level than normal (up to a maximum of 9th level). Unlike other metamagic feats, Heighten Spell actually increases the effective level of the spell that it modifies. All effects dependent on spell level (such as saving throw DCs and ability to penetrate a lesser globe of invulnerability) are calculated according to the heightened level. The heightened spell is as difficult to prepare and cast as a spell of its effective level.`,
    },
    {
    name: "Intensified Spell",
    prereq: "",
    key:true,
    cost: "1",
    type: "metamagic",
    shortDesc: "Increase maximum damage dice by 5 levels",
    longDesc: `An intensified spell increases the maximum number of damage dice by 5 levels. You must actually have sufficient caster levels to surpass the maximum in order to benefit from this feat. No other variables of the spell are affected, and spells that inflict damage that is not modified by caster level are not affected by this feat. An intensified spell uses up a spell slot one level higher than the spell's actual level.`,
    },
    // {
    // name: "Intuitive Spell",
    // prereq: "",
    // cost: "1",
    // type: "metamagic",
    // shortDesc: "Cast spell without thought components",
    // longDesc: `An intuitive spell can be cast with no thought components. Spells without thought components are not affected. An intuitive spell uses up a spell slot 1 level higher than the spell's actual level.`,
    // },
    {
    name: "Lingering Spell",
    prereq: "",
    cost: "1",
    type: "metamagic",
    shortDesc: "Instantaneous area effect spell lasts for 1 round",
    longDesc: `You may cause an instantaneous spell that affects an area to persist until the beginning of your next turn. Those already in the area suffer no additional harm, but other creatures or objects entering the area are subject to its effects. A lingering spell with a visual manifestation obscures vision, providing concealment (20% miss chance) beyond 5 feet and total concealment (50% miss chance) beyond 20 feet. A lingering spell uses up a spell slot one level higher than the spell's actual level.`,
    },
    // {
    // name: "Logical Spell",
    // prereq: "",
    // cost: "1",
    // type: "metamagic",
    // shortDesc: "Cast spell without emotion components",
    // longDesc: `A logical spell can be cast without emotion components. Spells that don't require emotion components are not affected. A logical spell uses up a spell slot 1 level higher than the spell's actual level.`,
    // },
    {
    name: "Maximize Spell",
    prereq: "",
    cost: "3",
    key:true,
    type: "metamagic",
    shortDesc: "Maximize spell variables",
    longDesc: `All variable, numeric effects of a spell modified by this feat are maximized. Saving throws and opposed rolls are not affected, nor are spells without random variables. A maximized spell uses up a spell slot three levels higher than the spell's actual level. An empowered, maximized spell gains the separate benefits of each feat: the maximum result plus half the normally rolled result.`,
    },
    {
    name: "Persistent Spell",
    prereq: "",
    cost: "2",
    type: "metamagic",
    shortDesc: "Creatures who saved against a spell must save again",
    longDesc: `Whenever a creature targeted by a persistent spell or within its area succeeds on its saving throw against the spell, it must make another saving throw against the effect. If a creature fails this second saving throw, it suffers the full effects of the spell, as if it had failed its first saving throw. A persistent spell uses up a spell slot two levels higher than the spell's actual level. Spells that do not require a saving throw to resist or lessen the spell's effect do not benefit from this feat.`,
    },
    {
        name: "Piercing Spell",
        cost: "1",
        type: "metamagic",
        shortDesc: "",
        longDesc: `When you cast a piercing spell against a target with spell resistance, it treats the spell resistance of the target as 4 lower than its actual SR.`,
    },
    {
    name: "Quicken Spell",
    prereq: "",
    cost: "4",
    key:true,
    type: "metamagic",
    shortDesc: "Cast spell as a swift action",
    longDesc: `Casting a quickened spell is a swift action. You can perform another action, even casting another spell, in the same round as you cast a quickened spell. A spell whose casting time is more than 1 round or 1 full-round action cannot be quickened. A quickened spell uses up a spell slot four levels higher than the spell's actual level. Casting a quickened spell doesn't provoke an attack of opportunity. You still cannot cast more than 2 spells per round.`,
    },
    {
    name: "Reach Spell",
    prereq: "",
    cost: "0",
    type: "metamagic",
    shortDesc: "Increase spell range to higher range category",
    longDesc: `You can alter a spell with a range of touch, close, or medium to increase its range to a higher range category, using the following order: touch, close, medium, and long. A reach spell uses up a spell slot one level higher than the spell's actual level for each increase in range category. For example, a spell with a range of touch increased to long range uses up a spell slot three levels higher. Spells modif ied by this feat that require melee touch attacks instead require ranged touch attacks. Spells that do not have a range of touch, close, or medium do not benefit from this feat.`,
    },
    {
    name: "Rime Spell",
    prereq: "",
    cost: "1",
    type: "metamagic",
    shortDesc: "Spell with the [cold] descriptor also entangles creatures if the spell damages them.",
    longDesc: `The frost of your cold spell clings to the target, impeding it for a short time. A rime spell causes creatures that takes cold damage from the spell to become entangled for a number of rounds equal to the original level of the spell. This feat only affects spells with the cold descriptor. A rime spell uses up a spell slot one level higher than the spell's actual level.`,
    },
    {
        name: "Scarring Spell",
        prereq: "",
        cost: "1",
        type: "metamagic",
        shortDesc: "",
        longDesc: `When a creature fails a saving throw against a scarring spell, for the next 24 hours that creature takes a —2 penalty on saving throws against emotion and fear effects you create, and a —1 penalty on saving throws against other emotion and fear effects. Penalties from multiple scarring spells don't stack. This metamagic feat can be applied only to spells with the emotion or fear descriptor.`,
    },
    {
    name: "Seeking Spell",
    prereq: "",
    cost: "2",
    type: "metamagic",
    shortDesc: "A seeking spell's range can bend around obstacles to reach the intended target.",
    longDesc: `A seeking spell's range can bend around obstacles to reach the intended target. You can define the route yourself or unambiguously identify a target and allow the spell to determine its own path. However, the spell fails if it would have to travel farther than its maximum range to reach the identified target. A ranged attack roll made to deliver a seeking spell is not subject to cover or concealment. In order to benefit from this feat, the selected spell must have a range greater than touch and target one or more creatures, or it must require the caster to make a ranged touch attack. A seeking spell uses up a spell slot 2 levels higher than the spell's actual level.`,
    },
    {
    name: "Selective Spell",
    prereq: "",
    cost: "1",
    type: "metamagic",
    shortDesc: "Exclude targets from an area effect spell",
    longDesc: `When casting a selective spell with an area effect and a duration of instantaneous, you can choose a number of targets in the area equal to your highest mental stat. These targets are excluded from the effects of your spell. A selective spell uses up a spell slot one level higher than the spell's actual level. Spells that do not have an area of effect or a duration of instantaneous do not benefit from this feat.`,
    },
    {
        name: "Shadow Grasp",
        prereq: "",
        cost: "1",
        type: "metamagic",
        shortDesc: "",
        longDesc: `When you cast a spell with the darkness descriptor that affects an area, creatures in the area are entangled. If the spell allows a saving throw, a successful save negates the entangle effect. If the spell does not normally allow a save, a creature can make a Reflex save (DC = the spell's DC if it had a saving throw) to negate the effect. If the spell allows spell resistance, failing to overcome a creature's spell resistance means it is not entangled. An entangled creature remains so as long as it is in the area of the spell and for 1 round after it leaves. A creature that leaves and reenters the area must make a new saving throw to avoid becoming entangled. Creatures that succeed at a save to resist being entangled do not have to make additional saves if they stay within the darkened area. You are never impeded by the effects of your spells modified by this feat.`,
    },
    {
        name: "Volatile Spell",
        prereq: "",
        cost: "1",
        type: "metamagic",
        shortDesc: "",
        longDesc: `Your spell gains 10% spell critical chance and 5% spell critical failure chance.`,
    },
    {
        name: "Carnage Magic",
        prereq: "",
        cost: "1",
        type: "metamagic",
        shortDesc: "",
        longDesc: `Your spell loses 25 spell power but gains 125% spell critical power.`,
    },
    {
        name: "Consistent Spell",
        prereq: "",
        cost: "1",
        type: "metamagic",
        shortDesc: "",
        longDesc: `You can trade up to 10% spell critical chance for 5 power per spell critical chance traded. You cannot reduce your spell critical chance below 0% with this.`,
    },
    {
    name: "Sickening Spell",
    prereq: "",
    cost: "2",
    type: "metamagic",
    shortDesc: "Sicken creature with spell damage",
    longDesc: `You can modify a spell to sicken a creature damaged by the spell. When a creature takes damage from this spell, they become sickened for a number of rounds equal to the original level of the spell. If the spell allows a saving throw, a successful save negates the sickening effect. If the spell does not allow a save, the target can make a Fortitude save to negate the sickening effect. If the spell effect also causes the creature to become sickened, the duration of this metamagic effect is added on to the duration of the spell. A sickening spell uses up a spell slot two levels higher than the spell's actual level. Spells that do not inflict damage do not benefit from this feat.`,
    },
    {
    name: "Silent Spell",
    prereq: "",
    cost: "1",
    type: "metamagic",
    shortDesc: "Cast spell without verbal components",
    longDesc: `A silent spell can be cast with no verbal components. Spells without verbal components are not affected. A silent spell uses up a spell slot one level higher than the spell's actual level.`,
    },
    {
        name: "Solar Spell",
        prereq: "",
        cost: "1",
        type: "metamagic",
        shortDesc: "",
        longDesc: `Any spell you cast with the [light] descriptor is fortified with the cleansing energies of the sun. If the spell creates an area of light, all creatures are dazzled for as long as they remain within the spell's area. Oozes, fungal creatures, creatures from the Shadow Plane, and undead must also succeed at a Will save (DC 10 + the spell level + your Wisdom or Charisma bonus) or take a -2 penalty on attack rolls, damage rolls, saving throws, skill checks, and ability checks for as long as they remain within the spell's area. If the spell normally dazzles or blinds affected creatures with a duration other than instantaneous or permanent, the duration of that effect is increased by a number of rounds equal to the spell's original level. Saving throws to remove the effect early still apply and can bypass this increase.
        \nIf the spell deals more damage against oozes, fungal creatures, creatures from the Shadow Plane, or undead with a specific vulnerability to sunlight, the spell deals 1 additional point of damage per die against such creatures.`,
    },
    {
    name: "Still Spell",
    prereq: "",
    cost: "1",
    type: "metamagic",
    shortDesc: "Cast spell without somatic components",
    longDesc: `A stilled spell can be cast with no somatic components. Spells without somatic components are not affected. A stilled spell uses up a spell slot one level higher than the spell's actual level.`,
    },
    {
        name: "Studied Spell",
        prereq: "",
        cost: "2",
        type: "metamagic",
        shortDesc: "",
        longDesc: `When casting a studied spell, designate one target affected by the spell. Attempt an appropriate Knowledge check based on that target's creature type as you cast the spell. The DC for this check is equal to 28 + the creature's HD. If you succeed, your studied spell ignores 10 energy resistance and 5 DR the creature may possess because of its creature type, and the DC of the spell increases by +1. For each 10 you beat the DC by, you ignore an additional 10 resistance, 5 DR, and the DC increases by an additional +1. Your studied spell doesn't ignore energy resistance, damage reduction, or saving throw bonuses granted by other spells and effects. If you fail the Knowledge check, the spell still has its normal effects.`,
    },
    {
        name: "Stygian Spell",
        prereq: "",
        cost: "2",
        type: "metamagic",
        shortDesc: "",
        longDesc: `You can enhance any spell with the water descriptor that targets at least one creature to become a Stygian spell. Any creature successfully hit by a Stygian spell (if the spell requires an attack roll) or that fails its saving throw against a Stygian spell must succeed at a Will save (using the save DC of the original spell) or take a permanent -2 penalty on will saving throws and skill checks in addition to the spell's normal effects. If the spell is a critical spell, the creature must instead succeed at a Will save (again using the same DC) or suffer from the amnesia greater madness. Madness gained this way lasts indefinitely, but can be treated using the normal methods for curing madness. This is a mind-affecting effect, and creatures native to the River Styx are immune to it. A spell modified by this feat gains the evil descriptor. Spells with the good descriptor can't be Stygian spells.`,
    },
    {
    name: "Tenacious Spell",
    prereq: "",
    cost: "1",
    type: "metamagic",
    shortDesc: "Spell is difficult to dispel and remains for 1d4 rounds",
    longDesc: `Increase the DC of caster level checks to counter or dispel a tenacious spell by 2. If a tenacious spell is dispelled or dismissed, it lasts for 1d4 further rounds (to a maximum of the spell's normal duration) before ending (this does not occur if antimagic field or a similar spell or effect suppresses or ends the spell's effect without dispelling or dismissing it). The lingering auras of tenacious spells detectable with detect magic last for twice as long as usual after the spells end. A tenacious spell uses up a spell slot 1 level higher than the spell's actual level.`,
    },
    {
        name: "Tenebrous Spell",
        prereq: "",
        cost: "0",
        type: "metamagic",
        shortDesc: "",
        longDesc: ` When you cast a tenebrous spell in darkness or dim light, the spell's effective caster level and any associated save DCs are increased by 1. Any attempts at dispelling a tenebrous spell in darkness or dim light take a -2 penalty on the dispel check.
        \nCasting a tenebrous spell in bright light is difficult, and requires a concentration check (DC 15 + twice the tenebrous spell's effective spell level). Attempts to dispel a tenebrous spell in bright light gain a +4 bonus on the dispel check.
        \nYou cannot use this feat on spells with the light descriptor. A tenebrous spell uses up a spell Slot one level higher than the spell's actual level, except in the case of spells with the darkness or shadow descriptor or of the illusion (shadow) subschool; this feat does not change the effective level of those spells (but still counts as using a metamagic feat for all other purposes).`,
    },
    {
    name: "Thanatopic Spell",
    prereq: "",
    cost: "2",
    type: "metamagic",
    shortDesc: "Affected spell's death effects, energy drain, and negative levels affect undead",
    longDesc: `A thanatopic spell pierces defenses and immunities that protect against death effects, negative levels, and energy drain, affecting the target as if the protective barrier did not exist. For example, you could cast a thanatopic vampiric touch or enervation spell on a target under the effects of death ward, and the target would suffer the normal effect of the spell. Saving throws and SR (if any) still apply. Undead are susceptible to spells augmented by this feat, as it retunes the negative energy to be harmful to them. A thanatopic spell that would kill a living creature (such as by giving it negative levels equal to its Hit Dice) destroys an undead (though undead such as ghosts, liches, and vampires may reform as normal). Undead affected by thanatopic spells that give negative levels automatically make their saving throws to remove negative levels after 24 hours. A thanatopic spell uses up a spell slot two levels higher than the spell's actual level.`,
    },
    {
    name: "Threnodic Spell",
    prereq: "",
    cost: "2",
    type: "metamagic",
    shortDesc: "Change a mind-affecting spell so it can affect undead, but not living creatures.",
    longDesc: `This feat only works on mind-affecting spells. A threnodic spell affects undead creatures (even mindless undead) as if they weren't immune to mind-affecting effects, but has no effect on living creatures. A threnodic spell uses up a spell slot two level higher than the spell's actual level.`,
    },
    {
        name: "Thundering Spell",
        prereq: "",
        cost: "2",
        type: "metamagic",
        shortDesc: "",
        longDesc: `You can modify a spell to deafen a creature damaged by the spell. When a creature takes damage from this spell, it becomes deafened for a number of rounds equal to the original level of the spell. If the spell allows a saving throw, a successful save negates the deafening effect. If the spell does not allow a save, the target can make a Fortitude save to negate the deafening effect. If the spell effect also causes the creature to become deafened, the duration of this metamagic effect is added to the duration of the spell. Spells that do not inflict damage do not benefit from this feat.`,
    },
    {
    name: "Toppling Spell",
    prereq: "",
    cost: "1",
    type: "metamagic",
    shortDesc: "Spell with the [force] descriptor knocks targets prone.",
    longDesc: `The impact of your force spell is strong enough to knock the target prone. If the target takes damage, fails its saving throw, or is moved by your force spell, make a trip check against the target, using your caster level plus your casting ability score bonus. This does not provoke an attack of opportunity. If the check fails, the target cannot attempt to trip you or the force effect in response. A toppling spell only affects spells with the force descriptor. A toppling spell uses up a spell slot one level higher than the spell's actual level.`,
    },
    {
    name: "Trick Spell",
    prereq: "",
    cost: "1",
    type: "metamagic",
    shortDesc: "Only enchantment spells that affect a single target and can be negated with a successful Will save can be trick spells. If the target fails its Will save against a trick spell, in addition to the spell's normal effects, the target also clumsily hinders itself. Immediately attempt a special combat maneuver check (1d20 + your caster level + your Charisma bonus) to perform a dirty trick combat maneuver against the target. Any feats you have that apply to dirty trick maneuvers (such as Greater Dirty Trick) also apply to this check.",
    longDesc: `Only enchantment spells that affect a single target and can be negated with a successful Will save can be trick spells. If the target fails its Will save against a trick spell, in addition to the spell's normal effects, the target also clumsily hinders itself. Immediately attempt a special combat maneuver check (1d20 + your caster level + your Charisma bonus) to perform a dirty trick combat maneuver against the target. Any feats you have that apply to dirty trick maneuvers (such as Greater Dirty TrickAPG) also apply to this check. A trick spell takes up a spell slot 1 level higher than the spell's actual level.`,
    },
    {
    name: "Tumultuous Spell",
    prereq: "",
    cost: "1",
    type: "metamagic",
    shortDesc: "You can enhance any spell that targets a single creature to become a tumultuous spell. A creature hit by a tumultuous spell (if the spell requires an attack roll) or that fails its saving throw against a tumultuous spell immediately moves 1d4×5 feet in a random direction.",
    longDesc: `You can enhance any spell that targets a single creature to become a tumultuous spell. A creature hit by a tumultuous spell (if the spell requires an attack roll) or that fails its saving throw against a tumultuous spell immediately moves 1d4x5 feet in a random direction. This movement does not provoke attacks of opportunity. If this movement would force a creature into a solid object or another creature, the movement ends harmlessly just before impact. A tumultuous spell uses a spell slot 1 level higher than the spell's normal spell level. Spells with the lawful descriptor can't be tumultuous spells.`,
    },
    {
    name: "Vast Spell",
    prereq: "",
    cost: "1",
    type: "metamagic",
    shortDesc: "You can alter a spell that targets a number of creatures no more than 30 feet apart, such as haste. The maximum distance apart of those you target with the spell increases to 60 feet.",
    longDesc: `You can alter a spell that targets a number of creatures no more than 30 feet apart, such as haste. The maximum distance apart of those you target with the spell increases to 60 feet. A vast spell uses up a spell slot 1 level higher than the spell's actual level.`,
    },
    {
    name: "Widen Spell",
    prereq: "",
    cost: "3",
    type: "metamagic",
    shortDesc: "You double the affected spells area of effect",
    longDesc: `You can alter a burst, emanation, or spread-shaped spell to increase its area. Any numeric measurements of the spell's area increase by 100%. A widened spell uses up a spell slot three levels higher than the spell's actual level. Spells that do not have an area of one of these four sorts are not affected by this feat.`,
    },
    {
        name: "Yai-Mimic Spell",
        prereq: "Still Spell",
        cost: "3",
        type: "metamagic",
        shortDesc: "",
        longDesc: `You can modify a ray spell to issue from the center of your forehead, where the third eye would be on a yai. This spell doesn't require somatic components.
        \nWhen the spell is cast, you gain regeneration 1 for a number of rounds equal to the original level of the spell. This regeneration can't regrow lost body parts or reattach severed limbs. Fire or acid damage suppresses this regeneration for 1 round, which counts against the total duration of the regeneration effect.`,
    },
    ]